// @ts-nocheck
import { QueryObject, QGuidPath, QBooleanPath, QDateTimeOffsetPath, QStringPath, QNumberPath, QEnumPath, QEntityCollectionPath, QId, QGuidParam, QEntityPath, QNumberParam, QBinaryPath, QCollectionPath, QStringCollection, QGuidCollection, QNumberCollection, QFunction, OperationReturnType, ReturnTypes, QComplexParam, QAction } from "@odata2ts/odata-query-objects";
import type { LogMessageCatalogId, LogMessageCatalogParametersId, LogMessageCatalogLanguagesId, FileId, FolderId, SegregationTagId, WorkOrderFacetId, OperationFacetId, APSOrderOperationStatusId, APSOrderStatusId, APSResourceId, APSOperationRelationId, APSOperationResourceId, APSOrderId, APSOrderOperationId, EXDSOpLandingEGSearchId, EXDSOpLandingWOOSearchId, EXDSAsBuiltMaterialsId, EXDSOpLandingMachineSearchId, EXDSOpLandingProducedMaterialsSearchId, EXDSOpLandingActConsMatWOOpId, EXDSOpLandingActConsMatWOStepId, EXDSOpLandingActProducedWOOpId, EXDSOpLandingActProducedWOStepId, EXDSOpLandingToBeConsMatWOOpId, EXDSOpLandingToBeConsMatWOStepId, ToBeAndActualProducedMaterial_MTUAndContainerId, EXDSContainerOrMTUId, EXDSOpLandingProducedMaterialsContainerSearchId, EXDSContainerOrMTUbyWorkOrderOperationId, EXDSActiveMTUOrContainerOnWOOpAndUserId, EXDSActiveMTUOrContainerOnWOStepAndUserId, EXDSOpLandingMaterialATNInstanceId, EXDSOpLandingContainerWithConsumptionStatusByWOOpAndUserId, EXDSOpLandingContainerWithConsumptionStatusByWOStepAndUserId, EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUserId, EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUserId, EXDSOpLandingActConsMatOnContainerWOOpId, EXDSOpLandingActConsMatOnContainerWOStepId, EXDSAsBuiltSNId, EXDSAsBuiltSNWithWOOpId, ToBeAndActualProducedMaterial_MTUAndContainerForStepsId, EXDSOpLandingActConsMatOnMTUWOOpId, EXDSOpLandingActConsMatOnMTUWOStepId, EXDSGetResultHistoryId, EXDSOpLandingAssignedUsersSearchId, ToBeAndActualProducedMTUWithContainerForPartialQuantityId, EXDSAsBuiltActualProdMatOnWoopId, ToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantityId, EXDSOpLandingPrekittedConsumptionWOOpId, EXDSOpLandingPrekittedConsumptionWOStepId, ToBeProducedMTUWithResultId, DMMtuWithResultId, ProducedMTUWithResultId, EXDSOpenWooId, EXDSOpenWooByEquipmentId, EXDSOpenWooByEquipmentTypeId, EXDSEquipmentRelationId, EXDSActiveWooId, EXDSActiveWooByEquipmentId, EXDSQueueWooByEquipmentId, EXDSQueueWooByEquipmentTypeId, EXDSEquipmentsOnOperationsId, EXDSCompleteWooId, EXDSCompleteWooByEquipmentId, EXDSEquipmentDetailsId, EXDSStartableActiveWooByEquipmentId, EXDSStartableActiveWooByEquipmentTypeId, EXDSActiveOperationFromActiveUsersOnMachinesId, EXDSCompleteOperationFromActualUsedMachinesId, EXDSOpenOperationFromToBeUsedMachinesId, EXDSStartableOperationFromToBeUsedMachinesId, EXDSOpLandingMachineEGSearchId, EXDSOpLandingProducedMaterialsEGSearchId, EXDSAsBuiltAutoconsumeReferenceMaterialsId, EXDSOpLandingTimeBasedInspectionId, EXDSOpLandingDocumentListId, EXDSGetMTUDocumentAssociationId, EXDSOpLandingGetAllMaterialDefinitionDocumentsId, EXDSGetNCDocumentAssociationId, vEXDSBoMId, vEXDSSnagAndNoteId, EXDSDocActualCollectDocumentId, EXDSWorkOrderHistoryRuntimeDocumentId, EXDSGetExecutionGroupListId, EXDSOpenAndStartableOperationFromToBeUsedMachinesId, EXDSGetReworkCodeId, EquipmentConfigurationToAutomationNodeInstanceId, DocumentNewId, InspectionOperationId, WorkOrderOperationToolInfoId, ScrewingToolHistoryId, TaskContextUserFieldId, TaskContextId, TaskId, TaskContextDefinitionUserFieldId, TaskDefinitionId, TaskContextDefinitionId, FeatureValueId, FeatureId, BillOfFeatureItemId, ToBeUsedBillOfFeatureId, BillOfFeatureId, NumberingPatternEntityInfoId, NumberingPatternMaterialAssociationId, ExtEventLogFailureNotificationId, ToBeUsedSetPointItemATNInstanceAssociationId, RuntimeCharReprRefOperationAssociationId, CharacteristicRepresentationFrequencyId, ScenarioInstanceId, SignatureInstanceId, SignatureConfigurationId, ScenarioConfigurationId, OutMsgId, DM_FunctionalCodeId, MaterialSupplierAssociationId, WorkInstructionToExecutionGroupPhaseAssociationId, WIDefinitionToEGPhaseAssociationId, ResultTypeId, ResultStrategyId, ResultHistoryActionId, ResultHistoryId, ResultId, ContainerCompatibleMaterialId, AttachmentId, QualityActionId, FailureReferenceId, FailureParentId, FailureChildId, FailureId, ContainerHistoryId, ExtObjectTypeId, ExtEventContextId, ExtEventTypeId, ExtEventLogId, ContainerTypeDocumentId, ContainerTypeCompatibleMaterialId, ContainerTypeId, OfflineActionAmendId, OfflineActionId, OfflineSessionWOOperationAssociationId, OfflineSessionId, DM_MaterialTrackingUnitDocumentAssociationId, WorkOrderHumanResourceId, ActualCoProducedMaterialId, ToBeCoProducedMaterialId, CertificationSpecificationId, UserWorkOrderOperationAssociationId, RuntimePJFSerialNumberAssociationId, SetPointItemToolDefinitionATNTypeParameterAssociationId, MachineToDNCId, DNCItemMachineMaterialAssociationId, DNCItemId, AutomationNodeTypeParameterId, AutomationNodeTypeId, AutomationNodeInstanceParameterId, AutomationNodeInstanceId, SetPointEquipmentTypeAssociationId, SetPointToolAssociationId, SetPointToolDefinitionAssociationId, ToolAutomationNodeInstanceAssociationId, ToolDefinitionAutomationNodeTypeAssociationId, SetPointItemDefaultValueId, SetPointItemATNInstanceAssociationId, SetPointItemId, SetPointEquipmentAssociationId, SetPointId, ToBeUsedMachinePJFId, ActualUsedMachinePJFId, DSParameterId, DiscreteAutomationNodeDataTypeMappingId, ProcessToOpLinkDependencyNavigationId, PrintJobFileEquipmentTypeAssociationId, PrintJobFileEquipmentAssociationId, PrintJobFileDM_MaterialAssociationId, AMPowderBatchGenealogyId, VisualDetectedFailureId, InspectionValueId, InspectionSampleId, InspectionAcquisitionContextId, WorkOrderStepSkillId, WOOpDependencyNavigationMTUAssociationId, WOOpDependencyNavigationId, StepSkillId, ItlkCheckOperationToStepLinkAssociationParameterValueId, ItlkCheckOperationToStepLinkAssociationId, WorkInstructionDefinitionToStepAssociationId, WIDefinitionToWOStepAssociationId, WorkInstructionToWorkOrderStepAssociationId, RuntimeCharacteristicRepresentationContainerId, RuntimeCharacteristicRepresentationId, ToBeUsedInspectionId, ActualUsedInspectionId, ItlkCheckWOStepAssociationParameterValueId, ItlkCheckWOStepAssociationId, CriticalityId, APSAlertId, CharacteristicSpecificationId, CharacteristicRepresentationId, CharacteristicFailureAssociation2Id, BoMItemGroupTypeId, BoMItemId, ItlkCheckOperationStepCategoryAssociationParameterValueId, ItlkCheckOperationStepCategoryAssociationId, InspectionSpecificationId, EquipmentStateMachineId, EquipmentPropertyAttributeId, EquipmentPropertyId, EquipmentGroupId, EquipmentGraphNodeId, EquipmentGraphLinkId, EquipmentId, EquipmentTypeStateMachineId, EquipmentTypePropertyAttributeId, EquipmentTypePropertyId, EquipmentTypeId, EquipmentLevelId, EquipmentGroupConfigurationId, EquipmentGraphTypeId, EquipmentGraphNodeConfigurationId, EquipmentGraphLinkConfigurationId, EquipmentGraphConfigurationId, EquipmentConfigurationStateMachineId, EquipmentConfigurationPropertyAttributeId, EquipmentConfigurationPropertyId, EquipmentConfigurationId, BoMId, WorkProcessDMMaterialTrackingUnitAssociationId, UserHAEquipmentPreferencesId, MaterialTrackingUnitAggregateId, MaterialTrackingUnitId, MaterialLotId, DM_MaterialTrackingUnitHistoryActionId, DM_MaterialTrackingUnitHistoryId, DM_MaterialTrackingUnitId, SupplierId, MaterialId, MaterialGroupId, DM_MaterialId, ProcessContextDefinitionUserFieldId, ProcessContextDefinitionId, ProcessDefinitionParameterId, ProcessDefinitionId, ItlkCheckProcessToOpLinkAssociationParameterValueId, ItlkCheckProcessToOpLinkAssociationId, OperationStepCategoryProcessDefinitionAssociationId, ItlkCheckWOOpAssociationParameterValueId, ItlkCheckWOOpAssociationId, ItlkCheckHistoryParameterValueId, ItlkCheckHistoryId, TeamUserAssociationId, TeamHistoryId, TeamHistoryActionId, TeamSkillAssociationId, TeamId, NonProductiveActivityHistoryId, NonProductiveActivityHistoryActionId, NonProductiveActivityContextId, NonProductiveActivityNotificationId, UserNonProductiveActivityId, ItlkCheckParameterId, ItlkCheckId, OperationStepCategoryId, NonProductiveActivityId, WorkOrderOperationSkillId, ExecutionGroupPhaseDependencyId, ActualCollectedDocumentId, WorkInstructionAssociationTypeId, WIDefinitionToWOOperationAssociationId, TransportOperationSourceId, TransportOperationHistoryAssignedHUId, TransportOperationHistoryActionId, TransportOperationHistoryId, TransportOperationDestinationId, TransportOperationId, RuntimeLogisticWhitelistId, LogisticRequestItemId, LogisticRequestHistoryActionId, LogisticRequestHistoryId, LogisticRequestId, HistoryItemsId, HandlingUnitMaterialItemAssociationId, HandlingUnitHistoryActionId, HandlingUnitHistoryId, HandlingUnitId, BufferToolAssociationId, BufferMaterialItemAssociationId, BufferHistoryActionId, BufferHistoryId, BufferEquipmentAssoicationId, BufferId, ExecutionGroupPhaseWOOAssociationId, WorkInstructionToWorkOrderOperationAssociationId, ExecutionGroupPhaseId, ExecutionGroupHistoryActionId, ExecutionGroupHistoryId, ExecutionGroupId, WorkInstructionStepItemLimitId, WorkInstructionStepItemId, WorkInstructionStepId, WorkInstructionSectionId, WorkInstructionParameterId, WorkInstructionId, WorkInstructionDefinitionToOperationAssociationId, WorkInstructionTemplateParameterId, WorkInstructionTemplateId, WorkInstructionDefinitionParameterId, WorkInstructionDefinitionId, NumberingPatternId, NumberingPatternParameterId, NumberingPatternPartId, NumberingPatternEntityId, CounterId, LogisticWhitelistId, LogisticClassId, CapacityTypeId, BufferDefinitionId, UoMFactorId, UoMDimensionId, UoMId, StatusTransitionDefinitionId, StatusTransitionId, StatusDefinitionId, StatusBehaviorDefinitionId, StatusId, StateMachineId, UserPlantAssociationId, MasterPlanId, Skill_BOPId, OperationToStepLinkId, ProcessToProcessLinkId, ProcessToOperationLinkId, OperationSkillId, ProducedMaterialUnderReworkId, SnagAndNoteNotificationId, NonConformanceStatusBehaviorId, NonConformanceItemId, ToBeConsumedMaterialPrekitHistoryId, ToBeConsumedMaterialPrekitId, WorkOperationTypeId, ToolDefinitionCompatibleMachineId, ToolDefinitionId, SkillId, ReworkCodeId, NonConformanceTransitionId, NonConformanceStatusId, NonConformanceSeverityId, NonConformanceLifecycleId, DefectTypeId, DefectSpecificationId, DefectGroupSpecificationId, DefectGroupId, WorkOStepDependencyId, WorkOrderStepId, WorkOrderOperationId, WorkOrderHistoryMaterialItemId, WorkOrderHistoryActionId, WorkOrderHistoryId, WorkOrderId, WorkOOperationDependencyId, ToolHistoryActionId, ToolHistoryId, ToolCompatibleMachineId, ToolId, ToBeUsedToolId, ToBeUsedMachineId, ToBeUsedDocumentId, ToBeProducedMaterialId, ToBeConsumedMaterialId, SkipReasonId, ProductionTypeId, ProducedMaterialItemId, PauseReasonId, NonConformanceSupervisorId, NonConformanceResourceId, NonConformanceHistoryId, NonConformanceAttachmentId, SnagAndNoteId, NonConformanceId, HoldReasonId, HoldId, FutureHoldId, DefectId, ChangeTypeId, AMSubstrateLifecycleId, AMPowderLifecycleId, ActualUsedToolId, ActualUsedMachineId, ActualProducedMaterialId, ActualConsumedMaterialId, ActiveUserOnMachineId, WorkOrderNotificationId, ProcessNotificationId, ConfigurationKeyMultiValueId, PrintJobFileId, MachineToAMId, ConfigurationKeyId, NonConformanceNotificationId, UserCertificationAssociationId, SkillCertificationAssociationId, RoleCertificationAssociationId, MaterialCertificationAssociationId, EquipmentCertificationAssociationId, CertificationHistoryActionId, CertificationHistoryId, CertificationId, TemplateToMaterialPlantId, TemplateTypeId, TemplateBlockId, TemplateId, MaterialSpecificationTypeId, ToolDefinitionDocumentId, StepDependencyId, StepId, ProcessId, OperationDependencyId, OperationId, MaterialSpecificationId, MaterialDefinitionDocumentId, EquipmentSpecificationId, DocumentId, DependencyTypeId, AsPlannedBOPId, ToolSpecificationId, DocumentNewFacetId, ContainerHistoryFacetId, InspectionValueFacetId, RuntimeCharacteristicRepresentationFacetId, CharacteristicSpecificationFacetId, MaterialTrackingUnitAggregateFacetId, DM_MaterialTrackingUnitHistoryFacetId, DM_MaterialTrackingUnitFacetId, MaterialFacetId, DM_MaterialFacetId, WIDefinitionToWOOperationAssociationFacetId, WorkInstructionStepItemFacetId, WorkInstructionStepFacetId, WorkInstructionFacetId, WorkInstructionDefinitionParameterFacetId, ToolDefinitionFacetId, WorkOrderOperationFacetId, WorkOrderHistoryMaterialItemFacetId, WorkOrderHistoryFacetId, ToolHistoryFacetId, ToolFacetId, ToBeUsedToolFacetId, ToBeProducedMaterialFacetId, ToBeConsumedMaterialFacetId, NonConformanceHistoryFacetId, NonConformanceFacetId, ActualUsedToolFacetId, ActualConsumedMaterialFacetId, EquipmentConfigurationToAutomationNodeInstanceFacetId, InspectionOperationFacetId, WorkOrderOperationToolInfoFacetId, ScrewingToolHistoryFacetId, TaskContextUserFieldFacetId, TaskContextFacetId, TaskFacetId, TaskContextDefinitionUserFieldFacetId, TaskDefinitionFacetId, TaskContextDefinitionFacetId, FeatureValueFacetId, FeatureFacetId, BillOfFeatureItemFacetId, ToBeUsedBillOfFeatureFacetId, BillOfFeatureFacetId, NumberingPatternEntityInfoFacetId, NumberingPatternMaterialAssociationFacetId, ExtEventLogFailureNotificationFacetId, ToBeUsedSetPointItemATNInstanceAssociationFacetId, RuntimeCharReprRefOperationAssociationFacetId, CharacteristicRepresentationFrequencyFacetId, SignatureConfigurationFacetId, ScenarioConfigurationFacetId, OutMsgFacetId, DM_FunctionalCodeFacetId, MaterialSupplierAssociationFacetId, WorkInstructionToExecutionGroupPhaseAssociationFacetId, WIDefinitionToEGPhaseAssociationFacetId, ResultTypeFacetId, ResultStrategyFacetId, ResultHistoryActionFacetId, ResultHistoryFacetId, ResultFacetId, ContainerCompatibleMaterialFacetId, AttachmentFacetId, QualityActionFacetId, FailureReferenceFacetId, FailureParentFacetId, FailureChildFacetId, FailureFacetId, ExtObjectTypeFacetId, ExtEventContextFacetId, ExtEventTypeFacetId, ExtEventLogFacetId, ContainerTypeDocumentFacetId, ContainerTypeCompatibleMaterialFacetId, ContainerTypeFacetId, OfflineActionAmendFacetId, OfflineActionFacetId, OfflineSessionWOOperationAssociationFacetId, OfflineSessionFacetId, DM_MaterialTrackingUnitDocumentAssociationFacetId, WorkOrderHumanResourceFacetId, ActualCoProducedMaterialFacetId, ToBeCoProducedMaterialFacetId, CertificationSpecificationFacetId, UserWorkOrderOperationAssociationFacetId, RuntimePJFSerialNumberAssociationFacetId, SetPointItemToolDefinitionATNTypeParameterAssociationFacetId, MachineToDNCFacetId, DNCItemMachineMaterialAssociationFacetId, DNCItemFacetId, AutomationNodeTypeParameterFacetId, AutomationNodeTypeFacetId, AutomationNodeInstanceParameterFacetId, AutomationNodeInstanceFacetId, SetPointEquipmentTypeAssociationFacetId, SetPointToolAssociationFacetId, SetPointToolDefinitionAssociationFacetId, ToolAutomationNodeInstanceAssociationFacetId, ToolDefinitionAutomationNodeTypeAssociationFacetId, SetPointItemDefaultValueFacetId, SetPointItemATNInstanceAssociationFacetId, SetPointItemFacetId, SetPointEquipmentAssociationFacetId, SetPointFacetId, ToBeUsedMachinePJFFacetId, ActualUsedMachinePJFFacetId, DSParameterFacetId, DiscreteAutomationNodeDataTypeMappingFacetId, ProcessToOpLinkDependencyNavigationFacetId, PrintJobFileEquipmentTypeAssociationFacetId, PrintJobFileEquipmentAssociationFacetId, PrintJobFileDM_MaterialAssociationFacetId, AMPowderBatchGenealogyFacetId, VisualDetectedFailureFacetId, InspectionSampleFacetId, InspectionAcquisitionContextFacetId, WorkOrderStepSkillFacetId, WOOpDependencyNavigationMTUAssociationFacetId, WOOpDependencyNavigationFacetId, StepSkillFacetId, ItlkCheckOperationToStepLinkAssociationParameterValueFacetId, ItlkCheckOperationToStepLinkAssociationFacetId, WorkInstructionDefinitionToStepAssociationFacetId, WIDefinitionToWOStepAssociationFacetId, WorkInstructionToWorkOrderStepAssociationFacetId, RuntimeCharacteristicRepresentationContainerFacetId, ToBeUsedInspectionFacetId, ActualUsedInspectionFacetId, ItlkCheckWOStepAssociationParameterValueFacetId, ItlkCheckWOStepAssociationFacetId, CriticalityFacetId, APSAlertFacetId, CharacteristicRepresentationFacetId, CharacteristicFailureAssociationFacetId, BoMItemGroupTypeFacetId, BoMItemFacetId, ItlkCheckOperationStepCategoryAssociationParameterValueFacetId, ItlkCheckOperationStepCategoryAssociationFacetId, InspectionSpecificationFacetId, EquipmentStateMachineFacetId, EquipmentPropertyAttributeFacetId, EquipmentPropertyFacetId, EquipmentGroupFacetId, EquipmentGraphNodeFacetId, EquipmentGraphLinkFacetId, EquipmentFacetId, EquipmentTypeStateMachineFacetId, EquipmentTypePropertyAttributeFacetId, EquipmentTypePropertyFacetId, EquipmentTypeFacetId, EquipmentLevelFacetId, EquipmentGroupConfigurationFacetId, EquipmentGraphTypeFacetId, EquipmentGraphNodeConfigurationFacetId, EquipmentGraphLinkConfigurationFacetId, EquipmentGraphConfigurationFacetId, EquipmentConfigurationStateMachineFacetId, EquipmentConfigurationPropertyAttributeFacetId, EquipmentConfigurationPropertyFacetId, EquipmentConfigurationFacetId, BoMFacetId, WorkProcessDMMaterialTrackingUnitAssociationFacetId, UserHAEquipmentPreferencesFacetId, MaterialTrackingUnitFacetId, MaterialLotFacetId, DM_MaterialTrackingUnitHistoryActionFacetId, SupplierFacetId, MaterialGroupFacetId, ProcessContextDefinitionUserFieldFacetId, ProcessContextDefinitionFacetId, ProcessDefinitionParameterFacetId, ProcessDefinitionFacetId, ItlkCheckProcessToOpLinkAssociationParameterValueFacetId, ItlkCheckProcessToOpLinkAssociationFacetId, OperationStepCategoryProcessDefinitionAssociationFacetId, ItlkCheckWOOpAssociationParameterValueFacetId, ItlkCheckWOOpAssociationFacetId, ItlkCheckHistoryParameterValueFacetId, ItlkCheckHistoryFacetId, TeamUserAssociationFacetId, TeamHistoryFacetId, TeamHistoryActionFacetId, TeamSkillAssociationFacetId, TeamFacetId, NonProductiveActivityHistoryFacetId, NonProductiveActivityHistoryActionFacetId, NonProductiveActivityContextFacetId, NonProductiveActivityNotificationFacetId, UserNonProductiveActivityFacetId, ItlkCheckParameterFacetId, ItlkCheckFacetId, OperationStepCategoryFacetId, NonProductiveActivityFacetId, WorkOrderOperationSkillFacetId, ExecutionGroupPhaseDependencyFacetId, ActualCollectedDocumentFacetId, WorkInstructionAssociationTypeFacetId, TransportOperationSourceFacetId, TransportOperationHistoryAssignedHUFacetId, TransportOperationHistoryActionFacetId, TransportOperationHistoryFacetId, TransportOperationDestinationFacetId, TransportOperationFacetId, RuntimeLogisticWhitelistFacetId, LogisticRequestItemFacetId, LogisticRequestHistoryActionFacetId, LogisticRequestHistoryFacetId, LogisticRequestFacetId, HistoryItemsFacetId, HandlingUnitMaterialItemAssociationFacetId, HandlingUnitHistoryActionFacetId, HandlingUnitHistoryFacetId, HandlingUnitFacetId, BufferToolAssociationFacetId, BufferMaterialItemAssociationFacetId, BufferHistoryActionFacetId, BufferHistoryFacetId, BufferEquipmentAssoicationFacetId, BufferFacetId, ExecutionGroupPhaseWOOAssociationFacetId, WorkInstructionToWorkOrderOperationAssociationFacetId, ExecutionGroupPhaseFacetId, ExecutionGroupHistoryActionFacetId, ExecutionGroupHistoryFacetId, ExecutionGroupFacetId, WorkInstructionStepItemLimitFacetId, WorkInstructionSectionFacetId, WorkInstructionParameterFacetId, WorkInstructionDefinitionToOperationAssociationFacetId, WorkInstructionTemplateParameterFacetId, WorkInstructionTemplateFacetId, WorkInstructionDefinitionFacetId, NumberingPatternFacetId, NumberingPatternParameterFacetId, NumberingPatternPartFacetId, NumberingPatternEntityFacetId, CounterFacetId, LogisticWhitelistFacetId, LogisticClassFacetId, CapacityTypeFacetId, BufferDefinitionFacetId, UoMFactorFacetId, UoMDimensionFacetId, UoMFacetId, StatusTransitionDefinitionFacetId, StatusTransitionFacetId, StatusDefinitionFacetId, StatusBehaviorDefinitionFacetId, StatusFacetId, StateMachineFacetId, UserPlantAssociationFacetId, MasterPlanFacetId, Skill_BOPFacetId, OperationToStepLinkFacetId, ProcessToProcessLinkFacetId, ProcessToOperationLinkFacetId, OperationSkillFacetId, ProducedMaterialUnderReworkFacetId, SnagAndNoteNotificationFacetId, NonConformanceStatusBehaviorFacetId, NonConformanceItemFacetId, ToBeConsumedMaterialPrekitHistoryFacetId, ToBeConsumedMaterialPrekitFacetId, WorkOperationTypeFacetId, ToolDefinitionCompatibleMachineFacetId, SkillFacetId, ReworkCodeFacetId, NonConformanceTransitionFacetId, NonConformanceStatusFacetId, NonConformanceSeverityFacetId, NonConformanceLifecycleFacetId, DefectTypeFacetId, DefectSpecificationFacetId, DefectGroupSpecificationFacetId, DefectGroupFacetId, WorkOStepDependencyFacetId, WorkOrderStepFacetId, WorkOrderHistoryActionFacetId, WorkOOperationDependencyFacetId, ToolHistoryActionFacetId, ToolCompatibleMachineFacetId, ToBeUsedMachineFacetId, ToBeUsedDocumentFacetId, SkipReasonFacetId, ProductionTypeFacetId, ProducedMaterialItemFacetId, PauseReasonFacetId, NonConformanceSupervisorFacetId, NonConformanceResourceFacetId, NonConformanceAttachmentFacetId, SnagAndNoteFacetId, HoldReasonFacetId, HoldFacetId, FutureHoldFacetId, DefectFacetId, ChangeTypeFacetId, AMSubstrateLifecycleFacetId, AMPowderLifecycleFacetId, ActualUsedMachineFacetId, ActualProducedMaterialFacetId, ActiveUserOnMachineFacetId, WorkOrderNotificationFacetId, ProcessNotificationFacetId, ConfigurationKeyMultiValueFacetId, PrintJobFileFacetId, MachineToAMFacetId, ConfigurationKeyFacetId, NonConformanceNotificationFacetId, UserCertificationAssociationFacetId, SkillCertificationAssociationFacetId, RoleCertificationAssociationFacetId, MaterialCertificationAssociationFacetId, EquipmentCertificationAssociationFacetId, CertificationHistoryActionFacetId, CertificationHistoryFacetId, CertificationFacetId, TemplateToMaterialPlantFacetId, TemplateTypeFacetId, TemplateBlockFacetId, TemplateFacetId, MaterialSpecificationTypeFacetId, ToolDefinitionDocumentFacetId, StepDependencyFacetId, StepFacetId, ProcessFacetId, OperationDependencyFacetId, MaterialSpecificationFacetId, MaterialDefinitionDocumentFacetId, EquipmentSpecificationFacetId, DocumentFacetId, DependencyTypeFacetId, AsPlannedBOPFacetId, ToolSpecificationFacetId, APPMain_DocumentCategoryId, APPMain_GF_UoMMappingsId, APPMain_GF_FileId, APPMain_GF_ReworkProcessAssignmentId, APPMain_MaterialPropertyId, APPMain_DocumentEntityLinkId, APPMain_TaskParameterId, APPMain_GF_ScanDiagnosticId, APPMain_GF_RunningScansId, APPMain_GF_ProductsWaitingForValidationId, APPMain_GF_LineRoutingId, APPMain_DocumentCategoryFacetId, APPMain_GF_UoMMappingsFacetId, APPMain_GF_FileFacetId, APPMain_GF_ReworkProcessAssignmentFacetId, APPMain_MaterialPropertyFacetId, APPMain_DocumentEntityLinkFacetId, APPMain_TaskParameterFacetId, APPMain_GF_ScanDiagnosticFacetId, APPMain_GF_RunningScansFacetId, APPMain_GF_ProductsWaitingForValidationFacetId, APPMain_GF_LineRoutingFacetId, DSBoF_AcquisitionCycleId, DSBoF_AcquisitionCycleFacetId, ToolAGW_EquipmentConfigurationToAutomationNodeInstanceId, ToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacetId, UADMGetAllReasons2Params, UADMGetExecutionGroupList2Params, UADMGetExecutionGroupHistory2Params, UADMGetAllExecutionGroupPhasesWithLinkedPJF2Params, UADMGetAllToBeUsedMachineForSetWKCHold2Params, APPMain_GF_GetBomItems2Params, UADMGetDefectOrFailure2Params, UADMGetNonConformanceContainerMTU2Params, UADMGetContainerToWorkOrderLink2Params, UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder2Params, UADMGetExecutionGroupsForWorkOrder2Params, UADMGetEquipmentAndRelatedOperations2Params, UADMGetAllEquipmentsAndRelatedOperations2Params, UADMGetWorkOrderOutMsgFile2Params, UADMGetBuyoffNonConformances2Params, UADMGetSignersFromBuyOffHistory2Params, UADMGetWIDetailsForWorkOrderOperationAndStep2Params, UADMGetContainerTobeConsumedMTUs2Params, UADMGetMTUFromBufferForToBeConsumedBatchMaterials2Params, UADMGetActualConsumedMaterialForGenealogy2Params, UADMGetEventLogs2Params, UADMGetAllMaterialDefinitionDocuments2Params, UADMGetDataFromFeatures2Params, UADMGetAllTasks2Params, UADMGetWIDetailsForEgPhase2Params, UADMGetScrewingDetails2Params, UADMGetScrewingHistoryFromMaterialTrackingUnit2Params, UADMGetAllDocumentsFromNonConformanceId2Params, UADMGetExecutionGroupListWithEstimatedDuration2Params, UADMGetAllMaterialForPrekit2Params, UADMGetItlkParametersDetails2Params, DM_MaterialAndMaterial2Params, UADMGetItlkCheckHistoryParamValues2Params, UADMGetFullEquipment2Params, UADMGetAllProcessMachines2Params, UADMGetAllItlkCheckWOOpAssociation2Params, UADMGetAllItlkCheckProcessToOpLinkAssociation2Params, UADMGetEquipmentForToBeUsedMachine2Params, UADMGetEquipmentForEqSpecification2Params, UADM_DMMaterialTrackingUnitAndMTU2Params, UADMGetAllToolCompatibleMachines2Params, UADMGetLinkableEquipment2Params, UADMGetAllToolDefinitionCompatibleMachine2Params, UADMGetAllItlkCheckWOStepAssociation2Params, UADMGetDefectGroupSpecifications2Params, UADMGetUnitsFromWorkCenter2Params, UADMGetUnitsFromBufferLocation2Params, UADMGetCharacteristicRepresentation2Params, UADMGetAlternativeGroupsFromWorkOrderId2Params, UADMGetQualityInspectionSamples2Params, UADMGetUnitsFromPlant2Params, UADMGetQualityForGenealogy2Params, UADMGetStartableItemsOnWOStep2Params, UADMGetCompletableItemsOnWOStep2Params, UADMGetAllPrintJobFiles2Params, UADMGetAlternativeGroupsFromProcessId2Params, UADMGetPrintJobFilesFromAssociations2Params, UADMGetWOByProcessRevision2Params, UADMGetStepForCatalog2Params, UADMGetAllEquipmentFor3DPrinter2Params, UADMGetAllToolDefinitionAutomationNodeType2Params, UADMGetAllToolAutomationNodeInstance2Params, UADMGetToolDefinationsBySetPoint2Params, UADMGetToolBySetPoint2Params, UADMGetDNCItemsFromAssociations2Params, UADMGetOperationToStepLink2Params, UADMGetWOSteps2Params, UADMGetAllWorkOrderPrintJobFileAssociation2Params, UADMGetBufferHistory2Params, UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes2Params, UADMGetCertificationDetails2Params, UADMGetWorkOrderHumanResourceDetails2Params, UADMGetOfflineSessionWOOperationAssociations2Params, UADMGetMaterialSpecificationTypeIndicator2Params, UADMGetAllOfflineSessions2Params, UADMGetProcessOperationDetails2Params, UADMGetProcessStepDetails2Params, UADMGetAllDocumentsFromDM_MaterialTrackingUnitIds2Params, UADMGetSerialNumberStatusForGenealogy2Params, UADMGetAllConsumedDM_MTUForProducedDM_MTU2Params, ToolAGW_ToolOnWorkplace2Params, UADMDeleteWorkOperationTypeList2Params, UADMStartOperation2Params, UADMUpdateWOByBoPList2Params, UADMStartWOOperationTransferBatchList2Params, UADMConsumeMaterialItemList2Params, UADMSentenceNonConformance2Params, UADMCreateNonConformance2Params, AcceptBuyOff2Params, RejectBuyOff2Params, UADMCreateWorkOrdersFromAsPlannedBOP2Params, UADMCreateTravellingWork2Params, UADMTakeOwnershipTravellingWork2Params, UADMAcceptTravellingWork2Params, UADMStartWOOperationSerializedList2Params, UADMSetWorkOrderOperationFutureHoldList2Params, UADMCreateChangeNonConformance2Params, UADMAbortWorkOrder2Params, UADMVerifyWorkOrder2Params, UADMSetWorkOrderHoldList2Params, UADMRemoveWorkOrderOperationFutureHoldList2Params, UADMCompleteWOOperationSerializedList2Params, UADMUnVerifyWorkOrder2Params, UADMCreateAndAssignProducedMaterialItems2Params, UADMCompleteWOStepList2Params, UADMStartWOStep2Params, UADMAcceptChangeRepeatOperation2Params, UADMAcceptChangeAddToBeConsumedMaterial2Params, UADMAcceptChangeAddDCDRuntimeTask2Params, UADMAcceptChangeAddOperation2Params, UADMAcceptChangeChangeDependency2Params, UADMAcceptChangeChangeToBeConsumedMaterialQuantity2Params, UADMAcceptChangeChangeToBeUsedMachine2Params, UADMAcceptChangeRemoveDependency2Params, UADMAcceptChangeRemoveOperation2Params, UADMAcceptChangeRemoveToBeConsumedMaterial2Params, UADMAcceptChangeReplaceToBeConsumedMaterial2Params, UADMRejectChangeNonConformance2Params, UADMCreateReworkCodeList2Params, UADMSentenceNonConformanceSetLocationHold2Params, UADMManageToBeConsumedMaterialDisassemble2Params, UADMSplitWorkOrder2Params, UADMSkipWOOperationFullQty2Params, UADMSkipWOOperationTransferBatch2Params, UADMSkipWOOperationSerialized2Params, UADMSentenceNonConformancePartially2Params, UADMGetActiveUserListOnWorkOrderOperation2Params, UADMCreateSnagAndNoteList2Params, UADMConfirmSnagAndNoteList2Params, UADMUseTool2Params, UADMSaveDCDRuntimeTaskValues2Params, UADMCheckDCDRuntimeValues2Params, UADMSetLocationHold2Params, UADMDisassembleMaterialItem2Params, UADMExportGenealogy2Params, UADMCreateNewMaterialDefinitionRevision2Params, UADMDisAssignProducedMaterialitems2Params, UADMImportLifecycle2Params, UADMSaveDocumentForPreview2Params, UADMAcceptChangeAddProcessOperation2Params, UADMDeleteEquipment2Params, UADMRemoveWorkOrderScrap2Params, UADMEnableLocationMachineForCompleteByDifferentUser2Params, UADMCreateWorkOrderOperationFromProcessOperation2Params, UADMCreateNonConformanceDefectList2Params, UADMCreateDefectTypeContextualization2Params, UADMCreateDefectGroupContextualization2Params, UADMAssignNonConformanceTransitionRoleList2Params, UADMRemoveNonConformanceTransitionRoleList2Params, UADMRemoveDefectGroupContextualization2Params, UADMRemoveDefectTypeContextualization2Params, UADMAssignNonConformanceTransitionMailAddressList2Params, UADMRemoveNonConformanceTransitionMailAddressList2Params, UADMCreatePrintJobFile2Params, UADMImportAMPrintJobFile2Params, UADMCreateEquipmentSpecificationWithPrintJobFile2Params, UADMEditPrintJobFile2Params, UADMTransferAMData2Params, UADMAutoTransferAMData2Params, UADMCompleteWOOperationTransferBatchMultiMachineList2Params, UADMDeletePrintJobFileList2Params, UADMCreatePrintJobFileList2Params, ImportAMPrintJobFile2Params, UADMPauseWorkOrderOperationMultiMachineList2Params, UADMCompleteWOOperationFullQtyMultiMachineList2Params, UADMDeleteToolDefinitionList2Params, UADMCreateForm2Params, UADMGetPMI2Params, UADMSaveAsWorkInstruction2Params, UADMAssociateFormsToTcM2Params, UADMChangeWorkInstructionStatus2Params, UADMCreateNewProcessRevision2Params, UADMUpdateNonConformance2Params, UADMSetWorkOrderForScheduling2Params, UADMReleaseWorkOrder2Params, UADMAcceptChangeAddToBeUsedTool2Params, PLMCreateIssueReport2Params, PLMCreateMasterPlan2Params, PLMCreateOperationList2Params, PLMCreateProcessList2Params, PLMCreateDocumentList2Params, PLMCreateMaterialDefinitionList2Params, PLMCreateToolDefinitionList2Params, PLMCreateStepList2Params, PLMAssociateDocumentToMaterialDefinitionList2Params, PLMAssociateDocumentToToolDefinitionList2Params, PLMAssociateDocumentToOperationList2Params, PLMAssociateDocumentToStepList2Params, PLMCreateAsPlannedBoP2Params, PLMLinkProcessToProcessFullList2Params, PLMLinkProcessToOperationFullList2Params, PLMLinkOperationToStepFullList2Params, PLMCreateStepMaterialSpecificationFullList2Params, PLMCreateStepToolSpecificationFullList2Params, PLMCreateStepDependencyList2Params, PLMCreateOperationEquipmentSpecLocationFullList2Params, PLMCreateOperationMaterialSpecificationFullList2Params, PLMCreateOperationToolSpecificationFullList2Params, PLMCreateOpDependencyList2Params, PLMSubmit2Params, PLMSubmitMasterPlan2Params, PLMRollback2Params, PLMRollbackMasterPlan2Params, PLMCreateIssueReportResult2Params, PLMCreateWorkOrderHeader2Params, PLMCreateWorkOrderFromMasterPlanBOMResolution2Params, UADMCompleteAsPlannedBOP2Params, UpdateMaterialDefinition2Params, UADMDeleteBufferDefinitionList2Params, CopyToolDefinition2Params, UADMUpdateToolDefinition2Params, UADMDeleteMaterialDefinitions2Params, UADMDeleteAsPlannedBOPList2Params, UADMLinkMaterialItemsToHandlingUnit2Params, UADMLinkGenericItemsToNonConformance2Params, UADMUnLinkGenericItemsFromNonConformance2Params, UADMCreateExecutionGroup2Params, UADMCreateWorkOrderFromProcess2Params, UADMLinkMaterialItemsToBuffer2Params, UADMAcceptChangeAddWorkInstruction2Params, UADMDeleteSkillList2Params, UADMStartNonProductiveActivityList2Params, UADMCompleteNonProductiveActivityList2Params, UADMDeleteNonProductiveActivityList2Params, UADMDeleteOperationStepCategoryList2Params, UADMLinkSkillsToTeam2Params, UADMCopyDM_Material2Params, UADMUnLinkUsersFromTeam2Params, UADMLinkUsersToTeam2Params, UADMDeleteDM_MaterialList2Params, UADMDeleteCustomItlkCheckList2Params, UADMDeleteCustomItlkCheckParameterList2Params, UADMRemoveHoldList2Params, PLMCreateOperationDCDList2Params, PLMCreateStepDCDList2Params, UADMRegisterNonProductiveActivityForUser2Params, UADMDeleteNonProductiveActivityListForUser2Params, UADMUpdateNonProductiveActivityForUser2Params, CancelScheduling2Params, SetInScheduling2Params, SetInScheduled2Params, SetAlternativeSelected2Params, UADMAutomaticCreateNonConformanceOnMTUList2Params, UADMAutomaticCreateNonConformanceOnWOOperation2Params, UADMAutomaticCreateNonConformanceOnEquipment2Params, UADMAutomaticUseToolList2Params, UADMAutomaticConsumeMaterialTrackingUnit2Params, UADMCreateNonConformanceV3_12Params, UADMSentenceNonConformanceV3_12Params, UADMAutomaticSentenceNonConformance2Params, UADMCreateToBeUsedMachinePJF2Params, UADMDeleteStepList2Params, UADMAbruptlyCloseFlexibleWorkOrder2Params, UADMLinkHumanResourceToProcess2Params, UADMUnlinkHumanResourceFromProcess2Params, PLMCreateCertificationWithSkillList2Params, PLMCreateOperationHRSpecificationFullList2Params, PLMCreateStepHRSpecificationFullList2Params, UADMDeleteDefectGroupList2Params, UADMDeleteDefectTypeList2Params, PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList2Params, PLMChangeStatusEventLog2Params, PLMDeleteEventLogList2Params, PLMChangeStatusEventLogList2Params, SetInScheduledNoBulk2Params, PLMCreateOperationDCDWI2Params, PLMCreateStepDCDWI2Params, UADMAutomaticAcquireQualityInspectionData2Params, UADMAutomaticCreateSnagAndNote2Params, UADMConsumeMaterialItemOnContainer2Params, UADMReleaseWorkOrderList2Params, CreateBoMItem2Params, SentenceNonConformance2Params, UpdateSkill2Params, SetWorkOrderHold2Params, TriggerPrintingOnWorkOrderOperation2Params, SetNonConformanceStatusIsFrozen2Params, DeleteMaterialsTrackingUnit2Params, DeleteToolSpecificationList2Params, UnlinkAMMachineToMES2Params, CreateToBeUsedMachinePJF2Params, LinkItlkCheckToOperationToStepLinkList2Params, DeleteUoM2Params, SetToBeCollectedDocument2Params, InitializeCreatedTask2Params, StartWOOperationSerialized2Params, UnlinkDocumentListToDM_MaterialTrackingUnit2Params, TCM2CreateResourceDefinitionList2Params, GetBufferWithActualQuantity2Params, DeleteToolDefinitionDocumentList2Params, SaveWorkInstructionDesign2Params, UnlinkSubstrateDefinitionToMachine2Params, LinkWIDefinitionsToWOStep2Params, LockWorkInstructionDefinition2Params, CreateEquipmentGraphConfiguration2Params, AssociateDNCItemMachineMaterialAssociation2Params, TCM2LinkOperationToStepList2Params, DeleteCustomItlkCheckParameterList2Params, CreateTeam2Params, DeleteProcessToOpLinkDependencyNavigationList2Params, UpdateOperation2Params, CreateEquipmentType2Params, EditWorkOrderHumanResource2Params, AssignNonConformanceTransitionMailAddressList2Params, SplitWorkOrder2Params, CreateVariableCharacteristicSpecification2Params, DeleteHold2Params, CreateDM_MaterialTrackingUnitHistoryList2Params, DeleteSkillList2Params, CreateStatusTransitionDefinition2Params, UnlinkCharacteristicRepresentationToStep2Params, DeleteActualUsedMachine2Params, UADMCreateDocument2Params, CreateBoMItemV4_02Params, RejectMaterialRequest2Params, MaterialItemSplitBatchByPartialPreview2Params, UpdateDM_Material2Params, UADMCreateToolDefinition2Params, DeleteTeam2Params, UpdateItlkCheckWOOpAssociationList2Params, ExecuteCustomItlkCheckOutbound2Params, CreateEquipmentSpecification2Params, SetWorkProcessToBeCleaned2Params, AutoGenerateSerialNumberCodes2Params, LinkUserToWorkOrderOperationList2Params, CreateResultTypeList2Params, AssignProducedMaterialItems2Params, DeleteFutureHoldAfterNonConformanceSentencing2Params, DeleteActiveUserOnMachine2Params, CreateWorkInstructionDefinition2Params, UploadOfflineActionList2Params, APSSetAlternativeSelected2Params, UpdateDNCItemMachineMaterialAssociation2Params, UADMUpdateOperation2Params, TriggerPrintingOnWorkOrder2Params, TCM2LinkProcessToProcessList2Params, AdministrativePause2Params, CheckInUploadDocuments2Params, DeleteStatusBehaviorDefinition2Params, CreateMaterialSpecification2Params, UnlinkDocumentListToStep2Params, CreateWorkOrderOutMsg2Params, LinkSkillsToCertificate2Params, CreateNewOperationRevisionInCatalogue2Params, DeleteNonProductiveActivityListForUser2Params, TCM2CreateMaterialSpecificationList2Params, TraceNonConformanceOnContainer2Params, CreateDocumentListFormFileIds2Params, TCM2CreateToolSpecificationList2Params, TCM2CreateStepDependencyList2Params, LinkSkillsToWorkOrderStep2Params, LinkItlkCheckToOperationStepCategoryList2Params, TCM2AssociateDocumentToOperationList2Params, StartWOStep2Params, UpdateMaterialSpecification2Params, DeleteToolCompatibleMachine2Params, CreateDM_MaterialTrackingUnitHistory2Params, DeleteAsPlannedBoP2Params, ChangeWorkOrderStatusToEdit2Params, UpdateBufferDefinition2Params, UpdateUoMDimension2Params, DeleteWorkProcessDMMaterialTrackingUnitAssociationList2Params, DeleteFailure2Params, LinkToolsToNonConformance2Params, UpdatePreferredProcessToOpLinkDependencyNavigation2Params, DeleteToBeUsedInspection2Params, CreateDocument2Params, UADMUpdateMaterialDefinition2Params, UnLinkPJFToEquipmentSpecification2Params, DeleteStatus2Params, UnlinkItlkCheckToOperationStepCategoryList2Params, UpdateStatusBehaviorDefinition2Params, UpdateItlkCheckToOperationToStepLinkList2Params, DeleteBufferDefinitionList2Params, UnlinkATNInstanceParameterToSetPointItemList2Params, StartUsingScrewingTool2Params, DeleteToolList2Params, LinkOperationStepCategoryToProcessDefinitionList2Params, DeleteNonConformanceNotification2Params, UpdateWOByBop2Params, DeleteTemplateToMaterialPlantList2Params, UpdatePreferredWOOpDependencyNavigation2Params, DeleteEquipmentLevel2Params, RecycleAMPowderBatch2Params, GetDCDRuntimeWIToSaveByMachine2Params, LinkMaterialItemsToHandlingUnit2Params, SetOperationStepCategoryProcessDefinitionByMTU2Params, UnlinkCharacteristicRepresentationToOperation2Params, LinkOperationToProcess2Params, TCM2LinkProcessToOperationList2Params, CreateWorkOrderAndMaterialItemHistory2Params, ConsumeMaterialItem2Params, CompleteWOOperationsSerializedLiteSingleWO2Params, DeleteEquipmentGraphConfiguration2Params, DeleteToBeUsedMachine2Params, UpdateResultList2Params, LinkWorkInstructionsToWOOperation2Params, LinkWOOperationListToExecutionGroup2Params, SetWorkOrderForScheduling2Params, UnLinkToBeUsedMachineToPartProgram2Params, DeleteMasterPlanList2Params, TCM2CreateOpDependencyList2Params, DeleteNonConformanceStatusList2Params, TCM2AssociateDocumentToToolDefinitionList2Params, LinkCharacteristicRepresentationToStep2Params, SetEquipmentStatus2Params, UADMUpdateEquipmentSpecification2Params, CreateEquipmentSpecificationList2Params, DeleteMaterialDefinitionDocumentList2Params, DeleteDefectTypeList2Params, UpdateSubstrateTreatmentAndThickness2Params, CreateMaterialAndDM_Material2Params, SetWorkOrderOperationFutureHold2Params, CreateWorkOrderFromMasterPlanWithQC2Params, CreateStepDependencyList2Params, UpdateWorkOrderHistory2Params, CreateMaterialClass2Params, LinkUserToPlant2Params, GetToBeProducedMaterialsResult2Params, CheckInCompleteWOOperationTransferBatch2Params, UpdateResultTypeList2Params, CompleteWOStepList2Params, DeleteDocument2Params, DeleteUoMFactor2Params, DeleteNonConformanceSupervisor2Params, UpdateToBeUsedMachinePJF2Params, DeleteWorkOrderHistoryMaterialItem2Params, UADMCreateMaterialDefinition2Params, CompleteTaskAndWorkProcessList2Params, LinkOfflineSessionToWorkOrderOperationList2Params, DeleteOperationDependencyList2Params, UnlinkSubstrateToMachine2Params, AutomaticConsumeMaterialItem2Params, CreateWorkOperationType2Params, UADMCreateEquipmentSpecification2Params, RevertResultsStrategy2Params, UpdateCharacteristicFailureAssociation2Params, AutoGenerateMTUCode2Params, ExecuteItlkCheckOutbound2Params, UpdateItlkCheckProcessToOpLinkAssociationList2Params, UpdateSetPointItem2Params, ValidateMaterialCoProductionIsComplete2Params, UnLinkMaterialItemsFromNonConformance2Params, UnlinkAutomationNodeInstanceParameterFromDCItemList2Params, UnlinkWorkOrderHumanResource2Params, DeleteStatusTransitionDefinition2Params, CreateSetPoint2Params, DeleteBuffer2Params, AcceptChangeAddToBeConsumedMaterial2Params, UADMCreateProcessInCatalogue2Params, DeleteWorkOrder2Params, CreateOperationList2Params, UnLinkLogisticWhitelist2Params, CreateToBeUsedMachinePJFFromProcess2Params, DeleteActualUsedTool2Params, UnlinkSkillsFromProcessOperation2Params, CreateTemplateBlock2Params, CreateActualUsedMachinePJF2Params, UpdateTemplateBlock2Params, CreatePauseReason2Params, DeleteOperation2Params, GetMaterialItemListForVerifyWorkOrderOperation2Params, DeleteEquipmentConfiguration2Params, UpdateNonProductiveActivityForUser2Params, CreateNonConformanceStatus2Params, UpdateNonConformanceLifecycle2Params, CheckInCreateNonConformance2Params, DeleteEquipmentGroupConfiguration2Params, RetrieveAllFilterQCData2Params, DeleteSnagAndNoteNotificationList2Params, DeleteStateMachine2Params, CopyToBeProducedFacets2Params, ChangeSetPointStatus2Params, ReleaseTransportOperation2Params, UnlinkSkillsFromCertificate2Params, CreateDefectTypeContextualization2Params, UnlinkMachineDefinitionToSetPoint2Params, DeleteCharacteristicSpecification2Params, LinkSkillsToWorkOrderOperation2Params, TCM2CreateOperationList2Params, DeleteToolHistoryAction2Params, Link3DPrinterToEquipment2Params, UpdateEquipmentConfiguration2Params, DeleteSnagAndNote2Params, DeleteResultTypeList2Params, GenerateRuntimePrintJobFile2Params, UpdateNonConformance2Params, CreateWorkOrderOperation2Params, CreateWorkOOperationDependencies2Params, DeleteNonConformance2Params, AcceptChangeRepeatOperation2Params, LinkPrintJobFileToMachine2Params, LinkSkillsToTeam2Params, LinkWorkInstructionsToContainer2Params, UnlinkPartProgramFromEquipmentSpecification2Params, CreateHoldReason2Params, DisassembleMaterialItemLite2Params, StartWOStepFullQty2Params, UnlinkOperationDependencyToProcess2Params, UpdateWorkOStepDependency2Params, CreateNonConformanceOnContainerContent2Params, DeleteReworkCodeList2Params, UnlinkMaterialFromContainerTypeList2Params, CreateToBeUsedTools2Params, DiscardOfflineSessionList2Params, LinkStepToOperation2Params, GetPJFsHookOnLinkToBeUsedMachineToPJF2Params, DeleteOperationStepCategoryList2Params, UseToolList2Params, MixAMPowderBatchList2Params, CreateBuyOffForActiveMTUs2Params, FilterInputResultsOnUndoRepeatWOOpStrategy2Params, CompleteNonProductiveActivityList2Params, CreateNonConformanceV3_12Params, CreateOperationStepCategory2Params, TCM2CompleteMasterPlan2Params, CreateStepList2Params, GetToBeProducedMaterialsResultOpList2Params, LinkWorkOrderHumanResource2Params, CreateStatusBehaviorDefinition2Params, UpdateAMPowderBatch2Params, SetNonConformanceStatusIsScrapped2Params, UpdateEquipmentConfigurationProperty2Params, DeleteCharacteristicFailureAssociation2Params, UnlinkDocumentToStep2Params, CreateActualUsedMachine2Params, UpdateCustomItlkCheckParameterList2Params, CreateNonConformanceDefectList2Params, CreateWorkOrderSteps2Params, CreateMaterial2Params, CreateProcess2Params, LinkMaterialSpecificationToOperation2Params, RemoveWorkOrderHold2Params, AcquireToolFromAutomationNodeInstanceParameter2Params, UpdateNonConformanceStatus2Params, GetWorkOrderOperationIdToStartByMachine2Params, LinkHumanResourceToProcess2Params, StartWOStepSerialized2Params, CreateResultHistoryList2Params, UpdateExecutionGroupPhase2Params, CreateToBeProducedMaterial2Params, CreateToolHistory2Params, TransmitToolSetPointItemToAutomationNodeParameterList2Params, CreateCharacteristicRepresentation2Params, CreateBoMV4_02Params, GetCurrentUserRoles2Params, CreateWOOpDependencyNavigationList2Params, CreateActualProducedMaterial2Params, CloseWorkProcess2Params, GetEquipSpecWithPJFHook2Params, TCM2AssociateDocumentToMaterialDefinitionList2Params, DeleteOperationDependency2Params, DeleteWorkOrderOperation2Params, EditSkillToOperationList2Params, LinkEquipmentsToBuffers2Params, CreateTemplate2Params, CreateToolDefinitionDocumentList2Params, LinkDocumentToContainerTypeList2Params, DeleteDM_MaterialTrackingUnitHistoryAction2Params, SentenceNonConformancePartially2Params, DeleteFunctionalCodeListV4_02Params, CheckInCompleteWOStepTransferBatch2Params, CreateNewMaterialDefinitionRevision2Params, UpdateNonConformanceStatusBehavior2Params, UnlinkSkillsToWorkOrderStep2Params, LinkBufferDefinitionToLogisticClassList2Params, AbortWorkOrder2Params, DeleteNonConformanceLifecycleList2Params, DeleteTemplateBlocks2Params, GetProcessWithoutOperationsList2Params, DeleteToolHistory2Params, CreateHandlingUnit2Params, CreateActualConsumedMaterial2Params, TCM2CreateEquipmentSpecificationList2Params, CreateNewProcessRevisionInCatalogue2Params, UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList2Params, RemoveEquipmentPreferencesForUser2Params, DeleteEquipmentSpecificationList2Params, StartContainer2Params, CreateOperationDependencyList2Params, LinkEquipmentSpecificationToOperation2Params, UploadDocuments2Params, EditWorkOrder2Params, CompleteTransportOperation2Params, RegisterNonProductiveActivityForUser2Params, GetUserDetailsList2Params, UpdateActualProducedMaterial2Params, DeleteNonConformanceTransitionList2Params, DeleteEquipmentTypePropertyAttribute2Params, UpdateStatusTransition2Params, CreateReworkOrder2Params, EvolveAsPlannedBOP2Params, GetActiveUserListOnWorkOrderOperation2Params, CreateNonConformanceHistory2Params, UADMAutomaticComplete2Params, DeleteStepList2Params, CreateFunctionalCode2Params, UpdateAMPowderBatchGenealogy2Params, DeleteDefect2Params, InEditingWorkInstruction2Params, LinkToBeUsedMachineToPartProgram2Params, CreateActiveUserOnMachine2Params, UpdateEquipmentSpecification2Params, UnlinkHumanResourceFromProcess2Params, PauseContainer2Params, UnlinkOperationToProcess2Params, CreateToolDefinitionDocument2Params, DeleteSupplierList2Params, CreateDefect2Params, CreateEquipmentGraphNodeConfiguration2Params, SetDefectGroupPath2Params, LinkToolToAutomationNodeInstanceList2Params, GetNonConformanceTransitionRoleMailList2Params, ValidateMaterialConsumptionIsComplete2Params, UpdateDNCItem2Params, CreateTool2Params, UnlinkEquipmentToSetPoint2Params, CreateBoM2Params, UpdateEquipmentGraphLinkConfiguration2Params, CreateWorkOrderHistory2Params, UpdateEquipmentGraphType2Params, ChangeBoMStatus2Params, ExecuteItlkCheckInbound2Params, ConsumeMaterialItemOnExecutionGroup2Params, DeleteOperationList2Params, CopyWorkInstructionDefinitionRevision2Params, RemoveWorkOrderOperationFutureHold2Params, LinkEquipmentToSetPoint2Params, UpdateHierarchyEquipmentNodeConfiguration2Params, CreateStatus2Params, LinkSubstrateDefinitionToMachine2Params, DeleteCustomItlkCheckList2Params, EditHumanResourceToProcess2Params, FilterWorkOrderOperationListByCheckCertification2Params, CreateNewStepRevision2Params, DeleteEquipmentTypeProperty2Params, UnlinkMaterialSpecificationToOperation2Params, CreateWorkOrderOperationFromProcessOperation2Params, UpdateCustomItlkCheckList2Params, CreateToolHistoryAction2Params, UpdateVariableCharacteristicSpecification2Params, UpdateWorkOrderStep2Params, CreateEquipmentGroupConfiguration2Params, UnlinkDocumentListToOperation2Params, UnlinkEquipmentSpecificationToOperation2Params, DeleteToolDefinitions2Params, CreateDM_MaterialTrackingUnit2Params, SetWorkInstructionDefinitionRevisionCurrent2Params, CreateExecutionGroup2Params, MergeWOHeaderWithProcess2Params, CheckInStartWOOperationSerialized2Params, DeleteProcessFromCatalogue2Params, BeginIdTemplateEditing2Params, UpdateEquipmentGraphConfiguration2Params, CreateDNCItem2Params, CheckInUseToolList2Params, DeleteWorkInstructionTemplateParameter2Params, GetWorkOrderOperationNIdToCompleteByMachine2Params, TCM2CreateAsPlannedBOP2Params, VerifyWorkOrder2Params, ReopenWorkOrderOperationSerialized2Params, GetProductionProcessFromAsPlanned2Params, DeleteNonConformanceHistory2Params, AcceptChangeAddOperation2Params, DeleteDocumentList2Params, CompleteContainer2Params, PauseWOOperation2Params, DeleteAsPlannedBOPList2Params, CreateHold2Params, LinkToBeUsedMachineToPJF2Params, GetResultStrategy2Params, LinkMachineDefinitionToSetPoint2Params, UpdateTeam2Params, CreateNewWorkInstructionDefinitionRevision2Params, DeleteTemplate2Params, GetResultValueOnEmpty2Params, TCMCreateUoMList2Params, CreateNonConformanceLifecycle2Params, SetIsOutOfDateAsPlannedBOP2Params, CreateActualUsedTool2Params, CheckWorkOrderStatusIsInEditing2Params, CreateItlkCheckHistoryList2Params, UpdateDM_MaterialTrackingUnit2Params, SetWaitingForInspection2Params, DeleteNonProductiveActivityList2Params, LinkAutomationNodeInstanceParameterToDCItemList2Params, LinkPartProgramToEquipmentSpecification2Params, UpdateActualUsedMachinePJF2Params, CopyNonConformanceFromParentWorkOrder2Params, CreateToBeUsedInspection2Params, DeleteWorkOrderHistoryAction2Params, UnlinkWOOperationsFromExecutionGroup2Params, ChangeBufferStatus2Params, ReleaseExecutionGroup2Params, DeleteWorkInstructionDefinitionParameter2Params, AcceptChangeChangeToBeUsedMachine2Params, ChangeHandlingUnitStatus2Params, LinkToolToSetPoint2Params, DeleteCertificationList2Params, SetPreferredMachine2Params, LinkToolDefinitionToSetPoint2Params, DeleteToBeUsedMachinePJF2Params, DeleteToolDefinitionDocument2Params, AutomaticCollectWorkInstruction2Params, CreatePrintJobFile2Params, AcceptChangeReplaceToBeConsumedMaterial2Params, UploadPLMX2Params, UnLinkSkillsFromTeam2Params, CompleteWOStepFullQty2Params, UpdateStep2Params, UnlinkPrintJobFileFromEquipmentType2Params, SetTargetQuantityOnFlexibleWorkOrder2Params, CreateOperation2Params, LinkPJFToEquipmentSpecification2Params, CreateAndAssignProducedMaterialItems2Params, CreateToolCompatibleMachine2Params, LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList2Params, AssociateDNCItemMachineMaterialsAssociation2Params, DeleteWorkInstructionTemplate2Params, ActivateMaterialTrackingUnitOnScrewingTool2Params, LinkWorkInstructionDefinitionListToStep2Params, UpdateTransportOperation2Params, DeleteWOOperationDependency2Params, UnLoadHandlingUnit2Params, TCM2AssociateDocumentToStepList2Params, DisassembleMaterialItem2Params, EnableLocationMachineForCompleteByDifferentUser2Params, UnsetWorkInstructionDefinitionRevisionCurrent2Params, UpdateActualUsedMachine2Params, UpdateEquipmentConfigurationPropertyAttribute2Params, DeleteDefectGroupList2Params, AbortExecutionGroupList2Params, CreateTemplateToMaterialPlant2Params, DeleteSetPointList2Params, CreateSkipReason2Params, CreateWorkInstruction2Params, LinkWorkInstructionsToWOStep2Params, DeleteMaterialSpecificationList2Params, DeleteToBeProducedMaterial2Params, CreateReworkCodeList2Params, LinkProcessToProcess2Params, CreateEquipmentConfiguration2Params, SetCheckedOutOnWorkOrderOperationList2Params, UpdateExecutionGroup2Params, UpdateWorkInstructionTemplateParameter2Params, RemoveCertificationToMaterialList2Params, DeleteMasterPlan2Params, CreateCriticality2Params, DeleteMaterialTrackingUnit2Params, UnLinkUsersFromTeam2Params, UpdateOfflineAction2Params, AcceptChangeAddWorkInstruction2Params, CreateToBeUsedDocuments2Params, CheckInCompleteWOOperationSerialized2Params, CreateWOStepDependency2Params, ReleaseWorkOrder2Params, DeleteBoMItemList2Params, StartWOOperationsSerializedLiteSingleWO2Params, SendMail2Params, StartWOOperationsSerializedLite2Params, CloneAsPlannedBOP2Params, GenerateAndAssociateMTUCode2Params, UpdateStatusDefinition2Params, GenerateWorkOrderNId2Params, CreateAMPowderBatchGenealogy2Params, UnlinkWIDefinitionsFromEGPhase2Params, UpdateFutureHold2Params, EditPrintJobFile2Params, CheckInStartWOOperationTransferBatch2Params, DeleteBufferDefinition2Params, UnlinkItlkCheckToWorkOrderStepList2Params, LinkDocumentListToDM_MaterialTrackingUnit2Params, CreateWorkOrderFromProcess2Params, CreateResultList2Params, CreateMaterialDefinitionDocument2Params, CheckOutWorkOrderOperationList2Params, CreateExecutionGroupPhaseDependency2Params, CreateWorkInstructionTemplate2Params, CreateStatusDefinition2Params, LinkMaterialToContainerTypeList2Params, CreateWorkOrderStepFromStep2Params, SubstrateMaintenance2Params, UseScrewingTool2Params, SetFutureHoldAfterNonConformanceCreation2Params, CreateNonConformanceAttachmentList2Params, DeleteWorkOrderHistory2Params, UnlinkDocumentToOperation2Params, CheckCertificationMultiMachine2Params, CreateLogisticRequestItem2Params, CreateOperationDependency2Params, DeleteWorkInstructionDefinition2Params, PunchInUsers2Params, CheckInCompleteWOStepFullQty2Params, TCM2CreateEquipmentSpecificationFullList2Params, CreateWorkOrder2Params, UseTool2Params, CreateToolSpecificationList2Params, LinkSkillsToProcessOperation2Params, Link3DPrinterTypeToEquipmentType2Params, CreateOperationRevisionSubStructure2Params, LinkProcessToAsPlannedBOP2Params, DeleteEquipmentGraphType2Params, RemoveNonConformanceTransitionMailAddressList2Params, LinkItlkCheckToWorkOrderOperationList2Params, UnloadContainer2Params, CreateChange2Params, DisAssignProducedMaterialItems2Params, UnlinkAutomationNodeInstanceParameterFromMaterialParameterList2Params, TCM2CreateMaterialSpecificationFullList2Params, StartWOOperationFullQty2Params, TakeOwnershipTransportOperation2Params, TraceCertificationHistory2Params, CreateSupplier2Params, AutoGenerateWorkOrderNId2Params, CreateWorkOrdersFromAsPlannedBOP2Params, ReserveMaterialItems2Params, DeleteBufferList2Params, CreateEquipmentLevel2Params, UnlinkWorkInstructionsFromWOStep2Params, AcceptChangeChangeDependency2Params, DeleteFunctionalCodeList2Params, StartExecutionGroup2Params, RemoveCertificationToRoleList2Params, CreateAPSAlert2Params, CreateBufferDefinition2Params, ResendConfirmWorkOrderOperation2Params, DNCTransferDNCItems2Params, UpdateNonConformanceSupervisor2Params, AcquireMTUFromAutomationNodeInstanceParameter2Params, CreateActualCollectedDocumentListOnContainer2Params, CreateToolDefinition2Params, DeleteEquipmentConfigurationProperty2Params, CreateAsPlannedBOP2Params, DeleteTemplateToMaterialPlant2Params, AcceptMaterialRequest2Params, UADMUpdateProcess2Params, AmendResultList2Params, UpdateToBeUsedMachine2Params, AssociateDNCItemMachinesMaterialsAssociation2Params, CreateRuntimeCharacteristicRepresentationContainer2Params, DeleteWOOpDependencyNavigationList2Params, CompleteWorkInstruction2Params, UnlockWorkInstructionDefinition2Params, AcceptChangeRemoveToBeConsumedMaterial2Params, APSSetInScheduled2Params, CreateLogisticClass2Params, Link3DPrinterTypeToMES2Params, AcceptChangeAddProcessOperation2Params, DeleteTool2Params, LinkPJFToMaterialDefinition2Params, UpdateCharacteristicRepresentation2Params, DeleteDNCItem2Params, DeleteAMPowderBatchGenealogy2Params, CreateCustomItlkCheckParameterList2Params, SetConfigurationKey2Params, CreateOperationStructureDependencyList2Params, CreateAndStartWorkProcessListFromProcessDefinition2Params, CreateDM_MaterialTrackingUnitHistoryAction2Params, TCM2CreateToolDefinitionList2Params, UnlinkStepToOperation2Params, CreateNonConformanceSupervisor2Params, CoProduceMaterialTrackingUnit2Params, GetInputResultType2Params, LinkPrintJobFileToEquipmentType2Params, LinkTransferPluginTo3DPrinter2Params, CreateSnagAndNoteList2Params, LinkSuppliersToMaterialV4_02Params, UpdateStateMachine2Params, DeleteCertification2Params, EditWorkOrderOperation2Params, LinkWorkInstructionsToEGPhase2Params, SkipWOOperationFullQty2Params, APSSetInScheduling2Params, AssignCertificationToSkillList2Params, SetDueDateOnExecGroup2Params, DeleteOperationListFromCatalogue2Params, TCM2DeleteLinkProcessToOperationList2Params, SentenceNonConformanceV3_12Params, DeleteStepDependencyList2Params, GetOfflineWorkInstructions2Params, UnlinkOperationListToProcess2Params, DeleteEquipmentGraphLinkConfiguration2Params, CompleteScrewingWOOpOnToolDeactivation2Params, CheckInStartWOStepTransferBatch2Params, CreateNonConformanceNotification2Params, LinkDocumentListToOperation2Params, LoadHandlingUnit2Params, ConsumeMaterialItemOnContainer2Params, SetEquipmentPropertyValue2Params, CheckInConsumeMaterialItem2Params, UADMCreateNewToolDefinitionRevision2Params, AcceptChangeChangeToBeConsumedMaterialQuantity2Params, DeletePauseReason2Params, ManageResultList2Params, AutomaticSentenceNonConformance2Params, UnlinkUserToWorkOrderOperationList2Params, CreateNonConformance2Params, TCM2CreateProcessList2Params, CreateEquipmentSpecificationWithPrintJobFile2Params, UpdateOperationDependency2Params, SkipWOOperationSerialized2Params, DeleteSkipReason2Params, UpdateCertification2Params, LinkWIDefinitionsToWOOperation2Params, CreateSkill_BOP2Params, SetEquipmentPreferencesForUser2Params, AcceptChangeRemoveDependency2Params, UnlinkPrintJobFileToMachine2Params, DeleteFutureHold2Params, DeleteEquipmentConfigurationPropertyAttribute2Params, CreateMaterialSpecificationList2Params, ValidateDataCollectionIsComplete2Params, TCM2CreateToolSpecificationFullList2Params, DeleteCharacteristicRepresentation2Params, AutomaticUseToolList2Params, SetConfigurationKeyList2Params, UpdateLinkStepToOperation2Params, UpdateWorkOrderOperationActualExecutionTimes2Params, CreateSkill2Params, UADMUpdateMaterialSpecification2Params, DNCGetMachineDNCItemAssociation2Params, MaterialItemSplitBatch2Params, UnlinkSetPointItemToSetPoint2Params, ConfirmSnagAndNoteList2Params, ConfirmWorkOrder2Params, ScheduleExecutionGroup2Params, AssociateContainerToWorkOrder2Params, CreateProcessList2Params, TCM2DeleteLinkOperationToStepList2Params, AcceptChangeAddToBeUsedTool2Params, DeassociateDNCItemMachineMaterialAssociation2Params, DeleteUoMDimension2Params, CompleteWOOperationTransferBatch2Params, LinkSetPointItemToSetPoint2Params, SaveResultQuantitiesOnWorkOrderOperationList2Params, CreateWIResultList2Params, UnLinkToolsFromNonConformance2Params, AssignCertificationToUserList2Params, EndIdTemplateEditing2Params, LinkDocumentListToEGPhase2Params, ManageRepeatResultForScrappedMTU2Params, DeleteProducedMaterialUnderRework2Params, DeleteWorkOrderNotificationList2Params, DeleteWorkOStepDependency2Params, DeleteHoldReason2Params, LinkCharacteristicRepresentationToOperation2Params, ManageToBeConsumedMaterialDisassemble2Params, LinkMaterialTrackingUnitToContainerList2Params, AssignNonConformanceTransitionRoleList2Params, CheckInPauseWOOperation2Params, CreateOperationStructureDependency2Params, CreateStateMachine2Params, DeleteStatusTransition2Params, UnLinkWorkInstructionDefinitionListFromStep2Params, StartWOStepTransferBatch2Params, CreateWorkOrderNotification2Params, UnlinkUserToPlant2Params, CreateDefectGroup2Params, CheckMaterialConsumption2Params, GetResolvedToBeUsedMachinesOnWOOperationList2Params, LinkAutomationNodeInstanceParameterToMaterialParameterList2Params, CreateUoMFactor2Params, CreateWorkOrderHistoryAction2Params, CreateContainerType2Params, CreateHierarchyEquipmentNodeConfigurations2Params, UADMCreateNewProcessRevisionMasterPlan2Params, AssignCertificationToLocationList2Params, CompleteWOStepTransferBatch2Params, DeleteMaterialList2Params, StartNonProductiveActivityList2Params, DeleteToBeConsumedMaterial2Params, UpdateEquipmentLevel2Params, LinkItlkCheckToProcessToOpLinkList2Params, CreateFailure2Params, DeleteDNCItemMachineMaterialAssociation2Params, SentenceNonConformanceSetLocationHold2Params, RemoveWorkOrderScrap2Params, UpdateDM_MaterialTrackingUnitHistory2Params, CreateStatusTransition2Params, SetEquipmentPropertyAttributeValue2Params, ReopenWorkOrderOperationTransferBatch2Params, ManageToBeConsumedMaterialDisassembleOnContainer2Params, UnlinkWorkInstructionsFromWOOperation2Params, SetLocationHold2Params, LinkToolSpecificationToOperation2Params, RemoveCertificationToSkillList2Params, LinkMaterialItemToBuffer2Params, GetOfflineWorkInstructionDefinitions2Params, UADMCreateProcess2Params, UpdateStatus2Params, ManageNullResultOnKoWOOperationList2Params, CreateDNCItemMachineMaterialAssociation2Params, GenerateMaterialBatchId2Params, DeleteHierarchyEquipmentNodeConfiguration2Params, LinkWorkInstructionDefinitionListToOperation2Params, UpdateNonConformanceHistory2Params, DeleteEquipmentConfigurationStateMachine2Params, TCM2CreateStepList2Params, DeleteActualConsumedMaterial2Params, DeleteNonConformanceResource2Params, SentencingChangeNonConformance2Params, DeleteWorkOperationTypeList2Params, CreateMaterialGroup2Params, CheckInDataCollection2Params, DeleteToBeUsedTool2Params, DeleteNonConformanceAttachmentList2Params, UpdateSerialNumberList2Params, UpdateDefectType2Params, GenerateSerialNumberCode2Params, AssignCertificationToMaterialList2Params, CreateDM_Material2Params, UpdateDefectGroup2Params, UpdateHold2Params, DeleteProcessNotificationList2Params, TriggerPrintingOnWorkOrderStep2Params, UADMDeleteEquipmentSpecificationList2Params, CreateProducedMaterialUnderRework2Params, UpdateWorkInstructionDefinition2Params, LinkMaterialToContainerList2Params, UpdateUoMFactor2Params, UnVerifyWorkOrder2Params, StartWOOperationTransferBatch2Params, CreateEquipmentConfigurationByDefaultEquipmentType2Params, LinkUsersToTeam2Params, CreateBuffer2Params, UnlinkToolDefinitionToAutomationNodeTypeList2Params, CreateEquipmentGraphType2Params, SaveDocumentForPreview2Params, CreateVisualCharacteristicSpecification2Params, SentenceBuyOff2Params, CreateOfflineSession2Params, CreateStepRevisionSubStructure2Params, SkipWOOperationTransferBatch2Params, UpdateContainerType2Params, CreateAttributiveCharacteristicSpecification2Params, GetPJFsHookOnLinkActualUsedMachinePJF2Params, DeleteEquipmentType2Params, UpdateMaterialAndDM_Material2Params, LinkBufferDefinitionToMaterialDefList2Params, LinkBufferDefinitionToToolDefList2Params, TCM2LinkProcessToOperationFullList2Params, CreateHandlingUnitHistory2Params, UnlinkToBeUsedMachineToPJF2Params, CreateNonProductiveActivity2Params, CompleteCheckIn2Params, UpdateOperationStepCategory2Params, LinkWIDefinitionsToEGPhase2Params, UpdateCharacteristicSpecification2Params, GetWIParameterValues2Params, SetOperationStepCategoryProcessDefinitionActiveStatus2Params, CreateToBeConsumedMaterials2Params, DeleteActualProducedMaterial2Params, UnlinkProcessToAsPlannedBOP2Params, UADMCreateOperation2Params, UnlinkSkillsFromWOOperation2Params, DeleteMachineToDNC2Params, DeleteResultsFromWOOperations2Params, CreateNewProcessRevision2Params, CheckIdTemplateEditing2Params, TCM2CompleteAsPlannedBOP2Params, CreateCharacteristicSpecification2Params, ConfirmWorkOrderOperation2Params, DeleteEquipmentTypeStateMachine2Params, CreateBufferDefinitionRevision2Params, DNCPreviewDNCItem2Params, ReopenWorkOrderOperationList2Params, ManageNullResultOnKoWorkOrderOperation2Params, ExecuteCustomItlkCheckInbound2Params, UnlinkProcessToProcess2Params, UnLinkMaterialItemFromBuffer2Params, LinkItlkCheckToWorkOrderStepList2Params, LinkSkillsToStep2Params, AmendOfflineAction2Params, UpdateEquipmentType2Params, TCM2LinkProcessToProcessFullList2Params, UpdateNonProductiveActivity2Params, LinkAutomationNodeInstanceParameterToToolDefinitionParameterList2Params, LinkToolDefinitionToAutomationNodeTypeList2Params, CreateMaterialDefinitionDocumentList2Params, UnlinkItlkCheckToWorkOrderOperationList2Params, SetWorkInstructionTemplateAsDefault2Params, SetNonConformanceStatusIsClosedOk2Params, UnlinkToolToSetPoint2Params, RemoveDefectGroupContextualization2Params, ManageResultsForSkippedOperations2Params, ManageRepeatOfKoWorkOrderOperation2Params, ConsumeMaterialItemLite2Params, CreateCertification2Params, CheckCertification2Params, CreateTransportOperation2Params, UpdateToolDefinition2Params, CreateWorkOrderStepFromMPProcessStep2Params, ManageResultWorkOrderOperationNIdForSplitWorkOrder2Params, AmendOfResultToRepeatMaterialConsumption2Params, UnlinkWorkInstructionDefinitionListFromOperation2Params, CreateToolSpecification2Params, DeleteToBeUsedDocument2Params, RemoveCertificationToLocationList2Params, CreateExecutionGroupPhase2Params, UnlinkATNTypeParameterFromToolDefinitionSetPointItemList2Params, UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit2Params, UnlinkToolSpecificationToOperation2Params, UnlinkToBeUsedMachineToPJFFromLogicalKey2Params, PunchOutUsers2Params, SetWorkOrderOperationEstimatedTimes2Params, DeletePrintJobFileList2Params, DeleteContainerTypeList2Params, LinkActualUsedMachineToPJF2Params, GetValidMachinesWOOpIds2Params, SelectMTUForPartBasedInspection2Params, CreateNonConformanceItem2Params, CreateNonConformanceResource2Params, EditMaterialItemsLinkedToHandlingUnit2Params, CreateDefectGroupContextualization2Params, LinkATNTypeParameterToToolDefinitionSetPointItemList2Params, UnlinkToolToAutomationNodeInstanceList2Params, CreateProcessRevisionSubStructure2Params, CreateWorkOrderOperations2Params, CreateCustomItlkCheckList2Params, UnlinkPJFToMaterialDefinition2Params, UnlinkItlkCheckToOperationToStepLinkList2Params, UnlinkMaterialTrackingUnitFromContainerList2Params, UpdateEquipmentTypePropertyAttribute2Params, SetIsValid2Params, TCM2DeleteLinkProcessToProcessList2Params, UnLinkMaterialItemsFromHandlingUnit2Params, CreateDM_MaterialTrackingUnitandMaterialTrackingUnit2Params, ChangeSubstrateStatusByThresholds2Params, DeleteMaterialGroup2Params, UseToolListOnContainer2Params, CreateProcessToOpLinkDependencyNavigationList2Params, DeactivateMaterialTrackingUnitOnScrewingTool2Params, CreateNewOperationRevision2Params, DeleteWorkOrderStep2Params, DeleteExecutionGroups2Params, RemoveLocationHold2Params, UnlinkProcessToProcessList2Params, UpdateEquipmentGroupConfiguration2Params, UpdateWorkInstructionTemplate2Params, UADMCreateOperationInCatalogue2Params, UnLinkEquipmentsToBuffers2Params, UpdateSetPoint2Params, UpdateTool2Params, CreateStepInOperation2Params, SplitAndLinkMaterialItemsToHandlingUnit2Params, LinkToBeUsedMachineToPJFForEGPhase2Params, CreateLogisticRequest2Params, LinkMaterialItemsToNonConformance2Params, PauseExecutionGroupPhase2Params, UpdateEquipmentTypeProperty2Params, CreateUoMDimension2Params, StartTransportOperation2Params, UpdateWOOpQuantityAssociatedToEG2Params, CompleteExecutionGroupPhase2Params, UpdateBuffer2Params, UpdateStepDependency2Params, AmendOfResultToRepeat2Params, CompleteAsPlannedBOP2Params, TransmitEquipmentSetPointToAutomationNodeParameters2Params, AcquireDCItemValueFromAutomationNodeInstanceParameter2Params, UpdateUoM2Params, UnlinkItlkCheckToProcessToOpLinkList2Params, UpdateAttributiveCharacteristicSpecification2Params, UpdateVisualCharacteristicSpecification2Params, UpdateMachineToDNC2Params, GenerateSerialNumberCodes2Params, DeleteActualUsedMachinePJF2Params, CheckInCompleteWOStepSerialized2Params, DeassociateDNCItemMachineMaterialsAssociation2Params, CreateWorkOrderHistoryMaterialItem2Params, UnlinkDocumentFromContainerTypeList2Params, LinkDocumentToOperation2Params, DeleteMaterialClassList2Params, LinkSubstrateToMachine2Params, UnlinkSkillsToStep2Params, UADMUpdateToolSpecification2Params, CreateWorkOrderHeader2Params, DeleteEquipmentGraphNodeConfiguration2Params, UADMAutomaticStart2Params, CreateNewStepRevisionInOperation2Params, CreateNonConformanceTransition2Params, UpdateWorkOOperationDependency2Params, CompleteWOOperationFullQty2Params, CompleteWOStepSerialized2Params, AcceptChangeRemoveOperation2Params, CompleteWOOperationsSerializedLite2Params, LinkAMMachineToMES2Params, DNCTransferDNCItem2Params, TCM2CreateDocumentList2Params, UpdateDefect2Params, RemoveNonConformanceTransitionRoleList2Params, DeleteStatusDefinition2Params, UnlinkOperationStepCategoryFromProcessDefinitionList2Params, UpdateItlkCheckWOStepAssociationList2Params, CreateProcessNotification2Params, CreateFutureHold2Params, CreateEquipmentGraphLinkConfiguration2Params, DeleteProcessList2Params, UpdateActualUsedTool2Params, DeleteOperationFromCatalogue2Params, CompleteWOOperationSerialized2Params, UpdateItlkCheckOperationStepCategoryAssociationList2Params, DeleteTemplateBlock2Params, SetExecGroupListInEditStatus2Params, DeleteMaterialDefinitionDocument2Params, UnLinkToBeUsedMachineToPJFForEGPhase2Params, UpdateWorkInstructionDefinitionParameter2Params, TCM2LinkOperationToStepFullList2Params, TCM2CreateMasterPlan2Params, CreateWorkOrderOperationFromMPProcessOperation2Params, CheckInStartWOStepSerialized2Params, UADMCreateMaterialSpecification2Params, CreateWOOpDependencyNavigationMTUAssociation2Params, CreateDefectType2Params, CreateToBeUsedMachine2Params, UnlinkToolDefinitionToSetPoint2Params, ToolMaintenance2Params, LinkATNInstanceParameterToSetPointItemList2Params, AssignCertificationToRoleList2Params, LinkOperationDependencyToProcess2Params, CheckInStartWOStepFullQty2Params, DeleteNonConformanceItem2Params, LinkDocumentListToStep2Params, RemoveDefectTypeContextualization2Params, LoadContainer2Params, CreateMachineToDNC2Params, RemoveCertificationToUserList2Params, ChangeOfflineSessionStatus2Params, ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2Params, ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration2Params, APPMain_GF_ImportLOIPRO2Params, APPMain_GF_ImportMATMAS2Params, APPMain_GF_KeepWorkerAlive_12Params, APPMain_GF_KeepWorkerAlive_22Params, APPMain_GF_KeepWorkerAlive_32Params, APPMain_GF_KeepWorkerAlive_42Params, APPMain_GF_KeepWorkerAlive_52Params, APPMain_GF_CreateKeepAliveWorkerTimer2Params, APPMain_GF_HandleScanFromShopfloor2Params, APPMain_GF_ImportMATMAS_CNMOM2Params, APPMain_GF_ImportLOIPRO_CNMOM2Params, APPMain_GF_ActivateAndStartTask2Params, APPMain_GF_InsertLineRoutingEntry2Params, APPMain_GF_InsertScanDiagnostic2Params, APPMain_GF_CreateMaterial2Params, APPMain_GF_OnEngraverHandshakeSent2Params, APPMain_GF_DeleteProductWaitingForValidation2Params, APPMain_GF_ManageWetTestResult2Params, APPMain_GF_CreateWorkOrderFromLOIPRO2Params, APPMain_GF_UpdateLineRoutingEntry2Params, APPMain_GF_DeleteRunningScan2Params, APPMain_GF_ManageScanFromShopfloor2Params, APPMain_GF_UpsertOperationExtensions2Params, APPMain_GF_SendMessageToHALP2Params, APPMain_GF_DeleteLineRoutingEntry2Params, APPMain_GF_CreateUoM2Params, APPMain_GF_OnPackagingHandshakeSent2Params, APPMain_GF_UpdateProductWaitingForValidation2Params, APPMain_GF_StartRequestDocuments2Params, APPMain_GF_InsertProductWaitingForValidation2Params, APPMain_GF_SendEngraverPrinterData2Params, APPMain_GF_CloseOperationSignalHandler2Params, APPMain_GF_UpdateMaterial2Params, APPMain_GF_GetUoM2Params, APPMain_GF_CreateBoM2Params, APPMain_GF_InsertRunningScan2Params, APPMain_GF_AllowKWAChecksExecution2Params, APPMain_GF_SendPackagingPrinterData2Params, APPMain_DeleteMaterial2Params, APPMain_GF_ClassificationDataImport2Params, APPMain_GF_ClassificationDataRequest2Params, APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized2Params, APPMain_GF_CompleteEquipmentPLCTask2Params, APPMain_GF_OnAssistedPickingStopped2Params, APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized2Params, APPMain_GF_DeleteReworkProcessAssignmentEntry2Params, APPMain_GF_OnEPLCStartWorkOrderOperationSerialized2Params, APPMain_GF_InsertReworkProcessAssignmentEntry2Params, APPMain_GF_SendMESDataToEquipmentPLC2Params, APPMain_GF_UpdateReworkProcessAssignmentEntry2Params, APPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized2Params, APPMain_GF_ResetTag2Params, APPMain_GF_StartEquipmentPLCOperation2Params, APPMain_GF_CompleteEquipmentPLCOperation2Params, APPMain_GF_OnCarrierArrived2Params, APPMain_GF_StartLineControllerOperation2Params, APPMain_GF_OnChangeNonConformanceEntity2Params, APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized2Params, APPMain_GF_CompleteLineControllerOperation2Params, APPMain_GF_ResetAutomationNodeTags2Params, APPMain_GF_SendCarrierToStation2Params, APPMain_GF_CreateGFFile2Params, APPMain_GF_ManageMarking2Params, RepairWorkInstruction2Params, CreateActivityList2Params, RepairMaterialConsumption2Params, MarkForCleaningToolList2Params, CreateCustomActivity2Params, MarkForCleaningWorkOrderList2Params, RepairToolUsage2Params, UpdateWorkOrderStatusAndPropertiesCommand2Params, MarkForCleaningMTUList2Params, MarkForCleaningExecutionGroupList2Params, RepairQualityInspection2Params, RepairScrewingToolUsage2Params, GroupWoOpsTotallyInExecGroupByType2Params, SetToBeCollectedDocumentOnStep2Params, APPMain_GF_DownloadAndAddDocuments2Params, APPMain_GF_HandleWorkOrderIdScanFromShopfloor2Params, APPMain_GF_ManageWorkOrderIdScanFromShopfloor2Params } from "./AppU4DMModel";
import { ApplicationLogLevelType, SegregationTagStatus, UrlSourceEnum, DocumentType, SupportedTypes, StatusScenarioEnum, ValidationModeEnum, ValidationPolicyEnum, QualityActionType, ParameterType, DataType, MTUCodeType, CharacteristicType, AlternativeOperationMTUStatus, AcquisitionBehaviour, CharacteristicContext, TimeBasedUoM, TaskDefinitionParameterDirections, ItlkCheckParameterDataTypeEnum, AcquisitionType, WorkInstructionStepType, WorkInstructionDefinitionParameterDirection, StatusesOutcome, AMSerialNumberManagement, TagDateTimeKind, NCContext, ProductionTypeEnum, GF_MessageToHALPLevels, DocumentRepositoryType, SignatureTypeEnum, TagSmoothingMode, TagAcquisitionMode, TagAddressType } from "./AppU4DMModel";

export class QLogMessageCatalog extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Owner = new QStringPath(this.withPrefix("Owner"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly MessageId = new QNumberPath(this.withPrefix("MessageId"));
    public readonly Level = new QEnumPath(this.withPrefix("Level"), ApplicationLogLevelType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalogParameters = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogParameters"), () => QLogMessageCatalogParameters);
    public readonly LogMessageCatalogLanguages = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogLanguages"), () => QLogMessageCatalogLanguages);
}

export const qLogMessageCatalog = new QLogMessageCatalog();

export class QLogMessageCatalogId extends QId<LogMessageCatalogId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogParameters extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterKey = new QStringPath(this.withPrefix("ParameterKey"));
    public readonly ParameterType = new QStringPath(this.withPrefix("ParameterType"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogParameters = new QLogMessageCatalogParameters();

export class QLogMessageCatalogParametersId extends QId<LogMessageCatalogParametersId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogLanguages extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogLanguages = new QLogMessageCatalogLanguages();

export class QLogMessageCatalogLanguagesId extends QId<LogMessageCatalogLanguagesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly PayloadSize = new QNumberPath(this.withPrefix("PayloadSize"));
    public readonly CreatedBy = new QStringPath(this.withPrefix("CreatedBy"));
    public readonly LastUpdatedBy = new QStringPath(this.withPrefix("LastUpdatedBy"));
    public readonly Folder_Id = new QGuidPath(this.withPrefix("Folder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Folder = new QEntityPath(this.withPrefix("Folder"), () => QFolder);
}

export const qFile = new QFile();

export class QFileId extends QId<FileId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFolder extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ParentFolder_Id = new QGuidPath(this.withPrefix("ParentFolder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentFolder = new QEntityPath(this.withPrefix("ParentFolder"), () => QFolder);
}

export const qFolder = new QFolder();

export class QFolderId extends QId<FolderId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSegregationTag extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly TagStatus = new QEnumPath(this.withPrefix("TagStatus"), SegregationTagStatus);
    public readonly IsLogRelevant = new QBooleanPath(this.withPrefix("IsLogRelevant"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
}

export const qSegregationTag = new QSegregationTag();

export class QSegregationTagId extends QId<SegregationTagId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
}

export const qWorkOrderFacet = new QWorkOrderFacet();

export class QWorkOrderFacetId extends QId<WorkOrderFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
}

export const qOperationFacet = new QOperationFacet();

export class QOperationFacetId extends QId<OperationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSOrderOperationStatus extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QNumberPath(this.withPrefix("Id"));
}

export const qAPSOrderOperationStatus = new QAPSOrderOperationStatus();

export class QAPSOrderOperationStatusId extends QId<APSOrderOperationStatusId> {
    private readonly params = [new QNumberParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSOrderStatus extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QNumberPath(this.withPrefix("Id"));
}

export const qAPSOrderStatus = new QAPSOrderStatus();

export class QAPSOrderStatusId extends QId<APSOrderStatusId> {
    private readonly params = [new QNumberParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSResource extends QueryObject {
    public readonly ResourceName = new QStringPath(this.withPrefix("ResourceName"));
    public readonly ResourceNId = new QStringPath(this.withPrefix("ResourceNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qAPSResource = new QAPSResource();

export class QAPSResourceId extends QId<APSResourceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSOperationRelation extends QueryObject {
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly PredecessorOperationNId = new QStringPath(this.withPrefix("PredecessorOperationNId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DependencyType = new QNumberPath(this.withPrefix("DependencyType"));
}

export const qAPSOperationRelation = new QAPSOperationRelation();

export class QAPSOperationRelationId extends QId<APSOperationRelationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSOperationResource extends QueryObject {
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly ResourceNId = new QStringPath(this.withPrefix("ResourceNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Type = new QNumberPath(this.withPrefix("Type"));
}

export const qAPSOperationResource = new QAPSOperationResource();

export class QAPSOperationResourceId extends QId<APSOperationResourceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSOrder extends QueryObject {
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly OrderNId = new QStringPath(this.withPrefix("OrderNId"));
    public readonly OrderNote = new QStringPath(this.withPrefix("OrderNote"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ProductName = new QStringPath(this.withPrefix("ProductName"));
    public readonly ProductNId = new QStringPath(this.withPrefix("ProductNId"));
    public readonly OrderStatus = new QStringPath(this.withPrefix("OrderStatus"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ProductionType = new QNumberPath(this.withPrefix("ProductionType"));
}

export const qAPSOrder = new QAPSOrder();

export class QAPSOrderId extends QId<APSOrderId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSOrderOperation extends QueryObject {
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly ActualResourceNId = new QStringPath(this.withPrefix("ActualResourceNId"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly Locked = new QNumberPath(this.withPrefix("Locked"));
    public readonly OperationName = new QStringPath(this.withPrefix("OperationName"));
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly OperationSequence = new QNumberPath(this.withPrefix("OperationSequence"));
    public readonly OrderNId = new QStringPath(this.withPrefix("OrderNId"));
    public readonly ProcessRate = new QNumberPath(this.withPrefix("ProcessRate"));
    public readonly ProcessTime = new QNumberPath(this.withPrefix("ProcessTime"));
    public readonly ProcessTimeType = new QNumberPath(this.withPrefix("ProcessTimeType"));
    public readonly OperationStatus = new QStringPath(this.withPrefix("OperationStatus"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qAPSOrderOperation = new QAPSOrderOperation();

export class QAPSOrderOperationId extends QId<APSOrderOperationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingEGSearch extends QueryObject {
    public readonly WONId = new QStringPath(this.withPrefix("WONId"));
    public readonly WOName = new QStringPath(this.withPrefix("WOName"));
    public readonly WODueDate = new QDateTimeOffsetPath(this.withPrefix("WODueDate"));
    public readonly WOEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("WOEstimatedStartTime"));
    public readonly WOEstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("WOEstimatedEndTime"));
    public readonly WOERPOrder = new QStringPath(this.withPrefix("WOERPOrder"));
    public readonly WOInitialQuantity = new QNumberPath(this.withPrefix("WOInitialQuantity"));
    public readonly WOActualTargetQuantity = new QNumberPath(this.withPrefix("WOActualTargetQuantity"));
    public readonly WOPlannedTargetQuantity = new QNumberPath(this.withPrefix("WOPlannedTargetQuantity"));
    public readonly WOTargetQuantity = new QNumberPath(this.withPrefix("WOTargetQuantity"));
    public readonly WOEnterprise = new QStringPath(this.withPrefix("WOEnterprise"));
    public readonly WOPlant = new QStringPath(this.withPrefix("WOPlant"));
    public readonly WOPriority = new QNumberPath(this.withPrefix("WOPriority"));
    public readonly WODMFinalMaterialId = new QGuidPath(this.withPrefix("WODMFinalMaterialId"));
    public readonly WOStatusNId = new QStringPath(this.withPrefix("WOStatusNId"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly FinalMaterialName = new QStringPath(this.withPrefix("FinalMaterialName"));
    public readonly WOONId = new QStringPath(this.withPrefix("WOONId"));
    public readonly WOOName = new QStringPath(this.withPrefix("WOOName"));
    public readonly WOODescription = new QStringPath(this.withPrefix("WOODescription"));
    public readonly WOOElectronicSignatureStart = new QBooleanPath(this.withPrefix("WOOElectronicSignatureStart"));
    public readonly WOOEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("WOOEstimatedStartTime"));
    public readonly WOOEstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("WOOEstimatedEndTime"));
    public readonly WOOActualStartTime = new QDateTimeOffsetPath(this.withPrefix("WOOActualStartTime"));
    public readonly WOOActualEndTime = new QDateTimeOffsetPath(this.withPrefix("WOOActualEndTime"));
    public readonly WOOEstimatedDurationTicks = new QNumberPath(this.withPrefix("WOOEstimatedDurationTicks"));
    public readonly WOOPriority = new QNumberPath(this.withPrefix("WOOPriority"));
    public readonly WOOSequence = new QNumberPath(this.withPrefix("WOOSequence"));
    public readonly WOOIsReady = new QBooleanPath(this.withPrefix("WOOIsReady"));
    public readonly WOOExecutionDurationTicks = new QNumberPath(this.withPrefix("WOOExecutionDurationTicks"));
    public readonly WOOOptional = new QBooleanPath(this.withPrefix("WOOOptional"));
    public readonly WOOSkippable = new QBooleanPath(this.withPrefix("WOOSkippable"));
    public readonly WOOPauseDurationTicks = new QNumberPath(this.withPrefix("WOOPauseDurationTicks"));
    public readonly WOOStatus = new QStringPath(this.withPrefix("WOOStatus"));
    public readonly WOOAvailableQuantity = new QNumberPath(this.withPrefix("WOOAvailableQuantity"));
    public readonly WOOTargetQuantity = new QNumberPath(this.withPrefix("WOOTargetQuantity"));
    public readonly WOOProducedQuantity = new QNumberPath(this.withPrefix("WOOProducedQuantity"));
    public readonly WOOPartialWorkedQuantity = new QNumberPath(this.withPrefix("WOOPartialWorkedQuantity"));
    public readonly WOOReworkedQuantity = new QNumberPath(this.withPrefix("WOOReworkedQuantity"));
    public readonly WOOActiveNonConformanceNr = new QNumberPath(this.withPrefix("WOOActiveNonConformanceNr"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly wooTypeNId = new QStringPath(this.withPrefix("wooTypeNId"));
    public readonly AM = new QBooleanPath(this.withPrefix("AM"));
    public readonly AutoStart = new QBooleanPath(this.withPrefix("AutoStart"));
    public readonly AutoComplete = new QBooleanPath(this.withPrefix("AutoComplete"));
    public readonly WOStateMachineNId = new QStringPath(this.withPrefix("WOStateMachineNId"));
    public readonly WOOStateMachineNId = new QStringPath(this.withPrefix("WOOStateMachineNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly egPhaseId = new QGuidPath(this.withPrefix("egPhaseId"));
    public readonly egWOOId = new QGuidPath(this.withPrefix("egWOOId"));
    public readonly egPhaseStatus = new QStringPath(this.withPrefix("egPhaseStatus"));
    public readonly egPhaseSequence = new QNumberPath(this.withPrefix("egPhaseSequence"));
    public readonly egPhaseEstimatedDurationTicks = new QNumberPath(this.withPrefix("egPhaseEstimatedDurationTicks"));
    public readonly egPhaseEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("egPhaseEstimatedStartTime"));
    public readonly egPhaseEstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("egPhaseEstimatedEndTime"));
    public readonly egPhaseStateMachineNId = new QStringPath(this.withPrefix("egPhaseStateMachineNId"));
    public readonly PreferredMachineNId = new QStringPath(this.withPrefix("PreferredMachineNId"));
    public readonly egNId = new QStringPath(this.withPrefix("egNId"));
    public readonly egName = new QStringPath(this.withPrefix("egName"));
    public readonly egDescription = new QStringPath(this.withPrefix("egDescription"));
    public readonly egEstimatedDuration = new QNumberPath(this.withPrefix("egEstimatedDuration"));
    public readonly egEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("egEstimatedStartTime"));
    public readonly egEstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("egEstimatedEndTime"));
    public readonly egIsUnderScheduling = new QBooleanPath(this.withPrefix("egIsUnderScheduling"));
    public readonly egSchedulingDate = new QDateTimeOffsetPath(this.withPrefix("egSchedulingDate"));
    public readonly egStatus = new QStringPath(this.withPrefix("egStatus"));
    public readonly egStateMachineNId = new QStringPath(this.withPrefix("egStateMachineNId"));
    public readonly egAssociationId = new QGuidPath(this.withPrefix("egAssociationId"));
    public readonly WOOKoQuantity = new QNumberPath(this.withPrefix("WOOKoQuantity"));
    public readonly WOOOkQuantity = new QNumberPath(this.withPrefix("WOOOkQuantity"));
    public readonly egPhaseName = new QStringPath(this.withPrefix("egPhaseName"));
    public readonly egDueDate = new QDateTimeOffsetPath(this.withPrefix("egDueDate"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly WOOId = new QGuidPath(this.withPrefix("WOOId"));
    public readonly egId = new QGuidPath(this.withPrefix("egId"));
    public readonly egCreatedOn = new QDateTimeOffsetPath(this.withPrefix("egCreatedOn"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ToBeUsedMachines = new QEntityCollectionPath(this.withPrefix("ToBeUsedMachines"), () => QEXDSOpLandingMachineEGSearch);
    public readonly ProducedMaterials = new QEntityCollectionPath(this.withPrefix("ProducedMaterials"), () => QEXDSOpLandingProducedMaterialsEGSearch);
}

export const qEXDSOpLandingEGSearch = new QEXDSOpLandingEGSearch();

export class QEXDSOpLandingEGSearchId extends QId<EXDSOpLandingEGSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingWOOSearch extends QueryObject {
    public readonly WONId = new QStringPath(this.withPrefix("WONId"));
    public readonly WOName = new QStringPath(this.withPrefix("WOName"));
    public readonly WODueDate = new QDateTimeOffsetPath(this.withPrefix("WODueDate"));
    public readonly WOEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("WOEstimatedStartTime"));
    public readonly WOEstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("WOEstimatedEndTime"));
    public readonly WOERPOrder = new QStringPath(this.withPrefix("WOERPOrder"));
    public readonly WOInitialQuantity = new QNumberPath(this.withPrefix("WOInitialQuantity"));
    public readonly WOActualTargetQuantity = new QNumberPath(this.withPrefix("WOActualTargetQuantity"));
    public readonly WOPlannedTargetQuantity = new QNumberPath(this.withPrefix("WOPlannedTargetQuantity"));
    public readonly WOTargetQuantity = new QNumberPath(this.withPrefix("WOTargetQuantity"));
    public readonly WOEnterprise = new QStringPath(this.withPrefix("WOEnterprise"));
    public readonly WOPlant = new QStringPath(this.withPrefix("WOPlant"));
    public readonly WOPriority = new QNumberPath(this.withPrefix("WOPriority"));
    public readonly WODMFinalMaterialId = new QGuidPath(this.withPrefix("WODMFinalMaterialId"));
    public readonly WOStatusNId = new QStringPath(this.withPrefix("WOStatusNId"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly FinalMaterialName = new QStringPath(this.withPrefix("FinalMaterialName"));
    public readonly WOONId = new QStringPath(this.withPrefix("WOONId"));
    public readonly WOOName = new QStringPath(this.withPrefix("WOOName"));
    public readonly WOODescription = new QStringPath(this.withPrefix("WOODescription"));
    public readonly WOOElectronicSignatureStart = new QBooleanPath(this.withPrefix("WOOElectronicSignatureStart"));
    public readonly WOOEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("WOOEstimatedStartTime"));
    public readonly WOOEstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("WOOEstimatedEndTime"));
    public readonly WOOActualStartTime = new QDateTimeOffsetPath(this.withPrefix("WOOActualStartTime"));
    public readonly WOOActualEndTime = new QDateTimeOffsetPath(this.withPrefix("WOOActualEndTime"));
    public readonly WOOEstimatedDurationTicks = new QNumberPath(this.withPrefix("WOOEstimatedDurationTicks"));
    public readonly WOOPriority = new QNumberPath(this.withPrefix("WOOPriority"));
    public readonly WOOSequence = new QNumberPath(this.withPrefix("WOOSequence"));
    public readonly WOOIsReady = new QBooleanPath(this.withPrefix("WOOIsReady"));
    public readonly WOOExecutionDurationTicks = new QNumberPath(this.withPrefix("WOOExecutionDurationTicks"));
    public readonly WOOOptional = new QBooleanPath(this.withPrefix("WOOOptional"));
    public readonly WOOSkippable = new QBooleanPath(this.withPrefix("WOOSkippable"));
    public readonly WOOPauseDurationTicks = new QNumberPath(this.withPrefix("WOOPauseDurationTicks"));
    public readonly WOOStatus = new QStringPath(this.withPrefix("WOOStatus"));
    public readonly WOOAvailableQuantity = new QNumberPath(this.withPrefix("WOOAvailableQuantity"));
    public readonly WOOTargetQuantity = new QNumberPath(this.withPrefix("WOOTargetQuantity"));
    public readonly WOOProducedQuantity = new QNumberPath(this.withPrefix("WOOProducedQuantity"));
    public readonly WOOPartialWorkedQuantity = new QNumberPath(this.withPrefix("WOOPartialWorkedQuantity"));
    public readonly WOOReworkedQuantity = new QNumberPath(this.withPrefix("WOOReworkedQuantity"));
    public readonly WOOActiveNonConformanceNr = new QNumberPath(this.withPrefix("WOOActiveNonConformanceNr"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly wooTypeNId = new QStringPath(this.withPrefix("wooTypeNId"));
    public readonly AM = new QBooleanPath(this.withPrefix("AM"));
    public readonly AutoStart = new QBooleanPath(this.withPrefix("AutoStart"));
    public readonly AutoComplete = new QBooleanPath(this.withPrefix("AutoComplete"));
    public readonly WOStateMachineNId = new QStringPath(this.withPrefix("WOStateMachineNId"));
    public readonly WOOStateMachineNId = new QStringPath(this.withPrefix("WOOStateMachineNId"));
    public readonly FacetId = new QGuidPath(this.withPrefix("FacetId"));
    public readonly FacetCheckedOutOffline = new QBooleanPath(this.withPrefix("FacetCheckedOutOffline"));
    public readonly ExistsContainer = new QNumberPath(this.withPrefix("ExistsContainer"));
    public readonly WOOScrappedQuantity = new QNumberPath(this.withPrefix("WOOScrappedQuantity"));
    public readonly WOOElectronicSignaturePause = new QBooleanPath(this.withPrefix("WOOElectronicSignaturePause"));
    public readonly WOOElectronicSignatureComplete = new QBooleanPath(this.withPrefix("WOOElectronicSignatureComplete"));
    public readonly WOOToBeCollectedDocument = new QBooleanPath(this.withPrefix("WOOToBeCollectedDocument"));
    public readonly RealInitialQty = new QNumberPath(this.withPrefix("RealInitialQty"));
    public readonly WOScrappedQuantity = new QNumberPath(this.withPrefix("WOScrappedQuantity"));
    public readonly ExistsExecutionGroup = new QNumberPath(this.withPrefix("ExistsExecutionGroup"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly PreferredMachineNId = new QStringPath(this.withPrefix("PreferredMachineNId"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly WOOId = new QGuidPath(this.withPrefix("WOOId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOKoQuantity = new QNumberPath(this.withPrefix("WOOKoQuantity"));
    public readonly WOOOkQuantity = new QNumberPath(this.withPrefix("WOOOkQuantity"));
    public readonly Frequency = new QNumberPath(this.withPrefix("Frequency"));
    public readonly EngineCounter = new QNumberPath(this.withPrefix("EngineCounter"));
    public readonly ToBeUsedMachines = new QEntityCollectionPath(this.withPrefix("ToBeUsedMachines"), () => QEXDSOpLandingMachineSearch);
    public readonly ProducedMaterials = new QEntityCollectionPath(this.withPrefix("ProducedMaterials"), () => QEXDSOpLandingProducedMaterialsSearch);
    public readonly ProducedMaterialsContainer = new QEntityCollectionPath(this.withPrefix("ProducedMaterialsContainer"), () => QEXDSOpLandingProducedMaterialsContainerSearch);
    public readonly AssignedUsers = new QEntityCollectionPath(this.withPrefix("AssignedUsers"), () => QEXDSOpLandingAssignedUsersSearch);
    public readonly TimeBasedInspectionEngines = new QEntityCollectionPath(this.withPrefix("TimeBasedInspectionEngines"), () => QEXDSOpLandingTimeBasedInspection);
}

export const qEXDSOpLandingWOOSearch = new QEXDSOpLandingWOOSearch();

export class QEXDSOpLandingWOOSearchId extends QId<EXDSOpLandingWOOSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSAsBuiltMaterials extends QueryObject {
    public readonly WONId = new QStringPath(this.withPrefix("WONId"));
    public readonly WOOpName = new QStringPath(this.withPrefix("WOOpName"));
    public readonly WOOpSequence = new QNumberPath(this.withPrefix("WOOpSequence"));
    public readonly WOOpStatusNId = new QStringPath(this.withPrefix("WOOpStatusNId"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly WOStepName = new QStringPath(this.withPrefix("WOStepName"));
    public readonly WOStepSequence = new QNumberPath(this.withPrefix("WOStepSequence"));
    public readonly WOStepStatusNId = new QStringPath(this.withPrefix("WOStepStatusNId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly HistoryAction = new QStringPath(this.withPrefix("HistoryAction"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly QuantityAssembled = new QNumberPath(this.withPrefix("QuantityAssembled"));
    public readonly QuantityDisassembled = new QNumberPath(this.withPrefix("QuantityDisassembled"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly EgPhaseNId = new QStringPath(this.withPrefix("EgPhaseNId"));
    public readonly EgNId = new QStringPath(this.withPrefix("EgNId"));
    public readonly ConsumptionDateTime = new QDateTimeOffsetPath(this.withPrefix("ConsumptionDateTime"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly OccurenceId = new QStringPath(this.withPrefix("OccurenceId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
}

export const qEXDSAsBuiltMaterials = new QEXDSAsBuiltMaterials();

export class QEXDSAsBuiltMaterialsId extends QId<EXDSAsBuiltMaterialsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingMachineSearch extends QueryObject {
    public readonly Machine = new QStringPath(this.withPrefix("Machine"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOSearchId_Id = new QGuidPath(this.withPrefix("WOOSearchId_Id"));
    public readonly WOOSearchId = new QEntityPath(this.withPrefix("WOOSearchId"), () => QEXDSOpLandingWOOSearch);
}

export const qEXDSOpLandingMachineSearch = new QEXDSOpLandingMachineSearch();

export class QEXDSOpLandingMachineSearchId extends QId<EXDSOpLandingMachineSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingProducedMaterialsSearch extends QueryObject {
    public readonly mtuCode = new QStringPath(this.withPrefix("mtuCode"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOSearchId_Id = new QGuidPath(this.withPrefix("WOOSearchId_Id"));
    public readonly WOOSearchId = new QEntityPath(this.withPrefix("WOOSearchId"), () => QEXDSOpLandingWOOSearch);
}

export const qEXDSOpLandingProducedMaterialsSearch = new QEXDSOpLandingProducedMaterialsSearch();

export class QEXDSOpLandingProducedMaterialsSearchId extends QId<EXDSOpLandingProducedMaterialsSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActConsMatWOOp extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MaterialConsumptionStatus = new QStringPath(this.withPrefix("MaterialConsumptionStatus"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly ActualConsumedTotalQty = new QNumberPath(this.withPrefix("ActualConsumedTotalQty"));
    public readonly ActualConsumedCode = new QStringPath(this.withPrefix("ActualConsumedCode"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly ToBeConsumedId = new QGuidPath(this.withPrefix("ToBeConsumedId"));
    public readonly ActualConsumedId = new QGuidPath(this.withPrefix("ActualConsumedId"));
    public readonly ProducedMaterialItemId_Id = new QGuidPath(this.withPrefix("ProducedMaterialItemId_Id"));
    public readonly ProducedMaterialItemId = new QEntityPath(this.withPrefix("ProducedMaterialItemId"), () => QEXDSOpLandingActProducedWOOp);
}

export const qEXDSOpLandingActConsMatWOOp = new QEXDSOpLandingActConsMatWOOp();

export class QEXDSOpLandingActConsMatWOOpId extends QId<EXDSOpLandingActConsMatWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActConsMatWOStep extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MaterialConsumptionStatus = new QStringPath(this.withPrefix("MaterialConsumptionStatus"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly ActualConsumedTotalQty = new QNumberPath(this.withPrefix("ActualConsumedTotalQty"));
    public readonly ActualConsumedCode = new QStringPath(this.withPrefix("ActualConsumedCode"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly ToBeConsumedId = new QGuidPath(this.withPrefix("ToBeConsumedId"));
    public readonly ActualConsumedId = new QGuidPath(this.withPrefix("ActualConsumedId"));
    public readonly ProducedMaterialItemId_Id = new QGuidPath(this.withPrefix("ProducedMaterialItemId_Id"));
    public readonly ProducedMaterialItemId = new QEntityPath(this.withPrefix("ProducedMaterialItemId"), () => QEXDSOpLandingActProducedWOStep);
}

export const qEXDSOpLandingActConsMatWOStep = new QEXDSOpLandingActConsMatWOStep();

export class QEXDSOpLandingActConsMatWOStepId extends QId<EXDSOpLandingActConsMatWOStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActProducedWOOp extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ProdMatStatus = new QStringPath(this.withPrefix("ProdMatStatus"));
    public readonly ConsumptionStatus = new QStringPath(this.withPrefix("ConsumptionStatus"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly DMMTUId = new QGuidPath(this.withPrefix("DMMTUId"));
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QEXDSOpLandingActConsMatWOOp);
}

export const qEXDSOpLandingActProducedWOOp = new QEXDSOpLandingActProducedWOOp();

export class QEXDSOpLandingActProducedWOOpId extends QId<EXDSOpLandingActProducedWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActProducedWOStep extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ProdMatStatus = new QStringPath(this.withPrefix("ProdMatStatus"));
    public readonly ConsumptionStatus = new QStringPath(this.withPrefix("ConsumptionStatus"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly DMMTUId = new QGuidPath(this.withPrefix("DMMTUId"));
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QEXDSOpLandingActConsMatWOStep);
}

export const qEXDSOpLandingActProducedWOStep = new QEXDSOpLandingActProducedWOStep();

export class QEXDSOpLandingActProducedWOStepId extends QId<EXDSOpLandingActProducedWOStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingToBeConsMatWOOp extends QueryObject {
    public readonly WOProductionType = new QStringPath(this.withPrefix("WOProductionType"));
    public readonly ProducedMaterialQty = new QNumberPath(this.withPrefix("ProducedMaterialQty"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly ToBeConsumedTotalQty = new QNumberPath(this.withPrefix("ToBeConsumedTotalQty"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly DM_MaterialDefinitionId = new QGuidPath(this.withPrefix("DM_MaterialDefinitionId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly PrekittedToBeConsumedMaterials = new QEntityCollectionPath(this.withPrefix("PrekittedToBeConsumedMaterials"), () => QEXDSOpLandingPrekittedConsumptionWOOp);
}

export const qEXDSOpLandingToBeConsMatWOOp = new QEXDSOpLandingToBeConsMatWOOp();

export class QEXDSOpLandingToBeConsMatWOOpId extends QId<EXDSOpLandingToBeConsMatWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingToBeConsMatWOStep extends QueryObject {
    public readonly WOProductionType = new QStringPath(this.withPrefix("WOProductionType"));
    public readonly ProducedMaterialQty = new QNumberPath(this.withPrefix("ProducedMaterialQty"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly ToBeConsumedTotalQty = new QNumberPath(this.withPrefix("ToBeConsumedTotalQty"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly DM_MaterialDefinitionId = new QGuidPath(this.withPrefix("DM_MaterialDefinitionId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly PrekittedToBeConsumedMaterials = new QEntityCollectionPath(this.withPrefix("PrekittedToBeConsumedMaterials"), () => QEXDSOpLandingPrekittedConsumptionWOStep);
}

export const qEXDSOpLandingToBeConsMatWOStep = new QEXDSOpLandingToBeConsMatWOStep();

export class QEXDSOpLandingToBeConsMatWOStepId extends QId<EXDSOpLandingToBeConsMatWOStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeAndActualProducedMaterial_MTUAndContainer extends QueryObject {
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly TOBeDMMtuID = new QGuidPath(this.withPrefix("TOBeDMMtuID"));
    public readonly ToBeProducedQuantity = new QNumberPath(this.withPrefix("ToBeProducedQuantity"));
    public readonly DMMtuId = new QGuidPath(this.withPrefix("DMMtuId"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly ActiveNCNumber = new QNumberPath(this.withPrefix("ActiveNCNumber"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly NotWorkedQuantity = new QNumberPath(this.withPrefix("NotWorkedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly PausedQuantity = new QNumberPath(this.withPrefix("PausedQuantity"));
    public readonly ReopenedQuantity = new QNumberPath(this.withPrefix("ReopenedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly SentencedQuantity = new QNumberPath(this.withPrefix("SentencedQuantity"));
    public readonly SplitQuantity = new QNumberPath(this.withPrefix("SplitQuantity"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly ActulDMMtuID = new QGuidPath(this.withPrefix("ActulDMMtuID"));
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly MaterialTrackingUnit = new QGuidPath(this.withPrefix("MaterialTrackingUnit"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialName = new QStringPath(this.withPrefix("MaterialName"));
    public readonly MaterialDescription = new QStringPath(this.withPrefix("MaterialDescription"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly MaterialDefNId = new QStringPath(this.withPrefix("MaterialDefNId"));
    public readonly materialRevision = new QStringPath(this.withPrefix("materialRevision"));
    public readonly materialQuantityValue = new QNumberPath(this.withPrefix("materialQuantityValue"));
    public readonly UoMNid = new QStringPath(this.withPrefix("UoMNid"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly IsContainerActiveOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerActiveOnCurrentOperation"));
    public readonly IsContainerPauseOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerPauseOnCurrentOperation"));
    public readonly IsContainerCompleteOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerCompleteOnCurrentOperation"));
    public readonly ResultStrategy = new QStringPath(this.withPrefix("ResultStrategy"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly SuggestedResultIsKo = new QBooleanPath(this.withPrefix("SuggestedResultIsKo"));
    public readonly SuggestedResultValue = new QStringPath(this.withPrefix("SuggestedResultValue"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsContainer = new QNumberPath(this.withPrefix("IsContainer"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
    public readonly IsRepeatOfKo = new QBooleanPath(this.withPrefix("IsRepeatOfKo"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
}

export const qToBeAndActualProducedMaterial_MTUAndContainer = new QToBeAndActualProducedMaterial_MTUAndContainer();

export class QToBeAndActualProducedMaterial_MTUAndContainerId extends QId<ToBeAndActualProducedMaterial_MTUAndContainerId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSContainerOrMTU extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly StateMachine = new QStringPath(this.withPrefix("StateMachine"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly IsContainer = new QBooleanPath(this.withPrefix("IsContainer"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSContainerOrMTU = new QEXDSContainerOrMTU();

export class QEXDSContainerOrMTUId extends QId<EXDSContainerOrMTUId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingProducedMaterialsContainerSearch extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOSearchId_Id = new QGuidPath(this.withPrefix("WOOSearchId_Id"));
    public readonly WOOSearchId = new QEntityPath(this.withPrefix("WOOSearchId"), () => QEXDSOpLandingWOOSearch);
}

export const qEXDSOpLandingProducedMaterialsContainerSearch = new QEXDSOpLandingProducedMaterialsContainerSearch();

export class QEXDSOpLandingProducedMaterialsContainerSearchId extends QId<EXDSOpLandingProducedMaterialsContainerSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSContainerOrMTUbyWorkOrderOperation extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly StateMachine = new QStringPath(this.withPrefix("StateMachine"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly IsContainer = new QBooleanPath(this.withPrefix("IsContainer"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qEXDSContainerOrMTUbyWorkOrderOperation = new QEXDSContainerOrMTUbyWorkOrderOperation();

export class QEXDSContainerOrMTUbyWorkOrderOperationId extends QId<EXDSContainerOrMTUbyWorkOrderOperationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSActiveMTUOrContainerOnWOOpAndUser extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MaterialTrackingUnitAggregate = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregate"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly TeamNId = new QStringPath(this.withPrefix("TeamNId"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsContainer = new QBooleanPath(this.withPrefix("IsContainer"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
}

export const qEXDSActiveMTUOrContainerOnWOOpAndUser = new QEXDSActiveMTUOrContainerOnWOOpAndUser();

export class QEXDSActiveMTUOrContainerOnWOOpAndUserId extends QId<EXDSActiveMTUOrContainerOnWOOpAndUserId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSActiveMTUOrContainerOnWOStepAndUser extends QueryObject {
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly MaterialTrackingUnitAggregate = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregate"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly TeamNId = new QStringPath(this.withPrefix("TeamNId"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsContainer = new QBooleanPath(this.withPrefix("IsContainer"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
}

export const qEXDSActiveMTUOrContainerOnWOStepAndUser = new QEXDSActiveMTUOrContainerOnWOStepAndUser();

export class QEXDSActiveMTUOrContainerOnWOStepAndUserId extends QId<EXDSActiveMTUOrContainerOnWOStepAndUserId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingMaterialATNInstance extends QueryObject {
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly ATNInstanceNId = new QStringPath(this.withPrefix("ATNInstanceNId"));
    public readonly MaterialParamaterNId = new QStringPath(this.withPrefix("MaterialParamaterNId"));
    public readonly ATNInstanceParameter = new QStringPath(this.withPrefix("ATNInstanceParameter"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSOpLandingMaterialATNInstance = new QEXDSOpLandingMaterialATNInstance();

export class QEXDSOpLandingMaterialATNInstanceId extends QId<EXDSOpLandingMaterialATNInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly TeamNId = new QStringPath(this.withPrefix("TeamNId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly ProdMatStatus = new QStringPath(this.withPrefix("ProdMatStatus"));
    public readonly ConsumptionStatus = new QStringPath(this.withPrefix("ConsumptionStatus"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QEXDSOpLandingActConsMatOnContainerWOOp);
}

export const qEXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser = new QEXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser();

export class QEXDSOpLandingContainerWithConsumptionStatusByWOOpAndUserId extends QId<EXDSOpLandingContainerWithConsumptionStatusByWOOpAndUserId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly TeamNId = new QStringPath(this.withPrefix("TeamNId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly ProdMatStatus = new QStringPath(this.withPrefix("ProdMatStatus"));
    public readonly ConsumptionStatus = new QStringPath(this.withPrefix("ConsumptionStatus"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QEXDSOpLandingActConsMatOnContainerWOStep);
}

export const qEXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser = new QEXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser();

export class QEXDSOpLandingContainerWithConsumptionStatusByWOStepAndUserId extends QId<EXDSOpLandingContainerWithConsumptionStatusByWOStepAndUserId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly TeamNId = new QStringPath(this.withPrefix("TeamNId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly ProdMatStatus = new QStringPath(this.withPrefix("ProdMatStatus"));
    public readonly ConsumptionStatus = new QStringPath(this.withPrefix("ConsumptionStatus"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly DMMTUId = new QGuidPath(this.withPrefix("DMMTUId"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QEXDSOpLandingActConsMatOnMTUWOOp);
}

export const qEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser = new QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser();

export class QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUserId extends QId<EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUserId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly TeamNId = new QStringPath(this.withPrefix("TeamNId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly ProdMatStatus = new QStringPath(this.withPrefix("ProdMatStatus"));
    public readonly ConsumptionStatus = new QStringPath(this.withPrefix("ConsumptionStatus"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly DMMTUId = new QGuidPath(this.withPrefix("DMMTUId"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QEXDSOpLandingActConsMatOnMTUWOStep);
}

export const qEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser = new QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser();

export class QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUserId extends QId<EXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUserId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActConsMatOnContainerWOOp extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly MaterialConsumptionStatus = new QStringPath(this.withPrefix("MaterialConsumptionStatus"));
    public readonly ActualConsumedCode = new QStringPath(this.withPrefix("ActualConsumedCode"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly ActualConsumedTotalQty = new QNumberPath(this.withPrefix("ActualConsumedTotalQty"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ProducedMaterialItemActualQtyOnEquipment = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQtyOnEquipment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly ToBeConsumedId = new QGuidPath(this.withPrefix("ToBeConsumedId"));
    public readonly MaterialTrackingUnitAggregateId_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregateId_Id"));
    public readonly MaterialTrackingUnitAggregateId = new QEntityPath(this.withPrefix("MaterialTrackingUnitAggregateId"), () => QEXDSOpLandingContainerWithConsumptionStatusByWOOpAndUser);
}

export const qEXDSOpLandingActConsMatOnContainerWOOp = new QEXDSOpLandingActConsMatOnContainerWOOp();

export class QEXDSOpLandingActConsMatOnContainerWOOpId extends QId<EXDSOpLandingActConsMatOnContainerWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActConsMatOnContainerWOStep extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly MaterialConsumptionStatus = new QStringPath(this.withPrefix("MaterialConsumptionStatus"));
    public readonly ActualConsumedCode = new QStringPath(this.withPrefix("ActualConsumedCode"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly ActualConsumedTotalQty = new QNumberPath(this.withPrefix("ActualConsumedTotalQty"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ProducedMaterialItemActualQtyOnEquipment = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQtyOnEquipment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly ToBeConsumedId = new QGuidPath(this.withPrefix("ToBeConsumedId"));
    public readonly MaterialTrackingUnitAggregateId_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregateId_Id"));
    public readonly MaterialTrackingUnitAggregateId = new QEntityPath(this.withPrefix("MaterialTrackingUnitAggregateId"), () => QEXDSOpLandingContainerWithConsumptionStatusByWOStepAndUser);
}

export const qEXDSOpLandingActConsMatOnContainerWOStep = new QEXDSOpLandingActConsMatOnContainerWOStep();

export class QEXDSOpLandingActConsMatOnContainerWOStepId extends QId<EXDSOpLandingActConsMatOnContainerWOStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSAsBuiltSN extends QueryObject {
    public readonly IsKO = new QBooleanPath(this.withPrefix("IsKO"));
    public readonly MtuNId = new QStringPath(this.withPrefix("MtuNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MtuDescription = new QStringPath(this.withPrefix("MtuDescription"));
    public readonly MtuName = new QStringPath(this.withPrefix("MtuName"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly MtuStatus = new QStringPath(this.withPrefix("MtuStatus"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UomNId = new QStringPath(this.withPrefix("UomNId"));
    public readonly WeightUoMNId = new QStringPath(this.withPrefix("WeightUoMNId"));
    public readonly WeightQty = new QNumberPath(this.withPrefix("WeightQty"));
    public readonly VolumeUoMNId = new QStringPath(this.withPrefix("VolumeUoMNId"));
    public readonly VolumeQty = new QNumberPath(this.withPrefix("VolumeQty"));
    public readonly DMMatNId = new QStringPath(this.withPrefix("DMMatNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly WorkOrderOperations = new QEntityCollectionPath(this.withPrefix("WorkOrderOperations"), () => QEXDSAsBuiltActualProdMatOnWoop);
}

export const qEXDSAsBuiltSN = new QEXDSAsBuiltSN();

export class QEXDSAsBuiltSNId extends QId<EXDSAsBuiltSNId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSAsBuiltSNWithWOOp extends QueryObject {
    public readonly IsKO = new QBooleanPath(this.withPrefix("IsKO"));
    public readonly MtuNId = new QStringPath(this.withPrefix("MtuNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MtuDescription = new QStringPath(this.withPrefix("MtuDescription"));
    public readonly MtuName = new QStringPath(this.withPrefix("MtuName"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly MtuStatus = new QStringPath(this.withPrefix("MtuStatus"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UomNId = new QStringPath(this.withPrefix("UomNId"));
    public readonly WeightUoMNId = new QStringPath(this.withPrefix("WeightUoMNId"));
    public readonly WeightQty = new QNumberPath(this.withPrefix("WeightQty"));
    public readonly VolumeUoMNId = new QStringPath(this.withPrefix("VolumeUoMNId"));
    public readonly VolumeQty = new QNumberPath(this.withPrefix("VolumeQty"));
    public readonly DMMatNId = new QStringPath(this.withPrefix("DMMatNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
}

export const qEXDSAsBuiltSNWithWOOp = new QEXDSAsBuiltSNWithWOOp();

export class QEXDSAsBuiltSNWithWOOpId extends QId<EXDSAsBuiltSNWithWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeAndActualProducedMaterial_MTUAndContainerForSteps extends QueryObject {
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly TOBeDMMtuID = new QGuidPath(this.withPrefix("TOBeDMMtuID"));
    public readonly ToBeProducedQuantity = new QNumberPath(this.withPrefix("ToBeProducedQuantity"));
    public readonly DMMtuId = new QGuidPath(this.withPrefix("DMMtuId"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly ActiveNCNumber = new QNumberPath(this.withPrefix("ActiveNCNumber"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly NotWorkedQuantity = new QNumberPath(this.withPrefix("NotWorkedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly PausedQuantity = new QNumberPath(this.withPrefix("PausedQuantity"));
    public readonly ReopenedQuantity = new QNumberPath(this.withPrefix("ReopenedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly SentencedQuantity = new QNumberPath(this.withPrefix("SentencedQuantity"));
    public readonly SplitQuantity = new QNumberPath(this.withPrefix("SplitQuantity"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly ActulDMMtuID = new QGuidPath(this.withPrefix("ActulDMMtuID"));
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly MaterialTrackingUnit = new QGuidPath(this.withPrefix("MaterialTrackingUnit"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialName = new QStringPath(this.withPrefix("MaterialName"));
    public readonly MaterialDescription = new QStringPath(this.withPrefix("MaterialDescription"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly MaterialDefNId = new QStringPath(this.withPrefix("MaterialDefNId"));
    public readonly materialRevision = new QStringPath(this.withPrefix("materialRevision"));
    public readonly materialQuantityValue = new QNumberPath(this.withPrefix("materialQuantityValue"));
    public readonly UoMNid = new QStringPath(this.withPrefix("UoMNid"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly IsContainerActiveOnCurrentStep = new QNumberPath(this.withPrefix("IsContainerActiveOnCurrentStep"));
    public readonly IsContainerPauseOnCurrentStep = new QNumberPath(this.withPrefix("IsContainerPauseOnCurrentStep"));
    public readonly IsContainerCompleteOnCurrentStep = new QNumberPath(this.withPrefix("IsContainerCompleteOnCurrentStep"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsContainer = new QNumberPath(this.withPrefix("IsContainer"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qToBeAndActualProducedMaterial_MTUAndContainerForSteps = new QToBeAndActualProducedMaterial_MTUAndContainerForSteps();

export class QToBeAndActualProducedMaterial_MTUAndContainerForStepsId extends QId<ToBeAndActualProducedMaterial_MTUAndContainerForStepsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActConsMatOnMTUWOOp extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MaterialConsumptionStatus = new QStringPath(this.withPrefix("MaterialConsumptionStatus"));
    public readonly ActualConsumedCode = new QStringPath(this.withPrefix("ActualConsumedCode"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly ActualConsumedTotalQty = new QNumberPath(this.withPrefix("ActualConsumedTotalQty"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ProducedMaterialItemActualQtyOnEquipment = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQtyOnEquipment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly ToBeConsumedId = new QGuidPath(this.withPrefix("ToBeConsumedId"));
    public readonly ActualConsumedId = new QGuidPath(this.withPrefix("ActualConsumedId"));
    public readonly ProducedMaterialItemId_Id = new QGuidPath(this.withPrefix("ProducedMaterialItemId_Id"));
    public readonly ProducedMaterialItemId = new QEntityPath(this.withPrefix("ProducedMaterialItemId"), () => QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOOpAndUser);
}

export const qEXDSOpLandingActConsMatOnMTUWOOp = new QEXDSOpLandingActConsMatOnMTUWOOp();

export class QEXDSOpLandingActConsMatOnMTUWOOpId extends QId<EXDSOpLandingActConsMatOnMTUWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingActConsMatOnMTUWOStep extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MaterialConsumptionStatus = new QStringPath(this.withPrefix("MaterialConsumptionStatus"));
    public readonly ActualConsumedCode = new QStringPath(this.withPrefix("ActualConsumedCode"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly ActualConsumedTotalQty = new QNumberPath(this.withPrefix("ActualConsumedTotalQty"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ProducedMaterialItemActualQtyOnEquipment = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQtyOnEquipment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly ToBeConsumedId = new QGuidPath(this.withPrefix("ToBeConsumedId"));
    public readonly ActualConsumedId = new QGuidPath(this.withPrefix("ActualConsumedId"));
    public readonly ProducedMaterialItemId_Id = new QGuidPath(this.withPrefix("ProducedMaterialItemId_Id"));
    public readonly ProducedMaterialItemId = new QEntityPath(this.withPrefix("ProducedMaterialItemId"), () => QEXDSOpLandingMTUNotInContainerWithConsumptionStatusByWOStepAndUser);
}

export const qEXDSOpLandingActConsMatOnMTUWOStep = new QEXDSOpLandingActConsMatOnMTUWOStep();

export class QEXDSOpLandingActConsMatOnMTUWOStepId extends QId<EXDSOpLandingActConsMatOnMTUWOStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSGetResultHistory extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderName = new QStringPath(this.withPrefix("WorkOrderName"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationSequence = new QNumberPath(this.withPrefix("WorkOrderOperationSequence"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderStepId = new QNumberPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly WorkOrderStepSequence = new QNumberPath(this.withPrefix("WorkOrderStepSequence"));
    public readonly WorkOrderStepName = new QStringPath(this.withPrefix("WorkOrderStepName"));
    public readonly CategoryNId = new QStringPath(this.withPrefix("CategoryNId"));
    public readonly CategoryName = new QStringPath(this.withPrefix("CategoryName"));
    public readonly WorkOperationTypeNId = new QStringPath(this.withPrefix("WorkOperationTypeNId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
    public readonly ActionName = new QStringPath(this.withPrefix("ActionName"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ResultIsKO = new QBooleanPath(this.withPrefix("ResultIsKO"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly ResultStrategy = new QStringPath(this.withPrefix("ResultStrategy"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ActivityType = new QStringPath(this.withPrefix("ActivityType"));
    public readonly IsPartial = new QBooleanPath(this.withPrefix("IsPartial"));
    public readonly CreatedWithActivity = new QBooleanPath(this.withPrefix("CreatedWithActivity"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSGetResultHistory = new QEXDSGetResultHistory();

export class QEXDSGetResultHistoryId extends QId<EXDSGetResultHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingAssignedUsersSearch extends QueryObject {
    public readonly UserName = new QStringPath(this.withPrefix("UserName"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOOSearchId_Id = new QGuidPath(this.withPrefix("WOOSearchId_Id"));
    public readonly WOOSearchId = new QEntityPath(this.withPrefix("WOOSearchId"), () => QEXDSOpLandingWOOSearch);
}

export const qEXDSOpLandingAssignedUsersSearch = new QEXDSOpLandingAssignedUsersSearch();

export class QEXDSOpLandingAssignedUsersSearchId extends QId<EXDSOpLandingAssignedUsersSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeAndActualProducedMTUWithContainerForPartialQuantity extends QueryObject {
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly TBQuantity = new QNumberPath(this.withPrefix("TBQuantity"));
    public readonly WorkOrderOpId = new QGuidPath(this.withPrefix("WorkOrderOpId"));
    public readonly ContainerId = new QGuidPath(this.withPrefix("ContainerId"));
    public readonly FakeMTUId = new QGuidPath(this.withPrefix("FakeMTUId"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly ActiveNCNumber = new QNumberPath(this.withPrefix("ActiveNCNumber"));
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialName = new QStringPath(this.withPrefix("MaterialName"));
    public readonly MaterialDescription = new QStringPath(this.withPrefix("MaterialDescription"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly MaterialDefNId = new QStringPath(this.withPrefix("MaterialDefNId"));
    public readonly materialRevision = new QStringPath(this.withPrefix("materialRevision"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly materialQuantityValue = new QNumberPath(this.withPrefix("materialQuantityValue"));
    public readonly UoMNid = new QStringPath(this.withPrefix("UoMNid"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsContainerActiveOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerActiveOnCurrentOperation"));
    public readonly IsContainerPauseOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerPauseOnCurrentOperation"));
    public readonly IsContainerCompleteOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerCompleteOnCurrentOperation"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qToBeAndActualProducedMTUWithContainerForPartialQuantity = new QToBeAndActualProducedMTUWithContainerForPartialQuantity();

export class QToBeAndActualProducedMTUWithContainerForPartialQuantityId extends QId<ToBeAndActualProducedMTUWithContainerForPartialQuantityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSAsBuiltActualProdMatOnWoop extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WoopId = new QGuidPath(this.withPrefix("WoopId"));
    public readonly ProdMatId_Id = new QGuidPath(this.withPrefix("ProdMatId_Id"));
    public readonly ProdMatId = new QEntityPath(this.withPrefix("ProdMatId"), () => QEXDSAsBuiltSN);
}

export const qEXDSAsBuiltActualProdMatOnWoop = new QEXDSAsBuiltActualProdMatOnWoop();

export class QEXDSAsBuiltActualProdMatOnWoopId extends QId<EXDSAsBuiltActualProdMatOnWoopId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantity extends QueryObject {
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly TOBeDMMtuID = new QGuidPath(this.withPrefix("TOBeDMMtuID"));
    public readonly ToBeProducedQuantity = new QNumberPath(this.withPrefix("ToBeProducedQuantity"));
    public readonly ContainerId = new QGuidPath(this.withPrefix("ContainerId"));
    public readonly DMMtuId = new QGuidPath(this.withPrefix("DMMtuId"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly ActiveNCNumber = new QNumberPath(this.withPrefix("ActiveNCNumber"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly NotWorkedQuantity = new QNumberPath(this.withPrefix("NotWorkedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly PausedQuantity = new QNumberPath(this.withPrefix("PausedQuantity"));
    public readonly ReopenedQuantity = new QNumberPath(this.withPrefix("ReopenedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly SentencedQuantity = new QNumberPath(this.withPrefix("SentencedQuantity"));
    public readonly SplitQuantity = new QNumberPath(this.withPrefix("SplitQuantity"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly ActulDMMtuID = new QGuidPath(this.withPrefix("ActulDMMtuID"));
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly MaterialTrackingUnit = new QGuidPath(this.withPrefix("MaterialTrackingUnit"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialName = new QStringPath(this.withPrefix("MaterialName"));
    public readonly MaterialDescription = new QStringPath(this.withPrefix("MaterialDescription"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QNumberPath(this.withPrefix("CodeType"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly MaterialDefNId = new QStringPath(this.withPrefix("MaterialDefNId"));
    public readonly materialRevision = new QStringPath(this.withPrefix("materialRevision"));
    public readonly materialQuantityValue = new QNumberPath(this.withPrefix("materialQuantityValue"));
    public readonly UoMNid = new QStringPath(this.withPrefix("UoMNid"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly IsContainerActiveOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerActiveOnCurrentOperation"));
    public readonly IsContainerPauseOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerPauseOnCurrentOperation"));
    public readonly IsContainerCompleteOnCurrentOperation = new QNumberPath(this.withPrefix("IsContainerCompleteOnCurrentOperation"));
    public readonly SuggestedResultIsKo = new QBooleanPath(this.withPrefix("SuggestedResultIsKo"));
    public readonly SuggestedResultValue = new QStringPath(this.withPrefix("SuggestedResultValue"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsContainer = new QNumberPath(this.withPrefix("IsContainer"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantity = new QToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantity();

export class QToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantityId extends QId<ToBeAndActualProducedMaterial_MTUAndContainerWithPartialQuantityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingPrekittedConsumptionWOOp extends QueryObject {
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly PrekittedTargetMaterialCode = new QStringPath(this.withPrefix("PrekittedTargetMaterialCode"));
    public readonly SourceMTUId = new QGuidPath(this.withPrefix("SourceMTUId"));
    public readonly PrekittedSourceMaterialCode = new QStringPath(this.withPrefix("PrekittedSourceMaterialCode"));
    public readonly PrekittedQty = new QNumberPath(this.withPrefix("PrekittedQty"));
    public readonly ToBeValidated = new QBooleanPath(this.withPrefix("ToBeValidated"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly TargetDMMTUId = new QGuidPath(this.withPrefix("TargetDMMTUId"));
    public readonly TargetMTUId = new QGuidPath(this.withPrefix("TargetMTUId"));
    public readonly SourceDMMTUId = new QGuidPath(this.withPrefix("SourceDMMTUId"));
    public readonly ToBeConsumedMaterialId_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId_Id"));
    public readonly ToBeConsumedMaterialId = new QEntityPath(this.withPrefix("ToBeConsumedMaterialId"), () => QEXDSOpLandingToBeConsMatWOOp);
}

export const qEXDSOpLandingPrekittedConsumptionWOOp = new QEXDSOpLandingPrekittedConsumptionWOOp();

export class QEXDSOpLandingPrekittedConsumptionWOOpId extends QId<EXDSOpLandingPrekittedConsumptionWOOpId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingPrekittedConsumptionWOStep extends QueryObject {
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly PrekittedTargetMaterialCode = new QStringPath(this.withPrefix("PrekittedTargetMaterialCode"));
    public readonly SourceMTUId = new QGuidPath(this.withPrefix("SourceMTUId"));
    public readonly PrekittedSourceMaterialCode = new QStringPath(this.withPrefix("PrekittedSourceMaterialCode"));
    public readonly PrekittedQty = new QNumberPath(this.withPrefix("PrekittedQty"));
    public readonly ToBeValidated = new QBooleanPath(this.withPrefix("ToBeValidated"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly TargetDMMTUId = new QGuidPath(this.withPrefix("TargetDMMTUId"));
    public readonly TargetMTUId = new QGuidPath(this.withPrefix("TargetMTUId"));
    public readonly SourceDMMTUId = new QGuidPath(this.withPrefix("SourceDMMTUId"));
    public readonly ToBeConsumedMaterialId_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId_Id"));
    public readonly ToBeConsumedMaterialId = new QEntityPath(this.withPrefix("ToBeConsumedMaterialId"), () => QEXDSOpLandingToBeConsMatWOStep);
}

export const qEXDSOpLandingPrekittedConsumptionWOStep = new QEXDSOpLandingPrekittedConsumptionWOStep();

export class QEXDSOpLandingPrekittedConsumptionWOStepId extends QId<EXDSOpLandingPrekittedConsumptionWOStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeProducedMTUWithResult extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly WooStepId = new QGuidPath(this.withPrefix("WooStepId"));
    public readonly WoopId = new QGuidPath(this.withPrefix("WoopId"));
    public readonly AggregateId = new QGuidPath(this.withPrefix("AggregateId"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DmMtuId = new QGuidPath(this.withPrefix("DmMtuId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qToBeProducedMTUWithResult = new QToBeProducedMTUWithResult();

export class QToBeProducedMTUWithResultId extends QId<ToBeProducedMTUWithResultId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDMMtuWithResult extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly Volume = new QNumberPath(this.withPrefix("Volume"));
    public readonly VolumeUoM = new QStringPath(this.withPrefix("VolumeUoM"));
    public readonly Weight = new QNumberPath(this.withPrefix("Weight"));
    public readonly WeightUoM = new QStringPath(this.withPrefix("WeightUoM"));
    public readonly CodeType = new QStringPath(this.withPrefix("CodeType"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qDMMtuWithResult = new QDMMtuWithResult();

export class QDMMtuWithResultId extends QId<DMMtuWithResultId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProducedMTUWithResult extends QueryObject {
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SerialNumberCode = new QStringPath(this.withPrefix("SerialNumberCode"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly WorkOrderStatus = new QStringPath(this.withPrefix("WorkOrderStatus"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly CodeType = new QStringPath(this.withPrefix("CodeType"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly DMMTUId = new QGuidPath(this.withPrefix("DMMTUId"));
}

export const qProducedMTUWithResult = new QProducedMTUWithResult();

export class QProducedMTUWithResultId extends QId<ProducedMTUWithResultId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpenWoo extends QueryObject {
    public readonly IsReady = new QBooleanPath(this.withPrefix("IsReady"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
}

export const qEXDSOpenWoo = new QEXDSOpenWoo();

export class QEXDSOpenWooId extends QId<EXDSOpenWooId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpenWooByEquipment extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSOpenWooByEquipment = new QEXDSOpenWooByEquipment();

export class QEXDSOpenWooByEquipmentId extends QId<EXDSOpenWooByEquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpenWooByEquipmentType extends QueryObject {
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSOpenWooByEquipmentType = new QEXDSOpenWooByEquipmentType();

export class QEXDSOpenWooByEquipmentTypeId extends QId<EXDSOpenWooByEquipmentTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSEquipmentRelation extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ChildEquipmentNId = new QStringPath(this.withPrefix("ChildEquipmentNId"));
    public readonly HierarchyNId = new QStringPath(this.withPrefix("HierarchyNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSEquipmentRelation = new QEXDSEquipmentRelation();

export class QEXDSEquipmentRelationId extends QId<EXDSEquipmentRelationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSActiveWoo extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
}

export const qEXDSActiveWoo = new QEXDSActiveWoo();

export class QEXDSActiveWooId extends QId<EXDSActiveWooId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSActiveWooByEquipment extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSActiveWooByEquipment = new QEXDSActiveWooByEquipment();

export class QEXDSActiveWooByEquipmentId extends QId<EXDSActiveWooByEquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSQueueWooByEquipment extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSQueueWooByEquipment = new QEXDSQueueWooByEquipment();

export class QEXDSQueueWooByEquipmentId extends QId<EXDSQueueWooByEquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSQueueWooByEquipmentType extends QueryObject {
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSQueueWooByEquipmentType = new QEXDSQueueWooByEquipmentType();

export class QEXDSQueueWooByEquipmentTypeId extends QId<EXDSQueueWooByEquipmentTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSEquipmentsOnOperations extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OpenOccurence = new QNumberPath(this.withPrefix("OpenOccurence"));
    public readonly QueueOccurence = new QNumberPath(this.withPrefix("QueueOccurence"));
    public readonly ActiveOccurence = new QNumberPath(this.withPrefix("ActiveOccurence"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSEquipmentsOnOperations = new QEXDSEquipmentsOnOperations();

export class QEXDSEquipmentsOnOperationsId extends QId<EXDSEquipmentsOnOperationsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSCompleteWoo extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
}

export const qEXDSCompleteWoo = new QEXDSCompleteWoo();

export class QEXDSCompleteWooId extends QId<EXDSCompleteWooId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSCompleteWooByEquipment extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSCompleteWooByEquipment = new QEXDSCompleteWooByEquipment();

export class QEXDSCompleteWooByEquipmentId extends QId<EXDSCompleteWooByEquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSEquipmentDetails extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentLevel = new QStringPath(this.withPrefix("EquipmentLevel"));
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly CompleteByDifferentUser = new QStringPath(this.withPrefix("CompleteByDifferentUser"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSEquipmentDetails = new QEXDSEquipmentDetails();

export class QEXDSEquipmentDetailsId extends QId<EXDSEquipmentDetailsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSStartableActiveWooByEquipment extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSStartableActiveWooByEquipment = new QEXDSStartableActiveWooByEquipment();

export class QEXDSStartableActiveWooByEquipmentId extends QId<EXDSStartableActiveWooByEquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSStartableActiveWooByEquipmentType extends QueryObject {
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSStartableActiveWooByEquipmentType = new QEXDSStartableActiveWooByEquipmentType();

export class QEXDSStartableActiveWooByEquipmentTypeId extends QId<EXDSStartableActiveWooByEquipmentTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSActiveOperationFromActiveUsersOnMachines extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly WooId = new QGuidPath(this.withPrefix("WooId"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSActiveOperationFromActiveUsersOnMachines = new QEXDSActiveOperationFromActiveUsersOnMachines();

export class QEXDSActiveOperationFromActiveUsersOnMachinesId extends QId<EXDSActiveOperationFromActiveUsersOnMachinesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSCompleteOperationFromActualUsedMachines extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly WooId = new QGuidPath(this.withPrefix("WooId"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSCompleteOperationFromActualUsedMachines = new QEXDSCompleteOperationFromActualUsedMachines();

export class QEXDSCompleteOperationFromActualUsedMachinesId extends QId<EXDSCompleteOperationFromActualUsedMachinesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpenOperationFromToBeUsedMachines extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly IsReady = new QBooleanPath(this.withPrefix("IsReady"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly WooId = new QGuidPath(this.withPrefix("WooId"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSOpenOperationFromToBeUsedMachines = new QEXDSOpenOperationFromToBeUsedMachines();

export class QEXDSOpenOperationFromToBeUsedMachinesId extends QId<EXDSOpenOperationFromToBeUsedMachinesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSStartableOperationFromToBeUsedMachines extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly WooId = new QGuidPath(this.withPrefix("WooId"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSStartableOperationFromToBeUsedMachines = new QEXDSStartableOperationFromToBeUsedMachines();

export class QEXDSStartableOperationFromToBeUsedMachinesId extends QId<EXDSStartableOperationFromToBeUsedMachinesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingMachineEGSearch extends QueryObject {
    public readonly Machine = new QStringPath(this.withPrefix("Machine"));
    public readonly Preferred = new QNumberPath(this.withPrefix("Preferred"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EGSearchId_Id = new QGuidPath(this.withPrefix("EGSearchId_Id"));
    public readonly EGSearchId = new QEntityPath(this.withPrefix("EGSearchId"), () => QEXDSOpLandingEGSearch);
}

export const qEXDSOpLandingMachineEGSearch = new QEXDSOpLandingMachineEGSearch();

export class QEXDSOpLandingMachineEGSearchId extends QId<EXDSOpLandingMachineEGSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingProducedMaterialsEGSearch extends QueryObject {
    public readonly mtuCode = new QStringPath(this.withPrefix("mtuCode"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EGSearchId_Id = new QGuidPath(this.withPrefix("EGSearchId_Id"));
    public readonly EGSearchId = new QEntityPath(this.withPrefix("EGSearchId"), () => QEXDSOpLandingEGSearch);
}

export const qEXDSOpLandingProducedMaterialsEGSearch = new QEXDSOpLandingProducedMaterialsEGSearch();

export class QEXDSOpLandingProducedMaterialsEGSearchId extends QId<EXDSOpLandingProducedMaterialsEGSearchId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSAsBuiltAutoconsumeReferenceMaterials extends QueryObject {
    public readonly WONId = new QStringPath(this.withPrefix("WONId"));
    public readonly WOOpName = new QStringPath(this.withPrefix("WOOpName"));
    public readonly WOOpSequence = new QNumberPath(this.withPrefix("WOOpSequence"));
    public readonly WOOpStatusNId = new QStringPath(this.withPrefix("WOOpStatusNId"));
    public readonly WOStepId = new QGuidPath(this.withPrefix("WOStepId"));
    public readonly WOStepName = new QStringPath(this.withPrefix("WOStepName"));
    public readonly WOStepSequence = new QNumberPath(this.withPrefix("WOStepSequence"));
    public readonly WOStepStatusNId = new QStringPath(this.withPrefix("WOStepStatusNId"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
    public readonly HistoryAction = new QStringPath(this.withPrefix("HistoryAction"));
    public readonly QuantityAssembled = new QNumberPath(this.withPrefix("QuantityAssembled"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly OccurenceId = new QStringPath(this.withPrefix("OccurenceId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
}

export const qEXDSAsBuiltAutoconsumeReferenceMaterials = new QEXDSAsBuiltAutoconsumeReferenceMaterials();

export class QEXDSAsBuiltAutoconsumeReferenceMaterialsId extends QId<EXDSAsBuiltAutoconsumeReferenceMaterialsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingTimeBasedInspection extends QueryObject {
    public readonly Frequency = new QNumberPath(this.withPrefix("Frequency"));
    public readonly TimeBasedScheduleMode = new QStringPath(this.withPrefix("TimeBasedScheduleMode"));
    public readonly CurrentTimerExpiration = new QDateTimeOffsetPath(this.withPrefix("CurrentTimerExpiration"));
    public readonly MandatoryInspectionWarning = new QNumberPath(this.withPrefix("MandatoryInspectionWarning"));
    public readonly MandatoryInspectionWarningUoM = new QStringPath(this.withPrefix("MandatoryInspectionWarningUoM"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EngineId = new QGuidPath(this.withPrefix("EngineId"));
    public readonly WOOSearch_Id = new QGuidPath(this.withPrefix("WOOSearch_Id"));
    public readonly WOOSearch = new QEntityPath(this.withPrefix("WOOSearch"), () => QEXDSOpLandingWOOSearch);
}

export const qEXDSOpLandingTimeBasedInspection = new QEXDSOpLandingTimeBasedInspection();

export class QEXDSOpLandingTimeBasedInspectionId extends QId<EXDSOpLandingTimeBasedInspectionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingDocumentList extends QueryObject {
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly ExecutionGroupPhase = new QGuidPath(this.withPrefix("ExecutionGroupPhase"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly ContainerTypeId = new QGuidPath(this.withPrefix("ContainerTypeId"));
    public readonly PLMXPackageId = new QStringPath(this.withPrefix("PLMXPackageId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Document = new QGuidPath(this.withPrefix("Document"));
}

export const qEXDSOpLandingDocumentList = new QEXDSOpLandingDocumentList();

export class QEXDSOpLandingDocumentListId extends QId<EXDSOpLandingDocumentListId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSGetMTUDocumentAssociation extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly RepositoryType = new QNumberPath(this.withPrefix("RepositoryType"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly DocumentCategoryLink = new QStringPath(this.withPrefix("DocumentCategoryLink"));
    public readonly MaterialTrackingUnitId = new QGuidPath(this.withPrefix("MaterialTrackingUnitId"));
    public readonly DM_MaterialTrackingUnitDocumentAssociationId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitDocumentAssociationId"));
    public readonly EntityLinkId = new QGuidPath(this.withPrefix("EntityLinkId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DocId = new QGuidPath(this.withPrefix("DocId"));
}

export const qEXDSGetMTUDocumentAssociation = new QEXDSGetMTUDocumentAssociation();

export class QEXDSGetMTUDocumentAssociationId extends QId<EXDSGetMTUDocumentAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpLandingGetAllMaterialDefinitionDocuments extends QueryObject {
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly Nid = new QStringPath(this.withPrefix("Nid"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DocId = new QGuidPath(this.withPrefix("DocId"));
}

export const qEXDSOpLandingGetAllMaterialDefinitionDocuments = new QEXDSOpLandingGetAllMaterialDefinitionDocuments();

export class QEXDSOpLandingGetAllMaterialDefinitionDocumentsId extends QId<EXDSOpLandingGetAllMaterialDefinitionDocumentsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSGetNCDocumentAssociation extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly RepositoryType = new QNumberPath(this.withPrefix("RepositoryType"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly NonconformanceId = new QGuidPath(this.withPrefix("NonconformanceId"));
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly NonconformanceHistoryId = new QGuidPath(this.withPrefix("NonconformanceHistoryId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EntityLinkId = new QGuidPath(this.withPrefix("EntityLinkId"));
    public readonly DocId = new QGuidPath(this.withPrefix("DocId"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
}

export const qEXDSGetNCDocumentAssociation = new QEXDSGetNCDocumentAssociation();

export class QEXDSGetNCDocumentAssociationId extends QId<EXDSGetNCDocumentAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QvEXDSBoM extends QueryObject {
    public readonly FinalMaterial = new QStringPath(this.withPrefix("FinalMaterial"));
    public readonly BOM = new QStringPath(this.withPrefix("BOM"));
    public readonly BOMItem = new QStringPath(this.withPrefix("BOMItem"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Material = new QStringPath(this.withPrefix("Material"));
    public readonly ParentBOM = new QGuidPath(this.withPrefix("ParentBOM"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qvEXDSBoM = new QvEXDSBoM();

export class QvEXDSBoMId extends QId<vEXDSBoMId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QvEXDSSnagAndNote extends QueryObject {
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qvEXDSSnagAndNote = new QvEXDSSnagAndNote();

export class QvEXDSSnagAndNoteId extends QId<vEXDSSnagAndNoteId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSDocActualCollectDocument extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly Document = new QGuidPath(this.withPrefix("Document"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly RepositoryType = new QNumberPath(this.withPrefix("RepositoryType"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly egPhaseNId = new QStringPath(this.withPrefix("egPhaseNId"));
    public readonly egPhaseName = new QStringPath(this.withPrefix("egPhaseName"));
    public readonly egNId = new QStringPath(this.withPrefix("egNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
}

export const qEXDSDocActualCollectDocument = new QEXDSDocActualCollectDocument();

export class QEXDSDocActualCollectDocumentId extends QId<EXDSDocActualCollectDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSWorkOrderHistoryRuntimeDocument extends QueryObject {
    public readonly Document = new QStringPath(this.withPrefix("Document"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly RepositoryType = new QNumberPath(this.withPrefix("RepositoryType"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly WorkOrderStepName = new QStringPath(this.withPrefix("WorkOrderStepName"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSWorkOrderHistoryRuntimeDocument = new QEXDSWorkOrderHistoryRuntimeDocument();

export class QEXDSWorkOrderHistoryRuntimeDocumentId extends QId<EXDSWorkOrderHistoryRuntimeDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSGetExecutionGroupList extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSGetExecutionGroupList = new QEXDSGetExecutionGroupList();

export class QEXDSGetExecutionGroupListId extends QId<EXDSGetExecutionGroupListId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSOpenAndStartableOperationFromToBeUsedMachines extends QueryObject {
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WoNId = new QStringPath(this.withPrefix("WoNId"));
    public readonly WoStatus = new QStringPath(this.withPrefix("WoStatus"));
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly IsReady = new QBooleanPath(this.withPrefix("IsReady"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly WooId = new QGuidPath(this.withPrefix("WooId"));
    public readonly WoId = new QGuidPath(this.withPrefix("WoId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qEXDSOpenAndStartableOperationFromToBeUsedMachines = new QEXDSOpenAndStartableOperationFromToBeUsedMachines();

export class QEXDSOpenAndStartableOperationFromToBeUsedMachinesId extends QId<EXDSOpenAndStartableOperationFromToBeUsedMachinesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEXDSGetReworkCode extends QueryObject {
    public readonly DefectTypeId = new QGuidPath(this.withPrefix("DefectTypeId"));
    public readonly DefectGroupId = new QGuidPath(this.withPrefix("DefectGroupId"));
    public readonly DM_MaterialNId = new QStringPath(this.withPrefix("DM_MaterialNId"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly FailureName = new QStringPath(this.withPrefix("FailureName"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProcessNId = new QStringPath(this.withPrefix("ProcessNId"));
    public readonly ProcessRevision = new QStringPath(this.withPrefix("ProcessRevision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly TypeDescription = new QStringPath(this.withPrefix("TypeDescription"));
    public readonly GroupDescription = new QStringPath(this.withPrefix("GroupDescription"));
    public readonly DefectGroupNId = new QStringPath(this.withPrefix("DefectGroupNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
}

export const qEXDSGetReworkCode = new QEXDSGetReworkCode();

export class QEXDSGetReworkCodeId extends QId<EXDSGetReworkCodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationToAutomationNodeInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationToAutomationNodeInstanceFacet);
}

export const qEquipmentConfigurationToAutomationNodeInstance = new QEquipmentConfigurationToAutomationNodeInstance();

export class QEquipmentConfigurationToAutomationNodeInstanceId extends QId<EquipmentConfigurationToAutomationNodeInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentNew extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly Url = new QStringPath(this.withPrefix("Url"));
    public readonly UrlSource = new QEnumPath(this.withPrefix("UrlSource"), UrlSourceEnum);
    public readonly Icon_Id_Id = new QGuidPath(this.withPrefix("Icon_Id_Id"));
    public readonly LocalFile_Id_Id = new QGuidPath(this.withPrefix("LocalFile_Id_Id"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Icon_Id = new QEntityPath(this.withPrefix("Icon_Id"), () => QFile);
    public readonly LocalFile_Id = new QEntityPath(this.withPrefix("LocalFile_Id"), () => QFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDocumentNewFacet);
}

export const qDocumentNew = new QDocumentNew();

export class QDocumentNewId extends QId<DocumentNewId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicRepresentations = new QEntityCollectionPath(this.withPrefix("CharacteristicRepresentations"), () => QCharacteristicRepresentation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QInspectionOperationFacet);
}

export const qInspectionOperation = new QInspectionOperation();

export class QInspectionOperationId extends QId<InspectionOperationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderOperationToolInfo extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly WorkplaceNId = new QStringPath(this.withPrefix("WorkplaceNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
    public readonly AlertCommunication = new QBooleanPath(this.withPrefix("AlertCommunication"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderOperationToolInfoFacet);
}

export const qWorkOrderOperationToolInfo = new QWorkOrderOperationToolInfo();

export class QWorkOrderOperationToolInfoId extends QId<WorkOrderOperationToolInfoId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QScrewingToolHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly UsageDate = new QDateTimeOffsetPath(this.withPrefix("UsageDate"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly Reason = new QStringPath(this.withPrefix("Reason"));
    public readonly Torque = new QNumberPath(this.withPrefix("Torque"));
    public readonly Angle = new QNumberPath(this.withPrefix("Angle"));
    public readonly IsOk = new QBooleanPath(this.withPrefix("IsOk"));
    public readonly ItemId = new QNumberPath(this.withPrefix("ItemId"));
    public readonly ToBeUsedTool_Id = new QGuidPath(this.withPrefix("ToBeUsedTool_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedTool = new QEntityPath(this.withPrefix("ToBeUsedTool"), () => QToBeUsedTool);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QScrewingToolHistoryFacet);
}

export const qScrewingToolHistory = new QScrewingToolHistory();

export class QScrewingToolHistoryId extends QId<ScrewingToolHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
    public readonly TaskContext_Id = new QGuidPath(this.withPrefix("TaskContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContext = new QEntityPath(this.withPrefix("TaskContext"), () => QTaskContext);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextUserFieldFacet);
}

export const qTaskContextUserField = new QTaskContextUserField();

export class QTaskContextUserFieldId extends QId<TaskContextUserFieldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContext extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContextEntityType = new QStringPath(this.withPrefix("ContextEntityType"));
    public readonly ContextDefinitionNId = new QStringPath(this.withPrefix("ContextDefinitionNId"));
    public readonly Task_Id = new QGuidPath(this.withPrefix("Task_Id"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QTaskContextUserField);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Task = new QEntityPath(this.withPrefix("Task"), () => QTask);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextFacet);
}

export const qTaskContext = new QTaskContext();

export class QTaskContextId extends QId<TaskContextId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTask extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskMessageUI = new QStringPath(this.withPrefix("TaskMessageUI"));
    public readonly TaskDefinitionNId = new QStringPath(this.withPrefix("TaskDefinitionNId"));
    public readonly TaskDefinitionRevision = new QStringPath(this.withPrefix("TaskDefinitionRevision"));
    public readonly TaskInstanceUI = new QStringPath(this.withPrefix("TaskInstanceUI"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ErrorCount = new QNumberPath(this.withPrefix("ErrorCount"));
    public readonly IsSkippable = new QBooleanPath(this.withPrefix("IsSkippable"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly TaskFlow = new QEntityPath(this.withPrefix("TaskFlow"), () => QTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types);
    public readonly Contexts = new QEntityCollectionPath(this.withPrefix("Contexts"), () => QTaskContext);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskFacet);
}

export const qTask = new QTask();

export class QTaskId extends QId<TaskId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinitionUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
    public readonly TaskContextDefinition_Id = new QGuidPath(this.withPrefix("TaskContextDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinition = new QEntityPath(this.withPrefix("TaskContextDefinition"), () => QTaskContextDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextDefinitionUserFieldFacet);
}

export const qTaskContextDefinitionUserField = new QTaskContextDefinitionUserField();

export class QTaskContextDefinitionUserFieldId extends QId<TaskContextDefinitionUserFieldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskDefinitionUI = new QStringPath(this.withPrefix("TaskDefinitionUI"));
    public readonly TaskMessageUI = new QStringPath(this.withPrefix("TaskMessageUI"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskEntityType = new QStringPath(this.withPrefix("TaskEntityType"));
    public readonly TaskInstanceUI = new QStringPath(this.withPrefix("TaskInstanceUI"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinitions = new QEntityCollectionPath(this.withPrefix("TaskContextDefinitions"), () => QTaskContextDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskDefinitionFacet);
}

export const qTaskDefinition = new QTaskDefinition();

export class QTaskDefinitionId extends QId<TaskDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContextEntityType = new QStringPath(this.withPrefix("ContextEntityType"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QTaskContextDefinitionUserField);
    public readonly TaskDefinitions = new QEntityCollectionPath(this.withPrefix("TaskDefinitions"), () => QTaskDefinition);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTaskContextDefinitionFacet);
}

export const qTaskContextDefinition = new QTaskContextDefinition();

export class QTaskContextDefinitionId extends QId<TaskContextDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFeatureValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Feature_Id = new QGuidPath(this.withPrefix("Feature_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Feature = new QEntityPath(this.withPrefix("Feature"), () => QFeature);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFeatureValueFacet);
}

export const qFeatureValue = new QFeatureValue();

export class QFeatureValueId extends QId<FeatureValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFeature extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsOption = new QBooleanPath(this.withPrefix("IsOption"));
    public readonly FeatureValueList = new QEntityCollectionPath(this.withPrefix("FeatureValueList"), () => QFeatureValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFeatureFacet);
}

export const qFeature = new QFeature();

export class QFeatureId extends QId<FeatureId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBillOfFeatureItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FeatureNId = new QStringPath(this.withPrefix("FeatureNId"));
    public readonly FeatureValueNId = new QStringPath(this.withPrefix("FeatureValueNId"));
    public readonly IsOption = new QBooleanPath(this.withPrefix("IsOption"));
    public readonly BillOfFeature_Id = new QGuidPath(this.withPrefix("BillOfFeature_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BillOfFeature = new QEntityPath(this.withPrefix("BillOfFeature"), () => QBillOfFeature);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBillOfFeatureItemFacet);
}

export const qBillOfFeatureItem = new QBillOfFeatureItem();

export class QBillOfFeatureItemId extends QId<BillOfFeatureItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedBillOfFeature extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedBillOfFeatureFacet);
}

export const qToBeUsedBillOfFeature = new QToBeUsedBillOfFeature();

export class QToBeUsedBillOfFeatureId extends QId<ToBeUsedBillOfFeatureId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBillOfFeature extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly BillOfFeatureItemList = new QEntityCollectionPath(this.withPrefix("BillOfFeatureItemList"), () => QBillOfFeatureItem);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBillOfFeatureFacet);
}

export const qBillOfFeature = new QBillOfFeature();

export class QBillOfFeatureId extends QId<BillOfFeatureId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternEntityInfo extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AppName = new QStringPath(this.withPrefix("AppName"));
    public readonly EntityName = new QStringPath(this.withPrefix("EntityName"));
    public readonly EntityProperty = new QStringPath(this.withPrefix("EntityProperty"));
    public readonly NumberingPatternEntityNId_Id = new QGuidPath(this.withPrefix("NumberingPatternEntityNId_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternEntityNId = new QEntityPath(this.withPrefix("NumberingPatternEntityNId"), () => QNumberingPatternEntity);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternEntityInfoFacet);
}

export const qNumberingPatternEntityInfo = new QNumberingPatternEntityInfo();

export class QNumberingPatternEntityInfoId extends QId<NumberingPatternEntityInfoId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternMaterialAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPatternNId = new QStringPath(this.withPrefix("NumberingPatternNId"));
    public readonly EntityTypeNId = new QStringPath(this.withPrefix("EntityTypeNId"));
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternMaterialAssociationFacet);
}

export const qNumberingPatternMaterialAssociation = new QNumberingPatternMaterialAssociation();

export class QNumberingPatternMaterialAssociationId extends QId<NumberingPatternMaterialAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventLogFailureNotification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly ExtEventLog_Id = new QGuidPath(this.withPrefix("ExtEventLog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventLog = new QEntityPath(this.withPrefix("ExtEventLog"), () => QExtEventLog);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExtEventLogFailureNotificationFacet);
}

export const qExtEventLogFailureNotification = new QExtEventLogFailureNotification();

export class QExtEventLogFailureNotificationId extends QId<ExtEventLogFailureNotificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedSetPointItemATNInstanceAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationInstanceNId = new QStringPath(this.withPrefix("AutomationInstanceNId"));
    public readonly AutomationInstanceParameterNId = new QStringPath(this.withPrefix("AutomationInstanceParameterNId"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly SetPointItemValue = new QStringPath(this.withPrefix("SetPointItemValue"));
    public readonly IsDefaultValue = new QBooleanPath(this.withPrefix("IsDefaultValue"));
    public readonly SetPointItem_Id = new QGuidPath(this.withPrefix("SetPointItem_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItem = new QEntityPath(this.withPrefix("SetPointItem"), () => QSetPointItem);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedSetPointItemATNInstanceAssociationFacet);
}

export const qToBeUsedSetPointItemATNInstanceAssociation = new QToBeUsedSetPointItemATNInstanceAssociation();

export class QToBeUsedSetPointItemATNInstanceAssociationId extends QId<ToBeUsedSetPointItemATNInstanceAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeCharReprRefOperationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimeCharacteristicRepresentationNId = new QStringPath(this.withPrefix("RuntimeCharacteristicRepresentationNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ProcessToOperationLinkUId = new QStringPath(this.withPrefix("ProcessToOperationLinkUId"));
    public readonly ChrReprFrequencyNId = new QStringPath(this.withPrefix("ChrReprFrequencyNId"));
    public readonly ToBeUsedInspection_Id = new QGuidPath(this.withPrefix("ToBeUsedInspection_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedInspection = new QEntityPath(this.withPrefix("ToBeUsedInspection"), () => QToBeUsedInspection);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QRuntimeCharReprRefOperationAssociationFacet);
}

export const qRuntimeCharReprRefOperationAssociation = new QRuntimeCharReprRefOperationAssociation();

export class QRuntimeCharReprRefOperationAssociationId extends QId<RuntimeCharReprRefOperationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCharacteristicRepresentationFrequency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicRepresentation = new QEntityCollectionPath(this.withPrefix("CharacteristicRepresentation"), () => QCharacteristicRepresentation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCharacteristicRepresentationFrequencyFacet);
}

export const qCharacteristicRepresentationFrequency = new QCharacteristicRepresentationFrequency();

export class QCharacteristicRepresentationFrequencyId extends QId<CharacteristicRepresentationFrequencyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QScenarioInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActionLabel = new QStringPath(this.withPrefix("ActionLabel"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SignedEntityType = new QStringPath(this.withPrefix("SignedEntityType"));
    public readonly Status = new QEnumPath(this.withPrefix("Status"), StatusScenarioEnum);
    public readonly ValidationMode = new QEnumPath(this.withPrefix("ValidationMode"), ValidationModeEnum);
    public readonly ScenarioConfigurationId = new QGuidPath(this.withPrefix("ScenarioConfigurationId"));
    public readonly ScenarioConfigurationNId = new QStringPath(this.withPrefix("ScenarioConfigurationNId"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly ScenarioConfigurationVersion = new QStringPath(this.withPrefix("ScenarioConfigurationVersion"));
    public readonly ApplicationName = new QStringPath(this.withPrefix("ApplicationName"));
    public readonly SignedEntityId = new QGuidPath(this.withPrefix("SignedEntityId"));
    public readonly ValidationPolicy = new QEnumPath(this.withPrefix("ValidationPolicy"), ValidationPolicyEnum);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SignatureInstances = new QEntityCollectionPath(this.withPrefix("SignatureInstances"), () => QSignatureInstance);
}

export const qScenarioInstance = new QScenarioInstance();

export class QScenarioInstanceId extends QId<ScenarioInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSignatureInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Reason = new QStringPath(this.withPrefix("Reason"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly Status = new QEnumPath(this.withPrefix("Status"), StatusScenarioEnum);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly IsCommentMandatory = new QBooleanPath(this.withPrefix("IsCommentMandatory"));
    public readonly Index = new QNumberPath(this.withPrefix("Index"));
    public readonly ScenarioInstance_Id = new QGuidPath(this.withPrefix("ScenarioInstance_Id"));
    public readonly Signer = new QEntityPath(this.withPrefix("Signer"), () => QSignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types);
    public readonly UserIdentity = new QEntityPath(this.withPrefix("UserIdentity"), () => QSignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ScenarioInstance = new QEntityPath(this.withPrefix("ScenarioInstance"), () => QScenarioInstance);
}

export const qSignatureInstance = new QSignatureInstance();

export class QSignatureInstanceId extends QId<SignatureInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSignatureConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Reason = new QStringPath(this.withPrefix("Reason"));
    public readonly IsCommentMandatory = new QBooleanPath(this.withPrefix("IsCommentMandatory"));
    public readonly Index = new QNumberPath(this.withPrefix("Index"));
    public readonly ScenarioConfiguration_Id = new QGuidPath(this.withPrefix("ScenarioConfiguration_Id"));
    public readonly Signer = new QEntityPath(this.withPrefix("Signer"), () => QSignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ScenarioConfiguration = new QEntityPath(this.withPrefix("ScenarioConfiguration"), () => QScenarioConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSignatureConfigurationFacet);
}

export const qSignatureConfiguration = new QSignatureConfiguration();

export class QSignatureConfigurationId extends QId<SignatureConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QScenarioConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly MultipleSignaturesFromSameUser = new QBooleanPath(this.withPrefix("MultipleSignaturesFromSameUser"));
    public readonly ValidationPolicy = new QEnumPath(this.withPrefix("ValidationPolicy"), ValidationPolicyEnum);
    public readonly SignatureConfigurations = new QEntityCollectionPath(this.withPrefix("SignatureConfigurations"), () => QSignatureConfiguration);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QScenarioConfigurationFacet);
}

export const qScenarioConfiguration = new QScenarioConfiguration();

export class QScenarioConfigurationId extends QId<ScenarioConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOutMsg extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MsgId = new QStringPath(this.withPrefix("MsgId"));
    public readonly OutMsgDefinitionNId = new QStringPath(this.withPrefix("OutMsgDefinitionNId"));
    public readonly MsgHeaderData = new QBinaryPath(this.withPrefix("MsgHeaderData"));
    public readonly SendTime = new QDateTimeOffsetPath(this.withPrefix("SendTime"));
    public readonly MsgSchemaNId = new QStringPath(this.withPrefix("MsgSchemaNId"));
    public readonly IsRegenerated = new QBooleanPath(this.withPrefix("IsRegenerated"));
    public readonly PlantNId = new QStringPath(this.withPrefix("PlantNId"));
    public readonly PlantERPNId = new QStringPath(this.withPrefix("PlantERPNId"));
    public readonly WorkPlaceNId = new QStringPath(this.withPrefix("WorkPlaceNId"));
    public readonly DestinationNId = new QStringPath(this.withPrefix("DestinationNId"));
    public readonly PFCMilestoneNId = new QStringPath(this.withPrefix("PFCMilestoneNId"));
    public readonly PFCDiagramNId = new QStringPath(this.withPrefix("PFCDiagramNId"));
    public readonly MaterialInstanceNId = new QStringPath(this.withPrefix("MaterialInstanceNId"));
    public readonly PFCMilestoneSequence = new QNumberPath(this.withPrefix("PFCMilestoneSequence"));
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
    public readonly OutMsgDefinitionRevision = new QStringPath(this.withPrefix("OutMsgDefinitionRevision"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOutMsgFacet);
}

export const qOutMsg = new QOutMsg();

export class QOutMsgId extends QId<OutMsgId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_FunctionalCode extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDM_FunctionalCodeFacet);
}

export const qDM_FunctionalCode = new QDM_FunctionalCode();

export class QDM_FunctionalCodeId extends QId<DM_FunctionalCodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialSupplierAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SupplierNId = new QStringPath(this.withPrefix("SupplierNId"));
    public readonly Supplier_Id = new QGuidPath(this.withPrefix("Supplier_Id"));
    public readonly DM_Material_Id = new QGuidPath(this.withPrefix("DM_Material_Id"));
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Supplier = new QEntityPath(this.withPrefix("Supplier"), () => QSupplier);
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QDM_Material);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialSupplierAssociationFacet);
}

export const qMaterialSupplierAssociation = new QMaterialSupplierAssociation();

export class QMaterialSupplierAssociationId extends QId<MaterialSupplierAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionToExecutionGroupPhaseAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly WorkInstruction_Id = new QGuidPath(this.withPrefix("WorkInstruction_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupPhase = new QEntityPath(this.withPrefix("ExecutionGroupPhase"), () => QExecutionGroupPhase);
    public readonly WorkInstruction = new QEntityPath(this.withPrefix("WorkInstruction"), () => QWorkInstruction);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionToExecutionGroupPhaseAssociationFacet);
}

export const qWorkInstructionToExecutionGroupPhaseAssociation = new QWorkInstructionToExecutionGroupPhaseAssociation();

export class QWorkInstructionToExecutionGroupPhaseAssociationId extends QId<WorkInstructionToExecutionGroupPhaseAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIDefinitionToEGPhaseAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionAssociationType_Id = new QGuidPath(this.withPrefix("WorkInstructionAssociationType_Id"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly EGPhase_Id = new QGuidPath(this.withPrefix("EGPhase_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionAssociationType = new QEntityPath(this.withPrefix("WorkInstructionAssociationType"), () => QWorkInstructionAssociationType);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
    public readonly EGPhase = new QEntityPath(this.withPrefix("EGPhase"), () => QExecutionGroupPhase);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWIDefinitionToEGPhaseAssociationFacet);
}

export const qWIDefinitionToEGPhaseAssociation = new QWIDefinitionToEGPhaseAssociation();

export class QWIDefinitionToEGPhaseAssociationId extends QId<WIDefinitionToEGPhaseAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly IsKO = new QBooleanPath(this.withPrefix("IsKO"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QResultTypeFacet);
}

export const qResultType = new QResultType();

export class QResultTypeId extends QId<ResultTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultStrategy extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QResultStrategyFacet);
}

export const qResultStrategy = new QResultStrategy();

export class QResultStrategyId extends QId<ResultStrategyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QResultHistoryActionFacet);
}

export const qResultHistoryAction = new QResultHistoryAction();

export class QResultHistoryActionId extends QId<ResultHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly ResultStrategy = new QStringPath(this.withPrefix("ResultStrategy"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ActivityType = new QStringPath(this.withPrefix("ActivityType"));
    public readonly IsPartial = new QBooleanPath(this.withPrefix("IsPartial"));
    public readonly ResultIsKO = new QBooleanPath(this.withPrefix("ResultIsKO"));
    public readonly ResultHistoryAction_Id = new QGuidPath(this.withPrefix("ResultHistoryAction_Id"));
    public readonly Results_Id = new QGuidPath(this.withPrefix("Results_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ResultHistoryAction = new QEntityPath(this.withPrefix("ResultHistoryAction"), () => QResultHistoryAction);
    public readonly Results = new QEntityPath(this.withPrefix("Results"), () => QResult);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QResultHistoryFacet);
}

export const qResultHistory = new QResultHistory();

export class QResultHistoryId extends QId<ResultHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResult extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ActivityType = new QStringPath(this.withPrefix("ActivityType"));
    public readonly IsPartial = new QBooleanPath(this.withPrefix("IsPartial"));
    public readonly ResultStrategy_Id = new QGuidPath(this.withPrefix("ResultStrategy_Id"));
    public readonly ResultType_Id = new QGuidPath(this.withPrefix("ResultType_Id"));
    public readonly ResultHistoryList = new QEntityCollectionPath(this.withPrefix("ResultHistoryList"), () => QResultHistory);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ResultStrategy = new QEntityPath(this.withPrefix("ResultStrategy"), () => QResultStrategy);
    public readonly ResultType = new QEntityPath(this.withPrefix("ResultType"), () => QResultType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QResultFacet);
}

export const qResult = new QResult();

export class QResultId extends QId<ResultId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerCompatibleMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaxQuantity = new QNumberPath(this.withPrefix("MaxQuantity"));
    public readonly Container_Id = new QGuidPath(this.withPrefix("Container_Id"));
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Container = new QEntityPath(this.withPrefix("Container"), () => QMaterialTrackingUnitAggregate);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QContainerCompatibleMaterialFacet);
}

export const qContainerCompatibleMaterial = new QContainerCompatibleMaterial();

export class QContainerCompatibleMaterialId extends QId<ContainerCompatibleMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAttachment extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly FileAttachment_Id_Id = new QGuidPath(this.withPrefix("FileAttachment_Id_Id"));
    public readonly IconAttachment_Id_Id = new QGuidPath(this.withPrefix("IconAttachment_Id_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Failures = new QEntityCollectionPath(this.withPrefix("Failures"), () => QFailure);
    public readonly FileAttachment_Id = new QEntityPath(this.withPrefix("FileAttachment_Id"), () => QFile);
    public readonly IconAttachment_Id = new QEntityPath(this.withPrefix("IconAttachment_Id"), () => QFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAttachmentFacet);
}

export const qAttachment = new QAttachment();

export class QAttachmentId extends QId<AttachmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly Type = new QEnumPath(this.withPrefix("Type"), QualityActionType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Failures = new QEntityCollectionPath(this.withPrefix("Failures"), () => QFailure);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QQualityActionFacet);
}

export const qQualityAction = new QQualityAction();

export class QQualityActionId extends QId<QualityActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureReference extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CharacteristicSpecification_Id = new QGuidPath(this.withPrefix("CharacteristicSpecification_Id"));
    public readonly Failure_Id = new QGuidPath(this.withPrefix("Failure_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicSpecification = new QEntityPath(this.withPrefix("CharacteristicSpecification"), () => QCharacteristicSpecification);
    public readonly Failure = new QEntityPath(this.withPrefix("Failure"), () => QFailure);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFailureReferenceFacet);
}

export const qFailureReference = new QFailureReference();

export class QFailureReferenceId extends QId<FailureReferenceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureParent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FailureParentNId = new QStringPath(this.withPrefix("FailureParentNId"));
    public readonly FailureParentRevision = new QStringPath(this.withPrefix("FailureParentRevision"));
    public readonly FailureChild_Id = new QGuidPath(this.withPrefix("FailureChild_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FailureChild = new QEntityPath(this.withPrefix("FailureChild"), () => QFailure);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFailureParentFacet);
}

export const qFailureParent = new QFailureParent();

export class QFailureParentId extends QId<FailureParentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureChild extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FailureChildNId = new QStringPath(this.withPrefix("FailureChildNId"));
    public readonly FailureChildRevision = new QStringPath(this.withPrefix("FailureChildRevision"));
    public readonly FailureParent_Id = new QGuidPath(this.withPrefix("FailureParent_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FailureParent = new QEntityPath(this.withPrefix("FailureParent"), () => QFailure);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFailureChildFacet);
}

export const qFailureChild = new QFailureChild();

export class QFailureChildId extends QId<FailureChildId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailure extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Attachments = new QEntityCollectionPath(this.withPrefix("Attachments"), () => QAttachment);
    public readonly FailureParents = new QEntityCollectionPath(this.withPrefix("FailureParents"), () => QFailureParent);
    public readonly FailureChildren = new QEntityCollectionPath(this.withPrefix("FailureChildren"), () => QFailureChild);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly QualityActions = new QEntityCollectionPath(this.withPrefix("QualityActions"), () => QQualityAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFailureFacet);
}

export const qFailure = new QFailure();

export class QFailureId extends QId<FailureId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly OldSourceEquipmentNId = new QStringPath(this.withPrefix("OldSourceEquipmentNId"));
    public readonly OldStatusNId = new QStringPath(this.withPrefix("OldStatusNId"));
    public readonly OldTargetEquipmentNId = new QStringPath(this.withPrefix("OldTargetEquipmentNId"));
    public readonly SourceEquipmentNId = new QStringPath(this.withPrefix("SourceEquipmentNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly TargetEquipmentNId = new QStringPath(this.withPrefix("TargetEquipmentNId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly MaterialTrackinUnitAggregateId = new QGuidPath(this.withPrefix("MaterialTrackinUnitAggregateId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OldEquipmentNId = new QStringPath(this.withPrefix("OldEquipmentNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly ExecGroupPhaseNId = new QStringPath(this.withPrefix("ExecGroupPhaseNId"));
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly MaterialTrackingUnits = new QEntityPath(this.withPrefix("MaterialTrackingUnits"), () => QMTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QContainerHistoryFacet);
}

export const qContainerHistory = new QContainerHistory();

export class QContainerHistoryId extends QId<ContainerHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtObjectType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventContexts = new QEntityCollectionPath(this.withPrefix("ExtEventContexts"), () => QExtEventContext);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExtObjectTypeFacet);
}

export const qExtObjectType = new QExtObjectType();

export class QExtObjectTypeId extends QId<ExtObjectTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventContext extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContextNId = new QStringPath(this.withPrefix("ContextNId"));
    public readonly State = new QStringPath(this.withPrefix("State"));
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly ObjectId = new QGuidPath(this.withPrefix("ObjectId"));
    public readonly ExtEventLog_Id = new QGuidPath(this.withPrefix("ExtEventLog_Id"));
    public readonly ExtObjectType_Id = new QGuidPath(this.withPrefix("ExtObjectType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventLog = new QEntityPath(this.withPrefix("ExtEventLog"), () => QExtEventLog);
    public readonly ExtObjectType = new QEntityPath(this.withPrefix("ExtObjectType"), () => QExtObjectType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExtEventContextFacet);
}

export const qExtEventContext = new QExtEventContext();

export class QExtEventContextId extends QId<ExtEventContextId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventLogs = new QEntityCollectionPath(this.withPrefix("ExtEventLogs"), () => QExtEventLog);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExtEventTypeFacet);
}

export const qExtEventType = new QExtEventType();

export class QExtEventTypeId extends QId<ExtEventTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventLog extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SystemNId = new QStringPath(this.withPrefix("SystemNId"));
    public readonly EventTypeNId = new QStringPath(this.withPrefix("EventTypeNId"));
    public readonly ObjectId = new QGuidPath(this.withPrefix("ObjectId"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly ExtEventType_Id = new QGuidPath(this.withPrefix("ExtEventType_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly ExtEventLogFailureNotification = new QEntityCollectionPath(this.withPrefix("ExtEventLogFailureNotification"), () => QExtEventLogFailureNotification);
    public readonly ExtEventContexts = new QEntityCollectionPath(this.withPrefix("ExtEventContexts"), () => QExtEventContext);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventType = new QEntityPath(this.withPrefix("ExtEventType"), () => QExtEventType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExtEventLogFacet);
}

export const qExtEventLog = new QExtEventLog();

export class QExtEventLogId extends QId<ExtEventLogId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerTypeDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly ContainerType_Id = new QGuidPath(this.withPrefix("ContainerType_Id"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerType = new QEntityPath(this.withPrefix("ContainerType"), () => QContainerType);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QContainerTypeDocumentFacet);
}

export const qContainerTypeDocument = new QContainerTypeDocument();

export class QContainerTypeDocumentId extends QId<ContainerTypeDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerTypeCompatibleMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaxQuantity = new QNumberPath(this.withPrefix("MaxQuantity"));
    public readonly ContainerType_Id = new QGuidPath(this.withPrefix("ContainerType_Id"));
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerType = new QEntityPath(this.withPrefix("ContainerType"), () => QContainerType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QContainerTypeCompatibleMaterialFacet);
}

export const qContainerTypeCompatibleMaterial = new QContainerTypeCompatibleMaterial();

export class QContainerTypeCompatibleMaterialId extends QId<ContainerTypeCompatibleMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Documents = new QEntityCollectionPath(this.withPrefix("Documents"), () => QContainerTypeDocument);
    public readonly CompatibleMaterials = new QEntityCollectionPath(this.withPrefix("CompatibleMaterials"), () => QContainerTypeCompatibleMaterial);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QContainerTypeFacet);
}

export const qContainerType = new QContainerType();

export class QContainerTypeId extends QId<ContainerTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineActionAmend extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly CommandPayload = new QBinaryPath(this.withPrefix("CommandPayload"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly OfflineAction_Id = new QGuidPath(this.withPrefix("OfflineAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineAction = new QEntityPath(this.withPrefix("OfflineAction"), () => QOfflineAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOfflineActionAmendFacet);
}

export const qOfflineActionAmend = new QOfflineActionAmend();

export class QOfflineActionAmendId extends QId<OfflineActionAmendId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly CommandName = new QStringPath(this.withPrefix("CommandName"));
    public readonly CommandApp = new QStringPath(this.withPrefix("CommandApp"));
    public readonly CommandPayload = new QBinaryPath(this.withPrefix("CommandPayload"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly CheckInDate = new QDateTimeOffsetPath(this.withPrefix("CheckInDate"));
    public readonly CheckInResponse = new QStringPath(this.withPrefix("CheckInResponse"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly InternalId = new QGuidPath(this.withPrefix("InternalId"));
    public readonly OfflineSession_Id = new QGuidPath(this.withPrefix("OfflineSession_Id"));
    public readonly CheckInStatus = new QEntityPath(this.withPrefix("CheckInStatus"), () => QStatusType);
    public readonly OfflineActionAmendList = new QEntityCollectionPath(this.withPrefix("OfflineActionAmendList"), () => QOfflineActionAmend);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineSession = new QEntityPath(this.withPrefix("OfflineSession"), () => QOfflineSession);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOfflineActionFacet);
}

export const qOfflineAction = new QOfflineAction();

export class QOfflineActionId extends QId<OfflineActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineSessionWOOperationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly OfflineSession_Id = new QGuidPath(this.withPrefix("OfflineSession_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineSession = new QEntityPath(this.withPrefix("OfflineSession"), () => QOfflineSession);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOfflineSessionWOOperationAssociationFacet);
}

export const qOfflineSessionWOOperationAssociation = new QOfflineSessionWOOperationAssociation();

export class QOfflineSessionWOOperationAssociationId extends QId<OfflineSessionWOOperationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineSession extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly DownloadDate = new QDateTimeOffsetPath(this.withPrefix("DownloadDate"));
    public readonly UploadDate = new QDateTimeOffsetPath(this.withPrefix("UploadDate"));
    public readonly CheckInDate = new QDateTimeOffsetPath(this.withPrefix("CheckInDate"));
    public readonly DeviceId = new QStringPath(this.withPrefix("DeviceId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly OfflineAction = new QEntityCollectionPath(this.withPrefix("OfflineAction"), () => QOfflineAction);
    public readonly OfflineSessionWOOperationAssociationList = new QEntityCollectionPath(this.withPrefix("OfflineSessionWOOperationAssociationList"), () => QOfflineSessionWOOperationAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOfflineSessionFacet);
}

export const qOfflineSession = new QOfflineSession();

export class QOfflineSessionId extends QId<OfflineSessionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_MaterialTrackingUnitDocumentAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentCategory = new QStringPath(this.withPrefix("DocumentCategory"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDM_MaterialTrackingUnitDocumentAssociationFacet);
}

export const qDM_MaterialTrackingUnitDocumentAssociation = new QDM_MaterialTrackingUnitDocumentAssociation();

export class QDM_MaterialTrackingUnitDocumentAssociationId extends QId<DM_MaterialTrackingUnitDocumentAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderHumanResource extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly NumberOfUsers = new QNumberPath(this.withPrefix("NumberOfUsers"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderHumanResourceFacet);
}

export const qWorkOrderHumanResource = new QWorkOrderHumanResource();

export class QWorkOrderHumanResourceId extends QId<WorkOrderHumanResourceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualCoProducedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly DisassembleWorkOrderOperationNId = new QStringPath(this.withPrefix("DisassembleWorkOrderOperationNId"));
    public readonly DisassembleWorkOrderStepNId = new QStringPath(this.withPrefix("DisassembleWorkOrderStepNId"));
    public readonly DisassembleMTUCode = new QStringPath(this.withPrefix("DisassembleMTUCode"));
    public readonly DisassembleWorkOrderNId = new QStringPath(this.withPrefix("DisassembleWorkOrderNId"));
    public readonly DisassembleWorkOrderOperationName = new QStringPath(this.withPrefix("DisassembleWorkOrderOperationName"));
    public readonly DisassembleMTUName = new QStringPath(this.withPrefix("DisassembleMTUName"));
    public readonly DisassembleWorkOrderStepName = new QStringPath(this.withPrefix("DisassembleWorkOrderStepName"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly MaterialItemCoProducedQty = new QNumberPath(this.withPrefix("MaterialItemCoProducedQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly ToBeCoProducedMaterial_Id = new QGuidPath(this.withPrefix("ToBeCoProducedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ToBeCoProducedMaterial = new QEntityPath(this.withPrefix("ToBeCoProducedMaterial"), () => QToBeCoProducedMaterial);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualCoProducedMaterialFacet);
}

export const qActualCoProducedMaterial = new QActualCoProducedMaterial();

export class QActualCoProducedMaterialId extends QId<ActualCoProducedMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeCoProducedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly MaterialSpecificationTypeNId = new QStringPath(this.withPrefix("MaterialSpecificationTypeNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
    public readonly DM_Material_Id = new QGuidPath(this.withPrefix("DM_Material_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly ActualCoProducedMaterial = new QEntityCollectionPath(this.withPrefix("ActualCoProducedMaterial"), () => QActualCoProducedMaterial);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QDM_Material);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeCoProducedMaterialFacet);
}

export const qToBeCoProducedMaterial = new QToBeCoProducedMaterial();

export class QToBeCoProducedMaterialId extends QId<ToBeCoProducedMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly NumberOfUsers = new QNumberPath(this.withPrefix("NumberOfUsers"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly AsPlannedBoP_Id = new QGuidPath(this.withPrefix("AsPlannedBoP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
    public readonly AsPlannedBoP = new QEntityPath(this.withPrefix("AsPlannedBoP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCertificationSpecificationFacet);
}

export const qCertificationSpecification = new QCertificationSpecification();

export class QCertificationSpecificationId extends QId<CertificationSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserWorkOrderOperationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUserWorkOrderOperationAssociationFacet);
}

export const qUserWorkOrderOperationAssociation = new QUserWorkOrderOperationAssociation();

export class QUserWorkOrderOperationAssociationId extends QId<UserWorkOrderOperationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimePJFSerialNumberAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFileId_Id = new QGuidPath(this.withPrefix("PrintJobFileId_Id"));
    public readonly SerialNumber_Id = new QGuidPath(this.withPrefix("SerialNumber_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFileId = new QEntityPath(this.withPrefix("PrintJobFileId"), () => QPrintJobFile);
    public readonly SerialNumber = new QEntityPath(this.withPrefix("SerialNumber"), () => QMaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QRuntimePJFSerialNumberAssociationFacet);
}

export const qRuntimePJFSerialNumberAssociation = new QRuntimePJFSerialNumberAssociation();

export class QRuntimePJFSerialNumberAssociationId extends QId<RuntimePJFSerialNumberAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemToolDefinitionATNTypeParameterAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessOperationUId = new QStringPath(this.withPrefix("ProcessOperationUId"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly AutomationNodeTypeParameterNId = new QStringPath(this.withPrefix("AutomationNodeTypeParameterNId"));
    public readonly Editable = new QBooleanPath(this.withPrefix("Editable"));
    public readonly SetpointItem_Id = new QGuidPath(this.withPrefix("SetpointItem_Id"));
    public readonly ToolDefinitionParameter = new QEntityPath(this.withPrefix("ToolDefinitionParameter"), () => QToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetpointItem = new QEntityPath(this.withPrefix("SetpointItem"), () => QSetPointItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointItemToolDefinitionATNTypeParameterAssociationFacet);
}

export const qSetPointItemToolDefinitionATNTypeParameterAssociation = new QSetPointItemToolDefinitionATNTypeParameterAssociation();

export class QSetPointItemToolDefinitionATNTypeParameterAssociationId extends QId<SetPointItemToolDefinitionATNTypeParameterAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMachineToDNC extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMachineToDNCFacet);
}

export const qMachineToDNC = new QMachineToDNC();

export class QMachineToDNCId extends QId<MachineToDNCId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDNCItemMachineMaterialAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialId_Id = new QGuidPath(this.withPrefix("DM_MaterialId_Id"));
    public readonly MachineToDNC_Id = new QGuidPath(this.withPrefix("MachineToDNC_Id"));
    public readonly DNCItem_Id = new QGuidPath(this.withPrefix("DNCItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialId = new QEntityPath(this.withPrefix("DM_MaterialId"), () => QDM_Material);
    public readonly MachineToDNC = new QEntityPath(this.withPrefix("MachineToDNC"), () => QMachineToDNC);
    public readonly DNCItem = new QEntityPath(this.withPrefix("DNCItem"), () => QDNCItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDNCItemMachineMaterialAssociationFacet);
}

export const qDNCItemMachineMaterialAssociation = new QDNCItemMachineMaterialAssociation();

export class QDNCItemMachineMaterialAssociationId extends QId<DNCItemMachineMaterialAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDNCItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly DNCExternalId = new QStringPath(this.withPrefix("DNCExternalId"));
    public readonly Trialcut = new QBooleanPath(this.withPrefix("Trialcut"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly CanBePreviewed = new QBooleanPath(this.withPrefix("CanBePreviewed"));
    public readonly CanBeTransferred = new QBooleanPath(this.withPrefix("CanBeTransferred"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Released = new QBooleanPath(this.withPrefix("Released"));
    public readonly Parent_Id = new QGuidPath(this.withPrefix("Parent_Id"));
    public readonly DNCItemMachineMaterialAssociationList = new QEntityCollectionPath(this.withPrefix("DNCItemMachineMaterialAssociationList"), () => QDNCItemMachineMaterialAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Parent = new QEntityPath(this.withPrefix("Parent"), () => QDNCItem);
    public readonly Children = new QEntityCollectionPath(this.withPrefix("Children"), () => QDNCItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDNCItemFacet);
}

export const qDNCItem = new QDNCItem();

export class QDNCItemId extends QId<DNCItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeTypeParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly MinValue = new QStringPath(this.withPrefix("MinValue"));
    public readonly MaxValue = new QStringPath(this.withPrefix("MaxValue"));
    public readonly MaxLength = new QNumberPath(this.withPrefix("MaxLength"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), ParameterType);
    public readonly ParameterValues = new QStringPath(this.withPrefix("ParameterValues"));
    public readonly DataType = new QEnumPath(this.withPrefix("DataType"), DataType);
    public readonly IsStatic = new QBooleanPath(this.withPrefix("IsStatic"));
    public readonly IsPersistent = new QBooleanPath(this.withPrefix("IsPersistent"));
    public readonly IsInternal = new QBooleanPath(this.withPrefix("IsInternal"));
    public readonly AutomationNodeType_Id = new QGuidPath(this.withPrefix("AutomationNodeType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeType = new QEntityPath(this.withPrefix("AutomationNodeType"), () => QAutomationNodeType);
    public readonly AutomationNodeInstanceParameters = new QEntityCollectionPath(this.withPrefix("AutomationNodeInstanceParameters"), () => QAutomationNodeInstanceParameter);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAutomationNodeTypeParameterFacet);
}

export const qAutomationNodeTypeParameter = new QAutomationNodeTypeParameter();

export class QAutomationNodeTypeParameterId extends QId<AutomationNodeTypeParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types);
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QAutomationNodeTypeParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeInstances = new QEntityCollectionPath(this.withPrefix("AutomationNodeInstances"), () => QAutomationNodeInstance);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAutomationNodeTypeFacet);
}

export const qAutomationNodeType = new QAutomationNodeType();

export class QAutomationNodeTypeId extends QId<AutomationNodeTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeInstanceParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterValues = new QStringPath(this.withPrefix("ParameterValues"));
    public readonly AutomationNodeInstance_Id = new QGuidPath(this.withPrefix("AutomationNodeInstance_Id"));
    public readonly AutomationNodeTypeParameter_Id = new QGuidPath(this.withPrefix("AutomationNodeTypeParameter_Id"));
    public readonly TagAspect = new QEntityPath(this.withPrefix("TagAspect"), () => QTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeInstance = new QEntityPath(this.withPrefix("AutomationNodeInstance"), () => QAutomationNodeInstance);
    public readonly AutomationNodeTypeParameter = new QEntityPath(this.withPrefix("AutomationNodeTypeParameter"), () => QAutomationNodeTypeParameter);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAutomationNodeInstanceParameterFacet);
}

export const qAutomationNodeInstanceParameter = new QAutomationNodeInstanceParameter();

export class QAutomationNodeInstanceParameterId extends QId<AutomationNodeInstanceParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ChannelNId = new QStringPath(this.withPrefix("ChannelNId"));
    public readonly AutomationNodeType_Id = new QGuidPath(this.withPrefix("AutomationNodeType_Id"));
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types);
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QAutomationNodeInstanceParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeType = new QEntityPath(this.withPrefix("AutomationNodeType"), () => QAutomationNodeType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAutomationNodeInstanceFacet);
}

export const qAutomationNodeInstance = new QAutomationNodeInstance();

export class QAutomationNodeInstanceId extends QId<AutomationNodeInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointEquipmentTypeAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly SetPoint_Id = new QGuidPath(this.withPrefix("SetPoint_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPoint = new QEntityPath(this.withPrefix("SetPoint"), () => QSetPoint);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointEquipmentTypeAssociationFacet);
}

export const qSetPointEquipmentTypeAssociation = new QSetPointEquipmentTypeAssociation();

export class QSetPointEquipmentTypeAssociationId extends QId<SetPointEquipmentTypeAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointToolAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly SetPoint_Id = new QGuidPath(this.withPrefix("SetPoint_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPoint = new QEntityPath(this.withPrefix("SetPoint"), () => QSetPoint);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointToolAssociationFacet);
}

export const qSetPointToolAssociation = new QSetPointToolAssociation();

export class QSetPointToolAssociationId extends QId<SetPointToolAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointToolDefinitionAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly SetPoint_Id = new QGuidPath(this.withPrefix("SetPoint_Id"));
    public readonly ToolDefinitionParameter = new QEntityPath(this.withPrefix("ToolDefinitionParameter"), () => QToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPoint = new QEntityPath(this.withPrefix("SetPoint"), () => QSetPoint);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointToolDefinitionAssociationFacet);
}

export const qSetPointToolDefinitionAssociation = new QSetPointToolDefinitionAssociation();

export class QSetPointToolDefinitionAssociationId extends QId<SetPointToolDefinitionAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolAutomationNodeInstanceAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolAutomationNodeInstanceAssociationFacet);
}

export const qToolAutomationNodeInstanceAssociation = new QToolAutomationNodeInstanceAssociation();

export class QToolAutomationNodeInstanceAssociationId extends QId<ToolAutomationNodeInstanceAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionAutomationNodeTypeAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly ToolDefinitionParameter = new QEntityPath(this.withPrefix("ToolDefinitionParameter"), () => QToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolDefinitionAutomationNodeTypeAssociationFacet);
}

export const qToolDefinitionAutomationNodeTypeAssociation = new QToolDefinitionAutomationNodeTypeAssociation();

export class QToolDefinitionAutomationNodeTypeAssociationId extends QId<ToolDefinitionAutomationNodeTypeAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemDefaultValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SetPointItem_Id = new QGuidPath(this.withPrefix("SetPointItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItem = new QEntityPath(this.withPrefix("SetPointItem"), () => QSetPointItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointItemDefaultValueFacet);
}

export const qSetPointItemDefaultValue = new QSetPointItemDefaultValue();

export class QSetPointItemDefaultValueId extends QId<SetPointItemDefaultValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemATNInstanceAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly AutomationInstanceNId = new QStringPath(this.withPrefix("AutomationInstanceNId"));
    public readonly AutomationInstanceParameterNId = new QStringPath(this.withPrefix("AutomationInstanceParameterNId"));
    public readonly SetPointItemValue = new QStringPath(this.withPrefix("SetPointItemValue"));
    public readonly SetPointItemATNInstanceAssociationDefaultValue = new QStringPath(this.withPrefix("SetPointItemATNInstanceAssociationDefaultValue"));
    public readonly ProcessOperation = new QGuidPath(this.withPrefix("ProcessOperation"));
    public readonly SetPointItem_Id = new QGuidPath(this.withPrefix("SetPointItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItem = new QEntityPath(this.withPrefix("SetPointItem"), () => QSetPointItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointItemATNInstanceAssociationFacet);
}

export const qSetPointItemATNInstanceAssociation = new QSetPointItemATNInstanceAssociation();

export class QSetPointItemATNInstanceAssociationId extends QId<SetPointItemATNInstanceAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly DataType = new QStringPath(this.withPrefix("DataType"));
    public readonly Editable = new QBooleanPath(this.withPrefix("Editable"));
    public readonly SetPoint_Id = new QGuidPath(this.withPrefix("SetPoint_Id"));
    public readonly SetPointItemDefaultValues = new QEntityCollectionPath(this.withPrefix("SetPointItemDefaultValues"), () => QSetPointItemDefaultValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPoint = new QEntityPath(this.withPrefix("SetPoint"), () => QSetPoint);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointItemFacet);
}

export const qSetPointItem = new QSetPointItem();

export class QSetPointItemId extends QId<SetPointItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointEquipmentAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly SetPoint_Id = new QGuidPath(this.withPrefix("SetPoint_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPoint = new QEntityPath(this.withPrefix("SetPoint"), () => QSetPoint);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointEquipmentAssociationFacet);
}

export const qSetPointEquipmentAssociation = new QSetPointEquipmentAssociation();

export class QSetPointEquipmentAssociationId extends QId<SetPointEquipmentAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPoint extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly SetPointEquipmentTypeAssociations = new QEntityCollectionPath(this.withPrefix("SetPointEquipmentTypeAssociations"), () => QSetPointEquipmentTypeAssociation);
    public readonly SetPointToTool = new QEntityCollectionPath(this.withPrefix("SetPointToTool"), () => QSetPointToolAssociation);
    public readonly SetPointToolDefinitionAssociations = new QEntityCollectionPath(this.withPrefix("SetPointToolDefinitionAssociations"), () => QSetPointToolDefinitionAssociation);
    public readonly SetPointItems = new QEntityCollectionPath(this.withPrefix("SetPointItems"), () => QSetPointItem);
    public readonly SetPointEquipmentAssociations = new QEntityCollectionPath(this.withPrefix("SetPointEquipmentAssociations"), () => QSetPointEquipmentAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSetPointFacet);
}

export const qSetPoint = new QSetPoint();

export class QSetPointId extends QId<SetPointId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedMachinePJF extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly EG_PhaseId = new QGuidPath(this.withPrefix("EG_PhaseId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile_Id = new QGuidPath(this.withPrefix("PrintJobFile_Id"));
    public readonly ToBeUsedMachine_Id = new QGuidPath(this.withPrefix("ToBeUsedMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPrintJobFile);
    public readonly ToBeUsedMachine = new QEntityPath(this.withPrefix("ToBeUsedMachine"), () => QToBeUsedMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedMachinePJFFacet);
}

export const qToBeUsedMachinePJF = new QToBeUsedMachinePJF();

export class QToBeUsedMachinePJFId extends QId<ToBeUsedMachinePJFId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedMachinePJF extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly EG_PhaseId = new QGuidPath(this.withPrefix("EG_PhaseId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile_Id = new QGuidPath(this.withPrefix("PrintJobFile_Id"));
    public readonly ActualUsedMachines_Id = new QGuidPath(this.withPrefix("ActualUsedMachines_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPrintJobFile);
    public readonly ActualUsedMachines = new QEntityPath(this.withPrefix("ActualUsedMachines"), () => QActualUsedMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualUsedMachinePJFFacet);
}

export const qActualUsedMachinePJF = new QActualUsedMachinePJF();

export class QActualUsedMachinePJFId extends QId<ActualUsedMachinePJFId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDSParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly DataType = new QStringPath(this.withPrefix("DataType"));
    public readonly ContextEntity = new QStringPath(this.withPrefix("ContextEntity"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDSParameterFacet);
}

export const qDSParameter = new QDSParameter();

export class QDSParameterId extends QId<DSParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDiscreteAutomationNodeDataTypeMapping extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AutomationType = new QStringPath(this.withPrefix("AutomationType"));
    public readonly DataType = new QStringPath(this.withPrefix("DataType"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDiscreteAutomationNodeDataTypeMappingFacet);
}

export const qDiscreteAutomationNodeDataTypeMapping = new QDiscreteAutomationNodeDataTypeMapping();

export class QDiscreteAutomationNodeDataTypeMappingId extends QId<DiscreteAutomationNodeDataTypeMappingId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessToOpLinkDependencyNavigation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
    public readonly RelativePath = new QStringPath(this.withPrefix("RelativePath"));
    public readonly FullPath = new QStringPath(this.withPrefix("FullPath"));
    public readonly ParentNavigation = new QGuidPath(this.withPrefix("ParentNavigation"));
    public readonly IsPreferred = new QBooleanPath(this.withPrefix("IsPreferred"));
    public readonly OperationDependency_Id = new QGuidPath(this.withPrefix("OperationDependency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationDependency = new QEntityPath(this.withPrefix("OperationDependency"), () => QOperationDependency);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessToOpLinkDependencyNavigationFacet);
}

export const qProcessToOpLinkDependencyNavigation = new QProcessToOpLinkDependencyNavigation();

export class QProcessToOpLinkDependencyNavigationId extends QId<ProcessToOpLinkDependencyNavigationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileEquipmentTypeAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly PrintJobFile_Id = new QGuidPath(this.withPrefix("PrintJobFile_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPrintJobFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QPrintJobFileEquipmentTypeAssociationFacet);
}

export const qPrintJobFileEquipmentTypeAssociation = new QPrintJobFileEquipmentTypeAssociation();

export class QPrintJobFileEquipmentTypeAssociationId extends QId<PrintJobFileEquipmentTypeAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileEquipmentAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly PrintJobFile_Id = new QGuidPath(this.withPrefix("PrintJobFile_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPrintJobFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QPrintJobFileEquipmentAssociationFacet);
}

export const qPrintJobFileEquipmentAssociation = new QPrintJobFileEquipmentAssociation();

export class QPrintJobFileEquipmentAssociationId extends QId<PrintJobFileEquipmentAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileDM_MaterialAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly PrintJobFile_Id = new QGuidPath(this.withPrefix("PrintJobFile_Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPrintJobFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QPrintJobFileDM_MaterialAssociationFacet);
}

export const qPrintJobFileDM_MaterialAssociation = new QPrintJobFileDM_MaterialAssociation();

export class QPrintJobFileDM_MaterialAssociationId extends QId<PrintJobFileDM_MaterialAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMPowderBatchGenealogy extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly MixedQuantity = new QStringPath(this.withPrefix("MixedQuantity"));
    public readonly RecycleCount = new QStringPath(this.withPrefix("RecycleCount"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly TargetDM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("TargetDM_MaterialTrackingUnit_Id"));
    public readonly SourceDM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("SourceDM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QDM_MaterialTrackingUnitHistoryAction);
    public readonly TargetDM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("TargetDM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly SourceDM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("SourceDM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAMPowderBatchGenealogyFacet);
}

export const qAMPowderBatchGenealogy = new QAMPowderBatchGenealogy();

export class QAMPowderBatchGenealogyId extends QId<AMPowderBatchGenealogyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QVisualDetectedFailure extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Count = new QNumberPath(this.withPrefix("Count"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly Coords = new QStringPath(this.withPrefix("Coords"));
    public readonly IsNoFailure = new QBooleanPath(this.withPrefix("IsNoFailure"));
    public readonly CharacteristicType = new QEnumPath(this.withPrefix("CharacteristicType"), CharacteristicType);
    public readonly InspectionSample_Id = new QGuidPath(this.withPrefix("InspectionSample_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionSample = new QEntityPath(this.withPrefix("InspectionSample"), () => QInspectionSample);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QVisualDetectedFailureFacet);
}

export const qVisualDetectedFailure = new QVisualDetectedFailure();

export class QVisualDetectedFailureId extends QId<VisualDetectedFailureId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MeasuredAttributeValue = new QBooleanPath(this.withPrefix("MeasuredAttributeValue"));
    public readonly MeasuredVariableValue = new QNumberPath(this.withPrefix("MeasuredVariableValue"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly FailureRevision = new QStringPath(this.withPrefix("FailureRevision"));
    public readonly CharacteristicType = new QEnumPath(this.withPrefix("CharacteristicType"), CharacteristicType);
    public readonly InspectionSample_Id = new QGuidPath(this.withPrefix("InspectionSample_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionSample = new QEntityPath(this.withPrefix("InspectionSample"), () => QInspectionSample);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QInspectionValueFacet);
}

export const qInspectionValue = new QInspectionValue();

export class QInspectionValueId extends QId<InspectionValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionSample extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AnyViolation = new QBooleanPath(this.withPrefix("AnyViolation"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ScenarioInstanceId = new QGuidPath(this.withPrefix("ScenarioInstanceId"));
    public readonly IsSignaturePending = new QBooleanPath(this.withPrefix("IsSignaturePending"));
    public readonly SketchRows = new QNumberPath(this.withPrefix("SketchRows"));
    public readonly SketchColumns = new QNumberPath(this.withPrefix("SketchColumns"));
    public readonly SketchMimeType = new QStringPath(this.withPrefix("SketchMimeType"));
    public readonly IsConfirmed = new QBooleanPath(this.withPrefix("IsConfirmed"));
    public readonly Sketch_Id_Id = new QGuidPath(this.withPrefix("Sketch_Id_Id"));
    public readonly MasterSketch_Id_Id = new QGuidPath(this.withPrefix("MasterSketch_Id_Id"));
    public readonly InspectionAcquisitionContext_Id = new QGuidPath(this.withPrefix("InspectionAcquisitionContext_Id"));
    public readonly VisualDetectedFailures = new QEntityCollectionPath(this.withPrefix("VisualDetectedFailures"), () => QVisualDetectedFailure);
    public readonly InspectionValues = new QEntityCollectionPath(this.withPrefix("InspectionValues"), () => QInspectionValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionAcquisitionContext = new QEntityPath(this.withPrefix("InspectionAcquisitionContext"), () => QInspectionAcquisitionContext);
    public readonly Sketch_Id = new QEntityPath(this.withPrefix("Sketch_Id"), () => QFile);
    public readonly MasterSketch_Id = new QEntityPath(this.withPrefix("MasterSketch_Id"), () => QFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QInspectionSampleFacet);
}

export const qInspectionSample = new QInspectionSample();

export class QInspectionSampleId extends QId<InspectionSampleId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionAcquisitionContext extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly CharacteristicRepresentationNId = new QStringPath(this.withPrefix("CharacteristicRepresentationNId"));
    public readonly RuntimeCharacteristicRepresentationNId = new QStringPath(this.withPrefix("RuntimeCharacteristicRepresentationNId"));
    public readonly InspectionSamples = new QEntityCollectionPath(this.withPrefix("InspectionSamples"), () => QInspectionSample);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QInspectionAcquisitionContextFacet);
}

export const qInspectionAcquisitionContext = new QInspectionAcquisitionContext();

export class QInspectionAcquisitionContextId extends QId<InspectionAcquisitionContextId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderStepSkill extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly SkillId_Id = new QGuidPath(this.withPrefix("SkillId_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SkillId = new QEntityPath(this.withPrefix("SkillId"), () => QSkill_BOP);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderStepSkillFacet);
}

export const qWorkOrderStepSkill = new QWorkOrderStepSkill();

export class QWorkOrderStepSkillId extends QId<WorkOrderStepSkillId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWOOpDependencyNavigationMTUAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialTrackingUnit = new QGuidPath(this.withPrefix("MaterialTrackingUnit"));
    public readonly MTUStatus = new QEnumPath(this.withPrefix("MTUStatus"), AlternativeOperationMTUStatus);
    public readonly WOOpDependencyNavigation_Id = new QGuidPath(this.withPrefix("WOOpDependencyNavigation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WOOpDependencyNavigation = new QEntityPath(this.withPrefix("WOOpDependencyNavigation"), () => QWOOpDependencyNavigation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWOOpDependencyNavigationMTUAssociationFacet);
}

export const qWOOpDependencyNavigationMTUAssociation = new QWOOpDependencyNavigationMTUAssociation();

export class QWOOpDependencyNavigationMTUAssociationId extends QId<WOOpDependencyNavigationMTUAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWOOpDependencyNavigation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
    public readonly RelativePath = new QStringPath(this.withPrefix("RelativePath"));
    public readonly FullPath = new QStringPath(this.withPrefix("FullPath"));
    public readonly ParentNavigation = new QGuidPath(this.withPrefix("ParentNavigation"));
    public readonly IsPreferred = new QBooleanPath(this.withPrefix("IsPreferred"));
    public readonly WorkOOperationDependency_Id = new QGuidPath(this.withPrefix("WorkOOperationDependency_Id"));
    public readonly WOOpDependencyNavigationMTUAssociation = new QEntityCollectionPath(this.withPrefix("WOOpDependencyNavigationMTUAssociation"), () => QWOOpDependencyNavigationMTUAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOOperationDependency = new QEntityPath(this.withPrefix("WorkOOperationDependency"), () => QWorkOOperationDependency);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWOOpDependencyNavigationFacet);
}

export const qWOOpDependencyNavigation = new QWOOpDependencyNavigation();

export class QWOOpDependencyNavigationId extends QId<WOOpDependencyNavigationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStepSkill extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly Skill_Id = new QGuidPath(this.withPrefix("Skill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
    public readonly Skill = new QEntityPath(this.withPrefix("Skill"), () => QSkill_BOP);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStepSkillFacet);
}

export const qStepSkill = new QStepSkill();

export class QStepSkillId extends QId<StepSkillId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationToStepLinkAssociationParameterValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ItlkCheckParameter_Id = new QGuidPath(this.withPrefix("ItlkCheckParameter_Id"));
    public readonly ItlkCheckOperationToStepLinkAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckParameter = new QEntityPath(this.withPrefix("ItlkCheckParameter"), () => QItlkCheckParameter);
    public readonly ItlkCheckOperationToStepLinkAssociation = new QEntityPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociation"), () => QItlkCheckOperationToStepLinkAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckOperationToStepLinkAssociationParameterValueFacet);
}

export const qItlkCheckOperationToStepLinkAssociationParameterValue = new QItlkCheckOperationToStepLinkAssociationParameterValue();

export class QItlkCheckOperationToStepLinkAssociationParameterValueId extends QId<ItlkCheckOperationToStepLinkAssociationParameterValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationToStepLinkAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly OperationToStepLink_Id = new QGuidPath(this.withPrefix("OperationToStepLink_Id"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly ItlkCheckOperationToStepLinkAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationParameterValues"), () => QItlkCheckOperationToStepLinkAssociationParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationToStepLink = new QEntityPath(this.withPrefix("OperationToStepLink"), () => QOperationToStepLink);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckOperationToStepLinkAssociationFacet);
}

export const qItlkCheckOperationToStepLinkAssociation = new QItlkCheckOperationToStepLinkAssociation();

export class QItlkCheckOperationToStepLinkAssociationId extends QId<ItlkCheckOperationToStepLinkAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinitionToStepAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionAssociationType_Id = new QGuidPath(this.withPrefix("WorkInstructionAssociationType_Id"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionAssociationType = new QEntityPath(this.withPrefix("WorkInstructionAssociationType"), () => QWorkInstructionAssociationType);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionDefinitionToStepAssociationFacet);
}

export const qWorkInstructionDefinitionToStepAssociation = new QWorkInstructionDefinitionToStepAssociation();

export class QWorkInstructionDefinitionToStepAssociationId extends QId<WorkInstructionDefinitionToStepAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIDefinitionToWOStepAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly WorkInstructionAssociationType_Id = new QGuidPath(this.withPrefix("WorkInstructionAssociationType_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
    public readonly WorkInstructionAssociationType = new QEntityPath(this.withPrefix("WorkInstructionAssociationType"), () => QWorkInstructionAssociationType);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWIDefinitionToWOStepAssociationFacet);
}

export const qWIDefinitionToWOStepAssociation = new QWIDefinitionToWOStepAssociation();

export class QWIDefinitionToWOStepAssociationId extends QId<WIDefinitionToWOStepAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionToWorkOrderStepAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly WorkInstruction_Id = new QGuidPath(this.withPrefix("WorkInstruction_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly WorkInstruction = new QEntityPath(this.withPrefix("WorkInstruction"), () => QWorkInstruction);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionToWorkOrderStepAssociationFacet);
}

export const qWorkInstructionToWorkOrderStepAssociation = new QWorkInstructionToWorkOrderStepAssociation();

export class QWorkInstructionToWorkOrderStepAssociationId extends QId<WorkInstructionToWorkOrderStepAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeCharacteristicRepresentationContainer extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimeChrRepresentations = new QEntityCollectionPath(this.withPrefix("RuntimeChrRepresentations"), () => QRuntimeCharacteristicRepresentation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QRuntimeCharacteristicRepresentationContainerFacet);
}

export const qRuntimeCharacteristicRepresentationContainer = new QRuntimeCharacteristicRepresentationContainer();

export class QRuntimeCharacteristicRepresentationContainerId extends QId<RuntimeCharacteristicRepresentationContainerId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeCharacteristicRepresentation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ChrReprNId = new QStringPath(this.withPrefix("ChrReprNId"));
    public readonly ChrSpecNId = new QStringPath(this.withPrefix("ChrSpecNId"));
    public readonly ChrSpecRevision = new QStringPath(this.withPrefix("ChrSpecRevision"));
    public readonly CanBeSkipped = new QBooleanPath(this.withPrefix("CanBeSkipped"));
    public readonly ChrSpecUId = new QStringPath(this.withPrefix("ChrSpecUId"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly ChrReprRevision = new QStringPath(this.withPrefix("ChrReprRevision"));
    public readonly ChrReprFrequencyNId = new QStringPath(this.withPrefix("ChrReprFrequencyNId"));
    public readonly ReferencedOperation = new QStringPath(this.withPrefix("ReferencedOperation"));
    public readonly AcquisitionBehaviour = new QEnumPath(this.withPrefix("AcquisitionBehaviour"), AcquisitionBehaviour);
    public readonly ChrReprSampleSize = new QNumberPath(this.withPrefix("ChrReprSampleSize"));
    public readonly MandatoryExecutionsCompleted = new QBooleanPath(this.withPrefix("MandatoryExecutionsCompleted"));
    public readonly RuntimeChrReprContainer_Id = new QGuidPath(this.withPrefix("RuntimeChrReprContainer_Id"));
    public readonly ScenarioConfiguration = new QEntityPath(this.withPrefix("ScenarioConfiguration"), () => QScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimeChrReprContainer = new QEntityPath(this.withPrefix("RuntimeChrReprContainer"), () => QRuntimeCharacteristicRepresentationContainer);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QRuntimeCharacteristicRepresentationFacet);
}

export const qRuntimeCharacteristicRepresentation = new QRuntimeCharacteristicRepresentation();

export class QRuntimeCharacteristicRepresentationId extends QId<RuntimeCharacteristicRepresentationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedInspection extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimeCharacteristicRepresentationContainerNId = new QStringPath(this.withPrefix("RuntimeCharacteristicRepresentationContainerNId"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly RuntimeCharReprRefOperationAssociations = new QEntityCollectionPath(this.withPrefix("RuntimeCharReprRefOperationAssociations"), () => QRuntimeCharReprRefOperationAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ActualUsedInspection = new QEntityCollectionPath(this.withPrefix("ActualUsedInspection"), () => QActualUsedInspection);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedInspectionFacet);
}

export const qToBeUsedInspection = new QToBeUsedInspection();

export class QToBeUsedInspectionId extends QId<ToBeUsedInspectionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedInspection extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedInspection_Id = new QGuidPath(this.withPrefix("ToBeUsedInspection_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedInspection = new QEntityPath(this.withPrefix("ToBeUsedInspection"), () => QToBeUsedInspection);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualUsedInspectionFacet);
}

export const qActualUsedInspection = new QActualUsedInspection();

export class QActualUsedInspectionId extends QId<ActualUsedInspectionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOStepAssociationParameterValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ItlkCheckParameter_Id = new QGuidPath(this.withPrefix("ItlkCheckParameter_Id"));
    public readonly ItlkCheckWOStepAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckParameter = new QEntityPath(this.withPrefix("ItlkCheckParameter"), () => QItlkCheckParameter);
    public readonly ItlkCheckWOStepAssociation = new QEntityPath(this.withPrefix("ItlkCheckWOStepAssociation"), () => QItlkCheckWOStepAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckWOStepAssociationParameterValueFacet);
}

export const qItlkCheckWOStepAssociationParameterValue = new QItlkCheckWOStepAssociationParameterValue();

export class QItlkCheckWOStepAssociationParameterValueId extends QId<ItlkCheckWOStepAssociationParameterValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOStepAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly ItlkCheckWOStepAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociationParameterValues"), () => QItlkCheckWOStepAssociationParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ItlkCheckHistoryList = new QEntityCollectionPath(this.withPrefix("ItlkCheckHistoryList"), () => QItlkCheckHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckWOStepAssociationFacet);
}

export const qItlkCheckWOStepAssociation = new QItlkCheckWOStepAssociation();

export class QItlkCheckWOStepAssociationId extends QId<ItlkCheckWOStepAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCriticality extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCriticalityFacet);
}

export const qCriticality = new QCriticality();

export class QCriticalityId extends QId<CriticalityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSAlert extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TraceDate = new QDateTimeOffsetPath(this.withPrefix("TraceDate"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly OrderNId = new QStringPath(this.withPrefix("OrderNId"));
    public readonly ChangeInformation = new QStringPath(this.withPrefix("ChangeInformation"));
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPSAlertFacet);
}

export const qAPSAlert = new QAPSAlert();

export class QAPSAlertId extends QId<APSAlertId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCharacteristicSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly CriticalityNId = new QStringPath(this.withPrefix("CriticalityNId"));
    public readonly Type = new QEnumPath(this.withPrefix("Type"), CharacteristicType);
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly FailureReferences = new QEntityCollectionPath(this.withPrefix("FailureReferences"), () => QFailureReference);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicRepresentations = new QEntityCollectionPath(this.withPrefix("CharacteristicRepresentations"), () => QCharacteristicRepresentation);
    public readonly CharacterisicFailureAssociations = new QEntityCollectionPath(this.withPrefix("CharacterisicFailureAssociations"), () => QCharacteristicFailureAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCharacteristicSpecificationFacet);
}

export const qCharacteristicSpecification = new QCharacteristicSpecification();

export class QCharacteristicSpecificationId extends QId<CharacteristicSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QVisualCharacteristicSpecification extends QCharacteristicSpecification {
    public readonly SketchRows = new QNumberPath(this.withPrefix("SketchRows"));
    public readonly SketchColumns = new QNumberPath(this.withPrefix("SketchColumns"));
    public readonly SketchMimeType = new QStringPath(this.withPrefix("SketchMimeType"));
    public readonly Sketch_Id_Id = new QGuidPath(this.withPrefix("Sketch_Id_Id"));
    public readonly Sketch_Id = new QEntityPath(this.withPrefix("Sketch_Id"), () => QFile);
}

export const qVisualCharacteristicSpecification = new QVisualCharacteristicSpecification();

export class QVariableCharacteristicSpecification extends QCharacteristicSpecification {
    public readonly LowerTolerance = new QEntityPath(this.withPrefix("LowerTolerance"), () => QQuantityType);
    public readonly UpperTolerance = new QEntityPath(this.withPrefix("UpperTolerance"), () => QQuantityType);
    public readonly NominalValue = new QEntityPath(this.withPrefix("NominalValue"), () => QQuantityType);
}

export const qVariableCharacteristicSpecification = new QVariableCharacteristicSpecification();

export class QAttributiveCharacteristicSpecification extends QCharacteristicSpecification {
    public readonly NOKDescription = new QStringPath(this.withPrefix("NOKDescription"));
    public readonly OKDescription = new QStringPath(this.withPrefix("OKDescription"));
}

export const qAttributiveCharacteristicSpecification = new QAttributiveCharacteristicSpecification();

export class QCharacteristicRepresentation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CanBeSkipped = new QBooleanPath(this.withPrefix("CanBeSkipped"));
    public readonly CharacteristicRepresentationFrequencyValue = new QNumberPath(this.withPrefix("CharacteristicRepresentationFrequencyValue"));
    public readonly TimeBasedScheduleMode = new QStringPath(this.withPrefix("TimeBasedScheduleMode"));
    public readonly TimeBasedMandatoryInspectionWarningValue = new QNumberPath(this.withPrefix("TimeBasedMandatoryInspectionWarningValue"));
    public readonly TimeBasedMandatoryInspectionWarningUoM = new QEnumPath(this.withPrefix("TimeBasedMandatoryInspectionWarningUoM"), TimeBasedUoM);
    public readonly SampleSize = new QNumberPath(this.withPrefix("SampleSize"));
    public readonly CharacteristicSpecification_Id = new QGuidPath(this.withPrefix("CharacteristicSpecification_Id"));
    public readonly CharacteristicRepresentationFrequency_Id = new QGuidPath(this.withPrefix("CharacteristicRepresentationFrequency_Id"));
    public readonly InspectionOperations = new QEntityCollectionPath(this.withPrefix("InspectionOperations"), () => QInspectionOperation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicSpecification = new QEntityPath(this.withPrefix("CharacteristicSpecification"), () => QCharacteristicSpecification);
    public readonly CharacteristicRepresentationFrequency = new QEntityPath(this.withPrefix("CharacteristicRepresentationFrequency"), () => QCharacteristicRepresentationFrequency);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCharacteristicRepresentationFacet);
}

export const qCharacteristicRepresentation = new QCharacteristicRepresentation();

export class QCharacteristicRepresentationId extends QId<CharacteristicRepresentationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCharacteristicFailureAssociation2 extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CharacteristicSpecification_Id = new QGuidPath(this.withPrefix("CharacteristicSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicSpecification = new QEntityPath(this.withPrefix("CharacteristicSpecification"), () => QCharacteristicSpecification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCharacteristicFailureAssociationFacet);
}

export const qCharacteristicFailureAssociation2 = new QCharacteristicFailureAssociation2();

export class QCharacteristicFailureAssociation2Id extends QId<CharacteristicFailureAssociation2Id> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBoMItemGroupType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBoMItemGroupTypeFacet);
}

export const qBoMItemGroupType = new QBoMItemGroupType();

export class QBoMItemGroupTypeId extends QId<BoMItemGroupTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBoMItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsAlternativeSelected = new QBooleanPath(this.withPrefix("IsAlternativeSelected"));
    public readonly GroupName = new QStringPath(this.withPrefix("GroupName"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly BoM_Id = new QGuidPath(this.withPrefix("BoM_Id"));
    public readonly BoMItemBoM_Id = new QGuidPath(this.withPrefix("BoMItemBoM_Id"));
    public readonly GroupType_Id = new QGuidPath(this.withPrefix("GroupType_Id"));
    public readonly MaterialDefinition_Id = new QGuidPath(this.withPrefix("MaterialDefinition_Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly MaterialProperties = new QEntityPath(this.withPrefix("MaterialProperties"), () => QMaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoM);
    public readonly BoMItemBoM = new QEntityPath(this.withPrefix("BoMItemBoM"), () => QBoM);
    public readonly GroupType = new QEntityPath(this.withPrefix("GroupType"), () => QBoMItemGroupType);
    public readonly MaterialDefinition = new QEntityPath(this.withPrefix("MaterialDefinition"), () => QDM_Material);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBoMItemFacet);
}

export const qBoMItem = new QBoMItem();

export class QBoMItemId extends QId<BoMItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationStepCategoryAssociationParameterValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ItlkCheckParameter_Id = new QGuidPath(this.withPrefix("ItlkCheckParameter_Id"));
    public readonly ItlkCheckOperationStepCategoryAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckParameter = new QEntityPath(this.withPrefix("ItlkCheckParameter"), () => QItlkCheckParameter);
    public readonly ItlkCheckOperationStepCategoryAssociation = new QEntityPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation"), () => QItlkCheckOperationStepCategoryAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckOperationStepCategoryAssociationParameterValueFacet);
}

export const qItlkCheckOperationStepCategoryAssociationParameterValue = new QItlkCheckOperationStepCategoryAssociationParameterValue();

export class QItlkCheckOperationStepCategoryAssociationParameterValueId extends QId<ItlkCheckOperationStepCategoryAssociationParameterValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationStepCategoryAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly StepRelevant = new QBooleanPath(this.withPrefix("StepRelevant"));
    public readonly OperationRelevant = new QBooleanPath(this.withPrefix("OperationRelevant"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly OperationStepCategory_Id = new QGuidPath(this.withPrefix("OperationStepCategory_Id"));
    public readonly ItlkCheckOperationStepCategoryAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationParameterValues"), () => QItlkCheckOperationStepCategoryAssociationParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
    public readonly OperationStepCategory = new QEntityPath(this.withPrefix("OperationStepCategory"), () => QOperationStepCategory);
    public readonly ItlkCheckOperationStepCategoryAssociations = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociations"), () => QItlkCheckHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckOperationStepCategoryAssociationFacet);
}

export const qItlkCheckOperationStepCategoryAssociation = new QItlkCheckOperationStepCategoryAssociation();

export class QItlkCheckOperationStepCategoryAssociationId extends QId<ItlkCheckOperationStepCategoryAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CharacteristicRepresentationNId = new QStringPath(this.withPrefix("CharacteristicRepresentationNId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly CharacteristicRepresentationRevision = new QStringPath(this.withPrefix("CharacteristicRepresentationRevision"));
    public readonly ReferencedOperation = new QStringPath(this.withPrefix("ReferencedOperation"));
    public readonly IsWOSpecific = new QBooleanPath(this.withPrefix("IsWOSpecific"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly AsPlannedBop_Id = new QGuidPath(this.withPrefix("AsPlannedBop_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
    public readonly AsPlannedBop = new QEntityPath(this.withPrefix("AsPlannedBop"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QInspectionSpecificationFacet);
}

export const qInspectionSpecification = new QInspectionSpecification();

export class QInspectionSpecificationId extends QId<InspectionSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentStateMachineFacet);
}

export const qEquipmentStateMachine = new QEquipmentStateMachine();

export class QEquipmentStateMachineId extends QId<EquipmentStateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly EquipmentProperty_Id = new QGuidPath(this.withPrefix("EquipmentProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentProperty = new QEntityPath(this.withPrefix("EquipmentProperty"), () => QEquipmentProperty);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentPropertyAttributeFacet);
}

export const qEquipmentPropertyAttribute = new QEquipmentPropertyAttribute();

export class QEquipmentPropertyAttributeId extends QId<EquipmentPropertyAttributeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly EquipmentPropertyAttributes = new QEntityCollectionPath(this.withPrefix("EquipmentPropertyAttributes"), () => QEquipmentPropertyAttribute);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentPropertyFacet);
}

export const qEquipmentProperty = new QEquipmentProperty();

export class QEquipmentPropertyId extends QId<EquipmentPropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroup extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentGroupConfigurationId = new QGuidPath(this.withPrefix("EquipmentGroupConfigurationId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityCollectionPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGroupFacet);
}

export const qEquipmentGroup = new QEquipmentGroup();

export class QEquipmentGroupId extends QId<EquipmentGroupId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNode extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphConfigurationNId = new QStringPath(this.withPrefix("EquipmentGraphConfigurationNId"));
    public readonly EquipmentGraphType = new QStringPath(this.withPrefix("EquipmentGraphType"));
    public readonly EquipmentGroupNId = new QStringPath(this.withPrefix("EquipmentGroupNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphNodeConfigurationId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphNodeFacet);
}

export const qEquipmentGraphNode = new QEquipmentGraphNode();

export class QEquipmentGraphNodeId extends QId<EquipmentGraphNodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
    public readonly EquipmentGraphLinkConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphLinkConfigurationId"));
    public readonly Source_Id = new QGuidPath(this.withPrefix("Source_Id"));
    public readonly Destination_Id = new QGuidPath(this.withPrefix("Destination_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Source = new QEntityPath(this.withPrefix("Source"), () => QEquipmentGraphNode);
    public readonly Destination = new QEntityPath(this.withPrefix("Destination"), () => QEquipmentGraphNode);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphLinkFacet);
}

export const qEquipmentGraphLink = new QEquipmentGraphLink();

export class QEquipmentGraphLinkId extends QId<EquipmentGraphLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipment extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly WorkCalendarNId = new QStringPath(this.withPrefix("WorkCalendarNId"));
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly StateMachines = new QEntityCollectionPath(this.withPrefix("StateMachines"), () => QEquipmentStateMachine);
    public readonly EquipmentProperties = new QEntityCollectionPath(this.withPrefix("EquipmentProperties"), () => QEquipmentProperty);
    public readonly EquipmentGroups = new QEntityCollectionPath(this.withPrefix("EquipmentGroups"), () => QEquipmentGroup);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentFacet);
}

export const qEquipment = new QEquipment();

export class QEquipmentId extends QId<EquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypeStateMachineFacet);
}

export const qEquipmentTypeStateMachine = new QEquipmentTypeStateMachine();

export class QEquipmentTypeStateMachineId extends QId<EquipmentTypeStateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypePropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly EquipmentTypeProperty_Id = new QGuidPath(this.withPrefix("EquipmentTypeProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypeProperty = new QEntityPath(this.withPrefix("EquipmentTypeProperty"), () => QEquipmentTypeProperty);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypePropertyAttributeFacet);
}

export const qEquipmentTypePropertyAttribute = new QEquipmentTypePropertyAttribute();

export class QEquipmentTypePropertyAttributeId extends QId<EquipmentTypePropertyAttributeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly EquipmentTypePropertyAttributes = new QEntityCollectionPath(this.withPrefix("EquipmentTypePropertyAttributes"), () => QEquipmentTypePropertyAttribute);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypePropertyFacet);
}

export const qEquipmentTypeProperty = new QEquipmentTypeProperty();

export class QEquipmentTypePropertyId extends QId<EquipmentTypePropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly StateMachines = new QEntityCollectionPath(this.withPrefix("StateMachines"), () => QEquipmentTypeStateMachine);
    public readonly EquipmentTypeProperties = new QEntityCollectionPath(this.withPrefix("EquipmentTypeProperties"), () => QEquipmentTypeProperty);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypeFacet);
}

export const qEquipmentType = new QEquipmentType();

export class QEquipmentTypeId extends QId<EquipmentTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentLevelFacet);
}

export const qEquipmentLevel = new QEquipmentLevel();

export class QEquipmentLevelId extends QId<EquipmentLevelId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurations = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurations"), () => QEquipmentConfiguration);
    public readonly EquipmentGroupConfigurationParents = new QEntityCollectionPath(this.withPrefix("EquipmentGroupConfigurationParents"), () => QEquipmentGroupConfiguration);
    public readonly EquipmentGroupConfigurationChildren = new QEntityCollectionPath(this.withPrefix("EquipmentGroupConfigurationChildren"), () => QEquipmentGroupConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGroupConfigurationFacet);
}

export const qEquipmentGroupConfiguration = new QEquipmentGroupConfiguration();

export class QEquipmentGroupConfigurationId extends QId<EquipmentGroupConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphTypeFacet);
}

export const qEquipmentGraphType = new QEquipmentGraphType();

export class QEquipmentGraphTypeId extends QId<EquipmentGraphTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly EquipmentGroupConfigurationNId = new QStringPath(this.withPrefix("EquipmentGroupConfigurationNId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
    public readonly EquipmentGraphConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphConfiguration"), () => QEquipmentGraphConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphNodeConfigurationFacet);
}

export const qEquipmentGraphNodeConfiguration = new QEquipmentGraphNodeConfiguration();

export class QEquipmentGraphNodeConfigurationId extends QId<EquipmentGraphNodeConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
    public readonly Source_Id = new QGuidPath(this.withPrefix("Source_Id"));
    public readonly Destination_Id = new QGuidPath(this.withPrefix("Destination_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Source = new QEntityPath(this.withPrefix("Source"), () => QEquipmentGraphNodeConfiguration);
    public readonly Destination = new QEntityPath(this.withPrefix("Destination"), () => QEquipmentGraphNodeConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphLinkConfigurationFacet);
}

export const qEquipmentGraphLinkConfiguration = new QEquipmentGraphLinkConfiguration();

export class QEquipmentGraphLinkConfigurationId extends QId<EquipmentGraphLinkConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly Type_Id = new QGuidPath(this.withPrefix("Type_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Type = new QEntityPath(this.withPrefix("Type"), () => QEquipmentGraphType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphConfigurationFacet);
}

export const qEquipmentGraphConfiguration = new QEquipmentGraphConfiguration();

export class QEquipmentGraphConfigurationId extends QId<EquipmentGraphConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationStateMachineFacet);
}

export const qEquipmentConfigurationStateMachine = new QEquipmentConfigurationStateMachine();

export class QEquipmentConfigurationStateMachineId extends QId<EquipmentConfigurationStateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly EquipmentConfigurationProperty_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationProperty = new QEntityPath(this.withPrefix("EquipmentConfigurationProperty"), () => QEquipmentConfigurationProperty);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationPropertyAttributeFacet);
}

export const qEquipmentConfigurationPropertyAttribute = new QEquipmentConfigurationPropertyAttribute();

export class QEquipmentConfigurationPropertyAttributeId extends QId<EquipmentConfigurationPropertyAttributeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly EquipmentConfigurationPropertyAttributes = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurationPropertyAttributes"), () => QEquipmentConfigurationPropertyAttribute);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationPropertyFacet);
}

export const qEquipmentConfigurationProperty = new QEquipmentConfigurationProperty();

export class QEquipmentConfigurationPropertyId extends QId<EquipmentConfigurationPropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly EquipmentGroupConfigurations = new QEntityCollectionPath(this.withPrefix("EquipmentGroupConfigurations"), () => QEquipmentGroupConfiguration);
    public readonly StateMachines = new QEntityCollectionPath(this.withPrefix("StateMachines"), () => QEquipmentConfigurationStateMachine);
    public readonly EquipmentConfigurationProperties = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurationProperties"), () => QEquipmentConfigurationProperty);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationFacet);
}

export const qEquipmentConfiguration = new QEquipmentConfiguration();

export class QEquipmentConfigurationId extends QId<EquipmentConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBoM extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ValidityFrom = new QDateTimeOffsetPath(this.withPrefix("ValidityFrom"));
    public readonly ValidityTo = new QDateTimeOffsetPath(this.withPrefix("ValidityTo"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly MaterialDefinition_Id = new QGuidPath(this.withPrefix("MaterialDefinition_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly MaterialProperties = new QEntityPath(this.withPrefix("MaterialProperties"), () => QMaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types);
    public readonly BoMItems = new QEntityCollectionPath(this.withPrefix("BoMItems"), () => QBoMItem);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialDefinition = new QEntityPath(this.withPrefix("MaterialDefinition"), () => QDM_Material);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBoMFacet);
}

export const qBoM = new QBoM();

export class QBoMId extends QId<BoMId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkProcessDMMaterialTrackingUnitAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkProcessNId = new QStringPath(this.withPrefix("WorkProcessNId"));
    public readonly DM_MaterialTrackingUnitNId = new QStringPath(this.withPrefix("DM_MaterialTrackingUnitNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkProcessDMMaterialTrackingUnitAssociationFacet);
}

export const qWorkProcessDMMaterialTrackingUnitAssociation = new QWorkProcessDMMaterialTrackingUnitAssociation();

export class QWorkProcessDMMaterialTrackingUnitAssociationId extends QId<WorkProcessDMMaterialTrackingUnitAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserHAEquipmentPreferences extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUserHAEquipmentPreferencesFacet);
}

export const qUserHAEquipmentPreferences = new QUserHAEquipmentPreferences();

export class QUserHAEquipmentPreferencesId extends QId<UserHAEquipmentPreferencesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialTrackingUnitAggregate extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly MaterialUId = new QStringPath(this.withPrefix("MaterialUId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly CurrentLocation = new QStringPath(this.withPrefix("CurrentLocation"));
    public readonly MaterialTrackingUnitAggregatePosition_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregatePosition_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialTrackingUnitAggregatePosition = new QEntityPath(this.withPrefix("MaterialTrackingUnitAggregatePosition"), () => QMaterialTrackingUnitAggregate);
    public readonly MaterialTrackingUnitAggregates = new QEntityCollectionPath(this.withPrefix("MaterialTrackingUnitAggregates"), () => QMaterialTrackingUnitAggregate);
    public readonly MaterialTrackingUnits = new QEntityCollectionPath(this.withPrefix("MaterialTrackingUnits"), () => QMaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialTrackingUnitAggregateFacet);
}

export const qMaterialTrackingUnitAggregate = new QMaterialTrackingUnitAggregate();

export class QMaterialTrackingUnitAggregateId extends QId<MaterialTrackingUnitAggregateId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialTrackingUnit extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly MaterialUId = new QStringPath(this.withPrefix("MaterialUId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly CurrentLocation = new QStringPath(this.withPrefix("CurrentLocation"));
    public readonly MaterialLot_Id = new QGuidPath(this.withPrefix("MaterialLot_Id"));
    public readonly MaterialTrackingUnitAggregate_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregate_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly MTU = new QEntityCollectionPath(this.withPrefix("MTU"), () => QRuntimePJFSerialNumberAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialLot = new QEntityPath(this.withPrefix("MaterialLot"), () => QMaterialLot);
    public readonly MaterialTrackingUnitAggregate = new QEntityPath(this.withPrefix("MaterialTrackingUnitAggregate"), () => QMaterialTrackingUnitAggregate);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialTrackingUnitFacet);
}

export const qMaterialTrackingUnit = new QMaterialTrackingUnit();

export class QMaterialTrackingUnitId extends QId<MaterialTrackingUnitId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialLot extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly MaterialUId = new QStringPath(this.withPrefix("MaterialUId"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly MaterialTrackingUnits = new QEntityCollectionPath(this.withPrefix("MaterialTrackingUnits"), () => QMaterialTrackingUnit);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialLotFacet);
}

export const qMaterialLot = new QMaterialLot();

export class QMaterialLotId extends QId<MaterialLotId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_MaterialTrackingUnitHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Histories = new QEntityCollectionPath(this.withPrefix("Histories"), () => QDM_MaterialTrackingUnitHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDM_MaterialTrackingUnitHistoryActionFacet);
}

export const qDM_MaterialTrackingUnitHistoryAction = new QDM_MaterialTrackingUnitHistoryAction();

export class QDM_MaterialTrackingUnitHistoryActionId extends QId<DM_MaterialTrackingUnitHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_MaterialTrackingUnitHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly MixedQuantity = new QStringPath(this.withPrefix("MixedQuantity"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QStringPath(this.withPrefix("RecycleCount"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly SourceDM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("SourceDM_MaterialTrackingUnitId"));
    public readonly TargetDM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("TargetDM_MaterialTrackingUnitId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OldCode = new QStringPath(this.withPrefix("OldCode"));
    public readonly NewCode = new QStringPath(this.withPrefix("NewCode"));
    public readonly ExecutionGroupPhase = new QGuidPath(this.withPrefix("ExecutionGroupPhase"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly DisassembledFromHistory = new QGuidPath(this.withPrefix("DisassembledFromHistory"));
    public readonly DocumentNId = new QStringPath(this.withPrefix("DocumentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ExecutionGroupPhaseNId = new QStringPath(this.withPrefix("ExecutionGroupPhaseNId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly NonConformance_Id = new QGuidPath(this.withPrefix("NonConformance_Id"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformance);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QDM_MaterialTrackingUnitHistoryAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDM_MaterialTrackingUnitHistoryFacet);
}

export const qDM_MaterialTrackingUnitHistory = new QDM_MaterialTrackingUnitHistory();

export class QDM_MaterialTrackingUnitHistoryId extends QId<DM_MaterialTrackingUnitHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_MaterialTrackingUnit extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly ActiveNonConformanceNumber = new QNumberPath(this.withPrefix("ActiveNonConformanceNumber"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly DM_MaterialId_Id = new QGuidPath(this.withPrefix("DM_MaterialId_Id"));
    public readonly ParentDM_MTU_Id = new QGuidPath(this.withPrefix("ParentDM_MTU_Id"));
    public readonly MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnit_Id"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialId = new QEntityPath(this.withPrefix("DM_MaterialId"), () => QDM_Material);
    public readonly ParentDM_MTU = new QEntityPath(this.withPrefix("ParentDM_MTU"), () => QDM_MaterialTrackingUnit);
    public readonly MaterialTrackingUnit = new QEntityPath(this.withPrefix("MaterialTrackingUnit"), () => QMaterialTrackingUnit);
    public readonly ProducedMaterialItem = new QEntityCollectionPath(this.withPrefix("ProducedMaterialItem"), () => QProducedMaterialItem);
    public readonly MaterialItem = new QEntityCollectionPath(this.withPrefix("MaterialItem"), () => QNonConformanceHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDM_MaterialTrackingUnitFacet);
}

export const qDM_MaterialTrackingUnit = new QDM_MaterialTrackingUnit();

export class QDM_MaterialTrackingUnitId extends QId<DM_MaterialTrackingUnitId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSupplier extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Materials = new QEntityCollectionPath(this.withPrefix("Materials"), () => QMaterialSupplierAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSupplierFacet);
}

export const qSupplier = new QSupplier();

export class QSupplierId extends QId<SupplierId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialGroups = new QEntityCollectionPath(this.withPrefix("MaterialGroups"), () => QMaterialGroup);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialFacet);
}

export const qMaterial = new QMaterial();

export class QMaterialId extends QId<MaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialGroup extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Materials = new QEntityCollectionPath(this.withPrefix("Materials"), () => QMaterial);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialGroupParents = new QEntityCollectionPath(this.withPrefix("MaterialGroupParents"), () => QMaterialGroup);
    public readonly MaterialGroupChildren = new QEntityCollectionPath(this.withPrefix("MaterialGroupChildren"), () => QMaterialGroup);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialGroupFacet);
}

export const qMaterialGroup = new QMaterialGroup();

export class QMaterialGroupId extends QId<MaterialGroupId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFunctionalCode extends QMaterialGroup {
}

export const qFunctionalCode = new QFunctionalCode();

export class QMaterialClass extends QMaterialGroup {
}

export const qMaterialClass = new QMaterialClass();

export class QDM_Material extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly Lot = new QBooleanPath(this.withPrefix("Lot"));
    public readonly EnableAutomaticConsumptionQty = new QBooleanPath(this.withPrefix("EnableAutomaticConsumptionQty"));
    public readonly MaxQuantityConsumption = new QNumberPath(this.withPrefix("MaxQuantityConsumption"));
    public readonly FunctionalCodeNId = new QStringPath(this.withPrefix("FunctionalCodeNId"));
    public readonly Material_Id = new QGuidPath(this.withPrefix("Material_Id"));
    public readonly MaterialClass_Id = new QGuidPath(this.withPrefix("MaterialClass_Id"));
    public readonly Supplier_Id = new QGuidPath(this.withPrefix("Supplier_Id"));
    public readonly FunctionalCode_Id = new QGuidPath(this.withPrefix("FunctionalCode_Id"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityType);
    public readonly Suppliers = new QEntityCollectionPath(this.withPrefix("Suppliers"), () => QMaterialSupplierAssociation);
    public readonly ToBeCoProducedMaterial = new QEntityCollectionPath(this.withPrefix("ToBeCoProducedMaterial"), () => QToBeCoProducedMaterial);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterial);
    public readonly MaterialClass = new QEntityPath(this.withPrefix("MaterialClass"), () => QMaterialClass);
    public readonly Supplier = new QEntityPath(this.withPrefix("Supplier"), () => QSupplier);
    public readonly FunctionalCode = new QEntityPath(this.withPrefix("FunctionalCode"), () => QFunctionalCode);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDM_MaterialFacet);
}

export const qDM_Material = new QDM_Material();

export class QDM_MaterialId extends QId<DM_MaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessContextDefinitionUserField extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
    public readonly UserFieldType = new QEnumPath(this.withPrefix("UserFieldType"), SupportedTypes);
    public readonly ProcessContextDefinition_Id = new QGuidPath(this.withPrefix("ProcessContextDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessContextDefinition = new QEntityPath(this.withPrefix("ProcessContextDefinition"), () => QProcessContextDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessContextDefinitionUserFieldFacet);
}

export const qProcessContextDefinitionUserField = new QProcessContextDefinitionUserField();

export class QProcessContextDefinitionUserFieldId extends QId<ProcessContextDefinitionUserFieldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessContextDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ContextEntityType = new QStringPath(this.withPrefix("ContextEntityType"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QProcessContextDefinitionUserField);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessDefinitions = new QEntityCollectionPath(this.withPrefix("ProcessDefinitions"), () => QProcessDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessContextDefinitionFacet);
}

export const qProcessContextDefinition = new QProcessContextDefinition();

export class QProcessContextDefinitionId extends QId<ProcessContextDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), TaskDefinitionParameterDirections);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly ProcessDefinition_Id = new QGuidPath(this.withPrefix("ProcessDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessDefinition = new QEntityPath(this.withPrefix("ProcessDefinition"), () => QProcessDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessDefinitionParameterFacet);
}

export const qProcessDefinitionParameter = new QProcessDefinitionParameter();

export class QProcessDefinitionParameterId extends QId<ProcessDefinitionParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly IsExecutable = new QBooleanPath(this.withPrefix("IsExecutable"));
    public readonly Design = new QEntityPath(this.withPrefix("Design"), () => QDesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types);
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QProcessDefinitionParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessContextDefinitions = new QEntityCollectionPath(this.withPrefix("ProcessContextDefinitions"), () => QProcessContextDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessDefinitionFacet);
}

export const qProcessDefinition = new QProcessDefinition();

export class QProcessDefinitionId extends QId<ProcessDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckProcessToOpLinkAssociationParameterValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ItlkCheckProcessToOpLinkAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociation_Id"));
    public readonly ItlkCheckParameter_Id = new QGuidPath(this.withPrefix("ItlkCheckParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckProcessToOpLinkAssociation = new QEntityPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociation"), () => QItlkCheckProcessToOpLinkAssociation);
    public readonly ItlkCheckParameter = new QEntityPath(this.withPrefix("ItlkCheckParameter"), () => QItlkCheckParameter);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckProcessToOpLinkAssociationParameterValueFacet);
}

export const qItlkCheckProcessToOpLinkAssociationParameterValue = new QItlkCheckProcessToOpLinkAssociationParameterValue();

export class QItlkCheckProcessToOpLinkAssociationParameterValueId extends QId<ItlkCheckProcessToOpLinkAssociationParameterValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckProcessToOpLinkAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly ProcessToOperationLink_Id = new QGuidPath(this.withPrefix("ProcessToOperationLink_Id"));
    public readonly ItlkCheckProcessToOpLinkAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationParameterValues"), () => QItlkCheckProcessToOpLinkAssociationParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
    public readonly ProcessToOperationLink = new QEntityPath(this.withPrefix("ProcessToOperationLink"), () => QProcessToOperationLink);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckProcessToOpLinkAssociationFacet);
}

export const qItlkCheckProcessToOpLinkAssociation = new QItlkCheckProcessToOpLinkAssociation();

export class QItlkCheckProcessToOpLinkAssociationId extends QId<ItlkCheckProcessToOpLinkAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationStepCategoryProcessDefinitionAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessDefinitionNId = new QStringPath(this.withPrefix("ProcessDefinitionNId"));
    public readonly ProcessDefinitionRevision = new QStringPath(this.withPrefix("ProcessDefinitionRevision"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Active = new QBooleanPath(this.withPrefix("Active"));
    public readonly ByMTU = new QBooleanPath(this.withPrefix("ByMTU"));
    public readonly DM_Material_Id = new QGuidPath(this.withPrefix("DM_Material_Id"));
    public readonly OperationStepCategory_Id = new QGuidPath(this.withPrefix("OperationStepCategory_Id"));
    public readonly ProcessDefinition_Id = new QGuidPath(this.withPrefix("ProcessDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QDM_Material);
    public readonly OperationStepCategory = new QEntityPath(this.withPrefix("OperationStepCategory"), () => QOperationStepCategory);
    public readonly ProcessDefinition = new QEntityPath(this.withPrefix("ProcessDefinition"), () => QProcessDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOperationStepCategoryProcessDefinitionAssociationFacet);
}

export const qOperationStepCategoryProcessDefinitionAssociation = new QOperationStepCategoryProcessDefinitionAssociation();

export class QOperationStepCategoryProcessDefinitionAssociationId extends QId<OperationStepCategoryProcessDefinitionAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOOpAssociationParameterValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ItlkCheckParameter_Id = new QGuidPath(this.withPrefix("ItlkCheckParameter_Id"));
    public readonly ItlkCheckWOOpAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckParameter = new QEntityPath(this.withPrefix("ItlkCheckParameter"), () => QItlkCheckParameter);
    public readonly ItlkCheckWOOpAssociation = new QEntityPath(this.withPrefix("ItlkCheckWOOpAssociation"), () => QItlkCheckWOOpAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckWOOpAssociationParameterValueFacet);
}

export const qItlkCheckWOOpAssociationParameterValue = new QItlkCheckWOOpAssociationParameterValue();

export class QItlkCheckWOOpAssociationParameterValueId extends QId<ItlkCheckWOOpAssociationParameterValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOOpAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly ItlkCheckWOOpAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationParameterValues"), () => QItlkCheckWOOpAssociationParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly ItlkCheckHistoryList = new QEntityCollectionPath(this.withPrefix("ItlkCheckHistoryList"), () => QItlkCheckHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckWOOpAssociationFacet);
}

export const qItlkCheckWOOpAssociation = new QItlkCheckWOOpAssociation();

export class QItlkCheckWOOpAssociationId extends QId<ItlkCheckWOOpAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckHistoryParameterValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ItlkCheckParameter = new QGuidPath(this.withPrefix("ItlkCheckParameter"));
    public readonly ItlkCheckHistory_Id = new QGuidPath(this.withPrefix("ItlkCheckHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckHistory = new QEntityPath(this.withPrefix("ItlkCheckHistory"), () => QItlkCheckHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckHistoryParameterValueFacet);
}

export const qItlkCheckHistoryParameterValue = new QItlkCheckHistoryParameterValue();

export class QItlkCheckHistoryParameterValueId extends QId<ItlkCheckHistoryParameterValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly OperationStepCategoryNId = new QStringPath(this.withPrefix("OperationStepCategoryNId"));
    public readonly ItlkCheckSessionId = new QGuidPath(this.withPrefix("ItlkCheckSessionId"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUCodeType = new QEnumPath(this.withPrefix("MTUCodeType"), MTUCodeType);
    public readonly ItlkCheckResult = new QBooleanPath(this.withPrefix("ItlkCheckResult"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ItlkCheckOperationStepCategoryAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation_Id"));
    public readonly ItlkCheckWOOpAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociation_Id"));
    public readonly ItlkCheckWOStepAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociation_Id"));
    public readonly ItlkCheckHistoryParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckHistoryParameterValues"), () => QItlkCheckHistoryParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckOperationStepCategoryAssociation = new QEntityPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation"), () => QItlkCheckOperationStepCategoryAssociation);
    public readonly ItlkCheckWOOpAssociation = new QEntityPath(this.withPrefix("ItlkCheckWOOpAssociation"), () => QItlkCheckWOOpAssociation);
    public readonly ItlkCheckWOStepAssociation = new QEntityPath(this.withPrefix("ItlkCheckWOStepAssociation"), () => QItlkCheckWOStepAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckHistoryFacet);
}

export const qItlkCheckHistory = new QItlkCheckHistory();

export class QItlkCheckHistoryId extends QId<ItlkCheckHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamUserAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly Team_Id = new QGuidPath(this.withPrefix("Team_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Team = new QEntityPath(this.withPrefix("Team"), () => QTeam);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTeamUserAssociationFacet);
}

export const qTeamUserAssociation = new QTeamUserAssociation();

export class QTeamUserAssociationId extends QId<TeamUserAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly AssociatedUser = new QStringPath(this.withPrefix("AssociatedUser"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly Teams_Id = new QGuidPath(this.withPrefix("Teams_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QTeamHistoryAction);
    public readonly Teams = new QEntityPath(this.withPrefix("Teams"), () => QTeam);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTeamHistoryFacet);
}

export const qTeamHistory = new QTeamHistory();

export class QTeamHistoryId extends QId<TeamHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTeamHistoryActionFacet);
}

export const qTeamHistoryAction = new QTeamHistoryAction();

export class QTeamHistoryActionId extends QId<TeamHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamSkillAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly Skill_Id = new QGuidPath(this.withPrefix("Skill_Id"));
    public readonly Teams_Id = new QGuidPath(this.withPrefix("Teams_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Skill = new QEntityPath(this.withPrefix("Skill"), () => QSkill_BOP);
    public readonly Teams = new QEntityPath(this.withPrefix("Teams"), () => QTeam);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTeamSkillAssociationFacet);
}

export const qTeamSkillAssociation = new QTeamSkillAssociation();

export class QTeamSkillAssociationId extends QId<TeamSkillAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeam extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaximumUsers = new QNumberPath(this.withPrefix("MaximumUsers"));
    public readonly TeamUserAssociation = new QEntityCollectionPath(this.withPrefix("TeamUserAssociation"), () => QTeamUserAssociation);
    public readonly TeamSkill = new QEntityCollectionPath(this.withPrefix("TeamSkill"), () => QTeamSkillAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Teams = new QEntityCollectionPath(this.withPrefix("Teams"), () => QWorkOrderHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTeamFacet);
}

export const qTeam = new QTeam();

export class QTeamId extends QId<TeamId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NPAContextId = new QGuidPath(this.withPrefix("NPAContextId"));
    public readonly NPAContextValue = new QGuidPath(this.withPrefix("NPAContextValue"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly NPAEquipmentNIdValue = new QStringPath(this.withPrefix("NPAEquipmentNIdValue"));
    public readonly NPAId = new QGuidPath(this.withPrefix("NPAId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QNonProductiveActivityHistoryAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonProductiveActivityHistoryFacet);
}

export const qNonProductiveActivityHistory = new QNonProductiveActivityHistory();

export class QNonProductiveActivityHistoryId extends QId<NonProductiveActivityHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonProductiveActivityHistoryActionFacet);
}

export const qNonProductiveActivityHistoryAction = new QNonProductiveActivityHistoryAction();

export class QNonProductiveActivityHistoryActionId extends QId<NonProductiveActivityHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityContext extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonProductiveActivityContextFacet);
}

export const qNonProductiveActivityContext = new QNonProductiveActivityContext();

export class QNonProductiveActivityContextId extends QId<NonProductiveActivityContextId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityNotification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly StartDate = new QDateTimeOffsetPath(this.withPrefix("StartDate"));
    public readonly EndDate = new QDateTimeOffsetPath(this.withPrefix("EndDate"));
    public readonly UserNPAId = new QGuidPath(this.withPrefix("UserNPAId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonProductiveActivityNotificationFacet);
}

export const qNonProductiveActivityNotification = new QNonProductiveActivityNotification();

export class QNonProductiveActivityNotificationId extends QId<NonProductiveActivityNotificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserNonProductiveActivity extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EndDate = new QDateTimeOffsetPath(this.withPrefix("EndDate"));
    public readonly NPAContextValue = new QGuidPath(this.withPrefix("NPAContextValue"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly NPAEquipmentNIdValue = new QStringPath(this.withPrefix("NPAEquipmentNIdValue"));
    public readonly StartDate = new QDateTimeOffsetPath(this.withPrefix("StartDate"));
    public readonly NPAId_Id = new QGuidPath(this.withPrefix("NPAId_Id"));
    public readonly NPAContext_Id = new QGuidPath(this.withPrefix("NPAContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NPAId = new QEntityPath(this.withPrefix("NPAId"), () => QNonProductiveActivity);
    public readonly NPAContext = new QEntityPath(this.withPrefix("NPAContext"), () => QNonProductiveActivityContext);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUserNonProductiveActivityFacet);
}

export const qUserNonProductiveActivity = new QUserNonProductiveActivity();

export class QUserNonProductiveActivityId extends QId<UserNonProductiveActivityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly DataType = new QEnumPath(this.withPrefix("DataType"), ItlkCheckParameterDataTypeEnum);
    public readonly IsMandatory = new QBooleanPath(this.withPrefix("IsMandatory"));
    public readonly IsList = new QBooleanPath(this.withPrefix("IsList"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly ItlkCheckWOStepAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociationParameterValues"), () => QItlkCheckWOStepAssociationParameterValue);
    public readonly ItlkCheckOperationStepCategoryAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationParameterValues"), () => QItlkCheckOperationStepCategoryAssociationParameterValue);
    public readonly ItlkCheckProcessToOpLinkAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationParameterValues"), () => QItlkCheckProcessToOpLinkAssociationParameterValue);
    public readonly ItlkCheckWOOpAssociationParameterValues = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationParameterValues"), () => QItlkCheckWOOpAssociationParameterValue);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckParameterFacet);
}

export const qItlkCheckParameter = new QItlkCheckParameter();

export class QItlkCheckParameterId extends QId<ItlkCheckParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheck extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StepRelevant = new QBooleanPath(this.withPrefix("StepRelevant"));
    public readonly OperationRelevant = new QBooleanPath(this.withPrefix("OperationRelevant"));
    public readonly IsStandard = new QBooleanPath(this.withPrefix("IsStandard"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckWOStepAssociations = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociations"), () => QItlkCheckWOStepAssociation);
    public readonly ItlkCheckOperationStepCategoryAssociation = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation"), () => QItlkCheckOperationStepCategoryAssociation);
    public readonly ItlkCheckProcessToOpLinkAssociations = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociations"), () => QItlkCheckProcessToOpLinkAssociation);
    public readonly ItlkCheckWOOpAssociations = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociations"), () => QItlkCheckWOOpAssociation);
    public readonly ItlkCheckParameters = new QEntityCollectionPath(this.withPrefix("ItlkCheckParameters"), () => QItlkCheckParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QItlkCheckFacet);
}

export const qItlkCheck = new QItlkCheck();

export class QItlkCheckId extends QId<ItlkCheckId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationStepCategory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly OperationStepCategoryProcessDefinitionAssociations = new QEntityCollectionPath(this.withPrefix("OperationStepCategoryProcessDefinitionAssociations"), () => QOperationStepCategoryProcessDefinitionAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderSteps = new QEntityCollectionPath(this.withPrefix("WorkOrderSteps"), () => QWorkOrderStep);
    public readonly WorkOrderOperations = new QEntityCollectionPath(this.withPrefix("WorkOrderOperations"), () => QWorkOrderOperation);
    public readonly Steps = new QEntityCollectionPath(this.withPrefix("Steps"), () => QStep);
    public readonly Operations = new QEntityCollectionPath(this.withPrefix("Operations"), () => QOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOperationStepCategoryFacet);
}

export const qOperationStepCategory = new QOperationStepCategory();

export class QOperationStepCategoryId extends QId<OperationStepCategoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivity extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UserNonProductiveActivity = new QEntityCollectionPath(this.withPrefix("UserNonProductiveActivity"), () => QUserNonProductiveActivity);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonProductiveActivityFacet);
}

export const qNonProductiveActivity = new QNonProductiveActivity();

export class QNonProductiveActivityId extends QId<NonProductiveActivityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderOperationSkill extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly SkillId_Id = new QGuidPath(this.withPrefix("SkillId_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SkillId = new QEntityPath(this.withPrefix("SkillId"), () => QSkill_BOP);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderOperationSkillFacet);
}

export const qWorkOrderOperationSkill = new QWorkOrderOperationSkill();

export class QWorkOrderOperationSkillId extends QId<WorkOrderOperationSkillId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupPhaseDependency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FromEGPhase_Id = new QGuidPath(this.withPrefix("FromEGPhase_Id"));
    public readonly ToEGPhase_Id = new QGuidPath(this.withPrefix("ToEGPhase_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FromEGPhase = new QEntityPath(this.withPrefix("FromEGPhase"), () => QExecutionGroupPhase);
    public readonly ToEGPhase = new QEntityPath(this.withPrefix("ToEGPhase"), () => QExecutionGroupPhase);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExecutionGroupPhaseDependencyFacet);
}

export const qExecutionGroupPhaseDependency = new QExecutionGroupPhaseDependency();

export class QExecutionGroupPhaseDependencyId extends QId<ExecutionGroupPhaseDependencyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualCollectedDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ExecutionGroupPhase = new QEntityPath(this.withPrefix("ExecutionGroupPhase"), () => QExecutionGroupPhase);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualCollectedDocumentFacet);
}

export const qActualCollectedDocument = new QActualCollectedDocument();

export class QActualCollectedDocumentId extends QId<ActualCollectedDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionAssociationType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly WorkInstructionAssociation = new QEntityCollectionPath(this.withPrefix("WorkInstructionAssociation"), () => QWorkInstructionDefinitionToStepAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionAssociationTypeFacet);
}

export const qWorkInstructionAssociationType = new QWorkInstructionAssociationType();

export class QWorkInstructionAssociationTypeId extends QId<WorkInstructionAssociationTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIDefinitionToWOOperationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HideOnExecGroup = new QBooleanPath(this.withPrefix("HideOnExecGroup"));
    public readonly WorkInstructionAssociationType_Id = new QGuidPath(this.withPrefix("WorkInstructionAssociationType_Id"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionAssociationType = new QEntityPath(this.withPrefix("WorkInstructionAssociationType"), () => QWorkInstructionAssociationType);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWIDefinitionToWOOperationAssociationFacet);
}

export const qWIDefinitionToWOOperationAssociation = new QWIDefinitionToWOOperationAssociation();

export class QWIDefinitionToWOOperationAssociationId extends QId<WIDefinitionToWOOperationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationSource extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsSelected = new QBooleanPath(this.withPrefix("IsSelected"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly TransportOperation_Id = new QGuidPath(this.withPrefix("TransportOperation_Id"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly LogisticRequestItem_Id = new QGuidPath(this.withPrefix("LogisticRequestItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperation = new QEntityPath(this.withPrefix("TransportOperation"), () => QTransportOperation);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly LogisticRequestItem = new QEntityPath(this.withPrefix("LogisticRequestItem"), () => QLogisticRequestItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTransportOperationSourceFacet);
}

export const qTransportOperationSource = new QTransportOperationSource();

export class QTransportOperationSourceId extends QId<TransportOperationSourceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationHistoryAssignedHU extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HandlingUnitNId = new QStringPath(this.withPrefix("HandlingUnitNId"));
    public readonly TransportOperationHistory_Id = new QGuidPath(this.withPrefix("TransportOperationHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperationHistory = new QEntityPath(this.withPrefix("TransportOperationHistory"), () => QTransportOperationHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTransportOperationHistoryAssignedHUFacet);
}

export const qTransportOperationHistoryAssignedHU = new QTransportOperationHistoryAssignedHU();

export class QTransportOperationHistoryAssignedHUId extends QId<TransportOperationHistoryAssignedHUId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTransportOperationHistoryActionFacet);
}

export const qTransportOperationHistoryAction = new QTransportOperationHistoryAction();

export class QTransportOperationHistoryActionId extends QId<TransportOperationHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly DestinationBufferNId = new QStringPath(this.withPrefix("DestinationBufferNId"));
    public readonly SourceBufferNId = new QStringPath(this.withPrefix("SourceBufferNId"));
    public readonly AssignedUserId = new QStringPath(this.withPrefix("AssignedUserId"));
    public readonly TransportOperation_Id = new QGuidPath(this.withPrefix("TransportOperation_Id"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly AssignedHandlingUnit = new QEntityCollectionPath(this.withPrefix("AssignedHandlingUnit"), () => QTransportOperationHistoryAssignedHU);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperation = new QEntityPath(this.withPrefix("TransportOperation"), () => QTransportOperation);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QTransportOperationHistoryAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTransportOperationHistoryFacet);
}

export const qTransportOperationHistory = new QTransportOperationHistory();

export class QTransportOperationHistoryId extends QId<TransportOperationHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationDestination extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsSelected = new QBooleanPath(this.withPrefix("IsSelected"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly TransportOperation_Id = new QGuidPath(this.withPrefix("TransportOperation_Id"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly LogisticRequestItem_Id = new QGuidPath(this.withPrefix("LogisticRequestItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperation = new QEntityPath(this.withPrefix("TransportOperation"), () => QTransportOperation);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly LogisticRequestItem = new QEntityPath(this.withPrefix("LogisticRequestItem"), () => QLogisticRequestItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTransportOperationDestinationFacet);
}

export const qTransportOperationDestination = new QTransportOperationDestination();

export class QTransportOperationDestinationId extends QId<TransportOperationDestinationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly RoleId = new QStringPath(this.withPrefix("RoleId"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly TransportOperationSources = new QEntityCollectionPath(this.withPrefix("TransportOperationSources"), () => QTransportOperationSource);
    public readonly TransportOperationHistoryList = new QEntityCollectionPath(this.withPrefix("TransportOperationHistoryList"), () => QTransportOperationHistory);
    public readonly TransportOperationDestinations = new QEntityCollectionPath(this.withPrefix("TransportOperationDestinations"), () => QTransportOperationDestination);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticRequestItems = new QEntityCollectionPath(this.withPrefix("LogisticRequestItems"), () => QLogisticRequestItem);
    public readonly HandlingUnits = new QEntityCollectionPath(this.withPrefix("HandlingUnits"), () => QHandlingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTransportOperationFacet);
}

export const qTransportOperation = new QTransportOperation();

export class QTransportOperationId extends QId<TransportOperationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeLogisticWhitelist extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CapacityType = new QGuidPath(this.withPrefix("CapacityType"));
    public readonly ContainedEntityType = new QStringPath(this.withPrefix("ContainedEntityType"));
    public readonly ContainerEntityType = new QStringPath(this.withPrefix("ContainerEntityType"));
    public readonly ToolDefinition = new QGuidPath(this.withPrefix("ToolDefinition"));
    public readonly LogisticClass_Id = new QGuidPath(this.withPrefix("LogisticClass_Id"));
    public readonly DM_Material_Id = new QGuidPath(this.withPrefix("DM_Material_Id"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly MaxQty = new QEntityPath(this.withPrefix("MaxQty"), () => QQuantityType);
    public readonly MaxVolume = new QEntityPath(this.withPrefix("MaxVolume"), () => QQuantityType);
    public readonly MaxWeight = new QEntityPath(this.withPrefix("MaxWeight"), () => QQuantityType);
    public readonly Min = new QEntityPath(this.withPrefix("Min"), () => QQuantityType);
    public readonly Target = new QEntityPath(this.withPrefix("Target"), () => QQuantityType);
    public readonly Threshold = new QEntityPath(this.withPrefix("Threshold"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticClass = new QEntityPath(this.withPrefix("LogisticClass"), () => QLogisticClass);
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QDM_Material);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QRuntimeLogisticWhitelistFacet);
}

export const qRuntimeLogisticWhitelist = new QRuntimeLogisticWhitelist();

export class QRuntimeLogisticWhitelistId extends QId<RuntimeLogisticWhitelistId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolDefinition = new QGuidPath(this.withPrefix("ToolDefinition"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly DM_Material_Id = new QGuidPath(this.withPrefix("DM_Material_Id"));
    public readonly LogisticRequest_Id = new QGuidPath(this.withPrefix("LogisticRequest_Id"));
    public readonly Source_Id = new QGuidPath(this.withPrefix("Source_Id"));
    public readonly TransportOperation_Id = new QGuidPath(this.withPrefix("TransportOperation_Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QDM_Material);
    public readonly LogisticRequest = new QEntityPath(this.withPrefix("LogisticRequest"), () => QLogisticRequest);
    public readonly Source = new QEntityPath(this.withPrefix("Source"), () => QBuffer);
    public readonly TransportOperation = new QEntityPath(this.withPrefix("TransportOperation"), () => QTransportOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QLogisticRequestItemFacet);
}

export const qLogisticRequestItem = new QLogisticRequestItem();

export class QLogisticRequestItemId extends QId<LogisticRequestItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QLogisticRequestHistoryActionFacet);
}

export const qLogisticRequestHistoryAction = new QLogisticRequestHistoryAction();

export class QLogisticRequestHistoryActionId extends QId<LogisticRequestHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly DestinationBufferId = new QGuidPath(this.withPrefix("DestinationBufferId"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly TransportOperationId = new QGuidPath(this.withPrefix("TransportOperationId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly LogisticRequest_Id = new QGuidPath(this.withPrefix("LogisticRequest_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QLogisticRequestHistoryAction);
    public readonly LogisticRequest = new QEntityPath(this.withPrefix("LogisticRequest"), () => QLogisticRequest);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QLogisticRequestHistoryFacet);
}

export const qLogisticRequestHistory = new QLogisticRequestHistory();

export class QLogisticRequestHistoryId extends QId<LogisticRequestHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequest extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Destination_Id = new QGuidPath(this.withPrefix("Destination_Id"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly LogisticRequestItems = new QEntityCollectionPath(this.withPrefix("LogisticRequestItems"), () => QLogisticRequestItem);
    public readonly LogisticRequestHistoryList = new QEntityCollectionPath(this.withPrefix("LogisticRequestHistoryList"), () => QLogisticRequestHistory);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Destination = new QEntityPath(this.withPrefix("Destination"), () => QBuffer);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QLogisticRequestFacet);
}

export const qLogisticRequest = new QLogisticRequest();

export class QLogisticRequestId extends QId<LogisticRequestId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHistoryItems extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferHistoryList = new QEntityCollectionPath(this.withPrefix("BufferHistoryList"), () => QBufferHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHistoryItemsFacet);
}

export const qHistoryItems = new QHistoryItems();

export class QHistoryItemsId extends QId<HistoryItemsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitMaterialItemAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly HandlingUnit_Id = new QGuidPath(this.withPrefix("HandlingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly HandlingUnit = new QEntityPath(this.withPrefix("HandlingUnit"), () => QHandlingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHandlingUnitMaterialItemAssociationFacet);
}

export const qHandlingUnitMaterialItemAssociation = new QHandlingUnitMaterialItemAssociation();

export class QHandlingUnitMaterialItemAssociationId extends QId<HandlingUnitMaterialItemAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHandlingUnitHistoryActionFacet);
}

export const qHandlingUnitHistoryAction = new QHandlingUnitHistoryAction();

export class QHandlingUnitHistoryActionId extends QId<HandlingUnitHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly DestinationBufferNId = new QStringPath(this.withPrefix("DestinationBufferNId"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
    public readonly HandlingUnitNId = new QStringPath(this.withPrefix("HandlingUnitNId"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly SourceBufferNId = new QStringPath(this.withPrefix("SourceBufferNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly TransportOperationNId = new QStringPath(this.withPrefix("TransportOperationNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly HandlingUnit_Id = new QGuidPath(this.withPrefix("HandlingUnit_Id"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly MaterialItemQuantity = new QEntityPath(this.withPrefix("MaterialItemQuantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HandlingUnit = new QEntityPath(this.withPrefix("HandlingUnit"), () => QHandlingUnit);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QHandlingUnitHistoryAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHandlingUnitHistoryFacet);
}

export const qHandlingUnitHistory = new QHandlingUnitHistory();

export class QHandlingUnitHistoryId extends QId<HandlingUnitHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnit extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly TransportOperation_Id = new QGuidPath(this.withPrefix("TransportOperation_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityType);
    public readonly HandlingUnitMaterialItemAssociations = new QEntityCollectionPath(this.withPrefix("HandlingUnitMaterialItemAssociations"), () => QHandlingUnitMaterialItemAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperation = new QEntityPath(this.withPrefix("TransportOperation"), () => QTransportOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHandlingUnitFacet);
}

export const qHandlingUnit = new QHandlingUnit();

export class QHandlingUnitId extends QId<HandlingUnitId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferToolAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Tool = new QGuidPath(this.withPrefix("Tool"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferToolAssociationFacet);
}

export const qBufferToolAssociation = new QBufferToolAssociation();

export class QBufferToolAssociationId extends QId<BufferToolAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferMaterialItemAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferMaterialItemAssociationFacet);
}

export const qBufferMaterialItemAssociation = new QBufferMaterialItemAssociation();

export class QBufferMaterialItemAssociationId extends QId<BufferMaterialItemAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityCollectionPath(this.withPrefix("Action"), () => QBufferHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferHistoryActionFacet);
}

export const qBufferHistoryAction = new QBufferHistoryAction();

export class QBufferHistoryActionId extends QId<BufferHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ItemId = new QGuidPath(this.withPrefix("ItemId"));
    public readonly ItemNId = new QStringPath(this.withPrefix("ItemNId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly Type_Id = new QGuidPath(this.withPrefix("Type_Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QBufferHistoryAction);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly Type = new QEntityPath(this.withPrefix("Type"), () => QHistoryItems);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferHistoryFacet);
}

export const qBufferHistory = new QBufferHistory();

export class QBufferHistoryId extends QId<BufferHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferEquipmentAssoication extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferEquipmentAssoicationFacet);
}

export const qBufferEquipmentAssoication = new QBufferEquipmentAssoication();

export class QBufferEquipmentAssoicationId extends QId<BufferEquipmentAssoicationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBuffer extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ValidityFrom = new QDateTimeOffsetPath(this.withPrefix("ValidityFrom"));
    public readonly ValidityTo = new QDateTimeOffsetPath(this.withPrefix("ValidityTo"));
    public readonly BufferDefinition_Id = new QGuidPath(this.withPrefix("BufferDefinition_Id"));
    public readonly CapacityType_Id = new QGuidPath(this.withPrefix("CapacityType_Id"));
    public readonly MaxQty = new QEntityPath(this.withPrefix("MaxQty"), () => QQuantityType);
    public readonly MaxVolume = new QEntityPath(this.withPrefix("MaxVolume"), () => QQuantityType);
    public readonly MaxWeight = new QEntityPath(this.withPrefix("MaxWeight"), () => QQuantityType);
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly RuntimeLogisticWhitelists = new QEntityCollectionPath(this.withPrefix("RuntimeLogisticWhitelists"), () => QRuntimeLogisticWhitelist);
    public readonly Source = new QEntityCollectionPath(this.withPrefix("Source"), () => QLogisticRequestItem);
    public readonly LogisticRequests = new QEntityCollectionPath(this.withPrefix("LogisticRequests"), () => QLogisticRequest);
    public readonly TriggeredLogisticRequests = new QEntityCollectionPath(this.withPrefix("TriggeredLogisticRequests"), () => QLogisticRequest);
    public readonly BufferToolAssociations = new QEntityCollectionPath(this.withPrefix("BufferToolAssociations"), () => QBufferToolAssociation);
    public readonly BufferMaterialItemAssociations = new QEntityCollectionPath(this.withPrefix("BufferMaterialItemAssociations"), () => QBufferMaterialItemAssociation);
    public readonly BufferHistoryList = new QEntityCollectionPath(this.withPrefix("BufferHistoryList"), () => QBufferHistory);
    public readonly BufferEquipmentAssoication = new QEntityCollectionPath(this.withPrefix("BufferEquipmentAssoication"), () => QBufferEquipmentAssoication);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferDefinition = new QEntityPath(this.withPrefix("BufferDefinition"), () => QBufferDefinition);
    public readonly CapacityType = new QEntityPath(this.withPrefix("CapacityType"), () => QCapacityType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferFacet);
}

export const qBuffer = new QBuffer();

export class QBufferId extends QId<BufferId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupPhaseWOOAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupPhase = new QEntityPath(this.withPrefix("ExecutionGroupPhase"), () => QExecutionGroupPhase);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExecutionGroupPhaseWOOAssociationFacet);
}

export const qExecutionGroupPhaseWOOAssociation = new QExecutionGroupPhaseWOOAssociation();

export class QExecutionGroupPhaseWOOAssociationId extends QId<ExecutionGroupPhaseWOOAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionToWorkOrderOperationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HideOnExecGroup = new QBooleanPath(this.withPrefix("HideOnExecGroup"));
    public readonly WIDefToWOOpAssociationId = new QGuidPath(this.withPrefix("WIDefToWOOpAssociationId"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkInstruction_Id = new QGuidPath(this.withPrefix("WorkInstruction_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkInstruction = new QEntityPath(this.withPrefix("WorkInstruction"), () => QWorkInstruction);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionToWorkOrderOperationAssociationFacet);
}

export const qWorkInstructionToWorkOrderOperationAssociation = new QWorkInstructionToWorkOrderOperationAssociation();

export class QWorkInstructionToWorkOrderOperationAssociationId extends QId<WorkInstructionToWorkOrderOperationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupPhase extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly PreferredMachineNId = new QStringPath(this.withPrefix("PreferredMachineNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly ExecutionGroup_Id = new QGuidPath(this.withPrefix("ExecutionGroup_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly WorkInstructionToEGPhaseAssociation = new QEntityCollectionPath(this.withPrefix("WorkInstructionToEGPhaseAssociation"), () => QWorkInstructionToExecutionGroupPhaseAssociation);
    public readonly WIDefinitionToEGPhaseAssociation = new QEntityCollectionPath(this.withPrefix("WIDefinitionToEGPhaseAssociation"), () => QWIDefinitionToEGPhaseAssociation);
    public readonly Successors = new QEntityCollectionPath(this.withPrefix("Successors"), () => QExecutionGroupPhaseDependency);
    public readonly Predecessor = new QEntityCollectionPath(this.withPrefix("Predecessor"), () => QExecutionGroupPhaseDependency);
    public readonly ActualCollectedDocument = new QEntityCollectionPath(this.withPrefix("ActualCollectedDocument"), () => QActualCollectedDocument);
    public readonly ExecutionGroupPhaseWOOAssociation = new QEntityCollectionPath(this.withPrefix("ExecutionGroupPhaseWOOAssociation"), () => QExecutionGroupPhaseWOOAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroup = new QEntityPath(this.withPrefix("ExecutionGroup"), () => QExecutionGroup);
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QActualConsumedMaterial);
    public readonly ActiveUserOnMachines = new QEntityCollectionPath(this.withPrefix("ActiveUserOnMachines"), () => QActiveUserOnMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExecutionGroupPhaseFacet);
}

export const qExecutionGroupPhase = new QExecutionGroupPhase();

export class QExecutionGroupPhaseId extends QId<ExecutionGroupPhaseId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExecutionGroupHistoryActionFacet);
}

export const qExecutionGroupHistoryAction = new QExecutionGroupHistoryAction();

export class QExecutionGroupHistoryActionId extends QId<ExecutionGroupHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WOOId = new QGuidPath(this.withPrefix("WOOId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly NewQuantity = new QNumberPath(this.withPrefix("NewQuantity"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QExecutionGroupHistoryAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExecutionGroupHistoryFacet);
}

export const qExecutionGroupHistory = new QExecutionGroupHistory();

export class QExecutionGroupHistoryId extends QId<ExecutionGroupHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroup extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly IsUnderScheduling = new QBooleanPath(this.withPrefix("IsUnderScheduling"));
    public readonly SchedulingDate = new QDateTimeOffsetPath(this.withPrefix("SchedulingDate"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly ExecutionGroupPhases = new QEntityCollectionPath(this.withPrefix("ExecutionGroupPhases"), () => QExecutionGroupPhase);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QExecutionGroupFacet);
}

export const qExecutionGroup = new QExecutionGroup();

export class QExecutionGroupId extends QId<ExecutionGroupId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionStepItemLimit extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItemNId = new QStringPath(this.withPrefix("ItemNId"));
    public readonly Target = new QStringPath(this.withPrefix("Target"));
    public readonly TargetBinding = new QStringPath(this.withPrefix("TargetBinding"));
    public readonly LowLimit = new QStringPath(this.withPrefix("LowLimit"));
    public readonly LowLimitBinding = new QStringPath(this.withPrefix("LowLimitBinding"));
    public readonly HighLimit = new QStringPath(this.withPrefix("HighLimit"));
    public readonly HighLimitBinding = new QStringPath(this.withPrefix("HighLimitBinding"));
    public readonly AlertMin = new QStringPath(this.withPrefix("AlertMin"));
    public readonly AlertMinBinding = new QStringPath(this.withPrefix("AlertMinBinding"));
    public readonly CautionMin = new QStringPath(this.withPrefix("CautionMin"));
    public readonly CautionMinBinding = new QStringPath(this.withPrefix("CautionMinBinding"));
    public readonly CautionMax = new QStringPath(this.withPrefix("CautionMax"));
    public readonly CautionMaxBinding = new QStringPath(this.withPrefix("CautionMaxBinding"));
    public readonly AlertMax = new QStringPath(this.withPrefix("AlertMax"));
    public readonly AlertMaxBinding = new QStringPath(this.withPrefix("AlertMaxBinding"));
    public readonly WorkInstructionStepItem_Id = new QGuidPath(this.withPrefix("WorkInstructionStepItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionStepItem = new QEntityPath(this.withPrefix("WorkInstructionStepItem"), () => QWorkInstructionStepItem);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionStepItemLimitFacet);
}

export const qWorkInstructionStepItemLimit = new QWorkInstructionStepItemLimit();

export class QWorkInstructionStepItemLimitId extends QId<WorkInstructionStepItemLimitId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionStepItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItemNId = new QStringPath(this.withPrefix("ItemNId"));
    public readonly StepNId = new QStringPath(this.withPrefix("StepNId"));
    public readonly ItemValue = new QStringPath(this.withPrefix("ItemValue"));
    public readonly DataType = new QStringPath(this.withPrefix("DataType"));
    public readonly Binding = new QStringPath(this.withPrefix("Binding"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly Caption = new QStringPath(this.withPrefix("Caption"));
    public readonly UIControl = new QStringPath(this.withPrefix("UIControl"));
    public readonly IsRequired = new QBooleanPath(this.withPrefix("IsRequired"));
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly Format = new QStringPath(this.withPrefix("Format"));
    public readonly DefaultValue = new QStringPath(this.withPrefix("DefaultValue"));
    public readonly ExecutionDate = new QDateTimeOffsetPath(this.withPrefix("ExecutionDate"));
    public readonly CompletedBy = new QStringPath(this.withPrefix("CompletedBy"));
    public readonly IsModifiable = new QBooleanPath(this.withPrefix("IsModifiable"));
    public readonly IsForceBlank = new QBooleanPath(this.withPrefix("IsForceBlank"));
    public readonly IsOutOfSpec = new QBooleanPath(this.withPrefix("IsOutOfSpec"));
    public readonly Length = new QNumberPath(this.withPrefix("Length"));
    public readonly LastValueUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastValueUpdatedOn"));
    public readonly IsCompleted = new QBooleanPath(this.withPrefix("IsCompleted"));
    public readonly InstanceNumber = new QNumberPath(this.withPrefix("InstanceNumber"));
    public readonly AcquisitionBehavior = new QEnumPath(this.withPrefix("AcquisitionBehavior"), AcquisitionType);
    public readonly WorkInstructionStep_Id = new QGuidPath(this.withPrefix("WorkInstructionStep_Id"));
    public readonly Limit = new QEntityCollectionPath(this.withPrefix("Limit"), () => QWorkInstructionStepItemLimit);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionStep = new QEntityPath(this.withPrefix("WorkInstructionStep"), () => QWorkInstructionStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionStepItemFacet);
}

export const qWorkInstructionStepItem = new QWorkInstructionStepItem();

export class QWorkInstructionStepItemId extends QId<WorkInstructionStepItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionStep extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Title = new QStringPath(this.withPrefix("Title"));
    public readonly InstanceNumber = new QNumberPath(this.withPrefix("InstanceNumber"));
    public readonly Instructions = new QStringPath(this.withPrefix("Instructions"));
    public readonly AcknowledgeOn = new QDateTimeOffsetPath(this.withPrefix("AcknowledgeOn"));
    public readonly CompletedBy = new QStringPath(this.withPrefix("CompletedBy"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly IsSignaturePending = new QBooleanPath(this.withPrefix("IsSignaturePending"));
    public readonly ScenarioInstanceId = new QGuidPath(this.withPrefix("ScenarioInstanceId"));
    public readonly Type = new QEnumPath(this.withPrefix("Type"), WorkInstructionStepType);
    public readonly IsCompleted = new QBooleanPath(this.withPrefix("IsCompleted"));
    public readonly WorkInstructionSection_Id = new QGuidPath(this.withPrefix("WorkInstructionSection_Id"));
    public readonly ScenarioConfiguration = new QEntityPath(this.withPrefix("ScenarioConfiguration"), () => QScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types);
    public readonly Items = new QEntityCollectionPath(this.withPrefix("Items"), () => QWorkInstructionStepItem);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionSection = new QEntityPath(this.withPrefix("WorkInstructionSection"), () => QWorkInstructionSection);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionStepFacet);
}

export const qWorkInstructionStep = new QWorkInstructionStep();

export class QWorkInstructionStepId extends QId<WorkInstructionStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionSection extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Title = new QStringPath(this.withPrefix("Title"));
    public readonly CompletedBy = new QStringPath(this.withPrefix("CompletedBy"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly IsCompleted = new QBooleanPath(this.withPrefix("IsCompleted"));
    public readonly WorkInstruction_Id = new QGuidPath(this.withPrefix("WorkInstruction_Id"));
    public readonly Steps = new QEntityCollectionPath(this.withPrefix("Steps"), () => QWorkInstructionStep);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstruction = new QEntityPath(this.withPrefix("WorkInstruction"), () => QWorkInstruction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionSectionFacet);
}

export const qWorkInstructionSection = new QWorkInstructionSection();

export class QWorkInstructionSectionId extends QId<WorkInstructionSectionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly WorkInstruction_Id = new QGuidPath(this.withPrefix("WorkInstruction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstruction = new QEntityPath(this.withPrefix("WorkInstruction"), () => QWorkInstruction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionParameterFacet);
}

export const qWorkInstructionParameter = new QWorkInstructionParameter();

export class QWorkInstructionParameterId extends QId<WorkInstructionParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstruction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly WorkInstructionDefinitionNId = new QStringPath(this.withPrefix("WorkInstructionDefinitionNId"));
    public readonly WorkInstructionDefinitionRevision = new QStringPath(this.withPrefix("WorkInstructionDefinitionRevision"));
    public readonly IsReEditEnabled = new QBooleanPath(this.withPrefix("IsReEditEnabled"));
    public readonly Design = new QEntityPath(this.withPrefix("Design"), () => QWorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types);
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly Sections = new QEntityCollectionPath(this.withPrefix("Sections"), () => QWorkInstructionSection);
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QWorkInstructionParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionFacet);
}

export const qWorkInstruction = new QWorkInstruction();

export class QWorkInstructionId extends QId<WorkInstructionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinitionToOperationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HideOnExecGroup = new QBooleanPath(this.withPrefix("HideOnExecGroup"));
    public readonly WorkInstructionAssociationType_Id = new QGuidPath(this.withPrefix("WorkInstructionAssociationType_Id"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionAssociationType = new QEntityPath(this.withPrefix("WorkInstructionAssociationType"), () => QWorkInstructionAssociationType);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionDefinitionToOperationAssociationFacet);
}

export const qWorkInstructionDefinitionToOperationAssociation = new QWorkInstructionDefinitionToOperationAssociation();

export class QWorkInstructionDefinitionToOperationAssociationId extends QId<WorkInstructionDefinitionToOperationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionTemplateParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly WorkInstructionTemplate_Id = new QGuidPath(this.withPrefix("WorkInstructionTemplate_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionTemplate = new QEntityPath(this.withPrefix("WorkInstructionTemplate"), () => QWorkInstructionTemplate);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionTemplateParameterFacet);
}

export const qWorkInstructionTemplateParameter = new QWorkInstructionTemplateParameter();

export class QWorkInstructionTemplateParameterId extends QId<WorkInstructionTemplateParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionTemplate extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly WorkInstructionTemplateParameters = new QEntityCollectionPath(this.withPrefix("WorkInstructionTemplateParameters"), () => QWorkInstructionTemplateParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionTemplateFacet);
}

export const qWorkInstructionTemplate = new QWorkInstructionTemplate();

export class QWorkInstructionTemplateId extends QId<WorkInstructionTemplateId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionDefinitionParameterFacet);
}

export const qWorkInstructionDefinitionParameter = new QWorkInstructionDefinitionParameter();

export class QWorkInstructionDefinitionParameterId extends QId<WorkInstructionDefinitionParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsExecutable = new QBooleanPath(this.withPrefix("IsExecutable"));
    public readonly WorkInstructionTemplateNId = new QStringPath(this.withPrefix("WorkInstructionTemplateNId"));
    public readonly Design = new QEntityPath(this.withPrefix("Design"), () => QWorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types);
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QWorkInstructionDefinitionParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkInstructionDefinitionFacet);
}

export const qWorkInstructionDefinition = new QWorkInstructionDefinition();

export class QWorkInstructionDefinitionId extends QId<WorkInstructionDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPattern extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EntityTypeNId = new QStringPath(this.withPrefix("EntityTypeNId"));
    public readonly DestinationProperty = new QStringPath(this.withPrefix("DestinationProperty"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternParts = new QEntityCollectionPath(this.withPrefix("NumberingPatternParts"), () => QNumberingPatternPart);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternFacet);
}

export const qNumberingPattern = new QNumberingPattern();

export class QNumberingPatternId extends QId<NumberingPatternId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly NumberingPatternEntity_Id = new QGuidPath(this.withPrefix("NumberingPatternEntity_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternEntity = new QEntityPath(this.withPrefix("NumberingPatternEntity"), () => QNumberingPatternEntity);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternParameterFacet);
}

export const qNumberingPatternParameter = new QNumberingPatternParameter();

export class QNumberingPatternParameterId extends QId<NumberingPatternParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternPart extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Constant = new QStringPath(this.withPrefix("Constant"));
    public readonly Timestamp = new QStringPath(this.withPrefix("Timestamp"));
    public readonly ParameterNId = new QStringPath(this.withPrefix("ParameterNId"));
    public readonly RegularExpression = new QStringPath(this.withPrefix("RegularExpression"));
    public readonly CustomPart = new QStringPath(this.withPrefix("CustomPart"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly NumberingPattern_Id = new QGuidPath(this.withPrefix("NumberingPattern_Id"));
    public readonly Counter_Id = new QGuidPath(this.withPrefix("Counter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPattern = new QEntityPath(this.withPrefix("NumberingPattern"), () => QNumberingPattern);
    public readonly Counter = new QEntityPath(this.withPrefix("Counter"), () => QCounter);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternPartFacet);
}

export const qNumberingPatternPart = new QNumberingPatternPart();

export class QNumberingPatternPartId extends QId<NumberingPatternPartId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternEntity extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly NumberingPatternEntityDescriptor = new QEntityCollectionPath(this.withPrefix("NumberingPatternEntityDescriptor"), () => QNumberingPatternEntityInfo);
    public readonly NumberingPatternParamenters = new QEntityCollectionPath(this.withPrefix("NumberingPatternParamenters"), () => QNumberingPatternParameter);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNumberingPatternEntityFacet);
}

export const qNumberingPatternEntity = new QNumberingPatternEntity();

export class QNumberingPatternEntityId extends QId<NumberingPatternEntityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCounter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Seed = new QNumberPath(this.withPrefix("Seed"));
    public readonly Increment = new QNumberPath(this.withPrefix("Increment"));
    public readonly MaxValue = new QNumberPath(this.withPrefix("MaxValue"));
    public readonly LeadingZeros = new QBooleanPath(this.withPrefix("LeadingZeros"));
    public readonly TimeBasedReset = new QStringPath(this.withPrefix("TimeBasedReset"));
    public readonly IsTransactional = new QBooleanPath(this.withPrefix("IsTransactional"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly NumberingPatternParts = new QEntityCollectionPath(this.withPrefix("NumberingPatternParts"), () => QNumberingPatternPart);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCounterFacet);
}

export const qCounter = new QCounter();

export class QCounterId extends QId<CounterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticWhitelist extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContainedEntityType = new QStringPath(this.withPrefix("ContainedEntityType"));
    public readonly ContainerEntityType = new QStringPath(this.withPrefix("ContainerEntityType"));
    public readonly ToolDefinition_Id = new QGuidPath(this.withPrefix("ToolDefinition_Id"));
    public readonly DMMaterial_Id = new QGuidPath(this.withPrefix("DMMaterial_Id"));
    public readonly CapacityType_Id = new QGuidPath(this.withPrefix("CapacityType_Id"));
    public readonly LogisticClass_Id = new QGuidPath(this.withPrefix("LogisticClass_Id"));
    public readonly BufferDefinition_Id = new QGuidPath(this.withPrefix("BufferDefinition_Id"));
    public readonly MaxQty = new QEntityPath(this.withPrefix("MaxQty"), () => QQuantityType);
    public readonly MaxWeight = new QEntityPath(this.withPrefix("MaxWeight"), () => QQuantityType);
    public readonly MaxVolume = new QEntityPath(this.withPrefix("MaxVolume"), () => QQuantityType);
    public readonly Min = new QEntityPath(this.withPrefix("Min"), () => QQuantityType);
    public readonly Target = new QEntityPath(this.withPrefix("Target"), () => QQuantityType);
    public readonly Treshold = new QEntityPath(this.withPrefix("Treshold"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinition = new QEntityPath(this.withPrefix("ToolDefinition"), () => QToolDefinition);
    public readonly DMMaterial = new QEntityPath(this.withPrefix("DMMaterial"), () => QDM_Material);
    public readonly CapacityType = new QEntityPath(this.withPrefix("CapacityType"), () => QCapacityType);
    public readonly LogisticClass = new QEntityPath(this.withPrefix("LogisticClass"), () => QLogisticClass);
    public readonly BufferDefinition = new QEntityPath(this.withPrefix("BufferDefinition"), () => QBufferDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QLogisticWhitelistFacet);
}

export const qLogisticWhitelist = new QLogisticWhitelist();

export class QLogisticWhitelistId extends QId<LogisticWhitelistId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticClass extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QLogisticClassFacet);
}

export const qLogisticClass = new QLogisticClass();

export class QLogisticClassId extends QId<LogisticClassId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCapacityType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CapacityTypes = new QEntityCollectionPath(this.withPrefix("CapacityTypes"), () => QBuffer);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCapacityTypeFacet);
}

export const qCapacityType = new QCapacityType();

export class QCapacityTypeId extends QId<CapacityTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly IsValid = new QBooleanPath(this.withPrefix("IsValid"));
    public readonly CapacityType_Id = new QGuidPath(this.withPrefix("CapacityType_Id"));
    public readonly MaxQty = new QEntityPath(this.withPrefix("MaxQty"), () => QQuantityType);
    public readonly MaxWeight = new QEntityPath(this.withPrefix("MaxWeight"), () => QQuantityType);
    public readonly MaxVolume = new QEntityPath(this.withPrefix("MaxVolume"), () => QQuantityType);
    public readonly BufferDefinitions = new QEntityCollectionPath(this.withPrefix("BufferDefinitions"), () => QBuffer);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CapacityType = new QEntityPath(this.withPrefix("CapacityType"), () => QCapacityType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QBufferDefinitionFacet);
}

export const qBufferDefinition = new QBufferDefinition();

export class QBufferDefinitionId extends QId<BufferDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMFactor extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly K0Multiplier = new QNumberPath(this.withPrefix("K0Multiplier"));
    public readonly Addend = new QNumberPath(this.withPrefix("Addend"));
    public readonly K1Multiplier = new QNumberPath(this.withPrefix("K1Multiplier"));
    public readonly Exponent = new QNumberPath(this.withPrefix("Exponent"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly TargetUoM_Id = new QGuidPath(this.withPrefix("TargetUoM_Id"));
    public readonly SourceUoM_Id = new QGuidPath(this.withPrefix("SourceUoM_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TargetUoM = new QEntityPath(this.withPrefix("TargetUoM"), () => QUoM);
    public readonly SourceUoM = new QEntityPath(this.withPrefix("SourceUoM"), () => QUoM);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUoMFactorFacet);
}

export const qUoMFactor = new QUoMFactor();

export class QUoMFactorId extends QId<UoMFactorId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMDimension extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMs = new QEntityCollectionPath(this.withPrefix("UoMs"), () => QUoM);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUoMDimensionFacet);
}

export const qUoMDimension = new QUoMDimension();

export class QUoMDimensionId extends QId<UoMDimensionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoM extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly UoMDimension_Id = new QGuidPath(this.withPrefix("UoMDimension_Id"));
    public readonly UoMBase_Id = new QGuidPath(this.withPrefix("UoMBase_Id"));
    public readonly TUoMFactors = new QEntityCollectionPath(this.withPrefix("TUoMFactors"), () => QUoMFactor);
    public readonly SUoMFactors = new QEntityCollectionPath(this.withPrefix("SUoMFactors"), () => QUoMFactor);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMDimension = new QEntityPath(this.withPrefix("UoMDimension"), () => QUoMDimension);
    public readonly UoMBase = new QEntityPath(this.withPrefix("UoMBase"), () => QUoM);
    public readonly UoMsMultipleOrSubmultiple = new QEntityCollectionPath(this.withPrefix("UoMsMultipleOrSubmultiple"), () => QUoM);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUoMFacet);
}

export const qUoM = new QUoM();

export class QUoMId extends QId<UoMId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusTransitionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusTransitionDefinitionFacet);
}

export const qStatusTransitionDefinition = new QStatusTransitionDefinition();

export class QStatusTransitionDefinitionId extends QId<StatusTransitionDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusTransition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly DoRaiseEvent = new QBooleanPath(this.withPrefix("DoRaiseEvent"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly TargetStatus_Id = new QGuidPath(this.withPrefix("TargetStatus_Id"));
    public readonly SourceStatus_Id = new QGuidPath(this.withPrefix("SourceStatus_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TargetStatus = new QEntityPath(this.withPrefix("TargetStatus"), () => QStatus);
    public readonly SourceStatus = new QEntityPath(this.withPrefix("SourceStatus"), () => QStatus);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusTransitionFacet);
}

export const qStatusTransition = new QStatusTransition();

export class QStatusTransitionId extends QId<StatusTransitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusDefinitionFacet);
}

export const qStatusDefinition = new QStatusDefinition();

export class QStatusDefinitionId extends QId<StatusDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusBehaviorDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Statuses = new QEntityCollectionPath(this.withPrefix("Statuses"), () => QStatus);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusBehaviorDefinitionFacet);
}

export const qStatusBehaviorDefinition = new QStatusBehaviorDefinition();

export class QStatusBehaviorDefinitionId extends QId<StatusBehaviorDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly IsInitial = new QBooleanPath(this.withPrefix("IsInitial"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
    public readonly StateMachine_Id = new QGuidPath(this.withPrefix("StateMachine_Id"));
    public readonly SourceStatusTransitions = new QEntityCollectionPath(this.withPrefix("SourceStatusTransitions"), () => QStatusTransition);
    public readonly TargetStatusTransitions = new QEntityCollectionPath(this.withPrefix("TargetStatusTransitions"), () => QStatusTransition);
    public readonly StatusBehaviorDefinitions = new QEntityCollectionPath(this.withPrefix("StatusBehaviorDefinitions"), () => QStatusBehaviorDefinition);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StateMachine = new QEntityPath(this.withPrefix("StateMachine"), () => QStateMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusFacet);
}

export const qStatus = new QStatus();

export class QStatusId extends QId<StatusId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly Statuses = new QEntityCollectionPath(this.withPrefix("Statuses"), () => QStatus);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStateMachineFacet);
}

export const qStateMachine = new QStateMachine();

export class QStateMachineId extends QId<StateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserPlantAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUserPlantAssociationFacet);
}

export const qUserPlantAssociation = new QUserPlantAssociation();

export class QUserPlantAssociationId extends QId<UserPlantAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMasterPlan extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Completed = new QBooleanPath(this.withPrefix("Completed"));
    public readonly SpecializedSpecificationSet = new QBooleanPath(this.withPrefix("SpecializedSpecificationSet"));
    public readonly CertificationSpecification = new QEntityCollectionPath(this.withPrefix("CertificationSpecification"), () => QCertificationSpecification);
    public readonly InspectionSpecification = new QEntityCollectionPath(this.withPrefix("InspectionSpecification"), () => QInspectionSpecification);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationToStepLinks = new QEntityCollectionPath(this.withPrefix("OperationToStepLinks"), () => QOperationToStepLink);
    public readonly ProcessToProcessLinks = new QEntityCollectionPath(this.withPrefix("ProcessToProcessLinks"), () => QProcessToProcessLink);
    public readonly ProcessToOperationLinks = new QEntityCollectionPath(this.withPrefix("ProcessToOperationLinks"), () => QProcessToOperationLink);
    public readonly StepDependencies = new QEntityCollectionPath(this.withPrefix("StepDependencies"), () => QStepDependency);
    public readonly Processes = new QEntityCollectionPath(this.withPrefix("Processes"), () => QProcess);
    public readonly OperationDependencies = new QEntityCollectionPath(this.withPrefix("OperationDependencies"), () => QOperationDependency);
    public readonly MaterialSpecification = new QEntityCollectionPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecification);
    public readonly EquipmentSpecification = new QEntityCollectionPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecification);
    public readonly ToolSpecification = new QEntityCollectionPath(this.withPrefix("ToolSpecification"), () => QToolSpecification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMasterPlanFacet);
}

export const qMasterPlan = new QMasterPlan();

export class QMasterPlanId extends QId<MasterPlanId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkill_BOP extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Skill_Step = new QEntityCollectionPath(this.withPrefix("Skill_Step"), () => QWorkOrderStepSkill);
    public readonly StepSkills = new QEntityCollectionPath(this.withPrefix("StepSkills"), () => QStepSkill);
    public readonly TeamSkill = new QEntityCollectionPath(this.withPrefix("TeamSkill"), () => QTeamSkillAssociation);
    public readonly Skill = new QEntityCollectionPath(this.withPrefix("Skill"), () => QWorkOrderOperationSkill);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationSkill = new QEntityCollectionPath(this.withPrefix("OperationSkill"), () => QOperationSkill);
    public readonly SkillId = new QEntityCollectionPath(this.withPrefix("SkillId"), () => QSkillCertificationAssociation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSkill_BOPFacet);
}

export const qSkill_BOP = new QSkill_BOP();

export class QSkill_BOPId extends QId<Skill_BOPId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationToStepLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly ParentOperation_Id = new QGuidPath(this.withPrefix("ParentOperation_Id"));
    public readonly ChildStep_Id = new QGuidPath(this.withPrefix("ChildStep_Id"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentOperation = new QEntityPath(this.withPrefix("ParentOperation"), () => QOperation);
    public readonly ChildStep = new QEntityPath(this.withPrefix("ChildStep"), () => QStep);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly ToStepDependency = new QEntityCollectionPath(this.withPrefix("ToStepDependency"), () => QStepDependency);
    public readonly FromStepDependency = new QEntityCollectionPath(this.withPrefix("FromStepDependency"), () => QStepDependency);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOperationToStepLinkFacet);
}

export const qOperationToStepLink = new QOperationToStepLink();

export class QOperationToStepLinkId extends QId<OperationToStepLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessToProcessLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly ParentProcess_Id = new QGuidPath(this.withPrefix("ParentProcess_Id"));
    public readonly ChildProcess_Id = new QGuidPath(this.withPrefix("ChildProcess_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly ParentProcess = new QEntityPath(this.withPrefix("ParentProcess"), () => QProcess);
    public readonly ChildProcess = new QEntityPath(this.withPrefix("ChildProcess"), () => QProcess);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessToProcessLinkFacet);
}

export const qProcessToProcessLink = new QProcessToProcessLink();

export class QProcessToProcessLinkId extends QId<ProcessToProcessLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessToOperationLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly ParentProcess_Id = new QGuidPath(this.withPrefix("ParentProcess_Id"));
    public readonly ChildOperation_Id = new QGuidPath(this.withPrefix("ChildOperation_Id"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentProcess = new QEntityPath(this.withPrefix("ParentProcess"), () => QProcess);
    public readonly ChildOperation = new QEntityPath(this.withPrefix("ChildOperation"), () => QOperation);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly DependencyLinkFrom = new QEntityCollectionPath(this.withPrefix("DependencyLinkFrom"), () => QOperationDependency);
    public readonly DependencyLinkTo = new QEntityCollectionPath(this.withPrefix("DependencyLinkTo"), () => QOperationDependency);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessToOperationLinkFacet);
}

export const qProcessToOperationLink = new QProcessToOperationLink();

export class QProcessToOperationLinkId extends QId<ProcessToOperationLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationSkill extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly Skill_Id = new QGuidPath(this.withPrefix("Skill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly Skill = new QEntityPath(this.withPrefix("Skill"), () => QSkill_BOP);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOperationSkillFacet);
}

export const qOperationSkill = new QOperationSkill();

export class QOperationSkillId extends QId<OperationSkillId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProducedMaterialUnderRework extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialItemStatusOnWOOp = new QStringPath(this.withPrefix("MaterialItemStatusOnWOOp"));
    public readonly PartialQuantity = new QNumberPath(this.withPrefix("PartialQuantity"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly ReworkOrder_Id = new QGuidPath(this.withPrefix("ReworkOrder_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ReworkOrder = new QEntityPath(this.withPrefix("ReworkOrder"), () => QWorkOrder);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProducedMaterialUnderReworkFacet);
}

export const qProducedMaterialUnderRework = new QProducedMaterialUnderRework();

export class QProducedMaterialUnderReworkId extends QId<ProducedMaterialUnderReworkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSnagAndNoteNotification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly SnagAndNoteId = new QGuidPath(this.withPrefix("SnagAndNoteId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSnagAndNoteNotificationFacet);
}

export const qSnagAndNoteNotification = new QSnagAndNoteNotification();

export class QSnagAndNoteNotificationId extends QId<SnagAndNoteNotificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceStatusBehavior extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly IsScrap = new QBooleanPath(this.withPrefix("IsScrap"));
    public readonly IsLock = new QBooleanPath(this.withPrefix("IsLock"));
    public readonly IsClosedOk = new QBooleanPath(this.withPrefix("IsClosedOk"));
    public readonly IsRuntimeFrozen = new QBooleanPath(this.withPrefix("IsRuntimeFrozen"));
    public readonly IsSetWckHold = new QBooleanPath(this.withPrefix("IsSetWckHold"));
    public readonly NonConformanceStatus_Id = new QGuidPath(this.withPrefix("NonConformanceStatus_Id"));
    public readonly NonConformanceLifecycle_Id = new QGuidPath(this.withPrefix("NonConformanceLifecycle_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceStatus = new QEntityPath(this.withPrefix("NonConformanceStatus"), () => QNonConformanceStatus);
    public readonly NonConformanceLifecycle = new QEntityPath(this.withPrefix("NonConformanceLifecycle"), () => QNonConformanceLifecycle);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceStatusBehaviorFacet);
}

export const qNonConformanceStatusBehavior = new QNonConformanceStatusBehavior();

export class QNonConformanceStatusBehaviorId extends QId<NonConformanceStatusBehaviorId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceSupervisor = new QGuidPath(this.withPrefix("NonConformanceSupervisor"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Tool_Id = new QGuidPath(this.withPrefix("Tool_Id"));
    public readonly NonConformance_Id = new QGuidPath(this.withPrefix("NonConformance_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QTool);
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformance);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceItemFacet);
}

export const qNonConformanceItem = new QNonConformanceItem();

export class QNonConformanceItemId extends QId<NonConformanceItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeConsumedMaterialPrekitHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
    public readonly DateHistory = new QDateTimeOffsetPath(this.withPrefix("DateHistory"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly PrekitDM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("PrekitDM_MaterialTrackingUnit_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly TargetMaterialItem_Id = new QGuidPath(this.withPrefix("TargetMaterialItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly PrekitDM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("PrekitDM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly TargetMaterialItem = new QEntityPath(this.withPrefix("TargetMaterialItem"), () => QDM_MaterialTrackingUnit);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeConsumedMaterialPrekitHistoryFacet);
}

export const qToBeConsumedMaterialPrekitHistory = new QToBeConsumedMaterialPrekitHistory();

export class QToBeConsumedMaterialPrekitHistoryId extends QId<ToBeConsumedMaterialPrekitHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeConsumedMaterialPrekit extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrekitSerialNumber = new QStringPath(this.withPrefix("PrekitSerialNumber"));
    public readonly PreKitBatchCode = new QStringPath(this.withPrefix("PreKitBatchCode"));
    public readonly ToBeValidated = new QBooleanPath(this.withPrefix("ToBeValidated"));
    public readonly ToBeConsumedMaterial_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterial_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly PrekitMaterialItem_Id = new QGuidPath(this.withPrefix("PrekitMaterialItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeConsumedMaterial = new QEntityPath(this.withPrefix("ToBeConsumedMaterial"), () => QToBeConsumedMaterial);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly PrekitMaterialItem = new QEntityPath(this.withPrefix("PrekitMaterialItem"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeConsumedMaterialPrekitFacet);
}

export const qToBeConsumedMaterialPrekit = new QToBeConsumedMaterialPrekit();

export class QToBeConsumedMaterialPrekitId extends QId<ToBeConsumedMaterialPrekitId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOperationType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Milestone = new QBooleanPath(this.withPrefix("Milestone"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly Skippable = new QBooleanPath(this.withPrefix("Skippable"));
    public readonly ActiveOnlyOne = new QBooleanPath(this.withPrefix("ActiveOnlyOne"));
    public readonly AutoStart = new QBooleanPath(this.withPrefix("AutoStart"));
    public readonly AutoComplete = new QBooleanPath(this.withPrefix("AutoComplete"));
    public readonly MachineAutoStart = new QBooleanPath(this.withPrefix("MachineAutoStart"));
    public readonly MachineAutoComplete = new QBooleanPath(this.withPrefix("MachineAutoComplete"));
    public readonly MachineAutoPause = new QBooleanPath(this.withPrefix("MachineAutoPause"));
    public readonly CNC = new QBooleanPath(this.withPrefix("CNC"));
    public readonly AM = new QBooleanPath(this.withPrefix("AM"));
    public readonly FastOperationConfirmation = new QBooleanPath(this.withPrefix("FastOperationConfirmation"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOperationTypeFacet);
}

export const qWorkOperationType = new QWorkOperationType();

export class QWorkOperationTypeId extends QId<WorkOperationTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionCompatibleMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly ToolDefinition_Id = new QGuidPath(this.withPrefix("ToolDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinition = new QEntityPath(this.withPrefix("ToolDefinition"), () => QToolDefinition);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolDefinitionCompatibleMachineFacet);
}

export const qToolDefinitionCompatibleMachine = new QToolDefinitionCompatibleMachine();

export class QToolDefinitionCompatibleMachineId extends QId<ToolDefinitionCompatibleMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ToolClass = new QNumberPath(this.withPrefix("ToolClass"));
    public readonly ToolClassNId = new QStringPath(this.withPrefix("ToolClassNId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QNumberPath(this.withPrefix("UsageDurationMax"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly RevisionExpression = new QStringPath(this.withPrefix("RevisionExpression"));
    public readonly Volume = new QNumberPath(this.withPrefix("Volume"));
    public readonly VolumeUoM = new QStringPath(this.withPrefix("VolumeUoM"));
    public readonly WeightUoM = new QStringPath(this.withPrefix("WeightUoM"));
    public readonly Weight = new QNumberPath(this.withPrefix("Weight"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly LogisticClass_Id = new QGuidPath(this.withPrefix("LogisticClass_Id"));
    public readonly ToolDefinitionCompatibleMachine = new QEntityCollectionPath(this.withPrefix("ToolDefinitionCompatibleMachine"), () => QToolDefinitionCompatibleMachine);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticClass = new QEntityPath(this.withPrefix("LogisticClass"), () => QLogisticClass);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolDefinitionFacet);
}

export const qToolDefinition = new QToolDefinition();

export class QToolDefinitionId extends QId<ToolDefinitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkill extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSkillFacet);
}

export const qSkill = new QSkill();

export class QSkillId extends QId<SkillId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QReworkCode extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialNId = new QStringPath(this.withPrefix("DM_MaterialNId"));
    public readonly ProcessNId = new QStringPath(this.withPrefix("ProcessNId"));
    public readonly ProcessRevision = new QStringPath(this.withPrefix("ProcessRevision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly ProcessId_Id = new QGuidPath(this.withPrefix("ProcessId_Id"));
    public readonly DefectGroup_Id = new QGuidPath(this.withPrefix("DefectGroup_Id"));
    public readonly DefectType_Id = new QGuidPath(this.withPrefix("DefectType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessId = new QEntityPath(this.withPrefix("ProcessId"), () => QProcess);
    public readonly DefectGroup = new QEntityPath(this.withPrefix("DefectGroup"), () => QDefectGroup);
    public readonly DefectType = new QEntityPath(this.withPrefix("DefectType"), () => QDefectType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QReworkCodeFacet);
}

export const qReworkCode = new QReworkCode();

export class QReworkCodeId extends QId<ReworkCodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceTransition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Lifecycle = new QStringPath(this.withPrefix("Lifecycle"));
    public readonly MailAddressList = new QStringPath(this.withPrefix("MailAddressList"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly AuthorizedRoleList = new QStringPath(this.withPrefix("AuthorizedRoleList"));
    public readonly SendMail = new QNumberPath(this.withPrefix("SendMail"));
    public readonly FromStatus_Id = new QGuidPath(this.withPrefix("FromStatus_Id"));
    public readonly ToStatus_Id = new QGuidPath(this.withPrefix("ToStatus_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FromStatus = new QEntityPath(this.withPrefix("FromStatus"), () => QNonConformanceStatus);
    public readonly ToStatus = new QEntityPath(this.withPrefix("ToStatus"), () => QNonConformanceStatus);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceTransitionFacet);
}

export const qNonConformanceTransition = new QNonConformanceTransition();

export class QNonConformanceTransitionId extends QId<NonConformanceTransitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceStatusFacet);
}

export const qNonConformanceStatus = new QNonConformanceStatus();

export class QNonConformanceStatusId extends QId<NonConformanceStatusId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceSeverity extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Val = new QNumberPath(this.withPrefix("Val"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceSeverityFacet);
}

export const qNonConformanceSeverity = new QNonConformanceSeverity();

export class QNonConformanceSeverityId extends QId<NonConformanceSeverityId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceLifecycle extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly InitialStatus_Id = new QGuidPath(this.withPrefix("InitialStatus_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InitialStatus = new QEntityPath(this.withPrefix("InitialStatus"), () => QNonConformanceStatus);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceLifecycleFacet);
}

export const qNonConformanceLifecycle = new QNonConformanceLifecycle();

export class QNonConformanceLifecycleId extends QId<NonConformanceLifecycleId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Groups = new QEntityCollectionPath(this.withPrefix("Groups"), () => QDefectGroup);
    public readonly DefectSpecifications = new QEntityCollectionPath(this.withPrefix("DefectSpecifications"), () => QDefectSpecification);
    public readonly Defects = new QEntityCollectionPath(this.withPrefix("Defects"), () => QNonConformanceHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDefectTypeFacet);
}

export const qDefectType = new QDefectType();

export class QDefectTypeId extends QId<DefectTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContextNId = new QStringPath(this.withPrefix("ContextNId"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
    public readonly SpecificationNId = new QStringPath(this.withPrefix("SpecificationNId"));
    public readonly SpecificationTypeCode = new QNumberPath(this.withPrefix("SpecificationTypeCode"));
    public readonly DefectType_Id = new QGuidPath(this.withPrefix("DefectType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectType = new QEntityPath(this.withPrefix("DefectType"), () => QDefectType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDefectSpecificationFacet);
}

export const qDefectSpecification = new QDefectSpecification();

export class QDefectSpecificationId extends QId<DefectSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectGroupSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContextNId = new QStringPath(this.withPrefix("ContextNId"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
    public readonly SpecificationNId = new QStringPath(this.withPrefix("SpecificationNId"));
    public readonly SpecificationTypeCode = new QNumberPath(this.withPrefix("SpecificationTypeCode"));
    public readonly DefectGroup_Id = new QGuidPath(this.withPrefix("DefectGroup_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectGroup = new QEntityPath(this.withPrefix("DefectGroup"), () => QDefectGroup);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDefectGroupSpecificationFacet);
}

export const qDefectGroupSpecification = new QDefectGroupSpecification();

export class QDefectGroupSpecificationId extends QId<DefectGroupSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectGroup extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Types = new QEntityCollectionPath(this.withPrefix("Types"), () => QDefectType);
    public readonly DefectGroupSpecifications = new QEntityCollectionPath(this.withPrefix("DefectGroupSpecifications"), () => QDefectGroupSpecification);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentGroups = new QEntityCollectionPath(this.withPrefix("ParentGroups"), () => QDefectGroup);
    public readonly ChildGroups = new QEntityCollectionPath(this.withPrefix("ChildGroups"), () => QDefectGroup);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDefectGroupFacet);
}

export const qDefectGroup = new QDefectGroup();

export class QDefectGroupId extends QId<DefectGroupId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOStepDependency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly To_Id = new QGuidPath(this.withPrefix("To_Id"));
    public readonly WosFrom_Id = new QGuidPath(this.withPrefix("WosFrom_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly To = new QEntityPath(this.withPrefix("To"), () => QWorkOrderStep);
    public readonly WosFrom = new QEntityPath(this.withPrefix("WosFrom"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOStepDependencyFacet);
}

export const qWorkOStepDependency = new QWorkOStepDependency();

export class QWorkOStepDependencyId extends QId<WorkOStepDependencyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderStep extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly LastPauseTime = new QDateTimeOffsetPath(this.withPrefix("LastPauseTime"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly PauseDuration = new QNumberPath(this.withPrefix("PauseDuration"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Step = new QGuidPath(this.withPrefix("Step"));
    public readonly StepNId = new QStringPath(this.withPrefix("StepNId"));
    public readonly StepRevision = new QStringPath(this.withPrefix("StepRevision"));
    public readonly StepUId = new QStringPath(this.withPrefix("StepUId"));
    public readonly WaitingForInspection = new QBooleanPath(this.withPrefix("WaitingForInspection"));
    public readonly TargetQuantity = new QNumberPath(this.withPrefix("TargetQuantity"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly ProducedQuantity = new QNumberPath(this.withPrefix("ProducedQuantity"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly NotWorkedQuantity = new QNumberPath(this.withPrefix("NotWorkedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly ReworkedQuantity = new QNumberPath(this.withPrefix("ReworkedQuantity"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly ExecutionDuration_Ticks = new QNumberPath(this.withPrefix("ExecutionDuration_Ticks"));
    public readonly ExecutionDuration = new QStringPath(this.withPrefix("ExecutionDuration"));
    public readonly IsReady = new QBooleanPath(this.withPrefix("IsReady"));
    public readonly OperationStepCategoryId_Id = new QGuidPath(this.withPrefix("OperationStepCategoryId_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly WorkOrderHumanResource = new QEntityCollectionPath(this.withPrefix("WorkOrderHumanResource"), () => QWorkOrderHumanResource);
    public readonly ActualCoProducedMaterials = new QEntityCollectionPath(this.withPrefix("ActualCoProducedMaterials"), () => QActualCoProducedMaterial);
    public readonly ToBeCoProducedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeCoProducedMaterials"), () => QToBeCoProducedMaterial);
    public readonly WorkOrderStepSkills = new QEntityCollectionPath(this.withPrefix("WorkOrderStepSkills"), () => QWorkOrderStepSkill);
    public readonly WIDefinitionToWOStepAssociation = new QEntityCollectionPath(this.withPrefix("WIDefinitionToWOStepAssociation"), () => QWIDefinitionToWOStepAssociation);
    public readonly WorkInstructionToWOStepAssociation = new QEntityCollectionPath(this.withPrefix("WorkInstructionToWOStepAssociation"), () => QWorkInstructionToWorkOrderStepAssociation);
    public readonly ToBeUsedInspection = new QEntityCollectionPath(this.withPrefix("ToBeUsedInspection"), () => QToBeUsedInspection);
    public readonly ActualUsedInspection = new QEntityCollectionPath(this.withPrefix("ActualUsedInspection"), () => QActualUsedInspection);
    public readonly ItlkCheckWOStepAssociations = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociations"), () => QItlkCheckWOStepAssociation);
    public readonly ActualCollectedDocuments = new QEntityCollectionPath(this.withPrefix("ActualCollectedDocuments"), () => QActualCollectedDocument);
    public readonly Predecessors = new QEntityCollectionPath(this.withPrefix("Predecessors"), () => QWorkOStepDependency);
    public readonly Successors = new QEntityCollectionPath(this.withPrefix("Successors"), () => QWorkOStepDependency);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationStepCategoryId = new QEntityPath(this.withPrefix("OperationStepCategoryId"), () => QOperationStepCategory);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly ToBeUsedTools = new QEntityCollectionPath(this.withPrefix("ToBeUsedTools"), () => QToBeUsedTool);
    public readonly ToBeUsedDocuments = new QEntityCollectionPath(this.withPrefix("ToBeUsedDocuments"), () => QToBeUsedDocument);
    public readonly ToBeProducedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeProducedMaterials"), () => QToBeProducedMaterial);
    public readonly ToBeConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeConsumedMaterials"), () => QToBeConsumedMaterial);
    public readonly ActualUsedTools = new QEntityCollectionPath(this.withPrefix("ActualUsedTools"), () => QActualUsedTool);
    public readonly ActualUsedMachines = new QEntityCollectionPath(this.withPrefix("ActualUsedMachines"), () => QActualUsedMachine);
    public readonly ActualProducedMaterials = new QEntityCollectionPath(this.withPrefix("ActualProducedMaterials"), () => QActualProducedMaterial);
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QActualConsumedMaterial);
    public readonly ActiveUserOnMachines = new QEntityCollectionPath(this.withPrefix("ActiveUserOnMachines"), () => QActiveUserOnMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderStepFacet);
}

export const qWorkOrderStep = new QWorkOrderStep();

export class QWorkOrderStepId extends QId<WorkOrderStepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActiveNonConformanceNr = new QNumberPath(this.withPrefix("ActiveNonConformanceNr"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly LastPauseTime = new QDateTimeOffsetPath(this.withPrefix("LastPauseTime"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly OperationRevision = new QStringPath(this.withPrefix("OperationRevision"));
    public readonly OperationUId = new QStringPath(this.withPrefix("OperationUId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly ProducedQuantity = new QNumberPath(this.withPrefix("ProducedQuantity"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly ReworkedQuantity = new QNumberPath(this.withPrefix("ReworkedQuantity"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly TargetQuantity = new QNumberPath(this.withPrefix("TargetQuantity"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly OperationOccurrenceUId = new QStringPath(this.withPrefix("OperationOccurrenceUId"));
    public readonly ERPConfirmationId = new QStringPath(this.withPrefix("ERPConfirmationId"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly ExecutionDuration_Ticks = new QNumberPath(this.withPrefix("ExecutionDuration_Ticks"));
    public readonly ExecutionDuration = new QStringPath(this.withPrefix("ExecutionDuration"));
    public readonly PauseDuration_Ticks = new QNumberPath(this.withPrefix("PauseDuration_Ticks"));
    public readonly PauseDuration = new QStringPath(this.withPrefix("PauseDuration"));
    public readonly IsReady = new QBooleanPath(this.withPrefix("IsReady"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Skippable = new QBooleanPath(this.withPrefix("Skippable"));
    public readonly WaitingForInspection = new QBooleanPath(this.withPrefix("WaitingForInspection"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly WorkOperationType_Id = new QGuidPath(this.withPrefix("WorkOperationType_Id"));
    public readonly OperationStepCategoryId_Id = new QGuidPath(this.withPrefix("OperationStepCategoryId_Id"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly PreviousStatus = new QEntityPath(this.withPrefix("PreviousStatus"), () => QStatusType);
    public readonly ToBeUsedSetPointItemATNInstanceAssociations = new QEntityCollectionPath(this.withPrefix("ToBeUsedSetPointItemATNInstanceAssociations"), () => QToBeUsedSetPointItemATNInstanceAssociation);
    public readonly WorkOrderHumanResource = new QEntityCollectionPath(this.withPrefix("WorkOrderHumanResource"), () => QWorkOrderHumanResource);
    public readonly ActualCoProducedMaterials = new QEntityCollectionPath(this.withPrefix("ActualCoProducedMaterials"), () => QActualCoProducedMaterial);
    public readonly ToBeCoProducedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeCoProducedMaterials"), () => QToBeCoProducedMaterial);
    public readonly AssociatedUsers = new QEntityCollectionPath(this.withPrefix("AssociatedUsers"), () => QUserWorkOrderOperationAssociation);
    public readonly ToBeUsedInspection = new QEntityCollectionPath(this.withPrefix("ToBeUsedInspection"), () => QToBeUsedInspection);
    public readonly ActualUsedInspection = new QEntityCollectionPath(this.withPrefix("ActualUsedInspection"), () => QActualUsedInspection);
    public readonly ItlkCheckWOOpAssociations = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociations"), () => QItlkCheckWOOpAssociation);
    public readonly WorkOrderOperationSkill = new QEntityCollectionPath(this.withPrefix("WorkOrderOperationSkill"), () => QWorkOrderOperationSkill);
    public readonly ActualCollectedDocuments = new QEntityCollectionPath(this.withPrefix("ActualCollectedDocuments"), () => QActualCollectedDocument);
    public readonly WIDefinitionToWOOperationAssociation = new QEntityCollectionPath(this.withPrefix("WIDefinitionToWOOperationAssociation"), () => QWIDefinitionToWOOperationAssociation);
    public readonly ExecutionGroupPhaseWOOAssociation = new QEntityCollectionPath(this.withPrefix("ExecutionGroupPhaseWOOAssociation"), () => QExecutionGroupPhaseWOOAssociation);
    public readonly WorkInstructionToWorkOOAssociation = new QEntityCollectionPath(this.withPrefix("WorkInstructionToWorkOOAssociation"), () => QWorkInstructionToWorkOrderOperationAssociation);
    public readonly ProducedMaterialUnderRework = new QEntityCollectionPath(this.withPrefix("ProducedMaterialUnderRework"), () => QProducedMaterialUnderRework);
    public readonly WorkOrderSteps = new QEntityCollectionPath(this.withPrefix("WorkOrderSteps"), () => QWorkOrderStep);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly WorkOperationType = new QEntityPath(this.withPrefix("WorkOperationType"), () => QWorkOperationType);
    public readonly OperationStepCategoryId = new QEntityPath(this.withPrefix("OperationStepCategoryId"), () => QOperationStepCategory);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
    public readonly Successors = new QEntityCollectionPath(this.withPrefix("Successors"), () => QWorkOOperationDependency);
    public readonly Predecessors = new QEntityCollectionPath(this.withPrefix("Predecessors"), () => QWorkOOperationDependency);
    public readonly ToBeUsedTools = new QEntityCollectionPath(this.withPrefix("ToBeUsedTools"), () => QToBeUsedTool);
    public readonly ToBeUsedMachines = new QEntityCollectionPath(this.withPrefix("ToBeUsedMachines"), () => QToBeUsedMachine);
    public readonly ToBeUsedDocuments = new QEntityCollectionPath(this.withPrefix("ToBeUsedDocuments"), () => QToBeUsedDocument);
    public readonly ToBeProducedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeProducedMaterials"), () => QToBeProducedMaterial);
    public readonly ToBeConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeConsumedMaterials"), () => QToBeConsumedMaterial);
    public readonly NonConformances = new QEntityCollectionPath(this.withPrefix("NonConformances"), () => QNonConformance);
    public readonly ActualUsedTools = new QEntityCollectionPath(this.withPrefix("ActualUsedTools"), () => QActualUsedTool);
    public readonly ActualUsedMachines = new QEntityCollectionPath(this.withPrefix("ActualUsedMachines"), () => QActualUsedMachine);
    public readonly ActualProducedMaterials = new QEntityCollectionPath(this.withPrefix("ActualProducedMaterials"), () => QActualProducedMaterial);
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QActualConsumedMaterial);
    public readonly ActiveUserOnMachines = new QEntityCollectionPath(this.withPrefix("ActiveUserOnMachines"), () => QActiveUserOnMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderOperationFacet);
}

export const qWorkOrderOperation = new QWorkOrderOperation();

export class QWorkOrderOperationId extends QId<WorkOrderOperationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderHistoryMaterialItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrderHistory_Id = new QGuidPath(this.withPrefix("WorkOrderHistory_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderHistory = new QEntityPath(this.withPrefix("WorkOrderHistory"), () => QWorkOrderHistory);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderHistoryMaterialItemFacet);
}

export const qWorkOrderHistoryMaterialItem = new QWorkOrderHistoryMaterialItem();

export class QWorkOrderHistoryMaterialItemId extends QId<WorkOrderHistoryMaterialItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderHistoryActionFacet);
}

export const qWorkOrderHistoryAction = new QWorkOrderHistoryAction();

export class QWorkOrderHistoryActionId extends QId<WorkOrderHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly DNCItem = new QStringPath(this.withPrefix("DNCItem"));
    public readonly Document = new QStringPath(this.withPrefix("Document"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly PrintJobFile = new QStringPath(this.withPrefix("PrintJobFile"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly BaseLine = new QStringPath(this.withPrefix("BaseLine"));
    public readonly OldBaseLine = new QStringPath(this.withPrefix("OldBaseLine"));
    public readonly SourceWorkOrderNId = new QStringPath(this.withPrefix("SourceWorkOrderNId"));
    public readonly TargetWorkOrderNId = new QStringPath(this.withPrefix("TargetWorkOrderNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly PartProgramName = new QStringPath(this.withPrefix("PartProgramName"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Team_Id = new QGuidPath(this.withPrefix("Team_Id"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly ReferencedWorkOrderHistory_Id = new QGuidPath(this.withPrefix("ReferencedWorkOrderHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Team = new QEntityPath(this.withPrefix("Team"), () => QTeam);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QWorkOrderHistoryAction);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
    public readonly ReferencedWorkOrderHistory = new QEntityPath(this.withPrefix("ReferencedWorkOrderHistory"), () => QWorkOrderHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderHistoryFacet);
}

export const qWorkOrderHistory = new QWorkOrderHistory();

export class QWorkOrderHistoryId extends QId<WorkOrderHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrder extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ParentBatch = new QStringPath(this.withPrefix("ParentBatch"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly AsPlanned = new QGuidPath(this.withPrefix("AsPlanned"));
    public readonly CreationDate = new QDateTimeOffsetPath(this.withPrefix("CreationDate"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly InitialQuantity = new QNumberPath(this.withPrefix("InitialQuantity"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ProcessNId = new QStringPath(this.withPrefix("ProcessNId"));
    public readonly ProcessRevision = new QStringPath(this.withPrefix("ProcessRevision"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly SchedulingDate = new QDateTimeOffsetPath(this.withPrefix("SchedulingDate"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ConfigurationParameter = new QStringPath(this.withPrefix("ConfigurationParameter"));
    public readonly RoutingID = new QStringPath(this.withPrefix("RoutingID"));
    public readonly TargetProductID = new QStringPath(this.withPrefix("TargetProductID"));
    public readonly PlannedTargetQuantity = new QNumberPath(this.withPrefix("PlannedTargetQuantity"));
    public readonly ActualTargetQuantity = new QNumberPath(this.withPrefix("ActualTargetQuantity"));
    public readonly TargetQuantity = new QNumberPath(this.withPrefix("TargetQuantity"));
    public readonly ConfirmationType = new QStringPath(this.withPrefix("ConfirmationType"));
    public readonly RealInitialQty = new QNumberPath(this.withPrefix("RealInitialQty"));
    public readonly PoC = new QNumberPath(this.withPrefix("PoC"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly IsUnderScheduling = new QBooleanPath(this.withPrefix("IsUnderScheduling"));
    public readonly ProducedQuantity = new QNumberPath(this.withPrefix("ProducedQuantity"));
    public readonly ReworkedQuantity = new QNumberPath(this.withPrefix("ReworkedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly Process_Id = new QGuidPath(this.withPrefix("Process_Id"));
    public readonly FinalMaterial_Id = new QGuidPath(this.withPrefix("FinalMaterial_Id"));
    public readonly ToBeUsedBillOfFeature_Id = new QGuidPath(this.withPrefix("ToBeUsedBillOfFeature_Id"));
    public readonly ReworkOfOrder_Id = new QGuidPath(this.withPrefix("ReworkOfOrder_Id"));
    public readonly ParentOrder_Id = new QGuidPath(this.withPrefix("ParentOrder_Id"));
    public readonly ProductionType_Id = new QGuidPath(this.withPrefix("ProductionType_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly PreviousStatus = new QEntityPath(this.withPrefix("PreviousStatus"), () => QStatusType);
    public readonly ToBeUsedBoM = new QEntityPath(this.withPrefix("ToBeUsedBoM"), () => QBoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types);
    public readonly ProducedMaterialUnderRework = new QEntityCollectionPath(this.withPrefix("ProducedMaterialUnderRework"), () => QProducedMaterialUnderRework);
    public readonly WorkOrderOperations = new QEntityCollectionPath(this.withPrefix("WorkOrderOperations"), () => QWorkOrderOperation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Process = new QEntityPath(this.withPrefix("Process"), () => QProcess);
    public readonly FinalMaterial = new QEntityPath(this.withPrefix("FinalMaterial"), () => QDM_Material);
    public readonly ToBeUsedBillOfFeature = new QEntityPath(this.withPrefix("ToBeUsedBillOfFeature"), () => QToBeUsedBillOfFeature);
    public readonly ReworkOfOrder = new QEntityPath(this.withPrefix("ReworkOfOrder"), () => QWorkOrder);
    public readonly ParentOrder = new QEntityPath(this.withPrefix("ParentOrder"), () => QWorkOrder);
    public readonly ChildOrders = new QEntityCollectionPath(this.withPrefix("ChildOrders"), () => QWorkOrder);
    public readonly ProductionType = new QEntityPath(this.withPrefix("ProductionType"), () => QProductionType);
    public readonly ProducedMaterialItems = new QEntityCollectionPath(this.withPrefix("ProducedMaterialItems"), () => QProducedMaterialItem);
    public readonly NonConformanceSupervisors = new QEntityCollectionPath(this.withPrefix("NonConformanceSupervisors"), () => QNonConformanceSupervisor);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderFacet);
}

export const qWorkOrder = new QWorkOrder();

export class QWorkOrderId extends QId<WorkOrderId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOOperationDependency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly PartialCompleted = new QBooleanPath(this.withPrefix("PartialCompleted"));
    public readonly FromWOO_Id = new QGuidPath(this.withPrefix("FromWOO_Id"));
    public readonly ToWOO_Id = new QGuidPath(this.withPrefix("ToWOO_Id"));
    public readonly WOOpDependencyNavigations = new QEntityCollectionPath(this.withPrefix("WOOpDependencyNavigations"), () => QWOOpDependencyNavigation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FromWOO = new QEntityPath(this.withPrefix("FromWOO"), () => QWorkOrderOperation);
    public readonly ToWOO = new QEntityPath(this.withPrefix("ToWOO"), () => QWorkOrderOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOOperationDependencyFacet);
}

export const qWorkOOperationDependency = new QWorkOOperationDependency();

export class QWorkOOperationDependencyId extends QId<WorkOOperationDependencyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolHistoryActionFacet);
}

export const qToolHistoryAction = new QToolHistoryAction();

export class QToolHistoryActionId extends QId<ToolHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly OldThickness = new QNumberPath(this.withPrefix("OldThickness"));
    public readonly OldTreatmentCount = new QNumberPath(this.withPrefix("OldTreatmentCount"));
    public readonly Thickness = new QNumberPath(this.withPrefix("Thickness"));
    public readonly TreatmentCount = new QNumberPath(this.withPrefix("TreatmentCount"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly UsageDuration_Ticks = new QNumberPath(this.withPrefix("UsageDuration_Ticks"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly UsedToolCount = new QNumberPath(this.withPrefix("UsedToolCount"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly NonConformance_Id = new QGuidPath(this.withPrefix("NonConformance_Id"));
    public readonly Tool_Id = new QGuidPath(this.withPrefix("Tool_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QToolHistoryAction);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformance);
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QTool);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolHistoryFacet);
}

export const qToolHistory = new QToolHistory();

export class QToolHistoryId extends QId<ToolHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolCompatibleMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Machine = new QStringPath(this.withPrefix("Machine"));
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly Tool_Id = new QGuidPath(this.withPrefix("Tool_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QTool);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolCompatibleMachineFacet);
}

export const qToolCompatibleMachine = new QToolCompatibleMachine();

export class QToolCompatibleMachineId extends QId<ToolCompatibleMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly UsageCounter = new QNumberPath(this.withPrefix("UsageCounter"));
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ActiveNonConformanceNr = new QNumberPath(this.withPrefix("ActiveNonConformanceNr"));
    public readonly IsScrap = new QBooleanPath(this.withPrefix("IsScrap"));
    public readonly IsLock = new QBooleanPath(this.withPrefix("IsLock"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly IsRuntimeFrozen = new QBooleanPath(this.withPrefix("IsRuntimeFrozen"));
    public readonly UsageDuration_Ticks = new QNumberPath(this.withPrefix("UsageDuration_Ticks"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly UsageDurationMax_Ticks = new QNumberPath(this.withPrefix("UsageDurationMax_Ticks"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ToolDefinition_Id = new QGuidPath(this.withPrefix("ToolDefinition_Id"));
    public readonly ToolHistoryList = new QEntityCollectionPath(this.withPrefix("ToolHistoryList"), () => QToolHistory);
    public readonly ToolCompatibleMachine = new QEntityCollectionPath(this.withPrefix("ToolCompatibleMachine"), () => QToolCompatibleMachine);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinition = new QEntityPath(this.withPrefix("ToolDefinition"), () => QToolDefinition);
    public readonly Tools = new QEntityCollectionPath(this.withPrefix("Tools"), () => QNonConformanceHistory);
    public readonly ActualUsedTools = new QEntityCollectionPath(this.withPrefix("ActualUsedTools"), () => QActualUsedTool);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolFacet);
}

export const qTool = new QTool();

export class QToolId extends QId<ToolId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly ToolDefinition_Id = new QGuidPath(this.withPrefix("ToolDefinition_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinition = new QEntityPath(this.withPrefix("ToolDefinition"), () => QToolDefinition);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ActualUsedTools = new QEntityCollectionPath(this.withPrefix("ActualUsedTools"), () => QActualUsedTool);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedToolFacet);
}

export const qToBeUsedTool = new QToBeUsedTool();

export class QToBeUsedToolId extends QId<ToBeUsedToolId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Machine = new QStringPath(this.withPrefix("Machine"));
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly ActualUsedMachine = new QEntityCollectionPath(this.withPrefix("ActualUsedMachine"), () => QActualUsedMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedMachineFacet);
}

export const qToBeUsedMachine = new QToBeUsedMachine();

export class QToBeUsedMachineId extends QId<ToBeUsedMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentType = new QStringPath(this.withPrefix("DocumentType"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeUsedDocumentFacet);
}

export const qToBeUsedDocument = new QToBeUsedDocument();

export class QToBeUsedDocumentId extends QId<ToBeUsedDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeProducedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ActualProducedMaterial = new QEntityCollectionPath(this.withPrefix("ActualProducedMaterial"), () => QActualProducedMaterial);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeProducedMaterialFacet);
}

export const qToBeProducedMaterial = new QToBeProducedMaterial();

export class QToBeProducedMaterialId extends QId<ToBeProducedMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeConsumedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly DCDRuntimeTask = new QStringPath(this.withPrefix("DCDRuntimeTask"));
    public readonly DCDTask = new QStringPath(this.withPrefix("DCDTask"));
    public readonly FAIRuntimeTask = new QStringPath(this.withPrefix("FAIRuntimeTask"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly PrekitSerialNumber = new QStringPath(this.withPrefix("PrekitSerialNumber"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly OccurenceId = new QStringPath(this.withPrefix("OccurenceId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly MaterialDefinition_Id = new QGuidPath(this.withPrefix("MaterialDefinition_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly PrekitSerialNumberList = new QEntityCollectionPath(this.withPrefix("PrekitSerialNumberList"), () => QToBeConsumedMaterialPrekit);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialDefinition = new QEntityPath(this.withPrefix("MaterialDefinition"), () => QDM_Material);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QActualConsumedMaterial);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToBeConsumedMaterialFacet);
}

export const qToBeConsumedMaterial = new QToBeConsumedMaterial();

export class QToBeConsumedMaterialId extends QId<ToBeConsumedMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkipReason extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSkipReasonFacet);
}

export const qSkipReason = new QSkipReason();

export class QSkipReasonId extends QId<SkipReasonId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProductionType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProductionTypeFacet);
}

export const qProductionType = new QProductionType();

export class QProductionTypeId extends QId<ProductionTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProducedMaterialItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
    public readonly ActualConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ActualConsumedMaterials"), () => QActualConsumedMaterial);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProducedMaterialItemFacet);
}

export const qProducedMaterialItem = new QProducedMaterialItem();

export class QProducedMaterialItemId extends QId<ProducedMaterialItemId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPauseReason extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Location = new QStringPath(this.withPrefix("Location"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QPauseReasonFacet);
}

export const qPauseReason = new QPauseReason();

export class QPauseReasonId extends QId<PauseReasonId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceSupervisor extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Defect = new QStringPath(this.withPrefix("Defect"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceSupervisorFacet);
}

export const qNonConformanceSupervisor = new QNonConformanceSupervisor();

export class QNonConformanceSupervisorId extends QId<NonConformanceSupervisorId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceResource extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Operation = new QStringPath(this.withPrefix("Operation"));
    public readonly ResourceId = new QStringPath(this.withPrefix("ResourceId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly NonConformanceHistory_Id = new QGuidPath(this.withPrefix("NonConformanceHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceHistory = new QEntityPath(this.withPrefix("NonConformanceHistory"), () => QNonConformanceHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceResourceFacet);
}

export const qNonConformanceResource = new QNonConformanceResource();

export class QNonConformanceResourceId extends QId<NonConformanceResourceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Transition = new QStringPath(this.withPrefix("Transition"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Action = new QStringPath(this.withPrefix("Action"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly PreviousSeverity = new QStringPath(this.withPrefix("PreviousSeverity"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Defect_Id = new QGuidPath(this.withPrefix("Defect_Id"));
    public readonly Tool_Id = new QGuidPath(this.withPrefix("Tool_Id"));
    public readonly MaterialItem_Id = new QGuidPath(this.withPrefix("MaterialItem_Id"));
    public readonly NonConformance_Id = new QGuidPath(this.withPrefix("NonConformance_Id"));
    public readonly Resources = new QEntityCollectionPath(this.withPrefix("Resources"), () => QNonConformanceResource);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Defect = new QEntityPath(this.withPrefix("Defect"), () => QDefectType);
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QTool);
    public readonly MaterialItem = new QEntityPath(this.withPrefix("MaterialItem"), () => QDM_MaterialTrackingUnit);
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformance);
    public readonly Attachments = new QEntityCollectionPath(this.withPrefix("Attachments"), () => QNonConformanceAttachment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceHistoryFacet);
}

export const qNonConformanceHistory = new QNonConformanceHistory();

export class QNonConformanceHistoryId extends QId<NonConformanceHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceAttachment extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly NonConformanceHistory_Id = new QGuidPath(this.withPrefix("NonConformanceHistory_Id"));
    public readonly Nonconformance_Id = new QGuidPath(this.withPrefix("Nonconformance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly NonConformanceHistory = new QEntityPath(this.withPrefix("NonConformanceHistory"), () => QNonConformanceHistory);
    public readonly Nonconformance = new QEntityPath(this.withPrefix("Nonconformance"), () => QNonConformance);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceAttachmentFacet);
}

export const qNonConformanceAttachment = new QNonConformanceAttachment();

export class QNonConformanceAttachmentId extends QId<NonConformanceAttachmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSnagAndNote extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly OpenDate = new QStringPath(this.withPrefix("OpenDate"));
    public readonly OpenDateTime = new QDateTimeOffsetPath(this.withPrefix("OpenDateTime"));
    public readonly OpenUser = new QStringPath(this.withPrefix("OpenUser"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly CloseDate = new QStringPath(this.withPrefix("CloseDate"));
    public readonly CloseDateTime = new QDateTimeOffsetPath(this.withPrefix("CloseDateTime"));
    public readonly CloseUser = new QStringPath(this.withPrefix("CloseUser"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly IsWorkOrderLevel = new QBooleanPath(this.withPrefix("IsWorkOrderLevel"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSnagAndNoteFacet);
}

export const qSnagAndNote = new QSnagAndNote();

export class QSnagAndNoteId extends QId<SnagAndNoteId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EndDate = new QDateTimeOffsetPath(this.withPrefix("EndDate"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly NonConformanceLifecycle = new QStringPath(this.withPrefix("NonConformanceLifecycle"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly StartDate = new QDateTimeOffsetPath(this.withPrefix("StartDate"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly InspectedQuantity = new QNumberPath(this.withPrefix("InspectedQuantity"));
    public readonly MaterialDefinition = new QStringPath(this.withPrefix("MaterialDefinition"));
    public readonly NonConformanceQuantity = new QNumberPath(this.withPrefix("NonConformanceQuantity"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly ToolDefinition = new QStringPath(this.withPrefix("ToolDefinition"));
    public readonly ParentNonConformanceNId = new QStringPath(this.withPrefix("ParentNonConformanceNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly ChangeType_Id = new QGuidPath(this.withPrefix("ChangeType_Id"));
    public readonly NonConformanceItems = new QEntityCollectionPath(this.withPrefix("NonConformanceItems"), () => QNonConformanceItem);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrder = new QEntityPath(this.withPrefix("WorkOrder"), () => QWorkOrder);
    public readonly ChangeType = new QEntityPath(this.withPrefix("ChangeType"), () => QChangeType);
    public readonly Defects = new QEntityCollectionPath(this.withPrefix("Defects"), () => QDefect);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceFacet);
}

export const qNonConformance = new QNonConformance();

export class QNonConformanceId extends QId<NonConformanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHoldReason extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHoldReasonFacet);
}

export const qHoldReason = new QHoldReason();

export class QHoldReasonId extends QId<HoldReasonId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHold extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CloseComment = new QStringPath(this.withPrefix("CloseComment"));
    public readonly CloseTime = new QDateTimeOffsetPath(this.withPrefix("CloseTime"));
    public readonly CloseUserId = new QStringPath(this.withPrefix("CloseUserId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly FutureHoldId = new QStringPath(this.withPrefix("FutureHoldId"));
    public readonly IsPresent = new QBooleanPath(this.withPrefix("IsPresent"));
    public readonly OpenTime = new QDateTimeOffsetPath(this.withPrefix("OpenTime"));
    public readonly OpenUserId = new QStringPath(this.withPrefix("OpenUserId"));
    public readonly PreviousState = new QStringPath(this.withPrefix("PreviousState"));
    public readonly ReasonId = new QGuidPath(this.withPrefix("ReasonId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly TypeNId = new QStringPath(this.withPrefix("TypeNId"));
    public readonly HoldReason_Id = new QGuidPath(this.withPrefix("HoldReason_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HoldReason = new QEntityPath(this.withPrefix("HoldReason"), () => QHoldReason);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QHoldFacet);
}

export const qHold = new QHold();

export class QHoldId extends QId<HoldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFutureHold extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CloseTime = new QDateTimeOffsetPath(this.withPrefix("CloseTime"));
    public readonly CloseUserId = new QStringPath(this.withPrefix("CloseUserId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly IsPresent = new QBooleanPath(this.withPrefix("IsPresent"));
    public readonly Lifecycle = new QStringPath(this.withPrefix("Lifecycle"));
    public readonly OpenTime = new QDateTimeOffsetPath(this.withPrefix("OpenTime"));
    public readonly OpenUserId = new QStringPath(this.withPrefix("OpenUserId"));
    public readonly PreviousStatus = new QStringPath(this.withPrefix("PreviousStatus"));
    public readonly ReasonId = new QStringPath(this.withPrefix("ReasonId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QFutureHoldFacet);
}

export const qFutureHold = new QFutureHold();

export class QFutureHoldId extends QId<FutureHoldId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefect extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly GroupPath = new QStringPath(this.withPrefix("GroupPath"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly DefectType_Id = new QGuidPath(this.withPrefix("DefectType_Id"));
    public readonly NonConformance_Id = new QGuidPath(this.withPrefix("NonConformance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectType = new QEntityPath(this.withPrefix("DefectType"), () => QDefectType);
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformance);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDefectFacet);
}

export const qDefect = new QDefect();

export class QDefectId extends QId<DefectId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QChangeType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Groupp = new QStringPath(this.withPrefix("Groupp"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QChangeTypeFacet);
}

export const qChangeType = new QChangeType();

export class QChangeTypeId extends QId<ChangeTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMSubstrateLifecycle extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAMSubstrateLifecycleFacet);
}

export const qAMSubstrateLifecycle = new QAMSubstrateLifecycle();

export class QAMSubstrateLifecycleId extends QId<AMSubstrateLifecycleId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMPowderLifecycle extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAMPowderLifecycleFacet);
}

export const qAMPowderLifecycle = new QAMPowderLifecycle();

export class QAMPowderLifecycleId extends QId<AMPowderLifecycleId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualUsageCounter = new QNumberPath(this.withPrefix("ActualUsageCounter"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly UsedTimes = new QNumberPath(this.withPrefix("UsedTimes"));
    public readonly ToolDefinition_Id = new QGuidPath(this.withPrefix("ToolDefinition_Id"));
    public readonly ToBeUsedTool_Id = new QGuidPath(this.withPrefix("ToBeUsedTool_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly Tool_Id = new QGuidPath(this.withPrefix("Tool_Id"));
    public readonly ProducedDM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("ProducedDM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinition = new QEntityPath(this.withPrefix("ToolDefinition"), () => QToolDefinition);
    public readonly ToBeUsedTool = new QEntityPath(this.withPrefix("ToBeUsedTool"), () => QToBeUsedTool);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QTool);
    public readonly ProducedDM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("ProducedDM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualUsedToolFacet);
}

export const qActualUsedTool = new QActualUsedTool();

export class QActualUsedToolId extends QId<ActualUsedToolId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Machine = new QStringPath(this.withPrefix("Machine"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly WorkOrderOperations_Id = new QGuidPath(this.withPrefix("WorkOrderOperations_Id"));
    public readonly ToBeUsedMachine_Id = new QGuidPath(this.withPrefix("ToBeUsedMachine_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperations = new QEntityPath(this.withPrefix("WorkOrderOperations"), () => QWorkOrderOperation);
    public readonly ToBeUsedMachine = new QEntityPath(this.withPrefix("ToBeUsedMachine"), () => QToBeUsedMachine);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualUsedMachineFacet);
}

export const qActualUsedMachine = new QActualUsedMachine();

export class QActualUsedMachineId extends QId<ActualUsedMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualProducedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly NotWorkedQuantity = new QNumberPath(this.withPrefix("NotWorkedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly PausedQuantity = new QNumberPath(this.withPrefix("PausedQuantity"));
    public readonly ReopenedQuantity = new QNumberPath(this.withPrefix("ReopenedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly SentencedQuantity = new QNumberPath(this.withPrefix("SentencedQuantity"));
    public readonly SplitQuantity = new QNumberPath(this.withPrefix("SplitQuantity"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WaitingForQualityQuantity = new QNumberPath(this.withPrefix("WaitingForQualityQuantity"));
    public readonly UnderQualityInspectionQuantity = new QNumberPath(this.withPrefix("UnderQualityInspectionQuantity"));
    public readonly WorkOrderOperations_Id = new QGuidPath(this.withPrefix("WorkOrderOperations_Id"));
    public readonly ToBeProducedMaterial_Id = new QGuidPath(this.withPrefix("ToBeProducedMaterial_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperations = new QEntityPath(this.withPrefix("WorkOrderOperations"), () => QWorkOrderOperation);
    public readonly ToBeProducedMaterial = new QEntityPath(this.withPrefix("ToBeProducedMaterial"), () => QToBeProducedMaterial);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualProducedMaterialFacet);
}

export const qActualProducedMaterial = new QActualProducedMaterial();

export class QActualProducedMaterialId extends QId<ActualProducedMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualConsumedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ConsumptionDateTime = new QDateTimeOffsetPath(this.withPrefix("ConsumptionDateTime"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ProducedMaterialItem_Id = new QGuidPath(this.withPrefix("ProducedMaterialItem_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly ToBeConsumedMaterial_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterial_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProducedMaterialItem = new QEntityPath(this.withPrefix("ProducedMaterialItem"), () => QProducedMaterialItem);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly ToBeConsumedMaterial = new QEntityPath(this.withPrefix("ToBeConsumedMaterial"), () => QToBeConsumedMaterial);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
    public readonly ExecutionGroupPhase = new QEntityPath(this.withPrefix("ExecutionGroupPhase"), () => QExecutionGroupPhase);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActualConsumedMaterialFacet);
}

export const qActualConsumedMaterial = new QActualConsumedMaterial();

export class QActualConsumedMaterialId extends QId<ActualConsumedMaterialId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActiveUserOnMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
    public readonly ExecutionGroupPhase = new QEntityPath(this.withPrefix("ExecutionGroupPhase"), () => QExecutionGroupPhase);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QActiveUserOnMachineFacet);
}

export const qActiveUserOnMachine = new QActiveUserOnMachine();

export class QActiveUserOnMachineId extends QId<ActiveUserOnMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderNotification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderStatus = new QStringPath(this.withPrefix("WorkOrderStatus"));
    public readonly WorkOrderFinalMaterial = new QStringPath(this.withPrefix("WorkOrderFinalMaterial"));
    public readonly WorkOrderEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("WorkOrderEstimatedStartTime"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QWorkOrderNotificationFacet);
}

export const qWorkOrderNotification = new QWorkOrderNotification();

export class QWorkOrderNotificationId extends QId<WorkOrderNotificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessNotification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessNId = new QStringPath(this.withPrefix("ProcessNId"));
    public readonly ProcessRevision = new QStringPath(this.withPrefix("ProcessRevision"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly ProcessName = new QStringPath(this.withPrefix("ProcessName"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessNotificationFacet);
}

export const qProcessNotification = new QProcessNotification();

export class QProcessNotificationId extends QId<ProcessNotificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QConfigurationKeyMultiValue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Val = new QStringPath(this.withPrefix("Val"));
    public readonly ConfigurationKey_Id = new QGuidPath(this.withPrefix("ConfigurationKey_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ConfigurationKey = new QEntityPath(this.withPrefix("ConfigurationKey"), () => QConfigurationKey);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QConfigurationKeyMultiValueFacet);
}

export const qConfigurationKeyMultiValue = new QConfigurationKeyMultiValue();

export class QConfigurationKeyMultiValueId extends QId<ConfigurationKeyMultiValueId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BuildtrayLayout = new QStringPath(this.withPrefix("BuildtrayLayout"));
    public readonly ExternalId = new QStringPath(this.withPrefix("ExternalId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly ProductSerializable = new QBooleanPath(this.withPrefix("ProductSerializable"));
    public readonly ProductSerialNumberManagement = new QEnumPath(this.withPrefix("ProductSerialNumberManagement"), AMSerialNumberManagement);
    public readonly RunTimeOnly = new QBooleanPath(this.withPrefix("RunTimeOnly"));
    public readonly Source = new QStringPath(this.withPrefix("Source"));
    public readonly TestBars = new QBooleanPath(this.withPrefix("TestBars"));
    public readonly TestBarsNumber = new QNumberPath(this.withPrefix("TestBarsNumber"));
    public readonly TestBarsSerializable = new QBooleanPath(this.withPrefix("TestBarsSerializable"));
    public readonly TestBarsSerialNumberManagement = new QEnumPath(this.withPrefix("TestBarsSerialNumberManagement"), AMSerialNumberManagement);
    public readonly ProductionPrinter = new QStringPath(this.withPrefix("ProductionPrinter"));
    public readonly EstimatedBuildProcessDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedBuildProcessDuration_Ticks"));
    public readonly EstimatedBuildProcessDuration = new QStringPath(this.withPrefix("EstimatedBuildProcessDuration"));
    public readonly EstimatedPrintDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedPrintDuration_Ticks"));
    public readonly EstimatedPrintDuration = new QStringPath(this.withPrefix("EstimatedPrintDuration"));
    public readonly ParentPJF_Id = new QGuidPath(this.withPrefix("ParentPJF_Id"));
    public readonly EstimatedMaterialConsumption = new QEntityPath(this.withPrefix("EstimatedMaterialConsumption"), () => QQuantityType);
    public readonly MaxProducedHeight = new QEntityPath(this.withPrefix("MaxProducedHeight"), () => QQuantityType);
    public readonly PJF = new QEntityCollectionPath(this.withPrefix("PJF"), () => QRuntimePJFSerialNumberAssociation);
    public readonly EquipmentTypeList = new QEntityCollectionPath(this.withPrefix("EquipmentTypeList"), () => QPrintJobFileEquipmentTypeAssociation);
    public readonly PrinterList = new QEntityCollectionPath(this.withPrefix("PrinterList"), () => QPrintJobFileEquipmentAssociation);
    public readonly DM_MaterialList = new QEntityCollectionPath(this.withPrefix("DM_MaterialList"), () => QPrintJobFileDM_MaterialAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentPJF = new QEntityPath(this.withPrefix("ParentPJF"), () => QPrintJobFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QPrintJobFileFacet);
}

export const qPrintJobFile = new QPrintJobFile();

export class QPrintJobFileId extends QId<PrintJobFileId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMachineToAM extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly AMMachine = new QStringPath(this.withPrefix("AMMachine"));
    public readonly TransferPlugin = new QStringPath(this.withPrefix("TransferPlugin"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMachineToAMFacet);
}

export const qMachineToAM = new QMachineToAM();

export class QMachineToAMId extends QId<MachineToAMId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QConfigurationKey extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Val = new QStringPath(this.withPrefix("Val"));
    public readonly IsProtected = new QBooleanPath(this.withPrefix("IsProtected"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly IsMultiValue = new QBooleanPath(this.withPrefix("IsMultiValue"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QConfigurationKeyFacet);
}

export const qConfigurationKey = new QConfigurationKey();

export class QConfigurationKeyId extends QId<ConfigurationKeyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceNotification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrder = new QStringPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QStringPath(this.withPrefix("WorkOrderOperation"));
    public readonly UserRole = new QStringPath(this.withPrefix("UserRole"));
    public readonly NonConformanceType = new QStringPath(this.withPrefix("NonConformanceType"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QNonConformanceNotificationFacet);
}

export const qNonConformanceNotification = new QNonConformanceNotification();

export class QNonConformanceNotificationId extends QId<NonConformanceNotificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserCertificationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExpiryDate = new QDateTimeOffsetPath(this.withPrefix("ExpiryDate"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly Certification_Id = new QGuidPath(this.withPrefix("Certification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Certification = new QEntityPath(this.withPrefix("Certification"), () => QCertification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QUserCertificationAssociationFacet);
}

export const qUserCertificationAssociation = new QUserCertificationAssociation();

export class QUserCertificationAssociationId extends QId<UserCertificationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkillCertificationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly SkillId_Id = new QGuidPath(this.withPrefix("SkillId_Id"));
    public readonly Certification_Id = new QGuidPath(this.withPrefix("Certification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SkillId = new QEntityPath(this.withPrefix("SkillId"), () => QSkill_BOP);
    public readonly Certification = new QEntityPath(this.withPrefix("Certification"), () => QCertification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QSkillCertificationAssociationFacet);
}

export const qSkillCertificationAssociation = new QSkillCertificationAssociation();

export class QSkillCertificationAssociationId extends QId<SkillCertificationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRoleCertificationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExpiryDate = new QDateTimeOffsetPath(this.withPrefix("ExpiryDate"));
    public readonly Role = new QStringPath(this.withPrefix("Role"));
    public readonly Certification_Id = new QGuidPath(this.withPrefix("Certification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Certification = new QEntityPath(this.withPrefix("Certification"), () => QCertification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QRoleCertificationAssociationFacet);
}

export const qRoleCertificationAssociation = new QRoleCertificationAssociation();

export class QRoleCertificationAssociationId extends QId<RoleCertificationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialCertificationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialId_Id = new QGuidPath(this.withPrefix("MaterialId_Id"));
    public readonly Certification_Id = new QGuidPath(this.withPrefix("Certification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialId = new QEntityPath(this.withPrefix("MaterialId"), () => QDM_Material);
    public readonly Certification = new QEntityPath(this.withPrefix("Certification"), () => QCertification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialCertificationAssociationFacet);
}

export const qMaterialCertificationAssociation = new QMaterialCertificationAssociation();

export class QMaterialCertificationAssociationId extends QId<MaterialCertificationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentCertificationAssociation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly Certification_Id = new QGuidPath(this.withPrefix("Certification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Certification = new QEntityPath(this.withPrefix("Certification"), () => QCertification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentCertificationAssociationFacet);
}

export const qEquipmentCertificationAssociation = new QEquipmentCertificationAssociation();

export class QEquipmentCertificationAssociationId extends QId<EquipmentCertificationAssociationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Certifications = new QEntityCollectionPath(this.withPrefix("Certifications"), () => QCertificationHistory);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCertificationHistoryActionFacet);
}

export const qCertificationHistoryAction = new QCertificationHistoryAction();

export class QCertificationHistoryActionId extends QId<CertificationHistoryActionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ReferenceRoleId = new QStringPath(this.withPrefix("ReferenceRoleId"));
    public readonly ReferenceUserId = new QStringPath(this.withPrefix("ReferenceUserId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly SkillNId = new QStringPath(this.withPrefix("SkillNId"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly SkillId = new QGuidPath(this.withPrefix("SkillId"));
    public readonly Action_Id = new QGuidPath(this.withPrefix("Action_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Action = new QEntityPath(this.withPrefix("Action"), () => QCertificationHistoryAction);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCertificationHistoryFacet);
}

export const qCertificationHistory = new QCertificationHistory();

export class QCertificationHistoryId extends QId<CertificationHistoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly UserList = new QEntityCollectionPath(this.withPrefix("UserList"), () => QUserCertificationAssociation);
    public readonly SkillList = new QEntityCollectionPath(this.withPrefix("SkillList"), () => QSkillCertificationAssociation);
    public readonly RoleList = new QEntityCollectionPath(this.withPrefix("RoleList"), () => QRoleCertificationAssociation);
    public readonly MaterialList = new QEntityCollectionPath(this.withPrefix("MaterialList"), () => QMaterialCertificationAssociation);
    public readonly EquipmentList = new QEntityCollectionPath(this.withPrefix("EquipmentList"), () => QEquipmentCertificationAssociation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QCertificationFacet);
}

export const qCertification = new QCertification();

export class QCertificationId extends QId<CertificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateToMaterialPlant extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_Material = new QGuidPath(this.withPrefix("DM_Material"));
    public readonly Template_Id = new QGuidPath(this.withPrefix("Template_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Template = new QEntityPath(this.withPrefix("Template"), () => QTemplate);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTemplateToMaterialPlantFacet);
}

export const qTemplateToMaterialPlant = new QTemplateToMaterialPlant();

export class QTemplateToMaterialPlantId extends QId<TemplateToMaterialPlantId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Templates = new QEntityCollectionPath(this.withPrefix("Templates"), () => QTemplate);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTemplateTypeFacet);
}

export const qTemplateType = new QTemplateType();

export class QTemplateTypeId extends QId<TemplateTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateBlock extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExtendedYear = new QBooleanPath(this.withPrefix("ExtendedYear"));
    public readonly NextValue = new QNumberPath(this.withPrefix("NextValue"));
    public readonly NumDigits = new QNumberPath(this.withPrefix("NumDigits"));
    public readonly Separator = new QStringPath(this.withPrefix("Separator"));
    public readonly BlockType = new QStringPath(this.withPrefix("BlockType"));
    public readonly ZeroPadding = new QBooleanPath(this.withPrefix("ZeroPadding"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Template_Id = new QGuidPath(this.withPrefix("Template_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Template = new QEntityPath(this.withPrefix("Template"), () => QTemplate);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTemplateBlockFacet);
}

export const qTemplateBlock = new QTemplateBlock();

export class QTemplateBlockId extends QId<TemplateBlockId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplate extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly EditingUser = new QStringPath(this.withPrefix("EditingUser"));
    public readonly Editing = new QBooleanPath(this.withPrefix("Editing"));
    public readonly TemplateType_Id = new QGuidPath(this.withPrefix("TemplateType_Id"));
    public readonly MaterialPlant = new QEntityCollectionPath(this.withPrefix("MaterialPlant"), () => QTemplateToMaterialPlant);
    public readonly TemplateBlocks = new QEntityCollectionPath(this.withPrefix("TemplateBlocks"), () => QTemplateBlock);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TemplateType = new QEntityPath(this.withPrefix("TemplateType"), () => QTemplateType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QTemplateFacet);
}

export const qTemplate = new QTemplate();

export class QTemplateId extends QId<TemplateId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialSpecificationType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly HasOutputBehavior = new QBooleanPath(this.withPrefix("HasOutputBehavior"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialSpecification = new QEntityCollectionPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialSpecificationTypeFacet);
}

export const qMaterialSpecificationType = new QMaterialSpecificationType();

export class QMaterialSpecificationTypeId extends QId<MaterialSpecificationTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolDefinitionDocumentFacet);
}

export const qToolDefinitionDocument = new QToolDefinitionDocument();

export class QToolDefinitionDocumentId extends QId<ToolDefinitionDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStepDependency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly LinkTo_Id = new QGuidPath(this.withPrefix("LinkTo_Id"));
    public readonly LinkFrom_Id = new QGuidPath(this.withPrefix("LinkFrom_Id"));
    public readonly ToStep_Id = new QGuidPath(this.withPrefix("ToStep_Id"));
    public readonly FromStep_Id = new QGuidPath(this.withPrefix("FromStep_Id"));
    public readonly DependencyType_Id = new QGuidPath(this.withPrefix("DependencyType_Id"));
    public readonly OperationContext_Id = new QGuidPath(this.withPrefix("OperationContext_Id"));
    public readonly AsPlannedBoP_Id = new QGuidPath(this.withPrefix("AsPlannedBoP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LinkTo = new QEntityPath(this.withPrefix("LinkTo"), () => QOperationToStepLink);
    public readonly LinkFrom = new QEntityPath(this.withPrefix("LinkFrom"), () => QOperationToStepLink);
    public readonly ToStep = new QEntityPath(this.withPrefix("ToStep"), () => QStep);
    public readonly FromStep = new QEntityPath(this.withPrefix("FromStep"), () => QStep);
    public readonly DependencyType = new QEntityPath(this.withPrefix("DependencyType"), () => QDependencyType);
    public readonly OperationContext = new QEntityPath(this.withPrefix("OperationContext"), () => QOperation);
    public readonly AsPlannedBoP = new QEntityPath(this.withPrefix("AsPlannedBoP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStepDependencyFacet);
}

export const qStepDependency = new QStepDependency();

export class QStepDependencyId extends QId<StepDependencyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStep extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly OperationStepCategoryId_Id = new QGuidPath(this.withPrefix("OperationStepCategoryId_Id"));
    public readonly CertificationSpecification = new QEntityCollectionPath(this.withPrefix("CertificationSpecification"), () => QCertificationSpecification);
    public readonly StepSkills = new QEntityCollectionPath(this.withPrefix("StepSkills"), () => QStepSkill);
    public readonly WorkInstructionDefinitions = new QEntityCollectionPath(this.withPrefix("WorkInstructionDefinitions"), () => QWorkInstructionDefinitionToStepAssociation);
    public readonly InspectionSpecification = new QEntityCollectionPath(this.withPrefix("InspectionSpecification"), () => QInspectionSpecification);
    public readonly OperationToStepLinks = new QEntityCollectionPath(this.withPrefix("OperationToStepLinks"), () => QOperationToStepLink);
    public readonly ToStepDependency = new QEntityCollectionPath(this.withPrefix("ToStepDependency"), () => QStepDependency);
    public readonly FromStepDependency = new QEntityCollectionPath(this.withPrefix("FromStepDependency"), () => QStepDependency);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationStepCategoryId = new QEntityPath(this.withPrefix("OperationStepCategoryId"), () => QOperationStepCategory);
    public readonly Operations = new QEntityCollectionPath(this.withPrefix("Operations"), () => QOperation);
    public readonly MaterialSpecifications = new QEntityCollectionPath(this.withPrefix("MaterialSpecifications"), () => QMaterialSpecification);
    public readonly Documents = new QEntityCollectionPath(this.withPrefix("Documents"), () => QDocument);
    public readonly ToolSpecifications = new QEntityCollectionPath(this.withPrefix("ToolSpecifications"), () => QToolSpecification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStepFacet);
}

export const qStep = new QStep();

export class QStepId extends QId<StepId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcess extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly FinalMaterialId_Id = new QGuidPath(this.withPrefix("FinalMaterialId_Id"));
    public readonly MaxQuantity = new QEntityPath(this.withPrefix("MaxQuantity"), () => QQuantityType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityType);
    public readonly DiscreteStatus = new QEntityPath(this.withPrefix("DiscreteStatus"), () => QStatusType);
    public readonly ProcessLinksWithRoleParent = new QEntityCollectionPath(this.withPrefix("ProcessLinksWithRoleParent"), () => QProcessToProcessLink);
    public readonly ProcessLinksWithRoleChild = new QEntityCollectionPath(this.withPrefix("ProcessLinksWithRoleChild"), () => QProcessToProcessLink);
    public readonly ProcessToOperationLinks = new QEntityCollectionPath(this.withPrefix("ProcessToOperationLinks"), () => QProcessToOperationLink);
    public readonly WorkOrders = new QEntityCollectionPath(this.withPrefix("WorkOrders"), () => QWorkOrder);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FinalMaterialId = new QEntityPath(this.withPrefix("FinalMaterialId"), () => QDM_Material);
    public readonly ParentProcesses = new QEntityCollectionPath(this.withPrefix("ParentProcesses"), () => QProcess);
    public readonly ChildrenProcesses = new QEntityCollectionPath(this.withPrefix("ChildrenProcesses"), () => QProcess);
    public readonly MasterPlan = new QEntityCollectionPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly AsPlannedBOP = new QEntityCollectionPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly OperationDependencies = new QEntityCollectionPath(this.withPrefix("OperationDependencies"), () => QOperationDependency);
    public readonly Operations = new QEntityCollectionPath(this.withPrefix("Operations"), () => QOperation);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QProcessFacet);
}

export const qProcess = new QProcess();

export class QProcessId extends QId<ProcessId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationDependency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly FromOperation_Id = new QGuidPath(this.withPrefix("FromOperation_Id"));
    public readonly ToOperation_Id = new QGuidPath(this.withPrefix("ToOperation_Id"));
    public readonly DependencyType_Id = new QGuidPath(this.withPrefix("DependencyType_Id"));
    public readonly ContextProcess_Id = new QGuidPath(this.withPrefix("ContextProcess_Id"));
    public readonly LinkFrom_Id = new QGuidPath(this.withPrefix("LinkFrom_Id"));
    public readonly LinkTo_Id = new QGuidPath(this.withPrefix("LinkTo_Id"));
    public readonly AsPlannedBoP_Id = new QGuidPath(this.withPrefix("AsPlannedBoP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly ProcessToOpLinkDependencyNavigations = new QEntityCollectionPath(this.withPrefix("ProcessToOpLinkDependencyNavigations"), () => QProcessToOpLinkDependencyNavigation);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FromOperation = new QEntityPath(this.withPrefix("FromOperation"), () => QOperation);
    public readonly ToOperation = new QEntityPath(this.withPrefix("ToOperation"), () => QOperation);
    public readonly DependencyType = new QEntityPath(this.withPrefix("DependencyType"), () => QDependencyType);
    public readonly ContextProcess = new QEntityPath(this.withPrefix("ContextProcess"), () => QProcess);
    public readonly LinkFrom = new QEntityPath(this.withPrefix("LinkFrom"), () => QProcessToOperationLink);
    public readonly LinkTo = new QEntityPath(this.withPrefix("LinkTo"), () => QProcessToOperationLink);
    public readonly AsPlannedBoP = new QEntityPath(this.withPrefix("AsPlannedBoP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOperationDependencyFacet);
}

export const qOperationDependency = new QOperationDependency();

export class QOperationDependencyId extends QId<OperationDependencyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly EstimatedDuration_Ticks = new QNumberPath(this.withPrefix("EstimatedDuration_Ticks"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly WorkOperationId_Id = new QGuidPath(this.withPrefix("WorkOperationId_Id"));
    public readonly OperationStepCategoryId_Id = new QGuidPath(this.withPrefix("OperationStepCategoryId_Id"));
    public readonly CertificationSpecification = new QEntityCollectionPath(this.withPrefix("CertificationSpecification"), () => QCertificationSpecification);
    public readonly InspectionSpecification = new QEntityCollectionPath(this.withPrefix("InspectionSpecification"), () => QInspectionSpecification);
    public readonly WorkInstructionDefinitions = new QEntityCollectionPath(this.withPrefix("WorkInstructionDefinitions"), () => QWorkInstructionDefinitionToOperationAssociation);
    public readonly OperationToStepLinks = new QEntityCollectionPath(this.withPrefix("OperationToStepLinks"), () => QOperationToStepLink);
    public readonly ProcessToOperationLinks = new QEntityCollectionPath(this.withPrefix("ProcessToOperationLinks"), () => QProcessToOperationLink);
    public readonly OperationSkill = new QEntityCollectionPath(this.withPrefix("OperationSkill"), () => QOperationSkill);
    public readonly WorkOrderOperations = new QEntityCollectionPath(this.withPrefix("WorkOrderOperations"), () => QWorkOrderOperation);
    public readonly StepDependencies = new QEntityCollectionPath(this.withPrefix("StepDependencies"), () => QStepDependency);
    public readonly Steps = new QEntityCollectionPath(this.withPrefix("Steps"), () => QStep);
    public readonly FromOperationDependency = new QEntityCollectionPath(this.withPrefix("FromOperationDependency"), () => QOperationDependency);
    public readonly ToOperationDependency = new QEntityCollectionPath(this.withPrefix("ToOperationDependency"), () => QOperationDependency);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOperationId = new QEntityPath(this.withPrefix("WorkOperationId"), () => QWorkOperationType);
    public readonly OperationStepCategoryId = new QEntityPath(this.withPrefix("OperationStepCategoryId"), () => QOperationStepCategory);
    public readonly Processes = new QEntityCollectionPath(this.withPrefix("Processes"), () => QProcess);
    public readonly MaterialSpecifications = new QEntityCollectionPath(this.withPrefix("MaterialSpecifications"), () => QMaterialSpecification);
    public readonly EquipmentSpecifications = new QEntityCollectionPath(this.withPrefix("EquipmentSpecifications"), () => QEquipmentSpecification);
    public readonly Documents = new QEntityCollectionPath(this.withPrefix("Documents"), () => QDocument);
    public readonly ToolSpecifications = new QEntityCollectionPath(this.withPrefix("ToolSpecifications"), () => QToolSpecification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOperationFacet);
}

export const qOperation = new QOperation();

export class QOperationId extends QId<OperationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly FunctionalCodeNId = new QStringPath(this.withPrefix("FunctionalCodeNId"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
    public readonly DM_MaterialId_Id = new QGuidPath(this.withPrefix("DM_MaterialId_Id"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly MaterialTypeNId_Id = new QGuidPath(this.withPrefix("MaterialTypeNId_Id"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialId = new QEntityPath(this.withPrefix("DM_MaterialId"), () => QDM_Material);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
    public readonly MaterialTypeNId = new QEntityPath(this.withPrefix("MaterialTypeNId"), () => QMaterialSpecificationType);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialSpecificationFacet);
}

export const qMaterialSpecification = new QMaterialSpecification();

export class QMaterialSpecificationId extends QId<MaterialSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialDefinitionDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QMaterialDefinitionDocumentFacet);
}

export const qMaterialDefinitionDocument = new QMaterialDefinitionDocument();

export class QMaterialDefinitionDocumentId extends QId<MaterialDefinitionDocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly PrintJobFile = new QStringPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileId = new QGuidPath(this.withPrefix("PrintJobFileId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly ParentOperation_Id = new QGuidPath(this.withPrefix("ParentOperation_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentOperation = new QEntityPath(this.withPrefix("ParentOperation"), () => QOperation);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentSpecificationFacet);
}

export const qEquipmentSpecification = new QEquipmentSpecification();

export class QEquipmentSpecificationId extends QId<EquipmentSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly File_Id_Id = new QGuidPath(this.withPrefix("File_Id_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Steps = new QEntityCollectionPath(this.withPrefix("Steps"), () => QStep);
    public readonly Operations = new QEntityCollectionPath(this.withPrefix("Operations"), () => QOperation);
    public readonly File_Id = new QEntityPath(this.withPrefix("File_Id"), () => QFile);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDocumentFacet);
}

export const qDocument = new QDocument();

export class QDocumentId extends QId<DocumentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDependencyType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDependencyTypeFacet);
}

export const qDependencyType = new QDependencyType();

export class QDependencyTypeId extends QId<DependencyTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAsPlannedBOP extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BaselineName = new QStringPath(this.withPrefix("BaselineName"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
    public readonly IsOutOfDate = new QBooleanPath(this.withPrefix("IsOutOfDate"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly Completed = new QBooleanPath(this.withPrefix("Completed"));
    public readonly CertificationSpecification = new QEntityCollectionPath(this.withPrefix("CertificationSpecification"), () => QCertificationSpecification);
    public readonly InspectionSpecification = new QEntityCollectionPath(this.withPrefix("InspectionSpecification"), () => QInspectionSpecification);
    public readonly OperationToStepLinks = new QEntityCollectionPath(this.withPrefix("OperationToStepLinks"), () => QOperationToStepLink);
    public readonly ProcessToProcessLinks = new QEntityCollectionPath(this.withPrefix("ProcessToProcessLinks"), () => QProcessToProcessLink);
    public readonly ProcessToOperationLinks = new QEntityCollectionPath(this.withPrefix("ProcessToOperationLinks"), () => QProcessToOperationLink);
    public readonly StepDependencies = new QEntityCollectionPath(this.withPrefix("StepDependencies"), () => QStepDependency);
    public readonly Processes = new QEntityCollectionPath(this.withPrefix("Processes"), () => QProcess);
    public readonly OperationDependencies = new QEntityCollectionPath(this.withPrefix("OperationDependencies"), () => QOperationDependency);
    public readonly MaterialSpecification = new QEntityCollectionPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecification);
    public readonly EquipmentSpecification = new QEntityCollectionPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecification);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolSpecification = new QEntityCollectionPath(this.withPrefix("ToolSpecification"), () => QToolSpecification);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAsPlannedBOPFacet);
}

export const qAsPlannedBOP = new QAsPlannedBOP();

export class QAsPlannedBOPId extends QId<AsPlannedBOPId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly UsageNumber = new QNumberPath(this.withPrefix("UsageNumber"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly UsageDuration_Ticks = new QNumberPath(this.withPrefix("UsageDuration_Ticks"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly ToolDefinitionId_Id = new QGuidPath(this.withPrefix("ToolDefinitionId_Id"));
    public readonly Operation_Id = new QGuidPath(this.withPrefix("Operation_Id"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinitionId = new QEntityPath(this.withPrefix("ToolDefinitionId"), () => QToolDefinition);
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperation);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolSpecificationFacet);
}

export const qToolSpecification = new QToolSpecification();

export class QToolSpecificationId extends QId<ToolSpecificationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentNewFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentNew_Id = new QGuidPath(this.withPrefix("DocumentNew_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DocumentNew = new QEntityPath(this.withPrefix("DocumentNew"), () => QDocumentNew);
}

export const qDocumentNewFacet = new QDocumentNewFacet();

export class QDocumentNewFacetId extends QId<DocumentNewFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPLMXDocument extends QDocumentNewFacet {
    public readonly PackageId = new QStringPath(this.withPrefix("PackageId"));
}

export const qPLMXDocument = new QPLMXDocument();

export class QContainerHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContainerHistory_Id = new QGuidPath(this.withPrefix("ContainerHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerHistory = new QEntityPath(this.withPrefix("ContainerHistory"), () => QContainerHistory);
}

export const qContainerHistoryFacet = new QContainerHistoryFacet();

export class QContainerHistoryFacetId extends QId<ContainerHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerNonConformance extends QContainerHistoryFacet {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly ReworkOrderNId = new QStringPath(this.withPrefix("ReworkOrderNId"));
}

export const qContainerNonConformance = new QContainerNonConformance();

export class QContainerExecutionHistory extends QContainerHistoryFacet {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
}

export const qContainerExecutionHistory = new QContainerExecutionHistory();

export class QInspectionValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly InspectionValue_Id = new QGuidPath(this.withPrefix("InspectionValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionValue = new QEntityPath(this.withPrefix("InspectionValue"), () => QInspectionValue);
}

export const qInspectionValueFacet = new QInspectionValueFacet();

export class QInspectionValueFacetId extends QId<InspectionValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityGateOnInspectionValue extends QInspectionValueFacet {
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
}

export const qQualityGateOnInspectionValue = new QQualityGateOnInspectionValue();

export class QRuntimeCharacteristicRepresentationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimeCharacteristicRepresentation_Id = new QGuidPath(this.withPrefix("RuntimeCharacteristicRepresentation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimeCharacteristicRepresentation = new QEntityPath(this.withPrefix("RuntimeCharacteristicRepresentation"), () => QRuntimeCharacteristicRepresentation);
}

export const qRuntimeCharacteristicRepresentationFacet = new QRuntimeCharacteristicRepresentationFacet();

export class QRuntimeCharacteristicRepresentationFacetId extends QId<RuntimeCharacteristicRepresentationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActivityToBeUsedInspection extends QRuntimeCharacteristicRepresentationFacet {
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly DefaultResultValue = new QStringPath(this.withPrefix("DefaultResultValue"));
    public readonly DefaultResultStrategy = new QStringPath(this.withPrefix("DefaultResultStrategy"));
}

export const qActivityToBeUsedInspection = new QActivityToBeUsedInspection();

export class QCharacteristicSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CharacteristicSpecification_Id = new QGuidPath(this.withPrefix("CharacteristicSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicSpecification = new QEntityPath(this.withPrefix("CharacteristicSpecification"), () => QCharacteristicSpecification);
}

export const qCharacteristicSpecificationFacet = new QCharacteristicSpecificationFacet();

export class QCharacteristicSpecificationFacetId extends QId<CharacteristicSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBuyOffCharacteristic extends QCharacteristicSpecificationFacet {
    public readonly IsBuyOff = new QBooleanPath(this.withPrefix("IsBuyOff"));
}

export const qBuyOffCharacteristic = new QBuyOffCharacteristic();

export class QMaterialTrackingUnitAggregateFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialTrackingUnitAggregate_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnitAggregate_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialTrackingUnitAggregate = new QEntityPath(this.withPrefix("MaterialTrackingUnitAggregate"), () => QMaterialTrackingUnitAggregate);
}

export const qMaterialTrackingUnitAggregateFacet = new QMaterialTrackingUnitAggregateFacet();

export class QMaterialTrackingUnitAggregateFacetId extends QId<MaterialTrackingUnitAggregateFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainer extends QMaterialTrackingUnitAggregateFacet {
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly SourceEquipmentNId = new QStringPath(this.withPrefix("SourceEquipmentNId"));
    public readonly TargetEquipmentNId = new QStringPath(this.withPrefix("TargetEquipmentNId"));
    public readonly IsContainer = new QBooleanPath(this.withPrefix("IsContainer"));
}

export const qContainer = new QContainer();

export class QContainerExecution extends QMaterialTrackingUnitAggregateFacet {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qContainerExecution = new QContainerExecution();

export class QDM_MaterialTrackingUnitHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnitHistory_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnitHistory = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnitHistory"), () => QDM_MaterialTrackingUnitHistory);
}

export const qDM_MaterialTrackingUnitHistoryFacet = new QDM_MaterialTrackingUnitHistoryFacet();

export class QDM_MaterialTrackingUnitHistoryFacetId extends QId<DM_MaterialTrackingUnitHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityGateOnDM_MaterialTrackingUnitHistory extends QDM_MaterialTrackingUnitHistoryFacet {
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
}

export const qQualityGateOnDM_MaterialTrackingUnitHistory = new QQualityGateOnDM_MaterialTrackingUnitHistory();

export class QContainerDM_MaterialTrackingUnitHistory extends QDM_MaterialTrackingUnitHistoryFacet {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
}

export const qContainerDM_MaterialTrackingUnitHistory = new QContainerDM_MaterialTrackingUnitHistory();

export class QATNAcquisitionMTUHistory extends QDM_MaterialTrackingUnitHistoryFacet {
    public readonly ATNAcquisitionHistoryAssociation = new QEntityPath(this.withPrefix("ATNAcquisitionHistoryAssociation"), () => QATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types);
}

export const qATNAcquisitionMTUHistory = new QATNAcquisitionMTUHistory();

export class QDM_MaterialTrackingUnitFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MaterialTrackingUnit);
}

export const qDM_MaterialTrackingUnitFacet = new QDM_MaterialTrackingUnitFacet();

export class QDM_MaterialTrackingUnitFacetId extends QId<DM_MaterialTrackingUnitFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMPowderMaterialTrackingUnit extends QDM_MaterialTrackingUnitFacet {
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityType);
}

export const qAMPowderMaterialTrackingUnit = new QAMPowderMaterialTrackingUnit();

export class QMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Material_Id = new QGuidPath(this.withPrefix("Material_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterial);
}

export const qMaterialFacet = new QMaterialFacet();

export class QMaterialFacetId extends QId<MaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialATNInstanceParameterAssociation extends QMaterialFacet {
    public readonly MaterialParameterNId = new QStringPath(this.withPrefix("MaterialParameterNId"));
    public readonly ATNInstanceParameter = new QEntityPath(this.withPrefix("ATNInstanceParameter"), () => QATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types);
}

export const qMaterialATNInstanceParameterAssociation = new QMaterialATNInstanceParameterAssociation();

export class QDM_MaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_Material_Id = new QGuidPath(this.withPrefix("DM_Material_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QDM_Material);
}

export const qDM_MaterialFacet = new QDM_MaterialFacet();

export class QDM_MaterialFacetId extends QId<DM_MaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMPowder extends QDM_MaterialFacet {
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityType);
}

export const qAMPowder = new QAMPowder();

export class QWIDefinitionToWOOperationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WIDefinitionToWOOperationAssociation_Id = new QGuidPath(this.withPrefix("WIDefinitionToWOOperationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WIDefinitionToWOOperationAssociation = new QEntityPath(this.withPrefix("WIDefinitionToWOOperationAssociation"), () => QWIDefinitionToWOOperationAssociation);
}

export const qWIDefinitionToWOOperationAssociationFacet = new QWIDefinitionToWOOperationAssociationFacet();

export class QWIDefinitionToWOOperationAssociationFacetId extends QId<WIDefinitionToWOOperationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActivityWorkInstruction extends QWIDefinitionToWOOperationAssociationFacet {
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly DefaultResultValue = new QStringPath(this.withPrefix("DefaultResultValue"));
    public readonly DefaultResultStrategy = new QStringPath(this.withPrefix("DefaultResultStrategy"));
}

export const qActivityWorkInstruction = new QActivityWorkInstruction();

export class QWorkInstructionStepItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionStepItem_Id = new QGuidPath(this.withPrefix("WorkInstructionStepItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionStepItem = new QEntityPath(this.withPrefix("WorkInstructionStepItem"), () => QWorkInstructionStepItem);
}

export const qWorkInstructionStepItemFacet = new QWorkInstructionStepItemFacet();

export class QWorkInstructionStepItemFacetId extends QId<WorkInstructionStepItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityGateOnWorkInstructionStepItem extends QWorkInstructionStepItemFacet {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
}

export const qQualityGateOnWorkInstructionStepItem = new QQualityGateOnWorkInstructionStepItem();

export class QATNAcquisitionHistoryAssociation extends QWorkInstructionStepItemFacet {
    public readonly ATNParameterValue = new QStringPath(this.withPrefix("ATNParameterValue"));
    public readonly ATNAcquisitionHistoryParameter = new QEntityPath(this.withPrefix("ATNAcquisitionHistoryParameter"), () => QATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types);
}

export const qATNAcquisitionHistoryAssociation = new QATNAcquisitionHistoryAssociation();

export class QWorkInstructionStepFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionStep_Id = new QGuidPath(this.withPrefix("WorkInstructionStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionStep = new QEntityPath(this.withPrefix("WorkInstructionStep"), () => QWorkInstructionStep);
}

export const qWorkInstructionStepFacet = new QWorkInstructionStepFacet();

export class QWorkInstructionStepFacetId extends QId<WorkInstructionStepFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityGateOnWorkInstructionStep extends QWorkInstructionStepFacet {
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qQualityGateOnWorkInstructionStep = new QQualityGateOnWorkInstructionStep();

export class QWorkInstructionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstruction_Id = new QGuidPath(this.withPrefix("WorkInstruction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstruction = new QEntityPath(this.withPrefix("WorkInstruction"), () => QWorkInstruction);
}

export const qWorkInstructionFacet = new QWorkInstructionFacet();

export class QWorkInstructionFacetId extends QId<WorkInstructionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIResult2 extends QWorkInstructionFacet {
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
    public readonly IsRepeated = new QBooleanPath(this.withPrefix("IsRepeated"));
    public readonly CanBeRepeated = new QBooleanPath(this.withPrefix("CanBeRepeated"));
}

export const qWIResult2 = new QWIResult2();

export class QWorkInstructionDefinitionParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionDefinitionParameter_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinitionParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionDefinitionParameter = new QEntityPath(this.withPrefix("WorkInstructionDefinitionParameter"), () => QWorkInstructionDefinitionParameter);
}

export const qWorkInstructionDefinitionParameterFacet = new QWorkInstructionDefinitionParameterFacet();

export class QWorkInstructionDefinitionParameterFacetId extends QId<WorkInstructionDefinitionParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIDefinitionATNInstanceParameterAssociation extends QWorkInstructionDefinitionParameterFacet {
    public readonly ATNInstanceParameter = new QEntityPath(this.withPrefix("ATNInstanceParameter"), () => QATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types);
}

export const qWIDefinitionATNInstanceParameterAssociation = new QWIDefinitionATNInstanceParameterAssociation();

export class QToolDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolDefinition_Id = new QGuidPath(this.withPrefix("ToolDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinition = new QEntityPath(this.withPrefix("ToolDefinition"), () => QToolDefinition);
}

export const qToolDefinitionFacet = new QToolDefinitionFacet();

export class QToolDefinitionFacetId extends QId<ToolDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionATNInstanceParameterAssociation extends QToolDefinitionFacet {
    public readonly ToolDefinitionParameterNId = new QStringPath(this.withPrefix("ToolDefinitionParameterNId"));
    public readonly ATNInstanceParameter = new QEntityPath(this.withPrefix("ATNInstanceParameter"), () => QATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types);
}

export const qToolDefinitionATNInstanceParameterAssociation = new QToolDefinitionATNInstanceParameterAssociation();

export class QSubstrateDefinition extends QToolDefinitionFacet {
    public readonly AutomaticThicknessDecrease = new QBooleanPath(this.withPrefix("AutomaticThicknessDecrease"));
    public readonly MaxTreatmentCountHold = new QNumberPath(this.withPrefix("MaxTreatmentCountHold"));
    public readonly MaxTreatmentCountWarning = new QNumberPath(this.withPrefix("MaxTreatmentCountWarning"));
    public readonly MinThicknessHold = new QNumberPath(this.withPrefix("MinThicknessHold"));
    public readonly MinThicknessWarning = new QNumberPath(this.withPrefix("MinThicknessWarning"));
    public readonly ThicknessDecreaseAmount = new QNumberPath(this.withPrefix("ThicknessDecreaseAmount"));
}

export const qSubstrateDefinition = new QSubstrateDefinition();

export class QWorkOrderOperationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperation);
}

export const qWorkOrderOperationFacet = new QWorkOrderOperationFacet();

export class QWorkOrderOperationFacetId extends QId<WorkOrderOperationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultQuantity extends QWorkOrderOperationFacet {
    public readonly KoQuantity = new QNumberPath(this.withPrefix("KoQuantity"));
    public readonly OkQuantity = new QNumberPath(this.withPrefix("OkQuantity"));
}

export const qResultQuantity = new QResultQuantity();

export class QOffline extends QWorkOrderOperationFacet {
    public readonly CheckedOut = new QBooleanPath(this.withPrefix("CheckedOut"));
}

export const qOffline = new QOffline();

export class QWorkOrderHistoryMaterialItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderHistoryMaterialItem_Id = new QGuidPath(this.withPrefix("WorkOrderHistoryMaterialItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderHistoryMaterialItem = new QEntityPath(this.withPrefix("WorkOrderHistoryMaterialItem"), () => QWorkOrderHistoryMaterialItem);
}

export const qWorkOrderHistoryMaterialItemFacet = new QWorkOrderHistoryMaterialItemFacet();

export class QWorkOrderHistoryMaterialItemFacetId extends QId<WorkOrderHistoryMaterialItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActionResult extends QWorkOrderHistoryMaterialItemFacet {
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
}

export const qActionResult = new QActionResult();

export class QContainerWorkOrderHistory extends QWorkOrderHistoryMaterialItemFacet {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qContainerWorkOrderHistory = new QContainerWorkOrderHistory();

export class QWorkOrderHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderHistory_Id = new QGuidPath(this.withPrefix("WorkOrderHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderHistory = new QEntityPath(this.withPrefix("WorkOrderHistory"), () => QWorkOrderHistory);
}

export const qWorkOrderHistoryFacet = new QWorkOrderHistoryFacet();

export class QWorkOrderHistoryFacetId extends QId<WorkOrderHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QATNTransmissionWorkOrderHistory extends QWorkOrderHistoryFacet {
    public readonly ATNTransmissionWorkOrderHistoryAssociation = new QEntityPath(this.withPrefix("ATNTransmissionWorkOrderHistoryAssociation"), () => QATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types);
}

export const qATNTransmissionWorkOrderHistory = new QATNTransmissionWorkOrderHistory();

export class QActivityManagement extends QWorkOrderFacet {
    public readonly CreateWithActivity = new QBooleanPath(this.withPrefix("CreateWithActivity"));
}

export const qActivityManagement = new QActivityManagement();

export class QToolHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolHistory_Id = new QGuidPath(this.withPrefix("ToolHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolHistory = new QEntityPath(this.withPrefix("ToolHistory"), () => QToolHistory);
}

export const qToolHistoryFacet = new QToolHistoryFacet();

export class QToolHistoryFacetId extends QId<ToolHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolUsageQualityGate extends QToolHistoryFacet {
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
}

export const qToolUsageQualityGate = new QToolUsageQualityGate();

export class QContainerToolHistory extends QToolHistoryFacet {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
}

export const qContainerToolHistory = new QContainerToolHistory();

export class QATNDataTransmissionToolHistory extends QToolHistoryFacet {
    public readonly ATNTransmissionToolHistoryAssociation = new QEntityPath(this.withPrefix("ATNTransmissionToolHistoryAssociation"), () => QATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types);
}

export const qATNDataTransmissionToolHistory = new QATNDataTransmissionToolHistory();

export class QATNAcquisitionToolHistory extends QToolHistoryFacet {
    public readonly ATNAcquisitionHistoryAssociation = new QEntityPath(this.withPrefix("ATNAcquisitionHistoryAssociation"), () => QATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types);
}

export const qATNAcquisitionToolHistory = new QATNAcquisitionToolHistory();

export class QToolFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Tool_Id = new QGuidPath(this.withPrefix("Tool_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QTool);
}

export const qToolFacet = new QToolFacet();

export class QToolFacetId extends QId<ToolFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSubstrate extends QToolFacet {
    public readonly AutomaticThicknessDecrease = new QBooleanPath(this.withPrefix("AutomaticThicknessDecrease"));
    public readonly CurrentThickness = new QNumberPath(this.withPrefix("CurrentThickness"));
    public readonly MaxTreatmentCountHold = new QNumberPath(this.withPrefix("MaxTreatmentCountHold"));
    public readonly MaxTreatmentCountWarning = new QNumberPath(this.withPrefix("MaxTreatmentCountWarning"));
    public readonly MinThicknessHold = new QNumberPath(this.withPrefix("MinThicknessHold"));
    public readonly MinThicknessWarning = new QNumberPath(this.withPrefix("MinThicknessWarning"));
    public readonly TreatmentCount = new QNumberPath(this.withPrefix("TreatmentCount"));
    public readonly ThicknessDescreaseAmount = new QNumberPath(this.withPrefix("ThicknessDescreaseAmount"));
}

export const qSubstrate = new QSubstrate();

export class QToBeUsedToolFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedTool_Id = new QGuidPath(this.withPrefix("ToBeUsedTool_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedTool = new QEntityPath(this.withPrefix("ToBeUsedTool"), () => QToBeUsedTool);
}

export const qToBeUsedToolFacet = new QToBeUsedToolFacet();

export class QToBeUsedToolFacetId extends QId<ToBeUsedToolFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActivityToBeUsedTool extends QToBeUsedToolFacet {
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly DefaultResultValue = new QStringPath(this.withPrefix("DefaultResultValue"));
    public readonly DefaultResultStrategy = new QStringPath(this.withPrefix("DefaultResultStrategy"));
}

export const qActivityToBeUsedTool = new QActivityToBeUsedTool();

export class QActiveMaterialTrackingUnit extends QToBeUsedToolFacet {
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
}

export const qActiveMaterialTrackingUnit = new QActiveMaterialTrackingUnit();

export class QScrewingOperationCharacteristics extends QToBeUsedToolFacet {
    public readonly AngleValueMin = new QNumberPath(this.withPrefix("AngleValueMin"));
    public readonly TorqueValueMin = new QNumberPath(this.withPrefix("TorqueValueMin"));
    public readonly AngleValueMax = new QNumberPath(this.withPrefix("AngleValueMax"));
    public readonly TorqueValueMax = new QNumberPath(this.withPrefix("TorqueValueMax"));
    public readonly NumberOfBolts = new QNumberPath(this.withPrefix("NumberOfBolts"));
}

export const qScrewingOperationCharacteristics = new QScrewingOperationCharacteristics();

export class QToBeProducedMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeProducedMaterial_Id = new QGuidPath(this.withPrefix("ToBeProducedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeProducedMaterial = new QEntityPath(this.withPrefix("ToBeProducedMaterial"), () => QToBeProducedMaterial);
}

export const qToBeProducedMaterialFacet = new QToBeProducedMaterialFacet();

export class QToBeProducedMaterialFacetId extends QId<ToBeProducedMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRepeat extends QToBeProducedMaterialFacet {
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
}

export const qRepeat = new QRepeat();

export class QToBeConsumedMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeConsumedMaterial_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeConsumedMaterial = new QEntityPath(this.withPrefix("ToBeConsumedMaterial"), () => QToBeConsumedMaterial);
}

export const qToBeConsumedMaterialFacet = new QToBeConsumedMaterialFacet();

export class QToBeConsumedMaterialFacetId extends QId<ToBeConsumedMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActivityToBeConsumedMaterial extends QToBeConsumedMaterialFacet {
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly DefaultResultValue = new QStringPath(this.withPrefix("DefaultResultValue"));
    public readonly DefaultResultStrategy = new QStringPath(this.withPrefix("DefaultResultStrategy"));
}

export const qActivityToBeConsumedMaterial = new QActivityToBeConsumedMaterial();

export class QNonConformanceHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceHistory_Id = new QGuidPath(this.withPrefix("NonConformanceHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceHistory = new QEntityPath(this.withPrefix("NonConformanceHistory"), () => QNonConformanceHistory);
}

export const qNonConformanceHistoryFacet = new QNonConformanceHistoryFacet();

export class QNonConformanceHistoryFacetId extends QId<NonConformanceHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBuyOffHistory extends QNonConformanceHistoryFacet {
    public readonly ActualValue = new QStringPath(this.withPrefix("ActualValue"));
    public readonly ScenarioInstanceId = new QGuidPath(this.withPrefix("ScenarioInstanceId"));
}

export const qBuyOffHistory = new QBuyOffHistory();

export class QContainerNonConformanceHistory extends QNonConformanceHistoryFacet {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
}

export const qContainerNonConformanceHistory = new QContainerNonConformanceHistory();

export class QNonConformanceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformance_Id = new QGuidPath(this.withPrefix("NonConformance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformance);
}

export const qNonConformanceFacet = new QNonConformanceFacet();

export class QNonConformanceFacetId extends QId<NonConformanceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QChangeRouting extends QNonConformanceFacet {
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly NewOperationFrom = new QStringPath(this.withPrefix("NewOperationFrom"));
    public readonly NewOperationTo = new QStringPath(this.withPrefix("NewOperationTo"));
    public readonly NewDependency = new QStringPath(this.withPrefix("NewDependency"));
    public readonly OldOperationFrom = new QStringPath(this.withPrefix("OldOperationFrom"));
    public readonly OldOperationTo = new QStringPath(this.withPrefix("OldOperationTo"));
    public readonly OldDependency = new QStringPath(this.withPrefix("OldDependency"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
}

export const qChangeRouting = new QChangeRouting();

export class QChangeTool extends QNonConformanceFacet {
    public readonly NewToolDefinitionName = new QStringPath(this.withPrefix("NewToolDefinitionName"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly ToolUsageNumber = new QNumberPath(this.withPrefix("ToolUsageNumber"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
}

export const qChangeTool = new QChangeTool();

export class QBuyOff extends QNonConformanceFacet {
    public readonly RuntimeCharRepresentationNId = new QStringPath(this.withPrefix("RuntimeCharRepresentationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qBuyOff = new QBuyOff();

export class QChangePart extends QNonConformanceFacet {
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly NewPart = new QStringPath(this.withPrefix("NewPart"));
    public readonly NewPartQuantity = new QNumberPath(this.withPrefix("NewPartQuantity"));
    public readonly OldPart = new QStringPath(this.withPrefix("OldPart"));
    public readonly OldPartQuantity = new QNumberPath(this.withPrefix("OldPartQuantity"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
}

export const qChangePart = new QChangePart();

export class QChangeOperation extends QNonConformanceFacet {
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly NewOperationName = new QStringPath(this.withPrefix("NewOperationName"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly OperationNameList = new QStringPath(this.withPrefix("OperationNameList"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly RoutingOperationAfter = new QStringPath(this.withPrefix("RoutingOperationAfter"));
    public readonly SequenceAfter = new QGuidPath(this.withPrefix("SequenceAfter"));
    public readonly OldOperationName = new QStringPath(this.withPrefix("OldOperationName"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
}

export const qChangeOperation = new QChangeOperation();

export class QChangeDataCollection extends QNonConformanceFacet {
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly ReferenceWorkorderOperations = new QStringPath(this.withPrefix("ReferenceWorkorderOperations"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly WIDefinition = new QStringPath(this.withPrefix("WIDefinition"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
}

export const qChangeDataCollection = new QChangeDataCollection();

export class QActualUsedToolFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualUsedTool_Id = new QGuidPath(this.withPrefix("ActualUsedTool_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualUsedTool = new QEntityPath(this.withPrefix("ActualUsedTool"), () => QActualUsedTool);
}

export const qActualUsedToolFacet = new QActualUsedToolFacet();

export class QActualUsedToolFacetId extends QId<ActualUsedToolFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityGateOnActualUsedTool extends QActualUsedToolFacet {
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
}

export const qQualityGateOnActualUsedTool = new QQualityGateOnActualUsedTool();

export class QActualConsumedMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualConsumedMaterial_Id = new QGuidPath(this.withPrefix("ActualConsumedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualConsumedMaterial = new QEntityPath(this.withPrefix("ActualConsumedMaterial"), () => QActualConsumedMaterial);
}

export const qActualConsumedMaterialFacet = new QActualConsumedMaterialFacet();

export class QActualConsumedMaterialFacetId extends QId<ActualConsumedMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityGateOnActualConsumedMaterial extends QActualConsumedMaterialFacet {
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
}

export const qQualityGateOnActualConsumedMaterial = new QQualityGateOnActualConsumedMaterial();

export class QEquipmentConfigurationToAutomationNodeInstanceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationToAutomationNodeInstance_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationToAutomationNodeInstance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationToAutomationNodeInstance = new QEntityPath(this.withPrefix("EquipmentConfigurationToAutomationNodeInstance"), () => QEquipmentConfigurationToAutomationNodeInstance);
}

export const qEquipmentConfigurationToAutomationNodeInstanceFacet = new QEquipmentConfigurationToAutomationNodeInstanceFacet();

export class QEquipmentConfigurationToAutomationNodeInstanceFacetId extends QId<EquipmentConfigurationToAutomationNodeInstanceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionOperationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly InspectionOperation_Id = new QGuidPath(this.withPrefix("InspectionOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionOperation = new QEntityPath(this.withPrefix("InspectionOperation"), () => QInspectionOperation);
}

export const qInspectionOperationFacet = new QInspectionOperationFacet();

export class QInspectionOperationFacetId extends QId<InspectionOperationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderOperationToolInfoFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationToolInfo_Id = new QGuidPath(this.withPrefix("WorkOrderOperationToolInfo_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperationToolInfo = new QEntityPath(this.withPrefix("WorkOrderOperationToolInfo"), () => QWorkOrderOperationToolInfo);
}

export const qWorkOrderOperationToolInfoFacet = new QWorkOrderOperationToolInfoFacet();

export class QWorkOrderOperationToolInfoFacetId extends QId<WorkOrderOperationToolInfoFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QScrewingToolHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ScrewingToolHistory_Id = new QGuidPath(this.withPrefix("ScrewingToolHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ScrewingToolHistory = new QEntityPath(this.withPrefix("ScrewingToolHistory"), () => QScrewingToolHistory);
}

export const qScrewingToolHistoryFacet = new QScrewingToolHistoryFacet();

export class QScrewingToolHistoryFacetId extends QId<ScrewingToolHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextUserFieldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContextUserField_Id = new QGuidPath(this.withPrefix("TaskContextUserField_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextUserField = new QEntityPath(this.withPrefix("TaskContextUserField"), () => QTaskContextUserField);
}

export const qTaskContextUserFieldFacet = new QTaskContextUserFieldFacet();

export class QTaskContextUserFieldFacetId extends QId<TaskContextUserFieldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContext_Id = new QGuidPath(this.withPrefix("TaskContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContext = new QEntityPath(this.withPrefix("TaskContext"), () => QTaskContext);
}

export const qTaskContextFacet = new QTaskContextFacet();

export class QTaskContextFacetId extends QId<TaskContextFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Task_Id = new QGuidPath(this.withPrefix("Task_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Task = new QEntityPath(this.withPrefix("Task"), () => QTask);
}

export const qTaskFacet = new QTaskFacet();

export class QTaskFacetId extends QId<TaskFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinitionUserFieldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContextDefinitionUserField_Id = new QGuidPath(this.withPrefix("TaskContextDefinitionUserField_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinitionUserField = new QEntityPath(this.withPrefix("TaskContextDefinitionUserField"), () => QTaskContextDefinitionUserField);
}

export const qTaskContextDefinitionUserFieldFacet = new QTaskContextDefinitionUserFieldFacet();

export class QTaskContextDefinitionUserFieldFacetId extends QId<TaskContextDefinitionUserFieldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskDefinition_Id = new QGuidPath(this.withPrefix("TaskDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskDefinition = new QEntityPath(this.withPrefix("TaskDefinition"), () => QTaskDefinition);
}

export const qTaskDefinitionFacet = new QTaskDefinitionFacet();

export class QTaskDefinitionFacetId extends QId<TaskDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTaskContextDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TaskContextDefinition_Id = new QGuidPath(this.withPrefix("TaskContextDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TaskContextDefinition = new QEntityPath(this.withPrefix("TaskContextDefinition"), () => QTaskContextDefinition);
}

export const qTaskContextDefinitionFacet = new QTaskContextDefinitionFacet();

export class QTaskContextDefinitionFacetId extends QId<TaskContextDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFeatureValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FeatureValue_Id = new QGuidPath(this.withPrefix("FeatureValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FeatureValue = new QEntityPath(this.withPrefix("FeatureValue"), () => QFeatureValue);
}

export const qFeatureValueFacet = new QFeatureValueFacet();

export class QFeatureValueFacetId extends QId<FeatureValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFeatureFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Feature_Id = new QGuidPath(this.withPrefix("Feature_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Feature = new QEntityPath(this.withPrefix("Feature"), () => QFeature);
}

export const qFeatureFacet = new QFeatureFacet();

export class QFeatureFacetId extends QId<FeatureFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBillOfFeatureItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BillOfFeatureItem_Id = new QGuidPath(this.withPrefix("BillOfFeatureItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BillOfFeatureItem = new QEntityPath(this.withPrefix("BillOfFeatureItem"), () => QBillOfFeatureItem);
}

export const qBillOfFeatureItemFacet = new QBillOfFeatureItemFacet();

export class QBillOfFeatureItemFacetId extends QId<BillOfFeatureItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedBillOfFeatureFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedBillOfFeature_Id = new QGuidPath(this.withPrefix("ToBeUsedBillOfFeature_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedBillOfFeature = new QEntityPath(this.withPrefix("ToBeUsedBillOfFeature"), () => QToBeUsedBillOfFeature);
}

export const qToBeUsedBillOfFeatureFacet = new QToBeUsedBillOfFeatureFacet();

export class QToBeUsedBillOfFeatureFacetId extends QId<ToBeUsedBillOfFeatureFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBillOfFeatureFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BillOfFeature_Id = new QGuidPath(this.withPrefix("BillOfFeature_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BillOfFeature = new QEntityPath(this.withPrefix("BillOfFeature"), () => QBillOfFeature);
}

export const qBillOfFeatureFacet = new QBillOfFeatureFacet();

export class QBillOfFeatureFacetId extends QId<BillOfFeatureFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternEntityInfoFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPatternEntityInfo_Id = new QGuidPath(this.withPrefix("NumberingPatternEntityInfo_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternEntityInfo = new QEntityPath(this.withPrefix("NumberingPatternEntityInfo"), () => QNumberingPatternEntityInfo);
}

export const qNumberingPatternEntityInfoFacet = new QNumberingPatternEntityInfoFacet();

export class QNumberingPatternEntityInfoFacetId extends QId<NumberingPatternEntityInfoFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternMaterialAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPatternMaterialAssociation_Id = new QGuidPath(this.withPrefix("NumberingPatternMaterialAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternMaterialAssociation = new QEntityPath(this.withPrefix("NumberingPatternMaterialAssociation"), () => QNumberingPatternMaterialAssociation);
}

export const qNumberingPatternMaterialAssociationFacet = new QNumberingPatternMaterialAssociationFacet();

export class QNumberingPatternMaterialAssociationFacetId extends QId<NumberingPatternMaterialAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventLogFailureNotificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExtEventLogFailureNotification_Id = new QGuidPath(this.withPrefix("ExtEventLogFailureNotification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventLogFailureNotification = new QEntityPath(this.withPrefix("ExtEventLogFailureNotification"), () => QExtEventLogFailureNotification);
}

export const qExtEventLogFailureNotificationFacet = new QExtEventLogFailureNotificationFacet();

export class QExtEventLogFailureNotificationFacetId extends QId<ExtEventLogFailureNotificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedSetPointItemATNInstanceAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedSetPointItemATNInstanceAssociation_Id = new QGuidPath(this.withPrefix("ToBeUsedSetPointItemATNInstanceAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedSetPointItemATNInstanceAssociation = new QEntityPath(this.withPrefix("ToBeUsedSetPointItemATNInstanceAssociation"), () => QToBeUsedSetPointItemATNInstanceAssociation);
}

export const qToBeUsedSetPointItemATNInstanceAssociationFacet = new QToBeUsedSetPointItemATNInstanceAssociationFacet();

export class QToBeUsedSetPointItemATNInstanceAssociationFacetId extends QId<ToBeUsedSetPointItemATNInstanceAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeCharReprRefOperationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimeCharReprRefOperationAssociation_Id = new QGuidPath(this.withPrefix("RuntimeCharReprRefOperationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimeCharReprRefOperationAssociation = new QEntityPath(this.withPrefix("RuntimeCharReprRefOperationAssociation"), () => QRuntimeCharReprRefOperationAssociation);
}

export const qRuntimeCharReprRefOperationAssociationFacet = new QRuntimeCharReprRefOperationAssociationFacet();

export class QRuntimeCharReprRefOperationAssociationFacetId extends QId<RuntimeCharReprRefOperationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCharacteristicRepresentationFrequencyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CharacteristicRepresentationFrequency_Id = new QGuidPath(this.withPrefix("CharacteristicRepresentationFrequency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicRepresentationFrequency = new QEntityPath(this.withPrefix("CharacteristicRepresentationFrequency"), () => QCharacteristicRepresentationFrequency);
}

export const qCharacteristicRepresentationFrequencyFacet = new QCharacteristicRepresentationFrequencyFacet();

export class QCharacteristicRepresentationFrequencyFacetId extends QId<CharacteristicRepresentationFrequencyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSignatureConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SignatureConfiguration_Id = new QGuidPath(this.withPrefix("SignatureConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SignatureConfiguration = new QEntityPath(this.withPrefix("SignatureConfiguration"), () => QSignatureConfiguration);
}

export const qSignatureConfigurationFacet = new QSignatureConfigurationFacet();

export class QSignatureConfigurationFacetId extends QId<SignatureConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QScenarioConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ScenarioConfiguration_Id = new QGuidPath(this.withPrefix("ScenarioConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ScenarioConfiguration = new QEntityPath(this.withPrefix("ScenarioConfiguration"), () => QScenarioConfiguration);
}

export const qScenarioConfigurationFacet = new QScenarioConfigurationFacet();

export class QScenarioConfigurationFacetId extends QId<ScenarioConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOutMsgFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OutMsg_Id = new QGuidPath(this.withPrefix("OutMsg_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OutMsg = new QEntityPath(this.withPrefix("OutMsg"), () => QOutMsg);
}

export const qOutMsgFacet = new QOutMsgFacet();

export class QOutMsgFacetId extends QId<OutMsgFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_FunctionalCodeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_FunctionalCode_Id = new QGuidPath(this.withPrefix("DM_FunctionalCode_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_FunctionalCode = new QEntityPath(this.withPrefix("DM_FunctionalCode"), () => QDM_FunctionalCode);
}

export const qDM_FunctionalCodeFacet = new QDM_FunctionalCodeFacet();

export class QDM_FunctionalCodeFacetId extends QId<DM_FunctionalCodeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialSupplierAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialSupplierAssociation_Id = new QGuidPath(this.withPrefix("MaterialSupplierAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialSupplierAssociation = new QEntityPath(this.withPrefix("MaterialSupplierAssociation"), () => QMaterialSupplierAssociation);
}

export const qMaterialSupplierAssociationFacet = new QMaterialSupplierAssociationFacet();

export class QMaterialSupplierAssociationFacetId extends QId<MaterialSupplierAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionToExecutionGroupPhaseAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionToExecutionGroupPhaseAssociation_Id = new QGuidPath(this.withPrefix("WorkInstructionToExecutionGroupPhaseAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionToExecutionGroupPhaseAssociation = new QEntityPath(this.withPrefix("WorkInstructionToExecutionGroupPhaseAssociation"), () => QWorkInstructionToExecutionGroupPhaseAssociation);
}

export const qWorkInstructionToExecutionGroupPhaseAssociationFacet = new QWorkInstructionToExecutionGroupPhaseAssociationFacet();

export class QWorkInstructionToExecutionGroupPhaseAssociationFacetId extends QId<WorkInstructionToExecutionGroupPhaseAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIDefinitionToEGPhaseAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WIDefinitionToEGPhaseAssociation_Id = new QGuidPath(this.withPrefix("WIDefinitionToEGPhaseAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WIDefinitionToEGPhaseAssociation = new QEntityPath(this.withPrefix("WIDefinitionToEGPhaseAssociation"), () => QWIDefinitionToEGPhaseAssociation);
}

export const qWIDefinitionToEGPhaseAssociationFacet = new QWIDefinitionToEGPhaseAssociationFacet();

export class QWIDefinitionToEGPhaseAssociationFacetId extends QId<WIDefinitionToEGPhaseAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ResultType_Id = new QGuidPath(this.withPrefix("ResultType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ResultType = new QEntityPath(this.withPrefix("ResultType"), () => QResultType);
}

export const qResultTypeFacet = new QResultTypeFacet();

export class QResultTypeFacetId extends QId<ResultTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultStrategyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ResultStrategy_Id = new QGuidPath(this.withPrefix("ResultStrategy_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ResultStrategy = new QEntityPath(this.withPrefix("ResultStrategy"), () => QResultStrategy);
}

export const qResultStrategyFacet = new QResultStrategyFacet();

export class QResultStrategyFacetId extends QId<ResultStrategyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ResultHistoryAction_Id = new QGuidPath(this.withPrefix("ResultHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ResultHistoryAction = new QEntityPath(this.withPrefix("ResultHistoryAction"), () => QResultHistoryAction);
}

export const qResultHistoryActionFacet = new QResultHistoryActionFacet();

export class QResultHistoryActionFacetId extends QId<ResultHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ResultHistory_Id = new QGuidPath(this.withPrefix("ResultHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ResultHistory = new QEntityPath(this.withPrefix("ResultHistory"), () => QResultHistory);
}

export const qResultHistoryFacet = new QResultHistoryFacet();

export class QResultHistoryFacetId extends QId<ResultHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QResultFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Result_Id = new QGuidPath(this.withPrefix("Result_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Result = new QEntityPath(this.withPrefix("Result"), () => QResult);
}

export const qResultFacet = new QResultFacet();

export class QResultFacetId extends QId<ResultFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerCompatibleMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContainerCompatibleMaterial_Id = new QGuidPath(this.withPrefix("ContainerCompatibleMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerCompatibleMaterial = new QEntityPath(this.withPrefix("ContainerCompatibleMaterial"), () => QContainerCompatibleMaterial);
}

export const qContainerCompatibleMaterialFacet = new QContainerCompatibleMaterialFacet();

export class QContainerCompatibleMaterialFacetId extends QId<ContainerCompatibleMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAttachmentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Attachment_Id = new QGuidPath(this.withPrefix("Attachment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Attachment = new QEntityPath(this.withPrefix("Attachment"), () => QAttachment);
}

export const qAttachmentFacet = new QAttachmentFacet();

export class QAttachmentFacetId extends QId<AttachmentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QQualityActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly QualityAction_Id = new QGuidPath(this.withPrefix("QualityAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly QualityAction = new QEntityPath(this.withPrefix("QualityAction"), () => QQualityAction);
}

export const qQualityActionFacet = new QQualityActionFacet();

export class QQualityActionFacetId extends QId<QualityActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureReferenceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FailureReference_Id = new QGuidPath(this.withPrefix("FailureReference_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FailureReference = new QEntityPath(this.withPrefix("FailureReference"), () => QFailureReference);
}

export const qFailureReferenceFacet = new QFailureReferenceFacet();

export class QFailureReferenceFacetId extends QId<FailureReferenceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureParentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FailureParent_Id = new QGuidPath(this.withPrefix("FailureParent_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FailureParent = new QEntityPath(this.withPrefix("FailureParent"), () => QFailureParent);
}

export const qFailureParentFacet = new QFailureParentFacet();

export class QFailureParentFacetId extends QId<FailureParentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureChildFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FailureChild_Id = new QGuidPath(this.withPrefix("FailureChild_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FailureChild = new QEntityPath(this.withPrefix("FailureChild"), () => QFailureChild);
}

export const qFailureChildFacet = new QFailureChildFacet();

export class QFailureChildFacetId extends QId<FailureChildFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFailureFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Failure_Id = new QGuidPath(this.withPrefix("Failure_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Failure = new QEntityPath(this.withPrefix("Failure"), () => QFailure);
}

export const qFailureFacet = new QFailureFacet();

export class QFailureFacetId extends QId<FailureFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtObjectTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExtObjectType_Id = new QGuidPath(this.withPrefix("ExtObjectType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtObjectType = new QEntityPath(this.withPrefix("ExtObjectType"), () => QExtObjectType);
}

export const qExtObjectTypeFacet = new QExtObjectTypeFacet();

export class QExtObjectTypeFacetId extends QId<ExtObjectTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventContextFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExtEventContext_Id = new QGuidPath(this.withPrefix("ExtEventContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventContext = new QEntityPath(this.withPrefix("ExtEventContext"), () => QExtEventContext);
}

export const qExtEventContextFacet = new QExtEventContextFacet();

export class QExtEventContextFacetId extends QId<ExtEventContextFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExtEventType_Id = new QGuidPath(this.withPrefix("ExtEventType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventType = new QEntityPath(this.withPrefix("ExtEventType"), () => QExtEventType);
}

export const qExtEventTypeFacet = new QExtEventTypeFacet();

export class QExtEventTypeFacetId extends QId<ExtEventTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExtEventLogFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExtEventLog_Id = new QGuidPath(this.withPrefix("ExtEventLog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExtEventLog = new QEntityPath(this.withPrefix("ExtEventLog"), () => QExtEventLog);
}

export const qExtEventLogFacet = new QExtEventLogFacet();

export class QExtEventLogFacetId extends QId<ExtEventLogFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerTypeDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContainerTypeDocument_Id = new QGuidPath(this.withPrefix("ContainerTypeDocument_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerTypeDocument = new QEntityPath(this.withPrefix("ContainerTypeDocument"), () => QContainerTypeDocument);
}

export const qContainerTypeDocumentFacet = new QContainerTypeDocumentFacet();

export class QContainerTypeDocumentFacetId extends QId<ContainerTypeDocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerTypeCompatibleMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContainerTypeCompatibleMaterial_Id = new QGuidPath(this.withPrefix("ContainerTypeCompatibleMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerTypeCompatibleMaterial = new QEntityPath(this.withPrefix("ContainerTypeCompatibleMaterial"), () => QContainerTypeCompatibleMaterial);
}

export const qContainerTypeCompatibleMaterialFacet = new QContainerTypeCompatibleMaterialFacet();

export class QContainerTypeCompatibleMaterialFacetId extends QId<ContainerTypeCompatibleMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QContainerTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ContainerType_Id = new QGuidPath(this.withPrefix("ContainerType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ContainerType = new QEntityPath(this.withPrefix("ContainerType"), () => QContainerType);
}

export const qContainerTypeFacet = new QContainerTypeFacet();

export class QContainerTypeFacetId extends QId<ContainerTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineActionAmendFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OfflineActionAmend_Id = new QGuidPath(this.withPrefix("OfflineActionAmend_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineActionAmend = new QEntityPath(this.withPrefix("OfflineActionAmend"), () => QOfflineActionAmend);
}

export const qOfflineActionAmendFacet = new QOfflineActionAmendFacet();

export class QOfflineActionAmendFacetId extends QId<OfflineActionAmendFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OfflineAction_Id = new QGuidPath(this.withPrefix("OfflineAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineAction = new QEntityPath(this.withPrefix("OfflineAction"), () => QOfflineAction);
}

export const qOfflineActionFacet = new QOfflineActionFacet();

export class QOfflineActionFacetId extends QId<OfflineActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineSessionWOOperationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OfflineSessionWOOperationAssociation_Id = new QGuidPath(this.withPrefix("OfflineSessionWOOperationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineSessionWOOperationAssociation = new QEntityPath(this.withPrefix("OfflineSessionWOOperationAssociation"), () => QOfflineSessionWOOperationAssociation);
}

export const qOfflineSessionWOOperationAssociationFacet = new QOfflineSessionWOOperationAssociationFacet();

export class QOfflineSessionWOOperationAssociationFacetId extends QId<OfflineSessionWOOperationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOfflineSessionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OfflineSession_Id = new QGuidPath(this.withPrefix("OfflineSession_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OfflineSession = new QEntityPath(this.withPrefix("OfflineSession"), () => QOfflineSession);
}

export const qOfflineSessionFacet = new QOfflineSessionFacet();

export class QOfflineSessionFacetId extends QId<OfflineSessionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_MaterialTrackingUnitDocumentAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnitDocumentAssociation_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitDocumentAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnitDocumentAssociation = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnitDocumentAssociation"), () => QDM_MaterialTrackingUnitDocumentAssociation);
}

export const qDM_MaterialTrackingUnitDocumentAssociationFacet = new QDM_MaterialTrackingUnitDocumentAssociationFacet();

export class QDM_MaterialTrackingUnitDocumentAssociationFacetId extends QId<DM_MaterialTrackingUnitDocumentAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderHumanResourceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderHumanResource_Id = new QGuidPath(this.withPrefix("WorkOrderHumanResource_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderHumanResource = new QEntityPath(this.withPrefix("WorkOrderHumanResource"), () => QWorkOrderHumanResource);
}

export const qWorkOrderHumanResourceFacet = new QWorkOrderHumanResourceFacet();

export class QWorkOrderHumanResourceFacetId extends QId<WorkOrderHumanResourceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualCoProducedMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualCoProducedMaterial_Id = new QGuidPath(this.withPrefix("ActualCoProducedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualCoProducedMaterial = new QEntityPath(this.withPrefix("ActualCoProducedMaterial"), () => QActualCoProducedMaterial);
}

export const qActualCoProducedMaterialFacet = new QActualCoProducedMaterialFacet();

export class QActualCoProducedMaterialFacetId extends QId<ActualCoProducedMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeCoProducedMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeCoProducedMaterial_Id = new QGuidPath(this.withPrefix("ToBeCoProducedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeCoProducedMaterial = new QEntityPath(this.withPrefix("ToBeCoProducedMaterial"), () => QToBeCoProducedMaterial);
}

export const qToBeCoProducedMaterialFacet = new QToBeCoProducedMaterialFacet();

export class QToBeCoProducedMaterialFacetId extends QId<ToBeCoProducedMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CertificationSpecification_Id = new QGuidPath(this.withPrefix("CertificationSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CertificationSpecification = new QEntityPath(this.withPrefix("CertificationSpecification"), () => QCertificationSpecification);
}

export const qCertificationSpecificationFacet = new QCertificationSpecificationFacet();

export class QCertificationSpecificationFacetId extends QId<CertificationSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserWorkOrderOperationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserWorkOrderOperationAssociation_Id = new QGuidPath(this.withPrefix("UserWorkOrderOperationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UserWorkOrderOperationAssociation = new QEntityPath(this.withPrefix("UserWorkOrderOperationAssociation"), () => QUserWorkOrderOperationAssociation);
}

export const qUserWorkOrderOperationAssociationFacet = new QUserWorkOrderOperationAssociationFacet();

export class QUserWorkOrderOperationAssociationFacetId extends QId<UserWorkOrderOperationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimePJFSerialNumberAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimePJFSerialNumberAssociation_Id = new QGuidPath(this.withPrefix("RuntimePJFSerialNumberAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimePJFSerialNumberAssociation = new QEntityPath(this.withPrefix("RuntimePJFSerialNumberAssociation"), () => QRuntimePJFSerialNumberAssociation);
}

export const qRuntimePJFSerialNumberAssociationFacet = new QRuntimePJFSerialNumberAssociationFacet();

export class QRuntimePJFSerialNumberAssociationFacetId extends QId<RuntimePJFSerialNumberAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemToolDefinitionATNTypeParameterAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointItemToolDefinitionATNTypeParameterAssociation_Id = new QGuidPath(this.withPrefix("SetPointItemToolDefinitionATNTypeParameterAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItemToolDefinitionATNTypeParameterAssociation = new QEntityPath(this.withPrefix("SetPointItemToolDefinitionATNTypeParameterAssociation"), () => QSetPointItemToolDefinitionATNTypeParameterAssociation);
}

export const qSetPointItemToolDefinitionATNTypeParameterAssociationFacet = new QSetPointItemToolDefinitionATNTypeParameterAssociationFacet();

export class QSetPointItemToolDefinitionATNTypeParameterAssociationFacetId extends QId<SetPointItemToolDefinitionATNTypeParameterAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMachineToDNCFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MachineToDNC_Id = new QGuidPath(this.withPrefix("MachineToDNC_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MachineToDNC = new QEntityPath(this.withPrefix("MachineToDNC"), () => QMachineToDNC);
}

export const qMachineToDNCFacet = new QMachineToDNCFacet();

export class QMachineToDNCFacetId extends QId<MachineToDNCFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDNCItemMachineMaterialAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DNCItemMachineMaterialAssociation_Id = new QGuidPath(this.withPrefix("DNCItemMachineMaterialAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DNCItemMachineMaterialAssociation = new QEntityPath(this.withPrefix("DNCItemMachineMaterialAssociation"), () => QDNCItemMachineMaterialAssociation);
}

export const qDNCItemMachineMaterialAssociationFacet = new QDNCItemMachineMaterialAssociationFacet();

export class QDNCItemMachineMaterialAssociationFacetId extends QId<DNCItemMachineMaterialAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDNCItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DNCItem_Id = new QGuidPath(this.withPrefix("DNCItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DNCItem = new QEntityPath(this.withPrefix("DNCItem"), () => QDNCItem);
}

export const qDNCItemFacet = new QDNCItemFacet();

export class QDNCItemFacetId extends QId<DNCItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeTypeParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeTypeParameter_Id = new QGuidPath(this.withPrefix("AutomationNodeTypeParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeTypeParameter = new QEntityPath(this.withPrefix("AutomationNodeTypeParameter"), () => QAutomationNodeTypeParameter);
}

export const qAutomationNodeTypeParameterFacet = new QAutomationNodeTypeParameterFacet();

export class QAutomationNodeTypeParameterFacetId extends QId<AutomationNodeTypeParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeType_Id = new QGuidPath(this.withPrefix("AutomationNodeType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeType = new QEntityPath(this.withPrefix("AutomationNodeType"), () => QAutomationNodeType);
}

export const qAutomationNodeTypeFacet = new QAutomationNodeTypeFacet();

export class QAutomationNodeTypeFacetId extends QId<AutomationNodeTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeInstanceParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeInstanceParameter_Id = new QGuidPath(this.withPrefix("AutomationNodeInstanceParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeInstanceParameter = new QEntityPath(this.withPrefix("AutomationNodeInstanceParameter"), () => QAutomationNodeInstanceParameter);
}

export const qAutomationNodeInstanceParameterFacet = new QAutomationNodeInstanceParameterFacet();

export class QAutomationNodeInstanceParameterFacetId extends QId<AutomationNodeInstanceParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAutomationNodeInstanceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeInstance_Id = new QGuidPath(this.withPrefix("AutomationNodeInstance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeInstance = new QEntityPath(this.withPrefix("AutomationNodeInstance"), () => QAutomationNodeInstance);
}

export const qAutomationNodeInstanceFacet = new QAutomationNodeInstanceFacet();

export class QAutomationNodeInstanceFacetId extends QId<AutomationNodeInstanceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointEquipmentTypeAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointEquipmentTypeAssociation_Id = new QGuidPath(this.withPrefix("SetPointEquipmentTypeAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointEquipmentTypeAssociation = new QEntityPath(this.withPrefix("SetPointEquipmentTypeAssociation"), () => QSetPointEquipmentTypeAssociation);
}

export const qSetPointEquipmentTypeAssociationFacet = new QSetPointEquipmentTypeAssociationFacet();

export class QSetPointEquipmentTypeAssociationFacetId extends QId<SetPointEquipmentTypeAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointToolAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointToolAssociation_Id = new QGuidPath(this.withPrefix("SetPointToolAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointToolAssociation = new QEntityPath(this.withPrefix("SetPointToolAssociation"), () => QSetPointToolAssociation);
}

export const qSetPointToolAssociationFacet = new QSetPointToolAssociationFacet();

export class QSetPointToolAssociationFacetId extends QId<SetPointToolAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointToolDefinitionAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointToolDefinitionAssociation_Id = new QGuidPath(this.withPrefix("SetPointToolDefinitionAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointToolDefinitionAssociation = new QEntityPath(this.withPrefix("SetPointToolDefinitionAssociation"), () => QSetPointToolDefinitionAssociation);
}

export const qSetPointToolDefinitionAssociationFacet = new QSetPointToolDefinitionAssociationFacet();

export class QSetPointToolDefinitionAssociationFacetId extends QId<SetPointToolDefinitionAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolAutomationNodeInstanceAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolAutomationNodeInstanceAssociation_Id = new QGuidPath(this.withPrefix("ToolAutomationNodeInstanceAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolAutomationNodeInstanceAssociation = new QEntityPath(this.withPrefix("ToolAutomationNodeInstanceAssociation"), () => QToolAutomationNodeInstanceAssociation);
}

export const qToolAutomationNodeInstanceAssociationFacet = new QToolAutomationNodeInstanceAssociationFacet();

export class QToolAutomationNodeInstanceAssociationFacetId extends QId<ToolAutomationNodeInstanceAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionAutomationNodeTypeAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolDefinitionAutomationNodeTypeAssociation_Id = new QGuidPath(this.withPrefix("ToolDefinitionAutomationNodeTypeAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinitionAutomationNodeTypeAssociation = new QEntityPath(this.withPrefix("ToolDefinitionAutomationNodeTypeAssociation"), () => QToolDefinitionAutomationNodeTypeAssociation);
}

export const qToolDefinitionAutomationNodeTypeAssociationFacet = new QToolDefinitionAutomationNodeTypeAssociationFacet();

export class QToolDefinitionAutomationNodeTypeAssociationFacetId extends QId<ToolDefinitionAutomationNodeTypeAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemDefaultValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointItemDefaultValue_Id = new QGuidPath(this.withPrefix("SetPointItemDefaultValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItemDefaultValue = new QEntityPath(this.withPrefix("SetPointItemDefaultValue"), () => QSetPointItemDefaultValue);
}

export const qSetPointItemDefaultValueFacet = new QSetPointItemDefaultValueFacet();

export class QSetPointItemDefaultValueFacetId extends QId<SetPointItemDefaultValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemATNInstanceAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointItemATNInstanceAssociation_Id = new QGuidPath(this.withPrefix("SetPointItemATNInstanceAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItemATNInstanceAssociation = new QEntityPath(this.withPrefix("SetPointItemATNInstanceAssociation"), () => QSetPointItemATNInstanceAssociation);
}

export const qSetPointItemATNInstanceAssociationFacet = new QSetPointItemATNInstanceAssociationFacet();

export class QSetPointItemATNInstanceAssociationFacetId extends QId<SetPointItemATNInstanceAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointItem_Id = new QGuidPath(this.withPrefix("SetPointItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointItem = new QEntityPath(this.withPrefix("SetPointItem"), () => QSetPointItem);
}

export const qSetPointItemFacet = new QSetPointItemFacet();

export class QSetPointItemFacetId extends QId<SetPointItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointEquipmentAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPointEquipmentAssociation_Id = new QGuidPath(this.withPrefix("SetPointEquipmentAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPointEquipmentAssociation = new QEntityPath(this.withPrefix("SetPointEquipmentAssociation"), () => QSetPointEquipmentAssociation);
}

export const qSetPointEquipmentAssociationFacet = new QSetPointEquipmentAssociationFacet();

export class QSetPointEquipmentAssociationFacetId extends QId<SetPointEquipmentAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSetPointFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SetPoint_Id = new QGuidPath(this.withPrefix("SetPoint_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SetPoint = new QEntityPath(this.withPrefix("SetPoint"), () => QSetPoint);
}

export const qSetPointFacet = new QSetPointFacet();

export class QSetPointFacetId extends QId<SetPointFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedMachinePJFFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedMachinePJF_Id = new QGuidPath(this.withPrefix("ToBeUsedMachinePJF_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedMachinePJF = new QEntityPath(this.withPrefix("ToBeUsedMachinePJF"), () => QToBeUsedMachinePJF);
}

export const qToBeUsedMachinePJFFacet = new QToBeUsedMachinePJFFacet();

export class QToBeUsedMachinePJFFacetId extends QId<ToBeUsedMachinePJFFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedMachinePJFFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualUsedMachinePJF_Id = new QGuidPath(this.withPrefix("ActualUsedMachinePJF_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualUsedMachinePJF = new QEntityPath(this.withPrefix("ActualUsedMachinePJF"), () => QActualUsedMachinePJF);
}

export const qActualUsedMachinePJFFacet = new QActualUsedMachinePJFFacet();

export class QActualUsedMachinePJFFacetId extends QId<ActualUsedMachinePJFFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDSParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DSParameter_Id = new QGuidPath(this.withPrefix("DSParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DSParameter = new QEntityPath(this.withPrefix("DSParameter"), () => QDSParameter);
}

export const qDSParameterFacet = new QDSParameterFacet();

export class QDSParameterFacetId extends QId<DSParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDiscreteAutomationNodeDataTypeMappingFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DiscreteAutomationNodeDataTypeMapping_Id = new QGuidPath(this.withPrefix("DiscreteAutomationNodeDataTypeMapping_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DiscreteAutomationNodeDataTypeMapping = new QEntityPath(this.withPrefix("DiscreteAutomationNodeDataTypeMapping"), () => QDiscreteAutomationNodeDataTypeMapping);
}

export const qDiscreteAutomationNodeDataTypeMappingFacet = new QDiscreteAutomationNodeDataTypeMappingFacet();

export class QDiscreteAutomationNodeDataTypeMappingFacetId extends QId<DiscreteAutomationNodeDataTypeMappingFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessToOpLinkDependencyNavigationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessToOpLinkDependencyNavigation_Id = new QGuidPath(this.withPrefix("ProcessToOpLinkDependencyNavigation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessToOpLinkDependencyNavigation = new QEntityPath(this.withPrefix("ProcessToOpLinkDependencyNavigation"), () => QProcessToOpLinkDependencyNavigation);
}

export const qProcessToOpLinkDependencyNavigationFacet = new QProcessToOpLinkDependencyNavigationFacet();

export class QProcessToOpLinkDependencyNavigationFacetId extends QId<ProcessToOpLinkDependencyNavigationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileEquipmentTypeAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFileEquipmentTypeAssociation_Id = new QGuidPath(this.withPrefix("PrintJobFileEquipmentTypeAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFileEquipmentTypeAssociation = new QEntityPath(this.withPrefix("PrintJobFileEquipmentTypeAssociation"), () => QPrintJobFileEquipmentTypeAssociation);
}

export const qPrintJobFileEquipmentTypeAssociationFacet = new QPrintJobFileEquipmentTypeAssociationFacet();

export class QPrintJobFileEquipmentTypeAssociationFacetId extends QId<PrintJobFileEquipmentTypeAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileEquipmentAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFileEquipmentAssociation_Id = new QGuidPath(this.withPrefix("PrintJobFileEquipmentAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFileEquipmentAssociation = new QEntityPath(this.withPrefix("PrintJobFileEquipmentAssociation"), () => QPrintJobFileEquipmentAssociation);
}

export const qPrintJobFileEquipmentAssociationFacet = new QPrintJobFileEquipmentAssociationFacet();

export class QPrintJobFileEquipmentAssociationFacetId extends QId<PrintJobFileEquipmentAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileDM_MaterialAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFileDM_MaterialAssociation_Id = new QGuidPath(this.withPrefix("PrintJobFileDM_MaterialAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFileDM_MaterialAssociation = new QEntityPath(this.withPrefix("PrintJobFileDM_MaterialAssociation"), () => QPrintJobFileDM_MaterialAssociation);
}

export const qPrintJobFileDM_MaterialAssociationFacet = new QPrintJobFileDM_MaterialAssociationFacet();

export class QPrintJobFileDM_MaterialAssociationFacetId extends QId<PrintJobFileDM_MaterialAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMPowderBatchGenealogyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AMPowderBatchGenealogy_Id = new QGuidPath(this.withPrefix("AMPowderBatchGenealogy_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AMPowderBatchGenealogy = new QEntityPath(this.withPrefix("AMPowderBatchGenealogy"), () => QAMPowderBatchGenealogy);
}

export const qAMPowderBatchGenealogyFacet = new QAMPowderBatchGenealogyFacet();

export class QAMPowderBatchGenealogyFacetId extends QId<AMPowderBatchGenealogyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QVisualDetectedFailureFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly VisualDetectedFailure_Id = new QGuidPath(this.withPrefix("VisualDetectedFailure_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly VisualDetectedFailure = new QEntityPath(this.withPrefix("VisualDetectedFailure"), () => QVisualDetectedFailure);
}

export const qVisualDetectedFailureFacet = new QVisualDetectedFailureFacet();

export class QVisualDetectedFailureFacetId extends QId<VisualDetectedFailureFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionSampleFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly InspectionSample_Id = new QGuidPath(this.withPrefix("InspectionSample_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionSample = new QEntityPath(this.withPrefix("InspectionSample"), () => QInspectionSample);
}

export const qInspectionSampleFacet = new QInspectionSampleFacet();

export class QInspectionSampleFacetId extends QId<InspectionSampleFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionAcquisitionContextFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly InspectionAcquisitionContext_Id = new QGuidPath(this.withPrefix("InspectionAcquisitionContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionAcquisitionContext = new QEntityPath(this.withPrefix("InspectionAcquisitionContext"), () => QInspectionAcquisitionContext);
}

export const qInspectionAcquisitionContextFacet = new QInspectionAcquisitionContextFacet();

export class QInspectionAcquisitionContextFacetId extends QId<InspectionAcquisitionContextFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderStepSkillFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderStepSkill_Id = new QGuidPath(this.withPrefix("WorkOrderStepSkill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderStepSkill = new QEntityPath(this.withPrefix("WorkOrderStepSkill"), () => QWorkOrderStepSkill);
}

export const qWorkOrderStepSkillFacet = new QWorkOrderStepSkillFacet();

export class QWorkOrderStepSkillFacetId extends QId<WorkOrderStepSkillFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWOOpDependencyNavigationMTUAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WOOpDependencyNavigationMTUAssociation_Id = new QGuidPath(this.withPrefix("WOOpDependencyNavigationMTUAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WOOpDependencyNavigationMTUAssociation = new QEntityPath(this.withPrefix("WOOpDependencyNavigationMTUAssociation"), () => QWOOpDependencyNavigationMTUAssociation);
}

export const qWOOpDependencyNavigationMTUAssociationFacet = new QWOOpDependencyNavigationMTUAssociationFacet();

export class QWOOpDependencyNavigationMTUAssociationFacetId extends QId<WOOpDependencyNavigationMTUAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWOOpDependencyNavigationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WOOpDependencyNavigation_Id = new QGuidPath(this.withPrefix("WOOpDependencyNavigation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WOOpDependencyNavigation = new QEntityPath(this.withPrefix("WOOpDependencyNavigation"), () => QWOOpDependencyNavigation);
}

export const qWOOpDependencyNavigationFacet = new QWOOpDependencyNavigationFacet();

export class QWOOpDependencyNavigationFacetId extends QId<WOOpDependencyNavigationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStepSkillFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StepSkill_Id = new QGuidPath(this.withPrefix("StepSkill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StepSkill = new QEntityPath(this.withPrefix("StepSkill"), () => QStepSkill);
}

export const qStepSkillFacet = new QStepSkillFacet();

export class QStepSkillFacetId extends QId<StepSkillFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationToStepLinkAssociationParameterValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckOperationToStepLinkAssociationParameterValue_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationParameterValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckOperationToStepLinkAssociationParameterValue = new QEntityPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationParameterValue"), () => QItlkCheckOperationToStepLinkAssociationParameterValue);
}

export const qItlkCheckOperationToStepLinkAssociationParameterValueFacet = new QItlkCheckOperationToStepLinkAssociationParameterValueFacet();

export class QItlkCheckOperationToStepLinkAssociationParameterValueFacetId extends QId<ItlkCheckOperationToStepLinkAssociationParameterValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationToStepLinkAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckOperationToStepLinkAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckOperationToStepLinkAssociation = new QEntityPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociation"), () => QItlkCheckOperationToStepLinkAssociation);
}

export const qItlkCheckOperationToStepLinkAssociationFacet = new QItlkCheckOperationToStepLinkAssociationFacet();

export class QItlkCheckOperationToStepLinkAssociationFacetId extends QId<ItlkCheckOperationToStepLinkAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinitionToStepAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionDefinitionToStepAssociation_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinitionToStepAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionDefinitionToStepAssociation = new QEntityPath(this.withPrefix("WorkInstructionDefinitionToStepAssociation"), () => QWorkInstructionDefinitionToStepAssociation);
}

export const qWorkInstructionDefinitionToStepAssociationFacet = new QWorkInstructionDefinitionToStepAssociationFacet();

export class QWorkInstructionDefinitionToStepAssociationFacetId extends QId<WorkInstructionDefinitionToStepAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWIDefinitionToWOStepAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WIDefinitionToWOStepAssociation_Id = new QGuidPath(this.withPrefix("WIDefinitionToWOStepAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WIDefinitionToWOStepAssociation = new QEntityPath(this.withPrefix("WIDefinitionToWOStepAssociation"), () => QWIDefinitionToWOStepAssociation);
}

export const qWIDefinitionToWOStepAssociationFacet = new QWIDefinitionToWOStepAssociationFacet();

export class QWIDefinitionToWOStepAssociationFacetId extends QId<WIDefinitionToWOStepAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionToWorkOrderStepAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionToWorkOrderStepAssociation_Id = new QGuidPath(this.withPrefix("WorkInstructionToWorkOrderStepAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionToWorkOrderStepAssociation = new QEntityPath(this.withPrefix("WorkInstructionToWorkOrderStepAssociation"), () => QWorkInstructionToWorkOrderStepAssociation);
}

export const qWorkInstructionToWorkOrderStepAssociationFacet = new QWorkInstructionToWorkOrderStepAssociationFacet();

export class QWorkInstructionToWorkOrderStepAssociationFacetId extends QId<WorkInstructionToWorkOrderStepAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeCharacteristicRepresentationContainerFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimeCharacteristicRepresentationContainer_Id = new QGuidPath(this.withPrefix("RuntimeCharacteristicRepresentationContainer_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimeCharacteristicRepresentationContainer = new QEntityPath(this.withPrefix("RuntimeCharacteristicRepresentationContainer"), () => QRuntimeCharacteristicRepresentationContainer);
}

export const qRuntimeCharacteristicRepresentationContainerFacet = new QRuntimeCharacteristicRepresentationContainerFacet();

export class QRuntimeCharacteristicRepresentationContainerFacetId extends QId<RuntimeCharacteristicRepresentationContainerFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedInspectionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedInspection_Id = new QGuidPath(this.withPrefix("ToBeUsedInspection_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedInspection = new QEntityPath(this.withPrefix("ToBeUsedInspection"), () => QToBeUsedInspection);
}

export const qToBeUsedInspectionFacet = new QToBeUsedInspectionFacet();

export class QToBeUsedInspectionFacetId extends QId<ToBeUsedInspectionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedInspectionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualUsedInspection_Id = new QGuidPath(this.withPrefix("ActualUsedInspection_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualUsedInspection = new QEntityPath(this.withPrefix("ActualUsedInspection"), () => QActualUsedInspection);
}

export const qActualUsedInspectionFacet = new QActualUsedInspectionFacet();

export class QActualUsedInspectionFacetId extends QId<ActualUsedInspectionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOStepAssociationParameterValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckWOStepAssociationParameterValue_Id = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociationParameterValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckWOStepAssociationParameterValue = new QEntityPath(this.withPrefix("ItlkCheckWOStepAssociationParameterValue"), () => QItlkCheckWOStepAssociationParameterValue);
}

export const qItlkCheckWOStepAssociationParameterValueFacet = new QItlkCheckWOStepAssociationParameterValueFacet();

export class QItlkCheckWOStepAssociationParameterValueFacetId extends QId<ItlkCheckWOStepAssociationParameterValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOStepAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckWOStepAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckWOStepAssociation = new QEntityPath(this.withPrefix("ItlkCheckWOStepAssociation"), () => QItlkCheckWOStepAssociation);
}

export const qItlkCheckWOStepAssociationFacet = new QItlkCheckWOStepAssociationFacet();

export class QItlkCheckWOStepAssociationFacetId extends QId<ItlkCheckWOStepAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCriticalityFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Criticality_Id = new QGuidPath(this.withPrefix("Criticality_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Criticality = new QEntityPath(this.withPrefix("Criticality"), () => QCriticality);
}

export const qCriticalityFacet = new QCriticalityFacet();

export class QCriticalityFacetId extends QId<CriticalityFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPSAlertFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APSAlert_Id = new QGuidPath(this.withPrefix("APSAlert_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APSAlert = new QEntityPath(this.withPrefix("APSAlert"), () => QAPSAlert);
}

export const qAPSAlertFacet = new QAPSAlertFacet();

export class QAPSAlertFacetId extends QId<APSAlertFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCharacteristicRepresentationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CharacteristicRepresentation_Id = new QGuidPath(this.withPrefix("CharacteristicRepresentation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicRepresentation = new QEntityPath(this.withPrefix("CharacteristicRepresentation"), () => QCharacteristicRepresentation);
}

export const qCharacteristicRepresentationFacet = new QCharacteristicRepresentationFacet();

export class QCharacteristicRepresentationFacetId extends QId<CharacteristicRepresentationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCharacteristicFailureAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CharacteristicFailureAssociation_Id = new QGuidPath(this.withPrefix("CharacteristicFailureAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CharacteristicFailureAssociation = new QEntityPath(this.withPrefix("CharacteristicFailureAssociation"), () => QCharacteristicFailureAssociation);
}

export const qCharacteristicFailureAssociationFacet = new QCharacteristicFailureAssociationFacet();

export class QCharacteristicFailureAssociationFacetId extends QId<CharacteristicFailureAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBoMItemGroupTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BoMItemGroupType_Id = new QGuidPath(this.withPrefix("BoMItemGroupType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BoMItemGroupType = new QEntityPath(this.withPrefix("BoMItemGroupType"), () => QBoMItemGroupType);
}

export const qBoMItemGroupTypeFacet = new QBoMItemGroupTypeFacet();

export class QBoMItemGroupTypeFacetId extends QId<BoMItemGroupTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBoMItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BoMItem_Id = new QGuidPath(this.withPrefix("BoMItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BoMItem = new QEntityPath(this.withPrefix("BoMItem"), () => QBoMItem);
}

export const qBoMItemFacet = new QBoMItemFacet();

export class QBoMItemFacetId extends QId<BoMItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationStepCategoryAssociationParameterValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckOperationStepCategoryAssociationParameterValue_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationParameterValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckOperationStepCategoryAssociationParameterValue = new QEntityPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationParameterValue"), () => QItlkCheckOperationStepCategoryAssociationParameterValue);
}

export const qItlkCheckOperationStepCategoryAssociationParameterValueFacet = new QItlkCheckOperationStepCategoryAssociationParameterValueFacet();

export class QItlkCheckOperationStepCategoryAssociationParameterValueFacetId extends QId<ItlkCheckOperationStepCategoryAssociationParameterValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckOperationStepCategoryAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckOperationStepCategoryAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckOperationStepCategoryAssociation = new QEntityPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociation"), () => QItlkCheckOperationStepCategoryAssociation);
}

export const qItlkCheckOperationStepCategoryAssociationFacet = new QItlkCheckOperationStepCategoryAssociationFacet();

export class QItlkCheckOperationStepCategoryAssociationFacetId extends QId<ItlkCheckOperationStepCategoryAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QInspectionSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly InspectionSpecification_Id = new QGuidPath(this.withPrefix("InspectionSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly InspectionSpecification = new QEntityPath(this.withPrefix("InspectionSpecification"), () => QInspectionSpecification);
}

export const qInspectionSpecificationFacet = new QInspectionSpecificationFacet();

export class QInspectionSpecificationFacetId extends QId<InspectionSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentStateMachine_Id = new QGuidPath(this.withPrefix("EquipmentStateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentStateMachine = new QEntityPath(this.withPrefix("EquipmentStateMachine"), () => QEquipmentStateMachine);
}

export const qEquipmentStateMachineFacet = new QEquipmentStateMachineFacet();

export class QEquipmentStateMachineFacetId extends QId<EquipmentStateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentPropertyAttributeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentPropertyAttribute_Id = new QGuidPath(this.withPrefix("EquipmentPropertyAttribute_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentPropertyAttribute = new QEntityPath(this.withPrefix("EquipmentPropertyAttribute"), () => QEquipmentPropertyAttribute);
}

export const qEquipmentPropertyAttributeFacet = new QEquipmentPropertyAttributeFacet();

export class QEquipmentPropertyAttributeFacetId extends QId<EquipmentPropertyAttributeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentPropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentProperty_Id = new QGuidPath(this.withPrefix("EquipmentProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentProperty = new QEntityPath(this.withPrefix("EquipmentProperty"), () => QEquipmentProperty);
}

export const qEquipmentPropertyFacet = new QEquipmentPropertyFacet();

export class QEquipmentPropertyFacetId extends QId<EquipmentPropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroupFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGroup_Id = new QGuidPath(this.withPrefix("EquipmentGroup_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGroup = new QEntityPath(this.withPrefix("EquipmentGroup"), () => QEquipmentGroup);
}

export const qEquipmentGroupFacet = new QEquipmentGroupFacet();

export class QEquipmentGroupFacetId extends QId<EquipmentGroupFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNodeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphNode_Id = new QGuidPath(this.withPrefix("EquipmentGraphNode_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphNode = new QEntityPath(this.withPrefix("EquipmentGraphNode"), () => QEquipmentGraphNode);
}

export const qEquipmentGraphNodeFacet = new QEquipmentGraphNodeFacet();

export class QEquipmentGraphNodeFacetId extends QId<EquipmentGraphNodeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphLink_Id = new QGuidPath(this.withPrefix("EquipmentGraphLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphLink = new QEntityPath(this.withPrefix("EquipmentGraphLink"), () => QEquipmentGraphLink);
}

export const qEquipmentGraphLinkFacet = new QEquipmentGraphLinkFacet();

export class QEquipmentGraphLinkFacetId extends QId<EquipmentGraphLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
}

export const qEquipmentFacet = new QEquipmentFacet();

export class QEquipmentFacetId extends QId<EquipmentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeStateMachine_Id = new QGuidPath(this.withPrefix("EquipmentTypeStateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypeStateMachine = new QEntityPath(this.withPrefix("EquipmentTypeStateMachine"), () => QEquipmentTypeStateMachine);
}

export const qEquipmentTypeStateMachineFacet = new QEquipmentTypeStateMachineFacet();

export class QEquipmentTypeStateMachineFacetId extends QId<EquipmentTypeStateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypePropertyAttributeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypePropertyAttribute_Id = new QGuidPath(this.withPrefix("EquipmentTypePropertyAttribute_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypePropertyAttribute = new QEntityPath(this.withPrefix("EquipmentTypePropertyAttribute"), () => QEquipmentTypePropertyAttribute);
}

export const qEquipmentTypePropertyAttributeFacet = new QEquipmentTypePropertyAttributeFacet();

export class QEquipmentTypePropertyAttributeFacetId extends QId<EquipmentTypePropertyAttributeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypePropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeProperty_Id = new QGuidPath(this.withPrefix("EquipmentTypeProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypeProperty = new QEntityPath(this.withPrefix("EquipmentTypeProperty"), () => QEquipmentTypeProperty);
}

export const qEquipmentTypePropertyFacet = new QEquipmentTypePropertyFacet();

export class QEquipmentTypePropertyFacetId extends QId<EquipmentTypePropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
}

export const qEquipmentTypeFacet = new QEquipmentTypeFacet();

export class QEquipmentTypeFacetId extends QId<EquipmentTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentLevelFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentLevel_Id = new QGuidPath(this.withPrefix("EquipmentLevel_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentLevel = new QEntityPath(this.withPrefix("EquipmentLevel"), () => QEquipmentLevel);
}

export const qEquipmentLevelFacet = new QEquipmentLevelFacet();

export class QEquipmentLevelFacetId extends QId<EquipmentLevelFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroupConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGroupConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGroupConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGroupConfiguration = new QEntityPath(this.withPrefix("EquipmentGroupConfiguration"), () => QEquipmentGroupConfiguration);
}

export const qEquipmentGroupConfigurationFacet = new QEquipmentGroupConfigurationFacet();

export class QEquipmentGroupConfigurationFacetId extends QId<EquipmentGroupConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphType_Id = new QGuidPath(this.withPrefix("EquipmentGraphType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphType = new QEntityPath(this.withPrefix("EquipmentGraphType"), () => QEquipmentGraphType);
}

export const qEquipmentGraphTypeFacet = new QEquipmentGraphTypeFacet();

export class QEquipmentGraphTypeFacetId extends QId<EquipmentGraphTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNodeConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphNodeConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphNodeConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphNodeConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphNodeConfiguration"), () => QEquipmentGraphNodeConfiguration);
}

export const qEquipmentGraphNodeConfigurationFacet = new QEquipmentGraphNodeConfigurationFacet();

export class QEquipmentGraphNodeConfigurationFacetId extends QId<EquipmentGraphNodeConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLinkConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphLinkConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphLinkConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphLinkConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphLinkConfiguration"), () => QEquipmentGraphLinkConfiguration);
}

export const qEquipmentGraphLinkConfigurationFacet = new QEquipmentGraphLinkConfigurationFacet();

export class QEquipmentGraphLinkConfigurationFacetId extends QId<EquipmentGraphLinkConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphConfiguration"), () => QEquipmentGraphConfiguration);
}

export const qEquipmentGraphConfigurationFacet = new QEquipmentGraphConfigurationFacet();

export class QEquipmentGraphConfigurationFacetId extends QId<EquipmentGraphConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationStateMachine_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationStateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationStateMachine = new QEntityPath(this.withPrefix("EquipmentConfigurationStateMachine"), () => QEquipmentConfigurationStateMachine);
}

export const qEquipmentConfigurationStateMachineFacet = new QEquipmentConfigurationStateMachineFacet();

export class QEquipmentConfigurationStateMachineFacetId extends QId<EquipmentConfigurationStateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationPropertyAttributeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationPropertyAttribute_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationPropertyAttribute_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationPropertyAttribute = new QEntityPath(this.withPrefix("EquipmentConfigurationPropertyAttribute"), () => QEquipmentConfigurationPropertyAttribute);
}

export const qEquipmentConfigurationPropertyAttributeFacet = new QEquipmentConfigurationPropertyAttributeFacet();

export class QEquipmentConfigurationPropertyAttributeFacetId extends QId<EquipmentConfigurationPropertyAttributeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationPropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationProperty_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationProperty = new QEntityPath(this.withPrefix("EquipmentConfigurationProperty"), () => QEquipmentConfigurationProperty);
}

export const qEquipmentConfigurationPropertyFacet = new QEquipmentConfigurationPropertyFacet();

export class QEquipmentConfigurationPropertyFacetId extends QId<EquipmentConfigurationPropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
}

export const qEquipmentConfigurationFacet = new QEquipmentConfigurationFacet();

export class QEquipmentConfigurationFacetId extends QId<EquipmentConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBoMFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BoM_Id = new QGuidPath(this.withPrefix("BoM_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoM);
}

export const qBoMFacet = new QBoMFacet();

export class QBoMFacetId extends QId<BoMFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkProcessDMMaterialTrackingUnitAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkProcessDMMaterialTrackingUnitAssociation_Id = new QGuidPath(this.withPrefix("WorkProcessDMMaterialTrackingUnitAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkProcessDMMaterialTrackingUnitAssociation = new QEntityPath(this.withPrefix("WorkProcessDMMaterialTrackingUnitAssociation"), () => QWorkProcessDMMaterialTrackingUnitAssociation);
}

export const qWorkProcessDMMaterialTrackingUnitAssociationFacet = new QWorkProcessDMMaterialTrackingUnitAssociationFacet();

export class QWorkProcessDMMaterialTrackingUnitAssociationFacetId extends QId<WorkProcessDMMaterialTrackingUnitAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserHAEquipmentPreferencesFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserHAEquipmentPreferences_Id = new QGuidPath(this.withPrefix("UserHAEquipmentPreferences_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UserHAEquipmentPreferences = new QEntityPath(this.withPrefix("UserHAEquipmentPreferences"), () => QUserHAEquipmentPreferences);
}

export const qUserHAEquipmentPreferencesFacet = new QUserHAEquipmentPreferencesFacet();

export class QUserHAEquipmentPreferencesFacetId extends QId<UserHAEquipmentPreferencesFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialTrackingUnitFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialTrackingUnit = new QEntityPath(this.withPrefix("MaterialTrackingUnit"), () => QMaterialTrackingUnit);
}

export const qMaterialTrackingUnitFacet = new QMaterialTrackingUnitFacet();

export class QMaterialTrackingUnitFacetId extends QId<MaterialTrackingUnitFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialLotFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialLot_Id = new QGuidPath(this.withPrefix("MaterialLot_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialLot = new QEntityPath(this.withPrefix("MaterialLot"), () => QMaterialLot);
}

export const qMaterialLotFacet = new QMaterialLotFacet();

export class QMaterialLotFacetId extends QId<MaterialLotFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDM_MaterialTrackingUnitHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DM_MaterialTrackingUnitHistoryAction_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DM_MaterialTrackingUnitHistoryAction = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnitHistoryAction"), () => QDM_MaterialTrackingUnitHistoryAction);
}

export const qDM_MaterialTrackingUnitHistoryActionFacet = new QDM_MaterialTrackingUnitHistoryActionFacet();

export class QDM_MaterialTrackingUnitHistoryActionFacetId extends QId<DM_MaterialTrackingUnitHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSupplierFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Supplier_Id = new QGuidPath(this.withPrefix("Supplier_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Supplier = new QEntityPath(this.withPrefix("Supplier"), () => QSupplier);
}

export const qSupplierFacet = new QSupplierFacet();

export class QSupplierFacetId extends QId<SupplierFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialGroupFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialGroup_Id = new QGuidPath(this.withPrefix("MaterialGroup_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialGroup = new QEntityPath(this.withPrefix("MaterialGroup"), () => QMaterialGroup);
}

export const qMaterialGroupFacet = new QMaterialGroupFacet();

export class QMaterialGroupFacetId extends QId<MaterialGroupFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessContextDefinitionUserFieldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessContextDefinitionUserField_Id = new QGuidPath(this.withPrefix("ProcessContextDefinitionUserField_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessContextDefinitionUserField = new QEntityPath(this.withPrefix("ProcessContextDefinitionUserField"), () => QProcessContextDefinitionUserField);
}

export const qProcessContextDefinitionUserFieldFacet = new QProcessContextDefinitionUserFieldFacet();

export class QProcessContextDefinitionUserFieldFacetId extends QId<ProcessContextDefinitionUserFieldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessContextDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessContextDefinition_Id = new QGuidPath(this.withPrefix("ProcessContextDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessContextDefinition = new QEntityPath(this.withPrefix("ProcessContextDefinition"), () => QProcessContextDefinition);
}

export const qProcessContextDefinitionFacet = new QProcessContextDefinitionFacet();

export class QProcessContextDefinitionFacetId extends QId<ProcessContextDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessDefinitionParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessDefinitionParameter_Id = new QGuidPath(this.withPrefix("ProcessDefinitionParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessDefinitionParameter = new QEntityPath(this.withPrefix("ProcessDefinitionParameter"), () => QProcessDefinitionParameter);
}

export const qProcessDefinitionParameterFacet = new QProcessDefinitionParameterFacet();

export class QProcessDefinitionParameterFacetId extends QId<ProcessDefinitionParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessDefinition_Id = new QGuidPath(this.withPrefix("ProcessDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessDefinition = new QEntityPath(this.withPrefix("ProcessDefinition"), () => QProcessDefinition);
}

export const qProcessDefinitionFacet = new QProcessDefinitionFacet();

export class QProcessDefinitionFacetId extends QId<ProcessDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckProcessToOpLinkAssociationParameterValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckProcessToOpLinkAssociationParameterValue_Id = new QGuidPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationParameterValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckProcessToOpLinkAssociationParameterValue = new QEntityPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationParameterValue"), () => QItlkCheckProcessToOpLinkAssociationParameterValue);
}

export const qItlkCheckProcessToOpLinkAssociationParameterValueFacet = new QItlkCheckProcessToOpLinkAssociationParameterValueFacet();

export class QItlkCheckProcessToOpLinkAssociationParameterValueFacetId extends QId<ItlkCheckProcessToOpLinkAssociationParameterValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckProcessToOpLinkAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckProcessToOpLinkAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckProcessToOpLinkAssociation = new QEntityPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociation"), () => QItlkCheckProcessToOpLinkAssociation);
}

export const qItlkCheckProcessToOpLinkAssociationFacet = new QItlkCheckProcessToOpLinkAssociationFacet();

export class QItlkCheckProcessToOpLinkAssociationFacetId extends QId<ItlkCheckProcessToOpLinkAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationStepCategoryProcessDefinitionAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OperationStepCategoryProcessDefinitionAssociation_Id = new QGuidPath(this.withPrefix("OperationStepCategoryProcessDefinitionAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationStepCategoryProcessDefinitionAssociation = new QEntityPath(this.withPrefix("OperationStepCategoryProcessDefinitionAssociation"), () => QOperationStepCategoryProcessDefinitionAssociation);
}

export const qOperationStepCategoryProcessDefinitionAssociationFacet = new QOperationStepCategoryProcessDefinitionAssociationFacet();

export class QOperationStepCategoryProcessDefinitionAssociationFacetId extends QId<OperationStepCategoryProcessDefinitionAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOOpAssociationParameterValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckWOOpAssociationParameterValue_Id = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociationParameterValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckWOOpAssociationParameterValue = new QEntityPath(this.withPrefix("ItlkCheckWOOpAssociationParameterValue"), () => QItlkCheckWOOpAssociationParameterValue);
}

export const qItlkCheckWOOpAssociationParameterValueFacet = new QItlkCheckWOOpAssociationParameterValueFacet();

export class QItlkCheckWOOpAssociationParameterValueFacetId extends QId<ItlkCheckWOOpAssociationParameterValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckWOOpAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckWOOpAssociation_Id = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckWOOpAssociation = new QEntityPath(this.withPrefix("ItlkCheckWOOpAssociation"), () => QItlkCheckWOOpAssociation);
}

export const qItlkCheckWOOpAssociationFacet = new QItlkCheckWOOpAssociationFacet();

export class QItlkCheckWOOpAssociationFacetId extends QId<ItlkCheckWOOpAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckHistoryParameterValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckHistoryParameterValue_Id = new QGuidPath(this.withPrefix("ItlkCheckHistoryParameterValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckHistoryParameterValue = new QEntityPath(this.withPrefix("ItlkCheckHistoryParameterValue"), () => QItlkCheckHistoryParameterValue);
}

export const qItlkCheckHistoryParameterValueFacet = new QItlkCheckHistoryParameterValueFacet();

export class QItlkCheckHistoryParameterValueFacetId extends QId<ItlkCheckHistoryParameterValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckHistory_Id = new QGuidPath(this.withPrefix("ItlkCheckHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckHistory = new QEntityPath(this.withPrefix("ItlkCheckHistory"), () => QItlkCheckHistory);
}

export const qItlkCheckHistoryFacet = new QItlkCheckHistoryFacet();

export class QItlkCheckHistoryFacetId extends QId<ItlkCheckHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamUserAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TeamUserAssociation_Id = new QGuidPath(this.withPrefix("TeamUserAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TeamUserAssociation = new QEntityPath(this.withPrefix("TeamUserAssociation"), () => QTeamUserAssociation);
}

export const qTeamUserAssociationFacet = new QTeamUserAssociationFacet();

export class QTeamUserAssociationFacetId extends QId<TeamUserAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TeamHistory_Id = new QGuidPath(this.withPrefix("TeamHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TeamHistory = new QEntityPath(this.withPrefix("TeamHistory"), () => QTeamHistory);
}

export const qTeamHistoryFacet = new QTeamHistoryFacet();

export class QTeamHistoryFacetId extends QId<TeamHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TeamHistoryAction_Id = new QGuidPath(this.withPrefix("TeamHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TeamHistoryAction = new QEntityPath(this.withPrefix("TeamHistoryAction"), () => QTeamHistoryAction);
}

export const qTeamHistoryActionFacet = new QTeamHistoryActionFacet();

export class QTeamHistoryActionFacetId extends QId<TeamHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamSkillAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TeamSkillAssociation_Id = new QGuidPath(this.withPrefix("TeamSkillAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TeamSkillAssociation = new QEntityPath(this.withPrefix("TeamSkillAssociation"), () => QTeamSkillAssociation);
}

export const qTeamSkillAssociationFacet = new QTeamSkillAssociationFacet();

export class QTeamSkillAssociationFacetId extends QId<TeamSkillAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTeamFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Team_Id = new QGuidPath(this.withPrefix("Team_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Team = new QEntityPath(this.withPrefix("Team"), () => QTeam);
}

export const qTeamFacet = new QTeamFacet();

export class QTeamFacetId extends QId<TeamFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonProductiveActivityHistory_Id = new QGuidPath(this.withPrefix("NonProductiveActivityHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonProductiveActivityHistory = new QEntityPath(this.withPrefix("NonProductiveActivityHistory"), () => QNonProductiveActivityHistory);
}

export const qNonProductiveActivityHistoryFacet = new QNonProductiveActivityHistoryFacet();

export class QNonProductiveActivityHistoryFacetId extends QId<NonProductiveActivityHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonProductiveActivityHistoryAction_Id = new QGuidPath(this.withPrefix("NonProductiveActivityHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonProductiveActivityHistoryAction = new QEntityPath(this.withPrefix("NonProductiveActivityHistoryAction"), () => QNonProductiveActivityHistoryAction);
}

export const qNonProductiveActivityHistoryActionFacet = new QNonProductiveActivityHistoryActionFacet();

export class QNonProductiveActivityHistoryActionFacetId extends QId<NonProductiveActivityHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityContextFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonProductiveActivityContext_Id = new QGuidPath(this.withPrefix("NonProductiveActivityContext_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonProductiveActivityContext = new QEntityPath(this.withPrefix("NonProductiveActivityContext"), () => QNonProductiveActivityContext);
}

export const qNonProductiveActivityContextFacet = new QNonProductiveActivityContextFacet();

export class QNonProductiveActivityContextFacetId extends QId<NonProductiveActivityContextFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityNotificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonProductiveActivityNotification_Id = new QGuidPath(this.withPrefix("NonProductiveActivityNotification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonProductiveActivityNotification = new QEntityPath(this.withPrefix("NonProductiveActivityNotification"), () => QNonProductiveActivityNotification);
}

export const qNonProductiveActivityNotificationFacet = new QNonProductiveActivityNotificationFacet();

export class QNonProductiveActivityNotificationFacetId extends QId<NonProductiveActivityNotificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserNonProductiveActivityFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserNonProductiveActivity_Id = new QGuidPath(this.withPrefix("UserNonProductiveActivity_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UserNonProductiveActivity = new QEntityPath(this.withPrefix("UserNonProductiveActivity"), () => QUserNonProductiveActivity);
}

export const qUserNonProductiveActivityFacet = new QUserNonProductiveActivityFacet();

export class QUserNonProductiveActivityFacetId extends QId<UserNonProductiveActivityFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheckParameter_Id = new QGuidPath(this.withPrefix("ItlkCheckParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheckParameter = new QEntityPath(this.withPrefix("ItlkCheckParameter"), () => QItlkCheckParameter);
}

export const qItlkCheckParameterFacet = new QItlkCheckParameterFacet();

export class QItlkCheckParameterFacetId extends QId<ItlkCheckParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QItlkCheckFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ItlkCheck_Id = new QGuidPath(this.withPrefix("ItlkCheck_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ItlkCheck = new QEntityPath(this.withPrefix("ItlkCheck"), () => QItlkCheck);
}

export const qItlkCheckFacet = new QItlkCheckFacet();

export class QItlkCheckFacetId extends QId<ItlkCheckFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationStepCategoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OperationStepCategory_Id = new QGuidPath(this.withPrefix("OperationStepCategory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationStepCategory = new QEntityPath(this.withPrefix("OperationStepCategory"), () => QOperationStepCategory);
}

export const qOperationStepCategoryFacet = new QOperationStepCategoryFacet();

export class QOperationStepCategoryFacetId extends QId<OperationStepCategoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonProductiveActivityFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonProductiveActivity_Id = new QGuidPath(this.withPrefix("NonProductiveActivity_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonProductiveActivity = new QEntityPath(this.withPrefix("NonProductiveActivity"), () => QNonProductiveActivity);
}

export const qNonProductiveActivityFacet = new QNonProductiveActivityFacet();

export class QNonProductiveActivityFacetId extends QId<NonProductiveActivityFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderOperationSkillFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderOperationSkill_Id = new QGuidPath(this.withPrefix("WorkOrderOperationSkill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderOperationSkill = new QEntityPath(this.withPrefix("WorkOrderOperationSkill"), () => QWorkOrderOperationSkill);
}

export const qWorkOrderOperationSkillFacet = new QWorkOrderOperationSkillFacet();

export class QWorkOrderOperationSkillFacetId extends QId<WorkOrderOperationSkillFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupPhaseDependencyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupPhaseDependency_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhaseDependency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupPhaseDependency = new QEntityPath(this.withPrefix("ExecutionGroupPhaseDependency"), () => QExecutionGroupPhaseDependency);
}

export const qExecutionGroupPhaseDependencyFacet = new QExecutionGroupPhaseDependencyFacet();

export class QExecutionGroupPhaseDependencyFacetId extends QId<ExecutionGroupPhaseDependencyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualCollectedDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualCollectedDocument_Id = new QGuidPath(this.withPrefix("ActualCollectedDocument_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualCollectedDocument = new QEntityPath(this.withPrefix("ActualCollectedDocument"), () => QActualCollectedDocument);
}

export const qActualCollectedDocumentFacet = new QActualCollectedDocumentFacet();

export class QActualCollectedDocumentFacetId extends QId<ActualCollectedDocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionAssociationTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionAssociationType_Id = new QGuidPath(this.withPrefix("WorkInstructionAssociationType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionAssociationType = new QEntityPath(this.withPrefix("WorkInstructionAssociationType"), () => QWorkInstructionAssociationType);
}

export const qWorkInstructionAssociationTypeFacet = new QWorkInstructionAssociationTypeFacet();

export class QWorkInstructionAssociationTypeFacetId extends QId<WorkInstructionAssociationTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationSourceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TransportOperationSource_Id = new QGuidPath(this.withPrefix("TransportOperationSource_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperationSource = new QEntityPath(this.withPrefix("TransportOperationSource"), () => QTransportOperationSource);
}

export const qTransportOperationSourceFacet = new QTransportOperationSourceFacet();

export class QTransportOperationSourceFacetId extends QId<TransportOperationSourceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationHistoryAssignedHUFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TransportOperationHistoryAssignedHU_Id = new QGuidPath(this.withPrefix("TransportOperationHistoryAssignedHU_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperationHistoryAssignedHU = new QEntityPath(this.withPrefix("TransportOperationHistoryAssignedHU"), () => QTransportOperationHistoryAssignedHU);
}

export const qTransportOperationHistoryAssignedHUFacet = new QTransportOperationHistoryAssignedHUFacet();

export class QTransportOperationHistoryAssignedHUFacetId extends QId<TransportOperationHistoryAssignedHUFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TransportOperationHistoryAction_Id = new QGuidPath(this.withPrefix("TransportOperationHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperationHistoryAction = new QEntityPath(this.withPrefix("TransportOperationHistoryAction"), () => QTransportOperationHistoryAction);
}

export const qTransportOperationHistoryActionFacet = new QTransportOperationHistoryActionFacet();

export class QTransportOperationHistoryActionFacetId extends QId<TransportOperationHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TransportOperationHistory_Id = new QGuidPath(this.withPrefix("TransportOperationHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperationHistory = new QEntityPath(this.withPrefix("TransportOperationHistory"), () => QTransportOperationHistory);
}

export const qTransportOperationHistoryFacet = new QTransportOperationHistoryFacet();

export class QTransportOperationHistoryFacetId extends QId<TransportOperationHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationDestinationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TransportOperationDestination_Id = new QGuidPath(this.withPrefix("TransportOperationDestination_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperationDestination = new QEntityPath(this.withPrefix("TransportOperationDestination"), () => QTransportOperationDestination);
}

export const qTransportOperationDestinationFacet = new QTransportOperationDestinationFacet();

export class QTransportOperationDestinationFacetId extends QId<TransportOperationDestinationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTransportOperationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TransportOperation_Id = new QGuidPath(this.withPrefix("TransportOperation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TransportOperation = new QEntityPath(this.withPrefix("TransportOperation"), () => QTransportOperation);
}

export const qTransportOperationFacet = new QTransportOperationFacet();

export class QTransportOperationFacetId extends QId<TransportOperationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRuntimeLogisticWhitelistFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RuntimeLogisticWhitelist_Id = new QGuidPath(this.withPrefix("RuntimeLogisticWhitelist_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RuntimeLogisticWhitelist = new QEntityPath(this.withPrefix("RuntimeLogisticWhitelist"), () => QRuntimeLogisticWhitelist);
}

export const qRuntimeLogisticWhitelistFacet = new QRuntimeLogisticWhitelistFacet();

export class QRuntimeLogisticWhitelistFacetId extends QId<RuntimeLogisticWhitelistFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LogisticRequestItem_Id = new QGuidPath(this.withPrefix("LogisticRequestItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticRequestItem = new QEntityPath(this.withPrefix("LogisticRequestItem"), () => QLogisticRequestItem);
}

export const qLogisticRequestItemFacet = new QLogisticRequestItemFacet();

export class QLogisticRequestItemFacetId extends QId<LogisticRequestItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LogisticRequestHistoryAction_Id = new QGuidPath(this.withPrefix("LogisticRequestHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticRequestHistoryAction = new QEntityPath(this.withPrefix("LogisticRequestHistoryAction"), () => QLogisticRequestHistoryAction);
}

export const qLogisticRequestHistoryActionFacet = new QLogisticRequestHistoryActionFacet();

export class QLogisticRequestHistoryActionFacetId extends QId<LogisticRequestHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LogisticRequestHistory_Id = new QGuidPath(this.withPrefix("LogisticRequestHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticRequestHistory = new QEntityPath(this.withPrefix("LogisticRequestHistory"), () => QLogisticRequestHistory);
}

export const qLogisticRequestHistoryFacet = new QLogisticRequestHistoryFacet();

export class QLogisticRequestHistoryFacetId extends QId<LogisticRequestHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticRequestFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LogisticRequest_Id = new QGuidPath(this.withPrefix("LogisticRequest_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticRequest = new QEntityPath(this.withPrefix("LogisticRequest"), () => QLogisticRequest);
}

export const qLogisticRequestFacet = new QLogisticRequestFacet();

export class QLogisticRequestFacetId extends QId<LogisticRequestFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHistoryItemsFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HistoryItems_Id = new QGuidPath(this.withPrefix("HistoryItems_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HistoryItems = new QEntityPath(this.withPrefix("HistoryItems"), () => QHistoryItems);
}

export const qHistoryItemsFacet = new QHistoryItemsFacet();

export class QHistoryItemsFacetId extends QId<HistoryItemsFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitMaterialItemAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HandlingUnitMaterialItemAssociation_Id = new QGuidPath(this.withPrefix("HandlingUnitMaterialItemAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HandlingUnitMaterialItemAssociation = new QEntityPath(this.withPrefix("HandlingUnitMaterialItemAssociation"), () => QHandlingUnitMaterialItemAssociation);
}

export const qHandlingUnitMaterialItemAssociationFacet = new QHandlingUnitMaterialItemAssociationFacet();

export class QHandlingUnitMaterialItemAssociationFacetId extends QId<HandlingUnitMaterialItemAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HandlingUnitHistoryAction_Id = new QGuidPath(this.withPrefix("HandlingUnitHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HandlingUnitHistoryAction = new QEntityPath(this.withPrefix("HandlingUnitHistoryAction"), () => QHandlingUnitHistoryAction);
}

export const qHandlingUnitHistoryActionFacet = new QHandlingUnitHistoryActionFacet();

export class QHandlingUnitHistoryActionFacetId extends QId<HandlingUnitHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HandlingUnitHistory_Id = new QGuidPath(this.withPrefix("HandlingUnitHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HandlingUnitHistory = new QEntityPath(this.withPrefix("HandlingUnitHistory"), () => QHandlingUnitHistory);
}

export const qHandlingUnitHistoryFacet = new QHandlingUnitHistoryFacet();

export class QHandlingUnitHistoryFacetId extends QId<HandlingUnitHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHandlingUnitFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HandlingUnit_Id = new QGuidPath(this.withPrefix("HandlingUnit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HandlingUnit = new QEntityPath(this.withPrefix("HandlingUnit"), () => QHandlingUnit);
}

export const qHandlingUnitFacet = new QHandlingUnitFacet();

export class QHandlingUnitFacetId extends QId<HandlingUnitFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferToolAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BufferToolAssociation_Id = new QGuidPath(this.withPrefix("BufferToolAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferToolAssociation = new QEntityPath(this.withPrefix("BufferToolAssociation"), () => QBufferToolAssociation);
}

export const qBufferToolAssociationFacet = new QBufferToolAssociationFacet();

export class QBufferToolAssociationFacetId extends QId<BufferToolAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferMaterialItemAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BufferMaterialItemAssociation_Id = new QGuidPath(this.withPrefix("BufferMaterialItemAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferMaterialItemAssociation = new QEntityPath(this.withPrefix("BufferMaterialItemAssociation"), () => QBufferMaterialItemAssociation);
}

export const qBufferMaterialItemAssociationFacet = new QBufferMaterialItemAssociationFacet();

export class QBufferMaterialItemAssociationFacetId extends QId<BufferMaterialItemAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BufferHistoryAction_Id = new QGuidPath(this.withPrefix("BufferHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferHistoryAction = new QEntityPath(this.withPrefix("BufferHistoryAction"), () => QBufferHistoryAction);
}

export const qBufferHistoryActionFacet = new QBufferHistoryActionFacet();

export class QBufferHistoryActionFacetId extends QId<BufferHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BufferHistory_Id = new QGuidPath(this.withPrefix("BufferHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferHistory = new QEntityPath(this.withPrefix("BufferHistory"), () => QBufferHistory);
}

export const qBufferHistoryFacet = new QBufferHistoryFacet();

export class QBufferHistoryFacetId extends QId<BufferHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferEquipmentAssoicationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BufferEquipmentAssoication_Id = new QGuidPath(this.withPrefix("BufferEquipmentAssoication_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferEquipmentAssoication = new QEntityPath(this.withPrefix("BufferEquipmentAssoication"), () => QBufferEquipmentAssoication);
}

export const qBufferEquipmentAssoicationFacet = new QBufferEquipmentAssoicationFacet();

export class QBufferEquipmentAssoicationFacetId extends QId<BufferEquipmentAssoicationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Buffer_Id = new QGuidPath(this.withPrefix("Buffer_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Buffer = new QEntityPath(this.withPrefix("Buffer"), () => QBuffer);
}

export const qBufferFacet = new QBufferFacet();

export class QBufferFacetId extends QId<BufferFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupPhaseWOOAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupPhaseWOOAssociation_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhaseWOOAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupPhaseWOOAssociation = new QEntityPath(this.withPrefix("ExecutionGroupPhaseWOOAssociation"), () => QExecutionGroupPhaseWOOAssociation);
}

export const qExecutionGroupPhaseWOOAssociationFacet = new QExecutionGroupPhaseWOOAssociationFacet();

export class QExecutionGroupPhaseWOOAssociationFacetId extends QId<ExecutionGroupPhaseWOOAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionToWorkOrderOperationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionToWorkOrderOperationAssociation_Id = new QGuidPath(this.withPrefix("WorkInstructionToWorkOrderOperationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionToWorkOrderOperationAssociation = new QEntityPath(this.withPrefix("WorkInstructionToWorkOrderOperationAssociation"), () => QWorkInstructionToWorkOrderOperationAssociation);
}

export const qWorkInstructionToWorkOrderOperationAssociationFacet = new QWorkInstructionToWorkOrderOperationAssociationFacet();

export class QWorkInstructionToWorkOrderOperationAssociationFacetId extends QId<WorkInstructionToWorkOrderOperationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupPhaseFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupPhase = new QEntityPath(this.withPrefix("ExecutionGroupPhase"), () => QExecutionGroupPhase);
}

export const qExecutionGroupPhaseFacet = new QExecutionGroupPhaseFacet();

export class QExecutionGroupPhaseFacetId extends QId<ExecutionGroupPhaseFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupHistoryAction_Id = new QGuidPath(this.withPrefix("ExecutionGroupHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupHistoryAction = new QEntityPath(this.withPrefix("ExecutionGroupHistoryAction"), () => QExecutionGroupHistoryAction);
}

export const qExecutionGroupHistoryActionFacet = new QExecutionGroupHistoryActionFacet();

export class QExecutionGroupHistoryActionFacetId extends QId<ExecutionGroupHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroupHistory_Id = new QGuidPath(this.withPrefix("ExecutionGroupHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroupHistory = new QEntityPath(this.withPrefix("ExecutionGroupHistory"), () => QExecutionGroupHistory);
}

export const qExecutionGroupHistoryFacet = new QExecutionGroupHistoryFacet();

export class QExecutionGroupHistoryFacetId extends QId<ExecutionGroupHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionGroupFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ExecutionGroup_Id = new QGuidPath(this.withPrefix("ExecutionGroup_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ExecutionGroup = new QEntityPath(this.withPrefix("ExecutionGroup"), () => QExecutionGroup);
}

export const qExecutionGroupFacet = new QExecutionGroupFacet();

export class QExecutionGroupFacetId extends QId<ExecutionGroupFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionStepItemLimitFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionStepItemLimit_Id = new QGuidPath(this.withPrefix("WorkInstructionStepItemLimit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionStepItemLimit = new QEntityPath(this.withPrefix("WorkInstructionStepItemLimit"), () => QWorkInstructionStepItemLimit);
}

export const qWorkInstructionStepItemLimitFacet = new QWorkInstructionStepItemLimitFacet();

export class QWorkInstructionStepItemLimitFacetId extends QId<WorkInstructionStepItemLimitFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionSectionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionSection_Id = new QGuidPath(this.withPrefix("WorkInstructionSection_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionSection = new QEntityPath(this.withPrefix("WorkInstructionSection"), () => QWorkInstructionSection);
}

export const qWorkInstructionSectionFacet = new QWorkInstructionSectionFacet();

export class QWorkInstructionSectionFacetId extends QId<WorkInstructionSectionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionParameter_Id = new QGuidPath(this.withPrefix("WorkInstructionParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionParameter = new QEntityPath(this.withPrefix("WorkInstructionParameter"), () => QWorkInstructionParameter);
}

export const qWorkInstructionParameterFacet = new QWorkInstructionParameterFacet();

export class QWorkInstructionParameterFacetId extends QId<WorkInstructionParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinitionToOperationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionDefinitionToOperationAssociation_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinitionToOperationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionDefinitionToOperationAssociation = new QEntityPath(this.withPrefix("WorkInstructionDefinitionToOperationAssociation"), () => QWorkInstructionDefinitionToOperationAssociation);
}

export const qWorkInstructionDefinitionToOperationAssociationFacet = new QWorkInstructionDefinitionToOperationAssociationFacet();

export class QWorkInstructionDefinitionToOperationAssociationFacetId extends QId<WorkInstructionDefinitionToOperationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionTemplateParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionTemplateParameter_Id = new QGuidPath(this.withPrefix("WorkInstructionTemplateParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionTemplateParameter = new QEntityPath(this.withPrefix("WorkInstructionTemplateParameter"), () => QWorkInstructionTemplateParameter);
}

export const qWorkInstructionTemplateParameterFacet = new QWorkInstructionTemplateParameterFacet();

export class QWorkInstructionTemplateParameterFacetId extends QId<WorkInstructionTemplateParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionTemplateFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionTemplate_Id = new QGuidPath(this.withPrefix("WorkInstructionTemplate_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionTemplate = new QEntityPath(this.withPrefix("WorkInstructionTemplate"), () => QWorkInstructionTemplate);
}

export const qWorkInstructionTemplateFacet = new QWorkInstructionTemplateFacet();

export class QWorkInstructionTemplateFacetId extends QId<WorkInstructionTemplateFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkInstructionDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QWorkInstructionDefinition);
}

export const qWorkInstructionDefinitionFacet = new QWorkInstructionDefinitionFacet();

export class QWorkInstructionDefinitionFacetId extends QId<WorkInstructionDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPattern_Id = new QGuidPath(this.withPrefix("NumberingPattern_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPattern = new QEntityPath(this.withPrefix("NumberingPattern"), () => QNumberingPattern);
}

export const qNumberingPatternFacet = new QNumberingPatternFacet();

export class QNumberingPatternFacetId extends QId<NumberingPatternFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPatternParameter_Id = new QGuidPath(this.withPrefix("NumberingPatternParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternParameter = new QEntityPath(this.withPrefix("NumberingPatternParameter"), () => QNumberingPatternParameter);
}

export const qNumberingPatternParameterFacet = new QNumberingPatternParameterFacet();

export class QNumberingPatternParameterFacetId extends QId<NumberingPatternParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternPartFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPatternPart_Id = new QGuidPath(this.withPrefix("NumberingPatternPart_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternPart = new QEntityPath(this.withPrefix("NumberingPatternPart"), () => QNumberingPatternPart);
}

export const qNumberingPatternPartFacet = new QNumberingPatternPartFacet();

export class QNumberingPatternPartFacetId extends QId<NumberingPatternPartFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNumberingPatternEntityFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NumberingPatternEntity_Id = new QGuidPath(this.withPrefix("NumberingPatternEntity_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NumberingPatternEntity = new QEntityPath(this.withPrefix("NumberingPatternEntity"), () => QNumberingPatternEntity);
}

export const qNumberingPatternEntityFacet = new QNumberingPatternEntityFacet();

export class QNumberingPatternEntityFacetId extends QId<NumberingPatternEntityFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCounterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Counter_Id = new QGuidPath(this.withPrefix("Counter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Counter = new QEntityPath(this.withPrefix("Counter"), () => QCounter);
}

export const qCounterFacet = new QCounterFacet();

export class QCounterFacetId extends QId<CounterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticWhitelistFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LogisticWhitelist_Id = new QGuidPath(this.withPrefix("LogisticWhitelist_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticWhitelist = new QEntityPath(this.withPrefix("LogisticWhitelist"), () => QLogisticWhitelist);
}

export const qLogisticWhitelistFacet = new QLogisticWhitelistFacet();

export class QLogisticWhitelistFacetId extends QId<LogisticWhitelistFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogisticClassFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LogisticClass_Id = new QGuidPath(this.withPrefix("LogisticClass_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogisticClass = new QEntityPath(this.withPrefix("LogisticClass"), () => QLogisticClass);
}

export const qLogisticClassFacet = new QLogisticClassFacet();

export class QLogisticClassFacetId extends QId<LogisticClassFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCapacityTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CapacityType_Id = new QGuidPath(this.withPrefix("CapacityType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CapacityType = new QEntityPath(this.withPrefix("CapacityType"), () => QCapacityType);
}

export const qCapacityTypeFacet = new QCapacityTypeFacet();

export class QCapacityTypeFacetId extends QId<CapacityTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QBufferDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly BufferDefinition_Id = new QGuidPath(this.withPrefix("BufferDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly BufferDefinition = new QEntityPath(this.withPrefix("BufferDefinition"), () => QBufferDefinition);
}

export const qBufferDefinitionFacet = new QBufferDefinitionFacet();

export class QBufferDefinitionFacetId extends QId<BufferDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMFactorFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UoMFactor_Id = new QGuidPath(this.withPrefix("UoMFactor_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMFactor = new QEntityPath(this.withPrefix("UoMFactor"), () => QUoMFactor);
}

export const qUoMFactorFacet = new QUoMFactorFacet();

export class QUoMFactorFacetId extends QId<UoMFactorFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMDimensionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UoMDimension_Id = new QGuidPath(this.withPrefix("UoMDimension_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoMDimension = new QEntityPath(this.withPrefix("UoMDimension"), () => QUoMDimension);
}

export const qUoMDimensionFacet = new QUoMDimensionFacet();

export class QUoMDimensionFacetId extends QId<UoMDimensionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUoMFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UoM_Id = new QGuidPath(this.withPrefix("UoM_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UoM = new QEntityPath(this.withPrefix("UoM"), () => QUoM);
}

export const qUoMFacet = new QUoMFacet();

export class QUoMFacetId extends QId<UoMFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusTransitionDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StatusTransitionDefinition_Id = new QGuidPath(this.withPrefix("StatusTransitionDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StatusTransitionDefinition = new QEntityPath(this.withPrefix("StatusTransitionDefinition"), () => QStatusTransitionDefinition);
}

export const qStatusTransitionDefinitionFacet = new QStatusTransitionDefinitionFacet();

export class QStatusTransitionDefinitionFacetId extends QId<StatusTransitionDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusTransitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StatusTransition_Id = new QGuidPath(this.withPrefix("StatusTransition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StatusTransition = new QEntityPath(this.withPrefix("StatusTransition"), () => QStatusTransition);
}

export const qStatusTransitionFacet = new QStatusTransitionFacet();

export class QStatusTransitionFacetId extends QId<StatusTransitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StatusDefinition_Id = new QGuidPath(this.withPrefix("StatusDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StatusDefinition = new QEntityPath(this.withPrefix("StatusDefinition"), () => QStatusDefinition);
}

export const qStatusDefinitionFacet = new QStatusDefinitionFacet();

export class QStatusDefinitionFacetId extends QId<StatusDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusBehaviorDefinitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StatusBehaviorDefinition_Id = new QGuidPath(this.withPrefix("StatusBehaviorDefinition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StatusBehaviorDefinition = new QEntityPath(this.withPrefix("StatusBehaviorDefinition"), () => QStatusBehaviorDefinition);
}

export const qStatusBehaviorDefinitionFacet = new QStatusBehaviorDefinitionFacet();

export class QStatusBehaviorDefinitionFacetId extends QId<StatusBehaviorDefinitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Status_Id = new QGuidPath(this.withPrefix("Status_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatus);
}

export const qStatusFacet = new QStatusFacet();

export class QStatusFacetId extends QId<StatusFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachine_Id = new QGuidPath(this.withPrefix("StateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StateMachine = new QEntityPath(this.withPrefix("StateMachine"), () => QStateMachine);
}

export const qStateMachineFacet = new QStateMachineFacet();

export class QStateMachineFacetId extends QId<StateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserPlantAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserPlantAssociation_Id = new QGuidPath(this.withPrefix("UserPlantAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UserPlantAssociation = new QEntityPath(this.withPrefix("UserPlantAssociation"), () => QUserPlantAssociation);
}

export const qUserPlantAssociationFacet = new QUserPlantAssociationFacet();

export class QUserPlantAssociationFacetId extends QId<UserPlantAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMasterPlanFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QMasterPlan);
}

export const qMasterPlanFacet = new QMasterPlanFacet();

export class QMasterPlanFacetId extends QId<MasterPlanFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkill_BOPFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Skill_BOP_Id = new QGuidPath(this.withPrefix("Skill_BOP_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Skill_BOP = new QEntityPath(this.withPrefix("Skill_BOP"), () => QSkill_BOP);
}

export const qSkill_BOPFacet = new QSkill_BOPFacet();

export class QSkill_BOPFacetId extends QId<Skill_BOPFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationToStepLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OperationToStepLink_Id = new QGuidPath(this.withPrefix("OperationToStepLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationToStepLink = new QEntityPath(this.withPrefix("OperationToStepLink"), () => QOperationToStepLink);
}

export const qOperationToStepLinkFacet = new QOperationToStepLinkFacet();

export class QOperationToStepLinkFacetId extends QId<OperationToStepLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessToProcessLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessToProcessLink_Id = new QGuidPath(this.withPrefix("ProcessToProcessLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessToProcessLink = new QEntityPath(this.withPrefix("ProcessToProcessLink"), () => QProcessToProcessLink);
}

export const qProcessToProcessLinkFacet = new QProcessToProcessLinkFacet();

export class QProcessToProcessLinkFacetId extends QId<ProcessToProcessLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessToOperationLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessToOperationLink_Id = new QGuidPath(this.withPrefix("ProcessToOperationLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessToOperationLink = new QEntityPath(this.withPrefix("ProcessToOperationLink"), () => QProcessToOperationLink);
}

export const qProcessToOperationLinkFacet = new QProcessToOperationLinkFacet();

export class QProcessToOperationLinkFacetId extends QId<ProcessToOperationLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationSkillFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OperationSkill_Id = new QGuidPath(this.withPrefix("OperationSkill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationSkill = new QEntityPath(this.withPrefix("OperationSkill"), () => QOperationSkill);
}

export const qOperationSkillFacet = new QOperationSkillFacet();

export class QOperationSkillFacetId extends QId<OperationSkillFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProducedMaterialUnderReworkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProducedMaterialUnderRework_Id = new QGuidPath(this.withPrefix("ProducedMaterialUnderRework_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProducedMaterialUnderRework = new QEntityPath(this.withPrefix("ProducedMaterialUnderRework"), () => QProducedMaterialUnderRework);
}

export const qProducedMaterialUnderReworkFacet = new QProducedMaterialUnderReworkFacet();

export class QProducedMaterialUnderReworkFacetId extends QId<ProducedMaterialUnderReworkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSnagAndNoteNotificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SnagAndNoteNotification_Id = new QGuidPath(this.withPrefix("SnagAndNoteNotification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SnagAndNoteNotification = new QEntityPath(this.withPrefix("SnagAndNoteNotification"), () => QSnagAndNoteNotification);
}

export const qSnagAndNoteNotificationFacet = new QSnagAndNoteNotificationFacet();

export class QSnagAndNoteNotificationFacetId extends QId<SnagAndNoteNotificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceStatusBehaviorFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceStatusBehavior_Id = new QGuidPath(this.withPrefix("NonConformanceStatusBehavior_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceStatusBehavior = new QEntityPath(this.withPrefix("NonConformanceStatusBehavior"), () => QNonConformanceStatusBehavior);
}

export const qNonConformanceStatusBehaviorFacet = new QNonConformanceStatusBehaviorFacet();

export class QNonConformanceStatusBehaviorFacetId extends QId<NonConformanceStatusBehaviorFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceItem_Id = new QGuidPath(this.withPrefix("NonConformanceItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceItem = new QEntityPath(this.withPrefix("NonConformanceItem"), () => QNonConformanceItem);
}

export const qNonConformanceItemFacet = new QNonConformanceItemFacet();

export class QNonConformanceItemFacetId extends QId<NonConformanceItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeConsumedMaterialPrekitHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeConsumedMaterialPrekitHistory_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterialPrekitHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeConsumedMaterialPrekitHistory = new QEntityPath(this.withPrefix("ToBeConsumedMaterialPrekitHistory"), () => QToBeConsumedMaterialPrekitHistory);
}

export const qToBeConsumedMaterialPrekitHistoryFacet = new QToBeConsumedMaterialPrekitHistoryFacet();

export class QToBeConsumedMaterialPrekitHistoryFacetId extends QId<ToBeConsumedMaterialPrekitHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeConsumedMaterialPrekitFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeConsumedMaterialPrekit_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterialPrekit_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeConsumedMaterialPrekit = new QEntityPath(this.withPrefix("ToBeConsumedMaterialPrekit"), () => QToBeConsumedMaterialPrekit);
}

export const qToBeConsumedMaterialPrekitFacet = new QToBeConsumedMaterialPrekitFacet();

export class QToBeConsumedMaterialPrekitFacetId extends QId<ToBeConsumedMaterialPrekitFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOperationTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOperationType_Id = new QGuidPath(this.withPrefix("WorkOperationType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOperationType = new QEntityPath(this.withPrefix("WorkOperationType"), () => QWorkOperationType);
}

export const qWorkOperationTypeFacet = new QWorkOperationTypeFacet();

export class QWorkOperationTypeFacetId extends QId<WorkOperationTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionCompatibleMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolDefinitionCompatibleMachine_Id = new QGuidPath(this.withPrefix("ToolDefinitionCompatibleMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinitionCompatibleMachine = new QEntityPath(this.withPrefix("ToolDefinitionCompatibleMachine"), () => QToolDefinitionCompatibleMachine);
}

export const qToolDefinitionCompatibleMachineFacet = new QToolDefinitionCompatibleMachineFacet();

export class QToolDefinitionCompatibleMachineFacetId extends QId<ToolDefinitionCompatibleMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkillFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Skill_Id = new QGuidPath(this.withPrefix("Skill_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Skill = new QEntityPath(this.withPrefix("Skill"), () => QSkill);
}

export const qSkillFacet = new QSkillFacet();

export class QSkillFacetId extends QId<SkillFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QReworkCodeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ReworkCode_Id = new QGuidPath(this.withPrefix("ReworkCode_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ReworkCode = new QEntityPath(this.withPrefix("ReworkCode"), () => QReworkCode);
}

export const qReworkCodeFacet = new QReworkCodeFacet();

export class QReworkCodeFacetId extends QId<ReworkCodeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceTransitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceTransition_Id = new QGuidPath(this.withPrefix("NonConformanceTransition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceTransition = new QEntityPath(this.withPrefix("NonConformanceTransition"), () => QNonConformanceTransition);
}

export const qNonConformanceTransitionFacet = new QNonConformanceTransitionFacet();

export class QNonConformanceTransitionFacetId extends QId<NonConformanceTransitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceStatusFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceStatus_Id = new QGuidPath(this.withPrefix("NonConformanceStatus_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceStatus = new QEntityPath(this.withPrefix("NonConformanceStatus"), () => QNonConformanceStatus);
}

export const qNonConformanceStatusFacet = new QNonConformanceStatusFacet();

export class QNonConformanceStatusFacetId extends QId<NonConformanceStatusFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceSeverityFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceSeverity_Id = new QGuidPath(this.withPrefix("NonConformanceSeverity_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceSeverity = new QEntityPath(this.withPrefix("NonConformanceSeverity"), () => QNonConformanceSeverity);
}

export const qNonConformanceSeverityFacet = new QNonConformanceSeverityFacet();

export class QNonConformanceSeverityFacetId extends QId<NonConformanceSeverityFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceLifecycleFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceLifecycle_Id = new QGuidPath(this.withPrefix("NonConformanceLifecycle_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceLifecycle = new QEntityPath(this.withPrefix("NonConformanceLifecycle"), () => QNonConformanceLifecycle);
}

export const qNonConformanceLifecycleFacet = new QNonConformanceLifecycleFacet();

export class QNonConformanceLifecycleFacetId extends QId<NonConformanceLifecycleFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DefectType_Id = new QGuidPath(this.withPrefix("DefectType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectType = new QEntityPath(this.withPrefix("DefectType"), () => QDefectType);
}

export const qDefectTypeFacet = new QDefectTypeFacet();

export class QDefectTypeFacetId extends QId<DefectTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DefectSpecification_Id = new QGuidPath(this.withPrefix("DefectSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectSpecification = new QEntityPath(this.withPrefix("DefectSpecification"), () => QDefectSpecification);
}

export const qDefectSpecificationFacet = new QDefectSpecificationFacet();

export class QDefectSpecificationFacetId extends QId<DefectSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectGroupSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DefectGroupSpecification_Id = new QGuidPath(this.withPrefix("DefectGroupSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectGroupSpecification = new QEntityPath(this.withPrefix("DefectGroupSpecification"), () => QDefectGroupSpecification);
}

export const qDefectGroupSpecificationFacet = new QDefectGroupSpecificationFacet();

export class QDefectGroupSpecificationFacetId extends QId<DefectGroupSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectGroupFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DefectGroup_Id = new QGuidPath(this.withPrefix("DefectGroup_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DefectGroup = new QEntityPath(this.withPrefix("DefectGroup"), () => QDefectGroup);
}

export const qDefectGroupFacet = new QDefectGroupFacet();

export class QDefectGroupFacetId extends QId<DefectGroupFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOStepDependencyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOStepDependency_Id = new QGuidPath(this.withPrefix("WorkOStepDependency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOStepDependency = new QEntityPath(this.withPrefix("WorkOStepDependency"), () => QWorkOStepDependency);
}

export const qWorkOStepDependencyFacet = new QWorkOStepDependencyFacet();

export class QWorkOStepDependencyFacetId extends QId<WorkOStepDependencyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderStepFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderStep = new QEntityPath(this.withPrefix("WorkOrderStep"), () => QWorkOrderStep);
}

export const qWorkOrderStepFacet = new QWorkOrderStepFacet();

export class QWorkOrderStepFacetId extends QId<WorkOrderStepFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderHistoryAction_Id = new QGuidPath(this.withPrefix("WorkOrderHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderHistoryAction = new QEntityPath(this.withPrefix("WorkOrderHistoryAction"), () => QWorkOrderHistoryAction);
}

export const qWorkOrderHistoryActionFacet = new QWorkOrderHistoryActionFacet();

export class QWorkOrderHistoryActionFacetId extends QId<WorkOrderHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOOperationDependencyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOOperationDependency_Id = new QGuidPath(this.withPrefix("WorkOOperationDependency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOOperationDependency = new QEntityPath(this.withPrefix("WorkOOperationDependency"), () => QWorkOOperationDependency);
}

export const qWorkOOperationDependencyFacet = new QWorkOOperationDependencyFacet();

export class QWorkOOperationDependencyFacetId extends QId<WorkOOperationDependencyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolHistoryAction_Id = new QGuidPath(this.withPrefix("ToolHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolHistoryAction = new QEntityPath(this.withPrefix("ToolHistoryAction"), () => QToolHistoryAction);
}

export const qToolHistoryActionFacet = new QToolHistoryActionFacet();

export class QToolHistoryActionFacetId extends QId<ToolHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolCompatibleMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolCompatibleMachine_Id = new QGuidPath(this.withPrefix("ToolCompatibleMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolCompatibleMachine = new QEntityPath(this.withPrefix("ToolCompatibleMachine"), () => QToolCompatibleMachine);
}

export const qToolCompatibleMachineFacet = new QToolCompatibleMachineFacet();

export class QToolCompatibleMachineFacetId extends QId<ToolCompatibleMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedMachine_Id = new QGuidPath(this.withPrefix("ToBeUsedMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedMachine = new QEntityPath(this.withPrefix("ToBeUsedMachine"), () => QToBeUsedMachine);
}

export const qToBeUsedMachineFacet = new QToBeUsedMachineFacet();

export class QToBeUsedMachineFacetId extends QId<ToBeUsedMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToBeUsedDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToBeUsedDocument_Id = new QGuidPath(this.withPrefix("ToBeUsedDocument_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToBeUsedDocument = new QEntityPath(this.withPrefix("ToBeUsedDocument"), () => QToBeUsedDocument);
}

export const qToBeUsedDocumentFacet = new QToBeUsedDocumentFacet();

export class QToBeUsedDocumentFacetId extends QId<ToBeUsedDocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkipReasonFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SkipReason_Id = new QGuidPath(this.withPrefix("SkipReason_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SkipReason = new QEntityPath(this.withPrefix("SkipReason"), () => QSkipReason);
}

export const qSkipReasonFacet = new QSkipReasonFacet();

export class QSkipReasonFacetId extends QId<SkipReasonFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProductionTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProductionType_Id = new QGuidPath(this.withPrefix("ProductionType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProductionType = new QEntityPath(this.withPrefix("ProductionType"), () => QProductionType);
}

export const qProductionTypeFacet = new QProductionTypeFacet();

export class QProductionTypeFacetId extends QId<ProductionTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProducedMaterialItemFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProducedMaterialItem_Id = new QGuidPath(this.withPrefix("ProducedMaterialItem_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProducedMaterialItem = new QEntityPath(this.withPrefix("ProducedMaterialItem"), () => QProducedMaterialItem);
}

export const qProducedMaterialItemFacet = new QProducedMaterialItemFacet();

export class QProducedMaterialItemFacetId extends QId<ProducedMaterialItemFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPauseReasonFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PauseReason_Id = new QGuidPath(this.withPrefix("PauseReason_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PauseReason = new QEntityPath(this.withPrefix("PauseReason"), () => QPauseReason);
}

export const qPauseReasonFacet = new QPauseReasonFacet();

export class QPauseReasonFacetId extends QId<PauseReasonFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceSupervisorFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceSupervisor_Id = new QGuidPath(this.withPrefix("NonConformanceSupervisor_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceSupervisor = new QEntityPath(this.withPrefix("NonConformanceSupervisor"), () => QNonConformanceSupervisor);
}

export const qNonConformanceSupervisorFacet = new QNonConformanceSupervisorFacet();

export class QNonConformanceSupervisorFacetId extends QId<NonConformanceSupervisorFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceResourceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceResource_Id = new QGuidPath(this.withPrefix("NonConformanceResource_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceResource = new QEntityPath(this.withPrefix("NonConformanceResource"), () => QNonConformanceResource);
}

export const qNonConformanceResourceFacet = new QNonConformanceResourceFacet();

export class QNonConformanceResourceFacetId extends QId<NonConformanceResourceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceAttachmentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceAttachment_Id = new QGuidPath(this.withPrefix("NonConformanceAttachment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceAttachment = new QEntityPath(this.withPrefix("NonConformanceAttachment"), () => QNonConformanceAttachment);
}

export const qNonConformanceAttachmentFacet = new QNonConformanceAttachmentFacet();

export class QNonConformanceAttachmentFacetId extends QId<NonConformanceAttachmentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSnagAndNoteFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SnagAndNote_Id = new QGuidPath(this.withPrefix("SnagAndNote_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SnagAndNote = new QEntityPath(this.withPrefix("SnagAndNote"), () => QSnagAndNote);
}

export const qSnagAndNoteFacet = new QSnagAndNoteFacet();

export class QSnagAndNoteFacetId extends QId<SnagAndNoteFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHoldReasonFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly HoldReason_Id = new QGuidPath(this.withPrefix("HoldReason_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly HoldReason = new QEntityPath(this.withPrefix("HoldReason"), () => QHoldReason);
}

export const qHoldReasonFacet = new QHoldReasonFacet();

export class QHoldReasonFacetId extends QId<HoldReasonFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QHoldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Hold_Id = new QGuidPath(this.withPrefix("Hold_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Hold = new QEntityPath(this.withPrefix("Hold"), () => QHold);
}

export const qHoldFacet = new QHoldFacet();

export class QHoldFacetId extends QId<HoldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFutureHoldFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FutureHold_Id = new QGuidPath(this.withPrefix("FutureHold_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly FutureHold = new QEntityPath(this.withPrefix("FutureHold"), () => QFutureHold);
}

export const qFutureHoldFacet = new QFutureHoldFacet();

export class QFutureHoldFacetId extends QId<FutureHoldFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDefectFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Defect_Id = new QGuidPath(this.withPrefix("Defect_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Defect = new QEntityPath(this.withPrefix("Defect"), () => QDefect);
}

export const qDefectFacet = new QDefectFacet();

export class QDefectFacetId extends QId<DefectFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QChangeTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ChangeType_Id = new QGuidPath(this.withPrefix("ChangeType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ChangeType = new QEntityPath(this.withPrefix("ChangeType"), () => QChangeType);
}

export const qChangeTypeFacet = new QChangeTypeFacet();

export class QChangeTypeFacetId extends QId<ChangeTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMSubstrateLifecycleFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AMSubstrateLifecycle_Id = new QGuidPath(this.withPrefix("AMSubstrateLifecycle_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AMSubstrateLifecycle = new QEntityPath(this.withPrefix("AMSubstrateLifecycle"), () => QAMSubstrateLifecycle);
}

export const qAMSubstrateLifecycleFacet = new QAMSubstrateLifecycleFacet();

export class QAMSubstrateLifecycleFacetId extends QId<AMSubstrateLifecycleFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAMPowderLifecycleFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AMPowderLifecycle_Id = new QGuidPath(this.withPrefix("AMPowderLifecycle_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AMPowderLifecycle = new QEntityPath(this.withPrefix("AMPowderLifecycle"), () => QAMPowderLifecycle);
}

export const qAMPowderLifecycleFacet = new QAMPowderLifecycleFacet();

export class QAMPowderLifecycleFacetId extends QId<AMPowderLifecycleFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualUsedMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualUsedMachine_Id = new QGuidPath(this.withPrefix("ActualUsedMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualUsedMachine = new QEntityPath(this.withPrefix("ActualUsedMachine"), () => QActualUsedMachine);
}

export const qActualUsedMachineFacet = new QActualUsedMachineFacet();

export class QActualUsedMachineFacetId extends QId<ActualUsedMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActualProducedMaterialFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActualProducedMaterial_Id = new QGuidPath(this.withPrefix("ActualProducedMaterial_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActualProducedMaterial = new QEntityPath(this.withPrefix("ActualProducedMaterial"), () => QActualProducedMaterial);
}

export const qActualProducedMaterialFacet = new QActualProducedMaterialFacet();

export class QActualProducedMaterialFacetId extends QId<ActualProducedMaterialFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QActiveUserOnMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ActiveUserOnMachine_Id = new QGuidPath(this.withPrefix("ActiveUserOnMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ActiveUserOnMachine = new QEntityPath(this.withPrefix("ActiveUserOnMachine"), () => QActiveUserOnMachine);
}

export const qActiveUserOnMachineFacet = new QActiveUserOnMachineFacet();

export class QActiveUserOnMachineFacetId extends QId<ActiveUserOnMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QWorkOrderNotificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly WorkOrderNotification_Id = new QGuidPath(this.withPrefix("WorkOrderNotification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly WorkOrderNotification = new QEntityPath(this.withPrefix("WorkOrderNotification"), () => QWorkOrderNotification);
}

export const qWorkOrderNotificationFacet = new QWorkOrderNotificationFacet();

export class QWorkOrderNotificationFacetId extends QId<WorkOrderNotificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessNotificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProcessNotification_Id = new QGuidPath(this.withPrefix("ProcessNotification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ProcessNotification = new QEntityPath(this.withPrefix("ProcessNotification"), () => QProcessNotification);
}

export const qProcessNotificationFacet = new QProcessNotificationFacet();

export class QProcessNotificationFacetId extends QId<ProcessNotificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QConfigurationKeyMultiValueFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ConfigurationKeyMultiValue_Id = new QGuidPath(this.withPrefix("ConfigurationKeyMultiValue_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ConfigurationKeyMultiValue = new QEntityPath(this.withPrefix("ConfigurationKeyMultiValue"), () => QConfigurationKeyMultiValue);
}

export const qConfigurationKeyMultiValueFacet = new QConfigurationKeyMultiValueFacet();

export class QConfigurationKeyMultiValueFacetId extends QId<ConfigurationKeyMultiValueFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QPrintJobFileFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly PrintJobFile_Id = new QGuidPath(this.withPrefix("PrintJobFile_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPrintJobFile);
}

export const qPrintJobFileFacet = new QPrintJobFileFacet();

export class QPrintJobFileFacetId extends QId<PrintJobFileFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMachineToAMFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MachineToAM_Id = new QGuidPath(this.withPrefix("MachineToAM_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MachineToAM = new QEntityPath(this.withPrefix("MachineToAM"), () => QMachineToAM);
}

export const qMachineToAMFacet = new QMachineToAMFacet();

export class QMachineToAMFacetId extends QId<MachineToAMFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QConfigurationKeyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ConfigurationKey_Id = new QGuidPath(this.withPrefix("ConfigurationKey_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ConfigurationKey = new QEntityPath(this.withPrefix("ConfigurationKey"), () => QConfigurationKey);
}

export const qConfigurationKeyFacet = new QConfigurationKeyFacet();

export class QConfigurationKeyFacetId extends QId<ConfigurationKeyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QNonConformanceNotificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NonConformanceNotification_Id = new QGuidPath(this.withPrefix("NonConformanceNotification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly NonConformanceNotification = new QEntityPath(this.withPrefix("NonConformanceNotification"), () => QNonConformanceNotification);
}

export const qNonConformanceNotificationFacet = new QNonConformanceNotificationFacet();

export class QNonConformanceNotificationFacetId extends QId<NonConformanceNotificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QUserCertificationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UserCertificationAssociation_Id = new QGuidPath(this.withPrefix("UserCertificationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly UserCertificationAssociation = new QEntityPath(this.withPrefix("UserCertificationAssociation"), () => QUserCertificationAssociation);
}

export const qUserCertificationAssociationFacet = new QUserCertificationAssociationFacet();

export class QUserCertificationAssociationFacetId extends QId<UserCertificationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSkillCertificationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SkillCertificationAssociation_Id = new QGuidPath(this.withPrefix("SkillCertificationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly SkillCertificationAssociation = new QEntityPath(this.withPrefix("SkillCertificationAssociation"), () => QSkillCertificationAssociation);
}

export const qSkillCertificationAssociationFacet = new QSkillCertificationAssociationFacet();

export class QSkillCertificationAssociationFacetId extends QId<SkillCertificationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QRoleCertificationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RoleCertificationAssociation_Id = new QGuidPath(this.withPrefix("RoleCertificationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly RoleCertificationAssociation = new QEntityPath(this.withPrefix("RoleCertificationAssociation"), () => QRoleCertificationAssociation);
}

export const qRoleCertificationAssociationFacet = new QRoleCertificationAssociationFacet();

export class QRoleCertificationAssociationFacetId extends QId<RoleCertificationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialCertificationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialCertificationAssociation_Id = new QGuidPath(this.withPrefix("MaterialCertificationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialCertificationAssociation = new QEntityPath(this.withPrefix("MaterialCertificationAssociation"), () => QMaterialCertificationAssociation);
}

export const qMaterialCertificationAssociationFacet = new QMaterialCertificationAssociationFacet();

export class QMaterialCertificationAssociationFacetId extends QId<MaterialCertificationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentCertificationAssociationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentCertificationAssociation_Id = new QGuidPath(this.withPrefix("EquipmentCertificationAssociation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentCertificationAssociation = new QEntityPath(this.withPrefix("EquipmentCertificationAssociation"), () => QEquipmentCertificationAssociation);
}

export const qEquipmentCertificationAssociationFacet = new QEquipmentCertificationAssociationFacet();

export class QEquipmentCertificationAssociationFacetId extends QId<EquipmentCertificationAssociationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationHistoryActionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CertificationHistoryAction_Id = new QGuidPath(this.withPrefix("CertificationHistoryAction_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CertificationHistoryAction = new QEntityPath(this.withPrefix("CertificationHistoryAction"), () => QCertificationHistoryAction);
}

export const qCertificationHistoryActionFacet = new QCertificationHistoryActionFacet();

export class QCertificationHistoryActionFacetId extends QId<CertificationHistoryActionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationHistoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly CertificationHistory_Id = new QGuidPath(this.withPrefix("CertificationHistory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly CertificationHistory = new QEntityPath(this.withPrefix("CertificationHistory"), () => QCertificationHistory);
}

export const qCertificationHistoryFacet = new QCertificationHistoryFacet();

export class QCertificationHistoryFacetId extends QId<CertificationHistoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QCertificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Certification_Id = new QGuidPath(this.withPrefix("Certification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Certification = new QEntityPath(this.withPrefix("Certification"), () => QCertification);
}

export const qCertificationFacet = new QCertificationFacet();

export class QCertificationFacetId extends QId<CertificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateToMaterialPlantFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TemplateToMaterialPlant_Id = new QGuidPath(this.withPrefix("TemplateToMaterialPlant_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TemplateToMaterialPlant = new QEntityPath(this.withPrefix("TemplateToMaterialPlant"), () => QTemplateToMaterialPlant);
}

export const qTemplateToMaterialPlantFacet = new QTemplateToMaterialPlantFacet();

export class QTemplateToMaterialPlantFacetId extends QId<TemplateToMaterialPlantFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TemplateType_Id = new QGuidPath(this.withPrefix("TemplateType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TemplateType = new QEntityPath(this.withPrefix("TemplateType"), () => QTemplateType);
}

export const qTemplateTypeFacet = new QTemplateTypeFacet();

export class QTemplateTypeFacetId extends QId<TemplateTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateBlockFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly TemplateBlock_Id = new QGuidPath(this.withPrefix("TemplateBlock_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TemplateBlock = new QEntityPath(this.withPrefix("TemplateBlock"), () => QTemplateBlock);
}

export const qTemplateBlockFacet = new QTemplateBlockFacet();

export class QTemplateBlockFacetId extends QId<TemplateBlockFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QTemplateFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Template_Id = new QGuidPath(this.withPrefix("Template_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Template = new QEntityPath(this.withPrefix("Template"), () => QTemplate);
}

export const qTemplateFacet = new QTemplateFacet();

export class QTemplateFacetId extends QId<TemplateFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialSpecificationTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialSpecificationType_Id = new QGuidPath(this.withPrefix("MaterialSpecificationType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialSpecificationType = new QEntityPath(this.withPrefix("MaterialSpecificationType"), () => QMaterialSpecificationType);
}

export const qMaterialSpecificationTypeFacet = new QMaterialSpecificationTypeFacet();

export class QMaterialSpecificationTypeFacetId extends QId<MaterialSpecificationTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolDefinitionDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolDefinitionDocument_Id = new QGuidPath(this.withPrefix("ToolDefinitionDocument_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolDefinitionDocument = new QEntityPath(this.withPrefix("ToolDefinitionDocument"), () => QToolDefinitionDocument);
}

export const qToolDefinitionDocumentFacet = new QToolDefinitionDocumentFacet();

export class QToolDefinitionDocumentFacetId extends QId<ToolDefinitionDocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStepDependencyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StepDependency_Id = new QGuidPath(this.withPrefix("StepDependency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StepDependency = new QEntityPath(this.withPrefix("StepDependency"), () => QStepDependency);
}

export const qStepDependencyFacet = new QStepDependencyFacet();

export class QStepDependencyFacetId extends QId<StepDependencyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStepFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Step_Id = new QGuidPath(this.withPrefix("Step_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStep);
}

export const qStepFacet = new QStepFacet();

export class QStepFacetId extends QId<StepFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QProcessFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Process_Id = new QGuidPath(this.withPrefix("Process_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Process = new QEntityPath(this.withPrefix("Process"), () => QProcess);
}

export const qProcessFacet = new QProcessFacet();

export class QProcessFacetId extends QId<ProcessFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOperationDependencyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OperationDependency_Id = new QGuidPath(this.withPrefix("OperationDependency_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OperationDependency = new QEntityPath(this.withPrefix("OperationDependency"), () => QOperationDependency);
}

export const qOperationDependencyFacet = new QOperationDependencyFacet();

export class QOperationDependencyFacetId extends QId<OperationDependencyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialSpecification_Id = new QGuidPath(this.withPrefix("MaterialSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialSpecification = new QEntityPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecification);
}

export const qMaterialSpecificationFacet = new QMaterialSpecificationFacet();

export class QMaterialSpecificationFacetId extends QId<MaterialSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QMaterialDefinitionDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly MaterialDefinitionDocument_Id = new QGuidPath(this.withPrefix("MaterialDefinitionDocument_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly MaterialDefinitionDocument = new QEntityPath(this.withPrefix("MaterialDefinitionDocument"), () => QMaterialDefinitionDocument);
}

export const qMaterialDefinitionDocumentFacet = new QMaterialDefinitionDocumentFacet();

export class QMaterialDefinitionDocumentFacetId extends QId<MaterialDefinitionDocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentSpecification_Id = new QGuidPath(this.withPrefix("EquipmentSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentSpecification = new QEntityPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecification);
}

export const qEquipmentSpecificationFacet = new QEquipmentSpecificationFacet();

export class QEquipmentSpecificationFacetId extends QId<EquipmentSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDocumentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Document_Id = new QGuidPath(this.withPrefix("Document_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocument);
}

export const qDocumentFacet = new QDocumentFacet();

export class QDocumentFacetId extends QId<DocumentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDependencyTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DependencyType_Id = new QGuidPath(this.withPrefix("DependencyType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DependencyType = new QEntityPath(this.withPrefix("DependencyType"), () => QDependencyType);
}

export const qDependencyTypeFacet = new QDependencyTypeFacet();

export class QDependencyTypeFacetId extends QId<DependencyTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAsPlannedBOPFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOP);
}

export const qAsPlannedBOPFacet = new QAsPlannedBOPFacet();

export class QAsPlannedBOPFacetId extends QId<AsPlannedBOPFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolSpecificationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolSpecification_Id = new QGuidPath(this.withPrefix("ToolSpecification_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolSpecification = new QEntityPath(this.withPrefix("ToolSpecification"), () => QToolSpecification);
}

export const qToolSpecificationFacet = new QToolSpecificationFacet();

export class QToolSpecificationFacetId extends QId<ToolSpecificationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_WorkOrderExtension extends QWorkOrderFacet {
    public readonly ShortText = new QStringPath(this.withPrefix("ShortText"));
    public readonly LongText = new QStringPath(this.withPrefix("LongText"));
    public readonly BasicDataText = new QStringPath(this.withPrefix("BasicDataText"));
    public readonly MaterialMemo = new QStringPath(this.withPrefix("MaterialMemo"));
}

export const qAPPMain_GF_WorkOrderExtension = new QAPPMain_GF_WorkOrderExtension();

export class QAPPMain_GF_Operation extends QOperationFacet {
    public readonly InclusionRule = new QStringPath(this.withPrefix("InclusionRule"));
    public readonly InclusionRuleParsed = new QStringPath(this.withPrefix("InclusionRuleParsed"));
    public readonly Mandatory = new QBooleanPath(this.withPrefix("Mandatory"));
}

export const qAPPMain_GF_Operation = new QAPPMain_GF_Operation();

export class QAPPMain_DocumentCategory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_DocumentCategoryFacet);
}

export const qAPPMain_DocumentCategory = new QAPPMain_DocumentCategory();

export class QAPPMain_DocumentCategoryId extends QId<APPMain_DocumentCategoryId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UoMMappings extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly SAPUoM = new QStringPath(this.withPrefix("SAPUoM"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_UoMMappingsFacet);
}

export const qAPPMain_GF_UoMMappings = new QAPPMain_GF_UoMMappings();

export class QAPPMain_GF_UoMMappingsId extends QId<APPMain_GF_UoMMappingsId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_File extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly File = new QBinaryPath(this.withPrefix("File"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly FileType = new QStringPath(this.withPrefix("FileType"));
    public readonly Metadata = new QStringPath(this.withPrefix("Metadata"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_FileFacet);
}

export const qAPPMain_GF_File = new QAPPMain_GF_File();

export class QAPPMain_GF_FileId extends QId<APPMain_GF_FileId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ReworkProcessAssignment extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
    public readonly Failure_Id = new QGuidPath(this.withPrefix("Failure_Id"));
    public readonly Process_Id = new QGuidPath(this.withPrefix("Process_Id"));
    public readonly EquipmentConfig_Id = new QGuidPath(this.withPrefix("EquipmentConfig_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Failure = new QEntityPath(this.withPrefix("Failure"), () => QFailure);
    public readonly Process = new QEntityPath(this.withPrefix("Process"), () => QProcess);
    public readonly EquipmentConfig = new QEntityPath(this.withPrefix("EquipmentConfig"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_ReworkProcessAssignmentFacet);
}

export const qAPPMain_GF_ReworkProcessAssignment = new QAPPMain_GF_ReworkProcessAssignment();

export class QAPPMain_GF_ReworkProcessAssignmentId extends QId<APPMain_GF_ReworkProcessAssignmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_MaterialProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly PropertyUoMNId = new QStringPath(this.withPrefix("PropertyUoMNId"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly Material_Id = new QGuidPath(this.withPrefix("Material_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterial);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_MaterialPropertyFacet);
}

export const qAPPMain_MaterialProperty = new QAPPMain_MaterialProperty();

export class QAPPMain_MaterialPropertyId extends QId<APPMain_MaterialPropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_DocumentEntityLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DocumentNId = new QStringPath(this.withPrefix("DocumentNId"));
    public readonly DocumentRevision = new QStringPath(this.withPrefix("DocumentRevision"));
    public readonly LinkedEntityType = new QStringPath(this.withPrefix("LinkedEntityType"));
    public readonly LinkedEntityId = new QGuidPath(this.withPrefix("LinkedEntityId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_DocumentEntityLinkFacet);
}

export const qAPPMain_DocumentEntityLink = new QAPPMain_DocumentEntityLink();

export class QAPPMain_DocumentEntityLinkId extends QId<APPMain_DocumentEntityLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_TaskParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), TaskDefinitionParameterDirections);
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly Task_Id = new QGuidPath(this.withPrefix("Task_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Task = new QEntityPath(this.withPrefix("Task"), () => QTask);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_TaskParameterFacet);
}

export const qAPPMain_TaskParameter = new QAPPMain_TaskParameter();

export class QAPPMain_TaskParameterId extends QId<APPMain_TaskParameterId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ScanDiagnostic extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly WorkCenter = new QStringPath(this.withPrefix("WorkCenter"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_ScanDiagnosticFacet);
}

export const qAPPMain_GF_ScanDiagnostic = new QAPPMain_GF_ScanDiagnostic();

export class QAPPMain_GF_ScanDiagnosticId extends QId<APPMain_GF_ScanDiagnosticId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_RunningScans extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_RunningScansFacet);
}

export const qAPPMain_GF_RunningScans = new QAPPMain_GF_RunningScans();

export class QAPPMain_GF_RunningScansId extends QId<APPMain_GF_RunningScansId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ProductsWaitingForValidation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly WorkcenterNId = new QStringPath(this.withPrefix("WorkcenterNId"));
    public readonly ValidatedProductId = new QStringPath(this.withPrefix("ValidatedProductId"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
    public readonly ValidationOK = new QBooleanPath(this.withPrefix("ValidationOK"));
    public readonly Handshaken = new QBooleanPath(this.withPrefix("Handshaken"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_ProductsWaitingForValidationFacet);
}

export const qAPPMain_GF_ProductsWaitingForValidation = new QAPPMain_GF_ProductsWaitingForValidation();

export class QAPPMain_GF_ProductsWaitingForValidationId extends QId<APPMain_GF_ProductsWaitingForValidationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_LineRouting extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly FEVOR = new QStringPath(this.withPrefix("FEVOR"));
    public readonly DISPO = new QStringPath(this.withPrefix("DISPO"));
    public readonly WERKS = new QStringPath(this.withPrefix("WERKS"));
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QAPPMain_GF_LineRoutingFacet);
}

export const qAPPMain_GF_LineRouting = new QAPPMain_GF_LineRouting();

export class QAPPMain_GF_LineRoutingId extends QId<APPMain_GF_LineRoutingId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_DocumentCategoryFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_DocumentCategory_Id = new QGuidPath(this.withPrefix("APPMain_DocumentCategory_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_DocumentCategory = new QEntityPath(this.withPrefix("APPMain_DocumentCategory"), () => QAPPMain_DocumentCategory);
}

export const qAPPMain_DocumentCategoryFacet = new QAPPMain_DocumentCategoryFacet();

export class QAPPMain_DocumentCategoryFacetId extends QId<APPMain_DocumentCategoryFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UoMMappingsFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_UoMMappings_Id = new QGuidPath(this.withPrefix("APPMain_GF_UoMMappings_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_UoMMappings = new QEntityPath(this.withPrefix("APPMain_GF_UoMMappings"), () => QAPPMain_GF_UoMMappings);
}

export const qAPPMain_GF_UoMMappingsFacet = new QAPPMain_GF_UoMMappingsFacet();

export class QAPPMain_GF_UoMMappingsFacetId extends QId<APPMain_GF_UoMMappingsFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_FileFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_File_Id = new QGuidPath(this.withPrefix("APPMain_GF_File_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_File = new QEntityPath(this.withPrefix("APPMain_GF_File"), () => QAPPMain_GF_File);
}

export const qAPPMain_GF_FileFacet = new QAPPMain_GF_FileFacet();

export class QAPPMain_GF_FileFacetId extends QId<APPMain_GF_FileFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ReworkProcessAssignmentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_ReworkProcessAssignment_Id = new QGuidPath(this.withPrefix("APPMain_GF_ReworkProcessAssignment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_ReworkProcessAssignment = new QEntityPath(this.withPrefix("APPMain_GF_ReworkProcessAssignment"), () => QAPPMain_GF_ReworkProcessAssignment);
}

export const qAPPMain_GF_ReworkProcessAssignmentFacet = new QAPPMain_GF_ReworkProcessAssignmentFacet();

export class QAPPMain_GF_ReworkProcessAssignmentFacetId extends QId<APPMain_GF_ReworkProcessAssignmentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_MaterialPropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_MaterialProperty_Id = new QGuidPath(this.withPrefix("APPMain_MaterialProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_MaterialProperty = new QEntityPath(this.withPrefix("APPMain_MaterialProperty"), () => QAPPMain_MaterialProperty);
}

export const qAPPMain_MaterialPropertyFacet = new QAPPMain_MaterialPropertyFacet();

export class QAPPMain_MaterialPropertyFacetId extends QId<APPMain_MaterialPropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_DocumentEntityLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_DocumentEntityLink_Id = new QGuidPath(this.withPrefix("APPMain_DocumentEntityLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_DocumentEntityLink = new QEntityPath(this.withPrefix("APPMain_DocumentEntityLink"), () => QAPPMain_DocumentEntityLink);
}

export const qAPPMain_DocumentEntityLinkFacet = new QAPPMain_DocumentEntityLinkFacet();

export class QAPPMain_DocumentEntityLinkFacetId extends QId<APPMain_DocumentEntityLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_TaskParameterFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_TaskParameter_Id = new QGuidPath(this.withPrefix("APPMain_TaskParameter_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_TaskParameter = new QEntityPath(this.withPrefix("APPMain_TaskParameter"), () => QAPPMain_TaskParameter);
}

export const qAPPMain_TaskParameterFacet = new QAPPMain_TaskParameterFacet();

export class QAPPMain_TaskParameterFacetId extends QId<APPMain_TaskParameterFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ScanDiagnosticFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_ScanDiagnostic_Id = new QGuidPath(this.withPrefix("APPMain_GF_ScanDiagnostic_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_ScanDiagnostic = new QEntityPath(this.withPrefix("APPMain_GF_ScanDiagnostic"), () => QAPPMain_GF_ScanDiagnostic);
}

export const qAPPMain_GF_ScanDiagnosticFacet = new QAPPMain_GF_ScanDiagnosticFacet();

export class QAPPMain_GF_ScanDiagnosticFacetId extends QId<APPMain_GF_ScanDiagnosticFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_RunningScansFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_RunningScans_Id = new QGuidPath(this.withPrefix("APPMain_GF_RunningScans_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_RunningScans = new QEntityPath(this.withPrefix("APPMain_GF_RunningScans"), () => QAPPMain_GF_RunningScans);
}

export const qAPPMain_GF_RunningScansFacet = new QAPPMain_GF_RunningScansFacet();

export class QAPPMain_GF_RunningScansFacetId extends QId<APPMain_GF_RunningScansFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ProductsWaitingForValidationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_ProductsWaitingForValidation_Id = new QGuidPath(this.withPrefix("APPMain_GF_ProductsWaitingForValidation_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_ProductsWaitingForValidation = new QEntityPath(this.withPrefix("APPMain_GF_ProductsWaitingForValidation"), () => QAPPMain_GF_ProductsWaitingForValidation);
}

export const qAPPMain_GF_ProductsWaitingForValidationFacet = new QAPPMain_GF_ProductsWaitingForValidationFacet();

export class QAPPMain_GF_ProductsWaitingForValidationFacetId extends QId<APPMain_GF_ProductsWaitingForValidationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_LineRoutingFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly APPMain_GF_LineRouting_Id = new QGuidPath(this.withPrefix("APPMain_GF_LineRouting_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly APPMain_GF_LineRouting = new QEntityPath(this.withPrefix("APPMain_GF_LineRouting"), () => QAPPMain_GF_LineRouting);
}

export const qAPPMain_GF_LineRoutingFacet = new QAPPMain_GF_LineRoutingFacet();

export class QAPPMain_GF_LineRoutingFacetId extends QId<APPMain_GF_LineRoutingFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDSBoF_AcquisitionCycle extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StartOn = new QDateTimeOffsetPath(this.withPrefix("StartOn"));
    public readonly Interval = new QNumberPath(this.withPrefix("Interval"));
    public readonly StartingTimeKind = new QEnumPath(this.withPrefix("StartingTimeKind"), TagDateTimeKind);
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QDSBoF_AcquisitionCycleFacet);
}

export const qDSBoF_AcquisitionCycle = new QDSBoF_AcquisitionCycle();

export class QDSBoF_AcquisitionCycleId extends QId<DSBoF_AcquisitionCycleId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QDSBoF_AcquisitionCycleFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly DSBoF_AcquisitionCycle_Id = new QGuidPath(this.withPrefix("DSBoF_AcquisitionCycle_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly DSBoF_AcquisitionCycle = new QEntityPath(this.withPrefix("DSBoF_AcquisitionCycle"), () => QDSBoF_AcquisitionCycle);
}

export const qDSBoF_AcquisitionCycleFacet = new QDSBoF_AcquisitionCycleFacet();

export class QDSBoF_AcquisitionCycleFacetId extends QId<DSBoF_AcquisitionCycleFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolAGW_EquipmentConfigurationToAutomationNodeInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet);
}

export const qToolAGW_EquipmentConfigurationToAutomationNodeInstance = new QToolAGW_EquipmentConfigurationToAutomationNodeInstance();

export class QToolAGW_EquipmentConfigurationToAutomationNodeInstanceId extends QId<ToolAGW_EquipmentConfigurationToAutomationNodeInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ToolAGW_EquipmentConfigurationToAutomationNodeInstance_Id = new QGuidPath(this.withPrefix("ToolAGW_EquipmentConfigurationToAutomationNodeInstance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ToolAGW_EquipmentConfigurationToAutomationNodeInstance = new QEntityPath(this.withPrefix("ToolAGW_EquipmentConfigurationToAutomationNodeInstance"), () => QToolAGW_EquipmentConfigurationToAutomationNodeInstance);
}

export const qToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet = new QToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacet();

export class QToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacetId extends QId<ToolAGW_EquipmentConfigurationToAutomationNodeInstanceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionError extends QueryObject {
    public readonly ErrorCode = new QNumberPath(this.withPrefix("ErrorCode"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
}

export const qExecutionError = new QExecutionError();

export class QPrecheckExecution extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FullName = new QStringPath(this.withPrefix("FullName"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
}

export const qPrecheckExecution = new QPrecheckExecution();

export class QSitUafExecutionDetail extends QueryObject {
    public readonly PrecheckDetails = new QEntityCollectionPath(this.withPrefix("PrecheckDetails"), () => QPrecheckExecution);
}

export const qSitUafExecutionDetail = new QSitUafExecutionDetail();

export class QCommandResponse extends QueryObject {
    public readonly Succeeded = new QBooleanPath(this.withPrefix("Succeeded"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
    public readonly SitUafExecutionDetail = new QEntityPath(this.withPrefix("SitUafExecutionDetail"), () => QSitUafExecutionDetail);
}

export const qCommandResponse = new QCommandResponse();

export class QFunctionResponse extends QCommandResponse {
}

export const qFunctionResponse = new QFunctionResponse();

export class QPreCheckResponse extends QCommandResponse {
}

export const qPreCheckResponse = new QPreCheckResponse();

export class QServiceLayerUnityError extends QueryObject {
    public readonly commandcallstack = new QCollectionPath(this.withPrefix("commandcallstack"), () => QStringCollection);
    public readonly stacktrace = new QStringPath(this.withPrefix("stacktrace"));
}

export const qServiceLayerUnityError = new QServiceLayerUnityError();

export class QServiceLayerErrorObject extends QueryObject {
    public readonly code = new QStringPath(this.withPrefix("code"));
    public readonly message = new QStringPath(this.withPrefix("message"));
    public readonly innererror = new QEntityPath(this.withPrefix("innererror"), () => QServiceLayerUnityError);
}

export const qServiceLayerErrorObject = new QServiceLayerErrorObject();

export class QServiceLayerError extends QueryObject {
    public readonly error = new QEntityPath(this.withPrefix("error"), () => QServiceLayerErrorObject);
}

export const qServiceLayerError = new QServiceLayerError();

export class QUADMDeleteWorkOperationTypeListResponse extends QCommandResponse {
}

export const qUADMDeleteWorkOperationTypeListResponse = new QUADMDeleteWorkOperationTypeListResponse();

export class QUADMDeleteWorkOperationTypeList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMDeleteWorkOperationTypeList = new QUADMDeleteWorkOperationTypeList();

export class QUADMStartOperationResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMStartOperationResponse = new QUADMStartOperationResponse();

export class QUADMStartOperation extends QueryObject {
    public readonly UADMStartOperationParameters = new QEntityCollectionPath(this.withPrefix("UADMStartOperationParameters"), () => QStartWOOperationFullQtyParameterType);
}

export const qUADMStartOperation = new QUADMStartOperation();

export class QUADMUpdateWOByBoPListResponse extends QCommandResponse {
    public readonly Id = new QCollectionPath(this.withPrefix("Id"), () => QGuidCollection);
}

export const qUADMUpdateWOByBoPListResponse = new QUADMUpdateWOByBoPListResponse();

export class QUADMUpdateWOByBoPList extends QueryObject {
    public readonly WOsDetailsForUpdate = new QEntityCollectionPath(this.withPrefix("WOsDetailsForUpdate"), () => QWorkOrderDetailsForBoPUpdateParameterType);
}

export const qUADMUpdateWOByBoPList = new QUADMUpdateWOByBoPList();

export class QUADMStartWOOperationTransferBatchListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMStartWOOperationTransferBatchListResponse = new QUADMStartWOOperationTransferBatchListResponse();

export class QUADMStartWOOperationTransferBatchList extends QueryObject {
    public readonly StartTransferBatchParameterTypeList = new QEntityCollectionPath(this.withPrefix("StartTransferBatchParameterTypeList"), () => QStartWOOperationTransferBatchParameterType);
}

export const qUADMStartWOOperationTransferBatchList = new QUADMStartWOOperationTransferBatchList();

export class QUADMConsumeMaterialItemListResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qUADMConsumeMaterialItemListResponse = new QUADMConsumeMaterialItemListResponse();

export class QUADMConsumeMaterialItemList extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly MaterialItemToConsumeList = new QEntityCollectionPath(this.withPrefix("MaterialItemToConsumeList"), () => QMaterialItemToConsumeParameterType);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qUADMConsumeMaterialItemList = new QUADMConsumeMaterialItemList();

export class QUADMSentenceNonConformanceResponse extends QCommandResponse {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
}

export const qUADMSentenceNonConformanceResponse = new QUADMSentenceNonConformanceResponse();

export class QUADMSentenceNonConformance extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceStatusNid = new QStringPath(this.withPrefix("NonConformanceStatusNid"));
    public readonly NonConformanceHistoryId = new QStringPath(this.withPrefix("NonConformanceHistoryId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly ReworkOrderCreationDetails = new QEntityPath(this.withPrefix("ReworkOrderCreationDetails"), () => QCreateReworkOrderParameterType);
}

export const qUADMSentenceNonConformance = new QUADMSentenceNonConformance();

export class QUADMCreateNonConformanceResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qUADMCreateNonConformanceResponse = new QUADMCreateNonConformanceResponse();

export class QUADMCreateNonConformance extends QueryObject {
    public readonly NonConformanceDetails = new QEntityPath(this.withPrefix("NonConformanceDetails"), () => QNonConformanceParameterType);
    public readonly NonConformanceHistoryDetails = new QEntityPath(this.withPrefix("NonConformanceHistoryDetails"), () => QNonConformanceHistoryParameterType);
    public readonly DefectsDetails = new QEntityCollectionPath(this.withPrefix("DefectsDetails"), () => QDefectParameterType);
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly ExtensionKey = new QStringPath(this.withPrefix("ExtensionKey"));
}

export const qUADMCreateNonConformance = new QUADMCreateNonConformance();

export class QAcceptBuyOffResponse extends QCommandResponse {
}

export const qAcceptBuyOffResponse = new QAcceptBuyOffResponse();

export class QAcceptBuyOff extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceHistoryId = new QStringPath(this.withPrefix("NonConformanceHistoryId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
}

export const qAcceptBuyOff = new QAcceptBuyOff();

export class QRejectBuyOffResponse extends QCommandResponse {
}

export const qRejectBuyOffResponse = new QRejectBuyOffResponse();

export class QRejectBuyOff extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceHistoryId = new QStringPath(this.withPrefix("NonConformanceHistoryId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
}

export const qRejectBuyOff = new QRejectBuyOff();

export class QUADMCreateWorkOrdersFromAsPlannedBOPResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMCreateWorkOrdersFromAsPlannedBOPResponse = new QUADMCreateWorkOrdersFromAsPlannedBOPResponse();

export class QUADMCreateWorkOrdersFromAsPlannedBOP extends QueryObject {
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly BomToBeUsed = new QEntityPath(this.withPrefix("BomToBeUsed"), () => QBoMParameterType);
}

export const qUADMCreateWorkOrdersFromAsPlannedBOP = new QUADMCreateWorkOrdersFromAsPlannedBOP();

export class QUADMCreateTravellingWorkResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qUADMCreateTravellingWorkResponse = new QUADMCreateTravellingWorkResponse();

export class QUADMCreateTravellingWork extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMCreateTravellingWork = new QUADMCreateTravellingWork();

export class QUADMTakeOwnershipTravellingWorkResponse extends QCommandResponse {
}

export const qUADMTakeOwnershipTravellingWorkResponse = new QUADMTakeOwnershipTravellingWorkResponse();

export class QUADMTakeOwnershipTravellingWork extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMTakeOwnershipTravellingWork = new QUADMTakeOwnershipTravellingWork();

export class QUADMAcceptTravellingWorkResponse extends QCommandResponse {
}

export const qUADMAcceptTravellingWorkResponse = new QUADMAcceptTravellingWorkResponse();

export class QUADMAcceptTravellingWork extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUADMAcceptTravellingWork = new QUADMAcceptTravellingWork();

export class QUADMStartWOOperationSerializedListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMStartWOOperationSerializedListResponse = new QUADMStartWOOperationSerializedListResponse();

export class QUADMStartWOOperationSerializedList extends QueryObject {
    public readonly StartWOOperationSerializedParameterTypeList = new QEntityCollectionPath(this.withPrefix("StartWOOperationSerializedParameterTypeList"), () => QStartWOOperationSerializedParameterType);
}

export const qUADMStartWOOperationSerializedList = new QUADMStartWOOperationSerializedList();

export class QUADMSetWorkOrderOperationFutureHoldListResponse extends QCommandResponse {
}

export const qUADMSetWorkOrderOperationFutureHoldListResponse = new QUADMSetWorkOrderOperationFutureHoldListResponse();

export class QUADMSetWorkOrderOperationFutureHoldList extends QueryObject {
    public readonly FutureHoldDetails = new QEntityCollectionPath(this.withPrefix("FutureHoldDetails"), () => QHoldParamterType);
}

export const qUADMSetWorkOrderOperationFutureHoldList = new QUADMSetWorkOrderOperationFutureHoldList();

export class QUADMCreateChangeNonConformanceResponse extends QCommandResponse {
}

export const qUADMCreateChangeNonConformanceResponse = new QUADMCreateChangeNonConformanceResponse();

export class QUADMCreateChangeNonConformance extends QueryObject {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ChangeTypeId = new QGuidPath(this.withPrefix("ChangeTypeId"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qUADMCreateChangeNonConformance = new QUADMCreateChangeNonConformance();

export class QUADMAbortWorkOrderResponse extends QCommandResponse {
}

export const qUADMAbortWorkOrderResponse = new QUADMAbortWorkOrderResponse();

export class QUADMAbortWorkOrder extends QueryObject {
    public readonly WorkOrderIdentifiersList = new QEntityCollectionPath(this.withPrefix("WorkOrderIdentifiersList"), () => QWorkOrderIdentifiersParameterType);
}

export const qUADMAbortWorkOrder = new QUADMAbortWorkOrder();

export class QUADMVerifyWorkOrderResponse extends QCommandResponse {
}

export const qUADMVerifyWorkOrderResponse = new QUADMVerifyWorkOrderResponse();

export class QUADMVerifyWorkOrder extends QueryObject {
    public readonly MaterialItemIdentifiersList = new QEntityCollectionPath(this.withPrefix("MaterialItemIdentifiersList"), () => QMaterialItemIdentifiersParameterType);
}

export const qUADMVerifyWorkOrder = new QUADMVerifyWorkOrder();

export class QUADMSetWorkOrderHoldListResponse extends QCommandResponse {
}

export const qUADMSetWorkOrderHoldListResponse = new QUADMSetWorkOrderHoldListResponse();

export class QUADMSetWorkOrderHoldList extends QueryObject {
    public readonly HoldDetails = new QEntityCollectionPath(this.withPrefix("HoldDetails"), () => QHoldParamterType);
}

export const qUADMSetWorkOrderHoldList = new QUADMSetWorkOrderHoldList();

export class QUADMRemoveWorkOrderOperationFutureHoldListResponse extends QCommandResponse {
}

export const qUADMRemoveWorkOrderOperationFutureHoldListResponse = new QUADMRemoveWorkOrderOperationFutureHoldListResponse();

export class QUADMRemoveWorkOrderOperationFutureHoldList extends QueryObject {
    public readonly FutureHoldIds = new QCollectionPath(this.withPrefix("FutureHoldIds"), () => QGuidCollection);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
}

export const qUADMRemoveWorkOrderOperationFutureHoldList = new QUADMRemoveWorkOrderOperationFutureHoldList();

export class QUADMCompleteWOOperationSerializedListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMCompleteWOOperationSerializedListResponse = new QUADMCompleteWOOperationSerializedListResponse();

export class QUADMCompleteWOOperationSerializedList extends QueryObject {
    public readonly CompleteSerializedWoOpParameterList = new QEntityCollectionPath(this.withPrefix("CompleteSerializedWoOpParameterList"), () => QCompleteWOOperationSerializedParameterType);
}

export const qUADMCompleteWOOperationSerializedList = new QUADMCompleteWOOperationSerializedList();

export class QUADMUnVerifyWorkOrderResponse extends QCommandResponse {
}

export const qUADMUnVerifyWorkOrderResponse = new QUADMUnVerifyWorkOrderResponse();

export class QUADMUnVerifyWorkOrder extends QueryObject {
    public readonly MaterialItemIdentifiersList = new QEntityCollectionPath(this.withPrefix("MaterialItemIdentifiersList"), () => QMaterialItemIdentifiersParameterType);
}

export const qUADMUnVerifyWorkOrder = new QUADMUnVerifyWorkOrder();

export class QUADMCreateAndAssignProducedMaterialItemsResponse extends QCommandResponse {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qUADMCreateAndAssignProducedMaterialItemsResponse = new QUADMCreateAndAssignProducedMaterialItemsResponse();

export class QUADMCreateAndAssignProducedMaterialItems extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly FlexibleWorkOrderQuantity = new QNumberPath(this.withPrefix("FlexibleWorkOrderQuantity"));
}

export const qUADMCreateAndAssignProducedMaterialItems = new QUADMCreateAndAssignProducedMaterialItems();

export class QUADMCompleteWOStepListResponse extends QCommandResponse {
}

export const qUADMCompleteWOStepListResponse = new QUADMCompleteWOStepListResponse();

export class QUADMCompleteWOStepList extends QueryObject {
    public readonly WorkOrderStepListDetails = new QEntityCollectionPath(this.withPrefix("WorkOrderStepListDetails"), () => QIdentifiersParameterType);
}

export const qUADMCompleteWOStepList = new QUADMCompleteWOStepList();

export class QUADMStartWOStepResponse extends QCommandResponse {
}

export const qUADMStartWOStepResponse = new QUADMStartWOStepResponse();

export class QUADMStartWOStep extends QueryObject {
    public readonly WorkOrderStepDetails = new QEntityPath(this.withPrefix("WorkOrderStepDetails"), () => QIdentifiersParameterType);
}

export const qUADMStartWOStep = new QUADMStartWOStep();

export class QUADMAcceptChangeRepeatOperationResponse extends QCommandResponse {
    public readonly WorkOrderOperationIds = new QCollectionPath(this.withPrefix("WorkOrderOperationIds"), () => QGuidCollection);
}

export const qUADMAcceptChangeRepeatOperationResponse = new QUADMAcceptChangeRepeatOperationResponse();

export class QUADMAcceptChangeRepeatOperation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly AfterWorkorderOperationId = new QGuidPath(this.withPrefix("AfterWorkorderOperationId"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly ChangeDetails = new QEntityCollectionPath(this.withPrefix("ChangeDetails"), () => QRepeatOperationChangeParameter);
}

export const qUADMAcceptChangeRepeatOperation = new QUADMAcceptChangeRepeatOperation();

export class QUADMAcceptChangeAddToBeConsumedMaterialResponse extends QCommandResponse {
}

export const qUADMAcceptChangeAddToBeConsumedMaterialResponse = new QUADMAcceptChangeAddToBeConsumedMaterialResponse();

export class QUADMAcceptChangeAddToBeConsumedMaterial extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ToBeConsumedMaterial = new QEntityPath(this.withPrefix("ToBeConsumedMaterial"), () => QToBeConsumedMaterialParameter);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qUADMAcceptChangeAddToBeConsumedMaterial = new QUADMAcceptChangeAddToBeConsumedMaterial();

export class QUADMAcceptChangeAddDCDRuntimeTaskResponse extends QCommandResponse {
}

export const qUADMAcceptChangeAddDCDRuntimeTaskResponse = new QUADMAcceptChangeAddDCDRuntimeTaskResponse();

export class QUADMAcceptChangeAddDCDRuntimeTask extends QueryObject {
    public readonly WorkOrderOperationId = new QNumberPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QNumberPath(this.withPrefix("WorkOrderStepId"));
    public readonly ToBeConsumedMaterialId = new QNumberPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly DCDTaskId = new QStringPath(this.withPrefix("DCDTaskId"));
    public readonly ChangeDataCollectionId = new QNumberPath(this.withPrefix("ChangeDataCollectionId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qUADMAcceptChangeAddDCDRuntimeTask = new QUADMAcceptChangeAddDCDRuntimeTask();

export class QUADMAcceptChangeAddOperationResponse extends QCommandResponse {
}

export const qUADMAcceptChangeAddOperationResponse = new QUADMAcceptChangeAddOperationResponse();

export class QUADMAcceptChangeAddOperation extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly ToBeUsedMachine = new QEntityPath(this.withPrefix("ToBeUsedMachine"), () => QToBeUsedMachineParameter);
    public readonly AfterSequence = new QNumberPath(this.withPrefix("AfterSequence"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly WorkOrderOperationDescription = new QStringPath(this.withPrefix("WorkOrderOperationDescription"));
}

export const qUADMAcceptChangeAddOperation = new QUADMAcceptChangeAddOperation();

export class QUADMAcceptChangeChangeDependencyResponse extends QCommandResponse {
}

export const qUADMAcceptChangeChangeDependencyResponse = new QUADMAcceptChangeChangeDependencyResponse();

export class QUADMAcceptChangeChangeDependency extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly OldWorkOOperationDependencyId = new QStringPath(this.withPrefix("OldWorkOOperationDependencyId"));
    public readonly NewWorkOOperationDependency = new QEntityPath(this.withPrefix("NewWorkOOperationDependency"), () => QWorkOOperationDependencyParameter);
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qUADMAcceptChangeChangeDependency = new QUADMAcceptChangeChangeDependency();

export class QUADMAcceptChangeChangeToBeConsumedMaterialQuantityResponse extends QCommandResponse {
}

export const qUADMAcceptChangeChangeToBeConsumedMaterialQuantityResponse = new QUADMAcceptChangeChangeToBeConsumedMaterialQuantityResponse();

export class QUADMAcceptChangeChangeToBeConsumedMaterialQuantity extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly NewQuantity = new QNumberPath(this.withPrefix("NewQuantity"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly IsMaterialBehaviourOutputTypeFlag0 = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputTypeFlag0"));
    public readonly IsMaterialBehaviourOutputType = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputType"));
}

export const qUADMAcceptChangeChangeToBeConsumedMaterialQuantity = new QUADMAcceptChangeChangeToBeConsumedMaterialQuantity();

export class QUADMAcceptChangeChangeToBeUsedMachineResponse extends QCommandResponse {
}

export const qUADMAcceptChangeChangeToBeUsedMachineResponse = new QUADMAcceptChangeChangeToBeUsedMachineResponse();

export class QUADMAcceptChangeChangeToBeUsedMachine extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly OldToBeUsedMachineId = new QGuidPath(this.withPrefix("OldToBeUsedMachineId"));
    public readonly NewToBeUsedMachine = new QEntityPath(this.withPrefix("NewToBeUsedMachine"), () => QToBeUsedMachineParameter);
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qUADMAcceptChangeChangeToBeUsedMachine = new QUADMAcceptChangeChangeToBeUsedMachine();

export class QUADMAcceptChangeRemoveDependencyResponse extends QCommandResponse {
}

export const qUADMAcceptChangeRemoveDependencyResponse = new QUADMAcceptChangeRemoveDependencyResponse();

export class QUADMAcceptChangeRemoveDependency extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly WorkOOperationDependencyId = new QGuidPath(this.withPrefix("WorkOOperationDependencyId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qUADMAcceptChangeRemoveDependency = new QUADMAcceptChangeRemoveDependency();

export class QUADMAcceptChangeRemoveOperationResponse extends QCommandResponse {
}

export const qUADMAcceptChangeRemoveOperationResponse = new QUADMAcceptChangeRemoveOperationResponse();

export class QUADMAcceptChangeRemoveOperation extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qUADMAcceptChangeRemoveOperation = new QUADMAcceptChangeRemoveOperation();

export class QUADMAcceptChangeRemoveToBeConsumedMaterialResponse extends QCommandResponse {
}

export const qUADMAcceptChangeRemoveToBeConsumedMaterialResponse = new QUADMAcceptChangeRemoveToBeConsumedMaterialResponse();

export class QUADMAcceptChangeRemoveToBeConsumedMaterial extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly IsMaterialBehaviourOutputTypeFlag0 = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputTypeFlag0"));
    public readonly IsMaterialBehaviourOutputType = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputType"));
}

export const qUADMAcceptChangeRemoveToBeConsumedMaterial = new QUADMAcceptChangeRemoveToBeConsumedMaterial();

export class QUADMAcceptChangeReplaceToBeConsumedMaterialResponse extends QCommandResponse {
}

export const qUADMAcceptChangeReplaceToBeConsumedMaterialResponse = new QUADMAcceptChangeReplaceToBeConsumedMaterialResponse();

export class QUADMAcceptChangeReplaceToBeConsumedMaterial extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly OldToBeConsumedMaterialId = new QGuidPath(this.withPrefix("OldToBeConsumedMaterialId"));
    public readonly NewToBeConsumedMaterial = new QEntityPath(this.withPrefix("NewToBeConsumedMaterial"), () => QToBeConsumedMaterialParameter);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly IsMaterialBehaviourOutputTypeFlag0 = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputTypeFlag0"));
    public readonly IsMaterialBehaviourOutputType = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputType"));
}

export const qUADMAcceptChangeReplaceToBeConsumedMaterial = new QUADMAcceptChangeReplaceToBeConsumedMaterial();

export class QUADMRejectChangeNonConformanceResponse extends QCommandResponse {
}

export const qUADMRejectChangeNonConformanceResponse = new QUADMRejectChangeNonConformanceResponse();

export class QUADMRejectChangeNonConformance extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMRejectChangeNonConformance = new QUADMRejectChangeNonConformance();

export class QUADMCreateReworkCodeListResponse extends QCommandResponse {
}

export const qUADMCreateReworkCodeListResponse = new QUADMCreateReworkCodeListResponse();

export class QUADMCreateReworkCodeList extends QueryObject {
    public readonly DefectTypeId = new QGuidPath(this.withPrefix("DefectTypeId"));
    public readonly DefectGroupId = new QGuidPath(this.withPrefix("DefectGroupId"));
    public readonly MaterialDefinitionIdList = new QCollectionPath(this.withPrefix("MaterialDefinitionIdList"), () => QGuidCollection);
    public readonly ProcessIdList = new QCollectionPath(this.withPrefix("ProcessIdList"), () => QGuidCollection);
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
}

export const qUADMCreateReworkCodeList = new QUADMCreateReworkCodeList();

export class QUADMSentenceNonConformanceSetLocationHoldResponse extends QCommandResponse {
}

export const qUADMSentenceNonConformanceSetLocationHoldResponse = new QUADMSentenceNonConformanceSetLocationHoldResponse();

export class QUADMSentenceNonConformanceSetLocationHold extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly HoldReasonNIdList = new QCollectionPath(this.withPrefix("HoldReasonNIdList"), () => QStringCollection);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
}

export const qUADMSentenceNonConformanceSetLocationHold = new QUADMSentenceNonConformanceSetLocationHold();

export class QUADMManageToBeConsumedMaterialDisassembleResponse extends QCommandResponse {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMManageToBeConsumedMaterialDisassembleResponse = new QUADMManageToBeConsumedMaterialDisassembleResponse();

export class QUADMManageToBeConsumedMaterialDisassemble extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly MaterialItemIdentifiersList = new QEntityCollectionPath(this.withPrefix("MaterialItemIdentifiersList"), () => QMaterialItemIdentifiersParameterType);
}

export const qUADMManageToBeConsumedMaterialDisassemble = new QUADMManageToBeConsumedMaterialDisassemble();

export class QUADMSplitWorkOrderResponse extends QCommandResponse {
    public readonly NewWorkOrderList = new QEntityCollectionPath(this.withPrefix("NewWorkOrderList"), () => QWorkOrderIdentifiersParameterType);
}

export const qUADMSplitWorkOrderResponse = new QUADMSplitWorkOrderResponse();

export class QUADMSplitWorkOrder extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly SplitType = new QStringPath(this.withPrefix("SplitType"));
    public readonly NewWorkOrderList = new QEntityCollectionPath(this.withPrefix("NewWorkOrderList"), () => QNewWorkOrderForSplit);
}

export const qUADMSplitWorkOrder = new QUADMSplitWorkOrder();

export class QUADMSkipWOOperationFullQtyResponse extends QCommandResponse {
}

export const qUADMSkipWOOperationFullQtyResponse = new QUADMSkipWOOperationFullQtyResponse();

export class QUADMSkipWOOperationFullQty extends QueryObject {
    public readonly WorkOrderOperationDetail = new QEntityPath(this.withPrefix("WorkOrderOperationDetail"), () => QIdentifiersParameterType);
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qUADMSkipWOOperationFullQty = new QUADMSkipWOOperationFullQty();

export class QUADMSkipWOOperationTransferBatchResponse extends QCommandResponse {
}

export const qUADMSkipWOOperationTransferBatchResponse = new QUADMSkipWOOperationTransferBatchResponse();

export class QUADMSkipWOOperationTransferBatch extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qUADMSkipWOOperationTransferBatch = new QUADMSkipWOOperationTransferBatch();

export class QUADMSkipWOOperationSerializedResponse extends QCommandResponse {
}

export const qUADMSkipWOOperationSerializedResponse = new QUADMSkipWOOperationSerializedResponse();

export class QUADMSkipWOOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qUADMSkipWOOperationSerialized = new QUADMSkipWOOperationSerialized();

export class QUADMSentenceNonConformancePartiallyResponse extends QCommandResponse {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
}

export const qUADMSentenceNonConformancePartiallyResponse = new QUADMSentenceNonConformancePartiallyResponse();

export class QUADMSentenceNonConformancePartially extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceStatusNId = new QStringPath(this.withPrefix("NonConformanceStatusNId"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ToBeProducedQuantity = new QNumberPath(this.withPrefix("ToBeProducedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly ReworkProcessId = new QGuidPath(this.withPrefix("ReworkProcessId"));
}

export const qUADMSentenceNonConformancePartially = new QUADMSentenceNonConformancePartially();

export class QUADMGetActiveUserListOnWorkOrderOperationResponse extends QCommandResponse {
    public readonly UserIds = new QCollectionPath(this.withPrefix("UserIds"), () => QStringCollection);
    public readonly IsUserActive = new QBooleanPath(this.withPrefix("IsUserActive"));
}

export const qUADMGetActiveUserListOnWorkOrderOperationResponse = new QUADMGetActiveUserListOnWorkOrderOperationResponse();

export class QUADMGetActiveUserListOnWorkOrderOperation extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qUADMGetActiveUserListOnWorkOrderOperation = new QUADMGetActiveUserListOnWorkOrderOperation();

export class QUADMCreateSnagAndNoteListResponse extends QCommandResponse {
}

export const qUADMCreateSnagAndNoteListResponse = new QUADMCreateSnagAndNoteListResponse();

export class QUADMCreateSnagAndNoteList extends QueryObject {
    public readonly Messages = new QCollectionPath(this.withPrefix("Messages"), () => QStringCollection);
    public readonly WorkOperationId = new QGuidPath(this.withPrefix("WorkOperationId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly IsWorkOrderLevel = new QBooleanPath(this.withPrefix("IsWorkOrderLevel"));
}

export const qUADMCreateSnagAndNoteList = new QUADMCreateSnagAndNoteList();

export class QUADMConfirmSnagAndNoteListResponse extends QCommandResponse {
}

export const qUADMConfirmSnagAndNoteListResponse = new QUADMConfirmSnagAndNoteListResponse();

export class QUADMConfirmSnagAndNoteList extends QueryObject {
    public readonly SnagAndNoteIds = new QCollectionPath(this.withPrefix("SnagAndNoteIds"), () => QGuidCollection);
}

export const qUADMConfirmSnagAndNoteList = new QUADMConfirmSnagAndNoteList();

export class QUADMUseToolResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMUseToolResponse = new QUADMUseToolResponse();

export class QUADMUseTool extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Comments = new QStringPath(this.withPrefix("Comments"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UsageDuration = new QNumberPath(this.withPrefix("UsageDuration"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
}

export const qUADMUseTool = new QUADMUseTool();

export class QUADMSaveDCDRuntimeTaskValuesResponse extends QCommandResponse {
}

export const qUADMSaveDCDRuntimeTaskValuesResponse = new QUADMSaveDCDRuntimeTaskValuesResponse();

export class QUADMSaveDCDRuntimeTaskValues extends QueryObject {
    public readonly TaskId = new QStringPath(this.withPrefix("TaskId"));
    public readonly ParametersData = new QEntityCollectionPath(this.withPrefix("ParametersData"), () => QWorkInstructionRuntimeValueParameterType);
}

export const qUADMSaveDCDRuntimeTaskValues = new QUADMSaveDCDRuntimeTaskValues();

export class QUADMCheckDCDRuntimeValuesResponse extends QCommandResponse {
    public readonly FailedTaskIds = new QCollectionPath(this.withPrefix("FailedTaskIds"), () => QStringCollection);
}

export const qUADMCheckDCDRuntimeValuesResponse = new QUADMCheckDCDRuntimeValuesResponse();

export class QUADMCheckDCDRuntimeValues extends QueryObject {
    public readonly WorkOrderOperationId = new QNumberPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QNumberPath(this.withPrefix("WorkOrderStepId"));
}

export const qUADMCheckDCDRuntimeValues = new QUADMCheckDCDRuntimeValues();

export class QUADMSetLocationHoldResponse extends QCommandResponse {
}

export const qUADMSetLocationHoldResponse = new QUADMSetLocationHoldResponse();

export class QUADMSetLocationHold extends QueryObject {
    public readonly EquipmentIdentifiers = new QStringPath(this.withPrefix("EquipmentIdentifiers"));
    public readonly HoldReasonNIdList = new QCollectionPath(this.withPrefix("HoldReasonNIdList"), () => QStringCollection);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
}

export const qUADMSetLocationHold = new QUADMSetLocationHold();

export class QUADMDisassembleMaterialItemResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qUADMDisassembleMaterialItemResponse = new QUADMDisassembleMaterialItemResponse();

export class QUADMDisassembleMaterialItem extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MaterialItemToDisassembleList = new QEntityCollectionPath(this.withPrefix("MaterialItemToDisassembleList"), () => QMaterialItemToDisassembleParameterType);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMDisassembleMaterialItem = new QUADMDisassembleMaterialItem();

export class QUADMExportGenealogyResponse extends QCommandResponse {
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
}

export const qUADMExportGenealogyResponse = new QUADMExportGenealogyResponse();

export class QUADMExportGenealogy extends QueryObject {
    public readonly ParentBatch = new QStringPath(this.withPrefix("ParentBatch"));
}

export const qUADMExportGenealogy = new QUADMExportGenealogy();

export class QUADMCreateNewMaterialDefinitionRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateNewMaterialDefinitionRevisionResponse = new QUADMCreateNewMaterialDefinitionRevisionResponse();

export class QUADMCreateNewMaterialDefinitionRevision extends QueryObject {
    public readonly OriginalId = new QGuidPath(this.withPrefix("OriginalId"));
}

export const qUADMCreateNewMaterialDefinitionRevision = new QUADMCreateNewMaterialDefinitionRevision();

export class QUADMDisAssignProducedMaterialitemsResponse extends QCommandResponse {
}

export const qUADMDisAssignProducedMaterialitemsResponse = new QUADMDisAssignProducedMaterialitemsResponse();

export class QUADMDisAssignProducedMaterialitems extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly MaterialItems = new QEntityCollectionPath(this.withPrefix("MaterialItems"), () => QMaterialItemIdentifiersParameterType);
}

export const qUADMDisAssignProducedMaterialitems = new QUADMDisAssignProducedMaterialitems();

export class QUADMImportLifecycleResponse extends QCommandResponse {
}

export const qUADMImportLifecycleResponse = new QUADMImportLifecycleResponse();

export class QUADMImportLifecycle extends QueryObject {
    public readonly LifecycleConfigurationXml = new QStringPath(this.withPrefix("LifecycleConfigurationXml"));
}

export const qUADMImportLifecycle = new QUADMImportLifecycle();

export class QUADMSaveDocumentForPreviewResponse extends QCommandResponse {
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
}

export const qUADMSaveDocumentForPreviewResponse = new QUADMSaveDocumentForPreviewResponse();

export class QUADMSaveDocumentForPreview extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qUADMSaveDocumentForPreview = new QUADMSaveDocumentForPreview();

export class QUADMAcceptChangeAddProcessOperationResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qUADMAcceptChangeAddProcessOperationResponse = new QUADMAcceptChangeAddProcessOperationResponse();

export class QUADMAcceptChangeAddProcessOperation extends QueryObject {
    public readonly ChangeProcessOperationId = new QGuidPath(this.withPrefix("ChangeProcessOperationId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly AfterSequence = new QNumberPath(this.withPrefix("AfterSequence"));
    public readonly ProcessOperationId = new QGuidPath(this.withPrefix("ProcessOperationId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderOperationSequence = new QNumberPath(this.withPrefix("WorkOrderOperationSequence"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
}

export const qUADMAcceptChangeAddProcessOperation = new QUADMAcceptChangeAddProcessOperation();

export class QUADMDeleteEquipmentResponse extends QCommandResponse {
}

export const qUADMDeleteEquipmentResponse = new QUADMDeleteEquipmentResponse();

export class QUADMDeleteEquipment extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qUADMDeleteEquipment = new QUADMDeleteEquipment();

export class QUADMRemoveWorkOrderScrapResponse extends QCommandResponse {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qUADMRemoveWorkOrderScrapResponse = new QUADMRemoveWorkOrderScrapResponse();

export class QUADMRemoveWorkOrderScrap extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMRemoveWorkOrderScrap = new QUADMRemoveWorkOrderScrap();

export class QUADMEnableLocationMachineForCompleteByDifferentUserResponse extends QCommandResponse {
}

export const qUADMEnableLocationMachineForCompleteByDifferentUserResponse = new QUADMEnableLocationMachineForCompleteByDifferentUserResponse();

export class QUADMEnableLocationMachineForCompleteByDifferentUser extends QueryObject {
    public readonly EquipmentNId = new QCollectionPath(this.withPrefix("EquipmentNId"), () => QStringCollection);
    public readonly Enabled = new QBooleanPath(this.withPrefix("Enabled"));
}

export const qUADMEnableLocationMachineForCompleteByDifferentUser = new QUADMEnableLocationMachineForCompleteByDifferentUser();

export class QUADMCreateWorkOrderOperationFromProcessOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateWorkOrderOperationFromProcessOperationResponse = new QUADMCreateWorkOrderOperationFromProcessOperationResponse();

export class QUADMCreateWorkOrderOperationFromProcessOperation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperationFromOperationParameter);
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
}

export const qUADMCreateWorkOrderOperationFromProcessOperation = new QUADMCreateWorkOrderOperationFromProcessOperation();

export class QUADMCreateNonConformanceDefectListResponse extends QCommandResponse {
}

export const qUADMCreateNonConformanceDefectListResponse = new QUADMCreateNonConformanceDefectListResponse();

export class QUADMCreateNonConformanceDefectList extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly DefectList = new QEntityCollectionPath(this.withPrefix("DefectList"), () => QDefectParameterType);
}

export const qUADMCreateNonConformanceDefectList = new QUADMCreateNonConformanceDefectList();

export class QUADMCreateDefectTypeContextualizationResponse extends QCommandResponse {
}

export const qUADMCreateDefectTypeContextualizationResponse = new QUADMCreateDefectTypeContextualizationResponse();

export class QUADMCreateDefectTypeContextualization extends QueryObject {
    public readonly DefectType = new QGuidPath(this.withPrefix("DefectType"));
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
    public readonly EquipmentConfigurationList = new QCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qUADMCreateDefectTypeContextualization = new QUADMCreateDefectTypeContextualization();

export class QUADMCreateDefectGroupContextualizationResponse extends QCommandResponse {
}

export const qUADMCreateDefectGroupContextualizationResponse = new QUADMCreateDefectGroupContextualizationResponse();

export class QUADMCreateDefectGroupContextualization extends QueryObject {
    public readonly DefectGroup = new QGuidPath(this.withPrefix("DefectGroup"));
    public readonly MaterialDefinitionList = new QCollectionPath(this.withPrefix("MaterialDefinitionList"), () => QGuidCollection);
    public readonly EquipmentList = new QCollectionPath(this.withPrefix("EquipmentList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qUADMCreateDefectGroupContextualization = new QUADMCreateDefectGroupContextualization();

export class QUADMAssignNonConformanceTransitionRoleListResponse extends QCommandResponse {
}

export const qUADMAssignNonConformanceTransitionRoleListResponse = new QUADMAssignNonConformanceTransitionRoleListResponse();

export class QUADMAssignNonConformanceTransitionRoleList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly RoleList = new QCollectionPath(this.withPrefix("RoleList"), () => QStringCollection);
    public readonly LifeCycle = new QStringPath(this.withPrefix("LifeCycle"));
}

export const qUADMAssignNonConformanceTransitionRoleList = new QUADMAssignNonConformanceTransitionRoleList();

export class QUADMRemoveNonConformanceTransitionRoleListResponse extends QCommandResponse {
}

export const qUADMRemoveNonConformanceTransitionRoleListResponse = new QUADMRemoveNonConformanceTransitionRoleListResponse();

export class QUADMRemoveNonConformanceTransitionRoleList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly RoleList = new QCollectionPath(this.withPrefix("RoleList"), () => QStringCollection);
    public readonly LifeCycle = new QStringPath(this.withPrefix("LifeCycle"));
}

export const qUADMRemoveNonConformanceTransitionRoleList = new QUADMRemoveNonConformanceTransitionRoleList();

export class QUADMRemoveDefectGroupContextualizationResponse extends QCommandResponse {
}

export const qUADMRemoveDefectGroupContextualizationResponse = new QUADMRemoveDefectGroupContextualizationResponse();

export class QUADMRemoveDefectGroupContextualization extends QueryObject {
    public readonly DefectGroupId = new QGuidPath(this.withPrefix("DefectGroupId"));
    public readonly MaterialDefinitionList = new QCollectionPath(this.withPrefix("MaterialDefinitionList"), () => QGuidCollection);
    public readonly EquipmentList = new QCollectionPath(this.withPrefix("EquipmentList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qUADMRemoveDefectGroupContextualization = new QUADMRemoveDefectGroupContextualization();

export class QUADMRemoveDefectTypeContextualizationResponse extends QCommandResponse {
}

export const qUADMRemoveDefectTypeContextualizationResponse = new QUADMRemoveDefectTypeContextualizationResponse();

export class QUADMRemoveDefectTypeContextualization extends QueryObject {
    public readonly DefectTypeId = new QGuidPath(this.withPrefix("DefectTypeId"));
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
    public readonly EquipmentConfigurationList = new QCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qUADMRemoveDefectTypeContextualization = new QUADMRemoveDefectTypeContextualization();

export class QUADMAssignNonConformanceTransitionMailAddressListResponse extends QCommandResponse {
}

export const qUADMAssignNonConformanceTransitionMailAddressListResponse = new QUADMAssignNonConformanceTransitionMailAddressListResponse();

export class QUADMAssignNonConformanceTransitionMailAddressList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly MailAddressList = new QCollectionPath(this.withPrefix("MailAddressList"), () => QStringCollection);
}

export const qUADMAssignNonConformanceTransitionMailAddressList = new QUADMAssignNonConformanceTransitionMailAddressList();

export class QUADMRemoveNonConformanceTransitionMailAddressListResponse extends QCommandResponse {
}

export const qUADMRemoveNonConformanceTransitionMailAddressListResponse = new QUADMRemoveNonConformanceTransitionMailAddressListResponse();

export class QUADMRemoveNonConformanceTransitionMailAddressList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly MailAddressList = new QCollectionPath(this.withPrefix("MailAddressList"), () => QStringCollection);
}

export const qUADMRemoveNonConformanceTransitionMailAddressList = new QUADMRemoveNonConformanceTransitionMailAddressList();

export class QUADMCreatePrintJobFileResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreatePrintJobFileResponse = new QUADMCreatePrintJobFileResponse();

export class QUADMCreatePrintJobFile extends QueryObject {
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPJFParameterType);
}

export const qUADMCreatePrintJobFile = new QUADMCreatePrintJobFile();

export class QUADMImportAMPrintJobFileResponse extends QCommandResponse {
}

export const qUADMImportAMPrintJobFileResponse = new QUADMImportAMPrintJobFileResponse();

export class QUADMImportAMPrintJobFile extends QueryObject {
    public readonly IsDeltaImport = new QBooleanPath(this.withPrefix("IsDeltaImport"));
    public readonly PlugInNameList = new QCollectionPath(this.withPrefix("PlugInNameList"), () => QStringCollection);
}

export const qUADMImportAMPrintJobFile = new QUADMImportAMPrintJobFile();

export class QUADMCreateEquipmentSpecificationWithPrintJobFileResponse extends QCommandResponse {
    public readonly EquipmentSpecificationId = new QGuidPath(this.withPrefix("EquipmentSpecificationId"));
}

export const qUADMCreateEquipmentSpecificationWithPrintJobFileResponse = new QUADMCreateEquipmentSpecificationWithPrintJobFileResponse();

export class QUADMCreateEquipmentSpecificationWithPrintJobFile extends QueryObject {
    public readonly EquipmentSpecification = new QEntityPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecificationParameterType);
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly Process = new QGuidPath(this.withPrefix("Process"));
}

export const qUADMCreateEquipmentSpecificationWithPrintJobFile = new QUADMCreateEquipmentSpecificationWithPrintJobFile();

export class QUADMEditPrintJobFileResponse extends QCommandResponse {
}

export const qUADMEditPrintJobFileResponse = new QUADMEditPrintJobFileResponse();

export class QUADMEditPrintJobFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PrintJobFileDetails = new QEntityPath(this.withPrefix("PrintJobFileDetails"), () => QPJFParameterType);
    public readonly IsImport = new QBooleanPath(this.withPrefix("IsImport"));
}

export const qUADMEditPrintJobFile = new QUADMEditPrintJobFile();

export class QUADMTransferAMDataResponse extends QCommandResponse {
}

export const qUADMTransferAMDataResponse = new QUADMTransferAMDataResponse();

export class QUADMTransferAMData extends QueryObject {
    public readonly PrintJobFileId = new QGuidPath(this.withPrefix("PrintJobFileId"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly MachineExternalId = new QStringPath(this.withPrefix("MachineExternalId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly MTUIdList = new QCollectionPath(this.withPrefix("MTUIdList"), () => QGuidCollection);
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
}

export const qUADMTransferAMData = new QUADMTransferAMData();

export class QUADMAutoTransferAMDataResponse extends QCommandResponse {
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
}

export const qUADMAutoTransferAMDataResponse = new QUADMAutoTransferAMDataResponse();

export class QUADMAutoTransferAMData extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProductId = new QGuidPath(this.withPrefix("ProductId"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly MTUIdList = new QCollectionPath(this.withPrefix("MTUIdList"), () => QGuidCollection);
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
}

export const qUADMAutoTransferAMData = new QUADMAutoTransferAMData();

export class QUADMCompleteWOOperationTransferBatchMultiMachineListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMCompleteWOOperationTransferBatchMultiMachineListResponse = new QUADMCompleteWOOperationTransferBatchMultiMachineListResponse();

export class QUADMCompleteWOOperationTransferBatchMultiMachineList extends QueryObject {
    public readonly CompleteTransferBatchParameterTypeList = new QEntityCollectionPath(this.withPrefix("CompleteTransferBatchParameterTypeList"), () => QCompleteWOOperationTransferBatchParameterType);
}

export const qUADMCompleteWOOperationTransferBatchMultiMachineList = new QUADMCompleteWOOperationTransferBatchMultiMachineList();

export class QUADMDeletePrintJobFileListResponse extends QCommandResponse {
}

export const qUADMDeletePrintJobFileListResponse = new QUADMDeletePrintJobFileListResponse();

export class QUADMDeletePrintJobFileList extends QueryObject {
    public readonly PrintJobFileList = new QCollectionPath(this.withPrefix("PrintJobFileList"), () => QGuidCollection);
}

export const qUADMDeletePrintJobFileList = new QUADMDeletePrintJobFileList();

export class QUADMCreatePrintJobFileListResponse extends QCommandResponse {
}

export const qUADMCreatePrintJobFileListResponse = new QUADMCreatePrintJobFileListResponse();

export class QUADMCreatePrintJobFileList extends QueryObject {
    public readonly quantity = new QNumberPath(this.withPrefix("quantity"));
}

export const qUADMCreatePrintJobFileList = new QUADMCreatePrintJobFileList();

export class QImportAMPrintJobFileResponse extends QCommandResponse {
}

export const qImportAMPrintJobFileResponse = new QImportAMPrintJobFileResponse();

export class QImportAMPrintJobFile extends QueryObject {
    public readonly IsDeltaImport = new QBooleanPath(this.withPrefix("IsDeltaImport"));
    public readonly PlugInName = new QStringPath(this.withPrefix("PlugInName"));
}

export const qImportAMPrintJobFile = new QImportAMPrintJobFile();

export class QUADMPauseWorkOrderOperationMultiMachineListResponse extends QCommandResponse {
}

export const qUADMPauseWorkOrderOperationMultiMachineListResponse = new QUADMPauseWorkOrderOperationMultiMachineListResponse();

export class QUADMPauseWorkOrderOperationMultiMachineList extends QueryObject {
    public readonly PauseMultiMachineParameterTypeList = new QEntityCollectionPath(this.withPrefix("PauseMultiMachineParameterTypeList"), () => QPauseWOOperationParameterType);
}

export const qUADMPauseWorkOrderOperationMultiMachineList = new QUADMPauseWorkOrderOperationMultiMachineList();

export class QUADMCompleteWOOperationFullQtyMultiMachineListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMCompleteWOOperationFullQtyMultiMachineListResponse = new QUADMCompleteWOOperationFullQtyMultiMachineListResponse();

export class QUADMCompleteWOOperationFullQtyMultiMachineList extends QueryObject {
    public readonly UADMCompleteOperationParameters = new QEntityCollectionPath(this.withPrefix("UADMCompleteOperationParameters"), () => QCompleteWOOperationFullQtyParameterType);
}

export const qUADMCompleteWOOperationFullQtyMultiMachineList = new QUADMCompleteWOOperationFullQtyMultiMachineList();

export class QUADMDeleteToolDefinitionListResponse extends QCommandResponse {
}

export const qUADMDeleteToolDefinitionListResponse = new QUADMDeleteToolDefinitionListResponse();

export class QUADMDeleteToolDefinitionList extends QueryObject {
    public readonly ToolDefinitionList = new QCollectionPath(this.withPrefix("ToolDefinitionList"), () => QGuidCollection);
    public readonly IgnoreToolDefinitionAssociation = new QBooleanPath(this.withPrefix("IgnoreToolDefinitionAssociation"));
}

export const qUADMDeleteToolDefinitionList = new QUADMDeleteToolDefinitionList();

export class QUADMCreateFormResponse extends QCommandResponse {
    public readonly FormName = new QStringPath(this.withPrefix("FormName"));
}

export const qUADMCreateFormResponse = new QUADMCreateFormResponse();

export class QUADMCreateForm extends QueryObject {
    public readonly PMIXml = new QStringPath(this.withPrefix("PMIXml"));
    public readonly ItamName = new QStringPath(this.withPrefix("ItamName"));
    public readonly ItemRevision = new QStringPath(this.withPrefix("ItemRevision"));
}

export const qUADMCreateForm = new QUADMCreateForm();

export class QUADMGetPMIResponse extends QCommandResponse {
    public readonly ItemRevision = new QStringPath(this.withPrefix("ItemRevision"));
    public readonly ItemName = new QStringPath(this.withPrefix("ItemName"));
    public readonly PMIXml = new QStringPath(this.withPrefix("PMIXml"));
}

export const qUADMGetPMIResponse = new QUADMGetPMIResponse();

export class QUADMGetPMI extends QueryObject {
    public readonly TCItemID = new QStringPath(this.withPrefix("TCItemID"));
    public readonly Context_id = new QStringPath(this.withPrefix("Context_id"));
}

export const qUADMGetPMI = new QUADMGetPMI();

export class QUADMSaveAsWorkInstructionResponse extends QCommandResponse {
    public readonly NewWorkInstructionId = new QStringPath(this.withPrefix("NewWorkInstructionId"));
}

export const qUADMSaveAsWorkInstructionResponse = new QUADMSaveAsWorkInstructionResponse();

export class QUADMSaveAsWorkInstruction extends QueryObject {
    public readonly WorkInstructionId = new QStringPath(this.withPrefix("WorkInstructionId"));
    public readonly NewWorkInstructionName = new QStringPath(this.withPrefix("NewWorkInstructionName"));
}

export const qUADMSaveAsWorkInstruction = new QUADMSaveAsWorkInstruction();

export class QUADMAssociateFormsToTcMResponse extends QCommandResponse {
}

export const qUADMAssociateFormsToTcMResponse = new QUADMAssociateFormsToTcMResponse();

export class QUADMAssociateFormsToTcM extends QueryObject {
    public readonly TCItemID = new QStringPath(this.withPrefix("TCItemID"));
    public readonly FormIdList = new QCollectionPath(this.withPrefix("FormIdList"), () => QStringCollection);
}

export const qUADMAssociateFormsToTcM = new QUADMAssociateFormsToTcM();

export class QUADMChangeWorkInstructionStatusResponse extends QCommandResponse {
}

export const qUADMChangeWorkInstructionStatusResponse = new QUADMChangeWorkInstructionStatusResponse();

export class QUADMChangeWorkInstructionStatus extends QueryObject {
    public readonly WorkInstructionIdList = new QCollectionPath(this.withPrefix("WorkInstructionIdList"), () => QStringCollection);
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qUADMChangeWorkInstructionStatus = new QUADMChangeWorkInstructionStatus();

export class QUADMCreateNewProcessRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateNewProcessRevisionResponse = new QUADMCreateNewProcessRevisionResponse();

export class QUADMCreateNewProcessRevision extends QueryObject {
    public readonly ParentProcessId = new QGuidPath(this.withPrefix("ParentProcessId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUADMCreateNewProcessRevision = new QUADMCreateNewProcessRevision();

export class QUADMUpdateNonConformanceResponse extends QCommandResponse {
}

export const qUADMUpdateNonConformanceResponse = new QUADMUpdateNonConformanceResponse();

export class QUADMUpdateNonConformance extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMUpdateNonConformance = new QUADMUpdateNonConformance();

export class QUADMSetWorkOrderForSchedulingResponse extends QCommandResponse {
}

export const qUADMSetWorkOrderForSchedulingResponse = new QUADMSetWorkOrderForSchedulingResponse();

export class QUADMSetWorkOrderForScheduling extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
}

export const qUADMSetWorkOrderForScheduling = new QUADMSetWorkOrderForScheduling();

export class QUADMReleaseWorkOrderResponse extends QCommandResponse {
    public readonly Id = new QCollectionPath(this.withPrefix("Id"), () => QGuidCollection);
}

export const qUADMReleaseWorkOrderResponse = new QUADMReleaseWorkOrderResponse();

export class QUADMReleaseWorkOrder extends QueryObject {
    public readonly ReleaseWorkOrderDetails = new QEntityCollectionPath(this.withPrefix("ReleaseWorkOrderDetails"), () => QReleaseWorkOrderParameterType);
}

export const qUADMReleaseWorkOrder = new QUADMReleaseWorkOrder();

export class QUADMAcceptChangeAddToBeUsedToolResponse extends QCommandResponse {
}

export const qUADMAcceptChangeAddToBeUsedToolResponse = new QUADMAcceptChangeAddToBeUsedToolResponse();

export class QUADMAcceptChangeAddToBeUsedTool extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly ToolDefinitionNId = new QStringPath(this.withPrefix("ToolDefinitionNId"));
    public readonly ToolUsage = new QNumberPath(this.withPrefix("ToolUsage"));
    public readonly ChangeToolId = new QGuidPath(this.withPrefix("ChangeToolId"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
}

export const qUADMAcceptChangeAddToBeUsedTool = new QUADMAcceptChangeAddToBeUsedTool();

export class QPLMCreateIssueReportResponse extends QCommandResponse {
}

export const qPLMCreateIssueReportResponse = new QPLMCreateIssueReportResponse();

export class QPLMCreateIssueReport extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly DocumentIdList = new QCollectionPath(this.withPrefix("DocumentIdList"), () => QGuidCollection);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qPLMCreateIssueReport = new QPLMCreateIssueReport();

export class QPLMCreateMasterPlanResponse extends QCommandResponse {
}

export const qPLMCreateMasterPlanResponse = new QPLMCreateMasterPlanResponse();

export class QPLMCreateMasterPlan extends QueryObject {
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QPLMMasterPlanParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateMasterPlan = new QPLMCreateMasterPlan();

export class QPLMCreateOperationListResponse extends QCommandResponse {
}

export const qPLMCreateOperationListResponse = new QPLMCreateOperationListResponse();

export class QPLMCreateOperationList extends QueryObject {
    public readonly OperationList = new QEntityCollectionPath(this.withPrefix("OperationList"), () => QPLMOperationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOperationList = new QPLMCreateOperationList();

export class QPLMCreateProcessListResponse extends QCommandResponse {
}

export const qPLMCreateProcessListResponse = new QPLMCreateProcessListResponse();

export class QPLMCreateProcessList extends QueryObject {
    public readonly ProcessList = new QEntityCollectionPath(this.withPrefix("ProcessList"), () => QPLMProcessParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateProcessList = new QPLMCreateProcessList();

export class QPLMCreateDocumentListResponse extends QCommandResponse {
}

export const qPLMCreateDocumentListResponse = new QPLMCreateDocumentListResponse();

export class QPLMCreateDocumentList extends QueryObject {
    public readonly DocumentList = new QEntityCollectionPath(this.withPrefix("DocumentList"), () => QPLMDocumentParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateDocumentList = new QPLMCreateDocumentList();

export class QPLMCreateMaterialDefinitionListResponse extends QCommandResponse {
}

export const qPLMCreateMaterialDefinitionListResponse = new QPLMCreateMaterialDefinitionListResponse();

export class QPLMCreateMaterialDefinitionList extends QueryObject {
    public readonly MaterialList = new QEntityCollectionPath(this.withPrefix("MaterialList"), () => QPLMMaterialDefinitionParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateMaterialDefinitionList = new QPLMCreateMaterialDefinitionList();

export class QPLMCreateToolDefinitionListResponse extends QCommandResponse {
}

export const qPLMCreateToolDefinitionListResponse = new QPLMCreateToolDefinitionListResponse();

export class QPLMCreateToolDefinitionList extends QueryObject {
    public readonly ToolList = new QEntityCollectionPath(this.withPrefix("ToolList"), () => QPLMToolDefinitionParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateToolDefinitionList = new QPLMCreateToolDefinitionList();

export class QPLMCreateStepListResponse extends QCommandResponse {
}

export const qPLMCreateStepListResponse = new QPLMCreateStepListResponse();

export class QPLMCreateStepList extends QueryObject {
    public readonly StepList = new QEntityCollectionPath(this.withPrefix("StepList"), () => QPLMStepParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateStepList = new QPLMCreateStepList();

export class QPLMAssociateDocumentToMaterialDefinitionListResponse extends QCommandResponse {
}

export const qPLMAssociateDocumentToMaterialDefinitionListResponse = new QPLMAssociateDocumentToMaterialDefinitionListResponse();

export class QPLMAssociateDocumentToMaterialDefinitionList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QPLMDocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMAssociateDocumentToMaterialDefinitionList = new QPLMAssociateDocumentToMaterialDefinitionList();

export class QPLMAssociateDocumentToToolDefinitionListResponse extends QCommandResponse {
}

export const qPLMAssociateDocumentToToolDefinitionListResponse = new QPLMAssociateDocumentToToolDefinitionListResponse();

export class QPLMAssociateDocumentToToolDefinitionList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QPLMDocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMAssociateDocumentToToolDefinitionList = new QPLMAssociateDocumentToToolDefinitionList();

export class QPLMAssociateDocumentToOperationListResponse extends QCommandResponse {
}

export const qPLMAssociateDocumentToOperationListResponse = new QPLMAssociateDocumentToOperationListResponse();

export class QPLMAssociateDocumentToOperationList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QPLMDocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMAssociateDocumentToOperationList = new QPLMAssociateDocumentToOperationList();

export class QPLMAssociateDocumentToStepListResponse extends QCommandResponse {
}

export const qPLMAssociateDocumentToStepListResponse = new QPLMAssociateDocumentToStepListResponse();

export class QPLMAssociateDocumentToStepList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QPLMDocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMAssociateDocumentToStepList = new QPLMAssociateDocumentToStepList();

export class QPLMCreateAsPlannedBoPResponse extends QCommandResponse {
}

export const qPLMCreateAsPlannedBoPResponse = new QPLMCreateAsPlannedBoPResponse();

export class QPLMCreateAsPlannedBoP extends QueryObject {
    public readonly AsPlannedBoP = new QEntityPath(this.withPrefix("AsPlannedBoP"), () => QPLMAsPlannedBoPParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateAsPlannedBoP = new QPLMCreateAsPlannedBoP();

export class QPLMLinkProcessToProcessFullListResponse extends QCommandResponse {
}

export const qPLMLinkProcessToProcessFullListResponse = new QPLMLinkProcessToProcessFullListResponse();

export class QPLMLinkProcessToProcessFullList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QPLMLinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMLinkProcessToProcessFullList = new QPLMLinkProcessToProcessFullList();

export class QPLMLinkProcessToOperationFullListResponse extends QCommandResponse {
}

export const qPLMLinkProcessToOperationFullListResponse = new QPLMLinkProcessToOperationFullListResponse();

export class QPLMLinkProcessToOperationFullList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QPLMLinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMLinkProcessToOperationFullList = new QPLMLinkProcessToOperationFullList();

export class QPLMLinkOperationToStepFullListResponse extends QCommandResponse {
}

export const qPLMLinkOperationToStepFullListResponse = new QPLMLinkOperationToStepFullListResponse();

export class QPLMLinkOperationToStepFullList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QPLMLinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMLinkOperationToStepFullList = new QPLMLinkOperationToStepFullList();

export class QPLMCreateStepMaterialSpecificationFullListResponse extends QCommandResponse {
}

export const qPLMCreateStepMaterialSpecificationFullListResponse = new QPLMCreateStepMaterialSpecificationFullListResponse();

export class QPLMCreateStepMaterialSpecificationFullList extends QueryObject {
    public readonly MaterialSpecificationList = new QEntityCollectionPath(this.withPrefix("MaterialSpecificationList"), () => QPLMMaterialSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateStepMaterialSpecificationFullList = new QPLMCreateStepMaterialSpecificationFullList();

export class QPLMCreateStepToolSpecificationFullListResponse extends QCommandResponse {
}

export const qPLMCreateStepToolSpecificationFullListResponse = new QPLMCreateStepToolSpecificationFullListResponse();

export class QPLMCreateStepToolSpecificationFullList extends QueryObject {
    public readonly ToolSpecificationList = new QEntityCollectionPath(this.withPrefix("ToolSpecificationList"), () => QPLMToolSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateStepToolSpecificationFullList = new QPLMCreateStepToolSpecificationFullList();

export class QPLMCreateStepDependencyListResponse extends QCommandResponse {
}

export const qPLMCreateStepDependencyListResponse = new QPLMCreateStepDependencyListResponse();

export class QPLMCreateStepDependencyList extends QueryObject {
    public readonly StepDependencyList = new QEntityCollectionPath(this.withPrefix("StepDependencyList"), () => QPLMStepDependencyParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateStepDependencyList = new QPLMCreateStepDependencyList();

export class QPLMCreateOperationEquipmentSpecLocationFullListResponse extends QCommandResponse {
}

export const qPLMCreateOperationEquipmentSpecLocationFullListResponse = new QPLMCreateOperationEquipmentSpecLocationFullListResponse();

export class QPLMCreateOperationEquipmentSpecLocationFullList extends QueryObject {
    public readonly EquipmentSpecificationList = new QEntityCollectionPath(this.withPrefix("EquipmentSpecificationList"), () => QPLMEquipmentSpecLocationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOperationEquipmentSpecLocationFullList = new QPLMCreateOperationEquipmentSpecLocationFullList();

export class QPLMCreateOperationMaterialSpecificationFullListResponse extends QCommandResponse {
}

export const qPLMCreateOperationMaterialSpecificationFullListResponse = new QPLMCreateOperationMaterialSpecificationFullListResponse();

export class QPLMCreateOperationMaterialSpecificationFullList extends QueryObject {
    public readonly MaterialSpecificationList = new QEntityCollectionPath(this.withPrefix("MaterialSpecificationList"), () => QPLMMaterialSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOperationMaterialSpecificationFullList = new QPLMCreateOperationMaterialSpecificationFullList();

export class QPLMCreateOperationToolSpecificationFullListResponse extends QCommandResponse {
}

export const qPLMCreateOperationToolSpecificationFullListResponse = new QPLMCreateOperationToolSpecificationFullListResponse();

export class QPLMCreateOperationToolSpecificationFullList extends QueryObject {
    public readonly ToolSpecificationList = new QEntityCollectionPath(this.withPrefix("ToolSpecificationList"), () => QPLMToolSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOperationToolSpecificationFullList = new QPLMCreateOperationToolSpecificationFullList();

export class QPLMCreateOpDependencyListResponse extends QCommandResponse {
}

export const qPLMCreateOpDependencyListResponse = new QPLMCreateOpDependencyListResponse();

export class QPLMCreateOpDependencyList extends QueryObject {
    public readonly OperationDependencyList = new QEntityCollectionPath(this.withPrefix("OperationDependencyList"), () => QPLMOpDependencyParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOpDependencyList = new QPLMCreateOpDependencyList();

export class QPLMSubmitResponse extends QCommandResponse {
}

export const qPLMSubmitResponse = new QPLMSubmitResponse();

export class QPLMSubmit extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMSubmit = new QPLMSubmit();

export class QPLMSubmitMasterPlanResponse extends QCommandResponse {
}

export const qPLMSubmitMasterPlanResponse = new QPLMSubmitMasterPlanResponse();

export class QPLMSubmitMasterPlan extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMSubmitMasterPlan = new QPLMSubmitMasterPlan();

export class QPLMRollbackResponse extends QCommandResponse {
}

export const qPLMRollbackResponse = new QPLMRollbackResponse();

export class QPLMRollback extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMRollback = new QPLMRollback();

export class QPLMRollbackMasterPlanResponse extends QCommandResponse {
}

export const qPLMRollbackMasterPlanResponse = new QPLMRollbackMasterPlanResponse();

export class QPLMRollbackMasterPlan extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMRollbackMasterPlan = new QPLMRollbackMasterPlan();

export class QPLMCreateIssueReportResultResponse extends QCommandResponse {
}

export const qPLMCreateIssueReportResultResponse = new QPLMCreateIssueReportResultResponse();

export class QPLMCreateIssueReportResult extends QueryObject {
    public readonly JobID = new QStringPath(this.withPrefix("JobID"));
    public readonly NonConformanceID = new QStringPath(this.withPrefix("NonConformanceID"));
    public readonly ProblemReportUID = new QStringPath(this.withPrefix("ProblemReportUID"));
    public readonly completed = new QBooleanPath(this.withPrefix("completed"));
    public readonly status = new QStringPath(this.withPrefix("status"));
    public readonly message = new QStringPath(this.withPrefix("message"));
}

export const qPLMCreateIssueReportResult = new QPLMCreateIssueReportResult();

export class QPLMCreateWorkOrderHeaderResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qPLMCreateWorkOrderHeaderResponse = new QPLMCreateWorkOrderHeaderResponse();

export class QPLMCreateWorkOrderHeader extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly ConfigurationParameter = new QStringPath(this.withPrefix("ConfigurationParameter"));
    public readonly RoutingID = new QStringPath(this.withPrefix("RoutingID"));
    public readonly TargetProductID = new QStringPath(this.withPrefix("TargetProductID"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly ConfirmationType = new QStringPath(this.withPrefix("ConfirmationType"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
}

export const qPLMCreateWorkOrderHeader = new QPLMCreateWorkOrderHeader();

export class QPLMCreateWorkOrderFromMasterPlanBOMResolutionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qPLMCreateWorkOrderFromMasterPlanBOMResolutionResponse = new QPLMCreateWorkOrderFromMasterPlanBOMResolutionResponse();

export class QPLMCreateWorkOrderFromMasterPlanBOMResolution extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly ConfirmationType = new QStringPath(this.withPrefix("ConfirmationType"));
    public readonly MasterPlanId = new QStringPath(this.withPrefix("MasterPlanId"));
    public readonly BOMMaterialList = new QCollectionPath(this.withPrefix("BOMMaterialList"), () => QStringCollection);
    public readonly TargetProductID = new QStringPath(this.withPrefix("TargetProductID"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly BomToBeUsed = new QEntityPath(this.withPrefix("BomToBeUsed"), () => QBoMParameterType);
}

export const qPLMCreateWorkOrderFromMasterPlanBOMResolution = new QPLMCreateWorkOrderFromMasterPlanBOMResolution();

export class QUADMCompleteAsPlannedBOPResponse extends QCommandResponse {
}

export const qUADMCompleteAsPlannedBOPResponse = new QUADMCompleteAsPlannedBOPResponse();

export class QUADMCompleteAsPlannedBOP extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCompleteAsPlannedBOP = new QUADMCompleteAsPlannedBOP();

export class QUpdateMaterialDefinitionResponse extends QCommandResponse {
}

export const qUpdateMaterialDefinitionResponse = new QUpdateMaterialDefinitionResponse();

export class QUpdateMaterialDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly LogisticParameterType = new QEntityPath(this.withPrefix("LogisticParameterType"), () => QLogisticParameterType);
}

export const qUpdateMaterialDefinition = new QUpdateMaterialDefinition();

export class QUADMDeleteBufferDefinitionListResponse extends QCommandResponse {
}

export const qUADMDeleteBufferDefinitionListResponse = new QUADMDeleteBufferDefinitionListResponse();

export class QUADMDeleteBufferDefinitionList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMDeleteBufferDefinitionList = new QUADMDeleteBufferDefinitionList();

export class QCopyToolDefinitionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCopyToolDefinitionResponse = new QCopyToolDefinitionResponse();

export class QCopyToolDefinition extends QueryObject {
    public readonly NID = new QStringPath(this.withPrefix("NID"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SubstrateDefinitionProperties = new QEntityPath(this.withPrefix("SubstrateDefinitionProperties"), () => QSubstrateDefinitionPropertiesParameterType);
    public readonly ToolClassNId = new QStringPath(this.withPrefix("ToolClassNId"));
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly RevisionExpression = new QStringPath(this.withPrefix("RevisionExpression"));
    public readonly LogisticParameter = new QEntityPath(this.withPrefix("LogisticParameter"), () => QLogisticParameterType);
    public readonly OriginalToolDefinitionID = new QGuidPath(this.withPrefix("OriginalToolDefinitionID"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
}

export const qCopyToolDefinition = new QCopyToolDefinition();

export class QUADMUpdateToolDefinitionResponse extends QCommandResponse {
}

export const qUADMUpdateToolDefinitionResponse = new QUADMUpdateToolDefinitionResponse();

export class QUADMUpdateToolDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SubstrateDefinitionProperties = new QEntityPath(this.withPrefix("SubstrateDefinitionProperties"), () => QSubstrateDefinitionPropertiesParameterType);
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly LogisticParameter = new QEntityPath(this.withPrefix("LogisticParameter"), () => QLogisticParameterType);
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
}

export const qUADMUpdateToolDefinition = new QUADMUpdateToolDefinition();

export class QUADMDeleteMaterialDefinitionsResponse extends QCommandResponse {
}

export const qUADMDeleteMaterialDefinitionsResponse = new QUADMDeleteMaterialDefinitionsResponse();

export class QUADMDeleteMaterialDefinitions extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMDeleteMaterialDefinitions = new QUADMDeleteMaterialDefinitions();

export class QUADMDeleteAsPlannedBOPListResponse extends QCommandResponse {
}

export const qUADMDeleteAsPlannedBOPListResponse = new QUADMDeleteAsPlannedBOPListResponse();

export class QUADMDeleteAsPlannedBOPList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMDeleteAsPlannedBOPList = new QUADMDeleteAsPlannedBOPList();

export class QUADMLinkMaterialItemsToHandlingUnitResponse extends QCommandResponse {
}

export const qUADMLinkMaterialItemsToHandlingUnitResponse = new QUADMLinkMaterialItemsToHandlingUnitResponse();

export class QUADMLinkMaterialItemsToHandlingUnit extends QueryObject {
    public readonly MaterialItems = new QCollectionPath(this.withPrefix("MaterialItems"), () => QGuidCollection);
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qUADMLinkMaterialItemsToHandlingUnit = new QUADMLinkMaterialItemsToHandlingUnit();

export class QUADMLinkGenericItemsToNonConformanceResponse extends QCommandResponse {
}

export const qUADMLinkGenericItemsToNonConformanceResponse = new QUADMLinkGenericItemsToNonConformanceResponse();

export class QUADMLinkGenericItemsToNonConformance extends QueryObject {
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly GenericItems = new QCollectionPath(this.withPrefix("GenericItems"), () => QGuidCollection);
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
}

export const qUADMLinkGenericItemsToNonConformance = new QUADMLinkGenericItemsToNonConformance();

export class QUADMUnLinkGenericItemsFromNonConformanceResponse extends QCommandResponse {
}

export const qUADMUnLinkGenericItemsFromNonConformanceResponse = new QUADMUnLinkGenericItemsFromNonConformanceResponse();

export class QUADMUnLinkGenericItemsFromNonConformance extends QueryObject {
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly GenericItems = new QCollectionPath(this.withPrefix("GenericItems"), () => QGuidCollection);
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
}

export const qUADMUnLinkGenericItemsFromNonConformance = new QUADMUnLinkGenericItemsFromNonConformance();

export class QUADMCreateExecutionGroupResponse extends QCommandResponse {
}

export const qUADMCreateExecutionGroupResponse = new QUADMCreateExecutionGroupResponse();

export class QUADMCreateExecutionGroup extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
}

export const qUADMCreateExecutionGroup = new QUADMCreateExecutionGroup();

export class QUADMCreateWorkOrderFromProcessResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateWorkOrderFromProcessResponse = new QUADMCreateWorkOrderFromProcessResponse();

export class QUADMCreateWorkOrderFromProcess extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly AsPlannedId = new QGuidPath(this.withPrefix("AsPlannedId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly BomToBeUsed = new QEntityPath(this.withPrefix("BomToBeUsed"), () => QBoMParameterType);
}

export const qUADMCreateWorkOrderFromProcess = new QUADMCreateWorkOrderFromProcess();

export class QUADMLinkMaterialItemsToBufferResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMLinkMaterialItemsToBufferResponse = new QUADMLinkMaterialItemsToBufferResponse();

export class QUADMLinkMaterialItemsToBuffer extends QueryObject {
    public readonly BufferId = new QGuidPath(this.withPrefix("BufferId"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
}

export const qUADMLinkMaterialItemsToBuffer = new QUADMLinkMaterialItemsToBuffer();

export class QUADMAcceptChangeAddWorkInstructionResponse extends QCommandResponse {
}

export const qUADMAcceptChangeAddWorkInstructionResponse = new QUADMAcceptChangeAddWorkInstructionResponse();

export class QUADMAcceptChangeAddWorkInstruction extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WIDefinitionId = new QGuidPath(this.withPrefix("WIDefinitionId"));
    public readonly SerialNumberCodes = new QCollectionPath(this.withPrefix("SerialNumberCodes"), () => QStringCollection);
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ChangeDataCollectionId = new QGuidPath(this.withPrefix("ChangeDataCollectionId"));
}

export const qUADMAcceptChangeAddWorkInstruction = new QUADMAcceptChangeAddWorkInstruction();

export class QUADMDeleteSkillListResponse extends QCommandResponse {
}

export const qUADMDeleteSkillListResponse = new QUADMDeleteSkillListResponse();

export class QUADMDeleteSkillList extends QueryObject {
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
}

export const qUADMDeleteSkillList = new QUADMDeleteSkillList();

export class QUADMStartNonProductiveActivityListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMStartNonProductiveActivityListResponse = new QUADMStartNonProductiveActivityListResponse();

export class QUADMStartNonProductiveActivityList extends QueryObject {
    public readonly NPAIds = new QCollectionPath(this.withPrefix("NPAIds"), () => QGuidCollection);
    public readonly NPAContextId = new QGuidPath(this.withPrefix("NPAContextId"));
    public readonly NPAContextValue = new QGuidPath(this.withPrefix("NPAContextValue"));
    public readonly NPAEquipmentNIdValue = new QStringPath(this.withPrefix("NPAEquipmentNIdValue"));
}

export const qUADMStartNonProductiveActivityList = new QUADMStartNonProductiveActivityList();

export class QUADMCompleteNonProductiveActivityListResponse extends QCommandResponse {
}

export const qUADMCompleteNonProductiveActivityListResponse = new QUADMCompleteNonProductiveActivityListResponse();

export class QUADMCompleteNonProductiveActivityList extends QueryObject {
    public readonly UserNPAIds = new QCollectionPath(this.withPrefix("UserNPAIds"), () => QGuidCollection);
}

export const qUADMCompleteNonProductiveActivityList = new QUADMCompleteNonProductiveActivityList();

export class QUADMDeleteNonProductiveActivityListResponse extends QCommandResponse {
}

export const qUADMDeleteNonProductiveActivityListResponse = new QUADMDeleteNonProductiveActivityListResponse();

export class QUADMDeleteNonProductiveActivityList extends QueryObject {
    public readonly NonProductiveActivityList = new QCollectionPath(this.withPrefix("NonProductiveActivityList"), () => QGuidCollection);
}

export const qUADMDeleteNonProductiveActivityList = new QUADMDeleteNonProductiveActivityList();

export class QUADMDeleteOperationStepCategoryListResponse extends QCommandResponse {
}

export const qUADMDeleteOperationStepCategoryListResponse = new QUADMDeleteOperationStepCategoryListResponse();

export class QUADMDeleteOperationStepCategoryList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMDeleteOperationStepCategoryList = new QUADMDeleteOperationStepCategoryList();

export class QUADMLinkSkillsToTeamResponse extends QCommandResponse {
}

export const qUADMLinkSkillsToTeamResponse = new QUADMLinkSkillsToTeamResponse();

export class QUADMLinkSkillsToTeam extends QueryObject {
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly TeamId = new QGuidPath(this.withPrefix("TeamId"));
}

export const qUADMLinkSkillsToTeam = new QUADMLinkSkillsToTeam();

export class QUADMCopyDM_MaterialResponse extends QCommandResponse {
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qUADMCopyDM_MaterialResponse = new QUADMCopyDM_MaterialResponse();

export class QUADMCopyDM_Material extends QueryObject {
    public readonly OriginalDM_MaterialId = new QGuidPath(this.withPrefix("OriginalDM_MaterialId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
}

export const qUADMCopyDM_Material = new QUADMCopyDM_Material();

export class QUADMUnLinkUsersFromTeamResponse extends QCommandResponse {
}

export const qUADMUnLinkUsersFromTeamResponse = new QUADMUnLinkUsersFromTeamResponse();

export class QUADMUnLinkUsersFromTeam extends QueryObject {
    public readonly TeamUserAssociationIds = new QCollectionPath(this.withPrefix("TeamUserAssociationIds"), () => QGuidCollection);
}

export const qUADMUnLinkUsersFromTeam = new QUADMUnLinkUsersFromTeam();

export class QUADMLinkUsersToTeamResponse extends QCommandResponse {
}

export const qUADMLinkUsersToTeamResponse = new QUADMLinkUsersToTeamResponse();

export class QUADMLinkUsersToTeam extends QueryObject {
    public readonly TeamId = new QGuidPath(this.withPrefix("TeamId"));
    public readonly Users = new QCollectionPath(this.withPrefix("Users"), () => QStringCollection);
}

export const qUADMLinkUsersToTeam = new QUADMLinkUsersToTeam();

export class QUADMDeleteDM_MaterialListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMDeleteDM_MaterialListResponse = new QUADMDeleteDM_MaterialListResponse();

export class QUADMDeleteDM_MaterialList extends QueryObject {
    public readonly DM_MaterialIds = new QCollectionPath(this.withPrefix("DM_MaterialIds"), () => QGuidCollection);
}

export const qUADMDeleteDM_MaterialList = new QUADMDeleteDM_MaterialList();

export class QUADMDeleteCustomItlkCheckListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMDeleteCustomItlkCheckListResponse = new QUADMDeleteCustomItlkCheckListResponse();

export class QUADMDeleteCustomItlkCheckList extends QueryObject {
    public readonly ListOfItlkCheckId = new QCollectionPath(this.withPrefix("ListOfItlkCheckId"), () => QGuidCollection);
}

export const qUADMDeleteCustomItlkCheckList = new QUADMDeleteCustomItlkCheckList();

export class QUADMDeleteCustomItlkCheckParameterListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMDeleteCustomItlkCheckParameterListResponse = new QUADMDeleteCustomItlkCheckParameterListResponse();

export class QUADMDeleteCustomItlkCheckParameterList extends QueryObject {
    public readonly ListOfItlkCheckParameterId = new QCollectionPath(this.withPrefix("ListOfItlkCheckParameterId"), () => QGuidCollection);
}

export const qUADMDeleteCustomItlkCheckParameterList = new QUADMDeleteCustomItlkCheckParameterList();

export class QUADMRemoveHoldListResponse extends QCommandResponse {
}

export const qUADMRemoveHoldListResponse = new QUADMRemoveHoldListResponse();

export class QUADMRemoveHoldList extends QueryObject {
    public readonly HoldIds = new QCollectionPath(this.withPrefix("HoldIds"), () => QGuidCollection);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
}

export const qUADMRemoveHoldList = new QUADMRemoveHoldList();

export class QPLMCreateOperationDCDListResponse extends QCommandResponse {
    public readonly WorkInstructionDefinitionList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionList"), () => QGuidCollection);
}

export const qPLMCreateOperationDCDListResponse = new QPLMCreateOperationDCDListResponse();

export class QPLMCreateOperationDCDList extends QueryObject {
    public readonly DCDList = new QEntityCollectionPath(this.withPrefix("DCDList"), () => QPLMDCDParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOperationDCDList = new QPLMCreateOperationDCDList();

export class QPLMCreateStepDCDListResponse extends QCommandResponse {
    public readonly WorkInstructionDefinitionList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionList"), () => QGuidCollection);
}

export const qPLMCreateStepDCDListResponse = new QPLMCreateStepDCDListResponse();

export class QPLMCreateStepDCDList extends QueryObject {
    public readonly DCDList = new QEntityCollectionPath(this.withPrefix("DCDList"), () => QPLMDCDParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateStepDCDList = new QPLMCreateStepDCDList();

export class QUADMRegisterNonProductiveActivityForUserResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMRegisterNonProductiveActivityForUserResponse = new QUADMRegisterNonProductiveActivityForUserResponse();

export class QUADMRegisterNonProductiveActivityForUser extends QueryObject {
    public readonly NPAId = new QGuidPath(this.withPrefix("NPAId"));
    public readonly NPAUserParameter = new QEntityPath(this.withPrefix("NPAUserParameter"), () => QNPAUserParameterType);
}

export const qUADMRegisterNonProductiveActivityForUser = new QUADMRegisterNonProductiveActivityForUser();

export class QUADMDeleteNonProductiveActivityListForUserResponse extends QCommandResponse {
}

export const qUADMDeleteNonProductiveActivityListForUserResponse = new QUADMDeleteNonProductiveActivityListForUserResponse();

export class QUADMDeleteNonProductiveActivityListForUser extends QueryObject {
    public readonly UserNPAIds = new QCollectionPath(this.withPrefix("UserNPAIds"), () => QGuidCollection);
}

export const qUADMDeleteNonProductiveActivityListForUser = new QUADMDeleteNonProductiveActivityListForUser();

export class QUADMUpdateNonProductiveActivityForUserResponse extends QCommandResponse {
}

export const qUADMUpdateNonProductiveActivityForUserResponse = new QUADMUpdateNonProductiveActivityForUserResponse();

export class QUADMUpdateNonProductiveActivityForUser extends QueryObject {
    public readonly UserNPAId = new QGuidPath(this.withPrefix("UserNPAId"));
    public readonly NPAUserParameter = new QEntityPath(this.withPrefix("NPAUserParameter"), () => QNPAUserParameterType);
}

export const qUADMUpdateNonProductiveActivityForUser = new QUADMUpdateNonProductiveActivityForUser();

export class QCancelSchedulingResponse extends QCommandResponse {
}

export const qCancelSchedulingResponse = new QCancelSchedulingResponse();

export class QCancelScheduling extends QueryObject {
}

export const qCancelScheduling = new QCancelScheduling();

export class QSetInSchedulingResponse extends QCommandResponse {
}

export const qSetInSchedulingResponse = new QSetInSchedulingResponse();

export class QSetInScheduling extends QueryObject {
    public readonly NIds = new QEntityPath(this.withPrefix("NIds"), () => QNIdsParameterType);
}

export const qSetInScheduling = new QSetInScheduling();

export class QSetInScheduledResponse extends QCommandResponse {
}

export const qSetInScheduledResponse = new QSetInScheduledResponse();

export class QSetInScheduled extends QueryObject {
    public readonly APSOrderOperations = new QEntityPath(this.withPrefix("APSOrderOperations"), () => QAPSOrderOperationsParameterType);
}

export const qSetInScheduled = new QSetInScheduled();

export class QSetAlternativeSelectedResponse extends QCommandResponse {
}

export const qSetAlternativeSelectedResponse = new QSetAlternativeSelectedResponse();

export class QSetAlternativeSelected extends QueryObject {
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
}

export const qSetAlternativeSelected = new QSetAlternativeSelected();

export class QUADMAutomaticCreateNonConformanceOnMTUListResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMAutomaticCreateNonConformanceOnMTUListResponse = new QUADMAutomaticCreateNonConformanceOnMTUListResponse();

export class QUADMAutomaticCreateNonConformanceOnMTUList extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly DefectTypeList = new QCollectionPath(this.withPrefix("DefectTypeList"), () => QStringCollection);
    public readonly MTUCodeList = new QCollectionPath(this.withPrefix("MTUCodeList"), () => QStringCollection);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMAutomaticCreateNonConformanceOnMTUList = new QUADMAutomaticCreateNonConformanceOnMTUList();

export class QUADMAutomaticCreateNonConformanceOnWOOperationResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMAutomaticCreateNonConformanceOnWOOperationResponse = new QUADMAutomaticCreateNonConformanceOnWOOperationResponse();

export class QUADMAutomaticCreateNonConformanceOnWOOperation extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly DefectTypeList = new QCollectionPath(this.withPrefix("DefectTypeList"), () => QStringCollection);
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMAutomaticCreateNonConformanceOnWOOperation = new QUADMAutomaticCreateNonConformanceOnWOOperation();

export class QUADMAutomaticCreateNonConformanceOnEquipmentResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMAutomaticCreateNonConformanceOnEquipmentResponse = new QUADMAutomaticCreateNonConformanceOnEquipmentResponse();

export class QUADMAutomaticCreateNonConformanceOnEquipment extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly DefectTypeList = new QCollectionPath(this.withPrefix("DefectTypeList"), () => QStringCollection);
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMAutomaticCreateNonConformanceOnEquipment = new QUADMAutomaticCreateNonConformanceOnEquipment();

export class QUADMAutomaticUseToolListResponse extends QCommandResponse {
}

export const qUADMAutomaticUseToolListResponse = new QUADMAutomaticUseToolListResponse();

export class QUADMAutomaticUseToolList extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly ToolToBeUsedOnMaterialItemList = new QEntityCollectionPath(this.withPrefix("ToolToBeUsedOnMaterialItemList"), () => QMaterialItemToolToBeUsedInfo);
}

export const qUADMAutomaticUseToolList = new QUADMAutomaticUseToolList();

export class QUADMAutomaticConsumeMaterialTrackingUnitResponse extends QCommandResponse {
}

export const qUADMAutomaticConsumeMaterialTrackingUnitResponse = new QUADMAutomaticConsumeMaterialTrackingUnitResponse();

export class QUADMAutomaticConsumeMaterialTrackingUnit extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly WorkOperationCategory = new QStringPath(this.withPrefix("WorkOperationCategory"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly ConsumptionDetails = new QEntityCollectionPath(this.withPrefix("ConsumptionDetails"), () => QAutomaticConsumptionParameterType);
}

export const qUADMAutomaticConsumeMaterialTrackingUnit = new QUADMAutomaticConsumeMaterialTrackingUnit();

export class QUADMCreateNonConformanceV3_1Response extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qUADMCreateNonConformanceV3_1Response = new QUADMCreateNonConformanceV3_1Response();

export class QUADMCreateNonConformanceV3_1 extends QueryObject {
    public readonly NonConformanceProperties = new QEntityPath(this.withPrefix("NonConformanceProperties"), () => QNonConformancePropertyType);
    public readonly DefectList = new QEntityCollectionPath(this.withPrefix("DefectList"), () => QDefectParameterType);
    public readonly ChangeOperationProperties = new QEntityPath(this.withPrefix("ChangeOperationProperties"), () => QChangeOperationParameterType);
    public readonly ChangePartProperties = new QEntityPath(this.withPrefix("ChangePartProperties"), () => QChangePartParameterType);
    public readonly ChangeDataCollectionProperties = new QEntityPath(this.withPrefix("ChangeDataCollectionProperties"), () => QChangeDataCollectionParameterType);
    public readonly QualityNonConformanceProperties = new QEntityPath(this.withPrefix("QualityNonConformanceProperties"), () => QQualityNonConformancePropertiesType);
    public readonly AttachmentList = new QEntityCollectionPath(this.withPrefix("AttachmentList"), () => QNonConformanceAttachmentParameterType);
    public readonly ContainerNidList = new QCollectionPath(this.withPrefix("ContainerNidList"), () => QStringCollection);
    public readonly IsAutomatic = new QBooleanPath(this.withPrefix("IsAutomatic"));
}

export const qUADMCreateNonConformanceV3_1 = new QUADMCreateNonConformanceV3_1();

export class QUADMSentenceNonConformanceV3_1Response extends QCommandResponse {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
}

export const qUADMSentenceNonConformanceV3_1Response = new QUADMSentenceNonConformanceV3_1Response();

export class QUADMSentenceNonConformanceV3_1 extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceStatusNId = new QStringPath(this.withPrefix("NonConformanceStatusNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly NonConformancePartialWOOpQuantities = new QEntityPath(this.withPrefix("NonConformancePartialWOOpQuantities"), () => QNonConformanceQuantities4PartialSentenceParameterType);
    public readonly ReworkProcessId = new QGuidPath(this.withPrefix("ReworkProcessId"));
    public readonly IsAutomaticallyInvoked = new QBooleanPath(this.withPrefix("IsAutomaticallyInvoked"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
}

export const qUADMSentenceNonConformanceV3_1 = new QUADMSentenceNonConformanceV3_1();

export class QUADMAutomaticSentenceNonConformanceResponse extends QCommandResponse {
}

export const qUADMAutomaticSentenceNonConformanceResponse = new QUADMAutomaticSentenceNonConformanceResponse();

export class QUADMAutomaticSentenceNonConformance extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly TargetStatus = new QStringPath(this.withPrefix("TargetStatus"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SerialNumberCodeList = new QCollectionPath(this.withPrefix("SerialNumberCodeList"), () => QStringCollection);
}

export const qUADMAutomaticSentenceNonConformance = new QUADMAutomaticSentenceNonConformance();

export class QUADMCreateToBeUsedMachinePJFResponse extends QCommandResponse {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qUADMCreateToBeUsedMachinePJFResponse = new QUADMCreateToBeUsedMachinePJFResponse();

export class QUADMCreateToBeUsedMachinePJF extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
}

export const qUADMCreateToBeUsedMachinePJF = new QUADMCreateToBeUsedMachinePJF();

export class QUADMDeleteStepListResponse extends QCommandResponse {
}

export const qUADMDeleteStepListResponse = new QUADMDeleteStepListResponse();

export class QUADMDeleteStepList extends QueryObject {
    public readonly StepIds = new QCollectionPath(this.withPrefix("StepIds"), () => QGuidCollection);
}

export const qUADMDeleteStepList = new QUADMDeleteStepList();

export class QUADMAbruptlyCloseFlexibleWorkOrderResponse extends QCommandResponse {
}

export const qUADMAbruptlyCloseFlexibleWorkOrderResponse = new QUADMAbruptlyCloseFlexibleWorkOrderResponse();

export class QUADMAbruptlyCloseFlexibleWorkOrder extends QueryObject {
    public readonly NewWorkOrderNId = new QStringPath(this.withPrefix("NewWorkOrderNId"));
    public readonly OriginalWorkOrderId = new QGuidPath(this.withPrefix("OriginalWorkOrderId"));
}

export const qUADMAbruptlyCloseFlexibleWorkOrder = new QUADMAbruptlyCloseFlexibleWorkOrder();

export class QUADMLinkHumanResourceToProcessResponse extends QCommandResponse {
}

export const qUADMLinkHumanResourceToProcessResponse = new QUADMLinkHumanResourceToProcessResponse();

export class QUADMLinkHumanResourceToProcess extends QueryObject {
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly CertificationNIds = new QCollectionPath(this.withPrefix("CertificationNIds"), () => QStringCollection);
    public readonly RequiredNumberOfHumanResource = new QCollectionPath(this.withPrefix("RequiredNumberOfHumanResource"), () => QNumberCollection);
    public readonly ParentIndicator = new QStringPath(this.withPrefix("ParentIndicator"));
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qUADMLinkHumanResourceToProcess = new QUADMLinkHumanResourceToProcess();

export class QUADMUnlinkHumanResourceFromProcessResponse extends QCommandResponse {
}

export const qUADMUnlinkHumanResourceFromProcessResponse = new QUADMUnlinkHumanResourceFromProcessResponse();

export class QUADMUnlinkHumanResourceFromProcess extends QueryObject {
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly ParentIndicator = new QStringPath(this.withPrefix("ParentIndicator"));
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
}

export const qUADMUnlinkHumanResourceFromProcess = new QUADMUnlinkHumanResourceFromProcess();

export class QPLMCreateCertificationWithSkillListResponse extends QCommandResponse {
}

export const qPLMCreateCertificationWithSkillListResponse = new QPLMCreateCertificationWithSkillListResponse();

export class QPLMCreateCertificationWithSkillList extends QueryObject {
    public readonly CertificationList = new QEntityCollectionPath(this.withPrefix("CertificationList"), () => QPLMCertificationWithSkillParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateCertificationWithSkillList = new QPLMCreateCertificationWithSkillList();

export class QPLMCreateOperationHRSpecificationFullListResponse extends QCommandResponse {
}

export const qPLMCreateOperationHRSpecificationFullListResponse = new QPLMCreateOperationHRSpecificationFullListResponse();

export class QPLMCreateOperationHRSpecificationFullList extends QueryObject {
    public readonly HumanResourceSpecificationList = new QEntityCollectionPath(this.withPrefix("HumanResourceSpecificationList"), () => QPLMHRSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateOperationHRSpecificationFullList = new QPLMCreateOperationHRSpecificationFullList();

export class QPLMCreateStepHRSpecificationFullListResponse extends QCommandResponse {
}

export const qPLMCreateStepHRSpecificationFullListResponse = new QPLMCreateStepHRSpecificationFullListResponse();

export class QPLMCreateStepHRSpecificationFullList extends QueryObject {
    public readonly HumanResourceSpecificationList = new QEntityCollectionPath(this.withPrefix("HumanResourceSpecificationList"), () => QPLMHRSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qPLMCreateStepHRSpecificationFullList = new QPLMCreateStepHRSpecificationFullList();

export class QUADMDeleteDefectGroupListResponse extends QCommandResponse {
}

export const qUADMDeleteDefectGroupListResponse = new QUADMDeleteDefectGroupListResponse();

export class QUADMDeleteDefectGroupList extends QueryObject {
    public readonly DefectGroupIdentifierList = new QEntityCollectionPath(this.withPrefix("DefectGroupIdentifierList"), () => QIdentifiersParameterType);
}

export const qUADMDeleteDefectGroupList = new QUADMDeleteDefectGroupList();

export class QUADMDeleteDefectTypeListResponse extends QCommandResponse {
}

export const qUADMDeleteDefectTypeListResponse = new QUADMDeleteDefectTypeListResponse();

export class QUADMDeleteDefectTypeList extends QueryObject {
    public readonly DefectTypeIdentifiersList = new QEntityCollectionPath(this.withPrefix("DefectTypeIdentifiersList"), () => QIdentifiersParameterType);
}

export const qUADMDeleteDefectTypeList = new QUADMDeleteDefectTypeList();

export class QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitListResponse extends QCommandResponse {
}

export const qPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitListResponse = new QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitListResponse();

export class QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly MaterialTrackingUnitList = new QEntityCollectionPath(this.withPrefix("MaterialTrackingUnitList"), () => QPLMMaterialTrackingUnitParameterType);
}

export const qPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList = new QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList();

export class QPLMChangeStatusEventLogResponse extends QCommandResponse {
}

export const qPLMChangeStatusEventLogResponse = new QPLMChangeStatusEventLogResponse();

export class QPLMChangeStatusEventLog extends QueryObject {
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly TransitionVerb = new QStringPath(this.withPrefix("TransitionVerb"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
}

export const qPLMChangeStatusEventLog = new QPLMChangeStatusEventLog();

export class QPLMDeleteEventLogListResponse extends QCommandResponse {
    public readonly DeletedEventIdList = new QCollectionPath(this.withPrefix("DeletedEventIdList"), () => QGuidCollection);
}

export const qPLMDeleteEventLogListResponse = new QPLMDeleteEventLogListResponse();

export class QPLMDeleteEventLogList extends QueryObject {
    public readonly EventIdList = new QCollectionPath(this.withPrefix("EventIdList"), () => QGuidCollection);
}

export const qPLMDeleteEventLogList = new QPLMDeleteEventLogList();

export class QPLMChangeStatusEventLogListResponse extends QCommandResponse {
}

export const qPLMChangeStatusEventLogListResponse = new QPLMChangeStatusEventLogListResponse();

export class QPLMChangeStatusEventLogList extends QueryObject {
    public readonly PLMChangeStatusEventLogParameterTypeList = new QEntityCollectionPath(this.withPrefix("PLMChangeStatusEventLogParameterTypeList"), () => QPLMChangeStatusEventLogParameterType);
}

export const qPLMChangeStatusEventLogList = new QPLMChangeStatusEventLogList();

export class QSetInScheduledNoBulkResponse extends QCommandResponse {
}

export const qSetInScheduledNoBulkResponse = new QSetInScheduledNoBulkResponse();

export class QSetInScheduledNoBulk extends QueryObject {
    public readonly APSOrderOperations = new QEntityPath(this.withPrefix("APSOrderOperations"), () => QAPSOrderOperationsParameterType);
}

export const qSetInScheduledNoBulk = new QSetInScheduledNoBulk();

export class QPLMCreateOperationDCDWIResponse extends QCommandResponse {
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
}

export const qPLMCreateOperationDCDWIResponse = new QPLMCreateOperationDCDWIResponse();

export class QPLMCreateOperationDCDWI extends QueryObject {
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly AssociationType = new QStringPath(this.withPrefix("AssociationType"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly DCDWI = new QEntityPath(this.withPrefix("DCDWI"), () => QPLMDCDWIParameterType);
}

export const qPLMCreateOperationDCDWI = new QPLMCreateOperationDCDWI();

export class QPLMCreateStepDCDWIResponse extends QCommandResponse {
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
}

export const qPLMCreateStepDCDWIResponse = new QPLMCreateStepDCDWIResponse();

export class QPLMCreateStepDCDWI extends QueryObject {
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly AssociationType = new QStringPath(this.withPrefix("AssociationType"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly DCDWI = new QEntityPath(this.withPrefix("DCDWI"), () => QPLMDCDWIParameterType);
}

export const qPLMCreateStepDCDWI = new QPLMCreateStepDCDWI();

export class QUADMAutomaticAcquireQualityInspectionDataResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qUADMAutomaticAcquireQualityInspectionDataResponse = new QUADMAutomaticAcquireQualityInspectionDataResponse();

export class QUADMAutomaticAcquireQualityInspectionData extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly MTUCodeList = new QCollectionPath(this.withPrefix("MTUCodeList"), () => QStringCollection);
    public readonly QualityCharctersticsDetails = new QEntityCollectionPath(this.withPrefix("QualityCharctersticsDetails"), () => QAutomaticAcquireQualityCharactersticsParameterType);
}

export const qUADMAutomaticAcquireQualityInspectionData = new QUADMAutomaticAcquireQualityInspectionData();

export class QUADMAutomaticCreateSnagAndNoteResponse extends QCommandResponse {
    public readonly SnagAndNoteId = new QStringPath(this.withPrefix("SnagAndNoteId"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUADMAutomaticCreateSnagAndNoteResponse = new QUADMAutomaticCreateSnagAndNoteResponse();

export class QUADMAutomaticCreateSnagAndNote extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMAutomaticCreateSnagAndNote = new QUADMAutomaticCreateSnagAndNote();

export class QUADMConsumeMaterialItemOnContainerResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qUADMConsumeMaterialItemOnContainerResponse = new QUADMConsumeMaterialItemOnContainerResponse();

export class QUADMConsumeMaterialItemOnContainer extends QueryObject {
    public readonly MaterialItemToConsumeOnContainerList = new QEntityCollectionPath(this.withPrefix("MaterialItemToConsumeOnContainerList"), () => QMaterialItemToConsumeOnContainerParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qUADMConsumeMaterialItemOnContainer = new QUADMConsumeMaterialItemOnContainer();

export class QUADMReleaseWorkOrderListResponse extends QCommandResponse {
}

export const qUADMReleaseWorkOrderListResponse = new QUADMReleaseWorkOrderListResponse();

export class QUADMReleaseWorkOrderList extends QueryObject {
    public readonly ReleaseWorkOrderDetails = new QEntityCollectionPath(this.withPrefix("ReleaseWorkOrderDetails"), () => QReleaseWorkOrderParameterType);
}

export const qUADMReleaseWorkOrderList = new QUADMReleaseWorkOrderList();

export class QSetPointParameterType extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly SetPointItemId = new QGuidPath(this.withPrefix("SetPointItemId"));
    public readonly SetPointItemValue = new QStringPath(this.withPrefix("SetPointItemValue"));
}

export const qSetPointParameterType = new QSetPointParameterType();

export class QStartWOOperationFullQtyParameterType extends QueryObject {
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartWOOperationFullQtyParameterType = new QStartWOOperationFullQtyParameterType();

export class QWorkOrderDetailsForBoPUpdateParameterType extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderStatus = new QStringPath(this.withPrefix("WorkOrderStatus"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedId = new QGuidPath(this.withPrefix("AsPlannedId"));
}

export const qWorkOrderDetailsForBoPUpdateParameterType = new QWorkOrderDetailsForBoPUpdateParameterType();

export class QStartWOOperationTransferBatchParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartWOOperationTransferBatchParameterType = new QStartWOOperationTransferBatchParameterType();

export class QMaterialItemParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
}

export const qMaterialItemParameterType = new QMaterialItemParameterType();

export class QToBeConsumedMaterialParameterType extends QueryObject {
    public readonly ActualQuantity = new QNumberPath(this.withPrefix("ActualQuantity"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly ToBeConsumedMaterialName = new QStringPath(this.withPrefix("ToBeConsumedMaterialName"));
    public readonly ToBeConsumedMaterialSequence = new QNumberPath(this.withPrefix("ToBeConsumedMaterialSequence"));
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
    public readonly MaterialDefinitonRevision = new QStringPath(this.withPrefix("MaterialDefinitonRevision"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
}

export const qToBeConsumedMaterialParameterType = new QToBeConsumedMaterialParameterType();

export class QMaterialItemToConsumeParameterType extends QueryObject {
    public readonly TargetMaterialItem = new QEntityPath(this.withPrefix("TargetMaterialItem"), () => QMaterialItemParameterType);
    public readonly ToBeConsumedMaterialItemList = new QEntityCollectionPath(this.withPrefix("ToBeConsumedMaterialItemList"), () => QToBeConsumedMaterialParameterType);
}

export const qMaterialItemToConsumeParameterType = new QMaterialItemToConsumeParameterType();

export class QCreateReworkOrderParameterType extends QueryObject {
    public readonly MaterialItemList = new QEntityCollectionPath(this.withPrefix("MaterialItemList"), () => QMaterialItemParameterType);
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly PartialQuantity = new QNumberPath(this.withPrefix("PartialQuantity"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
}

export const qCreateReworkOrderParameterType = new QCreateReworkOrderParameterType();

export class QNonConformanceParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly HistoryId = new QStringPath(this.withPrefix("HistoryId"));
    public readonly MateriaDefinitionNId = new QStringPath(this.withPrefix("MateriaDefinitionNId"));
    public readonly MaterialItemNId = new QStringPath(this.withPrefix("MaterialItemNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly NonConformanceLifecycleNId = new QStringPath(this.withPrefix("NonConformanceLifecycleNId"));
    public readonly NonConformanceType = new QStringPath(this.withPrefix("NonConformanceType"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Equipments = new QCollectionPath(this.withPrefix("Equipments"), () => QStringCollection);
    public readonly Tools = new QCollectionPath(this.withPrefix("Tools"), () => QStringCollection);
    public readonly MaterialItems = new QCollectionPath(this.withPrefix("MaterialItems"), () => QStringCollection);
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qNonConformanceParameterType = new QNonConformanceParameterType();

export class QNonConformanceAttachmentParameterType extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly DocumentFileName = new QStringPath(this.withPrefix("DocumentFileName"));
    public readonly DocumentMIMEType = new QStringPath(this.withPrefix("DocumentMIMEType"));
}

export const qNonConformanceAttachmentParameterType = new QNonConformanceAttachmentParameterType();

export class QNonConformanceDetectionParameterType extends QueryObject {
    public readonly InspectedQuantity = new QNumberPath(this.withPrefix("InspectedQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qNonConformanceDetectionParameterType = new QNonConformanceDetectionParameterType();

export class QNonConformanceResourceParameterType extends QueryObject {
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Operation = new QStringPath(this.withPrefix("Operation"));
    public readonly ResourceId = new QStringPath(this.withPrefix("ResourceId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qNonConformanceResourceParameterType = new QNonConformanceResourceParameterType();

export class QNonConformanceHistoryParameterType extends QueryObject {
    public readonly Attachments = new QEntityCollectionPath(this.withPrefix("Attachments"), () => QNonConformanceAttachmentParameterType);
    public readonly Detections = new QEntityCollectionPath(this.withPrefix("Detections"), () => QNonConformanceDetectionParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Resources = new QEntityCollectionPath(this.withPrefix("Resources"), () => QNonConformanceResourceParameterType);
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
}

export const qNonConformanceHistoryParameterType = new QNonConformanceHistoryParameterType();

export class QDefectParameterType extends QueryObject {
    public readonly DefectNId = new QStringPath(this.withPrefix("DefectNId"));
    public readonly GroupPath = new QStringPath(this.withPrefix("GroupPath"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
}

export const qDefectParameterType = new QDefectParameterType();

export class QBoMParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
}

export const qBoMParameterType = new QBoMParameterType();

export class QStartWOOperationSerializedParameterType extends QueryObject {
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartWOOperationSerializedParameterType = new QStartWOOperationSerializedParameterType();

export class QHoldParamterType extends QueryObject {
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Reasons = new QCollectionPath(this.withPrefix("Reasons"), () => QStringCollection);
    public readonly ReasonsId = new QCollectionPath(this.withPrefix("ReasonsId"), () => QGuidCollection);
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qHoldParamterType = new QHoldParamterType();

export class QWorkOrderIdentifiersParameterType extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qWorkOrderIdentifiersParameterType = new QWorkOrderIdentifiersParameterType();

export class QMaterialItemIdentifiersParameterType extends QueryObject {
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly MaterialItemNId = new QStringPath(this.withPrefix("MaterialItemNId"));
}

export const qMaterialItemIdentifiersParameterType = new QMaterialItemIdentifiersParameterType();

export class QResultParameterType extends QueryObject {
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly Strategy = new QStringPath(this.withPrefix("Strategy"));
}

export const qResultParameterType = new QResultParameterType();

export class QCompleteWOOperationSerializedParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly Results = new QEntityCollectionPath(this.withPrefix("Results"), () => QResultParameterType);
    public readonly AvoidPausingOtherSerialNos = new QBooleanPath(this.withPrefix("AvoidPausingOtherSerialNos"));
}

export const qCompleteWOOperationSerializedParameterType = new QCompleteWOOperationSerializedParameterType();

export class QIdentifiersParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qIdentifiersParameterType = new QIdentifiersParameterType();

export class QRepeatOperationChangeParameter extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly NewDescription = new QStringPath(this.withPrefix("NewDescription"));
    public readonly NewWorkOrderOperationNId = new QStringPath(this.withPrefix("NewWorkOrderOperationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qRepeatOperationChangeParameter = new QRepeatOperationChangeParameter();

export class QToBeConsumedMaterialParameter extends QueryObject {
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
}

export const qToBeConsumedMaterialParameter = new QToBeConsumedMaterialParameter();

export class QToBeUsedMachineParameter extends QueryObject {
    public readonly Machine = new QStringPath(this.withPrefix("Machine"));
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
}

export const qToBeUsedMachineParameter = new QToBeUsedMachineParameter();

export class QWorkOOperationDependencyParameter extends QueryObject {
    public readonly FromId = new QGuidPath(this.withPrefix("FromId"));
    public readonly OperationDependencyType = new QStringPath(this.withPrefix("OperationDependencyType"));
    public readonly ToId = new QGuidPath(this.withPrefix("ToId"));
    public readonly PartialCompleted = new QBooleanPath(this.withPrefix("PartialCompleted"));
}

export const qWorkOOperationDependencyParameter = new QWorkOOperationDependencyParameter();

export class QNewWorkOrderForSplit extends QueryObject {
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ToBeProducedQuantity = new QNumberPath(this.withPrefix("ToBeProducedQuantity"));
}

export const qNewWorkOrderForSplit = new QNewWorkOrderForSplit();

export class QToBeDisassembledMaterialItemParameterType extends QueryObject {
    public readonly AssembledQuantity = new QNumberPath(this.withPrefix("AssembledQuantity"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ProducedMaterialItemActualQuantity = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
}

export const qToBeDisassembledMaterialItemParameterType = new QToBeDisassembledMaterialItemParameterType();

export class QMaterialItemToDisassembleParameterType extends QueryObject {
    public readonly ProducedMaterialItem = new QEntityPath(this.withPrefix("ProducedMaterialItem"), () => QMaterialItemParameterType);
    public readonly ToBeDisassembledMaterialItemList = new QEntityCollectionPath(this.withPrefix("ToBeDisassembledMaterialItemList"), () => QToBeDisassembledMaterialItemParameterType);
}

export const qMaterialItemToDisassembleParameterType = new QMaterialItemToDisassembleParameterType();

export class QWorkOrderOperationFromOperationParameter extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly WorkOperationTypeId = new QGuidPath(this.withPrefix("WorkOperationTypeId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly ERPConfirmationId = new QStringPath(this.withPrefix("ERPConfirmationId"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
}

export const qWorkOrderOperationFromOperationParameter = new QWorkOrderOperationFromOperationParameter();

export class QActualProducedMaterialTBParameterType extends QueryObject {
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qActualProducedMaterialTBParameterType = new QActualProducedMaterialTBParameterType();

export class QCompleteWOOperationTransferBatchParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly ActualProducedMaterialList = new QEntityCollectionPath(this.withPrefix("ActualProducedMaterialList"), () => QActualProducedMaterialTBParameterType);
}

export const qCompleteWOOperationTransferBatchParameterType = new QCompleteWOOperationTransferBatchParameterType();

export class QPauseWOOperationParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
}

export const qPauseWOOperationParameterType = new QPauseWOOperationParameterType();

export class QCompleteWOOperationFullQtyParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly ResultList = new QEntityCollectionPath(this.withPrefix("ResultList"), () => QResultParameterType);
}

export const qCompleteWOOperationFullQtyParameterType = new QCompleteWOOperationFullQtyParameterType();

export class QReleaseWorkOrderParameterType extends QueryObject {
    public readonly SerialNumberCodes = new QCollectionPath(this.withPrefix("SerialNumberCodes"), () => QStringCollection);
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qReleaseWorkOrderParameterType = new QReleaseWorkOrderParameterType();

export class QNPAUserParameterType extends QueryObject {
    public readonly StartDate = new QDateTimeOffsetPath(this.withPrefix("StartDate"));
    public readonly EndDate = new QDateTimeOffsetPath(this.withPrefix("EndDate"));
    public readonly NPAContextId = new QGuidPath(this.withPrefix("NPAContextId"));
    public readonly NPAContextValue = new QGuidPath(this.withPrefix("NPAContextValue"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly NPAEquipmentNIdValue = new QStringPath(this.withPrefix("NPAEquipmentNIdValue"));
}

export const qNPAUserParameterType = new QNPAUserParameterType();

export class QAutomaticToBeConsumedMaterialTrackingUnitParameterType extends QueryObject {
    public readonly DM_MaterialNId = new QStringPath(this.withPrefix("DM_MaterialNId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly MaterialTrackingUnitCode = new QStringPath(this.withPrefix("MaterialTrackingUnitCode"));
}

export const qAutomaticToBeConsumedMaterialTrackingUnitParameterType = new QAutomaticToBeConsumedMaterialTrackingUnitParameterType();

export class QAutomaticConsumptionParameterType extends QueryObject {
    public readonly TargetMaterialTrackingUnitCode = new QStringPath(this.withPrefix("TargetMaterialTrackingUnitCode"));
    public readonly ToBeConsumedMaterialTrackingUnitList = new QEntityCollectionPath(this.withPrefix("ToBeConsumedMaterialTrackingUnitList"), () => QAutomaticToBeConsumedMaterialTrackingUnitParameterType);
}

export const qAutomaticConsumptionParameterType = new QAutomaticConsumptionParameterType();

export class QNonConformancePropertyType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly NonConformanceLifecycleNId = new QStringPath(this.withPrefix("NonConformanceLifecycleNId"));
    public readonly NonConformanceType = new QStringPath(this.withPrefix("NonConformanceType"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), NCContext);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly ParentNonConformanceNId = new QStringPath(this.withPrefix("ParentNonConformanceNId"));
}

export const qNonConformancePropertyType = new QNonConformancePropertyType();

export class QChangeOperationParameterType extends QueryObject {
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly SequenceAfter = new QGuidPath(this.withPrefix("SequenceAfter"));
    public readonly NewOperationName = new QStringPath(this.withPrefix("NewOperationName"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly OperationNameList = new QStringPath(this.withPrefix("OperationNameList"));
    public readonly RoutingOperationAfter = new QStringPath(this.withPrefix("RoutingOperationAfter"));
    public readonly OldOperationName = new QStringPath(this.withPrefix("OldOperationName"));
}

export const qChangeOperationParameterType = new QChangeOperationParameterType();

export class QChangePartParameterType extends QueryObject {
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly NewPart = new QStringPath(this.withPrefix("NewPart"));
    public readonly NewPartQuantity = new QNumberPath(this.withPrefix("NewPartQuantity"));
    public readonly OldPart = new QStringPath(this.withPrefix("OldPart"));
    public readonly OldPartQuantity = new QNumberPath(this.withPrefix("OldPartQuantity"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qChangePartParameterType = new QChangePartParameterType();

export class QChangeDataCollectionParameterType extends QueryObject {
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly ReferenceWorkorderOperations = new QStringPath(this.withPrefix("ReferenceWorkorderOperations"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly WIDefinition = new QStringPath(this.withPrefix("WIDefinition"));
}

export const qChangeDataCollectionParameterType = new QChangeDataCollectionParameterType();

export class QQualityNonConformancePropertiesType extends QueryObject {
    public readonly MTUNIdList = new QCollectionPath(this.withPrefix("MTUNIdList"), () => QStringCollection);
    public readonly ToolNIdList = new QCollectionPath(this.withPrefix("ToolNIdList"), () => QStringCollection);
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly IsTriggeredByQualityInspectionFailure = new QBooleanPath(this.withPrefix("IsTriggeredByQualityInspectionFailure"));
}

export const qQualityNonConformancePropertiesType = new QQualityNonConformancePropertiesType();

export class QNonConformanceQuantities4PartialSentenceParameterType extends QueryObject {
    public readonly MTUNIdList = new QCollectionPath(this.withPrefix("MTUNIdList"), () => QStringCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ToBeProducedQuantity = new QNumberPath(this.withPrefix("ToBeProducedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
}

export const qNonConformanceQuantities4PartialSentenceParameterType = new QNonConformanceQuantities4PartialSentenceParameterType();

export class QAutomaticAcquireQualityCharactersticsParameterType extends QueryObject {
    public readonly ChrReprNId = new QStringPath(this.withPrefix("ChrReprNId"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly MeasuredValue = new QStringPath(this.withPrefix("MeasuredValue"));
}

export const qAutomaticAcquireQualityCharactersticsParameterType = new QAutomaticAcquireQualityCharactersticsParameterType();

export class QNonConformanceSpecificationParameterType extends QueryObject {
    public readonly SpecificationNId = new QStringPath(this.withPrefix("SpecificationNId"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
    public readonly SpecificationTypeCode = new QNumberPath(this.withPrefix("SpecificationTypeCode"));
}

export const qNonConformanceSpecificationParameterType = new QNonConformanceSpecificationParameterType();

export class QNonConformanceSentencingParamaterType extends QueryObject {
    public readonly NonConformanceAttachmentList = new QEntityCollectionPath(this.withPrefix("NonConformanceAttachmentList"), () => QNonConformanceAttachmentParameterType);
    public readonly NonConformanceDetectionList = new QEntityCollectionPath(this.withPrefix("NonConformanceDetectionList"), () => QNonConformanceDetectionParameterType);
    public readonly NonConformanceHistoryId = new QStringPath(this.withPrefix("NonConformanceHistoryId"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceSpecificationList = new QEntityCollectionPath(this.withPrefix("NonConformanceSpecificationList"), () => QNonConformanceSpecificationParameterType);
    public readonly NonConformanceTransitionNId = new QStringPath(this.withPrefix("NonConformanceTransitionNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ReworkOrderCreationDetails = new QEntityPath(this.withPrefix("ReworkOrderCreationDetails"), () => QCreateReworkOrderParameterType);
}

export const qNonConformanceSentencingParamaterType = new QNonConformanceSentencingParamaterType();

export class QMaterialItemForSplitType extends QueryObject {
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly QuantityType = new QEntityPath(this.withPrefix("QuantityType"), () => QQuantityParameterType);
    public readonly MaterialItemSplitQuantity = new QNumberPath(this.withPrefix("MaterialItemSplitQuantity"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qMaterialItemForSplitType = new QMaterialItemForSplitType();

export class QItlkCheckDM_MTUParameterType extends QueryObject {
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUCodeType = new QEnumPath(this.withPrefix("MTUCodeType"), MTUCodeType);
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
}

export const qItlkCheckDM_MTUParameterType = new QItlkCheckDM_MTUParameterType();

export class QDeleteFutureHoldParameterType extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceStatusNId = new QStringPath(this.withPrefix("NonConformanceStatusNId"));
    public readonly NonConformanceTransitionNId = new QStringPath(this.withPrefix("NonConformanceTransitionNId"));
}

export const qDeleteFutureHoldParameterType = new QDeleteFutureHoldParameterType();

export class QWOOpDependencyNavigationParameterType extends QueryObject {
    public readonly WorkOrderOperationDependencyId = new QGuidPath(this.withPrefix("WorkOrderOperationDependencyId"));
    public readonly IsPreferred = new QBooleanPath(this.withPrefix("IsPreferred"));
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
}

export const qWOOpDependencyNavigationParameterType = new QWOOpDependencyNavigationParameterType();

export class QProductMaterialItem extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Result = new QStringPath(this.withPrefix("Result"));
}

export const qProductMaterialItem = new QProductMaterialItem();

export class QMaterialItemHistoryParameterType extends QueryObject {
    public readonly DM_MTU_Id = new QGuidPath(this.withPrefix("DM_MTU_Id"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly ReferenceWorkOrderHistoryId = new QGuidPath(this.withPrefix("ReferenceWorkOrderHistoryId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qMaterialItemHistoryParameterType = new QMaterialItemHistoryParameterType();

export class QSplitContext extends QueryObject {
    public readonly ParentBacthId = new QGuidPath(this.withPrefix("ParentBacthId"));
    public readonly ChildBatchIdList = new QCollectionPath(this.withPrefix("ChildBatchIdList"), () => QGuidCollection);
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qSplitContext = new QSplitContext();

export class QResultWithTypeParameterType extends QueryObject {
    public readonly Result = new QEntityPath(this.withPrefix("Result"), () => QResultParameterType);
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qResultWithTypeParameterType = new QResultWithTypeParameterType();

export class QCompletedMTUParameterType extends QueryObject {
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly IsRealComplete = new QBooleanPath(this.withPrefix("IsRealComplete"));
    public readonly Result = new QEntityPath(this.withPrefix("Result"), () => QResultWithTypeParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WOHistoryMaterialItemId = new QGuidPath(this.withPrefix("WOHistoryMaterialItemId"));
    public readonly ProductionType = new QEnumPath(this.withPrefix("ProductionType"), ProductionTypeEnum);
    public readonly WOOpTargetQuantity = new QNumberPath(this.withPrefix("WOOpTargetQuantity"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ActivityType = new QStringPath(this.withPrefix("ActivityType"));
}

export const qCompletedMTUParameterType = new QCompletedMTUParameterType();

export class QWOOpSerializedLiteOutputParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationStatusNId = new QStringPath(this.withPrefix("WorkOrderOperationStatusNId"));
}

export const qWOOpSerializedLiteOutputParameterType = new QWOOpSerializedLiteOutputParameterType();

export class QWOOperationSerializedLiteParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qWOOperationSerializedLiteParameterType = new QWOOperationSerializedLiteParameterType();

export class QCompleteWOOpSerializedLiteParameterType extends QueryObject {
    public readonly WOOperationSerializedLiteParameter = new QEntityPath(this.withPrefix("WOOperationSerializedLiteParameter"), () => QWOOperationSerializedLiteParameterType);
    public readonly Results = new QEntityCollectionPath(this.withPrefix("Results"), () => QResultParameterType);
}

export const qCompleteWOOpSerializedLiteParameterType = new QCompleteWOOpSerializedLiteParameterType();

export class QExecutionGroupOperationParameterType extends QueryObject {
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qExecutionGroupOperationParameterType = new QExecutionGroupOperationParameterType();

export class QMaterialItemForVerify extends QueryObject {
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly CanVerify = new QBooleanPath(this.withPrefix("CanVerify"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly LocationPath = new QStringPath(this.withPrefix("LocationPath"));
    public readonly MaterialDefination = new QGuidPath(this.withPrefix("MaterialDefination"));
    public readonly MaterialDefinationNId = new QStringPath(this.withPrefix("MaterialDefinationNId"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly SerialNumberCode = new QStringPath(this.withPrefix("SerialNumberCode"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
}

export const qMaterialItemForVerify = new QMaterialItemForVerify();

export class QCopyToBeProducedFacetsOutputParameterType extends QueryObject {
    public readonly CopiedFacetId = new QGuidPath(this.withPrefix("CopiedFacetId"));
    public readonly NewFacetId = new QGuidPath(this.withPrefix("NewFacetId"));
}

export const qCopyToBeProducedFacetsOutputParameterType = new QCopyToBeProducedFacetsOutputParameterType();

export class QChangeRoutingParameterType extends QueryObject {
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly NewOperationFrom = new QStringPath(this.withPrefix("NewOperationFrom"));
    public readonly NewOperationTo = new QStringPath(this.withPrefix("NewOperationTo"));
    public readonly NewDependency = new QStringPath(this.withPrefix("NewDependency"));
    public readonly OldOperationFrom = new QStringPath(this.withPrefix("OldOperationFrom"));
    public readonly OldOperationTo = new QStringPath(this.withPrefix("OldOperationTo"));
    public readonly OldDependency = new QStringPath(this.withPrefix("OldDependency"));
}

export const qChangeRoutingParameterType = new QChangeRoutingParameterType();

export class QWorkOrderOperationParameter extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly WorkOperationTypeId = new QGuidPath(this.withPrefix("WorkOperationTypeId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly ERPConfirmationId = new QStringPath(this.withPrefix("ERPConfirmationId"));
    public readonly MaterialSpecificationIdList = new QCollectionPath(this.withPrefix("MaterialSpecificationIdList"), () => QGuidCollection);
    public readonly InspectionSpecificationIdList = new QCollectionPath(this.withPrefix("InspectionSpecificationIdList"), () => QGuidCollection);
    public readonly SetPointItemATNInstanceAssociationIdList = new QCollectionPath(this.withPrefix("SetPointItemATNInstanceAssociationIdList"), () => QGuidCollection);
    public readonly ToolSpecificationIdList = new QCollectionPath(this.withPrefix("ToolSpecificationIdList"), () => QGuidCollection);
}

export const qWorkOrderOperationParameter = new QWorkOrderOperationParameter();

export class QDisassembledMaterialItemParameterType extends QueryObject {
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly ProducedMaterialItemActualQuantity = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ToBeConsumedMaterial_Id = new QGuidPath(this.withPrefix("ToBeConsumedMaterial_Id"));
}

export const qDisassembledMaterialItemParameterType = new QDisassembledMaterialItemParameterType();

export class QStartWOStepFullQtyParameterType extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qStartWOStepFullQtyParameterType = new QStartWOStepFullQtyParameterType();

export class QWorkOStepDependencyParameter extends QueryObject {
    public readonly FromId = new QGuidPath(this.withPrefix("FromId"));
    public readonly ToId = new QGuidPath(this.withPrefix("ToId"));
    public readonly StepDependencyType = new QStringPath(this.withPrefix("StepDependencyType"));
}

export const qWorkOStepDependencyParameter = new QWorkOStepDependencyParameter();

export class QToBeUsedToolParameter extends QueryObject {
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
}

export const qToBeUsedToolParameter = new QToBeUsedToolParameter();

export class QTimesOfToolUsageParameterType extends QueryObject {
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly ToBeUsedToolId = new QGuidPath(this.withPrefix("ToBeUsedToolId"));
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly UsedTimes = new QNumberPath(this.withPrefix("UsedTimes"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qTimesOfToolUsageParameterType = new QTimesOfToolUsageParameterType();

export class QToolToBeUsedParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
}

export const qToolToBeUsedParameterType = new QToolToBeUsedParameterType();

export class QToolToBeUsedOnSNParameterType extends QueryObject {
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QToolToBeUsedParameterType);
}

export const qToolToBeUsedOnSNParameterType = new QToolToBeUsedOnSNParameterType();

export class QAMPowderBatchMixParameterType extends QueryObject {
    public readonly AMPowderBatchList = new QCollectionPath(this.withPrefix("AMPowderBatchList"), () => QGuidCollection);
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
}

export const qAMPowderBatchMixParameterType = new QAMPowderBatchMixParameterType();

export class QAMPowderBatchFakeParameterType extends QueryObject {
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
}

export const qAMPowderBatchFakeParameterType = new QAMPowderBatchFakeParameterType();

export class QChangeToolParameterType extends QueryObject {
    public readonly NewToolDefinitionName = new QStringPath(this.withPrefix("NewToolDefinitionName"));
    public readonly ChangeType = new QGuidPath(this.withPrefix("ChangeType"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly ToolUsageNumber = new QNumberPath(this.withPrefix("ToolUsageNumber"));
}

export const qChangeToolParameterType = new QChangeToolParameterType();

export class QToBeProducedIdAndOpId extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ToBeProducedMaterialIdList = new QCollectionPath(this.withPrefix("ToBeProducedMaterialIdList"), () => QGuidCollection);
}

export const qToBeProducedIdAndOpId = new QToBeProducedIdAndOpId();

export class QDM_MTUIdAndOpId extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MaterialTrackingUnitIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitIdList"), () => QGuidCollection);
}

export const qDM_MTUIdAndOpId = new QDM_MTUIdAndOpId();

export class QProducedMaterialItemParameterType extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qProducedMaterialItemParameterType = new QProducedMaterialItemParameterType();

export class QStartWOStepSerializedParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
}

export const qStartWOStepSerializedParameterType = new QStartWOStepSerializedParameterType();

export class QCompleteWOStepTransferBatchParameterType extends QueryObject {
    public readonly ActualProducedMaterialList = new QEntityCollectionPath(this.withPrefix("ActualProducedMaterialList"), () => QActualProducedMaterialTBParameterType);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qCompleteWOStepTransferBatchParameterType = new QCompleteWOStepTransferBatchParameterType();

export class QUserDetailsParameterType extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly IsUserPunchedIn = new QBooleanPath(this.withPrefix("IsUserPunchedIn"));
    public readonly IsUserEnabled = new QBooleanPath(this.withPrefix("IsUserEnabled"));
}

export const qUserDetailsParameterType = new QUserDetailsParameterType();

export class QMaterialItemWithHistoryParameterType extends QueryObject {
    public readonly WOHistoryMaterialItemId = new QGuidPath(this.withPrefix("WOHistoryMaterialItemId"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
}

export const qMaterialItemWithHistoryParameterType = new QMaterialItemWithHistoryParameterType();

export class QWOOpExecutionParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly WorkOrderOperationTargetQuantity = new QNumberPath(this.withPrefix("WorkOrderOperationTargetQuantity"));
    public readonly WOHistoryMatItemIdWithDM_MTUIdList = new QEntityCollectionPath(this.withPrefix("WOHistoryMatItemIdWithDM_MTUIdList"), () => QMaterialItemWithHistoryParameterType);
}

export const qWOOpExecutionParameterType = new QWOOpExecutionParameterType();

export class QNonConformanceGroupPathParameterType extends QueryObject {
    public readonly DefectNId = new QStringPath(this.withPrefix("DefectNId"));
    public readonly GroupPath = new QStringPath(this.withPrefix("GroupPath"));
    public readonly MeasureId = new QStringPath(this.withPrefix("MeasureId"));
}

export const qNonConformanceGroupPathParameterType = new QNonConformanceGroupPathParameterType();

export class QSubstratePropertiesParameterType extends QueryObject {
    public readonly CurrentThickness = new QNumberPath(this.withPrefix("CurrentThickness"));
    public readonly SubstrateThresholds = new QEntityPath(this.withPrefix("SubstrateThresholds"), () => QSubstrateDefinitionPropertiesParameterType);
    public readonly TreatmentCount = new QNumberPath(this.withPrefix("TreatmentCount"));
}

export const qSubstratePropertiesParameterType = new QSubstratePropertiesParameterType();

export class QMaterialToBeConsumed extends QueryObject {
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qMaterialToBeConsumed = new QMaterialToBeConsumed();

export class QWOHeaderParameterType extends QueryObject {
    public readonly BOPId = new QGuidPath(this.withPrefix("BOPId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ParentBatch = new QStringPath(this.withPrefix("ParentBatch"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
}

export const qWOHeaderParameterType = new QWOHeaderParameterType();

export class QExecutionGroupParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qExecutionGroupParameterType = new QExecutionGroupParameterType();

export class QCompleteWOStepFullQtyParameterType extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
}

export const qCompleteWOStepFullQtyParameterType = new QCompleteWOStepFullQtyParameterType();

export class QRuntimeCharReprRefOpAssParameterType extends QueryObject {
    public readonly RuntimeCharacteristicRepresentationNId = new QStringPath(this.withPrefix("RuntimeCharacteristicRepresentationNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ToBeUsedInspectionId = new QGuidPath(this.withPrefix("ToBeUsedInspectionId"));
    public readonly ProcessToOperationLinkUId = new QStringPath(this.withPrefix("ProcessToOperationLinkUId"));
}

export const qRuntimeCharReprRefOpAssParameterType = new QRuntimeCharReprRefOpAssParameterType();

export class QCheckCertificationMultiMachineParameterType extends QueryObject {
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qCheckCertificationMultiMachineParameterType = new QCheckCertificationMultiMachineParameterType();

export class QActiveUserOnMachineParameterType extends QueryObject {
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WoStepId = new QGuidPath(this.withPrefix("WoStepId"));
}

export const qActiveUserOnMachineParameterType = new QActiveUserOnMachineParameterType();

export class QAsPlannedWorkOrder extends QueryObject {
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
}

export const qAsPlannedWorkOrder = new QAsPlannedWorkOrder();

export class QMaterialItemToReserveParamerType extends QueryObject {
    public readonly MaterialDefinition = new QGuidPath(this.withPrefix("MaterialDefinition"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SerialNumberCode = new QStringPath(this.withPrefix("SerialNumberCode"));
    public readonly ToBeConsumedMaterialName = new QStringPath(this.withPrefix("ToBeConsumedMaterialName"));
    public readonly ToBeConsumedMaterialSequence = new QNumberPath(this.withPrefix("ToBeConsumedMaterialSequence"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly PreKitBatchCode = new QStringPath(this.withPrefix("PreKitBatchCode"));
    public readonly ToBeConsumedMaterialPrekitId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialPrekitId"));
    public readonly ToBeValidated = new QBooleanPath(this.withPrefix("ToBeValidated"));
}

export const qMaterialItemToReserveParamerType = new QMaterialItemToReserveParamerType();

export class QOperationMaterialParameterType extends QueryObject {
    public readonly WorkOperationMaterialList = new QCollectionPath(this.withPrefix("WorkOperationMaterialList"), () => QGuidCollection);
    public readonly WorkOperationId = new QGuidPath(this.withPrefix("WorkOperationId"));
}

export const qOperationMaterialParameterType = new QOperationMaterialParameterType();

export class QStartExecutionGroupParameteType extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OperationMaterialParameterType = new QEntityCollectionPath(this.withPrefix("OperationMaterialParameterType"), () => QOperationMaterialParameterType);
}

export const qStartExecutionGroupParameteType = new QStartExecutionGroupParameteType();

export class QCharacteristicRepresentationType extends QueryObject {
    public readonly CharacteristicRepresentationRevision = new QStringPath(this.withPrefix("CharacteristicRepresentationRevision"));
    public readonly CharacteristicRepresentationId = new QGuidPath(this.withPrefix("CharacteristicRepresentationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qCharacteristicRepresentationType = new QCharacteristicRepresentationType();

export class QToBeDisassembledFromParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly TargetDM_MTUId = new QGuidPath(this.withPrefix("TargetDM_MTUId"));
}

export const qToBeDisassembledFromParameterType = new QToBeDisassembledFromParameterType();

export class QToBeCoProducedMaterialParameterType extends QueryObject {
    public readonly ToBeCoProducedMaterialNId = new QStringPath(this.withPrefix("ToBeCoProducedMaterialNId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ToBeDisassembledFromList = new QEntityCollectionPath(this.withPrefix("ToBeDisassembledFromList"), () => QToBeDisassembledFromParameterType);
    public readonly MaterialSpecificationNId = new QStringPath(this.withPrefix("MaterialSpecificationNId"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly ToBeCoProducedMaterialId = new QGuidPath(this.withPrefix("ToBeCoProducedMaterialId"));
}

export const qToBeCoProducedMaterialParameterType = new QToBeCoProducedMaterialParameterType();

export class QStartWOStepTransferBatchParameterType extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ElectronicSignatureId = new QGuidPath(this.withPrefix("ElectronicSignatureId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qStartWOStepTransferBatchParameterType = new QStartWOStepTransferBatchParameterType();

export class QUsedToolParameterType extends QueryObject {
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly ToolHistoryId = new QNumberPath(this.withPrefix("ToolHistoryId"));
    public readonly EquipmentId = new QNumberPath(this.withPrefix("EquipmentId"));
    public readonly MaterialItemId = new QNumberPath(this.withPrefix("MaterialItemId"));
}

export const qUsedToolParameterType = new QUsedToolParameterType();

export class QProducedMaterialItemQuantity extends QueryObject {
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qProducedMaterialItemQuantity = new QProducedMaterialItemQuantity();

export class QUpdateSerialNumberParameterType extends QueryObject {
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly NewSerialNumberCode = new QStringPath(this.withPrefix("NewSerialNumberCode"));
}

export const qUpdateSerialNumberParameterType = new QUpdateSerialNumberParameterType();

export class QMaterialItemUnderReworkParameterType extends QueryObject {
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly MaterialItemStatusOnWOOp = new QStringPath(this.withPrefix("MaterialItemStatusOnWOOp"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly PartialQuantity = new QNumberPath(this.withPrefix("PartialQuantity"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
}

export const qMaterialItemUnderReworkParameterType = new QMaterialItemUnderReworkParameterType();

export class QToBeConsumedMaterialInfo extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
}

export const qToBeConsumedMaterialInfo = new QToBeConsumedMaterialInfo();

export class QWorkOrderOperationAndMTUsToSkipType extends QueryObject {
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
}

export const qWorkOrderOperationAndMTUsToSkipType = new QWorkOrderOperationAndMTUsToSkipType();

export class QCheckCertificationParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qCheckCertificationParameterType = new QCheckCertificationParameterType();

export class QWorkOrderOperationPairParameterType extends QueryObject {
    public readonly NewWorkOrderOperationId = new QGuidPath(this.withPrefix("NewWorkOrderOperationId"));
    public readonly SplittedWorkOrderOperationId = new QGuidPath(this.withPrefix("SplittedWorkOrderOperationId"));
    public readonly ClonedToBeProducedDM_MtuIds = new QCollectionPath(this.withPrefix("ClonedToBeProducedDM_MtuIds"), () => QGuidCollection);
}

export const qWorkOrderOperationPairParameterType = new QWorkOrderOperationPairParameterType();

export class QExecutionGroupPhaseParameterType extends QueryObject {
    public readonly ExecutionGroupPhaseNId = new QStringPath(this.withPrefix("ExecutionGroupPhaseNId"));
    public readonly ExecutionGroupPhaseSequence = new QNumberPath(this.withPrefix("ExecutionGroupPhaseSequence"));
    public readonly WorkOrderOperationIds = new QCollectionPath(this.withPrefix("WorkOrderOperationIds"), () => QGuidCollection);
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly PreviousExecutionGroupPhaseNId = new QStringPath(this.withPrefix("PreviousExecutionGroupPhaseNId"));
}

export const qExecutionGroupPhaseParameterType = new QExecutionGroupPhaseParameterType();

export class QGetValidMachineWOOpIdsParameterType extends QueryObject {
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly WOOperationNId = new QStringPath(this.withPrefix("WOOperationNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qGetValidMachineWOOpIdsParameterType = new QGetValidMachineWOOpIdsParameterType();

export class QDM_MaterialTrackingUnitIdentifierParameterType extends QueryObject {
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
}

export const qDM_MaterialTrackingUnitIdentifierParameterType = new QDM_MaterialTrackingUnitIdentifierParameterType();

export class QCompleteWOStepSerializedParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qCompleteWOStepSerializedParameterType = new QCompleteWOStepSerializedParameterType();

export class QWorkOrderToBeGrouped extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qWorkOrderToBeGrouped = new QWorkOrderToBeGrouped();

export class QWoTypeAndEgNId extends QueryObject {
    public readonly WorkOperationTypeNId = new QStringPath(this.withPrefix("WorkOperationTypeNId"));
    public readonly ExecutionGroupNId = new QStringPath(this.withPrefix("ExecutionGroupNId"));
}

export const qWoTypeAndEgNId = new QWoTypeAndEgNId();

export class QWorkInstructionRuntimeValueParameterType extends QueryObject {
    public readonly ParameterName = new QStringPath(this.withPrefix("ParameterName"));
    public readonly Sequence = new QStringPath(this.withPrefix("Sequence"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
}

export const qWorkInstructionRuntimeValueParameterType = new QWorkInstructionRuntimeValueParameterType();

export class QPLMMasterPlanParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly RootProcessUID = new QStringPath(this.withPrefix("RootProcessUID"));
}

export const qPLMMasterPlanParameterType = new QPLMMasterPlanParameterType();

export class QPLMOperationParameterType extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly FinalMaterialUID = new QStringPath(this.withPrefix("FinalMaterialUID"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly WorkOperationTypeNId = new QStringPath(this.withPrefix("WorkOperationTypeNId"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly OperationCategory = new QStringPath(this.withPrefix("OperationCategory"));
}

export const qPLMOperationParameterType = new QPLMOperationParameterType();

export class QPLMProcessParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly MaxQuantity = new QNumberPath(this.withPrefix("MaxQuantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly FinalMaterialUID = new QStringPath(this.withPrefix("FinalMaterialUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qPLMProcessParameterType = new QPLMProcessParameterType();

export class QPLMDocumentParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly FileLink = new QStringPath(this.withPrefix("FileLink"));
    public readonly FileBlob = new QBinaryPath(this.withPrefix("FileBlob"));
}

export const qPLMDocumentParameterType = new QPLMDocumentParameterType();

export class QPLMMaterialDefinitionParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UOM = new QStringPath(this.withPrefix("UOM"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Lot = new QBooleanPath(this.withPrefix("Lot"));
    public readonly Rotable = new QBooleanPath(this.withPrefix("Rotable"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly PreserveQuantity = new QBooleanPath(this.withPrefix("PreserveQuantity"));
    public readonly LifeLimited = new QBooleanPath(this.withPrefix("LifeLimited"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qPLMMaterialDefinitionParameterType = new QPLMMaterialDefinitionParameterType();

export class QPLMToolDefinitionParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qPLMToolDefinitionParameterType = new QPLMToolDefinitionParameterType();

export class QPLMStepParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly StepCategory = new QStringPath(this.withPrefix("StepCategory"));
}

export const qPLMStepParameterType = new QPLMStepParameterType();

export class QPLMDocumentAssociationParameterType extends QueryObject {
    public readonly DocumentUID = new QStringPath(this.withPrefix("DocumentUID"));
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
}

export const qPLMDocumentAssociationParameterType = new QPLMDocumentAssociationParameterType();

export class QPLMAsPlannedBoPParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly RootProcessUID = new QStringPath(this.withPrefix("RootProcessUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qPLMAsPlannedBoPParameterType = new QPLMAsPlannedBoPParameterType();

export class QPLMLinkParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly ParentUID = new QStringPath(this.withPrefix("ParentUID"));
    public readonly ChildUID = new QStringPath(this.withPrefix("ChildUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
}

export const qPLMLinkParameterType = new QPLMLinkParameterType();

export class QPLMMaterialSpecificationParameterType extends QueryObject {
    public readonly MaterialDefinitionUID = new QStringPath(this.withPrefix("MaterialDefinitionUID"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly MaterialSpecificationTypeNId = new QStringPath(this.withPrefix("MaterialSpecificationTypeNId"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
}

export const qPLMMaterialSpecificationParameterType = new QPLMMaterialSpecificationParameterType();

export class QPLMToolSpecificationParameterType extends QueryObject {
    public readonly ToolDefinitionUID = new QStringPath(this.withPrefix("ToolDefinitionUID"));
    public readonly UsageNumber = new QNumberPath(this.withPrefix("UsageNumber"));
    public readonly UsageDuration = new QNumberPath(this.withPrefix("UsageDuration"));
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
}

export const qPLMToolSpecificationParameterType = new QPLMToolSpecificationParameterType();

export class QPLMStepDependencyParameterType extends QueryObject {
    public readonly OperationToStepLinkFromUID = new QStringPath(this.withPrefix("OperationToStepLinkFromUID"));
    public readonly OperationToStepLinkToUID = new QStringPath(this.withPrefix("OperationToStepLinkToUID"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
}

export const qPLMStepDependencyParameterType = new QPLMStepDependencyParameterType();

export class QPLMEquipmentSpecLocationParameterType extends QueryObject {
    public readonly LocationId = new QStringPath(this.withPrefix("LocationId"));
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
}

export const qPLMEquipmentSpecLocationParameterType = new QPLMEquipmentSpecLocationParameterType();

export class QPLMOpDependencyParameterType extends QueryObject {
    public readonly ProcessToOperationLinkFromUID = new QStringPath(this.withPrefix("ProcessToOperationLinkFromUID"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly ProcessToOperationLinkToUID = new QStringPath(this.withPrefix("ProcessToOperationLinkToUID"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
}

export const qPLMOpDependencyParameterType = new QPLMOpDependencyParameterType();

export class QPLMDCDParameterType extends QueryObject {
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly DimensionType = new QStringPath(this.withPrefix("DimensionType"));
    public readonly NominalValue = new QNumberPath(this.withPrefix("NominalValue"));
    public readonly UpperLimit = new QNumberPath(this.withPrefix("UpperLimit"));
    public readonly LowerLimit = new QNumberPath(this.withPrefix("LowerLimit"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly InspectionType = new QStringPath(this.withPrefix("InspectionType"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly IsOptional = new QBooleanPath(this.withPrefix("IsOptional"));
    public readonly Placeholder = new QStringPath(this.withPrefix("Placeholder"));
    public readonly DateTimeFormat = new QStringPath(this.withPrefix("DateTimeFormat"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly NumberOfDecimalPlaces = new QNumberPath(this.withPrefix("NumberOfDecimalPlaces"));
    public readonly StringFormat = new QStringPath(this.withPrefix("StringFormat"));
    public readonly MaximumLength = new QNumberPath(this.withPrefix("MaximumLength"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly AssociationType = new QStringPath(this.withPrefix("AssociationType"));
    public readonly AlertMinLimit = new QNumberPath(this.withPrefix("AlertMinLimit"));
    public readonly AlertMaxLimit = new QNumberPath(this.withPrefix("AlertMaxLimit"));
    public readonly CautionMinLimit = new QNumberPath(this.withPrefix("CautionMinLimit"));
    public readonly CautionMaxLimit = new QNumberPath(this.withPrefix("CautionMaxLimit"));
    public readonly OutOfRangeBehavior = new QStringPath(this.withPrefix("OutOfRangeBehavior"));
    public readonly DataAcquisitionMethod = new QStringPath(this.withPrefix("DataAcquisitionMethod"));
}

export const qPLMDCDParameterType = new QPLMDCDParameterType();

export class QToolToBeUsedInfoParameterType extends QueryObject {
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly UsageDuration = new QNumberPath(this.withPrefix("UsageDuration"));
}

export const qToolToBeUsedInfoParameterType = new QToolToBeUsedInfoParameterType();

export class QMaterialItemToolToBeUsedInfo extends QueryObject {
    public readonly SN = new QStringPath(this.withPrefix("SN"));
    public readonly Tools = new QEntityCollectionPath(this.withPrefix("Tools"), () => QToolToBeUsedInfoParameterType);
}

export const qMaterialItemToolToBeUsedInfo = new QMaterialItemToolToBeUsedInfo();

export class QPLMCertificationWithSkillParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SkillList = new QCollectionPath(this.withPrefix("SkillList"), () => QStringCollection);
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
}

export const qPLMCertificationWithSkillParameterType = new QPLMCertificationWithSkillParameterType();

export class QPLMHRSpecificationParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPUID = new QStringPath(this.withPrefix("AsPlannedBOPUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
}

export const qPLMHRSpecificationParameterType = new QPLMHRSpecificationParameterType();

export class QPLMMaterialTrackingUnitParameterType extends QueryObject {
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly Weigth = new QEntityPath(this.withPrefix("Weigth"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly ActiveNonConformanceNumber = new QNumberPath(this.withPrefix("ActiveNonConformanceNumber"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
}

export const qPLMMaterialTrackingUnitParameterType = new QPLMMaterialTrackingUnitParameterType();

export class QPLMChangeStatusEventLogParameterType extends QueryObject {
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly TransitionVerb = new QStringPath(this.withPrefix("TransitionVerb"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
}

export const qPLMChangeStatusEventLogParameterType = new QPLMChangeStatusEventLogParameterType();

export class QPLMDCDStepItemParameterType extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly DimensionType = new QStringPath(this.withPrefix("DimensionType"));
    public readonly NominalValue = new QNumberPath(this.withPrefix("NominalValue"));
    public readonly UpperLimit = new QNumberPath(this.withPrefix("UpperLimit"));
    public readonly LowerLimit = new QNumberPath(this.withPrefix("LowerLimit"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly InspectionType = new QStringPath(this.withPrefix("InspectionType"));
    public readonly MaximumLength = new QNumberPath(this.withPrefix("MaximumLength"));
    public readonly NumberOfDecimalPlaces = new QNumberPath(this.withPrefix("NumberOfDecimalPlaces"));
    public readonly StringFormat = new QStringPath(this.withPrefix("StringFormat"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly IsOptional = new QBooleanPath(this.withPrefix("IsOptional"));
    public readonly Placeholder = new QStringPath(this.withPrefix("Placeholder"));
    public readonly DateTimeFormat = new QStringPath(this.withPrefix("DateTimeFormat"));
    public readonly AlertMinLimit = new QNumberPath(this.withPrefix("AlertMinLimit"));
    public readonly AlertMaxLimit = new QNumberPath(this.withPrefix("AlertMaxLimit"));
    public readonly CautionMinLimit = new QNumberPath(this.withPrefix("CautionMinLimit"));
    public readonly CautionMaxLimit = new QNumberPath(this.withPrefix("CautionMaxLimit"));
    public readonly OutOfRangeBehavior = new QStringPath(this.withPrefix("OutOfRangeBehavior"));
    public readonly DataAcquisitionMethod = new QStringPath(this.withPrefix("DataAcquisitionMethod"));
}

export const qPLMDCDStepItemParameterType = new QPLMDCDStepItemParameterType();

export class QPLMDCDWIParameterType extends QueryObject {
    public readonly Instructions = new QStringPath(this.withPrefix("Instructions"));
    public readonly DCDList = new QEntityCollectionPath(this.withPrefix("DCDList"), () => QPLMDCDStepItemParameterType);
}

export const qPLMDCDWIParameterType = new QPLMDCDWIParameterType();

export class QSvgIcon extends QueryObject {
    public readonly path = new QStringPath(this.withPrefix("path"));
    public readonly size = new QStringPath(this.withPrefix("size"));
}

export const qSvgIcon = new QSvgIcon();

export class QSkillParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qSkillParameterType = new QSkillParameterType();

export class QSignerParameterType extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly SignerRequired = new QStringPath(this.withPrefix("SignerRequired"));
}

export const qSignerParameterType = new QSignerParameterType();

export class QMaterialQuantityList extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qMaterialQuantityList = new QMaterialQuantityList();

export class QStateMachineStatusNIdParameterType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qStateMachineStatusNIdParameterType = new QStateMachineStatusNIdParameterType();

export class QMTUGenealogyType extends QueryObject {
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QStringPath(this.withPrefix("CodeType"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly MaterialLot_Id = new QGuidPath(this.withPrefix("MaterialLot_Id"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStateMachineStatusNIdParameterType);
}

export const qMTUGenealogyType = new QMTUGenealogyType();

export class QDM_MTUGenealogyType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DM_MaterialId_Id = new QGuidPath(this.withPrefix("DM_MaterialId_Id"));
    public readonly MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("MaterialTrackingUnit_Id"));
    public readonly ParentDM_MTU_Id = new QGuidPath(this.withPrefix("ParentDM_MTU_Id"));
    public readonly MaterialTrackingUnit = new QEntityPath(this.withPrefix("MaterialTrackingUnit"), () => QMTUGenealogyType);
}

export const qDM_MTUGenealogyType = new QDM_MTUGenealogyType();

export class QProducedMTUGenealogyType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MTUGenealogyType);
}

export const qProducedMTUGenealogyType = new QProducedMTUGenealogyType();

export class QToBeConsumedMaterialGenealogyType extends QueryObject {
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly MaterialDefinition_Id = new QGuidPath(this.withPrefix("MaterialDefinition_Id"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly PrekitSerialNumber = new QStringPath(this.withPrefix("PrekitSerialNumber"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
}

export const qToBeConsumedMaterialGenealogyType = new QToBeConsumedMaterialGenealogyType();

export class QUserFieldNIdValueParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UserFieldValue = new QStringPath(this.withPrefix("UserFieldValue"));
}

export const qUserFieldNIdValueParameterType = new QUserFieldNIdValueParameterType();

export class QTaskContextParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly UserFields = new QEntityCollectionPath(this.withPrefix("UserFields"), () => QUserFieldNIdValueParameterType);
}

export const qTaskContextParameterType = new QTaskContextParameterType();

export class QScrewingDetailsParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly AngleValueMax = new QNumberPath(this.withPrefix("AngleValueMax"));
    public readonly AngleValueMin = new QNumberPath(this.withPrefix("AngleValueMin"));
    public readonly TorqueValueMax = new QNumberPath(this.withPrefix("TorqueValueMax"));
    public readonly TorqueValueMin = new QNumberPath(this.withPrefix("TorqueValueMin"));
    public readonly BoltsNumber = new QNumberPath(this.withPrefix("BoltsNumber"));
    public readonly OkBoltsNumber = new QNumberPath(this.withPrefix("OkBoltsNumber"));
    public readonly NokBoltsNumber = new QNumberPath(this.withPrefix("NokBoltsNumber"));
    public readonly MissingBoltsNumber = new QNumberPath(this.withPrefix("MissingBoltsNumber"));
    public readonly IsActive = new QBooleanPath(this.withPrefix("IsActive"));
    public readonly ToBeUsedToolId = new QGuidPath(this.withPrefix("ToBeUsedToolId"));
}

export const qScrewingDetailsParameterType = new QScrewingDetailsParameterType();

export class QScrewingDataParameterType extends QueryObject {
    public readonly Angle = new QNumberPath(this.withPrefix("Angle"));
    public readonly Torque = new QNumberPath(this.withPrefix("Torque"));
    public readonly BoltItemNumber = new QNumberPath(this.withPrefix("BoltItemNumber"));
    public readonly IsOk = new QBooleanPath(this.withPrefix("IsOk"));
}

export const qScrewingDataParameterType = new QScrewingDataParameterType();

export class QProcessMachinesParameterType extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly EquipmentSpecificationId = new QGuidPath(this.withPrefix("EquipmentSpecificationId"));
    public readonly AssociatedPrintJobFileId = new QGuidPath(this.withPrefix("AssociatedPrintJobFileId"));
    public readonly AssociatedPrintJobFileNId = new QStringPath(this.withPrefix("AssociatedPrintJobFileNId"));
    public readonly AssociatedPartProgramId = new QGuidPath(this.withPrefix("AssociatedPartProgramId"));
    public readonly AssociatedPartProgramNId = new QStringPath(this.withPrefix("AssociatedPartProgramNId"));
    public readonly IsWorkOperationAM = new QBooleanPath(this.withPrefix("IsWorkOperationAM"));
    public readonly IsWorkOperationCNC = new QBooleanPath(this.withPrefix("IsWorkOperationCNC"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qProcessMachinesParameterType = new QProcessMachinesParameterType();

export class QToolCompatibleMachineParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly Level = new QStringPath(this.withPrefix("Level"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly CompleteByDifferentUser = new QBooleanPath(this.withPrefix("CompleteByDifferentUser"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly IsActive = new QBooleanPath(this.withPrefix("IsActive"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qToolCompatibleMachineParameterType = new QToolCompatibleMachineParameterType();

export class QRF_ToolDefinitionCompatibleMachineParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly ToolDefinitionNId = new QStringPath(this.withPrefix("ToolDefinitionNId"));
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly LevelName = new QStringPath(this.withPrefix("LevelName"));
    public readonly EquipmentConfigurationName = new QStringPath(this.withPrefix("EquipmentConfigurationName"));
}

export const qRF_ToolDefinitionCompatibleMachineParameterType = new QRF_ToolDefinitionCompatibleMachineParameterType();

export class QUADMMaterialParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Volume = new QNumberPath(this.withPrefix("Volume"));
    public readonly VolumeUoMNId = new QStringPath(this.withPrefix("VolumeUoMNId"));
    public readonly Weight = new QNumberPath(this.withPrefix("Weight"));
    public readonly WeightUoMNId = new QStringPath(this.withPrefix("WeightUoMNId"));
}

export const qUADMMaterialParameterType = new QUADMMaterialParameterType();

export class QUADMEquipmentSpecificationParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly IsScrapped = new QBooleanPath(this.withPrefix("IsScrapped"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EnabledForCompleteByDifferentUser = new QBooleanPath(this.withPrefix("EnabledForCompleteByDifferentUser"));
    public readonly IsActive = new QBooleanPath(this.withPrefix("IsActive"));
}

export const qUADMEquipmentSpecificationParameterType = new QUADMEquipmentSpecificationParameterType();

export class QQualityInspectionDataType extends QueryObject {
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly MeasuredAttributiveValue = new QBooleanPath(this.withPrefix("MeasuredAttributiveValue"));
    public readonly MeasuredVariableValue = new QNumberPath(this.withPrefix("MeasuredVariableValue"));
    public readonly VisualFailureNId = new QStringPath(this.withPrefix("VisualFailureNId"));
    public readonly VisualFailureCount = new QNumberPath(this.withPrefix("VisualFailureCount"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly AnyViolation = new QBooleanPath(this.withPrefix("AnyViolation"));
    public readonly CharacteristicRepresentationNId = new QStringPath(this.withPrefix("CharacteristicRepresentationNId"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly InspectionValue_Id = new QGuidPath(this.withPrefix("InspectionValue_Id"));
}

export const qQualityInspectionDataType = new QQualityInspectionDataType();

export class QEquipment3DPrinterParameterType extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly ExternalEquipmentNId = new QStringPath(this.withPrefix("ExternalEquipmentNId"));
    public readonly TransferPlugIn = new QStringPath(this.withPrefix("TransferPlugIn"));
}

export const qEquipment3DPrinterParameterType = new QEquipment3DPrinterParameterType();

export class QAutomationNodeTypeParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qAutomationNodeTypeParameterType = new QAutomationNodeTypeParameterType();

export class QAutomationNodeInstanceParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qAutomationNodeInstanceParameterType = new QAutomationNodeInstanceParameterType();

export class QPrintJobFileWorkOrderParameterType extends QueryObject {
    public readonly WorkOrder = new QStringPath(this.withPrefix("WorkOrder"));
    public readonly OperationName = new QStringPath(this.withPrefix("OperationName"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly MachineUsed = new QStringPath(this.withPrefix("MachineUsed"));
    public readonly ActionId = new QStringPath(this.withPrefix("ActionId"));
    public readonly PJFTransferDate = new QDateTimeOffsetPath(this.withPrefix("PJFTransferDate"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly WorkOrderStatus = new QStringPath(this.withPrefix("WorkOrderStatus"));
    public readonly WorkOrderOperationStatus = new QStringPath(this.withPrefix("WorkOrderOperationStatus"));
}

export const qPrintJobFileWorkOrderParameterType = new QPrintJobFileWorkOrderParameterType();

export class QQuantityParameterType extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly QuantityValue = new QNumberPath(this.withPrefix("QuantityValue"));
}

export const qQuantityParameterType = new QQuantityParameterType();

export class QBaseUoMParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qBaseUoMParameterType = new QBaseUoMParameterType();

export class QPropertyParameterTypeCreate extends QueryObject {
    public readonly PropertyNId = new QStringPath(this.withPrefix("PropertyNId"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyUoMNId = new QStringPath(this.withPrefix("PropertyUoMNId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
}

export const qPropertyParameterTypeCreate = new QPropertyParameterTypeCreate();

export class QParameterValueParameterType extends QueryObject {
    public readonly ParameterNId = new QStringPath(this.withPrefix("ParameterNId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qParameterValueParameterType = new QParameterValueParameterType();

export class QStatusParameterType extends QueryObject {
    public readonly StatusDefinitionId = new QGuidPath(this.withPrefix("StatusDefinitionId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qStatusParameterType = new QStatusParameterType();

export class QStatusTypeParameterType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
}

export const qStatusTypeParameterType = new QStatusTypeParameterType();

export class QMultipleOrSubmultipleUoMParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly K0Multiplier = new QNumberPath(this.withPrefix("K0Multiplier"));
    public readonly K1Multiplier = new QNumberPath(this.withPrefix("K1Multiplier"));
    public readonly Addend = new QNumberPath(this.withPrefix("Addend"));
    public readonly Exponent = new QNumberPath(this.withPrefix("Exponent"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qMultipleOrSubmultipleUoMParameterType = new QMultipleOrSubmultipleUoMParameterType();

export class QPJFParameterType extends QueryObject {
    public readonly BuildtrayLayout = new QStringPath(this.withPrefix("BuildtrayLayout"));
    public readonly EstimatedBuildProcessDuration = new QStringPath(this.withPrefix("EstimatedBuildProcessDuration"));
    public readonly EstimatedMaterialConsumption = new QEntityPath(this.withPrefix("EstimatedMaterialConsumption"), () => QQuantityParameterType);
    public readonly EstimatedPrintDuration = new QStringPath(this.withPrefix("EstimatedPrintDuration"));
    public readonly ExternalId = new QStringPath(this.withPrefix("ExternalId"));
    public readonly MaxProducedHeight = new QEntityPath(this.withPrefix("MaxProducedHeight"), () => QQuantityParameterType);
    public readonly ProductSerializable = new QBooleanPath(this.withPrefix("ProductSerializable"));
    public readonly RunTimeOnly = new QBooleanPath(this.withPrefix("RunTimeOnly"));
    public readonly Source = new QStringPath(this.withPrefix("Source"));
    public readonly TestBars = new QBooleanPath(this.withPrefix("TestBars"));
    public readonly TestBarsSerializable = new QBooleanPath(this.withPrefix("TestBarsSerializable"));
    public readonly TestBarsNumber = new QNumberPath(this.withPrefix("TestBarsNumber"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly ProductSerialNumberManagement = new QEnumPath(this.withPrefix("ProductSerialNumberManagement"), AMSerialNumberManagement);
    public readonly TestBarsSerialNumberManagement = new QEnumPath(this.withPrefix("TestBarsSerialNumberManagement"), AMSerialNumberManagement);
    public readonly PrinterTypeList = new QCollectionPath(this.withPrefix("PrinterTypeList"), () => QStringCollection);
    public readonly ProductionPrinter = new QStringPath(this.withPrefix("ProductionPrinter"));
    public readonly ParentPJF = new QGuidPath(this.withPrefix("ParentPJF"));
}

export const qPJFParameterType = new QPJFParameterType();

export class QLink3DPrinterparameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ExternalEquipmentNId = new QStringPath(this.withPrefix("ExternalEquipmentNId"));
    public readonly TransferPlugIn = new QStringPath(this.withPrefix("TransferPlugIn"));
}

export const qLink3DPrinterparameterType = new QLink3DPrinterparameterType();

export class QPrinterParameterType extends QueryObject {
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly TransferPlugin = new QStringPath(this.withPrefix("TransferPlugin"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
}

export const qPrinterParameterType = new QPrinterParameterType();

export class QEquipmentSpecificationParameterType extends QueryObject {
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly OperationID = new QGuidPath(this.withPrefix("OperationID"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qEquipmentSpecificationParameterType = new QEquipmentSpecificationParameterType();

export class QTCM2ResourceDefinitionParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
}

export const qTCM2ResourceDefinitionParameterType = new QTCM2ResourceDefinitionParameterType();

export class QTCM2LinkParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly AsPlannedBopUID = new QStringPath(this.withPrefix("AsPlannedBopUID"));
    public readonly ParentUID = new QStringPath(this.withPrefix("ParentUID"));
    public readonly ChildUID = new QStringPath(this.withPrefix("ChildUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly EWIStepURL = new QStringPath(this.withPrefix("EWIStepURL"));
}

export const qTCM2LinkParameterType = new QTCM2LinkParameterType();

export class QOperationParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly WorkOperationId = new QGuidPath(this.withPrefix("WorkOperationId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RevisionEffectivityExpression = new QStringPath(this.withPrefix("RevisionEffectivityExpression"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
}

export const qOperationParameterType = new QOperationParameterType();

export class QMaterialSpecificationParameterType extends QueryObject {
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly MaterialSpecificationTypeId = new QGuidPath(this.withPrefix("MaterialSpecificationTypeId"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly FunctionalCodeNId = new QStringPath(this.withPrefix("FunctionalCodeNId"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
}

export const qMaterialSpecificationParameterType = new QMaterialSpecificationParameterType();

export class QTCM2MaterialSpecificationParameterType extends QueryObject {
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBopUID = new QStringPath(this.withPrefix("AsPlannedBopUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly MaterialSpecificationTypeId = new QGuidPath(this.withPrefix("MaterialSpecificationTypeId"));
    public readonly DMMaterialId = new QGuidPath(this.withPrefix("DMMaterialId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
}

export const qTCM2MaterialSpecificationParameterType = new QTCM2MaterialSpecificationParameterType();

export class QDocumentFromFileParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
}

export const qDocumentFromFileParameterType = new QDocumentFromFileParameterType();

export class QTCM2ToolSpecificationParameterType extends QueryObject {
    public readonly UsageNumber = new QNumberPath(this.withPrefix("UsageNumber"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBopUID = new QStringPath(this.withPrefix("AsPlannedBopUID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
}

export const qTCM2ToolSpecificationParameterType = new QTCM2ToolSpecificationParameterType();

export class QTCM2StepDependencyParameterType extends QueryObject {
    public readonly OperationToStepLinkFromUID = new QStringPath(this.withPrefix("OperationToStepLinkFromUID"));
    public readonly OperationToStepLinkToUID = new QStringPath(this.withPrefix("OperationToStepLinkToUID"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly AsPlannedBopUID = new QStringPath(this.withPrefix("AsPlannedBopUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
}

export const qTCM2StepDependencyParameterType = new QTCM2StepDependencyParameterType();

export class QTCM2DocumentAssociationParameterType extends QueryObject {
    public readonly DocumentUID = new QStringPath(this.withPrefix("DocumentUID"));
    public readonly ReferencedEntityUID = new QStringPath(this.withPrefix("ReferencedEntityUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
}

export const qTCM2DocumentAssociationParameterType = new QTCM2DocumentAssociationParameterType();

export class QDependencyNavigationParameterType extends QueryObject {
    public readonly OperationDependencyId = new QGuidPath(this.withPrefix("OperationDependencyId"));
    public readonly IsPreferred = new QBooleanPath(this.withPrefix("IsPreferred"));
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
}

export const qDependencyNavigationParameterType = new QDependencyNavigationParameterType();

export class QDocumentParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly File = new QBinaryPath(this.withPrefix("File"));
}

export const qDocumentParameterType = new QDocumentParameterType();

export class QProcessDefinitionIdentifierParameterType extends QueryObject {
    public readonly ProcessDefinitionRevision = new QStringPath(this.withPrefix("ProcessDefinitionRevision"));
    public readonly ProcessDefinitionNId = new QStringPath(this.withPrefix("ProcessDefinitionNId"));
}

export const qProcessDefinitionIdentifierParameterType = new QProcessDefinitionIdentifierParameterType();

export class QTCM2OpDependencyParameterType extends QueryObject {
    public readonly ProcessToOperationLinkFromUID = new QStringPath(this.withPrefix("ProcessToOperationLinkFromUID"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly ProcessToOperationLinkToUID = new QStringPath(this.withPrefix("ProcessToOperationLinkToUID"));
    public readonly AsPlannedBopUID = new QStringPath(this.withPrefix("AsPlannedBopUID"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
}

export const qTCM2OpDependencyParameterType = new QTCM2OpDependencyParameterType();

export class QStepDependencyParameterType extends QueryObject {
    public readonly FromStepId = new QGuidPath(this.withPrefix("FromStepId"));
    public readonly ToStepId = new QGuidPath(this.withPrefix("ToStepId"));
}

export const qStepDependencyParameterType = new QStepDependencyParameterType();

export class QTCM2OperationParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly WorkOperationTypeNId = new QStringPath(this.withPrefix("WorkOperationTypeNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
}

export const qTCM2OperationParameterType = new QTCM2OperationParameterType();

export class QOperationStepCategoryType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qOperationStepCategoryType = new QOperationStepCategoryType();

export class QStepCatalogueParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
}

export const qStepCatalogueParameterType = new QStepCatalogueParameterType();

export class QProcessParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ParentProcessId = new QGuidPath(this.withPrefix("ParentProcessId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MaxQuantity = new QEntityPath(this.withPrefix("MaxQuantity"), () => QQuantityParameterType);
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityParameterType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly RevisionEffectivityExpression = new QStringPath(this.withPrefix("RevisionEffectivityExpression"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qProcessParameterType = new QProcessParameterType();

export class QToolDefinitionDocumentParameterType extends QueryObject {
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qToolDefinitionDocumentParameterType = new QToolDefinitionDocumentParameterType();

export class QProcessInfoParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
}

export const qProcessInfoParameterType = new QProcessInfoParameterType();

export class QTCM2EquipmentSpecificationParameterType extends QueryObject {
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPUId = new QStringPath(this.withPrefix("AsPlannedBOPUId"));
    public readonly MasterPlanUId = new QStringPath(this.withPrefix("MasterPlanUId"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly ReferencedOperationUID = new QStringPath(this.withPrefix("ReferencedOperationUID"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly OperationUID = new QStringPath(this.withPrefix("OperationUID"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MachineDefinitionNId = new QStringPath(this.withPrefix("MachineDefinitionNId"));
}

export const qTCM2EquipmentSpecificationParameterType = new QTCM2EquipmentSpecificationParameterType();

export class QOperationDependencyParameterType extends QueryObject {
    public readonly FromOperationId = new QGuidPath(this.withPrefix("FromOperationId"));
    public readonly ToOperationId = new QGuidPath(this.withPrefix("ToOperationId"));
    public readonly Context = new QGuidPath(this.withPrefix("Context"));
    public readonly DependencyTypeId = new QGuidPath(this.withPrefix("DependencyTypeId"));
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
}

export const qOperationDependencyParameterType = new QOperationDependencyParameterType();

export class QTCM2AsPlannedBOPParameterType extends QueryObject {
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
    public readonly BaselineName = new QStringPath(this.withPrefix("BaselineName"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly MasterPlanUID = new QStringPath(this.withPrefix("MasterPlanUID"));
    public readonly RootProcessUID = new QStringPath(this.withPrefix("RootProcessUID"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qTCM2AsPlannedBOPParameterType = new QTCM2AsPlannedBOPParameterType();

export class QUpdateStepParameterType extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
}

export const qUpdateStepParameterType = new QUpdateStepParameterType();

export class QToolSpecificationParameterType extends QueryObject {
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly UsageNumber = new QNumberPath(this.withPrefix("UsageNumber"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qToolSpecificationParameterType = new QToolSpecificationParameterType();

export class QAsPlannedBOPParameterType extends QueryObject {
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
    public readonly BaselineName = new QStringPath(this.withPrefix("BaselineName"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
}

export const qAsPlannedBOPParameterType = new QAsPlannedBOPParameterType();

export class QOperationStructureDependencyParameterType extends QueryObject {
    public readonly FromLinkId = new QGuidPath(this.withPrefix("FromLinkId"));
    public readonly ToLinkId = new QGuidPath(this.withPrefix("ToLinkId"));
    public readonly DependencyTypeId = new QGuidPath(this.withPrefix("DependencyTypeId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qOperationStructureDependencyParameterType = new QOperationStructureDependencyParameterType();

export class QTCM2ProcessParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly MaxQuantity = new QNumberPath(this.withPrefix("MaxQuantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly FinalMaterialUID = new QStringPath(this.withPrefix("FinalMaterialUID"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qTCM2ProcessParameterType = new QTCM2ProcessParameterType();

export class QOutputProcessParameterType extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
}

export const qOutputProcessParameterType = new QOutputProcessParameterType();

export class QTCM2StepParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
}

export const qTCM2StepParameterType = new QTCM2StepParameterType();

export class QMaterialDefinitionDocumentParameterType extends QueryObject {
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qMaterialDefinitionDocumentParameterType = new QMaterialDefinitionDocumentParameterType();

export class QLinkParameterType extends QueryObject {
    public readonly ChildEntityId = new QGuidPath(this.withPrefix("ChildEntityId"));
    public readonly ParentEntityId = new QGuidPath(this.withPrefix("ParentEntityId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
}

export const qLinkParameterType = new QLinkParameterType();

export class QStepInOperationParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly PredecessorId = new QGuidPath(this.withPrefix("PredecessorId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qStepInOperationParameterType = new QStepInOperationParameterType();

export class QTCM2DocumentParameterType extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
}

export const qTCM2DocumentParameterType = new QTCM2DocumentParameterType();

export class QTCM2MasterPlanParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly RootProcessUID = new QStringPath(this.withPrefix("RootProcessUID"));
}

export const qTCM2MasterPlanParameterType = new QTCM2MasterPlanParameterType();

export class QLogisticParameterType extends QueryObject {
    public readonly Volume = new QNumberPath(this.withPrefix("Volume"));
    public readonly Weight = new QNumberPath(this.withPrefix("Weight"));
    public readonly VolumeUoM = new QStringPath(this.withPrefix("VolumeUoM"));
    public readonly WeightUoM = new QStringPath(this.withPrefix("WeightUoM"));
    public readonly LogisticClass = new QGuidPath(this.withPrefix("LogisticClass"));
}

export const qLogisticParameterType = new QLogisticParameterType();

export class QTCMOutputParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly IsCreated = new QBooleanPath(this.withPrefix("IsCreated"));
}

export const qTCMOutputParameter = new QTCMOutputParameter();

export class QSubstrateDefinitionPropertiesParameterType extends QueryObject {
    public readonly AutomaticThicknessDecrease = new QBooleanPath(this.withPrefix("AutomaticThicknessDecrease"));
    public readonly MaximumTreatmentCountHold = new QNumberPath(this.withPrefix("MaximumTreatmentCountHold"));
    public readonly MaximumTreatmentCountWarning = new QNumberPath(this.withPrefix("MaximumTreatmentCountWarning"));
    public readonly MinimumThicknessWarning = new QNumberPath(this.withPrefix("MinimumThicknessWarning"));
    public readonly MinimumThicknessHold = new QNumberPath(this.withPrefix("MinimumThicknessHold"));
    public readonly ThicknessDecreaseAmount = new QNumberPath(this.withPrefix("ThicknessDecreaseAmount"));
}

export const qSubstrateDefinitionPropertiesParameterType = new QSubstrateDefinitionPropertiesParameterType();

export class QIdentifiersParameterType2 extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qIdentifiersParameterType2 = new QIdentifiersParameterType2();

export class QProcessIdentifiersParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qProcessIdentifiersParameterType = new QProcessIdentifiersParameterType();

export class QTCM2ToolDefinitionParameterTypeCreate extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ToolClassNId = new QStringPath(this.withPrefix("ToolClassNId"));
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly SubstrateDefinitionProperties = new QEntityPath(this.withPrefix("SubstrateDefinitionProperties"), () => QSubstrateDefinitionPropertiesParameterType);
}

export const qTCM2ToolDefinitionParameterTypeCreate = new QTCM2ToolDefinitionParameterTypeCreate();

export class QAMPowderPropertiesParameterType extends QueryObject {
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityParameterType);
}

export const qAMPowderPropertiesParameterType = new QAMPowderPropertiesParameterType();

export class QDM_MaterialTrackingUnitHistoryParameterType extends QueryObject {
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly DisassembleFromHistoryId = new QGuidPath(this.withPrefix("DisassembleFromHistoryId"));
    public readonly ExecutionGroupPhase = new QGuidPath(this.withPrefix("ExecutionGroupPhase"));
    public readonly NewCode = new QStringPath(this.withPrefix("NewCode"));
    public readonly OldCode = new QStringPath(this.withPrefix("OldCode"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly TargetDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("TargetDM_MaterialTrackingUnit"));
    public readonly SourceDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("SourceDM_MaterialTrackingUnit"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly MixedQuantity = new QNumberPath(this.withPrefix("MixedQuantity"));
    public readonly Action = new QGuidPath(this.withPrefix("Action"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
}

export const qDM_MaterialTrackingUnitHistoryParameterType = new QDM_MaterialTrackingUnitHistoryParameterType();

export class QNIdsParameterType extends QueryObject {
    public readonly Values = new QCollectionPath(this.withPrefix("Values"), () => QStringCollection);
}

export const qNIdsParameterType = new QNIdsParameterType();

export class QAPSOrderOperationParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly AssignedResourceNId = new QStringPath(this.withPrefix("AssignedResourceNId"));
}

export const qAPSOrderOperationParameterType = new QAPSOrderOperationParameterType();

export class QAPSOrderOperationsParameterType extends QueryObject {
    public readonly Values = new QEntityCollectionPath(this.withPrefix("Values"), () => QAPSOrderOperationParameterType);
}

export const qAPSOrderOperationsParameterType = new QAPSOrderOperationsParameterType();

export class QMaterialItemToConsumeOnContainerParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly ToBeConsumedMaterialItemList = new QEntityCollectionPath(this.withPrefix("ToBeConsumedMaterialItemList"), () => QToBeConsumedMaterialParameterType);
}

export const qMaterialItemToConsumeOnContainerParameterType = new QMaterialItemToConsumeOnContainerParameterType();

export class QUnloadContainerParameterType extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly MTUNIdList = new QCollectionPath(this.withPrefix("MTUNIdList"), () => QStringCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qUnloadContainerParameterType = new QUnloadContainerParameterType();

export class QToolToBeUsedOnContainerParameterType extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly Tool = new QEntityPath(this.withPrefix("Tool"), () => QToolToBeUsedParameterType);
}

export const qToolToBeUsedOnContainerParameterType = new QToolToBeUsedOnContainerParameterType();

export class QCreateBoMItemResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBoMItemResponse = new QCreateBoMItemResponse();

export class QCreateBoMItem extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly IsAlternativeSelected = new QBooleanPath(this.withPrefix("IsAlternativeSelected"));
    public readonly BoMItemBoM = new QGuidPath(this.withPrefix("BoMItemBoM"));
    public readonly GroupType = new QGuidPath(this.withPrefix("GroupType"));
    public readonly GroupName = new QStringPath(this.withPrefix("GroupName"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly BoM = new QGuidPath(this.withPrefix("BoM"));
    public readonly MaterialDefinition = new QGuidPath(this.withPrefix("MaterialDefinition"));
}

export const qCreateBoMItem = new QCreateBoMItem();

export class QSentenceNonConformanceResponse extends QCommandResponse {
    public readonly CurrentStatus = new QStringPath(this.withPrefix("CurrentStatus"));
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
}

export const qSentenceNonConformanceResponse = new QSentenceNonConformanceResponse();

export class QSentenceNonConformance extends QueryObject {
    public readonly NonConformanceSentencingDetails = new QEntityPath(this.withPrefix("NonConformanceSentencingDetails"), () => QNonConformanceSentencingParamaterType);
}

export const qSentenceNonConformance = new QSentenceNonConformance();

export class QUpdateSkillResponse extends QCommandResponse {
}

export const qUpdateSkillResponse = new QUpdateSkillResponse();

export class QUpdateSkill extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
}

export const qUpdateSkill = new QUpdateSkill();

export class QSetWorkOrderHoldResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qSetWorkOrderHoldResponse = new QSetWorkOrderHoldResponse();

export class QSetWorkOrderHold extends QueryObject {
    public readonly HoldParametersType = new QEntityPath(this.withPrefix("HoldParametersType"), () => QHoldParamterType);
}

export const qSetWorkOrderHold = new QSetWorkOrderHold();

export class QTriggerPrintingOnWorkOrderOperationResponse extends QCommandResponse {
}

export const qTriggerPrintingOnWorkOrderOperationResponse = new QTriggerPrintingOnWorkOrderOperationResponse();

export class QTriggerPrintingOnWorkOrderOperation extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qTriggerPrintingOnWorkOrderOperation = new QTriggerPrintingOnWorkOrderOperation();

export class QSetNonConformanceStatusIsFrozenResponse extends QCommandResponse {
}

export const qSetNonConformanceStatusIsFrozenResponse = new QSetNonConformanceStatusIsFrozenResponse();

export class QSetNonConformanceStatusIsFrozen extends QueryObject {
    public readonly NonConformanceLifecycleId = new QGuidPath(this.withPrefix("NonConformanceLifecycleId"));
    public readonly NonConformanceStatusId = new QGuidPath(this.withPrefix("NonConformanceStatusId"));
    public readonly IsRuntimeFrozen = new QBooleanPath(this.withPrefix("IsRuntimeFrozen"));
}

export const qSetNonConformanceStatusIsFrozen = new QSetNonConformanceStatusIsFrozen();

export class QDeleteMaterialsTrackingUnitResponse extends QCommandResponse {
}

export const qDeleteMaterialsTrackingUnitResponse = new QDeleteMaterialsTrackingUnitResponse();

export class QDeleteMaterialsTrackingUnit extends QueryObject {
    public readonly DM_MaterialTrackingUnitIds = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitIds"), () => QGuidCollection);
}

export const qDeleteMaterialsTrackingUnit = new QDeleteMaterialsTrackingUnit();

export class QDeleteToolSpecificationListResponse extends QCommandResponse {
}

export const qDeleteToolSpecificationListResponse = new QDeleteToolSpecificationListResponse();

export class QDeleteToolSpecificationList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteToolSpecificationList = new QDeleteToolSpecificationList();

export class QUnlinkAMMachineToMESResponse extends QCommandResponse {
}

export const qUnlinkAMMachineToMESResponse = new QUnlinkAMMachineToMESResponse();

export class QUnlinkAMMachineToMES extends QueryObject {
    public readonly MachineToAMMachine = new QGuidPath(this.withPrefix("MachineToAMMachine"));
}

export const qUnlinkAMMachineToMES = new QUnlinkAMMachineToMES();

export class QCreateToBeUsedMachinePJFResponse extends QCommandResponse {
}

export const qCreateToBeUsedMachinePJFResponse = new QCreateToBeUsedMachinePJFResponse();

export class QCreateToBeUsedMachinePJF extends QueryObject {
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
}

export const qCreateToBeUsedMachinePJF = new QCreateToBeUsedMachinePJF();

export class QLinkItlkCheckToOperationToStepLinkListResponse extends QCommandResponse {
    public readonly ItlkCheckOperationToStepLinkAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qLinkItlkCheckToOperationToStepLinkListResponse = new QLinkItlkCheckToOperationToStepLinkListResponse();

export class QLinkItlkCheckToOperationToStepLinkList extends QueryObject {
    public readonly ItlkCheckOperationToStepLinkAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationList"), () => QItlkCheckOperationToStepLinkAssociationParameterType);
}

export const qLinkItlkCheckToOperationToStepLinkList = new QLinkItlkCheckToOperationToStepLinkList();

export class QDeleteUoMResponse extends QCommandResponse {
}

export const qDeleteUoMResponse = new QDeleteUoMResponse();

export class QDeleteUoM extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteUoM = new QDeleteUoM();

export class QSetToBeCollectedDocumentResponse extends QCommandResponse {
}

export const qSetToBeCollectedDocumentResponse = new QSetToBeCollectedDocumentResponse();

export class QSetToBeCollectedDocument extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qSetToBeCollectedDocument = new QSetToBeCollectedDocument();

export class QInitializeCreatedTaskResponse extends QCommandResponse {
}

export const qInitializeCreatedTaskResponse = new QInitializeCreatedTaskResponse();

export class QInitializeCreatedTask extends QueryObject {
    public readonly InitializeCreatedTaskParameter = new QEntityPath(this.withPrefix("InitializeCreatedTaskParameter"), () => QInitializeCreatedTaskParameterType);
}

export const qInitializeCreatedTask = new QInitializeCreatedTask();

export class QStartWOOperationSerializedResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qStartWOOperationSerializedResponse = new QStartWOOperationSerializedResponse();

export class QStartWOOperationSerialized extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly StartWOOperationSerializedParameterType = new QEntityPath(this.withPrefix("StartWOOperationSerializedParameterType"), () => QStartWOOperationSerializedParameterType);
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartWOOperationSerialized = new QStartWOOperationSerialized();

export class QUnlinkDocumentListToDM_MaterialTrackingUnitResponse extends QCommandResponse {
}

export const qUnlinkDocumentListToDM_MaterialTrackingUnitResponse = new QUnlinkDocumentListToDM_MaterialTrackingUnitResponse();

export class QUnlinkDocumentListToDM_MaterialTrackingUnit extends QueryObject {
    public readonly DM_MaterialTrackingUnitDocumentAssociationIds = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitDocumentAssociationIds"), () => QGuidCollection);
}

export const qUnlinkDocumentListToDM_MaterialTrackingUnit = new QUnlinkDocumentListToDM_MaterialTrackingUnit();

export class QTCM2CreateResourceDefinitionListResponse extends QCommandResponse {
}

export const qTCM2CreateResourceDefinitionListResponse = new QTCM2CreateResourceDefinitionListResponse();

export class QTCM2CreateResourceDefinitionList extends QueryObject {
    public readonly ResourceDefinitionList = new QEntityCollectionPath(this.withPrefix("ResourceDefinitionList"), () => QTCM2ResourceDefinitionParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateResourceDefinitionList = new QTCM2CreateResourceDefinitionList();

export class QGetBufferWithActualQuantityResponse extends QCommandResponse {
    public readonly ActualQuantities = new QEntityCollectionPath(this.withPrefix("ActualQuantities"), () => QOutputBufferActualQuantityType);
}

export const qGetBufferWithActualQuantityResponse = new QGetBufferWithActualQuantityResponse();

export class QGetBufferWithActualQuantity extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qGetBufferWithActualQuantity = new QGetBufferWithActualQuantity();

export class QDeleteToolDefinitionDocumentListResponse extends QCommandResponse {
}

export const qDeleteToolDefinitionDocumentListResponse = new QDeleteToolDefinitionDocumentListResponse();

export class QDeleteToolDefinitionDocumentList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteToolDefinitionDocumentList = new QDeleteToolDefinitionDocumentList();

export class QSaveWorkInstructionDesignResponse extends QCommandResponse {
}

export const qSaveWorkInstructionDesignResponse = new QSaveWorkInstructionDesignResponse();

export class QSaveWorkInstructionDesign extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Model = new QStringPath(this.withPrefix("Model"));
    public readonly WI_ESScenarios = new QEntityCollectionPath(this.withPrefix("WI_ESScenarios"), () => QWI_ESScenerioParameterType);
}

export const qSaveWorkInstructionDesign = new QSaveWorkInstructionDesign();

export class QUnlinkSubstrateDefinitionToMachineResponse extends QCommandResponse {
}

export const qUnlinkSubstrateDefinitionToMachineResponse = new QUnlinkSubstrateDefinitionToMachineResponse();

export class QUnlinkSubstrateDefinitionToMachine extends QueryObject {
    public readonly SubstrateDefinitionCompatibleMachineList = new QCollectionPath(this.withPrefix("SubstrateDefinitionCompatibleMachineList"), () => QGuidCollection);
}

export const qUnlinkSubstrateDefinitionToMachine = new QUnlinkSubstrateDefinitionToMachine();

export class QLinkWIDefinitionsToWOStepResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWIDefinitionsToWOStepResponse = new QLinkWIDefinitionsToWOStepResponse();

export class QLinkWIDefinitionsToWOStep extends QueryObject {
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkInstructionAssociationType = new QStringPath(this.withPrefix("WorkInstructionAssociationType"));
}

export const qLinkWIDefinitionsToWOStep = new QLinkWIDefinitionsToWOStep();

export class QLockWorkInstructionDefinitionResponse extends QCommandResponse {
}

export const qLockWorkInstructionDefinitionResponse = new QLockWorkInstructionDefinitionResponse();

export class QLockWorkInstructionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qLockWorkInstructionDefinition = new QLockWorkInstructionDefinition();

export class QCreateEquipmentGraphConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphConfigurationResponse = new QCreateEquipmentGraphConfigurationResponse();

export class QCreateEquipmentGraphConfiguration extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qCreateEquipmentGraphConfiguration = new QCreateEquipmentGraphConfiguration();

export class QAssociateDNCItemMachineMaterialAssociationResponse extends QCommandResponse {
    public readonly DNCItemMachineMaterialAssociationId = new QGuidPath(this.withPrefix("DNCItemMachineMaterialAssociationId"));
}

export const qAssociateDNCItemMachineMaterialAssociationResponse = new QAssociateDNCItemMachineMaterialAssociationResponse();

export class QAssociateDNCItemMachineMaterialAssociation extends QueryObject {
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qAssociateDNCItemMachineMaterialAssociation = new QAssociateDNCItemMachineMaterialAssociation();

export class QTCM2LinkOperationToStepListResponse extends QCommandResponse {
}

export const qTCM2LinkOperationToStepListResponse = new QTCM2LinkOperationToStepListResponse();

export class QTCM2LinkOperationToStepList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QTCM2LinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2LinkOperationToStepList = new QTCM2LinkOperationToStepList();

export class QDeleteCustomItlkCheckParameterListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteCustomItlkCheckParameterListResponse = new QDeleteCustomItlkCheckParameterListResponse();

export class QDeleteCustomItlkCheckParameterList extends QueryObject {
    public readonly ListOfItlkCheckParameterId = new QCollectionPath(this.withPrefix("ListOfItlkCheckParameterId"), () => QGuidCollection);
}

export const qDeleteCustomItlkCheckParameterList = new QDeleteCustomItlkCheckParameterList();

export class QCreateTeamResponse extends QCommandResponse {
}

export const qCreateTeamResponse = new QCreateTeamResponse();

export class QCreateTeam extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaximumUsers = new QNumberPath(this.withPrefix("MaximumUsers"));
}

export const qCreateTeam = new QCreateTeam();

export class QDeleteProcessToOpLinkDependencyNavigationListResponse extends QCommandResponse {
}

export const qDeleteProcessToOpLinkDependencyNavigationListResponse = new QDeleteProcessToOpLinkDependencyNavigationListResponse();

export class QDeleteProcessToOpLinkDependencyNavigationList extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
}

export const qDeleteProcessToOpLinkDependencyNavigationList = new QDeleteProcessToOpLinkDependencyNavigationList();

export class QUpdateOperationResponse extends QCommandResponse {
}

export const qUpdateOperationResponse = new QUpdateOperationResponse();

export class QUpdateOperation extends QueryObject {
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperationParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
}

export const qUpdateOperation = new QUpdateOperation();

export class QCreateEquipmentTypeResponse extends QCommandResponse {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
}

export const qCreateEquipmentTypeResponse = new QCreateEquipmentTypeResponse();

export class QCreateEquipmentType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StateMachineNIds = new QCollectionPath(this.withPrefix("StateMachineNIds"), () => QStringCollection);
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
}

export const qCreateEquipmentType = new QCreateEquipmentType();

export class QEditWorkOrderHumanResourceResponse extends QCommandResponse {
}

export const qEditWorkOrderHumanResourceResponse = new QEditWorkOrderHumanResourceResponse();

export class QEditWorkOrderHumanResource extends QueryObject {
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly RequiredNumberOfHumanResource = new QNumberPath(this.withPrefix("RequiredNumberOfHumanResource"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qEditWorkOrderHumanResource = new QEditWorkOrderHumanResource();

export class QAssignNonConformanceTransitionMailAddressListResponse extends QCommandResponse {
}

export const qAssignNonConformanceTransitionMailAddressListResponse = new QAssignNonConformanceTransitionMailAddressListResponse();

export class QAssignNonConformanceTransitionMailAddressList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly MailAddressList = new QCollectionPath(this.withPrefix("MailAddressList"), () => QStringCollection);
}

export const qAssignNonConformanceTransitionMailAddressList = new QAssignNonConformanceTransitionMailAddressList();

export class QSplitWorkOrderResponse extends QCommandResponse {
    public readonly NewWorkOrderList = new QEntityCollectionPath(this.withPrefix("NewWorkOrderList"), () => QWorkOrderIdentifiersParameterType);
}

export const qSplitWorkOrderResponse = new QSplitWorkOrderResponse();

export class QSplitWorkOrder extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly SplitType = new QStringPath(this.withPrefix("SplitType"));
    public readonly NewWorkOrderList = new QEntityCollectionPath(this.withPrefix("NewWorkOrderList"), () => QNewWorkOrderForSplit);
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly IsScrap = new QBooleanPath(this.withPrefix("IsScrap"));
}

export const qSplitWorkOrder = new QSplitWorkOrder();

export class QCreateVariableCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateVariableCharacteristicSpecificationResponse = new QCreateVariableCharacteristicSpecificationResponse();

export class QCreateVariableCharacteristicSpecification extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly NominalValue = new QEntityPath(this.withPrefix("NominalValue"), () => QQuantityParameterType);
    public readonly UpperTolerance = new QEntityPath(this.withPrefix("UpperTolerance"), () => QQuantityParameterType);
    public readonly LowerTolerance = new QEntityPath(this.withPrefix("LowerTolerance"), () => QQuantityParameterType);
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qCreateVariableCharacteristicSpecification = new QCreateVariableCharacteristicSpecification();

export class QDeleteHoldResponse extends QCommandResponse {
}

export const qDeleteHoldResponse = new QDeleteHoldResponse();

export class QDeleteHold extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteHold = new QDeleteHold();

export class QCreateDM_MaterialTrackingUnitHistoryListResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qCreateDM_MaterialTrackingUnitHistoryListResponse = new QCreateDM_MaterialTrackingUnitHistoryListResponse();

export class QCreateDM_MaterialTrackingUnitHistoryList extends QueryObject {
    public readonly DM_MaterialTrackingUnitHistoryParameterTypeList = new QEntityCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryParameterTypeList"), () => QDM_MaterialTrackingUnitHistoryParameterType);
}

export const qCreateDM_MaterialTrackingUnitHistoryList = new QCreateDM_MaterialTrackingUnitHistoryList();

export class QDeleteSkillListResponse extends QCommandResponse {
}

export const qDeleteSkillListResponse = new QDeleteSkillListResponse();

export class QDeleteSkillList extends QueryObject {
    public readonly SkillIdList = new QCollectionPath(this.withPrefix("SkillIdList"), () => QGuidCollection);
}

export const qDeleteSkillList = new QDeleteSkillList();

export class QCreateStatusTransitionDefinitionResponse extends QCommandResponse {
    public readonly StatusTransitionDefinitionId = new QGuidPath(this.withPrefix("StatusTransitionDefinitionId"));
}

export const qCreateStatusTransitionDefinitionResponse = new QCreateStatusTransitionDefinitionResponse();

export class QCreateStatusTransitionDefinition extends QueryObject {
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
}

export const qCreateStatusTransitionDefinition = new QCreateStatusTransitionDefinition();

export class QUnlinkCharacteristicRepresentationToStepResponse extends QCommandResponse {
}

export const qUnlinkCharacteristicRepresentationToStepResponse = new QUnlinkCharacteristicRepresentationToStepResponse();

export class QUnlinkCharacteristicRepresentationToStep extends QueryObject {
    public readonly InspectionSpecificationId = new QGuidPath(this.withPrefix("InspectionSpecificationId"));
}

export const qUnlinkCharacteristicRepresentationToStep = new QUnlinkCharacteristicRepresentationToStep();

export class QDeleteActualUsedMachineResponse extends QCommandResponse {
}

export const qDeleteActualUsedMachineResponse = new QDeleteActualUsedMachineResponse();

export class QDeleteActualUsedMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteActualUsedMachine = new QDeleteActualUsedMachine();

export class QUADMCreateDocumentResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateDocumentResponse = new QUADMCreateDocumentResponse();

export class QUADMCreateDocument extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly File = new QBinaryPath(this.withPrefix("File"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
}

export const qUADMCreateDocument = new QUADMCreateDocument();

export class QCreateBoMItemV4_0Response extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBoMItemV4_0Response = new QCreateBoMItemV4_0Response();

export class QCreateBoMItemV4_0 extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly IsAlternativeSelected = new QBooleanPath(this.withPrefix("IsAlternativeSelected"));
    public readonly BoMItemBoM = new QGuidPath(this.withPrefix("BoMItemBoM"));
    public readonly GroupType = new QGuidPath(this.withPrefix("GroupType"));
    public readonly GroupName = new QStringPath(this.withPrefix("GroupName"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly BoM = new QGuidPath(this.withPrefix("BoM"));
    public readonly MaterialProperties = new QEntityPath(this.withPrefix("MaterialProperties"), () => QDM_MaterialParameterType);
}

export const qCreateBoMItemV4_0 = new QCreateBoMItemV4_0();

export class QRejectMaterialRequestResponse extends QCommandResponse {
}

export const qRejectMaterialRequestResponse = new QRejectMaterialRequestResponse();

export class QRejectMaterialRequest extends QueryObject {
    public readonly MaterialRequestIds = new QCollectionPath(this.withPrefix("MaterialRequestIds"), () => QGuidCollection);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qRejectMaterialRequest = new QRejectMaterialRequest();

export class QMaterialItemSplitBatchByPartialPreviewResponse extends QCommandResponse {
    public readonly SplitBatchList = new QEntityCollectionPath(this.withPrefix("SplitBatchList"), () => QMaterialItemForSplitType);
}

export const qMaterialItemSplitBatchByPartialPreviewResponse = new QMaterialItemSplitBatchByPartialPreviewResponse();

export class QMaterialItemSplitBatchByPartialPreview extends QueryObject {
    public readonly TargetQuantity = new QEntityPath(this.withPrefix("TargetQuantity"), () => QQuantityParameterType);
    public readonly MaterialItemIdFlag0 = new QBooleanPath(this.withPrefix("MaterialItemIdFlag0"));
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
}

export const qMaterialItemSplitBatchByPartialPreview = new QMaterialItemSplitBatchByPartialPreview();

export class QUpdateDM_MaterialResponse extends QCommandResponse {
}

export const qUpdateDM_MaterialResponse = new QUpdateDM_MaterialResponse();

export class QUpdateDM_Material extends QueryObject {
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
    public readonly Lot = new QBooleanPath(this.withPrefix("Lot"));
    public readonly EnableAutomaticConsumptionQty = new QBooleanPath(this.withPrefix("EnableAutomaticConsumptionQty"));
    public readonly MaxQuantityConsumption = new QNumberPath(this.withPrefix("MaxQuantityConsumption"));
    public readonly FunctionalCodeNId = new QStringPath(this.withPrefix("FunctionalCodeNId"));
}

export const qUpdateDM_Material = new QUpdateDM_Material();

export class QUADMCreateToolDefinitionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateToolDefinitionResponse = new QUADMCreateToolDefinitionResponse();

export class QUADMCreateToolDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ToolClassNId = new QStringPath(this.withPrefix("ToolClassNId"));
    public readonly SubstrateDefinitionProperties = new QEntityPath(this.withPrefix("SubstrateDefinitionProperties"), () => QSubstrateDefinitionPropertiesParameterType);
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly RevisionExpression = new QStringPath(this.withPrefix("RevisionExpression"));
    public readonly LogisticParameter = new QEntityPath(this.withPrefix("LogisticParameter"), () => QLogisticParameterType);
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
}

export const qUADMCreateToolDefinition = new QUADMCreateToolDefinition();

export class QDeleteTeamResponse extends QCommandResponse {
}

export const qDeleteTeamResponse = new QDeleteTeamResponse();

export class QDeleteTeam extends QueryObject {
    public readonly TeamId = new QGuidPath(this.withPrefix("TeamId"));
}

export const qDeleteTeam = new QDeleteTeam();

export class QUpdateItlkCheckWOOpAssociationListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateItlkCheckWOOpAssociationListResponse = new QUpdateItlkCheckWOOpAssociationListResponse();

export class QUpdateItlkCheckWOOpAssociationList extends QueryObject {
    public readonly ItlkCheckWOOpAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationList"), () => QItlkCheckWOOpAssociationUpdateParameterType);
}

export const qUpdateItlkCheckWOOpAssociationList = new QUpdateItlkCheckWOOpAssociationList();

export class QExecuteCustomItlkCheckOutboundResponse extends QCommandResponse {
    public readonly CustomItlkCheckOutputList = new QEntityCollectionPath(this.withPrefix("CustomItlkCheckOutputList"), () => QItlkCheckOrchestratorOutputParameterType);
}

export const qExecuteCustomItlkCheckOutboundResponse = new QExecuteCustomItlkCheckOutboundResponse();

export class QExecuteCustomItlkCheckOutbound extends QueryObject {
    public readonly CustomItlkCheckInputList = new QEntityCollectionPath(this.withPrefix("CustomItlkCheckInputList"), () => QItlkCheckOrchestratorInputParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly DM_MTUList = new QEntityCollectionPath(this.withPrefix("DM_MTUList"), () => QItlkCheckDM_MTUParameterType);
    public readonly IsAutomatic = new QBooleanPath(this.withPrefix("IsAutomatic"));
    public readonly ItlkCheckSessionId = new QGuidPath(this.withPrefix("ItlkCheckSessionId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qExecuteCustomItlkCheckOutbound = new QExecuteCustomItlkCheckOutbound();

export class QCreateEquipmentSpecificationResponse extends QCommandResponse {
    public readonly EquipmentSpecificationId = new QGuidPath(this.withPrefix("EquipmentSpecificationId"));
}

export const qCreateEquipmentSpecificationResponse = new QCreateEquipmentSpecificationResponse();

export class QCreateEquipmentSpecification extends QueryObject {
    public readonly EquipmentSpecification = new QEntityPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qCreateEquipmentSpecification = new QCreateEquipmentSpecification();

export class QSetWorkProcessToBeCleanedResponse extends QCommandResponse {
}

export const qSetWorkProcessToBeCleanedResponse = new QSetWorkProcessToBeCleanedResponse();

export class QSetWorkProcessToBeCleaned extends QueryObject {
    public readonly WorkProcessId = new QGuidPath(this.withPrefix("WorkProcessId"));
}

export const qSetWorkProcessToBeCleaned = new QSetWorkProcessToBeCleaned();

export class QAutoGenerateSerialNumberCodesResponse extends QCommandResponse {
    public readonly AutoGeneratedSNCodes = new QCollectionPath(this.withPrefix("AutoGeneratedSNCodes"), () => QStringCollection);
}

export const qAutoGenerateSerialNumberCodesResponse = new QAutoGenerateSerialNumberCodesResponse();

export class QAutoGenerateSerialNumberCodes extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly NumberingPatternNId = new QStringPath(this.withPrefix("NumberingPatternNId"));
    public readonly Count = new QNumberPath(this.withPrefix("Count"));
}

export const qAutoGenerateSerialNumberCodes = new QAutoGenerateSerialNumberCodes();

export class QLinkUserToWorkOrderOperationListResponse extends QCommandResponse {
}

export const qLinkUserToWorkOrderOperationListResponse = new QLinkUserToWorkOrderOperationListResponse();

export class QLinkUserToWorkOrderOperationList extends QueryObject {
    public readonly UserIdList = new QCollectionPath(this.withPrefix("UserIdList"), () => QStringCollection);
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
}

export const qLinkUserToWorkOrderOperationList = new QLinkUserToWorkOrderOperationList();

export class QCreateResultTypeListResponse extends QCommandResponse {
    public readonly ResultTypeIdList = new QCollectionPath(this.withPrefix("ResultTypeIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qCreateResultTypeListResponse = new QCreateResultTypeListResponse();

export class QCreateResultTypeList extends QueryObject {
    public readonly ResultTypeList = new QEntityCollectionPath(this.withPrefix("ResultTypeList"), () => QCreateResultTypeParameterType);
}

export const qCreateResultTypeList = new QCreateResultTypeList();

export class QAssignProducedMaterialItemsResponse extends QCommandResponse {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qAssignProducedMaterialItemsResponse = new QAssignProducedMaterialItemsResponse();

export class QAssignProducedMaterialItems extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly SerialNumbers = new QEntityCollectionPath(this.withPrefix("SerialNumbers"), () => QMaterialItemParameterType);
}

export const qAssignProducedMaterialItems = new QAssignProducedMaterialItems();

export class QDeleteFutureHoldAfterNonConformanceSentencingResponse extends QCommandResponse {
}

export const qDeleteFutureHoldAfterNonConformanceSentencingResponse = new QDeleteFutureHoldAfterNonConformanceSentencingResponse();

export class QDeleteFutureHoldAfterNonConformanceSentencing extends QueryObject {
    public readonly DeleteFutureHoldDetails = new QEntityPath(this.withPrefix("DeleteFutureHoldDetails"), () => QDeleteFutureHoldParameterType);
}

export const qDeleteFutureHoldAfterNonConformanceSentencing = new QDeleteFutureHoldAfterNonConformanceSentencing();

export class QDeleteActiveUserOnMachineResponse extends QCommandResponse {
}

export const qDeleteActiveUserOnMachineResponse = new QDeleteActiveUserOnMachineResponse();

export class QDeleteActiveUserOnMachine extends QueryObject {
    public readonly ActiveUserOnMachineId = new QGuidPath(this.withPrefix("ActiveUserOnMachineId"));
}

export const qDeleteActiveUserOnMachine = new QDeleteActiveUserOnMachine();

export class QCreateWorkInstructionDefinitionResponse extends QCommandResponse {
    public readonly ParameterIds = new QCollectionPath(this.withPrefix("ParameterIds"), () => QGuidCollection);
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
}

export const qCreateWorkInstructionDefinitionResponse = new QCreateWorkInstructionDefinitionResponse();

export class QCreateWorkInstructionDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QWorkInstructionDefinitionParameterParameterType);
    public readonly UseDefaultTemplate = new QBooleanPath(this.withPrefix("UseDefaultTemplate"));
}

export const qCreateWorkInstructionDefinition = new QCreateWorkInstructionDefinition();

export class QUploadOfflineActionListResponse extends QCommandResponse {
}

export const qUploadOfflineActionListResponse = new QUploadOfflineActionListResponse();

export class QUploadOfflineActionList extends QueryObject {
    public readonly OfflineSessionIdFlag0 = new QBooleanPath(this.withPrefix("OfflineSessionIdFlag0"));
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
    public readonly OfflineActionList = new QEntityCollectionPath(this.withPrefix("OfflineActionList"), () => QOfflineActionType);
}

export const qUploadOfflineActionList = new QUploadOfflineActionList();

export class QAPSSetAlternativeSelectedResponse extends QCommandResponse {
}

export const qAPSSetAlternativeSelectedResponse = new QAPSSetAlternativeSelectedResponse();

export class QAPSSetAlternativeSelected extends QueryObject {
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
}

export const qAPSSetAlternativeSelected = new QAPSSetAlternativeSelected();

export class QUpdateDNCItemMachineMaterialAssociationResponse extends QCommandResponse {
}

export const qUpdateDNCItemMachineMaterialAssociationResponse = new QUpdateDNCItemMachineMaterialAssociationResponse();

export class QUpdateDNCItemMachineMaterialAssociation extends QueryObject {
    public readonly DNCItemMachineMaterialAssociationId = new QGuidPath(this.withPrefix("DNCItemMachineMaterialAssociationId"));
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qUpdateDNCItemMachineMaterialAssociation = new QUpdateDNCItemMachineMaterialAssociation();

export class QUADMUpdateOperationResponse extends QCommandResponse {
}

export const qUADMUpdateOperationResponse = new QUADMUpdateOperationResponse();

export class QUADMUpdateOperation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly CreateDependency = new QBooleanPath(this.withPrefix("CreateDependency"));
    public readonly DependencyType = new QGuidPath(this.withPrefix("DependencyType"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly WorkOperationId = new QGuidPath(this.withPrefix("WorkOperationId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly RevisionEffectivityExpression = new QStringPath(this.withPrefix("RevisionEffectivityExpression"));
    public readonly OriginalSequence = new QNumberPath(this.withPrefix("OriginalSequence"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
}

export const qUADMUpdateOperation = new QUADMUpdateOperation();

export class QTriggerPrintingOnWorkOrderResponse extends QCommandResponse {
}

export const qTriggerPrintingOnWorkOrderResponse = new QTriggerPrintingOnWorkOrderResponse();

export class QTriggerPrintingOnWorkOrder extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qTriggerPrintingOnWorkOrder = new QTriggerPrintingOnWorkOrder();

export class QTCM2LinkProcessToProcessListResponse extends QCommandResponse {
}

export const qTCM2LinkProcessToProcessListResponse = new QTCM2LinkProcessToProcessListResponse();

export class QTCM2LinkProcessToProcessList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QTCM2LinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2LinkProcessToProcessList = new QTCM2LinkProcessToProcessList();

export class QAdministrativePauseResponse extends QCommandResponse {
}

export const qAdministrativePauseResponse = new QAdministrativePauseResponse();

export class QAdministrativePause extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qAdministrativePause = new QAdministrativePause();

export class QCheckInUploadDocumentsResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCheckInUploadDocumentsResponse = new QCheckInUploadDocumentsResponse();

export class QCheckInUploadDocuments extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DocumentType = new QStringPath(this.withPrefix("DocumentType"));
    public readonly MaterialItemIdList = new QCollectionPath(this.withPrefix("MaterialItemIdList"), () => QGuidCollection);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
}

export const qCheckInUploadDocuments = new QCheckInUploadDocuments();

export class QDeleteStatusBehaviorDefinitionResponse extends QCommandResponse {
}

export const qDeleteStatusBehaviorDefinitionResponse = new QDeleteStatusBehaviorDefinitionResponse();

export class QDeleteStatusBehaviorDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteStatusBehaviorDefinition = new QDeleteStatusBehaviorDefinition();

export class QCreateMaterialSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateMaterialSpecificationResponse = new QCreateMaterialSpecificationResponse();

export class QCreateMaterialSpecification extends QueryObject {
    public readonly MaterialSpecification = new QEntityPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qCreateMaterialSpecification = new QCreateMaterialSpecification();

export class QUnlinkDocumentListToStepResponse extends QCommandResponse {
}

export const qUnlinkDocumentListToStepResponse = new QUnlinkDocumentListToStepResponse();

export class QUnlinkDocumentListToStep extends QueryObject {
    public readonly ListOfDocumentId = new QCollectionPath(this.withPrefix("ListOfDocumentId"), () => QGuidCollection);
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
}

export const qUnlinkDocumentListToStep = new QUnlinkDocumentListToStep();

export class QCreateWorkOrderOutMsgResponse extends QCommandResponse {
}

export const qCreateWorkOrderOutMsgResponse = new QCreateWorkOrderOutMsgResponse();

export class QCreateWorkOrderOutMsg extends QueryObject {
    public readonly InstanceNId = new QStringPath(this.withPrefix("InstanceNId"));
    public readonly MsgTypeNId = new QStringPath(this.withPrefix("MsgTypeNId"));
}

export const qCreateWorkOrderOutMsg = new QCreateWorkOrderOutMsg();

export class QLinkSkillsToCertificateResponse extends QCommandResponse {
}

export const qLinkSkillsToCertificateResponse = new QLinkSkillsToCertificateResponse();

export class QLinkSkillsToCertificate extends QueryObject {
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qLinkSkillsToCertificate = new QLinkSkillsToCertificate();

export class QCreateNewOperationRevisionInCatalogueResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewOperationRevisionInCatalogueResponse = new QCreateNewOperationRevisionInCatalogueResponse();

export class QCreateNewOperationRevisionInCatalogue extends QueryObject {
    public readonly SourceOperationId = new QGuidPath(this.withPrefix("SourceOperationId"));
}

export const qCreateNewOperationRevisionInCatalogue = new QCreateNewOperationRevisionInCatalogue();

export class QDeleteNonProductiveActivityListForUserResponse extends QCommandResponse {
}

export const qDeleteNonProductiveActivityListForUserResponse = new QDeleteNonProductiveActivityListForUserResponse();

export class QDeleteNonProductiveActivityListForUser extends QueryObject {
    public readonly UserNPAIds = new QCollectionPath(this.withPrefix("UserNPAIds"), () => QGuidCollection);
}

export const qDeleteNonProductiveActivityListForUser = new QDeleteNonProductiveActivityListForUser();

export class QTCM2CreateMaterialSpecificationListResponse extends QCommandResponse {
}

export const qTCM2CreateMaterialSpecificationListResponse = new QTCM2CreateMaterialSpecificationListResponse();

export class QTCM2CreateMaterialSpecificationList extends QueryObject {
    public readonly MaterialSpecificationList = new QEntityCollectionPath(this.withPrefix("MaterialSpecificationList"), () => QTCM2MaterialSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateMaterialSpecificationList = new QTCM2CreateMaterialSpecificationList();

export class QTraceNonConformanceOnContainerResponse extends QCommandResponse {
}

export const qTraceNonConformanceOnContainerResponse = new QTraceNonConformanceOnContainerResponse();

export class QTraceNonConformanceOnContainer extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Mtus = new QEntityCollectionPath(this.withPrefix("Mtus"), () => QMTuWithQty);
    public readonly ReworkOrderNId = new QStringPath(this.withPrefix("ReworkOrderNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qTraceNonConformanceOnContainer = new QTraceNonConformanceOnContainer();

export class QCreateDocumentListFormFileIdsResponse extends QCommandResponse {
    public readonly DocumentIds = new QEntityCollectionPath(this.withPrefix("DocumentIds"), () => QTCMOutputParameter);
}

export const qCreateDocumentListFormFileIdsResponse = new QCreateDocumentListFormFileIdsResponse();

export class QCreateDocumentListFormFileIds extends QueryObject {
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly Documents = new QEntityCollectionPath(this.withPrefix("Documents"), () => QDocumentFromFileParameterType);
}

export const qCreateDocumentListFormFileIds = new QCreateDocumentListFormFileIds();

export class QTCM2CreateToolSpecificationListResponse extends QCommandResponse {
}

export const qTCM2CreateToolSpecificationListResponse = new QTCM2CreateToolSpecificationListResponse();

export class QTCM2CreateToolSpecificationList extends QueryObject {
    public readonly ToolSpecificationList = new QEntityCollectionPath(this.withPrefix("ToolSpecificationList"), () => QTCM2ToolSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateToolSpecificationList = new QTCM2CreateToolSpecificationList();

export class QTCM2CreateStepDependencyListResponse extends QCommandResponse {
}

export const qTCM2CreateStepDependencyListResponse = new QTCM2CreateStepDependencyListResponse();

export class QTCM2CreateStepDependencyList extends QueryObject {
    public readonly StepDependencyList = new QEntityCollectionPath(this.withPrefix("StepDependencyList"), () => QTCM2StepDependencyParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateStepDependencyList = new QTCM2CreateStepDependencyList();

export class QLinkSkillsToWorkOrderStepResponse extends QCommandResponse {
}

export const qLinkSkillsToWorkOrderStepResponse = new QLinkSkillsToWorkOrderStepResponse();

export class QLinkSkillsToWorkOrderStep extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly SkillLevel = new QNumberPath(this.withPrefix("SkillLevel"));
}

export const qLinkSkillsToWorkOrderStep = new QLinkSkillsToWorkOrderStep();

export class QLinkItlkCheckToOperationStepCategoryListResponse extends QCommandResponse {
    public readonly ItlkCheckOperationStepCategoryAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qLinkItlkCheckToOperationStepCategoryListResponse = new QLinkItlkCheckToOperationStepCategoryListResponse();

export class QLinkItlkCheckToOperationStepCategoryList extends QueryObject {
    public readonly ItlkCheckOperationStepCategoryAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationList"), () => QItlkCheckOperationStepCategoryAssociationParameterType);
}

export const qLinkItlkCheckToOperationStepCategoryList = new QLinkItlkCheckToOperationStepCategoryList();

export class QTCM2AssociateDocumentToOperationListResponse extends QCommandResponse {
}

export const qTCM2AssociateDocumentToOperationListResponse = new QTCM2AssociateDocumentToOperationListResponse();

export class QTCM2AssociateDocumentToOperationList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QTCM2DocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2AssociateDocumentToOperationList = new QTCM2AssociateDocumentToOperationList();

export class QStartWOStepResponse extends QCommandResponse {
}

export const qStartWOStepResponse = new QStartWOStepResponse();

export class QStartWOStep extends QueryObject {
    public readonly WorkOrderStepDetails = new QEntityPath(this.withPrefix("WorkOrderStepDetails"), () => QIdentifiersParameterType);
}

export const qStartWOStep = new QStartWOStep();

export class QUpdateMaterialSpecificationResponse extends QCommandResponse {
}

export const qUpdateMaterialSpecificationResponse = new QUpdateMaterialSpecificationResponse();

export class QUpdateMaterialSpecification extends QueryObject {
    public readonly MaterialSpecification = new QEntityPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecificationParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateMaterialSpecification = new QUpdateMaterialSpecification();

export class QDeleteToolCompatibleMachineResponse extends QCommandResponse {
}

export const qDeleteToolCompatibleMachineResponse = new QDeleteToolCompatibleMachineResponse();

export class QDeleteToolCompatibleMachine extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
    public readonly MachineDefintionNId = new QStringPath(this.withPrefix("MachineDefintionNId"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteToolCompatibleMachine = new QDeleteToolCompatibleMachine();

export class QCreateDM_MaterialTrackingUnitHistoryResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitHistoryId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitHistoryId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateDM_MaterialTrackingUnitHistoryResponse = new QCreateDM_MaterialTrackingUnitHistoryResponse();

export class QCreateDM_MaterialTrackingUnitHistory extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action = new QGuidPath(this.withPrefix("Action"));
    public readonly MixedQuantity = new QNumberPath(this.withPrefix("MixedQuantity"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly SourceDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("SourceDM_MaterialTrackingUnit"));
    public readonly TargetDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("TargetDM_MaterialTrackingUnit"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OldCode = new QStringPath(this.withPrefix("OldCode"));
    public readonly NewCode = new QStringPath(this.withPrefix("NewCode"));
    public readonly ExecutionGroupPhase = new QGuidPath(this.withPrefix("ExecutionGroupPhase"));
    public readonly DisassembleFromHistoryId = new QGuidPath(this.withPrefix("DisassembleFromHistoryId"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly DocumentNId = new QStringPath(this.withPrefix("DocumentNId"));
    public readonly ExecutioGroupPhaseNId = new QStringPath(this.withPrefix("ExecutioGroupPhaseNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qCreateDM_MaterialTrackingUnitHistory = new QCreateDM_MaterialTrackingUnitHistory();

export class QDeleteAsPlannedBoPResponse extends QCommandResponse {
}

export const qDeleteAsPlannedBoPResponse = new QDeleteAsPlannedBoPResponse();

export class QDeleteAsPlannedBoP extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteAsPlannedBoP = new QDeleteAsPlannedBoP();

export class QChangeWorkOrderStatusToEditResponse extends QCommandResponse {
    public readonly Id = new QCollectionPath(this.withPrefix("Id"), () => QGuidCollection);
}

export const qChangeWorkOrderStatusToEditResponse = new QChangeWorkOrderStatusToEditResponse();

export class QChangeWorkOrderStatusToEdit extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qChangeWorkOrderStatusToEdit = new QChangeWorkOrderStatusToEdit();

export class QUpdateBufferDefinitionResponse extends QCommandResponse {
}

export const qUpdateBufferDefinitionResponse = new QUpdateBufferDefinitionResponse();

export class QUpdateBufferDefinition extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly CapacityType = new QStringPath(this.withPrefix("CapacityType"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly IsValid = new QBooleanPath(this.withPrefix("IsValid"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
}

export const qUpdateBufferDefinition = new QUpdateBufferDefinition();

export class QUpdateUoMDimensionResponse extends QCommandResponse {
    public readonly BaseUoMIds = new QCollectionPath(this.withPrefix("BaseUoMIds"), () => QGuidCollection);
}

export const qUpdateUoMDimensionResponse = new QUpdateUoMDimensionResponse();

export class QUpdateUoMDimension extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly BaseUoMs = new QEntityCollectionPath(this.withPrefix("BaseUoMs"), () => QBaseUoMParameterType);
}

export const qUpdateUoMDimension = new QUpdateUoMDimension();

export class QDeleteWorkProcessDMMaterialTrackingUnitAssociationListResponse extends QCommandResponse {
}

export const qDeleteWorkProcessDMMaterialTrackingUnitAssociationListResponse = new QDeleteWorkProcessDMMaterialTrackingUnitAssociationListResponse();

export class QDeleteWorkProcessDMMaterialTrackingUnitAssociationList extends QueryObject {
    public readonly DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameter = new QEntityPath(this.withPrefix("DeleteWorkProcessDMMaterialTrackingUnitAssociationListParameter"), () => QDeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType);
}

export const qDeleteWorkProcessDMMaterialTrackingUnitAssociationList = new QDeleteWorkProcessDMMaterialTrackingUnitAssociationList();

export class QDeleteFailureResponse extends QCommandResponse {
    public readonly NotDeletedIds = new QCollectionPath(this.withPrefix("NotDeletedIds"), () => QGuidCollection);
}

export const qDeleteFailureResponse = new QDeleteFailureResponse();

export class QDeleteFailure extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteFailure = new QDeleteFailure();

export class QLinkToolsToNonConformanceResponse extends QCommandResponse {
}

export const qLinkToolsToNonConformanceResponse = new QLinkToolsToNonConformanceResponse();

export class QLinkToolsToNonConformance extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly ToolIds = new QCollectionPath(this.withPrefix("ToolIds"), () => QGuidCollection);
}

export const qLinkToolsToNonConformance = new QLinkToolsToNonConformance();

export class QUpdatePreferredProcessToOpLinkDependencyNavigationResponse extends QCommandResponse {
}

export const qUpdatePreferredProcessToOpLinkDependencyNavigationResponse = new QUpdatePreferredProcessToOpLinkDependencyNavigationResponse();

export class QUpdatePreferredProcessToOpLinkDependencyNavigation extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProcessToOpLinkDependecyNavigation = new QEntityCollectionPath(this.withPrefix("ProcessToOpLinkDependecyNavigation"), () => QDependencyNavigationParameterType);
}

export const qUpdatePreferredProcessToOpLinkDependencyNavigation = new QUpdatePreferredProcessToOpLinkDependencyNavigation();

export class QDeleteToBeUsedInspectionResponse extends QCommandResponse {
}

export const qDeleteToBeUsedInspectionResponse = new QDeleteToBeUsedInspectionResponse();

export class QDeleteToBeUsedInspection extends QueryObject {
    public readonly ToBeUsedInspectionId = new QGuidPath(this.withPrefix("ToBeUsedInspectionId"));
}

export const qDeleteToBeUsedInspection = new QDeleteToBeUsedInspection();

export class QCreateDocumentResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateDocumentResponse = new QCreateDocumentResponse();

export class QCreateDocument extends QueryObject {
    public readonly Document = new QEntityPath(this.withPrefix("Document"), () => QDocumentParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
}

export const qCreateDocument = new QCreateDocument();

export class QUADMUpdateMaterialDefinitionResponse extends QCommandResponse {
}

export const qUADMUpdateMaterialDefinitionResponse = new QUADMUpdateMaterialDefinitionResponse();

export class QUADMUpdateMaterialDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly LogisticParameterType = new QEntityPath(this.withPrefix("LogisticParameterType"), () => QLogisticParameterType);
}

export const qUADMUpdateMaterialDefinition = new QUADMUpdateMaterialDefinition();

export class QUnLinkPJFToEquipmentSpecificationResponse extends QCommandResponse {
}

export const qUnLinkPJFToEquipmentSpecificationResponse = new QUnLinkPJFToEquipmentSpecificationResponse();

export class QUnLinkPJFToEquipmentSpecification extends QueryObject {
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExtId = new QStringPath(this.withPrefix("PrintJobFileExtId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
    public readonly EquipmentSpecification = new QGuidPath(this.withPrefix("EquipmentSpecification"));
}

export const qUnLinkPJFToEquipmentSpecification = new QUnLinkPJFToEquipmentSpecification();

export class QDeleteStatusResponse extends QCommandResponse {
}

export const qDeleteStatusResponse = new QDeleteStatusResponse();

export class QDeleteStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteStatus = new QDeleteStatus();

export class QUnlinkItlkCheckToOperationStepCategoryListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnlinkItlkCheckToOperationStepCategoryListResponse = new QUnlinkItlkCheckToOperationStepCategoryListResponse();

export class QUnlinkItlkCheckToOperationStepCategoryList extends QueryObject {
    public readonly ItlkCheckOperationStepCategoryAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkItlkCheckToOperationStepCategoryList = new QUnlinkItlkCheckToOperationStepCategoryList();

export class QUpdateStatusBehaviorDefinitionResponse extends QCommandResponse {
}

export const qUpdateStatusBehaviorDefinitionResponse = new QUpdateStatusBehaviorDefinitionResponse();

export class QUpdateStatusBehaviorDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateStatusBehaviorDefinition = new QUpdateStatusBehaviorDefinition();

export class QUpdateItlkCheckToOperationToStepLinkListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateItlkCheckToOperationToStepLinkListResponse = new QUpdateItlkCheckToOperationToStepLinkListResponse();

export class QUpdateItlkCheckToOperationToStepLinkList extends QueryObject {
    public readonly ItlkCheckOperationToStepLinkAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationList"), () => QItlkCheckOperationToStepLinkAssociationUpdateParameterType);
}

export const qUpdateItlkCheckToOperationToStepLinkList = new QUpdateItlkCheckToOperationToStepLinkList();

export class QDeleteBufferDefinitionListResponse extends QCommandResponse {
}

export const qDeleteBufferDefinitionListResponse = new QDeleteBufferDefinitionListResponse();

export class QDeleteBufferDefinitionList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteBufferDefinitionList = new QDeleteBufferDefinitionList();

export class QUnlinkATNInstanceParameterToSetPointItemListResponse extends QCommandResponse {
}

export const qUnlinkATNInstanceParameterToSetPointItemListResponse = new QUnlinkATNInstanceParameterToSetPointItemListResponse();

export class QUnlinkATNInstanceParameterToSetPointItemList extends QueryObject {
    public readonly SetPointItemATNInstanceParameterAssociationList = new QCollectionPath(this.withPrefix("SetPointItemATNInstanceParameterAssociationList"), () => QGuidCollection);
}

export const qUnlinkATNInstanceParameterToSetPointItemList = new QUnlinkATNInstanceParameterToSetPointItemList();

export class QStartUsingScrewingToolResponse extends QCommandResponse {
}

export const qStartUsingScrewingToolResponse = new QStartUsingScrewingToolResponse();

export class QStartUsingScrewingTool extends QueryObject {
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly ActivatedOn = new QStringPath(this.withPrefix("ActivatedOn"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qStartUsingScrewingTool = new QStartUsingScrewingTool();

export class QDeleteToolListResponse extends QCommandResponse {
}

export const qDeleteToolListResponse = new QDeleteToolListResponse();

export class QDeleteToolList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteToolList = new QDeleteToolList();

export class QLinkOperationStepCategoryToProcessDefinitionListResponse extends QCommandResponse {
}

export const qLinkOperationStepCategoryToProcessDefinitionListResponse = new QLinkOperationStepCategoryToProcessDefinitionListResponse();

export class QLinkOperationStepCategoryToProcessDefinitionList extends QueryObject {
    public readonly OperationStepCategory = new QGuidPath(this.withPrefix("OperationStepCategory"));
    public readonly ProcessDefinitionList = new QEntityCollectionPath(this.withPrefix("ProcessDefinitionList"), () => QProcessDefinitionIdentifierParameterType);
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
}

export const qLinkOperationStepCategoryToProcessDefinitionList = new QLinkOperationStepCategoryToProcessDefinitionList();

export class QDeleteNonConformanceNotificationResponse extends QCommandResponse {
}

export const qDeleteNonConformanceNotificationResponse = new QDeleteNonConformanceNotificationResponse();

export class QDeleteNonConformanceNotification extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qDeleteNonConformanceNotification = new QDeleteNonConformanceNotification();

export class QUpdateWOByBopResponse extends QCommandResponse {
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
}

export const qUpdateWOByBopResponse = new QUpdateWOByBopResponse();

export class QUpdateWOByBop extends QueryObject {
    public readonly WODetailsForUpdate = new QEntityPath(this.withPrefix("WODetailsForUpdate"), () => QWorkOrderDetailsForBoPUpdateParameterType);
}

export const qUpdateWOByBop = new QUpdateWOByBop();

export class QDeleteTemplateToMaterialPlantListResponse extends QCommandResponse {
}

export const qDeleteTemplateToMaterialPlantListResponse = new QDeleteTemplateToMaterialPlantListResponse();

export class QDeleteTemplateToMaterialPlantList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteTemplateToMaterialPlantList = new QDeleteTemplateToMaterialPlantList();

export class QUpdatePreferredWOOpDependencyNavigationResponse extends QCommandResponse {
}

export const qUpdatePreferredWOOpDependencyNavigationResponse = new QUpdatePreferredWOOpDependencyNavigationResponse();

export class QUpdatePreferredWOOpDependencyNavigation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WOOpDependencyNavigation = new QEntityCollectionPath(this.withPrefix("WOOpDependencyNavigation"), () => QWOOpDependencyNavigationParameterType);
}

export const qUpdatePreferredWOOpDependencyNavigation = new QUpdatePreferredWOOpDependencyNavigation();

export class QDeleteEquipmentLevelResponse extends QCommandResponse {
}

export const qDeleteEquipmentLevelResponse = new QDeleteEquipmentLevelResponse();

export class QDeleteEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentLevel = new QDeleteEquipmentLevel();

export class QRecycleAMPowderBatchResponse extends QCommandResponse {
    public readonly AMPowderBatchStatus = new QStringPath(this.withPrefix("AMPowderBatchStatus"));
}

export const qRecycleAMPowderBatchResponse = new QRecycleAMPowderBatchResponse();

export class QRecycleAMPowderBatch extends QueryObject {
    public readonly AMPowderBatchId = new QGuidPath(this.withPrefix("AMPowderBatchId"));
}

export const qRecycleAMPowderBatch = new QRecycleAMPowderBatch();

export class QGetDCDRuntimeWIToSaveByMachineResponse extends QCommandResponse {
    public readonly WorkOrderOperationIds = new QCollectionPath(this.withPrefix("WorkOrderOperationIds"), () => QGuidCollection);
    public readonly WorkOrderStepIds = new QCollectionPath(this.withPrefix("WorkOrderStepIds"), () => QGuidCollection);
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
}

export const qGetDCDRuntimeWIToSaveByMachineResponse = new QGetDCDRuntimeWIToSaveByMachineResponse();

export class QGetDCDRuntimeWIToSaveByMachine extends QueryObject {
    public readonly WorkInstructionIds = new QCollectionPath(this.withPrefix("WorkInstructionIds"), () => QGuidCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly ProducedMaterialItemList = new QEntityCollectionPath(this.withPrefix("ProducedMaterialItemList"), () => QProductMaterialItem);
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
}

export const qGetDCDRuntimeWIToSaveByMachine = new QGetDCDRuntimeWIToSaveByMachine();

export class QLinkMaterialItemsToHandlingUnitResponse extends QCommandResponse {
}

export const qLinkMaterialItemsToHandlingUnitResponse = new QLinkMaterialItemsToHandlingUnitResponse();

export class QLinkMaterialItemsToHandlingUnit extends QueryObject {
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qLinkMaterialItemsToHandlingUnit = new QLinkMaterialItemsToHandlingUnit();

export class QSetOperationStepCategoryProcessDefinitionByMTUResponse extends QCommandResponse {
}

export const qSetOperationStepCategoryProcessDefinitionByMTUResponse = new QSetOperationStepCategoryProcessDefinitionByMTUResponse();

export class QSetOperationStepCategoryProcessDefinitionByMTU extends QueryObject {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
    public readonly ByMTU = new QBooleanPath(this.withPrefix("ByMTU"));
}

export const qSetOperationStepCategoryProcessDefinitionByMTU = new QSetOperationStepCategoryProcessDefinitionByMTU();

export class QUnlinkCharacteristicRepresentationToOperationResponse extends QCommandResponse {
}

export const qUnlinkCharacteristicRepresentationToOperationResponse = new QUnlinkCharacteristicRepresentationToOperationResponse();

export class QUnlinkCharacteristicRepresentationToOperation extends QueryObject {
    public readonly InspectionSpecificationId = new QGuidPath(this.withPrefix("InspectionSpecificationId"));
}

export const qUnlinkCharacteristicRepresentationToOperation = new QUnlinkCharacteristicRepresentationToOperation();

export class QLinkOperationToProcessResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qLinkOperationToProcessResponse = new QLinkOperationToProcessResponse();

export class QLinkOperationToProcess extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly InheritWIFromProcessOperation = new QBooleanPath(this.withPrefix("InheritWIFromProcessOperation"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
}

export const qLinkOperationToProcess = new QLinkOperationToProcess();

export class QTCM2LinkProcessToOperationListResponse extends QCommandResponse {
}

export const qTCM2LinkProcessToOperationListResponse = new QTCM2LinkProcessToOperationListResponse();

export class QTCM2LinkProcessToOperationList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QTCM2LinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2LinkProcessToOperationList = new QTCM2LinkProcessToOperationList();

export class QCreateWorkOrderAndMaterialItemHistoryResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QEntityCollectionPath(this.withPrefix("WorkOrderHistoryId"), () => QMaterialItemHistoryParameterType);
}

export const qCreateWorkOrderAndMaterialItemHistoryResponse = new QCreateWorkOrderAndMaterialItemHistoryResponse();

export class QCreateWorkOrderAndMaterialItemHistory extends QueryObject {
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action = new QGuidPath(this.withPrefix("Action"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly DNCItem = new QStringPath(this.withPrefix("DNCItem"));
    public readonly Document = new QStringPath(this.withPrefix("Document"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly PrintJobFile = new QStringPath(this.withPrefix("PrintJobFile"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MaterialItemList = new QEntityCollectionPath(this.withPrefix("MaterialItemList"), () => QMaterialItemHistoryParameterType);
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ReferencedWorkOrderHistory = new QGuidPath(this.withPrefix("ReferencedWorkOrderHistory"));
    public readonly SourceWorkOrderNId = new QStringPath(this.withPrefix("SourceWorkOrderNId"));
    public readonly TargetWorkOrderNId = new QStringPath(this.withPrefix("TargetWorkOrderNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly PartProgramName = new QStringPath(this.withPrefix("PartProgramName"));
}

export const qCreateWorkOrderAndMaterialItemHistory = new QCreateWorkOrderAndMaterialItemHistory();

export class QConsumeMaterialItemResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ActualConsumedMaterialIdList = new QCollectionPath(this.withPrefix("ActualConsumedMaterialIdList"), () => QGuidCollection);
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
    public readonly SplitContextList = new QEntityCollectionPath(this.withPrefix("SplitContextList"), () => QSplitContext);
}

export const qConsumeMaterialItemResponse = new QConsumeMaterialItemResponse();

export class QConsumeMaterialItem extends QueryObject {
    public readonly MaterialItemToConsumeList = new QEntityCollectionPath(this.withPrefix("MaterialItemToConsumeList"), () => QMaterialItemToConsumeParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly FailAtFirstError = new QBooleanPath(this.withPrefix("FailAtFirstError"));
}

export const qConsumeMaterialItem = new QConsumeMaterialItem();

export class QCompleteWOOperationsSerializedLiteSingleWOResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
    public readonly CompletedMaterialTrackingUnits = new QEntityCollectionPath(this.withPrefix("CompletedMaterialTrackingUnits"), () => QCompletedMTUParameterType);
    public readonly CompletedWorkOrderOperations = new QEntityCollectionPath(this.withPrefix("CompletedWorkOrderOperations"), () => QWOOpSerializedLiteOutputParameterType);
}

export const qCompleteWOOperationsSerializedLiteSingleWOResponse = new QCompleteWOOperationsSerializedLiteSingleWOResponse();

export class QCompleteWOOperationsSerializedLiteSingleWO extends QueryObject {
    public readonly CompleteWOOpSerializedLiteParameters = new QEntityCollectionPath(this.withPrefix("CompleteWOOpSerializedLiteParameters"), () => QCompleteWOOpSerializedLiteParameterType);
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly PauseSerialNumbers = new QBooleanPath(this.withPrefix("PauseSerialNumbers"));
}

export const qCompleteWOOperationsSerializedLiteSingleWO = new QCompleteWOOperationsSerializedLiteSingleWO();

export class QDeleteEquipmentGraphConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphConfigurationResponse = new QDeleteEquipmentGraphConfigurationResponse();

export class QDeleteEquipmentGraphConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphConfiguration = new QDeleteEquipmentGraphConfiguration();

export class QDeleteToBeUsedMachineResponse extends QCommandResponse {
}

export const qDeleteToBeUsedMachineResponse = new QDeleteToBeUsedMachineResponse();

export class QDeleteToBeUsedMachine extends QueryObject {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qDeleteToBeUsedMachine = new QDeleteToBeUsedMachine();

export class QUpdateResultListResponse extends QCommandResponse {
    public readonly ResultIdList = new QCollectionPath(this.withPrefix("ResultIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly UpdatedResultList = new QEntityCollectionPath(this.withPrefix("UpdatedResultList"), () => QOnResultCreationParameterType);
}

export const qUpdateResultListResponse = new QUpdateResultListResponse();

export class QUpdateResultList extends QueryObject {
    public readonly ResultList = new QEntityCollectionPath(this.withPrefix("ResultList"), () => QUpdateResultListParameterType);
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
}

export const qUpdateResultList = new QUpdateResultList();

export class QLinkWorkInstructionsToWOOperationResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWorkInstructionsToWOOperationResponse = new QLinkWorkInstructionsToWOOperationResponse();

export class QLinkWorkInstructionsToWOOperation extends QueryObject {
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly SerialNumbers = new QCollectionPath(this.withPrefix("SerialNumbers"), () => QStringCollection);
    public readonly IsReEditEnabled = new QBooleanPath(this.withPrefix("IsReEditEnabled"));
    public readonly LinkFromExecutionGroup = new QBooleanPath(this.withPrefix("LinkFromExecutionGroup"));
}

export const qLinkWorkInstructionsToWOOperation = new QLinkWorkInstructionsToWOOperation();

export class QLinkWOOperationListToExecutionGroupResponse extends QCommandResponse {
}

export const qLinkWOOperationListToExecutionGroupResponse = new QLinkWOOperationListToExecutionGroupResponse();

export class QLinkWOOperationListToExecutionGroup extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly ExecutionGroupOperations = new QEntityCollectionPath(this.withPrefix("ExecutionGroupOperations"), () => QExecutionGroupOperationParameterType);
}

export const qLinkWOOperationListToExecutionGroup = new QLinkWOOperationListToExecutionGroup();

export class QSetWorkOrderForSchedulingResponse extends QCommandResponse {
}

export const qSetWorkOrderForSchedulingResponse = new QSetWorkOrderForSchedulingResponse();

export class QSetWorkOrderForScheduling extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
}

export const qSetWorkOrderForScheduling = new QSetWorkOrderForScheduling();

export class QUnLinkToBeUsedMachineToPartProgramResponse extends QCommandResponse {
}

export const qUnLinkToBeUsedMachineToPartProgramResponse = new QUnLinkToBeUsedMachineToPartProgramResponse();

export class QUnLinkToBeUsedMachineToPartProgram extends QueryObject {
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly ToBeUsedMachine = new QGuidPath(this.withPrefix("ToBeUsedMachine"));
}

export const qUnLinkToBeUsedMachineToPartProgram = new QUnLinkToBeUsedMachineToPartProgram();

export class QDeleteMasterPlanListResponse extends QCommandResponse {
}

export const qDeleteMasterPlanListResponse = new QDeleteMasterPlanListResponse();

export class QDeleteMasterPlanList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteMasterPlanList = new QDeleteMasterPlanList();

export class QTCM2CreateOpDependencyListResponse extends QCommandResponse {
}

export const qTCM2CreateOpDependencyListResponse = new QTCM2CreateOpDependencyListResponse();

export class QTCM2CreateOpDependencyList extends QueryObject {
    public readonly OperationDependencyList = new QEntityCollectionPath(this.withPrefix("OperationDependencyList"), () => QTCM2OpDependencyParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateOpDependencyList = new QTCM2CreateOpDependencyList();

export class QDeleteNonConformanceStatusListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteNonConformanceStatusListResponse = new QDeleteNonConformanceStatusListResponse();

export class QDeleteNonConformanceStatusList extends QueryObject {
    public readonly StatusIdList = new QCollectionPath(this.withPrefix("StatusIdList"), () => QGuidCollection);
}

export const qDeleteNonConformanceStatusList = new QDeleteNonConformanceStatusList();

export class QTCM2AssociateDocumentToToolDefinitionListResponse extends QCommandResponse {
}

export const qTCM2AssociateDocumentToToolDefinitionListResponse = new QTCM2AssociateDocumentToToolDefinitionListResponse();

export class QTCM2AssociateDocumentToToolDefinitionList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QTCM2DocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2AssociateDocumentToToolDefinitionList = new QTCM2AssociateDocumentToToolDefinitionList();

export class QLinkCharacteristicRepresentationToStepResponse extends QCommandResponse {
}

export const qLinkCharacteristicRepresentationToStepResponse = new QLinkCharacteristicRepresentationToStepResponse();

export class QLinkCharacteristicRepresentationToStep extends QueryObject {
    public readonly CharacteristicRepresentationNId = new QStringPath(this.withPrefix("CharacteristicRepresentationNId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly CharacteristicRepresentationRevision = new QStringPath(this.withPrefix("CharacteristicRepresentationRevision"));
}

export const qLinkCharacteristicRepresentationToStep = new QLinkCharacteristicRepresentationToStep();

export class QSetEquipmentStatusResponse extends QCommandResponse {
}

export const qSetEquipmentStatusResponse = new QSetEquipmentStatusResponse();

export class QSetEquipmentStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly EquipmentStateMachineId = new QGuidPath(this.withPrefix("EquipmentStateMachineId"));
}

export const qSetEquipmentStatus = new QSetEquipmentStatus();

export class QUADMUpdateEquipmentSpecificationResponse extends QCommandResponse {
}

export const qUADMUpdateEquipmentSpecificationResponse = new QUADMUpdateEquipmentSpecificationResponse();

export class QUADMUpdateEquipmentSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMUpdateEquipmentSpecification = new QUADMUpdateEquipmentSpecification();

export class QCreateEquipmentSpecificationListResponse extends QCommandResponse {
}

export const qCreateEquipmentSpecificationListResponse = new QCreateEquipmentSpecificationListResponse();

export class QCreateEquipmentSpecificationList extends QueryObject {
    public readonly EquipmentSpecificationList = new QEntityCollectionPath(this.withPrefix("EquipmentSpecificationList"), () => QEquipmentSpecificationParameterType);
}

export const qCreateEquipmentSpecificationList = new QCreateEquipmentSpecificationList();

export class QDeleteMaterialDefinitionDocumentListResponse extends QCommandResponse {
}

export const qDeleteMaterialDefinitionDocumentListResponse = new QDeleteMaterialDefinitionDocumentListResponse();

export class QDeleteMaterialDefinitionDocumentList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteMaterialDefinitionDocumentList = new QDeleteMaterialDefinitionDocumentList();

export class QDeleteDefectTypeListResponse extends QCommandResponse {
}

export const qDeleteDefectTypeListResponse = new QDeleteDefectTypeListResponse();

export class QDeleteDefectTypeList extends QueryObject {
    public readonly DefectTypeIdentifiersList = new QEntityCollectionPath(this.withPrefix("DefectTypeIdentifiersList"), () => QIdentifiersParameterType);
}

export const qDeleteDefectTypeList = new QDeleteDefectTypeList();

export class QUpdateSubstrateTreatmentAndThicknessResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateSubstrateTreatmentAndThicknessResponse = new QUpdateSubstrateTreatmentAndThicknessResponse();

export class QUpdateSubstrateTreatmentAndThickness extends QueryObject {
    public readonly SubstrateId = new QGuidPath(this.withPrefix("SubstrateId"));
    public readonly IsTreatment = new QBooleanPath(this.withPrefix("IsTreatment"));
    public readonly IsThicknessDecrease = new QBooleanPath(this.withPrefix("IsThicknessDecrease"));
}

export const qUpdateSubstrateTreatmentAndThickness = new QUpdateSubstrateTreatmentAndThickness();

export class QCreateMaterialAndDM_MaterialResponse extends QCommandResponse {
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qCreateMaterialAndDM_MaterialResponse = new QCreateMaterialAndDM_MaterialResponse();

export class QCreateMaterialAndDM_Material extends QueryObject {
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly Traceble = new QBooleanPath(this.withPrefix("Traceble"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly MaterialClassId = new QGuidPath(this.withPrefix("MaterialClassId"));
    public readonly SupplierId = new QGuidPath(this.withPrefix("SupplierId"));
    public readonly FunctionalCodeId = new QGuidPath(this.withPrefix("FunctionalCodeId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qCreateMaterialAndDM_Material = new QCreateMaterialAndDM_Material();

export class QSetWorkOrderOperationFutureHoldResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qSetWorkOrderOperationFutureHoldResponse = new QSetWorkOrderOperationFutureHoldResponse();

export class QSetWorkOrderOperationFutureHold extends QueryObject {
    public readonly FutureHoldDetails = new QEntityPath(this.withPrefix("FutureHoldDetails"), () => QHoldParamterType);
}

export const qSetWorkOrderOperationFutureHold = new QSetWorkOrderOperationFutureHold();

export class QCreateWorkOrderFromMasterPlanWithQCResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderFromMasterPlanWithQCResponse = new QCreateWorkOrderFromMasterPlanWithQCResponse();

export class QCreateWorkOrderFromMasterPlanWithQC extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly TargetProductId = new QStringPath(this.withPrefix("TargetProductId"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly ConfirmationType = new QStringPath(this.withPrefix("ConfirmationType"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoMParameterType);
}

export const qCreateWorkOrderFromMasterPlanWithQC = new QCreateWorkOrderFromMasterPlanWithQC();

export class QCreateStepDependencyListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateStepDependencyListResponse = new QCreateStepDependencyListResponse();

export class QCreateStepDependencyList extends QueryObject {
    public readonly StepDependencyList = new QEntityCollectionPath(this.withPrefix("StepDependencyList"), () => QStepDependencyParameterType);
}

export const qCreateStepDependencyList = new QCreateStepDependencyList();

export class QUpdateWorkOrderHistoryResponse extends QCommandResponse {
}

export const qUpdateWorkOrderHistoryResponse = new QUpdateWorkOrderHistoryResponse();

export class QUpdateWorkOrderHistory extends QueryObject {
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly DNCItem = new QStringPath(this.withPrefix("DNCItem"));
    public readonly Document = new QStringPath(this.withPrefix("Document"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly PrintJobFile = new QStringPath(this.withPrefix("PrintJobFile"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateWorkOrderHistory = new QUpdateWorkOrderHistory();

export class QCreateMaterialClassResponse extends QCommandResponse {
    public readonly MaterialGroupId = new QGuidPath(this.withPrefix("MaterialGroupId"));
}

export const qCreateMaterialClassResponse = new QCreateMaterialClassResponse();

export class QCreateMaterialClass extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateMaterialClass = new QCreateMaterialClass();

export class QLinkUserToPlantResponse extends QCommandResponse {
}

export const qLinkUserToPlantResponse = new QLinkUserToPlantResponse();

export class QLinkUserToPlant extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qLinkUserToPlant = new QLinkUserToPlant();

export class QGetToBeProducedMaterialsResultResponse extends QCommandResponse {
    public readonly ToBeProducedMaterialIdKoList = new QCollectionPath(this.withPrefix("ToBeProducedMaterialIdKoList"), () => QGuidCollection);
    public readonly DM_MaterialTrackingUnitIdKoList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitIdKoList"), () => QGuidCollection);
}

export const qGetToBeProducedMaterialsResultResponse = new QGetToBeProducedMaterialsResultResponse();

export class QGetToBeProducedMaterialsResult extends QueryObject {
    public readonly WOOpId = new QGuidPath(this.withPrefix("WOOpId"));
    public readonly ToBeProducedMaterialIdList = new QCollectionPath(this.withPrefix("ToBeProducedMaterialIdList"), () => QGuidCollection);
    public readonly DM_MaterialTrackingUnitIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitIdList"), () => QGuidCollection);
}

export const qGetToBeProducedMaterialsResult = new QGetToBeProducedMaterialsResult();

export class QCheckInCompleteWOOperationTransferBatchResponse extends QCommandResponse {
}

export const qCheckInCompleteWOOperationTransferBatchResponse = new QCheckInCompleteWOOperationTransferBatchResponse();

export class QCheckInCompleteWOOperationTransferBatch extends QueryObject {
    public readonly CompleteWOOperationTransferBatchParameterType = new QEntityPath(this.withPrefix("CompleteWOOperationTransferBatchParameterType"), () => QCompleteWOOperationTransferBatchParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInCompleteWOOperationTransferBatch = new QCheckInCompleteWOOperationTransferBatch();

export class QUpdateResultTypeListResponse extends QCommandResponse {
    public readonly ResultTypeIdList = new QCollectionPath(this.withPrefix("ResultTypeIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qUpdateResultTypeListResponse = new QUpdateResultTypeListResponse();

export class QUpdateResultTypeList extends QueryObject {
    public readonly ResultTypeList = new QEntityCollectionPath(this.withPrefix("ResultTypeList"), () => QUpdateResultTypeParameterType);
}

export const qUpdateResultTypeList = new QUpdateResultTypeList();

export class QCompleteWOStepListResponse extends QCommandResponse {
}

export const qCompleteWOStepListResponse = new QCompleteWOStepListResponse();

export class QCompleteWOStepList extends QueryObject {
    public readonly WorkOrderStepListDetails = new QEntityCollectionPath(this.withPrefix("WorkOrderStepListDetails"), () => QIdentifiersParameterType);
}

export const qCompleteWOStepList = new QCompleteWOStepList();

export class QDeleteDocumentResponse extends QCommandResponse {
}

export const qDeleteDocumentResponse = new QDeleteDocumentResponse();

export class QDeleteDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteDocument = new QDeleteDocument();

export class QDeleteUoMFactorResponse extends QCommandResponse {
}

export const qDeleteUoMFactorResponse = new QDeleteUoMFactorResponse();

export class QDeleteUoMFactor extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteUoMFactor = new QDeleteUoMFactor();

export class QDeleteNonConformanceSupervisorResponse extends QCommandResponse {
}

export const qDeleteNonConformanceSupervisorResponse = new QDeleteNonConformanceSupervisorResponse();

export class QDeleteNonConformanceSupervisor extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteNonConformanceSupervisor = new QDeleteNonConformanceSupervisor();

export class QUpdateToBeUsedMachinePJFResponse extends QCommandResponse {
}

export const qUpdateToBeUsedMachinePJFResponse = new QUpdateToBeUsedMachinePJFResponse();

export class QUpdateToBeUsedMachinePJF extends QueryObject {
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
}

export const qUpdateToBeUsedMachinePJF = new QUpdateToBeUsedMachinePJF();

export class QDeleteWorkOrderHistoryMaterialItemResponse extends QCommandResponse {
}

export const qDeleteWorkOrderHistoryMaterialItemResponse = new QDeleteWorkOrderHistoryMaterialItemResponse();

export class QDeleteWorkOrderHistoryMaterialItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkOrderHistoryMaterialItem = new QDeleteWorkOrderHistoryMaterialItem();

export class QUADMCreateMaterialDefinitionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateMaterialDefinitionResponse = new QUADMCreateMaterialDefinitionResponse();

export class QUADMCreateMaterialDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UOM = new QStringPath(this.withPrefix("UOM"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
    public readonly MinQuantity = new QNumberPath(this.withPrefix("MinQuantity"));
    public readonly RevisionExpression = new QStringPath(this.withPrefix("RevisionExpression"));
    public readonly LogisticParameterType = new QEntityPath(this.withPrefix("LogisticParameterType"), () => QLogisticParameterType);
}

export const qUADMCreateMaterialDefinition = new QUADMCreateMaterialDefinition();

export class QCompleteTaskAndWorkProcessListResponse extends QCommandResponse {
}

export const qCompleteTaskAndWorkProcessListResponse = new QCompleteTaskAndWorkProcessListResponse();

export class QCompleteTaskAndWorkProcessList extends QueryObject {
    public readonly CompleteTaskAndWorkProcessListParameter = new QEntityPath(this.withPrefix("CompleteTaskAndWorkProcessListParameter"), () => QCompleteTaskAndWorkProcessListParameterType);
}

export const qCompleteTaskAndWorkProcessList = new QCompleteTaskAndWorkProcessList();

export class QLinkOfflineSessionToWorkOrderOperationListResponse extends QCommandResponse {
}

export const qLinkOfflineSessionToWorkOrderOperationListResponse = new QLinkOfflineSessionToWorkOrderOperationListResponse();

export class QLinkOfflineSessionToWorkOrderOperationList extends QueryObject {
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
    public readonly OfflineSessionIdFlag0 = new QBooleanPath(this.withPrefix("OfflineSessionIdFlag0"));
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
}

export const qLinkOfflineSessionToWorkOrderOperationList = new QLinkOfflineSessionToWorkOrderOperationList();

export class QDeleteOperationDependencyListResponse extends QCommandResponse {
}

export const qDeleteOperationDependencyListResponse = new QDeleteOperationDependencyListResponse();

export class QDeleteOperationDependencyList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteOperationDependencyList = new QDeleteOperationDependencyList();

export class QUnlinkSubstrateToMachineResponse extends QCommandResponse {
}

export const qUnlinkSubstrateToMachineResponse = new QUnlinkSubstrateToMachineResponse();

export class QUnlinkSubstrateToMachine extends QueryObject {
    public readonly SubstrateCompatibleMachineList = new QCollectionPath(this.withPrefix("SubstrateCompatibleMachineList"), () => QGuidCollection);
}

export const qUnlinkSubstrateToMachine = new QUnlinkSubstrateToMachine();

export class QAutomaticConsumeMaterialItemResponse extends QCommandResponse {
    public readonly ActualConsumedMaterial = new QCollectionPath(this.withPrefix("ActualConsumedMaterial"), () => QGuidCollection);
}

export const qAutomaticConsumeMaterialItemResponse = new QAutomaticConsumeMaterialItemResponse();

export class QAutomaticConsumeMaterialItem extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly ConsumptionDetails = new QEntityCollectionPath(this.withPrefix("ConsumptionDetails"), () => QAutomaticConsumptionParameterType);
}

export const qAutomaticConsumeMaterialItem = new QAutomaticConsumeMaterialItem();

export class QCreateWorkOperationTypeResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOperationTypeResponse = new QCreateWorkOperationTypeResponse();

export class QCreateWorkOperationType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ActiveOnlyOne = new QBooleanPath(this.withPrefix("ActiveOnlyOne"));
    public readonly AutoComplete = new QBooleanPath(this.withPrefix("AutoComplete"));
    public readonly AutoStart = new QBooleanPath(this.withPrefix("AutoStart"));
    public readonly CNC = new QBooleanPath(this.withPrefix("CNC"));
    public readonly MachineAutoComplete = new QBooleanPath(this.withPrefix("MachineAutoComplete"));
    public readonly MachineAutoStart = new QBooleanPath(this.withPrefix("MachineAutoStart"));
    public readonly MachineAutoPause = new QBooleanPath(this.withPrefix("MachineAutoPause"));
    public readonly Milestone = new QBooleanPath(this.withPrefix("Milestone"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly AM = new QBooleanPath(this.withPrefix("AM"));
    public readonly Skippable = new QBooleanPath(this.withPrefix("Skippable"));
    public readonly FastOperationConfirmation = new QBooleanPath(this.withPrefix("FastOperationConfirmation"));
}

export const qCreateWorkOperationType = new QCreateWorkOperationType();

export class QUADMCreateEquipmentSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateEquipmentSpecificationResponse = new QUADMCreateEquipmentSpecificationResponse();

export class QUADMCreateEquipmentSpecification extends QueryObject {
    public readonly EquipmentSpecification = new QEntityPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qUADMCreateEquipmentSpecification = new QUADMCreateEquipmentSpecification();

export class QRevertResultsStrategyResponse extends QCommandResponse {
}

export const qRevertResultsStrategyResponse = new QRevertResultsStrategyResponse();

export class QRevertResultsStrategy extends QueryObject {
    public readonly ResultList = new QEntityCollectionPath(this.withPrefix("ResultList"), () => QRevertResultsStrategyParameterType);
}

export const qRevertResultsStrategy = new QRevertResultsStrategy();

export class QUpdateCharacteristicFailureAssociationResponse extends QCommandResponse {
}

export const qUpdateCharacteristicFailureAssociationResponse = new QUpdateCharacteristicFailureAssociationResponse();

export class QUpdateCharacteristicFailureAssociation extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateCharacteristicFailureAssociation = new QUpdateCharacteristicFailureAssociation();

export class QAutoGenerateMTUCodeResponse extends QCommandResponse {
    public readonly AutoGeneratedCode = new QStringPath(this.withPrefix("AutoGeneratedCode"));
}

export const qAutoGenerateMTUCodeResponse = new QAutoGenerateMTUCodeResponse();

export class QAutoGenerateMTUCode extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly NumberingPatternNId = new QStringPath(this.withPrefix("NumberingPatternNId"));
    public readonly DestinationProperty = new QStringPath(this.withPrefix("DestinationProperty"));
}

export const qAutoGenerateMTUCode = new QAutoGenerateMTUCode();

export class QExecuteItlkCheckOutboundResponse extends QCommandResponse {
}

export const qExecuteItlkCheckOutboundResponse = new QExecuteItlkCheckOutboundResponse();

export class QExecuteItlkCheckOutbound extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly MaterialList = new QEntityCollectionPath(this.withPrefix("MaterialList"), () => QItlkCheckDM_MTUParameterType);
    public readonly IsAutomatic = new QBooleanPath(this.withPrefix("IsAutomatic"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qExecuteItlkCheckOutbound = new QExecuteItlkCheckOutbound();

export class QUpdateItlkCheckProcessToOpLinkAssociationListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateItlkCheckProcessToOpLinkAssociationListResponse = new QUpdateItlkCheckProcessToOpLinkAssociationListResponse();

export class QUpdateItlkCheckProcessToOpLinkAssociationList extends QueryObject {
    public readonly ItlkCheckProcessToOpLinkAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationList"), () => QItlkCheckProcessToOpAssociationUpdateParameterType);
}

export const qUpdateItlkCheckProcessToOpLinkAssociationList = new QUpdateItlkCheckProcessToOpLinkAssociationList();

export class QUpdateSetPointItemResponse extends QCommandResponse {
}

export const qUpdateSetPointItemResponse = new QUpdateSetPointItemResponse();

export class QUpdateSetPointItem extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Editable = new QBooleanPath(this.withPrefix("Editable"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly DefaultValues = new QCollectionPath(this.withPrefix("DefaultValues"), () => QStringCollection);
}

export const qUpdateSetPointItem = new QUpdateSetPointItem();

export class QValidateMaterialCoProductionIsCompleteResponse extends QCommandResponse {
}

export const qValidateMaterialCoProductionIsCompleteResponse = new QValidateMaterialCoProductionIsCompleteResponse();

export class QValidateMaterialCoProductionIsComplete extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qValidateMaterialCoProductionIsComplete = new QValidateMaterialCoProductionIsComplete();

export class QUnLinkMaterialItemsFromNonConformanceResponse extends QCommandResponse {
}

export const qUnLinkMaterialItemsFromNonConformanceResponse = new QUnLinkMaterialItemsFromNonConformanceResponse();

export class QUnLinkMaterialItemsFromNonConformance extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
}

export const qUnLinkMaterialItemsFromNonConformance = new QUnLinkMaterialItemsFromNonConformance();

export class QUnlinkAutomationNodeInstanceParameterFromDCItemListResponse extends QCommandResponse {
}

export const qUnlinkAutomationNodeInstanceParameterFromDCItemListResponse = new QUnlinkAutomationNodeInstanceParameterFromDCItemListResponse();

export class QUnlinkAutomationNodeInstanceParameterFromDCItemList extends QueryObject {
    public readonly AutomationNodeInstanceWIDefinitionParameterIds = new QCollectionPath(this.withPrefix("AutomationNodeInstanceWIDefinitionParameterIds"), () => QGuidCollection);
}

export const qUnlinkAutomationNodeInstanceParameterFromDCItemList = new QUnlinkAutomationNodeInstanceParameterFromDCItemList();

export class QUnlinkWorkOrderHumanResourceResponse extends QCommandResponse {
}

export const qUnlinkWorkOrderHumanResourceResponse = new QUnlinkWorkOrderHumanResourceResponse();

export class QUnlinkWorkOrderHumanResource extends QueryObject {
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qUnlinkWorkOrderHumanResource = new QUnlinkWorkOrderHumanResource();

export class QDeleteStatusTransitionDefinitionResponse extends QCommandResponse {
}

export const qDeleteStatusTransitionDefinitionResponse = new QDeleteStatusTransitionDefinitionResponse();

export class QDeleteStatusTransitionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteStatusTransitionDefinition = new QDeleteStatusTransitionDefinition();

export class QCreateSetPointResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateSetPointResponse = new QCreateSetPointResponse();

export class QCreateSetPoint extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateSetPoint = new QCreateSetPoint();

export class QDeleteBufferResponse extends QCommandResponse {
}

export const qDeleteBufferResponse = new QDeleteBufferResponse();

export class QDeleteBuffer extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteBuffer = new QDeleteBuffer();

export class QAcceptChangeAddToBeConsumedMaterialResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeAddToBeConsumedMaterialResponse = new QAcceptChangeAddToBeConsumedMaterialResponse();

export class QAcceptChangeAddToBeConsumedMaterial extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ToBeConsumedMaterial = new QEntityPath(this.withPrefix("ToBeConsumedMaterial"), () => QToBeConsumedMaterialParameter);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qAcceptChangeAddToBeConsumedMaterial = new QAcceptChangeAddToBeConsumedMaterial();

export class QUADMCreateProcessInCatalogueResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateProcessInCatalogueResponse = new QUADMCreateProcessInCatalogueResponse();

export class QUADMCreateProcessInCatalogue extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly ExtendedProperties = new QStringPath(this.withPrefix("ExtendedProperties"));
    public readonly FinalMaterialUID = new QStringPath(this.withPrefix("FinalMaterialUID"));
    public readonly MaxQuantity = new QEntityPath(this.withPrefix("MaxQuantity"), () => QQuantityParameterType);
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityParameterType);
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
}

export const qUADMCreateProcessInCatalogue = new QUADMCreateProcessInCatalogue();

export class QDeleteWorkOrderResponse extends QCommandResponse {
}

export const qDeleteWorkOrderResponse = new QDeleteWorkOrderResponse();

export class QDeleteWorkOrder extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkOrder = new QDeleteWorkOrder();

export class QCreateOperationListResponse extends QCommandResponse {
}

export const qCreateOperationListResponse = new QCreateOperationListResponse();

export class QCreateOperationList extends QueryObject {
    public readonly OperationList = new QEntityCollectionPath(this.withPrefix("OperationList"), () => QOperationParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
}

export const qCreateOperationList = new QCreateOperationList();

export class QUnLinkLogisticWhitelistResponse extends QCommandResponse {
}

export const qUnLinkLogisticWhitelistResponse = new QUnLinkLogisticWhitelistResponse();

export class QUnLinkLogisticWhitelist extends QueryObject {
    public readonly LogisticWhitelistElementList = new QCollectionPath(this.withPrefix("LogisticWhitelistElementList"), () => QGuidCollection);
}

export const qUnLinkLogisticWhitelist = new QUnLinkLogisticWhitelist();

export class QCreateToBeUsedMachinePJFFromProcessResponse extends QCommandResponse {
}

export const qCreateToBeUsedMachinePJFFromProcessResponse = new QCreateToBeUsedMachinePJFFromProcessResponse();

export class QCreateToBeUsedMachinePJFFromProcess extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedId = new QGuidPath(this.withPrefix("AsPlannedId"));
}

export const qCreateToBeUsedMachinePJFFromProcess = new QCreateToBeUsedMachinePJFFromProcess();

export class QDeleteActualUsedToolResponse extends QCommandResponse {
}

export const qDeleteActualUsedToolResponse = new QDeleteActualUsedToolResponse();

export class QDeleteActualUsedTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteActualUsedTool = new QDeleteActualUsedTool();

export class QUnlinkSkillsFromProcessOperationResponse extends QCommandResponse {
}

export const qUnlinkSkillsFromProcessOperationResponse = new QUnlinkSkillsFromProcessOperationResponse();

export class QUnlinkSkillsFromProcessOperation extends QueryObject {
    public readonly OperationSkillIds = new QCollectionPath(this.withPrefix("OperationSkillIds"), () => QGuidCollection);
}

export const qUnlinkSkillsFromProcessOperation = new QUnlinkSkillsFromProcessOperation();

export class QCreateTemplateBlockResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateTemplateBlockResponse = new QCreateTemplateBlockResponse();

export class QCreateTemplateBlock extends QueryObject {
    public readonly BlockInfo = new QEntityPath(this.withPrefix("BlockInfo"), () => QIdTemplateBlockInfoParameterType);
    public readonly BlockType = new QStringPath(this.withPrefix("BlockType"));
    public readonly IdTemplate = new QGuidPath(this.withPrefix("IdTemplate"));
}

export const qCreateTemplateBlock = new QCreateTemplateBlock();

export class QCreateActualUsedMachinePJFResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateActualUsedMachinePJFResponse = new QCreateActualUsedMachinePJFResponse();

export class QCreateActualUsedMachinePJF extends QueryObject {
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly ActualUsedMachineId = new QGuidPath(this.withPrefix("ActualUsedMachineId"));
    public readonly EG_PhaseId = new QGuidPath(this.withPrefix("EG_PhaseId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
}

export const qCreateActualUsedMachinePJF = new QCreateActualUsedMachinePJF();

export class QUpdateTemplateBlockResponse extends QCommandResponse {
}

export const qUpdateTemplateBlockResponse = new QUpdateTemplateBlockResponse();

export class QUpdateTemplateBlock extends QueryObject {
    public readonly BlockInfo = new QEntityPath(this.withPrefix("BlockInfo"), () => QIdTemplateBlockInfoParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateTemplateBlock = new QUpdateTemplateBlock();

export class QCreatePauseReasonResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreatePauseReasonResponse = new QCreatePauseReasonResponse();

export class QCreatePauseReason extends QueryObject {
    public readonly Location = new QStringPath(this.withPrefix("Location"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreatePauseReason = new QCreatePauseReason();

export class QDeleteOperationResponse extends QCommandResponse {
}

export const qDeleteOperationResponse = new QDeleteOperationResponse();

export class QDeleteOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteOperation = new QDeleteOperation();

export class QGetMaterialItemListForVerifyWorkOrderOperationResponse extends QCommandResponse {
    public readonly MaterialItemForVerify = new QEntityCollectionPath(this.withPrefix("MaterialItemForVerify"), () => QMaterialItemForVerify);
}

export const qGetMaterialItemListForVerifyWorkOrderOperationResponse = new QGetMaterialItemListForVerifyWorkOrderOperationResponse();

export class QGetMaterialItemListForVerifyWorkOrderOperation extends QueryObject {
}

export const qGetMaterialItemListForVerifyWorkOrderOperation = new QGetMaterialItemListForVerifyWorkOrderOperation();

export class QDeleteEquipmentConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationResponse = new QDeleteEquipmentConfigurationResponse();

export class QDeleteEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentConfiguration = new QDeleteEquipmentConfiguration();

export class QUpdateNonProductiveActivityForUserResponse extends QCommandResponse {
}

export const qUpdateNonProductiveActivityForUserResponse = new QUpdateNonProductiveActivityForUserResponse();

export class QUpdateNonProductiveActivityForUser extends QueryObject {
    public readonly UserNPAId = new QGuidPath(this.withPrefix("UserNPAId"));
    public readonly NPAUserParameter = new QEntityPath(this.withPrefix("NPAUserParameter"), () => QNPAUserParameterType);
}

export const qUpdateNonProductiveActivityForUser = new QUpdateNonProductiveActivityForUser();

export class QCreateNonConformanceStatusResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateNonConformanceStatusResponse = new QCreateNonConformanceStatusResponse();

export class QCreateNonConformanceStatus extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateNonConformanceStatus = new QCreateNonConformanceStatus();

export class QUpdateNonConformanceLifecycleResponse extends QCommandResponse {
}

export const qUpdateNonConformanceLifecycleResponse = new QUpdateNonConformanceLifecycleResponse();

export class QUpdateNonConformanceLifecycle extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly InitialStatus = new QStringPath(this.withPrefix("InitialStatus"));
}

export const qUpdateNonConformanceLifecycle = new QUpdateNonConformanceLifecycle();

export class QCheckInCreateNonConformanceResponse extends QCommandResponse {
}

export const qCheckInCreateNonConformanceResponse = new QCheckInCreateNonConformanceResponse();

export class QCheckInCreateNonConformance extends QueryObject {
    public readonly NonConformanceProperties = new QEntityPath(this.withPrefix("NonConformanceProperties"), () => QNonConformancePropertyType);
    public readonly DefectList = new QEntityCollectionPath(this.withPrefix("DefectList"), () => QDefectParameterType);
    public readonly ChangeOperationProperties = new QEntityPath(this.withPrefix("ChangeOperationProperties"), () => QChangeOperationParameterType);
    public readonly ChangePartProperties = new QEntityPath(this.withPrefix("ChangePartProperties"), () => QChangePartParameterType);
    public readonly ChangeDataCollectionProperties = new QEntityPath(this.withPrefix("ChangeDataCollectionProperties"), () => QChangeDataCollectionParameterType);
    public readonly QualityNonConformanceProperties = new QEntityPath(this.withPrefix("QualityNonConformanceProperties"), () => QQualityNonConformancePropertiesType);
    public readonly AttachmentList = new QEntityCollectionPath(this.withPrefix("AttachmentList"), () => QNonConformanceAttachmentParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInCreateNonConformance = new QCheckInCreateNonConformance();

export class QDeleteEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGroupConfigurationResponse = new QDeleteEquipmentGroupConfigurationResponse();

export class QDeleteEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGroupConfiguration = new QDeleteEquipmentGroupConfiguration();

export class QRetrieveAllFilterQCDataResponse extends QCommandResponse {
}

export const qRetrieveAllFilterQCDataResponse = new QRetrieveAllFilterQCDataResponse();

export class QRetrieveAllFilterQCData extends QueryObject {
    public readonly QualifCriteriaList = new QEntityCollectionPath(this.withPrefix("QualifCriteriaList"), () => QQualificationCriteriaParameterType);
    public readonly Entities = new QCollectionPath(this.withPrefix("Entities"), () => QStringCollection);
    public readonly ErpOrderNId = new QStringPath(this.withPrefix("ErpOrderNId"));
    public readonly MaterialInstanceNId = new QStringPath(this.withPrefix("MaterialInstanceNId"));
    public readonly FileIdContainerNId = new QStringPath(this.withPrefix("FileIdContainerNId"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
}

export const qRetrieveAllFilterQCData = new QRetrieveAllFilterQCData();

export class QDeleteSnagAndNoteNotificationListResponse extends QCommandResponse {
}

export const qDeleteSnagAndNoteNotificationListResponse = new QDeleteSnagAndNoteNotificationListResponse();

export class QDeleteSnagAndNoteNotificationList extends QueryObject {
    public readonly SnagAndNoteNotificationIdList = new QCollectionPath(this.withPrefix("SnagAndNoteNotificationIdList"), () => QGuidCollection);
}

export const qDeleteSnagAndNoteNotificationList = new QDeleteSnagAndNoteNotificationList();

export class QDeleteStateMachineResponse extends QCommandResponse {
}

export const qDeleteStateMachineResponse = new QDeleteStateMachineResponse();

export class QDeleteStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteStateMachine = new QDeleteStateMachine();

export class QCopyToBeProducedFacetsResponse extends QCommandResponse {
    public readonly PairFacetIds = new QEntityCollectionPath(this.withPrefix("PairFacetIds"), () => QCopyToBeProducedFacetsOutputParameterType);
}

export const qCopyToBeProducedFacetsResponse = new QCopyToBeProducedFacetsResponse();

export class QCopyToBeProducedFacets extends QueryObject {
    public readonly FacetIds = new QCollectionPath(this.withPrefix("FacetIds"), () => QGuidCollection);
}

export const qCopyToBeProducedFacets = new QCopyToBeProducedFacets();

export class QChangeSetPointStatusResponse extends QCommandResponse {
}

export const qChangeSetPointStatusResponse = new QChangeSetPointStatusResponse();

export class QChangeSetPointStatus extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qChangeSetPointStatus = new QChangeSetPointStatus();

export class QReleaseTransportOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qReleaseTransportOperationResponse = new QReleaseTransportOperationResponse();

export class QReleaseTransportOperation extends QueryObject {
    public readonly TransportOperationId = new QGuidPath(this.withPrefix("TransportOperationId"));
}

export const qReleaseTransportOperation = new QReleaseTransportOperation();

export class QUnlinkSkillsFromCertificateResponse extends QCommandResponse {
}

export const qUnlinkSkillsFromCertificateResponse = new QUnlinkSkillsFromCertificateResponse();

export class QUnlinkSkillsFromCertificate extends QueryObject {
    public readonly SkillCertificationAssociationIds = new QCollectionPath(this.withPrefix("SkillCertificationAssociationIds"), () => QGuidCollection);
}

export const qUnlinkSkillsFromCertificate = new QUnlinkSkillsFromCertificate();

export class QCreateDefectTypeContextualizationResponse extends QCommandResponse {
}

export const qCreateDefectTypeContextualizationResponse = new QCreateDefectTypeContextualizationResponse();

export class QCreateDefectTypeContextualization extends QueryObject {
    public readonly DefectType = new QGuidPath(this.withPrefix("DefectType"));
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
    public readonly EquipmentConfigurationList = new QCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qCreateDefectTypeContextualization = new QCreateDefectTypeContextualization();

export class QUnlinkMachineDefinitionToSetPointResponse extends QCommandResponse {
}

export const qUnlinkMachineDefinitionToSetPointResponse = new QUnlinkMachineDefinitionToSetPointResponse();

export class QUnlinkMachineDefinitionToSetPoint extends QueryObject {
    public readonly SetPointMachineDefinitionList = new QCollectionPath(this.withPrefix("SetPointMachineDefinitionList"), () => QGuidCollection);
}

export const qUnlinkMachineDefinitionToSetPoint = new QUnlinkMachineDefinitionToSetPoint();

export class QDeleteCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly NotDeletedIds = new QCollectionPath(this.withPrefix("NotDeletedIds"), () => QGuidCollection);
}

export const qDeleteCharacteristicSpecificationResponse = new QDeleteCharacteristicSpecificationResponse();

export class QDeleteCharacteristicSpecification extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteCharacteristicSpecification = new QDeleteCharacteristicSpecification();

export class QLinkSkillsToWorkOrderOperationResponse extends QCommandResponse {
}

export const qLinkSkillsToWorkOrderOperationResponse = new QLinkSkillsToWorkOrderOperationResponse();

export class QLinkSkillsToWorkOrderOperation extends QueryObject {
    public readonly SkillLevel = new QNumberPath(this.withPrefix("SkillLevel"));
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qLinkSkillsToWorkOrderOperation = new QLinkSkillsToWorkOrderOperation();

export class QTCM2CreateOperationListResponse extends QCommandResponse {
}

export const qTCM2CreateOperationListResponse = new QTCM2CreateOperationListResponse();

export class QTCM2CreateOperationList extends QueryObject {
    public readonly OperationList = new QEntityCollectionPath(this.withPrefix("OperationList"), () => QTCM2OperationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateOperationList = new QTCM2CreateOperationList();

export class QDeleteToolHistoryActionResponse extends QCommandResponse {
}

export const qDeleteToolHistoryActionResponse = new QDeleteToolHistoryActionResponse();

export class QDeleteToolHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteToolHistoryAction = new QDeleteToolHistoryAction();

export class QLink3DPrinterToEquipmentResponse extends QCommandResponse {
}

export const qLink3DPrinterToEquipmentResponse = new QLink3DPrinterToEquipmentResponse();

export class QLink3DPrinterToEquipment extends QueryObject {
    public readonly Link3DPrinterToEquipmentList = new QEntityCollectionPath(this.withPrefix("Link3DPrinterToEquipmentList"), () => QLink3DPrinterparameterType);
}

export const qLink3DPrinterToEquipment = new QLink3DPrinterToEquipment();

export class QUpdateEquipmentConfigurationResponse extends QCommandResponse {
    public readonly PropertyIds = new QCollectionPath(this.withPrefix("PropertyIds"), () => QGuidCollection);
}

export const qUpdateEquipmentConfigurationResponse = new QUpdateEquipmentConfigurationResponse();

export class QUpdateEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyParameterType);
}

export const qUpdateEquipmentConfiguration = new QUpdateEquipmentConfiguration();

export class QDeleteSnagAndNoteResponse extends QCommandResponse {
}

export const qDeleteSnagAndNoteResponse = new QDeleteSnagAndNoteResponse();

export class QDeleteSnagAndNote extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteSnagAndNote = new QDeleteSnagAndNote();

export class QDeleteResultTypeListResponse extends QCommandResponse {
}

export const qDeleteResultTypeListResponse = new QDeleteResultTypeListResponse();

export class QDeleteResultTypeList extends QueryObject {
    public readonly ResultIdList = new QCollectionPath(this.withPrefix("ResultIdList"), () => QGuidCollection);
}

export const qDeleteResultTypeList = new QDeleteResultTypeList();

export class QGenerateRuntimePrintJobFileResponse extends QCommandResponse {
}

export const qGenerateRuntimePrintJobFileResponse = new QGenerateRuntimePrintJobFileResponse();

export class QGenerateRuntimePrintJobFile extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly SerialNumberList = new QCollectionPath(this.withPrefix("SerialNumberList"), () => QGuidCollection);
    public readonly PrintJobFileId = new QGuidPath(this.withPrefix("PrintJobFileId"));
    public readonly PluginName = new QStringPath(this.withPrefix("PluginName"));
    public readonly MachineId = new QGuidPath(this.withPrefix("MachineId"));
    public readonly ActualUsedMachineId = new QGuidPath(this.withPrefix("ActualUsedMachineId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EG_PhaseId = new QGuidPath(this.withPrefix("EG_PhaseId"));
}

export const qGenerateRuntimePrintJobFile = new QGenerateRuntimePrintJobFile();

export class QUpdateNonConformanceResponse extends QCommandResponse {
}

export const qUpdateNonConformanceResponse = new QUpdateNonConformanceResponse();

export class QUpdateNonConformance extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ChangeOperationProperty = new QEntityPath(this.withPrefix("ChangeOperationProperty"), () => QChangeOperationParameterType);
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly ChangeWorkInstructionProperty = new QEntityPath(this.withPrefix("ChangeWorkInstructionProperty"), () => QChangeDataCollectionParameterType);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ChangeRoutingProperty = new QEntityPath(this.withPrefix("ChangeRoutingProperty"), () => QChangeRoutingParameterType);
}

export const qUpdateNonConformance = new QUpdateNonConformance();

export class QCreateWorkOrderOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderOperationResponse = new QCreateWorkOrderOperationResponse();

export class QCreateWorkOrderOperation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperationParameter);
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
}

export const qCreateWorkOrderOperation = new QCreateWorkOrderOperation();

export class QCreateWorkOOperationDependenciesResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QStringCollection);
}

export const qCreateWorkOOperationDependenciesResponse = new QCreateWorkOOperationDependenciesResponse();

export class QCreateWorkOOperationDependencies extends QueryObject {
    public readonly Dependencies = new QEntityCollectionPath(this.withPrefix("Dependencies"), () => QWorkOOperationDependencyParameter);
}

export const qCreateWorkOOperationDependencies = new QCreateWorkOOperationDependencies();

export class QDeleteNonConformanceResponse extends QCommandResponse {
}

export const qDeleteNonConformanceResponse = new QDeleteNonConformanceResponse();

export class QDeleteNonConformance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteNonConformance = new QDeleteNonConformance();

export class QAcceptChangeRepeatOperationResponse extends QCommandResponse {
    public readonly WorkOrderOperationIds = new QCollectionPath(this.withPrefix("WorkOrderOperationIds"), () => QGuidCollection);
}

export const qAcceptChangeRepeatOperationResponse = new QAcceptChangeRepeatOperationResponse();

export class QAcceptChangeRepeatOperation extends QueryObject {
    public readonly ChangeDetails = new QEntityCollectionPath(this.withPrefix("ChangeDetails"), () => QRepeatOperationChangeParameter);
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly AfterWorkOperationId = new QGuidPath(this.withPrefix("AfterWorkOperationId"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
}

export const qAcceptChangeRepeatOperation = new QAcceptChangeRepeatOperation();

export class QLinkPrintJobFileToMachineResponse extends QCommandResponse {
}

export const qLinkPrintJobFileToMachineResponse = new QLinkPrintJobFileToMachineResponse();

export class QLinkPrintJobFileToMachine extends QueryObject {
    public readonly PrintJobFileToMachine = new QGuidPath(this.withPrefix("PrintJobFileToMachine"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
}

export const qLinkPrintJobFileToMachine = new QLinkPrintJobFileToMachine();

export class QLinkSkillsToTeamResponse extends QCommandResponse {
}

export const qLinkSkillsToTeamResponse = new QLinkSkillsToTeamResponse();

export class QLinkSkillsToTeam extends QueryObject {
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly TeamId = new QGuidPath(this.withPrefix("TeamId"));
}

export const qLinkSkillsToTeam = new QLinkSkillsToTeam();

export class QLinkWorkInstructionsToContainerResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWorkInstructionsToContainerResponse = new QLinkWorkInstructionsToContainerResponse();

export class QLinkWorkInstructionsToContainer extends QueryObject {
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ContainerNIds = new QCollectionPath(this.withPrefix("ContainerNIds"), () => QStringCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qLinkWorkInstructionsToContainer = new QLinkWorkInstructionsToContainer();

export class QUnlinkPartProgramFromEquipmentSpecificationResponse extends QCommandResponse {
}

export const qUnlinkPartProgramFromEquipmentSpecificationResponse = new QUnlinkPartProgramFromEquipmentSpecificationResponse();

export class QUnlinkPartProgramFromEquipmentSpecification extends QueryObject {
    public readonly EquipmentSpecification = new QGuidPath(this.withPrefix("EquipmentSpecification"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
}

export const qUnlinkPartProgramFromEquipmentSpecification = new QUnlinkPartProgramFromEquipmentSpecification();

export class QCreateHoldReasonResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateHoldReasonResponse = new QCreateHoldReasonResponse();

export class QCreateHoldReason extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qCreateHoldReason = new QCreateHoldReason();

export class QDisassembleMaterialItemLiteResponse extends QCommandResponse {
    public readonly DisassembledDMMTUIds = new QCollectionPath(this.withPrefix("DisassembledDMMTUIds"), () => QGuidCollection);
    public readonly DisassembledMaterialItemList = new QEntityCollectionPath(this.withPrefix("DisassembledMaterialItemList"), () => QDisassembledMaterialItemParameterType);
}

export const qDisassembleMaterialItemLiteResponse = new QDisassembleMaterialItemLiteResponse();

export class QDisassembleMaterialItemLite extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProducedDMMaterialTrackingUnitId = new QGuidPath(this.withPrefix("ProducedDMMaterialTrackingUnitId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qDisassembleMaterialItemLite = new QDisassembleMaterialItemLite();

export class QStartWOStepFullQtyResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qStartWOStepFullQtyResponse = new QStartWOStepFullQtyResponse();

export class QStartWOStepFullQty extends QueryObject {
    public readonly StartWOStepFullQtyParameter = new QEntityPath(this.withPrefix("StartWOStepFullQtyParameter"), () => QStartWOStepFullQtyParameterType);
}

export const qStartWOStepFullQty = new QStartWOStepFullQty();

export class QUnlinkOperationDependencyToProcessResponse extends QCommandResponse {
}

export const qUnlinkOperationDependencyToProcessResponse = new QUnlinkOperationDependencyToProcessResponse();

export class QUnlinkOperationDependencyToProcess extends QueryObject {
    public readonly OperationDependencyId = new QGuidPath(this.withPrefix("OperationDependencyId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
}

export const qUnlinkOperationDependencyToProcess = new QUnlinkOperationDependencyToProcess();

export class QUpdateWorkOStepDependencyResponse extends QCommandResponse {
}

export const qUpdateWorkOStepDependencyResponse = new QUpdateWorkOStepDependencyResponse();

export class QUpdateWorkOStepDependency extends QueryObject {
    public readonly Dependency = new QEntityPath(this.withPrefix("Dependency"), () => QWorkOStepDependencyParameter);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateWorkOStepDependency = new QUpdateWorkOStepDependency();

export class QCreateNonConformanceOnContainerContentResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceHistoryIds = new QCollectionPath(this.withPrefix("NonConformanceHistoryIds"), () => QGuidCollection);
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
}

export const qCreateNonConformanceOnContainerContentResponse = new QCreateNonConformanceOnContainerContentResponse();

export class QCreateNonConformanceOnContainerContent extends QueryObject {
    public readonly DefectList = new QEntityCollectionPath(this.withPrefix("DefectList"), () => QDefectParameterType);
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ContainerNidList = new QCollectionPath(this.withPrefix("ContainerNidList"), () => QStringCollection);
    public readonly NonConformanceProperties = new QEntityPath(this.withPrefix("NonConformanceProperties"), () => QNonConformancePropertyType);
    public readonly AttachmentList = new QEntityCollectionPath(this.withPrefix("AttachmentList"), () => QNonConformanceAttachmentParameterType);
}

export const qCreateNonConformanceOnContainerContent = new QCreateNonConformanceOnContainerContent();

export class QDeleteReworkCodeListResponse extends QCommandResponse {
}

export const qDeleteReworkCodeListResponse = new QDeleteReworkCodeListResponse();

export class QDeleteReworkCodeList extends QueryObject {
    public readonly UId = new QCollectionPath(this.withPrefix("UId"), () => QGuidCollection);
}

export const qDeleteReworkCodeList = new QDeleteReworkCodeList();

export class QUnlinkMaterialFromContainerTypeListResponse extends QCommandResponse {
}

export const qUnlinkMaterialFromContainerTypeListResponse = new QUnlinkMaterialFromContainerTypeListResponse();

export class QUnlinkMaterialFromContainerTypeList extends QueryObject {
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly CompatibleMaterialList = new QEntityCollectionPath(this.withPrefix("CompatibleMaterialList"), () => QMaterialParameterType);
}

export const qUnlinkMaterialFromContainerTypeList = new QUnlinkMaterialFromContainerTypeList();

export class QCreateToBeUsedToolsResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateToBeUsedToolsResponse = new QCreateToBeUsedToolsResponse();

export class QCreateToBeUsedTools extends QueryObject {
    public readonly ToBeUsedTools = new QEntityCollectionPath(this.withPrefix("ToBeUsedTools"), () => QToBeUsedToolParameter);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qCreateToBeUsedTools = new QCreateToBeUsedTools();

export class QDiscardOfflineSessionListResponse extends QCommandResponse {
}

export const qDiscardOfflineSessionListResponse = new QDiscardOfflineSessionListResponse();

export class QDiscardOfflineSessionList extends QueryObject {
    public readonly OfflineSessionIds = new QCollectionPath(this.withPrefix("OfflineSessionIds"), () => QGuidCollection);
}

export const qDiscardOfflineSessionList = new QDiscardOfflineSessionList();

export class QLinkStepToOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qLinkStepToOperationResponse = new QLinkStepToOperationResponse();

export class QLinkStepToOperation extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qLinkStepToOperation = new QLinkStepToOperation();

export class QGetPJFsHookOnLinkToBeUsedMachineToPJFResponse extends QCommandResponse {
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
}

export const qGetPJFsHookOnLinkToBeUsedMachineToPJFResponse = new QGetPJFsHookOnLinkToBeUsedMachineToPJFResponse();

export class QGetPJFsHookOnLinkToBeUsedMachineToPJF extends QueryObject {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
}

export const qGetPJFsHookOnLinkToBeUsedMachineToPJF = new QGetPJFsHookOnLinkToBeUsedMachineToPJF();

export class QDeleteOperationStepCategoryListResponse extends QCommandResponse {
}

export const qDeleteOperationStepCategoryListResponse = new QDeleteOperationStepCategoryListResponse();

export class QDeleteOperationStepCategoryList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteOperationStepCategoryList = new QDeleteOperationStepCategoryList();

export class QUseToolListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
    public readonly ToolHistoryIds = new QCollectionPath(this.withPrefix("ToolHistoryIds"), () => QGuidCollection);
    public readonly TimesOfToolUsage = new QEntityCollectionPath(this.withPrefix("TimesOfToolUsage"), () => QTimesOfToolUsageParameterType);
}

export const qUseToolListResponse = new QUseToolListResponse();

export class QUseToolList extends QueryObject {
    public readonly ToolToBeUsedList = new QEntityCollectionPath(this.withPrefix("ToolToBeUsedList"), () => QToolToBeUsedOnSNParameterType);
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUseToolList = new QUseToolList();

export class QMixAMPowderBatchListResponse extends QCommandResponse {
    public readonly AMPowderBatchMixedId = new QGuidPath(this.withPrefix("AMPowderBatchMixedId"));
}

export const qMixAMPowderBatchListResponse = new QMixAMPowderBatchListResponse();

export class QMixAMPowderBatchList extends QueryObject {
    public readonly AMPowderBatchList = new QEntityPath(this.withPrefix("AMPowderBatchList"), () => QAMPowderBatchMixParameterType);
    public readonly AMPowderBatchFake = new QEntityPath(this.withPrefix("AMPowderBatchFake"), () => QAMPowderBatchFakeParameterType);
}

export const qMixAMPowderBatchList = new QMixAMPowderBatchList();

export class QCreateBuyOffForActiveMTUsResponse extends QCommandResponse {
}

export const qCreateBuyOffForActiveMTUsResponse = new QCreateBuyOffForActiveMTUsResponse();

export class QCreateBuyOffForActiveMTUs extends QueryObject {
    public readonly RuntimeCharReprNId = new QStringPath(this.withPrefix("RuntimeCharReprNId"));
    public readonly TargetCodes = new QCollectionPath(this.withPrefix("TargetCodes"), () => QStringCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qCreateBuyOffForActiveMTUs = new QCreateBuyOffForActiveMTUs();

export class QFilterInputResultsOnUndoRepeatWOOpStrategyResponse extends QCommandResponse {
    public readonly InputMTUsWithNoResultToSkip = new QEntityCollectionPath(this.withPrefix("InputMTUsWithNoResultToSkip"), () => QCompletedMTUParameterType);
}

export const qFilterInputResultsOnUndoRepeatWOOpStrategyResponse = new QFilterInputResultsOnUndoRepeatWOOpStrategyResponse();

export class QFilterInputResultsOnUndoRepeatWOOpStrategy extends QueryObject {
    public readonly InputMTUsWithNoResult = new QEntityCollectionPath(this.withPrefix("InputMTUsWithNoResult"), () => QCompletedMTUParameterType);
}

export const qFilterInputResultsOnUndoRepeatWOOpStrategy = new QFilterInputResultsOnUndoRepeatWOOpStrategy();

export class QCompleteNonProductiveActivityListResponse extends QCommandResponse {
}

export const qCompleteNonProductiveActivityListResponse = new QCompleteNonProductiveActivityListResponse();

export class QCompleteNonProductiveActivityList extends QueryObject {
    public readonly UserNPAIds = new QCollectionPath(this.withPrefix("UserNPAIds"), () => QGuidCollection);
}

export const qCompleteNonProductiveActivityList = new QCompleteNonProductiveActivityList();

export class QCreateNonConformanceV3_1Response extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceHistoryIds = new QCollectionPath(this.withPrefix("NonConformanceHistoryIds"), () => QGuidCollection);
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
}

export const qCreateNonConformanceV3_1Response = new QCreateNonConformanceV3_1Response();

export class QCreateNonConformanceV3_1 extends QueryObject {
    public readonly NonConformanceProperties = new QEntityPath(this.withPrefix("NonConformanceProperties"), () => QNonConformancePropertyType);
    public readonly DefectList = new QEntityCollectionPath(this.withPrefix("DefectList"), () => QDefectParameterType);
    public readonly ChangeOperationProperties = new QEntityPath(this.withPrefix("ChangeOperationProperties"), () => QChangeOperationParameterType);
    public readonly ChangePartProperties = new QEntityPath(this.withPrefix("ChangePartProperties"), () => QChangePartParameterType);
    public readonly ChangeDataCollectionProperties = new QEntityPath(this.withPrefix("ChangeDataCollectionProperties"), () => QChangeDataCollectionParameterType);
    public readonly QualityNonConformanceProperties = new QEntityPath(this.withPrefix("QualityNonConformanceProperties"), () => QQualityNonConformancePropertiesType);
    public readonly AttachmentList = new QEntityCollectionPath(this.withPrefix("AttachmentList"), () => QNonConformanceAttachmentParameterType);
    public readonly IsAutomatic = new QBooleanPath(this.withPrefix("IsAutomatic"));
    public readonly ChangeToolProperties = new QEntityPath(this.withPrefix("ChangeToolProperties"), () => QChangeToolParameterType);
    public readonly ChangeRoutingProperties = new QEntityPath(this.withPrefix("ChangeRoutingProperties"), () => QChangeRoutingParameterType);
}

export const qCreateNonConformanceV3_1 = new QCreateNonConformanceV3_1();

export class QCreateOperationStepCategoryResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateOperationStepCategoryResponse = new QCreateOperationStepCategoryResponse();

export class QCreateOperationStepCategory extends QueryObject {
    public readonly OperationStepCategory = new QEntityPath(this.withPrefix("OperationStepCategory"), () => QOperationStepCategoryType);
}

export const qCreateOperationStepCategory = new QCreateOperationStepCategory();

export class QTCM2CompleteMasterPlanResponse extends QCommandResponse {
}

export const qTCM2CompleteMasterPlanResponse = new QTCM2CompleteMasterPlanResponse();

export class QTCM2CompleteMasterPlan extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CompleteMasterPlan = new QTCM2CompleteMasterPlan();

export class QCreateStepListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qCreateStepListResponse = new QCreateStepListResponse();

export class QCreateStepList extends QueryObject {
    public readonly Steps = new QEntityCollectionPath(this.withPrefix("Steps"), () => QStepCatalogueParameterType);
}

export const qCreateStepList = new QCreateStepList();

export class QGetToBeProducedMaterialsResultOpListResponse extends QCommandResponse {
    public readonly OpAndToBeProducedIdKoPairList = new QEntityCollectionPath(this.withPrefix("OpAndToBeProducedIdKoPairList"), () => QToBeProducedIdAndOpId);
    public readonly OpAndDMMtuIdKoPairList = new QEntityCollectionPath(this.withPrefix("OpAndDMMtuIdKoPairList"), () => QDM_MTUIdAndOpId);
}

export const qGetToBeProducedMaterialsResultOpListResponse = new QGetToBeProducedMaterialsResultOpListResponse();

export class QGetToBeProducedMaterialsResultOpList extends QueryObject {
    public readonly WOOpIdList = new QCollectionPath(this.withPrefix("WOOpIdList"), () => QGuidCollection);
    public readonly OpAndToBeProducedIdPairList = new QEntityCollectionPath(this.withPrefix("OpAndToBeProducedIdPairList"), () => QToBeProducedIdAndOpId);
    public readonly OpAndDMMtuIdPairList = new QEntityCollectionPath(this.withPrefix("OpAndDMMtuIdPairList"), () => QDM_MTUIdAndOpId);
}

export const qGetToBeProducedMaterialsResultOpList = new QGetToBeProducedMaterialsResultOpList();

export class QLinkWorkOrderHumanResourceResponse extends QCommandResponse {
}

export const qLinkWorkOrderHumanResourceResponse = new QLinkWorkOrderHumanResourceResponse();

export class QLinkWorkOrderHumanResource extends QueryObject {
    public readonly CertificationNId = new QCollectionPath(this.withPrefix("CertificationNId"), () => QStringCollection);
    public readonly RequiredNumberOfHumanResource = new QCollectionPath(this.withPrefix("RequiredNumberOfHumanResource"), () => QNumberCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qLinkWorkOrderHumanResource = new QLinkWorkOrderHumanResource();

export class QCreateStatusBehaviorDefinitionResponse extends QCommandResponse {
    public readonly StatusBehaviorDefinitionId = new QGuidPath(this.withPrefix("StatusBehaviorDefinitionId"));
}

export const qCreateStatusBehaviorDefinitionResponse = new QCreateStatusBehaviorDefinitionResponse();

export class QCreateStatusBehaviorDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateStatusBehaviorDefinition = new QCreateStatusBehaviorDefinition();

export class QUpdateAMPowderBatchResponse extends QCommandResponse {
    public readonly AMPowderBatchStatus = new QStringPath(this.withPrefix("AMPowderBatchStatus"));
}

export const qUpdateAMPowderBatchResponse = new QUpdateAMPowderBatchResponse();

export class QUpdateAMPowderBatch extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qUpdateAMPowderBatch = new QUpdateAMPowderBatch();

export class QSetNonConformanceStatusIsScrappedResponse extends QCommandResponse {
}

export const qSetNonConformanceStatusIsScrappedResponse = new QSetNonConformanceStatusIsScrappedResponse();

export class QSetNonConformanceStatusIsScrapped extends QueryObject {
    public readonly NonConformanceStatusId = new QGuidPath(this.withPrefix("NonConformanceStatusId"));
    public readonly NonConformanceLifecycleId = new QGuidPath(this.withPrefix("NonConformanceLifecycleId"));
    public readonly IsScrap = new QBooleanPath(this.withPrefix("IsScrap"));
}

export const qSetNonConformanceStatusIsScrapped = new QSetNonConformanceStatusIsScrapped();

export class QUpdateEquipmentConfigurationPropertyResponse extends QCommandResponse {
    public readonly AttributeIds = new QCollectionPath(this.withPrefix("AttributeIds"), () => QGuidCollection);
}

export const qUpdateEquipmentConfigurationPropertyResponse = new QUpdateEquipmentConfigurationPropertyResponse();

export class QUpdateEquipmentConfigurationProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Attributes = new QEntityCollectionPath(this.withPrefix("Attributes"), () => QPropertyParameterType);
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentConfigurationProperty = new QUpdateEquipmentConfigurationProperty();

export class QDeleteCharacteristicFailureAssociationResponse extends QCommandResponse {
    public readonly NotDeletedIds = new QCollectionPath(this.withPrefix("NotDeletedIds"), () => QGuidCollection);
}

export const qDeleteCharacteristicFailureAssociationResponse = new QDeleteCharacteristicFailureAssociationResponse();

export class QDeleteCharacteristicFailureAssociation extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteCharacteristicFailureAssociation = new QDeleteCharacteristicFailureAssociation();

export class QUnlinkDocumentToStepResponse extends QCommandResponse {
}

export const qUnlinkDocumentToStepResponse = new QUnlinkDocumentToStepResponse();

export class QUnlinkDocumentToStep extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
}

export const qUnlinkDocumentToStep = new QUnlinkDocumentToStep();

export class QCreateActualUsedMachineResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateActualUsedMachineResponse = new QCreateActualUsedMachineResponse();

export class QCreateActualUsedMachine extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qCreateActualUsedMachine = new QCreateActualUsedMachine();

export class QUpdateCustomItlkCheckParameterListResponse extends QCommandResponse {
    public readonly ListOfItlkCheckParameterId = new QCollectionPath(this.withPrefix("ListOfItlkCheckParameterId"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateCustomItlkCheckParameterListResponse = new QUpdateCustomItlkCheckParameterListResponse();

export class QUpdateCustomItlkCheckParameterList extends QueryObject {
    public readonly ListOfItlkCheckParameter = new QEntityCollectionPath(this.withPrefix("ListOfItlkCheckParameter"), () => QCustomItlkCheckParamParameterType);
}

export const qUpdateCustomItlkCheckParameterList = new QUpdateCustomItlkCheckParameterList();

export class QCreateNonConformanceDefectListResponse extends QCommandResponse {
}

export const qCreateNonConformanceDefectListResponse = new QCreateNonConformanceDefectListResponse();

export class QCreateNonConformanceDefectList extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly DefectList = new QEntityCollectionPath(this.withPrefix("DefectList"), () => QDefectParameterType);
}

export const qCreateNonConformanceDefectList = new QCreateNonConformanceDefectList();

export class QCreateWorkOrderStepsResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateWorkOrderStepsResponse = new QCreateWorkOrderStepsResponse();

export class QCreateWorkOrderSteps extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderSteps = new QEntityCollectionPath(this.withPrefix("WorkOrderSteps"), () => QWorkOrderOperationParameter);
}

export const qCreateWorkOrderSteps = new QCreateWorkOrderSteps();

export class QCreateMaterialResponse extends QCommandResponse {
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly PropertyIds = new QCollectionPath(this.withPrefix("PropertyIds"), () => QGuidCollection);
}

export const qCreateMaterialResponse = new QCreateMaterialResponse();

export class QCreateMaterial extends QueryObject {
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly UseDefault = new QBooleanPath(this.withPrefix("UseDefault"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyParameterTypeCreate);
}

export const qCreateMaterial = new QCreateMaterial();

export class QCreateProcessResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateProcessResponse = new QCreateProcessResponse();

export class QCreateProcess extends QueryObject {
    public readonly Process = new QEntityPath(this.withPrefix("Process"), () => QProcessParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
}

export const qCreateProcess = new QCreateProcess();

export class QLinkMaterialSpecificationToOperationResponse extends QCommandResponse {
}

export const qLinkMaterialSpecificationToOperationResponse = new QLinkMaterialSpecificationToOperationResponse();

export class QLinkMaterialSpecificationToOperation extends QueryObject {
    public readonly MaterialSpecificationId = new QGuidPath(this.withPrefix("MaterialSpecificationId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qLinkMaterialSpecificationToOperation = new QLinkMaterialSpecificationToOperation();

export class QRemoveWorkOrderHoldResponse extends QCommandResponse {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qRemoveWorkOrderHoldResponse = new QRemoveWorkOrderHoldResponse();

export class QRemoveWorkOrderHold extends QueryObject {
    public readonly HoldId = new QGuidPath(this.withPrefix("HoldId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
}

export const qRemoveWorkOrderHold = new QRemoveWorkOrderHold();

export class QAcquireToolFromAutomationNodeInstanceParameterResponse extends QCommandResponse {
}

export const qAcquireToolFromAutomationNodeInstanceParameterResponse = new QAcquireToolFromAutomationNodeInstanceParameterResponse();

export class QAcquireToolFromAutomationNodeInstanceParameter extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ToolsToBeAcquireParameterType = new QEntityCollectionPath(this.withPrefix("ToolsToBeAcquireParameterType"), () => QToolToBeAcquireParameterType);
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
}

export const qAcquireToolFromAutomationNodeInstanceParameter = new QAcquireToolFromAutomationNodeInstanceParameter();

export class QUpdateNonConformanceStatusResponse extends QCommandResponse {
}

export const qUpdateNonConformanceStatusResponse = new QUpdateNonConformanceStatusResponse();

export class QUpdateNonConformanceStatus extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateNonConformanceStatus = new QUpdateNonConformanceStatus();

export class QGetWorkOrderOperationIdToStartByMachineResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderProductionType = new QStringPath(this.withPrefix("WorkOrderProductionType"));
}

export const qGetWorkOrderOperationIdToStartByMachineResponse = new QGetWorkOrderOperationIdToStartByMachineResponse();

export class QGetWorkOrderOperationIdToStartByMachine extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly ProducedMaterialItemList = new QEntityCollectionPath(this.withPrefix("ProducedMaterialItemList"), () => QProducedMaterialItemParameterType);
}

export const qGetWorkOrderOperationIdToStartByMachine = new QGetWorkOrderOperationIdToStartByMachine();

export class QLinkHumanResourceToProcessResponse extends QCommandResponse {
}

export const qLinkHumanResourceToProcessResponse = new QLinkHumanResourceToProcessResponse();

export class QLinkHumanResourceToProcess extends QueryObject {
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly CertificationNId = new QCollectionPath(this.withPrefix("CertificationNId"), () => QStringCollection);
    public readonly RequiredNumberOfHumanResource = new QCollectionPath(this.withPrefix("RequiredNumberOfHumanResource"), () => QNumberCollection);
    public readonly ParentIndicator = new QStringPath(this.withPrefix("ParentIndicator"));
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qLinkHumanResourceToProcess = new QLinkHumanResourceToProcess();

export class QStartWOStepSerializedResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qStartWOStepSerializedResponse = new QStartWOStepSerializedResponse();

export class QStartWOStepSerialized extends QueryObject {
    public readonly StartWOStepSerializedParameter = new QEntityPath(this.withPrefix("StartWOStepSerializedParameter"), () => QStartWOStepSerializedParameterType);
}

export const qStartWOStepSerialized = new QStartWOStepSerialized();

export class QCreateResultHistoryListResponse extends QCommandResponse {
    public readonly ResultHistoryIdList = new QCollectionPath(this.withPrefix("ResultHistoryIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly ResultHistoryInfo = new QEntityCollectionPath(this.withPrefix("ResultHistoryInfo"), () => QResultHistoryParamType);
}

export const qCreateResultHistoryListResponse = new QCreateResultHistoryListResponse();

export class QCreateResultHistoryList extends QueryObject {
    public readonly ResultHistoryList = new QEntityCollectionPath(this.withPrefix("ResultHistoryList"), () => QCreateResultHistoryListParameterType);
}

export const qCreateResultHistoryList = new QCreateResultHistoryList();

export class QUpdateExecutionGroupPhaseResponse extends QCommandResponse {
}

export const qUpdateExecutionGroupPhaseResponse = new QUpdateExecutionGroupPhaseResponse();

export class QUpdateExecutionGroupPhase extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly PreferredMachineNId = new QStringPath(this.withPrefix("PreferredMachineNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly ExecutionGroupPhaseName = new QStringPath(this.withPrefix("ExecutionGroupPhaseName"));
}

export const qUpdateExecutionGroupPhase = new QUpdateExecutionGroupPhase();

export class QCreateToBeProducedMaterialResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToBeProducedMaterialResponse = new QCreateToBeProducedMaterialResponse();

export class QCreateToBeProducedMaterial extends QueryObject {
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
}

export const qCreateToBeProducedMaterial = new QCreateToBeProducedMaterial();

export class QCreateToolHistoryResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolHistoryResponse = new QCreateToolHistoryResponse();

export class QCreateToolHistory extends QueryObject {
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly OldThickness = new QNumberPath(this.withPrefix("OldThickness"));
    public readonly OldTreatmentCount = new QNumberPath(this.withPrefix("OldTreatmentCount"));
    public readonly Thickness = new QNumberPath(this.withPrefix("Thickness"));
    public readonly TreatmentCount = new QNumberPath(this.withPrefix("TreatmentCount"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly UsedToolCount = new QNumberPath(this.withPrefix("UsedToolCount"));
    public readonly HistoryAction = new QGuidPath(this.withPrefix("HistoryAction"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
}

export const qCreateToolHistory = new QCreateToolHistory();

export class QTransmitToolSetPointItemToAutomationNodeParameterListResponse extends QCommandResponse {
}

export const qTransmitToolSetPointItemToAutomationNodeParameterListResponse = new QTransmitToolSetPointItemToAutomationNodeParameterListResponse();

export class QTransmitToolSetPointItemToAutomationNodeParameterList extends QueryObject {
    public readonly ToolHistoryId = new QGuidPath(this.withPrefix("ToolHistoryId"));
    public readonly SetPointItemsToBeTransmitted = new QEntityPath(this.withPrefix("SetPointItemsToBeTransmitted"), () => QSetPointParameterType);
}

export const qTransmitToolSetPointItemToAutomationNodeParameterList = new QTransmitToolSetPointItemToAutomationNodeParameterList();

export class QCreateCharacteristicRepresentationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateCharacteristicRepresentationResponse = new QCreateCharacteristicRepresentationResponse();

export class QCreateCharacteristicRepresentation extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly CharacteristicSpecificationId = new QGuidPath(this.withPrefix("CharacteristicSpecificationId"));
    public readonly SampleSize = new QNumberPath(this.withPrefix("SampleSize"));
    public readonly CanBeSkipped = new QBooleanPath(this.withPrefix("CanBeSkipped"));
    public readonly ScenarioNId = new QStringPath(this.withPrefix("ScenarioNId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly CharacteristicRepresentationFrequencyId = new QGuidPath(this.withPrefix("CharacteristicRepresentationFrequencyId"));
    public readonly CharacteristicRepresentationFrequencyValue = new QNumberPath(this.withPrefix("CharacteristicRepresentationFrequencyValue"));
    public readonly TimeBasedScheduleMode = new QStringPath(this.withPrefix("TimeBasedScheduleMode"));
    public readonly TimeBasedMandatoryInspectionWarningValue = new QNumberPath(this.withPrefix("TimeBasedMandatoryInspectionWarningValue"));
    public readonly TimeBasedMandatoryInspectionWarningUoMNId = new QEnumPath(this.withPrefix("TimeBasedMandatoryInspectionWarningUoMNId"), TimeBasedUoM);
}

export const qCreateCharacteristicRepresentation = new QCreateCharacteristicRepresentation();

export class QCreateBoMV4_0Response extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBoMV4_0Response = new QCreateBoMV4_0Response();

export class QCreateBoMV4_0 extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly ValidFrom = new QDateTimeOffsetPath(this.withPrefix("ValidFrom"));
    public readonly ValidTo = new QDateTimeOffsetPath(this.withPrefix("ValidTo"));
    public readonly MaterialProperties = new QEntityPath(this.withPrefix("MaterialProperties"), () => QDM_MaterialParameterType);
}

export const qCreateBoMV4_0 = new QCreateBoMV4_0();

export class QGetCurrentUserRolesResponse extends QCommandResponse {
    public readonly roles = new QCollectionPath(this.withPrefix("roles"), () => QStringCollection);
}

export const qGetCurrentUserRolesResponse = new QGetCurrentUserRolesResponse();

export class QGetCurrentUserRoles extends QueryObject {
}

export const qGetCurrentUserRoles = new QGetCurrentUserRoles();

export class QCreateWOOpDependencyNavigationListResponse extends QCommandResponse {
}

export const qCreateWOOpDependencyNavigationListResponse = new QCreateWOOpDependencyNavigationListResponse();

export class QCreateWOOpDependencyNavigationList extends QueryObject {
    public readonly WOOpDependencyNavigation = new QEntityCollectionPath(this.withPrefix("WOOpDependencyNavigation"), () => QWOOpDependencyNavigationParameterType);
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qCreateWOOpDependencyNavigationList = new QCreateWOOpDependencyNavigationList();

export class QCreateActualProducedMaterialResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateActualProducedMaterialResponse = new QCreateActualProducedMaterialResponse();

export class QCreateActualProducedMaterial extends QueryObject {
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly NotWorkedQuantity = new QNumberPath(this.withPrefix("NotWorkedQuantity"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly PausedQuantity = new QNumberPath(this.withPrefix("PausedQuantity"));
    public readonly ReopenedQuantity = new QNumberPath(this.withPrefix("ReopenedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly SentencedQuantity = new QNumberPath(this.withPrefix("SentencedQuantity"));
    public readonly SplitQuantity = new QNumberPath(this.withPrefix("SplitQuantity"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly MaterialItem = new QGuidPath(this.withPrefix("MaterialItem"));
    public readonly ToBeProducedMaterialId = new QGuidPath(this.withPrefix("ToBeProducedMaterialId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qCreateActualProducedMaterial = new QCreateActualProducedMaterial();

export class QCloseWorkProcessResponse extends QCommandResponse {
}

export const qCloseWorkProcessResponse = new QCloseWorkProcessResponse();

export class QCloseWorkProcess extends QueryObject {
    public readonly WorkProcessId = new QGuidPath(this.withPrefix("WorkProcessId"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
}

export const qCloseWorkProcess = new QCloseWorkProcess();

export class QGetEquipSpecWithPJFHookResponse extends QCommandResponse {
    public readonly EquipSpecWithPjfList = new QEntityCollectionPath(this.withPrefix("EquipSpecWithPjfList"), () => QEquipSpecWithPjf);
}

export const qGetEquipSpecWithPJFHookResponse = new QGetEquipSpecWithPJFHookResponse();

export class QGetEquipSpecWithPJFHook extends QueryObject {
    public readonly OperatonIdList = new QCollectionPath(this.withPrefix("OperatonIdList"), () => QGuidCollection);
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qGetEquipSpecWithPJFHook = new QGetEquipSpecWithPJFHook();

export class QTCM2AssociateDocumentToMaterialDefinitionListResponse extends QCommandResponse {
}

export const qTCM2AssociateDocumentToMaterialDefinitionListResponse = new QTCM2AssociateDocumentToMaterialDefinitionListResponse();

export class QTCM2AssociateDocumentToMaterialDefinitionList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QTCM2DocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2AssociateDocumentToMaterialDefinitionList = new QTCM2AssociateDocumentToMaterialDefinitionList();

export class QDeleteOperationDependencyResponse extends QCommandResponse {
}

export const qDeleteOperationDependencyResponse = new QDeleteOperationDependencyResponse();

export class QDeleteOperationDependency extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteOperationDependency = new QDeleteOperationDependency();

export class QDeleteWorkOrderOperationResponse extends QCommandResponse {
}

export const qDeleteWorkOrderOperationResponse = new QDeleteWorkOrderOperationResponse();

export class QDeleteWorkOrderOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkOrderOperation = new QDeleteWorkOrderOperation();

export class QEditSkillToOperationListResponse extends QCommandResponse {
}

export const qEditSkillToOperationListResponse = new QEditSkillToOperationListResponse();

export class QEditSkillToOperationList extends QueryObject {
    public readonly OperationSkillIdList = new QCollectionPath(this.withPrefix("OperationSkillIdList"), () => QGuidCollection);
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qEditSkillToOperationList = new QEditSkillToOperationList();

export class QLinkEquipmentsToBuffersResponse extends QCommandResponse {
}

export const qLinkEquipmentsToBuffersResponse = new QLinkEquipmentsToBuffersResponse();

export class QLinkEquipmentsToBuffers extends QueryObject {
    public readonly BufferIds = new QCollectionPath(this.withPrefix("BufferIds"), () => QGuidCollection);
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
}

export const qLinkEquipmentsToBuffers = new QLinkEquipmentsToBuffers();

export class QCreateTemplateResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateTemplateResponse = new QCreateTemplateResponse();

export class QCreateTemplate extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IdTemplateType = new QGuidPath(this.withPrefix("IdTemplateType"));
}

export const qCreateTemplate = new QCreateTemplate();

export class QCreateToolDefinitionDocumentListResponse extends QCommandResponse {
}

export const qCreateToolDefinitionDocumentListResponse = new QCreateToolDefinitionDocumentListResponse();

export class QCreateToolDefinitionDocumentList extends QueryObject {
    public readonly ToolDefinitionDocumentList = new QEntityCollectionPath(this.withPrefix("ToolDefinitionDocumentList"), () => QToolDefinitionDocumentParameterType);
}

export const qCreateToolDefinitionDocumentList = new QCreateToolDefinitionDocumentList();

export class QLinkDocumentToContainerTypeListResponse extends QCommandResponse {
}

export const qLinkDocumentToContainerTypeListResponse = new QLinkDocumentToContainerTypeListResponse();

export class QLinkDocumentToContainerTypeList extends QueryObject {
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly DocumentIdList = new QCollectionPath(this.withPrefix("DocumentIdList"), () => QGuidCollection);
}

export const qLinkDocumentToContainerTypeList = new QLinkDocumentToContainerTypeList();

export class QDeleteDM_MaterialTrackingUnitHistoryActionResponse extends QCommandResponse {
}

export const qDeleteDM_MaterialTrackingUnitHistoryActionResponse = new QDeleteDM_MaterialTrackingUnitHistoryActionResponse();

export class QDeleteDM_MaterialTrackingUnitHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteDM_MaterialTrackingUnitHistoryAction = new QDeleteDM_MaterialTrackingUnitHistoryAction();

export class QSentenceNonConformancePartiallyResponse extends QCommandResponse {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
}

export const qSentenceNonConformancePartiallyResponse = new QSentenceNonConformancePartiallyResponse();

export class QSentenceNonConformancePartially extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceStatusNId = new QStringPath(this.withPrefix("NonConformanceStatusNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly NewWorkOrderList = new QEntityCollectionPath(this.withPrefix("NewWorkOrderList"), () => QNewWorkOrderForSplit);
    public readonly ReworkProcessId = new QGuidPath(this.withPrefix("ReworkProcessId"));
}

export const qSentenceNonConformancePartially = new QSentenceNonConformancePartially();

export class QDeleteFunctionalCodeListV4_0Response extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteFunctionalCodeListV4_0Response = new QDeleteFunctionalCodeListV4_0Response();

export class QDeleteFunctionalCodeListV4_0 extends QueryObject {
    public readonly FunctionalCodeIds = new QCollectionPath(this.withPrefix("FunctionalCodeIds"), () => QGuidCollection);
}

export const qDeleteFunctionalCodeListV4_0 = new QDeleteFunctionalCodeListV4_0();

export class QCheckInCompleteWOStepTransferBatchResponse extends QCommandResponse {
}

export const qCheckInCompleteWOStepTransferBatchResponse = new QCheckInCompleteWOStepTransferBatchResponse();

export class QCheckInCompleteWOStepTransferBatch extends QueryObject {
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
    public readonly CompleteWOStepTransferBatchParameter = new QEntityPath(this.withPrefix("CompleteWOStepTransferBatchParameter"), () => QCompleteWOStepTransferBatchParameterType);
}

export const qCheckInCompleteWOStepTransferBatch = new QCheckInCompleteWOStepTransferBatch();

export class QCreateNewMaterialDefinitionRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewMaterialDefinitionRevisionResponse = new QCreateNewMaterialDefinitionRevisionResponse();

export class QCreateNewMaterialDefinitionRevision extends QueryObject {
    public readonly OriginalId = new QGuidPath(this.withPrefix("OriginalId"));
}

export const qCreateNewMaterialDefinitionRevision = new QCreateNewMaterialDefinitionRevision();

export class QUpdateNonConformanceStatusBehaviorResponse extends QCommandResponse {
}

export const qUpdateNonConformanceStatusBehaviorResponse = new QUpdateNonConformanceStatusBehaviorResponse();

export class QUpdateNonConformanceStatusBehavior extends QueryObject {
    public readonly NonConformanceLifecycleId = new QGuidPath(this.withPrefix("NonConformanceLifecycleId"));
    public readonly NonConformanceStatusId = new QGuidPath(this.withPrefix("NonConformanceStatusId"));
    public readonly IsClosedOk = new QBooleanPath(this.withPrefix("IsClosedOk"));
    public readonly IsRuntimeFrozen = new QBooleanPath(this.withPrefix("IsRuntimeFrozen"));
    public readonly IsScrap = new QBooleanPath(this.withPrefix("IsScrap"));
}

export const qUpdateNonConformanceStatusBehavior = new QUpdateNonConformanceStatusBehavior();

export class QUnlinkSkillsToWorkOrderStepResponse extends QCommandResponse {
}

export const qUnlinkSkillsToWorkOrderStepResponse = new QUnlinkSkillsToWorkOrderStepResponse();

export class QUnlinkSkillsToWorkOrderStep extends QueryObject {
    public readonly WorkOrderStepSkillIds = new QCollectionPath(this.withPrefix("WorkOrderStepSkillIds"), () => QGuidCollection);
}

export const qUnlinkSkillsToWorkOrderStep = new QUnlinkSkillsToWorkOrderStep();

export class QLinkBufferDefinitionToLogisticClassListResponse extends QCommandResponse {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qLinkBufferDefinitionToLogisticClassListResponse = new QLinkBufferDefinitionToLogisticClassListResponse();

export class QLinkBufferDefinitionToLogisticClassList extends QueryObject {
    public readonly BufferDefinitionId = new QGuidPath(this.withPrefix("BufferDefinitionId"));
    public readonly LogisticClassList = new QCollectionPath(this.withPrefix("LogisticClassList"), () => QGuidCollection);
    public readonly Min = new QEntityPath(this.withPrefix("Min"), () => QQuantityParameterType);
    public readonly Max = new QEntityPath(this.withPrefix("Max"), () => QQuantityParameterType);
    public readonly Threshold = new QEntityPath(this.withPrefix("Threshold"), () => QQuantityParameterType);
    public readonly Target = new QEntityPath(this.withPrefix("Target"), () => QQuantityParameterType);
}

export const qLinkBufferDefinitionToLogisticClassList = new QLinkBufferDefinitionToLogisticClassList();

export class QAbortWorkOrderResponse extends QCommandResponse {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QWorkOrderIdentifiersParameterType);
}

export const qAbortWorkOrderResponse = new QAbortWorkOrderResponse();

export class QAbortWorkOrder extends QueryObject {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QWorkOrderIdentifiersParameterType);
}

export const qAbortWorkOrder = new QAbortWorkOrder();

export class QDeleteNonConformanceLifecycleListResponse extends QCommandResponse {
}

export const qDeleteNonConformanceLifecycleListResponse = new QDeleteNonConformanceLifecycleListResponse();

export class QDeleteNonConformanceLifecycleList extends QueryObject {
    public readonly LifecycleIdList = new QCollectionPath(this.withPrefix("LifecycleIdList"), () => QGuidCollection);
}

export const qDeleteNonConformanceLifecycleList = new QDeleteNonConformanceLifecycleList();

export class QDeleteTemplateBlocksResponse extends QCommandResponse {
}

export const qDeleteTemplateBlocksResponse = new QDeleteTemplateBlocksResponse();

export class QDeleteTemplateBlocks extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteTemplateBlocks = new QDeleteTemplateBlocks();

export class QGetProcessWithoutOperationsListResponse extends QCommandResponse {
    public readonly ProcessList = new QEntityCollectionPath(this.withPrefix("ProcessList"), () => QProcessInfoParameterType);
}

export const qGetProcessWithoutOperationsListResponse = new QGetProcessWithoutOperationsListResponse();

export class QGetProcessWithoutOperationsList extends QueryObject {
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
}

export const qGetProcessWithoutOperationsList = new QGetProcessWithoutOperationsList();

export class QDeleteToolHistoryResponse extends QCommandResponse {
}

export const qDeleteToolHistoryResponse = new QDeleteToolHistoryResponse();

export class QDeleteToolHistory extends QueryObject {
    public readonly ToolHistoryId = new QGuidPath(this.withPrefix("ToolHistoryId"));
}

export const qDeleteToolHistory = new QDeleteToolHistory();

export class QCreateHandlingUnitResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateHandlingUnitResponse = new QCreateHandlingUnitResponse();

export class QCreateHandlingUnit extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
}

export const qCreateHandlingUnit = new QCreateHandlingUnit();

export class QCreateActualConsumedMaterialResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateActualConsumedMaterialResponse = new QCreateActualConsumedMaterialResponse();

export class QCreateActualConsumedMaterial extends QueryObject {
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly MaterialItem = new QGuidPath(this.withPrefix("MaterialItem"));
    public readonly ToBeConsumedMaterial = new QGuidPath(this.withPrefix("ToBeConsumedMaterial"));
    public readonly ProducedMaterialItem = new QGuidPath(this.withPrefix("ProducedMaterialItem"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly ExecutionGroupPhase = new QGuidPath(this.withPrefix("ExecutionGroupPhase"));
}

export const qCreateActualConsumedMaterial = new QCreateActualConsumedMaterial();

export class QTCM2CreateEquipmentSpecificationListResponse extends QCommandResponse {
}

export const qTCM2CreateEquipmentSpecificationListResponse = new QTCM2CreateEquipmentSpecificationListResponse();

export class QTCM2CreateEquipmentSpecificationList extends QueryObject {
    public readonly EquipmentSpecificationList = new QEntityCollectionPath(this.withPrefix("EquipmentSpecificationList"), () => QTCM2EquipmentSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateEquipmentSpecificationList = new QTCM2CreateEquipmentSpecificationList();

export class QCreateNewProcessRevisionInCatalogueResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewProcessRevisionInCatalogueResponse = new QCreateNewProcessRevisionInCatalogueResponse();

export class QCreateNewProcessRevisionInCatalogue extends QueryObject {
    public readonly SourceProcessId = new QGuidPath(this.withPrefix("SourceProcessId"));
}

export const qCreateNewProcessRevisionInCatalogue = new QCreateNewProcessRevisionInCatalogue();

export class QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterListResponse extends QCommandResponse {
}

export const qUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterListResponse = new QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterListResponse();

export class QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList extends QueryObject {
    public readonly ToolDefinitionAutomationNodeInstanceParameterAssociationList = new QCollectionPath(this.withPrefix("ToolDefinitionAutomationNodeInstanceParameterAssociationList"), () => QGuidCollection);
}

export const qUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList = new QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList();

export class QRemoveEquipmentPreferencesForUserResponse extends QCommandResponse {
}

export const qRemoveEquipmentPreferencesForUserResponse = new QRemoveEquipmentPreferencesForUserResponse();

export class QRemoveEquipmentPreferencesForUser extends QueryObject {
}

export const qRemoveEquipmentPreferencesForUser = new QRemoveEquipmentPreferencesForUser();

export class QDeleteEquipmentSpecificationListResponse extends QCommandResponse {
}

export const qDeleteEquipmentSpecificationListResponse = new QDeleteEquipmentSpecificationListResponse();

export class QDeleteEquipmentSpecificationList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteEquipmentSpecificationList = new QDeleteEquipmentSpecificationList();

export class QStartContainerResponse extends QCommandResponse {
}

export const qStartContainerResponse = new QStartContainerResponse();

export class QStartContainer extends QueryObject {
    public readonly ContainerNIdList = new QCollectionPath(this.withPrefix("ContainerNIdList"), () => QStringCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly SetPointList = new QEntityCollectionPath(this.withPrefix("SetPointList"), () => QSetPointParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qStartContainer = new QStartContainer();

export class QCreateOperationDependencyListResponse extends QCommandResponse {
}

export const qCreateOperationDependencyListResponse = new QCreateOperationDependencyListResponse();

export class QCreateOperationDependencyList extends QueryObject {
    public readonly OperationDependencyList = new QEntityCollectionPath(this.withPrefix("OperationDependencyList"), () => QOperationDependencyParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qCreateOperationDependencyList = new QCreateOperationDependencyList();

export class QLinkEquipmentSpecificationToOperationResponse extends QCommandResponse {
}

export const qLinkEquipmentSpecificationToOperationResponse = new QLinkEquipmentSpecificationToOperationResponse();

export class QLinkEquipmentSpecificationToOperation extends QueryObject {
    public readonly EquipmentSpecificationId = new QGuidPath(this.withPrefix("EquipmentSpecificationId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qLinkEquipmentSpecificationToOperation = new QLinkEquipmentSpecificationToOperation();

export class QUploadDocumentsResponse extends QCommandResponse {
    public readonly UploadedFileIds = new QCollectionPath(this.withPrefix("UploadedFileIds"), () => QGuidCollection);
    public readonly NotUploadedFileIds = new QCollectionPath(this.withPrefix("NotUploadedFileIds"), () => QGuidCollection);
}

export const qUploadDocumentsResponse = new QUploadDocumentsResponse();

export class QUploadDocuments extends QueryObject {
    public readonly FileIds = new QCollectionPath(this.withPrefix("FileIds"), () => QGuidCollection);
    public readonly ProjectName = new QStringPath(this.withPrefix("ProjectName"));
    public readonly FolderName = new QStringPath(this.withPrefix("FolderName"));
}

export const qUploadDocuments = new QUploadDocuments();

export class QEditWorkOrderResponse extends QCommandResponse {
}

export const qEditWorkOrderResponse = new QEditWorkOrderResponse();

export class QEditWorkOrder extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly InitialQuantity = new QNumberPath(this.withPrefix("InitialQuantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly ParentBatch = new QStringPath(this.withPrefix("ParentBatch"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly PlannedTargetQuantity = new QNumberPath(this.withPrefix("PlannedTargetQuantity"));
}

export const qEditWorkOrder = new QEditWorkOrder();

export class QCompleteTransportOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCompleteTransportOperationResponse = new QCompleteTransportOperationResponse();

export class QCompleteTransportOperation extends QueryObject {
    public readonly TransportOperationId = new QGuidPath(this.withPrefix("TransportOperationId"));
}

export const qCompleteTransportOperation = new QCompleteTransportOperation();

export class QRegisterNonProductiveActivityForUserResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qRegisterNonProductiveActivityForUserResponse = new QRegisterNonProductiveActivityForUserResponse();

export class QRegisterNonProductiveActivityForUser extends QueryObject {
    public readonly NPAId = new QGuidPath(this.withPrefix("NPAId"));
    public readonly NPAUserParameter = new QEntityPath(this.withPrefix("NPAUserParameter"), () => QNPAUserParameterType);
}

export const qRegisterNonProductiveActivityForUser = new QRegisterNonProductiveActivityForUser();

export class QGetUserDetailsListResponse extends QCommandResponse {
    public readonly UsersDataList = new QEntityCollectionPath(this.withPrefix("UsersDataList"), () => QUserDetailsParameterType);
}

export const qGetUserDetailsListResponse = new QGetUserDetailsListResponse();

export class QGetUserDetailsList extends QueryObject {
    public readonly UserList = new QEntityCollectionPath(this.withPrefix("UserList"), () => QUserDetailsParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ApplyPCDFilter = new QBooleanPath(this.withPrefix("ApplyPCDFilter"));
}

export const qGetUserDetailsList = new QGetUserDetailsList();

export class QUpdateActualProducedMaterialResponse extends QCommandResponse {
}

export const qUpdateActualProducedMaterialResponse = new QUpdateActualProducedMaterialResponse();

export class QUpdateActualProducedMaterial extends QueryObject {
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NotWorkedQuantiyty = new QNumberPath(this.withPrefix("NotWorkedQuantiyty"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly PausedQuantity = new QNumberPath(this.withPrefix("PausedQuantity"));
    public readonly ReopenedQuantity = new QNumberPath(this.withPrefix("ReopenedQuantity"));
    public readonly ScrappedQuantity = new QNumberPath(this.withPrefix("ScrappedQuantity"));
    public readonly SentencedQuantity = new QNumberPath(this.withPrefix("SentencedQuantity"));
    public readonly SplitQuantity = new QNumberPath(this.withPrefix("SplitQuantity"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly ToBeProducedMaterialId = new QGuidPath(this.withPrefix("ToBeProducedMaterialId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qUpdateActualProducedMaterial = new QUpdateActualProducedMaterial();

export class QDeleteNonConformanceTransitionListResponse extends QCommandResponse {
}

export const qDeleteNonConformanceTransitionListResponse = new QDeleteNonConformanceTransitionListResponse();

export class QDeleteNonConformanceTransitionList extends QueryObject {
    public readonly TransitionIdList = new QCollectionPath(this.withPrefix("TransitionIdList"), () => QGuidCollection);
}

export const qDeleteNonConformanceTransitionList = new QDeleteNonConformanceTransitionList();

export class QDeleteEquipmentTypePropertyAttributeResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypePropertyAttributeResponse = new QDeleteEquipmentTypePropertyAttributeResponse();

export class QDeleteEquipmentTypePropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentTypePropertyAttribute = new QDeleteEquipmentTypePropertyAttribute();

export class QUpdateStatusTransitionResponse extends QCommandResponse {
}

export const qUpdateStatusTransitionResponse = new QUpdateStatusTransitionResponse();

export class QUpdateStatusTransition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DoRaiseEvent = new QBooleanPath(this.withPrefix("DoRaiseEvent"));
    public readonly TargetStatusId = new QGuidPath(this.withPrefix("TargetStatusId"));
}

export const qUpdateStatusTransition = new QUpdateStatusTransition();

export class QCreateReworkOrderResponse extends QCommandResponse {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
}

export const qCreateReworkOrderResponse = new QCreateReworkOrderResponse();

export class QCreateReworkOrder extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly MaterialItemList = new QEntityCollectionPath(this.withPrefix("MaterialItemList"), () => QMaterialItemParameterType);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly PartialQuantity = new QNumberPath(this.withPrefix("PartialQuantity"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
}

export const qCreateReworkOrder = new QCreateReworkOrder();

export class QEvolveAsPlannedBOPResponse extends QCommandResponse {
}

export const qEvolveAsPlannedBOPResponse = new QEvolveAsPlannedBOPResponse();

export class QEvolveAsPlannedBOP extends QueryObject {
    public readonly SourceAsPlannedBOPId = new QGuidPath(this.withPrefix("SourceAsPlannedBOPId"));
}

export const qEvolveAsPlannedBOP = new QEvolveAsPlannedBOP();

export class QGetActiveUserListOnWorkOrderOperationResponse extends QCommandResponse {
    public readonly UserIds = new QCollectionPath(this.withPrefix("UserIds"), () => QStringCollection);
    public readonly IsUserActive = new QBooleanPath(this.withPrefix("IsUserActive"));
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
}

export const qGetActiveUserListOnWorkOrderOperationResponse = new QGetActiveUserListOnWorkOrderOperationResponse();

export class QGetActiveUserListOnWorkOrderOperation extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationId = new QStringPath(this.withPrefix("WorkOrderOperationId"));
}

export const qGetActiveUserListOnWorkOrderOperation = new QGetActiveUserListOnWorkOrderOperation();

export class QCreateNonConformanceHistoryResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNonConformanceHistoryResponse = new QCreateNonConformanceHistoryResponse();

export class QCreateNonConformanceHistory extends QueryObject {
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly NonConformance = new QGuidPath(this.withPrefix("NonConformance"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Transition = new QStringPath(this.withPrefix("Transition"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Attachments = new QCollectionPath(this.withPrefix("Attachments"), () => QGuidCollection);
    public readonly Resource = new QCollectionPath(this.withPrefix("Resource"), () => QGuidCollection);
    public readonly Action = new QStringPath(this.withPrefix("Action"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly PreviousSeverity = new QStringPath(this.withPrefix("PreviousSeverity"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
    public readonly DefectId = new QGuidPath(this.withPrefix("DefectId"));
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qCreateNonConformanceHistory = new QCreateNonConformanceHistory();

export class QUADMAutomaticCompleteResponse extends QCommandResponse {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ExecutionContextData = new QEntityPath(this.withPrefix("ExecutionContextData"), () => QWOOpExecutionParameterType);
}

export const qUADMAutomaticCompleteResponse = new QUADMAutomaticCompleteResponse();

export class QUADMAutomaticComplete extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly ProductMaterialItemList = new QEntityCollectionPath(this.withPrefix("ProductMaterialItemList"), () => QProductMaterialItem);
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly AvoidPausingOtherSerialNos = new QBooleanPath(this.withPrefix("AvoidPausingOtherSerialNos"));
}

export const qUADMAutomaticComplete = new QUADMAutomaticComplete();

export class QDeleteStepListResponse extends QCommandResponse {
}

export const qDeleteStepListResponse = new QDeleteStepListResponse();

export class QDeleteStepList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteStepList = new QDeleteStepList();

export class QCreateFunctionalCodeResponse extends QCommandResponse {
    public readonly MaterialGroupId = new QGuidPath(this.withPrefix("MaterialGroupId"));
}

export const qCreateFunctionalCodeResponse = new QCreateFunctionalCodeResponse();

export class QCreateFunctionalCode extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateFunctionalCode = new QCreateFunctionalCode();

export class QUpdateAMPowderBatchGenealogyResponse extends QCommandResponse {
}

export const qUpdateAMPowderBatchGenealogyResponse = new QUpdateAMPowderBatchGenealogyResponse();

export class QUpdateAMPowderBatchGenealogy extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly MixedQuantity = new QStringPath(this.withPrefix("MixedQuantity"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QStringPath(this.withPrefix("RecycleCount"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
}

export const qUpdateAMPowderBatchGenealogy = new QUpdateAMPowderBatchGenealogy();

export class QDeleteDefectResponse extends QCommandResponse {
}

export const qDeleteDefectResponse = new QDeleteDefectResponse();

export class QDeleteDefect extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteDefect = new QDeleteDefect();

export class QInEditingWorkInstructionResponse extends QCommandResponse {
}

export const qInEditingWorkInstructionResponse = new QInEditingWorkInstructionResponse();

export class QInEditingWorkInstruction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qInEditingWorkInstruction = new QInEditingWorkInstruction();

export class QLinkToBeUsedMachineToPartProgramResponse extends QCommandResponse {
}

export const qLinkToBeUsedMachineToPartProgramResponse = new QLinkToBeUsedMachineToPartProgramResponse();

export class QLinkToBeUsedMachineToPartProgram extends QueryObject {
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly ToBeUsedMachine = new QGuidPath(this.withPrefix("ToBeUsedMachine"));
}

export const qLinkToBeUsedMachineToPartProgram = new QLinkToBeUsedMachineToPartProgram();

export class QCreateActiveUserOnMachineResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateActiveUserOnMachineResponse = new QCreateActiveUserOnMachineResponse();

export class QCreateActiveUserOnMachine extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qCreateActiveUserOnMachine = new QCreateActiveUserOnMachine();

export class QUpdateEquipmentSpecificationResponse extends QCommandResponse {
}

export const qUpdateEquipmentSpecificationResponse = new QUpdateEquipmentSpecificationResponse();

export class QUpdateEquipmentSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
}

export const qUpdateEquipmentSpecification = new QUpdateEquipmentSpecification();

export class QUnlinkHumanResourceFromProcessResponse extends QCommandResponse {
}

export const qUnlinkHumanResourceFromProcessResponse = new QUnlinkHumanResourceFromProcessResponse();

export class QUnlinkHumanResourceFromProcess extends QueryObject {
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly ParentIndicator = new QStringPath(this.withPrefix("ParentIndicator"));
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qUnlinkHumanResourceFromProcess = new QUnlinkHumanResourceFromProcess();

export class QPauseContainerResponse extends QCommandResponse {
}

export const qPauseContainerResponse = new QPauseContainerResponse();

export class QPauseContainer extends QueryObject {
    public readonly ContainerNIdList = new QCollectionPath(this.withPrefix("ContainerNIdList"), () => QStringCollection);
    public readonly PauseWOOperationParameterType = new QEntityPath(this.withPrefix("PauseWOOperationParameterType"), () => QPauseWOOperationParameterType);
}

export const qPauseContainer = new QPauseContainer();

export class QUnlinkOperationToProcessResponse extends QCommandResponse {
    public readonly OutputProcessId = new QGuidPath(this.withPrefix("OutputProcessId"));
}

export const qUnlinkOperationToProcessResponse = new QUnlinkOperationToProcessResponse();

export class QUnlinkOperationToProcess extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
}

export const qUnlinkOperationToProcess = new QUnlinkOperationToProcess();

export class QCreateToolDefinitionDocumentResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolDefinitionDocumentResponse = new QCreateToolDefinitionDocumentResponse();

export class QCreateToolDefinitionDocument extends QueryObject {
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qCreateToolDefinitionDocument = new QCreateToolDefinitionDocument();

export class QDeleteSupplierListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteSupplierListResponse = new QDeleteSupplierListResponse();

export class QDeleteSupplierList extends QueryObject {
    public readonly SupplierIds = new QCollectionPath(this.withPrefix("SupplierIds"), () => QGuidCollection);
}

export const qDeleteSupplierList = new QDeleteSupplierList();

export class QCreateDefectResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateDefectResponse = new QCreateDefectResponse();

export class QCreateDefect extends QueryObject {
    public readonly DefectType = new QGuidPath(this.withPrefix("DefectType"));
    public readonly NonConformance = new QGuidPath(this.withPrefix("NonConformance"));
    public readonly GroupPath = new QStringPath(this.withPrefix("GroupPath"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
}

export const qCreateDefect = new QCreateDefect();

export class QCreateEquipmentGraphNodeConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphNodeConfigurationResponse = new QCreateEquipmentGraphNodeConfigurationResponse();

export class QCreateEquipmentGraphNodeConfiguration extends QueryObject {
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly EquipmentGroupConfigurationNId = new QStringPath(this.withPrefix("EquipmentGroupConfigurationNId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
}

export const qCreateEquipmentGraphNodeConfiguration = new QCreateEquipmentGraphNodeConfiguration();

export class QSetDefectGroupPathResponse extends QCommandResponse {
}

export const qSetDefectGroupPathResponse = new QSetDefectGroupPathResponse();

export class QSetDefectGroupPath extends QueryObject {
    public readonly NonConformanceGroupPaths = new QEntityCollectionPath(this.withPrefix("NonConformanceGroupPaths"), () => QNonConformanceGroupPathParameterType);
}

export const qSetDefectGroupPath = new QSetDefectGroupPath();

export class QLinkToolToAutomationNodeInstanceListResponse extends QCommandResponse {
}

export const qLinkToolToAutomationNodeInstanceListResponse = new QLinkToolToAutomationNodeInstanceListResponse();

export class QLinkToolToAutomationNodeInstanceList extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
    public readonly AutomationNodeInstanceNIdList = new QCollectionPath(this.withPrefix("AutomationNodeInstanceNIdList"), () => QStringCollection);
}

export const qLinkToolToAutomationNodeInstanceList = new QLinkToolToAutomationNodeInstanceList();

export class QGetNonConformanceTransitionRoleMailListResponse extends QCommandResponse {
    public readonly AuthorizedRoleList = new QCollectionPath(this.withPrefix("AuthorizedRoleList"), () => QStringCollection);
    public readonly MailAddressList = new QCollectionPath(this.withPrefix("MailAddressList"), () => QStringCollection);
}

export const qGetNonConformanceTransitionRoleMailListResponse = new QGetNonConformanceTransitionRoleMailListResponse();

export class QGetNonConformanceTransitionRoleMailList extends QueryObject {
    public readonly NonConformaceTransitionId = new QGuidPath(this.withPrefix("NonConformaceTransitionId"));
}

export const qGetNonConformanceTransitionRoleMailList = new QGetNonConformanceTransitionRoleMailList();

export class QValidateMaterialConsumptionIsCompleteResponse extends QCommandResponse {
}

export const qValidateMaterialConsumptionIsCompleteResponse = new QValidateMaterialConsumptionIsCompleteResponse();

export class QValidateMaterialConsumptionIsComplete extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
}

export const qValidateMaterialConsumptionIsComplete = new QValidateMaterialConsumptionIsComplete();

export class QUpdateDNCItemResponse extends QCommandResponse {
}

export const qUpdateDNCItemResponse = new QUpdateDNCItemResponse();

export class QUpdateDNCItem extends QueryObject {
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Released = new QBooleanPath(this.withPrefix("Released"));
    public readonly Trialcut = new QBooleanPath(this.withPrefix("Trialcut"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly DNCExternalId = new QStringPath(this.withPrefix("DNCExternalId"));
    public readonly CanBeTransferred = new QBooleanPath(this.withPrefix("CanBeTransferred"));
    public readonly CanBePreviewed = new QBooleanPath(this.withPrefix("CanBePreviewed"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qUpdateDNCItem = new QUpdateDNCItem();

export class QCreateToolResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolResponse = new QCreateToolResponse();

export class QCreateTool extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UsageCounter = new QNumberPath(this.withPrefix("UsageCounter"));
    public readonly SubstrateProperties = new QEntityPath(this.withPrefix("SubstrateProperties"), () => QSubstratePropertiesParameterType);
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
}

export const qCreateTool = new QCreateTool();

export class QUnlinkEquipmentToSetPointResponse extends QCommandResponse {
}

export const qUnlinkEquipmentToSetPointResponse = new QUnlinkEquipmentToSetPointResponse();

export class QUnlinkEquipmentToSetPoint extends QueryObject {
    public readonly SetPointEquipmentList = new QCollectionPath(this.withPrefix("SetPointEquipmentList"), () => QGuidCollection);
}

export const qUnlinkEquipmentToSetPoint = new QUnlinkEquipmentToSetPoint();

export class QCreateBoMResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBoMResponse = new QCreateBoMResponse();

export class QCreateBoM extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly ValidFrom = new QDateTimeOffsetPath(this.withPrefix("ValidFrom"));
    public readonly ValidTo = new QDateTimeOffsetPath(this.withPrefix("ValidTo"));
    public readonly MaterialDefinition = new QGuidPath(this.withPrefix("MaterialDefinition"));
}

export const qCreateBoM = new QCreateBoM();

export class QUpdateEquipmentGraphLinkConfigurationResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphLinkConfigurationResponse = new QUpdateEquipmentGraphLinkConfigurationResponse();

export class QUpdateEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly SourceEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("SourceEquipmentGraphNodeConfigurationId"));
    public readonly DestinationEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("DestinationEquipmentGraphNodeConfigurationId"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
}

export const qUpdateEquipmentGraphLinkConfiguration = new QUpdateEquipmentGraphLinkConfiguration();

export class QCreateWorkOrderHistoryResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qCreateWorkOrderHistoryResponse = new QCreateWorkOrderHistoryResponse();

export class QCreateWorkOrderHistory extends QueryObject {
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action = new QGuidPath(this.withPrefix("Action"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly DNCItem = new QStringPath(this.withPrefix("DNCItem"));
    public readonly Document = new QStringPath(this.withPrefix("Document"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly PrintJobFile = new QStringPath(this.withPrefix("PrintJobFile"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ReferencedWorkOrderHistory = new QGuidPath(this.withPrefix("ReferencedWorkOrderHistory"));
    public readonly SourceWorkOrderNId = new QStringPath(this.withPrefix("SourceWorkOrderNId"));
    public readonly TargetWorkOrderNId = new QStringPath(this.withPrefix("TargetWorkOrderNId"));
}

export const qCreateWorkOrderHistory = new QCreateWorkOrderHistory();

export class QUpdateEquipmentGraphTypeResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphTypeResponse = new QUpdateEquipmentGraphTypeResponse();

export class QUpdateEquipmentGraphType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateEquipmentGraphType = new QUpdateEquipmentGraphType();

export class QChangeBoMStatusResponse extends QCommandResponse {
}

export const qChangeBoMStatusResponse = new QChangeBoMStatusResponse();

export class QChangeBoMStatus extends QueryObject {
    public readonly BoMId = new QGuidPath(this.withPrefix("BoMId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qChangeBoMStatus = new QChangeBoMStatus();

export class QExecuteItlkCheckInboundResponse extends QCommandResponse {
}

export const qExecuteItlkCheckInboundResponse = new QExecuteItlkCheckInboundResponse();

export class QExecuteItlkCheckInbound extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly MaterialList = new QEntityCollectionPath(this.withPrefix("MaterialList"), () => QItlkCheckDM_MTUParameterType);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qExecuteItlkCheckInbound = new QExecuteItlkCheckInbound();

export class QConsumeMaterialItemOnExecutionGroupResponse extends QCommandResponse {
    public readonly ActualConsumedMaterialIdList = new QCollectionPath(this.withPrefix("ActualConsumedMaterialIdList"), () => QGuidCollection);
}

export const qConsumeMaterialItemOnExecutionGroupResponse = new QConsumeMaterialItemOnExecutionGroupResponse();

export class QConsumeMaterialItemOnExecutionGroup extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly MaterialToBeConsumedList = new QEntityCollectionPath(this.withPrefix("MaterialToBeConsumedList"), () => QMaterialToBeConsumed);
}

export const qConsumeMaterialItemOnExecutionGroup = new QConsumeMaterialItemOnExecutionGroup();

export class QDeleteOperationListResponse extends QCommandResponse {
}

export const qDeleteOperationListResponse = new QDeleteOperationListResponse();

export class QDeleteOperationList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteOperationList = new QDeleteOperationList();

export class QCopyWorkInstructionDefinitionRevisionResponse extends QCommandResponse {
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
}

export const qCopyWorkInstructionDefinitionRevisionResponse = new QCopyWorkInstructionDefinitionRevisionResponse();

export class QCopyWorkInstructionDefinitionRevision extends QueryObject {
    public readonly SourceNId = new QStringPath(this.withPrefix("SourceNId"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly TargetNId = new QStringPath(this.withPrefix("TargetNId"));
    public readonly TargetRevision = new QStringPath(this.withPrefix("TargetRevision"));
}

export const qCopyWorkInstructionDefinitionRevision = new QCopyWorkInstructionDefinitionRevision();

export class QRemoveWorkOrderOperationFutureHoldResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qRemoveWorkOrderOperationFutureHoldResponse = new QRemoveWorkOrderOperationFutureHoldResponse();

export class QRemoveWorkOrderOperationFutureHold extends QueryObject {
    public readonly FutureHoldId = new QGuidPath(this.withPrefix("FutureHoldId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
}

export const qRemoveWorkOrderOperationFutureHold = new QRemoveWorkOrderOperationFutureHold();

export class QLinkEquipmentToSetPointResponse extends QCommandResponse {
}

export const qLinkEquipmentToSetPointResponse = new QLinkEquipmentToSetPointResponse();

export class QLinkEquipmentToSetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly EquipmentList = new QCollectionPath(this.withPrefix("EquipmentList"), () => QStringCollection);
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
}

export const qLinkEquipmentToSetPoint = new QLinkEquipmentToSetPoint();

export class QUpdateHierarchyEquipmentNodeConfigurationResponse extends QCommandResponse {
}

export const qUpdateHierarchyEquipmentNodeConfigurationResponse = new QUpdateHierarchyEquipmentNodeConfigurationResponse();

export class QUpdateHierarchyEquipmentNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParentEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("ParentEquipmentGraphNodeConfigurationId"));
}

export const qUpdateHierarchyEquipmentNodeConfiguration = new QUpdateHierarchyEquipmentNodeConfiguration();

export class QCreateStatusResponse extends QCommandResponse {
    public readonly StatusId = new QGuidPath(this.withPrefix("StatusId"));
}

export const qCreateStatusResponse = new QCreateStatusResponse();

export class QCreateStatus extends QueryObject {
    public readonly StatusDefinitionId = new QGuidPath(this.withPrefix("StatusDefinitionId"));
    public readonly StateMachineId = new QGuidPath(this.withPrefix("StateMachineId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsInitial = new QBooleanPath(this.withPrefix("IsInitial"));
}

export const qCreateStatus = new QCreateStatus();

export class QLinkSubstrateDefinitionToMachineResponse extends QCommandResponse {
}

export const qLinkSubstrateDefinitionToMachineResponse = new QLinkSubstrateDefinitionToMachineResponse();

export class QLinkSubstrateDefinitionToMachine extends QueryObject {
    public readonly SubstrateId = new QGuidPath(this.withPrefix("SubstrateId"));
    public readonly MachineList = new QCollectionPath(this.withPrefix("MachineList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qLinkSubstrateDefinitionToMachine = new QLinkSubstrateDefinitionToMachine();

export class QDeleteCustomItlkCheckListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteCustomItlkCheckListResponse = new QDeleteCustomItlkCheckListResponse();

export class QDeleteCustomItlkCheckList extends QueryObject {
    public readonly ListOfItlkCheckId = new QCollectionPath(this.withPrefix("ListOfItlkCheckId"), () => QGuidCollection);
}

export const qDeleteCustomItlkCheckList = new QDeleteCustomItlkCheckList();

export class QEditHumanResourceToProcessResponse extends QCommandResponse {
}

export const qEditHumanResourceToProcessResponse = new QEditHumanResourceToProcessResponse();

export class QEditHumanResourceToProcess extends QueryObject {
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly RequiredNumberOfHumanResource = new QNumberPath(this.withPrefix("RequiredNumberOfHumanResource"));
    public readonly ParentIndicator = new QStringPath(this.withPrefix("ParentIndicator"));
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qEditHumanResourceToProcess = new QEditHumanResourceToProcess();

export class QFilterWorkOrderOperationListByCheckCertificationResponse extends QCommandResponse {
    public readonly ValidWorkOrderOperationNIdList = new QCollectionPath(this.withPrefix("ValidWorkOrderOperationNIdList"), () => QStringCollection);
}

export const qFilterWorkOrderOperationListByCheckCertificationResponse = new QFilterWorkOrderOperationListByCheckCertificationResponse();

export class QFilterWorkOrderOperationListByCheckCertification extends QueryObject {
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
}

export const qFilterWorkOrderOperationListByCheckCertification = new QFilterWorkOrderOperationListByCheckCertification();

export class QCreateNewStepRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewStepRevisionResponse = new QCreateNewStepRevisionResponse();

export class QCreateNewStepRevision extends QueryObject {
    public readonly SourceStepId = new QGuidPath(this.withPrefix("SourceStepId"));
}

export const qCreateNewStepRevision = new QCreateNewStepRevision();

export class QDeleteEquipmentTypePropertyResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypePropertyResponse = new QDeleteEquipmentTypePropertyResponse();

export class QDeleteEquipmentTypeProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentTypeProperty = new QDeleteEquipmentTypeProperty();

export class QUnlinkMaterialSpecificationToOperationResponse extends QCommandResponse {
}

export const qUnlinkMaterialSpecificationToOperationResponse = new QUnlinkMaterialSpecificationToOperationResponse();

export class QUnlinkMaterialSpecificationToOperation extends QueryObject {
    public readonly MaterialSpecificationId = new QGuidPath(this.withPrefix("MaterialSpecificationId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qUnlinkMaterialSpecificationToOperation = new QUnlinkMaterialSpecificationToOperation();

export class QCreateWorkOrderOperationFromProcessOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderOperationFromProcessOperationResponse = new QCreateWorkOrderOperationFromProcessOperationResponse();

export class QCreateWorkOrderOperationFromProcessOperation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperation = new QEntityPath(this.withPrefix("WorkOrderOperation"), () => QWorkOrderOperationFromOperationParameter);
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
}

export const qCreateWorkOrderOperationFromProcessOperation = new QCreateWorkOrderOperationFromProcessOperation();

export class QUpdateCustomItlkCheckListResponse extends QCommandResponse {
    public readonly ListOfItlkCheckId = new QCollectionPath(this.withPrefix("ListOfItlkCheckId"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateCustomItlkCheckListResponse = new QUpdateCustomItlkCheckListResponse();

export class QUpdateCustomItlkCheckList extends QueryObject {
    public readonly ListOfItlkCheck = new QEntityCollectionPath(this.withPrefix("ListOfItlkCheck"), () => QCustomItlkCheckParameterType);
}

export const qUpdateCustomItlkCheckList = new QUpdateCustomItlkCheckList();

export class QCreateToolHistoryActionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolHistoryActionResponse = new QCreateToolHistoryActionResponse();

export class QCreateToolHistoryAction extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateToolHistoryAction = new QCreateToolHistoryAction();

export class QUpdateVariableCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly FailureAssociationIds = new QCollectionPath(this.withPrefix("FailureAssociationIds"), () => QGuidCollection);
}

export const qUpdateVariableCharacteristicSpecificationResponse = new QUpdateVariableCharacteristicSpecificationResponse();

export class QUpdateVariableCharacteristicSpecification extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly NominalValue = new QEntityPath(this.withPrefix("NominalValue"), () => QQuantityParameterType);
    public readonly UpperTolerance = new QEntityPath(this.withPrefix("UpperTolerance"), () => QQuantityParameterType);
    public readonly LowerTolerance = new QEntityPath(this.withPrefix("LowerTolerance"), () => QQuantityParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly FailureAssociations = new QEntityCollectionPath(this.withPrefix("FailureAssociations"), () => QCharacteristicFailureAssociation);
}

export const qUpdateVariableCharacteristicSpecification = new QUpdateVariableCharacteristicSpecification();

export class QUpdateWorkOrderStepResponse extends QCommandResponse {
}

export const qUpdateWorkOrderStepResponse = new QUpdateWorkOrderStepResponse();

export class QUpdateWorkOrderStep extends QueryObject {
    public readonly WorkOrderSteps = new QEntityCollectionPath(this.withPrefix("WorkOrderSteps"), () => QWorkOrderOperationParameter);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateWorkOrderStep = new QUpdateWorkOrderStep();

export class QCreateEquipmentGroupConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGroupConfigurationResponse = new QCreateEquipmentGroupConfigurationResponse();

export class QCreateEquipmentGroupConfiguration extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
}

export const qCreateEquipmentGroupConfiguration = new QCreateEquipmentGroupConfiguration();

export class QUnlinkDocumentListToOperationResponse extends QCommandResponse {
}

export const qUnlinkDocumentListToOperationResponse = new QUnlinkDocumentListToOperationResponse();

export class QUnlinkDocumentListToOperation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly ListOfDocumentId = new QCollectionPath(this.withPrefix("ListOfDocumentId"), () => QGuidCollection);
}

export const qUnlinkDocumentListToOperation = new QUnlinkDocumentListToOperation();

export class QUnlinkEquipmentSpecificationToOperationResponse extends QCommandResponse {
}

export const qUnlinkEquipmentSpecificationToOperationResponse = new QUnlinkEquipmentSpecificationToOperationResponse();

export class QUnlinkEquipmentSpecificationToOperation extends QueryObject {
    public readonly EquipmentSpecificationId = new QGuidPath(this.withPrefix("EquipmentSpecificationId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qUnlinkEquipmentSpecificationToOperation = new QUnlinkEquipmentSpecificationToOperation();

export class QDeleteToolDefinitionsResponse extends QCommandResponse {
}

export const qDeleteToolDefinitionsResponse = new QDeleteToolDefinitionsResponse();

export class QDeleteToolDefinitions extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteToolDefinitions = new QDeleteToolDefinitions();

export class QCreateDM_MaterialTrackingUnitResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qCreateDM_MaterialTrackingUnitResponse = new QCreateDM_MaterialTrackingUnitResponse();

export class QCreateDM_MaterialTrackingUnit extends QueryObject {
    public readonly MaterialTrackingUnitId = new QGuidPath(this.withPrefix("MaterialTrackingUnitId"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly ActiveNonConformanceNumber = new QNumberPath(this.withPrefix("ActiveNonConformanceNumber"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly ParentDM_MTUId = new QGuidPath(this.withPrefix("ParentDM_MTUId"));
    public readonly IsCalledFromSplitOfMTU = new QBooleanPath(this.withPrefix("IsCalledFromSplitOfMTU"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
}

export const qCreateDM_MaterialTrackingUnit = new QCreateDM_MaterialTrackingUnit();

export class QSetWorkInstructionDefinitionRevisionCurrentResponse extends QCommandResponse {
}

export const qSetWorkInstructionDefinitionRevisionCurrentResponse = new QSetWorkInstructionDefinitionRevisionCurrentResponse();

export class QSetWorkInstructionDefinitionRevisionCurrent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSetWorkInstructionDefinitionRevisionCurrent = new QSetWorkInstructionDefinitionRevisionCurrent();

export class QCreateExecutionGroupResponse extends QCommandResponse {
}

export const qCreateExecutionGroupResponse = new QCreateExecutionGroupResponse();

export class QCreateExecutionGroup extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
}

export const qCreateExecutionGroup = new QCreateExecutionGroup();

export class QMergeWOHeaderWithProcessResponse extends QCommandResponse {
}

export const qMergeWOHeaderWithProcessResponse = new QMergeWOHeaderWithProcessResponse();

export class QMergeWOHeaderWithProcess extends QueryObject {
    public readonly MergeWOProcessParameters = new QEntityPath(this.withPrefix("MergeWOProcessParameters"), () => QWOHeaderParameterType);
}

export const qMergeWOHeaderWithProcess = new QMergeWOHeaderWithProcess();

export class QCheckInStartWOOperationSerializedResponse extends QCommandResponse {
}

export const qCheckInStartWOOperationSerializedResponse = new QCheckInStartWOOperationSerializedResponse();

export class QCheckInStartWOOperationSerialized extends QueryObject {
    public readonly StartWOOperationSerializedParameterType = new QEntityPath(this.withPrefix("StartWOOperationSerializedParameterType"), () => QStartWOOperationSerializedParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInStartWOOperationSerialized = new QCheckInStartWOOperationSerialized();

export class QDeleteProcessFromCatalogueResponse extends QCommandResponse {
}

export const qDeleteProcessFromCatalogueResponse = new QDeleteProcessFromCatalogueResponse();

export class QDeleteProcessFromCatalogue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteProcessFromCatalogue = new QDeleteProcessFromCatalogue();

export class QBeginIdTemplateEditingResponse extends QCommandResponse {
}

export const qBeginIdTemplateEditingResponse = new QBeginIdTemplateEditingResponse();

export class QBeginIdTemplateEditing extends QueryObject {
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qBeginIdTemplateEditing = new QBeginIdTemplateEditing();

export class QUpdateEquipmentGraphConfigurationResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphConfigurationResponse = new QUpdateEquipmentGraphConfigurationResponse();

export class QUpdateEquipmentGraphConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateEquipmentGraphConfiguration = new QUpdateEquipmentGraphConfiguration();

export class QCreateDNCItemResponse extends QCommandResponse {
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
}

export const qCreateDNCItemResponse = new QCreateDNCItemResponse();

export class QCreateDNCItem extends QueryObject {
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Released = new QBooleanPath(this.withPrefix("Released"));
    public readonly Trialcut = new QBooleanPath(this.withPrefix("Trialcut"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly DNCExternalId = new QStringPath(this.withPrefix("DNCExternalId"));
    public readonly CanBeTransferred = new QBooleanPath(this.withPrefix("CanBeTransferred"));
    public readonly CanBePreviewed = new QBooleanPath(this.withPrefix("CanBePreviewed"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qCreateDNCItem = new QCreateDNCItem();

export class QCheckInUseToolListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qCheckInUseToolListResponse = new QCheckInUseToolListResponse();

export class QCheckInUseToolList extends QueryObject {
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
    public readonly ToolToBeUsedList = new QEntityCollectionPath(this.withPrefix("ToolToBeUsedList"), () => QToolToBeUsedOnSNParameterType);
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
}

export const qCheckInUseToolList = new QCheckInUseToolList();

export class QDeleteWorkInstructionTemplateParameterResponse extends QCommandResponse {
}

export const qDeleteWorkInstructionTemplateParameterResponse = new QDeleteWorkInstructionTemplateParameterResponse();

export class QDeleteWorkInstructionTemplateParameter extends QueryObject {
    public readonly IdFlag0 = new QBooleanPath(this.withPrefix("IdFlag0"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkInstructionTemplateParameter = new QDeleteWorkInstructionTemplateParameter();

export class QGetWorkOrderOperationNIdToCompleteByMachineResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderProductionType = new QStringPath(this.withPrefix("WorkOrderProductionType"));
}

export const qGetWorkOrderOperationNIdToCompleteByMachineResponse = new QGetWorkOrderOperationNIdToCompleteByMachineResponse();

export class QGetWorkOrderOperationNIdToCompleteByMachine extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly ProductMaterialItemList = new QEntityCollectionPath(this.withPrefix("ProductMaterialItemList"), () => QProductMaterialItem);
}

export const qGetWorkOrderOperationNIdToCompleteByMachine = new QGetWorkOrderOperationNIdToCompleteByMachine();

export class QTCM2CreateAsPlannedBOPResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qTCM2CreateAsPlannedBOPResponse = new QTCM2CreateAsPlannedBOPResponse();

export class QTCM2CreateAsPlannedBOP extends QueryObject {
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QTCM2AsPlannedBOPParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateAsPlannedBOP = new QTCM2CreateAsPlannedBOP();

export class QVerifyWorkOrderResponse extends QCommandResponse {
    public readonly MaterialItemIdentifiers = new QEntityPath(this.withPrefix("MaterialItemIdentifiers"), () => QMaterialItemIdentifiersParameterType);
}

export const qVerifyWorkOrderResponse = new QVerifyWorkOrderResponse();

export class QVerifyWorkOrder extends QueryObject {
    public readonly MaterialItemIdentifiers = new QEntityPath(this.withPrefix("MaterialItemIdentifiers"), () => QMaterialItemIdentifiersParameterType);
}

export const qVerifyWorkOrder = new QVerifyWorkOrder();

export class QReopenWorkOrderOperationSerializedResponse extends QCommandResponse {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QIdentifiersParameterType);
    public readonly WorkOrderOperationIdentifiers = new QEntityPath(this.withPrefix("WorkOrderOperationIdentifiers"), () => QIdentifiersParameterType);
}

export const qReopenWorkOrderOperationSerializedResponse = new QReopenWorkOrderOperationSerializedResponse();

export class QReopenWorkOrderOperationSerialized extends QueryObject {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QIdentifiersParameterType);
    public readonly WorkOrderOperationIdentifiers = new QEntityPath(this.withPrefix("WorkOrderOperationIdentifiers"), () => QIdentifiersParameterType);
    public readonly SerialNumberToReopenList = new QEntityCollectionPath(this.withPrefix("SerialNumberToReopenList"), () => QMaterialItemParameterType);
}

export const qReopenWorkOrderOperationSerialized = new QReopenWorkOrderOperationSerialized();

export class QGetProductionProcessFromAsPlannedResponse extends QCommandResponse {
    public readonly ProcessIdList = new QCollectionPath(this.withPrefix("ProcessIdList"), () => QGuidCollection);
    public readonly ProcessWithoutPlantFound = new QBooleanPath(this.withPrefix("ProcessWithoutPlantFound"));
}

export const qGetProductionProcessFromAsPlannedResponse = new QGetProductionProcessFromAsPlannedResponse();

export class QGetProductionProcessFromAsPlanned extends QueryObject {
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
}

export const qGetProductionProcessFromAsPlanned = new QGetProductionProcessFromAsPlanned();

export class QDeleteNonConformanceHistoryResponse extends QCommandResponse {
}

export const qDeleteNonConformanceHistoryResponse = new QDeleteNonConformanceHistoryResponse();

export class QDeleteNonConformanceHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteNonConformanceHistory = new QDeleteNonConformanceHistory();

export class QAcceptChangeAddOperationResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeAddOperationResponse = new QAcceptChangeAddOperationResponse();

export class QAcceptChangeAddOperation extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly ToBeUsedMachine = new QEntityPath(this.withPrefix("ToBeUsedMachine"), () => QToBeUsedMachineParameter);
    public readonly AfterSequence = new QNumberPath(this.withPrefix("AfterSequence"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly WorkOrderOperationDescription = new QStringPath(this.withPrefix("WorkOrderOperationDescription"));
}

export const qAcceptChangeAddOperation = new QAcceptChangeAddOperation();

export class QDeleteDocumentListResponse extends QCommandResponse {
}

export const qDeleteDocumentListResponse = new QDeleteDocumentListResponse();

export class QDeleteDocumentList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteDocumentList = new QDeleteDocumentList();

export class QCompleteContainerResponse extends QCommandResponse {
}

export const qCompleteContainerResponse = new QCompleteContainerResponse();

export class QCompleteContainer extends QueryObject {
    public readonly ContainerNIdList = new QCollectionPath(this.withPrefix("ContainerNIdList"), () => QStringCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ActualProduceParameterType = new QEntityCollectionPath(this.withPrefix("ActualProduceParameterType"), () => QActualProducedMaterialTBParameterType);
    public readonly Results = new QEntityCollectionPath(this.withPrefix("Results"), () => QResultParameterType);
}

export const qCompleteContainer = new QCompleteContainer();

export class QPauseWOOperationResponse extends QCommandResponse {
    public readonly WorkOrderHistoryIds = new QCollectionPath(this.withPrefix("WorkOrderHistoryIds"), () => QGuidCollection);
}

export const qPauseWOOperationResponse = new QPauseWOOperationResponse();

export class QPauseWOOperation extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly PauseWOOperationParameterType = new QEntityPath(this.withPrefix("PauseWOOperationParameterType"), () => QPauseWOOperationParameterType);
}

export const qPauseWOOperation = new QPauseWOOperation();

export class QDeleteAsPlannedBOPListResponse extends QCommandResponse {
}

export const qDeleteAsPlannedBOPListResponse = new QDeleteAsPlannedBOPListResponse();

export class QDeleteAsPlannedBOPList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteAsPlannedBOPList = new QDeleteAsPlannedBOPList();

export class QCreateHoldResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateHoldResponse = new QCreateHoldResponse();

export class QCreateHold extends QueryObject {
    public readonly CloseComment = new QStringPath(this.withPrefix("CloseComment"));
    public readonly CloseTime = new QDateTimeOffsetPath(this.withPrefix("CloseTime"));
    public readonly CloseUserId = new QStringPath(this.withPrefix("CloseUserId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly FutureHold = new QStringPath(this.withPrefix("FutureHold"));
    public readonly IsPresent = new QBooleanPath(this.withPrefix("IsPresent"));
    public readonly OpenTime = new QDateTimeOffsetPath(this.withPrefix("OpenTime"));
    public readonly OpenUserId = new QStringPath(this.withPrefix("OpenUserId"));
    public readonly PreviousState = new QStringPath(this.withPrefix("PreviousState"));
    public readonly ReasonId = new QGuidPath(this.withPrefix("ReasonId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly TypeNId = new QStringPath(this.withPrefix("TypeNId"));
}

export const qCreateHold = new QCreateHold();

export class QLinkToBeUsedMachineToPJFResponse extends QCommandResponse {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qLinkToBeUsedMachineToPJFResponse = new QLinkToBeUsedMachineToPJFResponse();

export class QLinkToBeUsedMachineToPJF extends QueryObject {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
}

export const qLinkToBeUsedMachineToPJF = new QLinkToBeUsedMachineToPJF();

export class QGetResultStrategyResponse extends QCommandResponse {
    public readonly StrategyNId = new QStringPath(this.withPrefix("StrategyNId"));
}

export const qGetResultStrategyResponse = new QGetResultStrategyResponse();

export class QGetResultStrategy extends QueryObject {
}

export const qGetResultStrategy = new QGetResultStrategy();

export class QLinkMachineDefinitionToSetPointResponse extends QCommandResponse {
}

export const qLinkMachineDefinitionToSetPointResponse = new QLinkMachineDefinitionToSetPointResponse();

export class QLinkMachineDefinitionToSetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly MachineDefinitionList = new QCollectionPath(this.withPrefix("MachineDefinitionList"), () => QStringCollection);
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
}

export const qLinkMachineDefinitionToSetPoint = new QLinkMachineDefinitionToSetPoint();

export class QUpdateTeamResponse extends QCommandResponse {
}

export const qUpdateTeamResponse = new QUpdateTeamResponse();

export class QUpdateTeam extends QueryObject {
    public readonly TeamId = new QGuidPath(this.withPrefix("TeamId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaximumUsers = new QNumberPath(this.withPrefix("MaximumUsers"));
}

export const qUpdateTeam = new QUpdateTeam();

export class QCreateNewWorkInstructionDefinitionRevisionResponse extends QCommandResponse {
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
}

export const qCreateNewWorkInstructionDefinitionRevisionResponse = new QCreateNewWorkInstructionDefinitionRevisionResponse();

export class QCreateNewWorkInstructionDefinitionRevision extends QueryObject {
    public readonly SourceNId = new QStringPath(this.withPrefix("SourceNId"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly TargetRevision = new QStringPath(this.withPrefix("TargetRevision"));
}

export const qCreateNewWorkInstructionDefinitionRevision = new QCreateNewWorkInstructionDefinitionRevision();

export class QDeleteTemplateResponse extends QCommandResponse {
}

export const qDeleteTemplateResponse = new QDeleteTemplateResponse();

export class QDeleteTemplate extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTemplate = new QDeleteTemplate();

export class QGetResultValueOnEmptyResponse extends QCommandResponse {
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
}

export const qGetResultValueOnEmptyResponse = new QGetResultValueOnEmptyResponse();

export class QGetResultValueOnEmpty extends QueryObject {
}

export const qGetResultValueOnEmpty = new QGetResultValueOnEmpty();

export class QTCMCreateUoMListResponse extends QCommandResponse {
    public readonly UoMOutput = new QEntityCollectionPath(this.withPrefix("UoMOutput"), () => QTCMOutputParameter);
}

export const qTCMCreateUoMListResponse = new QTCMCreateUoMListResponse();

export class QTCMCreateUoMList extends QueryObject {
    public readonly NIds = new QCollectionPath(this.withPrefix("NIds"), () => QStringCollection);
}

export const qTCMCreateUoMList = new QTCMCreateUoMList();

export class QCreateNonConformanceLifecycleResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateNonConformanceLifecycleResponse = new QCreateNonConformanceLifecycleResponse();

export class QCreateNonConformanceLifecycle extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly InitialStatus = new QStringPath(this.withPrefix("InitialStatus"));
}

export const qCreateNonConformanceLifecycle = new QCreateNonConformanceLifecycle();

export class QSetIsOutOfDateAsPlannedBOPResponse extends QCommandResponse {
}

export const qSetIsOutOfDateAsPlannedBOPResponse = new QSetIsOutOfDateAsPlannedBOPResponse();

export class QSetIsOutOfDateAsPlannedBOP extends QueryObject {
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly NIDList = new QCollectionPath(this.withPrefix("NIDList"), () => QStringCollection);
}

export const qSetIsOutOfDateAsPlannedBOP = new QSetIsOutOfDateAsPlannedBOP();

export class QCreateActualUsedToolResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateActualUsedToolResponse = new QCreateActualUsedToolResponse();

export class QCreateActualUsedTool extends QueryObject {
    public readonly Tool = new QGuidPath(this.withPrefix("Tool"));
    public readonly ToolDefinition = new QGuidPath(this.withPrefix("ToolDefinition"));
    public readonly UsedTimes = new QNumberPath(this.withPrefix("UsedTimes"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ToBeUsedTool = new QGuidPath(this.withPrefix("ToBeUsedTool"));
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly ActualUsageCounter = new QNumberPath(this.withPrefix("ActualUsageCounter"));
}

export const qCreateActualUsedTool = new QCreateActualUsedTool();

export class QCheckWorkOrderStatusIsInEditingResponse extends QCommandResponse {
    public readonly IsInEditing = new QBooleanPath(this.withPrefix("IsInEditing"));
    public readonly WorkOrderExist = new QBooleanPath(this.withPrefix("WorkOrderExist"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qCheckWorkOrderStatusIsInEditingResponse = new QCheckWorkOrderStatusIsInEditingResponse();

export class QCheckWorkOrderStatusIsInEditing extends QueryObject {
    public readonly WorkOrderId = new QStringPath(this.withPrefix("WorkOrderId"));
}

export const qCheckWorkOrderStatusIsInEditing = new QCheckWorkOrderStatusIsInEditing();

export class QCreateItlkCheckHistoryListResponse extends QCommandResponse {
    public readonly ItlkCheckHistoryIdList = new QCollectionPath(this.withPrefix("ItlkCheckHistoryIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qCreateItlkCheckHistoryListResponse = new QCreateItlkCheckHistoryListResponse();

export class QCreateItlkCheckHistoryList extends QueryObject {
    public readonly ItlkCheckHistoryList = new QEntityCollectionPath(this.withPrefix("ItlkCheckHistoryList"), () => QItlkCheckHistoryParameterType);
}

export const qCreateItlkCheckHistoryList = new QCreateItlkCheckHistoryList();

export class QUpdateDM_MaterialTrackingUnitResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qUpdateDM_MaterialTrackingUnitResponse = new QUpdateDM_MaterialTrackingUnitResponse();

export class QUpdateDM_MaterialTrackingUnit extends QueryObject {
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly ActiveNonConformanceNumber = new QNumberPath(this.withPrefix("ActiveNonConformanceNumber"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly HistoryAction = new QStringPath(this.withPrefix("HistoryAction"));
    public readonly IsCalledFromSplitOfMTU = new QBooleanPath(this.withPrefix("IsCalledFromSplitOfMTU"));
}

export const qUpdateDM_MaterialTrackingUnit = new QUpdateDM_MaterialTrackingUnit();

export class QSetWaitingForInspectionResponse extends QCommandResponse {
}

export const qSetWaitingForInspectionResponse = new QSetWaitingForInspectionResponse();

export class QSetWaitingForInspection extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly InspectionValue = new QBooleanPath(this.withPrefix("InspectionValue"));
}

export const qSetWaitingForInspection = new QSetWaitingForInspection();

export class QDeleteNonProductiveActivityListResponse extends QCommandResponse {
}

export const qDeleteNonProductiveActivityListResponse = new QDeleteNonProductiveActivityListResponse();

export class QDeleteNonProductiveActivityList extends QueryObject {
    public readonly NonProductiveActivityList = new QCollectionPath(this.withPrefix("NonProductiveActivityList"), () => QGuidCollection);
}

export const qDeleteNonProductiveActivityList = new QDeleteNonProductiveActivityList();

export class QLinkAutomationNodeInstanceParameterToDCItemListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkAutomationNodeInstanceParameterToDCItemListResponse = new QLinkAutomationNodeInstanceParameterToDCItemListResponse();

export class QLinkAutomationNodeInstanceParameterToDCItemList extends QueryObject {
    public readonly WorkInstructionDefinitionParameterIdList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionParameterIdList"), () => QGuidCollection);
    public readonly ATNInstanceParameter = new QEntityPath(this.withPrefix("ATNInstanceParameter"), () => QATNInstanceParameterType);
}

export const qLinkAutomationNodeInstanceParameterToDCItemList = new QLinkAutomationNodeInstanceParameterToDCItemList();

export class QLinkPartProgramToEquipmentSpecificationResponse extends QCommandResponse {
}

export const qLinkPartProgramToEquipmentSpecificationResponse = new QLinkPartProgramToEquipmentSpecificationResponse();

export class QLinkPartProgramToEquipmentSpecification extends QueryObject {
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly EquipmentSpecification = new QGuidPath(this.withPrefix("EquipmentSpecification"));
    public readonly Process = new QGuidPath(this.withPrefix("Process"));
}

export const qLinkPartProgramToEquipmentSpecification = new QLinkPartProgramToEquipmentSpecification();

export class QUpdateActualUsedMachinePJFResponse extends QCommandResponse {
}

export const qUpdateActualUsedMachinePJFResponse = new QUpdateActualUsedMachinePJFResponse();

export class QUpdateActualUsedMachinePJF extends QueryObject {
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ActualUsedMachineId = new QGuidPath(this.withPrefix("ActualUsedMachineId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
}

export const qUpdateActualUsedMachinePJF = new QUpdateActualUsedMachinePJF();

export class QCopyNonConformanceFromParentWorkOrderResponse extends QCommandResponse {
}

export const qCopyNonConformanceFromParentWorkOrderResponse = new QCopyNonConformanceFromParentWorkOrderResponse();

export class QCopyNonConformanceFromParentWorkOrder extends QueryObject {
    public readonly WorkOrderIdParent = new QGuidPath(this.withPrefix("WorkOrderIdParent"));
    public readonly WorkOrderIdSplit = new QGuidPath(this.withPrefix("WorkOrderIdSplit"));
    public readonly NonConformanceToExcluded = new QCollectionPath(this.withPrefix("NonConformanceToExcluded"), () => QStringCollection);
}

export const qCopyNonConformanceFromParentWorkOrder = new QCopyNonConformanceFromParentWorkOrder();

export class QCreateToBeUsedInspectionResponse extends QCommandResponse {
    public readonly ToBeUsedInspectionId = new QGuidPath(this.withPrefix("ToBeUsedInspectionId"));
}

export const qCreateToBeUsedInspectionResponse = new QCreateToBeUsedInspectionResponse();

export class QCreateToBeUsedInspection extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly RuntimeCharacteristicRepresentationContainerNId = new QStringPath(this.withPrefix("RuntimeCharacteristicRepresentationContainerNId"));
}

export const qCreateToBeUsedInspection = new QCreateToBeUsedInspection();

export class QDeleteWorkOrderHistoryActionResponse extends QCommandResponse {
}

export const qDeleteWorkOrderHistoryActionResponse = new QDeleteWorkOrderHistoryActionResponse();

export class QDeleteWorkOrderHistoryAction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkOrderHistoryAction = new QDeleteWorkOrderHistoryAction();

export class QUnlinkWOOperationsFromExecutionGroupResponse extends QCommandResponse {
}

export const qUnlinkWOOperationsFromExecutionGroupResponse = new QUnlinkWOOperationsFromExecutionGroupResponse();

export class QUnlinkWOOperationsFromExecutionGroup extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly WorkOrderOperations = new QCollectionPath(this.withPrefix("WorkOrderOperations"), () => QGuidCollection);
}

export const qUnlinkWOOperationsFromExecutionGroup = new QUnlinkWOOperationsFromExecutionGroup();

export class QChangeBufferStatusResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qChangeBufferStatusResponse = new QChangeBufferStatusResponse();

export class QChangeBufferStatus extends QueryObject {
    public readonly BufferInstanceId = new QGuidPath(this.withPrefix("BufferInstanceId"));
    public readonly StatusId = new QStringPath(this.withPrefix("StatusId"));
}

export const qChangeBufferStatus = new QChangeBufferStatus();

export class QReleaseExecutionGroupResponse extends QCommandResponse {
}

export const qReleaseExecutionGroupResponse = new QReleaseExecutionGroupResponse();

export class QReleaseExecutionGroup extends QueryObject {
    public readonly ExecutionGroups = new QEntityCollectionPath(this.withPrefix("ExecutionGroups"), () => QExecutionGroupParameterType);
}

export const qReleaseExecutionGroup = new QReleaseExecutionGroup();

export class QDeleteWorkInstructionDefinitionParameterResponse extends QCommandResponse {
}

export const qDeleteWorkInstructionDefinitionParameterResponse = new QDeleteWorkInstructionDefinitionParameterResponse();

export class QDeleteWorkInstructionDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkInstructionDefinitionParameter = new QDeleteWorkInstructionDefinitionParameter();

export class QAcceptChangeChangeToBeUsedMachineResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeChangeToBeUsedMachineResponse = new QAcceptChangeChangeToBeUsedMachineResponse();

export class QAcceptChangeChangeToBeUsedMachine extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly OldToBeUsedMachineId = new QGuidPath(this.withPrefix("OldToBeUsedMachineId"));
    public readonly NewToBeUsedMachine = new QEntityPath(this.withPrefix("NewToBeUsedMachine"), () => QToBeUsedMachineParameter);
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qAcceptChangeChangeToBeUsedMachine = new QAcceptChangeChangeToBeUsedMachine();

export class QChangeHandlingUnitStatusResponse extends QCommandResponse {
}

export const qChangeHandlingUnitStatusResponse = new QChangeHandlingUnitStatusResponse();

export class QChangeHandlingUnitStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
}

export const qChangeHandlingUnitStatus = new QChangeHandlingUnitStatus();

export class QLinkToolToSetPointResponse extends QCommandResponse {
}

export const qLinkToolToSetPointResponse = new QLinkToolToSetPointResponse();

export class QLinkToolToSetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly ToolList = new QCollectionPath(this.withPrefix("ToolList"), () => QGuidCollection);
    public readonly IsDefaultFlag0 = new QBooleanPath(this.withPrefix("IsDefaultFlag0"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
}

export const qLinkToolToSetPoint = new QLinkToolToSetPoint();

export class QDeleteCertificationListResponse extends QCommandResponse {
}

export const qDeleteCertificationListResponse = new QDeleteCertificationListResponse();

export class QDeleteCertificationList extends QueryObject {
    public readonly DeleteCertificationParameterList = new QEntityCollectionPath(this.withPrefix("DeleteCertificationParameterList"), () => QDeleteCertificationParameterType);
}

export const qDeleteCertificationList = new QDeleteCertificationList();

export class QSetPreferredMachineResponse extends QCommandResponse {
}

export const qSetPreferredMachineResponse = new QSetPreferredMachineResponse();

export class QSetPreferredMachine extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qSetPreferredMachine = new QSetPreferredMachine();

export class QLinkToolDefinitionToSetPointResponse extends QCommandResponse {
}

export const qLinkToolDefinitionToSetPointResponse = new QLinkToolDefinitionToSetPointResponse();

export class QLinkToolDefinitionToSetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly ToolDefinitionList = new QCollectionPath(this.withPrefix("ToolDefinitionList"), () => QGuidCollection);
    public readonly IsDefaultFlag0 = new QBooleanPath(this.withPrefix("IsDefaultFlag0"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
}

export const qLinkToolDefinitionToSetPoint = new QLinkToolDefinitionToSetPoint();

export class QDeleteToBeUsedMachinePJFResponse extends QCommandResponse {
}

export const qDeleteToBeUsedMachinePJFResponse = new QDeleteToBeUsedMachinePJFResponse();

export class QDeleteToBeUsedMachinePJF extends QueryObject {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qDeleteToBeUsedMachinePJF = new QDeleteToBeUsedMachinePJF();

export class QDeleteToolDefinitionDocumentResponse extends QCommandResponse {
}

export const qDeleteToolDefinitionDocumentResponse = new QDeleteToolDefinitionDocumentResponse();

export class QDeleteToolDefinitionDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteToolDefinitionDocument = new QDeleteToolDefinitionDocument();

export class QAutomaticCollectWorkInstructionResponse extends QCommandResponse {
}

export const qAutomaticCollectWorkInstructionResponse = new QAutomaticCollectWorkInstructionResponse();

export class QAutomaticCollectWorkInstruction extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly ProducedMaterialItemList = new QEntityCollectionPath(this.withPrefix("ProducedMaterialItemList"), () => QProductMaterialItem);
    public readonly WIs = new QEntityCollectionPath(this.withPrefix("WIs"), () => QWorkInstructionParameters);
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
}

export const qAutomaticCollectWorkInstruction = new QAutomaticCollectWorkInstruction();

export class QCreatePrintJobFileResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreatePrintJobFileResponse = new QCreatePrintJobFileResponse();

export class QCreatePrintJobFile extends QueryObject {
    public readonly PrintJobFile = new QEntityPath(this.withPrefix("PrintJobFile"), () => QPJFParameterType);
}

export const qCreatePrintJobFile = new QCreatePrintJobFile();

export class QAcceptChangeReplaceToBeConsumedMaterialResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeReplaceToBeConsumedMaterialResponse = new QAcceptChangeReplaceToBeConsumedMaterialResponse();

export class QAcceptChangeReplaceToBeConsumedMaterial extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly OldToBeConsumedMaterialId = new QGuidPath(this.withPrefix("OldToBeConsumedMaterialId"));
    public readonly NewToBeConsumedMaterialId = new QEntityPath(this.withPrefix("NewToBeConsumedMaterialId"), () => QToBeConsumedMaterialParameter);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly IsMaterialBehaviourOutputTypeFlag0 = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputTypeFlag0"));
    public readonly IsMaterialBehaviourOutputType = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputType"));
}

export const qAcceptChangeReplaceToBeConsumedMaterial = new QAcceptChangeReplaceToBeConsumedMaterial();

export class QUploadPLMXResponse extends QCommandResponse {
    public readonly FileURL = new QStringPath(this.withPrefix("FileURL"));
}

export const qUploadPLMXResponse = new QUploadPLMXResponse();

export class QUploadPLMX extends QueryObject {
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
    public readonly PackageId = new QStringPath(this.withPrefix("PackageId"));
}

export const qUploadPLMX = new QUploadPLMX();

export class QUnLinkSkillsFromTeamResponse extends QCommandResponse {
}

export const qUnLinkSkillsFromTeamResponse = new QUnLinkSkillsFromTeamResponse();

export class QUnLinkSkillsFromTeam extends QueryObject {
    public readonly TeamSkillAssociationIds = new QCollectionPath(this.withPrefix("TeamSkillAssociationIds"), () => QGuidCollection);
}

export const qUnLinkSkillsFromTeam = new QUnLinkSkillsFromTeam();

export class QCompleteWOStepFullQtyResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qCompleteWOStepFullQtyResponse = new QCompleteWOStepFullQtyResponse();

export class QCompleteWOStepFullQty extends QueryObject {
    public readonly CompleteWOStepFullQtyParameterType = new QEntityPath(this.withPrefix("CompleteWOStepFullQtyParameterType"), () => QCompleteWOStepFullQtyParameterType);
}

export const qCompleteWOStepFullQty = new QCompleteWOStepFullQty();

export class QUpdateStepResponse extends QCommandResponse {
}

export const qUpdateStepResponse = new QUpdateStepResponse();

export class QUpdateStep extends QueryObject {
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QUpdateStepParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateStep = new QUpdateStep();

export class QUnlinkPrintJobFileFromEquipmentTypeResponse extends QCommandResponse {
}

export const qUnlinkPrintJobFileFromEquipmentTypeResponse = new QUnlinkPrintJobFileFromEquipmentTypeResponse();

export class QUnlinkPrintJobFileFromEquipmentType extends QueryObject {
    public readonly AssociationId = new QGuidPath(this.withPrefix("AssociationId"));
}

export const qUnlinkPrintJobFileFromEquipmentType = new QUnlinkPrintJobFileFromEquipmentType();

export class QSetTargetQuantityOnFlexibleWorkOrderResponse extends QCommandResponse {
}

export const qSetTargetQuantityOnFlexibleWorkOrderResponse = new QSetTargetQuantityOnFlexibleWorkOrderResponse();

export class QSetTargetQuantityOnFlexibleWorkOrder extends QueryObject {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qSetTargetQuantityOnFlexibleWorkOrder = new QSetTargetQuantityOnFlexibleWorkOrder();

export class QCreateOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateOperationResponse = new QCreateOperationResponse();

export class QCreateOperation extends QueryObject {
    public readonly Operation = new QEntityPath(this.withPrefix("Operation"), () => QOperationParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qCreateOperation = new QCreateOperation();

export class QLinkPJFToEquipmentSpecificationResponse extends QCommandResponse {
}

export const qLinkPJFToEquipmentSpecificationResponse = new QLinkPJFToEquipmentSpecificationResponse();

export class QLinkPJFToEquipmentSpecification extends QueryObject {
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExtId = new QStringPath(this.withPrefix("PrintJobFileExtId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
    public readonly EquipmentSpecification = new QGuidPath(this.withPrefix("EquipmentSpecification"));
    public readonly Process = new QGuidPath(this.withPrefix("Process"));
}

export const qLinkPJFToEquipmentSpecification = new QLinkPJFToEquipmentSpecification();

export class QCreateAndAssignProducedMaterialItemsResponse extends QCommandResponse {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qCreateAndAssignProducedMaterialItemsResponse = new QCreateAndAssignProducedMaterialItemsResponse();

export class QCreateAndAssignProducedMaterialItems extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly SerialNumberCodes = new QCollectionPath(this.withPrefix("SerialNumberCodes"), () => QStringCollection);
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
}

export const qCreateAndAssignProducedMaterialItems = new QCreateAndAssignProducedMaterialItems();

export class QCreateToolCompatibleMachineResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolCompatibleMachineResponse = new QCreateToolCompatibleMachineResponse();

export class QCreateToolCompatibleMachine extends QueryObject {
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
}

export const qCreateToolCompatibleMachine = new QCreateToolCompatibleMachine();

export class QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationListResponse extends QCommandResponse {
    public readonly RuntimeCharReprRefOperationAssociationIdList = new QCollectionPath(this.withPrefix("RuntimeCharReprRefOperationAssociationIdList"), () => QGuidCollection);
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
}

export const qLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationListResponse = new QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationListResponse();

export class QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList extends QueryObject {
    public readonly RuntimeCharReprRefOpAssParameterTypeList = new QEntityCollectionPath(this.withPrefix("RuntimeCharReprRefOpAssParameterTypeList"), () => QRuntimeCharReprRefOpAssParameterType);
}

export const qLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList = new QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList();

export class QAssociateDNCItemMachineMaterialsAssociationResponse extends QCommandResponse {
    public readonly FailedId = new QGuidPath(this.withPrefix("FailedId"));
}

export const qAssociateDNCItemMachineMaterialsAssociationResponse = new QAssociateDNCItemMachineMaterialsAssociationResponse();

export class QAssociateDNCItemMachineMaterialsAssociation extends QueryObject {
    public readonly Ids = new QEntityPath(this.withPrefix("Ids"), () => QIdsParameterType);
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
    public readonly ManageHierarchy = new QBooleanPath(this.withPrefix("ManageHierarchy"));
}

export const qAssociateDNCItemMachineMaterialsAssociation = new QAssociateDNCItemMachineMaterialsAssociation();

export class QDeleteWorkInstructionTemplateResponse extends QCommandResponse {
}

export const qDeleteWorkInstructionTemplateResponse = new QDeleteWorkInstructionTemplateResponse();

export class QDeleteWorkInstructionTemplate extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkInstructionTemplate = new QDeleteWorkInstructionTemplate();

export class QActivateMaterialTrackingUnitOnScrewingToolResponse extends QCommandResponse {
}

export const qActivateMaterialTrackingUnitOnScrewingToolResponse = new QActivateMaterialTrackingUnitOnScrewingToolResponse();

export class QActivateMaterialTrackingUnitOnScrewingTool extends QueryObject {
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly ToBeUsedToolId = new QGuidPath(this.withPrefix("ToBeUsedToolId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qActivateMaterialTrackingUnitOnScrewingTool = new QActivateMaterialTrackingUnitOnScrewingTool();

export class QLinkWorkInstructionDefinitionListToStepResponse extends QCommandResponse {
}

export const qLinkWorkInstructionDefinitionListToStepResponse = new QLinkWorkInstructionDefinitionListToStepResponse();

export class QLinkWorkInstructionDefinitionListToStep extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly WorkInstructionDefinitionList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionList"), () => QGuidCollection);
    public readonly WorkInstructionAssociationType = new QStringPath(this.withPrefix("WorkInstructionAssociationType"));
}

export const qLinkWorkInstructionDefinitionListToStep = new QLinkWorkInstructionDefinitionListToStep();

export class QUpdateTransportOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateTransportOperationResponse = new QUpdateTransportOperationResponse();

export class QUpdateTransportOperation extends QueryObject {
    public readonly TransportOperationId = new QGuidPath(this.withPrefix("TransportOperationId"));
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
    public readonly SourceBufferId = new QGuidPath(this.withPrefix("SourceBufferId"));
    public readonly DestinationBufferId = new QGuidPath(this.withPrefix("DestinationBufferId"));
}

export const qUpdateTransportOperation = new QUpdateTransportOperation();

export class QDeleteWOOperationDependencyResponse extends QCommandResponse {
}

export const qDeleteWOOperationDependencyResponse = new QDeleteWOOperationDependencyResponse();

export class QDeleteWOOperationDependency extends QueryObject {
    public readonly Dependency = new QEntityPath(this.withPrefix("Dependency"), () => QWorkOOperationDependencyParameter);
}

export const qDeleteWOOperationDependency = new QDeleteWOOperationDependency();

export class QUnLoadHandlingUnitResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnLoadHandlingUnitResponse = new QUnLoadHandlingUnitResponse();

export class QUnLoadHandlingUnit extends QueryObject {
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
}

export const qUnLoadHandlingUnit = new QUnLoadHandlingUnit();

export class QTCM2AssociateDocumentToStepListResponse extends QCommandResponse {
}

export const qTCM2AssociateDocumentToStepListResponse = new QTCM2AssociateDocumentToStepListResponse();

export class QTCM2AssociateDocumentToStepList extends QueryObject {
    public readonly DocumentAssociationList = new QEntityCollectionPath(this.withPrefix("DocumentAssociationList"), () => QTCM2DocumentAssociationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2AssociateDocumentToStepList = new QTCM2AssociateDocumentToStepList();

export class QDisassembleMaterialItemResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly DM_MaterialHistoryId = new QGuidPath(this.withPrefix("DM_MaterialHistoryId"));
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly DisassembledMaterialItemList = new QEntityCollectionPath(this.withPrefix("DisassembledMaterialItemList"), () => QDisassembledMaterialItemParameterType);
}

export const qDisassembleMaterialItemResponse = new QDisassembleMaterialItemResponse();

export class QDisassembleMaterialItem extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MaterialItemToDisassembleList = new QEntityCollectionPath(this.withPrefix("MaterialItemToDisassembleList"), () => QMaterialItemToDisassembleParameterType);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly IsCoProduct = new QBooleanPath(this.withPrefix("IsCoProduct"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
}

export const qDisassembleMaterialItem = new QDisassembleMaterialItem();

export class QEnableLocationMachineForCompleteByDifferentUserResponse extends QCommandResponse {
}

export const qEnableLocationMachineForCompleteByDifferentUserResponse = new QEnableLocationMachineForCompleteByDifferentUserResponse();

export class QEnableLocationMachineForCompleteByDifferentUser extends QueryObject {
    public readonly EquipmentConfigurationNId = new QCollectionPath(this.withPrefix("EquipmentConfigurationNId"), () => QStringCollection);
    public readonly Enabled = new QBooleanPath(this.withPrefix("Enabled"));
}

export const qEnableLocationMachineForCompleteByDifferentUser = new QEnableLocationMachineForCompleteByDifferentUser();

export class QUnsetWorkInstructionDefinitionRevisionCurrentResponse extends QCommandResponse {
}

export const qUnsetWorkInstructionDefinitionRevisionCurrentResponse = new QUnsetWorkInstructionDefinitionRevisionCurrentResponse();

export class QUnsetWorkInstructionDefinitionRevisionCurrent extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnsetWorkInstructionDefinitionRevisionCurrent = new QUnsetWorkInstructionDefinitionRevisionCurrent();

export class QUpdateActualUsedMachineResponse extends QCommandResponse {
}

export const qUpdateActualUsedMachineResponse = new QUpdateActualUsedMachineResponse();

export class QUpdateActualUsedMachine extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qUpdateActualUsedMachine = new QUpdateActualUsedMachine();

export class QUpdateEquipmentConfigurationPropertyAttributeResponse extends QCommandResponse {
}

export const qUpdateEquipmentConfigurationPropertyAttributeResponse = new QUpdateEquipmentConfigurationPropertyAttributeResponse();

export class QUpdateEquipmentConfigurationPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentConfigurationPropertyAttribute = new QUpdateEquipmentConfigurationPropertyAttribute();

export class QDeleteDefectGroupListResponse extends QCommandResponse {
}

export const qDeleteDefectGroupListResponse = new QDeleteDefectGroupListResponse();

export class QDeleteDefectGroupList extends QueryObject {
    public readonly DefectGroupIdentifierList = new QEntityCollectionPath(this.withPrefix("DefectGroupIdentifierList"), () => QIdentifiersParameterType);
}

export const qDeleteDefectGroupList = new QDeleteDefectGroupList();

export class QAbortExecutionGroupListResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
}

export const qAbortExecutionGroupListResponse = new QAbortExecutionGroupListResponse();

export class QAbortExecutionGroupList extends QueryObject {
    public readonly ExecutionGroupNIdList = new QCollectionPath(this.withPrefix("ExecutionGroupNIdList"), () => QStringCollection);
}

export const qAbortExecutionGroupList = new QAbortExecutionGroupList();

export class QCreateTemplateToMaterialPlantResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateTemplateToMaterialPlantResponse = new QCreateTemplateToMaterialPlantResponse();

export class QCreateTemplateToMaterialPlant extends QueryObject {
    public readonly DM_Material = new QGuidPath(this.withPrefix("DM_Material"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qCreateTemplateToMaterialPlant = new QCreateTemplateToMaterialPlant();

export class QDeleteSetPointListResponse extends QCommandResponse {
}

export const qDeleteSetPointListResponse = new QDeleteSetPointListResponse();

export class QDeleteSetPointList extends QueryObject {
    public readonly SetPointIds = new QCollectionPath(this.withPrefix("SetPointIds"), () => QGuidCollection);
}

export const qDeleteSetPointList = new QDeleteSetPointList();

export class QCreateSkipReasonResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateSkipReasonResponse = new QCreateSkipReasonResponse();

export class QCreateSkipReason extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateSkipReason = new QCreateSkipReason();

export class QCreateWorkInstructionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkInstructionResponse = new QCreateWorkInstructionResponse();

export class QCreateWorkInstruction extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly WorkInstructionDefinitionNId = new QStringPath(this.withPrefix("WorkInstructionDefinitionNId"));
    public readonly WorkInstructionDefinitionRevision = new QStringPath(this.withPrefix("WorkInstructionDefinitionRevision"));
    public readonly ParameterValues = new QEntityCollectionPath(this.withPrefix("ParameterValues"), () => QParameterValueParameterType);
    public readonly IsReEditEnabled = new QBooleanPath(this.withPrefix("IsReEditEnabled"));
}

export const qCreateWorkInstruction = new QCreateWorkInstruction();

export class QLinkWorkInstructionsToWOStepResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWorkInstructionsToWOStepResponse = new QLinkWorkInstructionsToWOStepResponse();

export class QLinkWorkInstructionsToWOStep extends QueryObject {
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly SerialNumbers = new QCollectionPath(this.withPrefix("SerialNumbers"), () => QStringCollection);
    public readonly IsReEditEnabled = new QBooleanPath(this.withPrefix("IsReEditEnabled"));
}

export const qLinkWorkInstructionsToWOStep = new QLinkWorkInstructionsToWOStep();

export class QDeleteMaterialSpecificationListResponse extends QCommandResponse {
}

export const qDeleteMaterialSpecificationListResponse = new QDeleteMaterialSpecificationListResponse();

export class QDeleteMaterialSpecificationList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteMaterialSpecificationList = new QDeleteMaterialSpecificationList();

export class QDeleteToBeProducedMaterialResponse extends QCommandResponse {
}

export const qDeleteToBeProducedMaterialResponse = new QDeleteToBeProducedMaterialResponse();

export class QDeleteToBeProducedMaterial extends QueryObject {
    public readonly ToBeProducedMaterialId = new QGuidPath(this.withPrefix("ToBeProducedMaterialId"));
}

export const qDeleteToBeProducedMaterial = new QDeleteToBeProducedMaterial();

export class QCreateReworkCodeListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateReworkCodeListResponse = new QCreateReworkCodeListResponse();

export class QCreateReworkCodeList extends QueryObject {
    public readonly DM_MaterialIdList = new QCollectionPath(this.withPrefix("DM_MaterialIdList"), () => QGuidCollection);
    public readonly DefectTypeId = new QGuidPath(this.withPrefix("DefectTypeId"));
    public readonly DefectGroupId = new QGuidPath(this.withPrefix("DefectGroupId"));
    public readonly ProcessIdentifiersList = new QEntityCollectionPath(this.withPrefix("ProcessIdentifiersList"), () => QProcessIdentifiersParameterType);
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
}

export const qCreateReworkCodeList = new QCreateReworkCodeList();

export class QLinkProcessToProcessResponse extends QCommandResponse {
}

export const qLinkProcessToProcessResponse = new QLinkProcessToProcessResponse();

export class QLinkProcessToProcess extends QueryObject {
    public readonly FromProcessId = new QGuidPath(this.withPrefix("FromProcessId"));
    public readonly ToProcessId = new QGuidPath(this.withPrefix("ToProcessId"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qLinkProcessToProcess = new QLinkProcessToProcess();

export class QCreateEquipmentConfigurationResponse extends QCommandResponse {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qCreateEquipmentConfigurationResponse = new QCreateEquipmentConfigurationResponse();

export class QCreateEquipmentConfiguration extends QueryObject {
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentConfigStateMachineNids = new QCollectionPath(this.withPrefix("EquipmentConfigStateMachineNids"), () => QStringCollection);
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyWithAttributesParameterType);
}

export const qCreateEquipmentConfiguration = new QCreateEquipmentConfiguration();

export class QSetCheckedOutOnWorkOrderOperationListResponse extends QCommandResponse {
}

export const qSetCheckedOutOnWorkOrderOperationListResponse = new QSetCheckedOutOnWorkOrderOperationListResponse();

export class QSetCheckedOutOnWorkOrderOperationList extends QueryObject {
    public readonly CheckOutFlag0 = new QBooleanPath(this.withPrefix("CheckOutFlag0"));
    public readonly CheckOut = new QBooleanPath(this.withPrefix("CheckOut"));
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
}

export const qSetCheckedOutOnWorkOrderOperationList = new QSetCheckedOutOnWorkOrderOperationList();

export class QUpdateExecutionGroupResponse extends QCommandResponse {
}

export const qUpdateExecutionGroupResponse = new QUpdateExecutionGroupResponse();

export class QUpdateExecutionGroup extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateExecutionGroup = new QUpdateExecutionGroup();

export class QUpdateWorkInstructionTemplateParameterResponse extends QCommandResponse {
}

export const qUpdateWorkInstructionTemplateParameterResponse = new QUpdateWorkInstructionTemplateParameterResponse();

export class QUpdateWorkInstructionTemplateParameter extends QueryObject {
    public readonly IdFlag0 = new QBooleanPath(this.withPrefix("IdFlag0"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qUpdateWorkInstructionTemplateParameter = new QUpdateWorkInstructionTemplateParameter();

export class QRemoveCertificationToMaterialListResponse extends QCommandResponse {
}

export const qRemoveCertificationToMaterialListResponse = new QRemoveCertificationToMaterialListResponse();

export class QRemoveCertificationToMaterialList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly MaterialIds = new QEntityCollectionPath(this.withPrefix("MaterialIds"), () => QCertificationAssociationParameterType);
}

export const qRemoveCertificationToMaterialList = new QRemoveCertificationToMaterialList();

export class QDeleteMasterPlanResponse extends QCommandResponse {
}

export const qDeleteMasterPlanResponse = new QDeleteMasterPlanResponse();

export class QDeleteMasterPlan extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteMasterPlan = new QDeleteMasterPlan();

export class QCreateCriticalityResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateCriticalityResponse = new QCreateCriticalityResponse();

export class QCreateCriticality extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
}

export const qCreateCriticality = new QCreateCriticality();

export class QDeleteMaterialTrackingUnitResponse extends QCommandResponse {
}

export const qDeleteMaterialTrackingUnitResponse = new QDeleteMaterialTrackingUnitResponse();

export class QDeleteMaterialTrackingUnit extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteMaterialTrackingUnit = new QDeleteMaterialTrackingUnit();

export class QUnLinkUsersFromTeamResponse extends QCommandResponse {
}

export const qUnLinkUsersFromTeamResponse = new QUnLinkUsersFromTeamResponse();

export class QUnLinkUsersFromTeam extends QueryObject {
    public readonly TeamUserAssociationIds = new QCollectionPath(this.withPrefix("TeamUserAssociationIds"), () => QGuidCollection);
}

export const qUnLinkUsersFromTeam = new QUnLinkUsersFromTeam();

export class QUpdateOfflineActionResponse extends QCommandResponse {
}

export const qUpdateOfflineActionResponse = new QUpdateOfflineActionResponse();

export class QUpdateOfflineAction extends QueryObject {
    public readonly OfflineActionIdFlag0 = new QBooleanPath(this.withPrefix("OfflineActionIdFlag0"));
    public readonly OfflineActionId = new QGuidPath(this.withPrefix("OfflineActionId"));
    public readonly StatusTransitionVerb = new QStringPath(this.withPrefix("StatusTransitionVerb"));
    public readonly CommandResponse = new QStringPath(this.withPrefix("CommandResponse"));
}

export const qUpdateOfflineAction = new QUpdateOfflineAction();

export class QAcceptChangeAddWorkInstructionResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeAddWorkInstructionResponse = new QAcceptChangeAddWorkInstructionResponse();

export class QAcceptChangeAddWorkInstruction extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WIDefinitionId = new QGuidPath(this.withPrefix("WIDefinitionId"));
    public readonly SerialNumberCodes = new QCollectionPath(this.withPrefix("SerialNumberCodes"), () => QStringCollection);
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ChangeDataCollectionId = new QGuidPath(this.withPrefix("ChangeDataCollectionId"));
}

export const qAcceptChangeAddWorkInstruction = new QAcceptChangeAddWorkInstruction();

export class QCreateToBeUsedDocumentsResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateToBeUsedDocumentsResponse = new QCreateToBeUsedDocumentsResponse();

export class QCreateToBeUsedDocuments extends QueryObject {
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DocumentType = new QStringPath(this.withPrefix("DocumentType"));
    public readonly MaterialItemIdList = new QCollectionPath(this.withPrefix("MaterialItemIdList"), () => QGuidCollection);
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qCreateToBeUsedDocuments = new QCreateToBeUsedDocuments();

export class QCheckInCompleteWOOperationSerializedResponse extends QCommandResponse {
}

export const qCheckInCompleteWOOperationSerializedResponse = new QCheckInCompleteWOOperationSerializedResponse();

export class QCheckInCompleteWOOperationSerialized extends QueryObject {
    public readonly CompleteWOOperationSerializedParameterType = new QEntityPath(this.withPrefix("CompleteWOOperationSerializedParameterType"), () => QCompleteWOOperationSerializedParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInCompleteWOOperationSerialized = new QCheckInCompleteWOOperationSerialized();

export class QCreateWOStepDependencyResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWOStepDependencyResponse = new QCreateWOStepDependencyResponse();

export class QCreateWOStepDependency extends QueryObject {
    public readonly Dependency = new QEntityPath(this.withPrefix("Dependency"), () => QWorkOStepDependencyParameter);
}

export const qCreateWOStepDependency = new QCreateWOStepDependency();

export class QReleaseWorkOrderResponse extends QCommandResponse {
    public readonly Id = new QCollectionPath(this.withPrefix("Id"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qReleaseWorkOrderResponse = new QReleaseWorkOrderResponse();

export class QReleaseWorkOrder extends QueryObject {
    public readonly ReleaseWorkOrderDetails = new QEntityCollectionPath(this.withPrefix("ReleaseWorkOrderDetails"), () => QReleaseWorkOrderParameterType);
}

export const qReleaseWorkOrder = new QReleaseWorkOrder();

export class QDeleteBoMItemListResponse extends QCommandResponse {
}

export const qDeleteBoMItemListResponse = new QDeleteBoMItemListResponse();

export class QDeleteBoMItemList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteBoMItemList = new QDeleteBoMItemList();

export class QStartWOOperationsSerializedLiteSingleWOResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
    public readonly StartedWorkOrderOperations = new QEntityCollectionPath(this.withPrefix("StartedWorkOrderOperations"), () => QWOOpSerializedLiteOutputParameterType);
}

export const qStartWOOperationsSerializedLiteSingleWOResponse = new QStartWOOperationsSerializedLiteSingleWOResponse();

export class QStartWOOperationsSerializedLiteSingleWO extends QueryObject {
    public readonly StartWOOpSerializedLiteParameters = new QEntityCollectionPath(this.withPrefix("StartWOOpSerializedLiteParameters"), () => QWOOperationSerializedLiteParameterType);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qStartWOOperationsSerializedLiteSingleWO = new QStartWOOperationsSerializedLiteSingleWO();

export class QSendMailResponse extends QCommandResponse {
}

export const qSendMailResponse = new QSendMailResponse();

export class QSendMail extends QueryObject {
    public readonly NonConformance = new QEntityPath(this.withPrefix("NonConformance"), () => QNonConformanceParameterType);
    public readonly NonConformanceTransitionNId = new QStringPath(this.withPrefix("NonConformanceTransitionNId"));
}

export const qSendMail = new QSendMail();

export class QStartWOOperationsSerializedLiteResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
}

export const qStartWOOperationsSerializedLiteResponse = new QStartWOOperationsSerializedLiteResponse();

export class QStartWOOperationsSerializedLite extends QueryObject {
    public readonly StartWOOpSerializedLiteParameters = new QEntityCollectionPath(this.withPrefix("StartWOOpSerializedLiteParameters"), () => QWOOperationSerializedLiteParameterType);
    public readonly User = new QStringPath(this.withPrefix("User"));
}

export const qStartWOOperationsSerializedLite = new QStartWOOperationsSerializedLite();

export class QCloneAsPlannedBOPResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCloneAsPlannedBOPResponse = new QCloneAsPlannedBOPResponse();

export class QCloneAsPlannedBOP extends QueryObject {
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
    public readonly BaselineName = new QStringPath(this.withPrefix("BaselineName"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly SourceAsPlannedBOPId = new QGuidPath(this.withPrefix("SourceAsPlannedBOPId"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
}

export const qCloneAsPlannedBOP = new QCloneAsPlannedBOP();

export class QGenerateAndAssociateMTUCodeResponse extends QCommandResponse {
}

export const qGenerateAndAssociateMTUCodeResponse = new QGenerateAndAssociateMTUCodeResponse();

export class QGenerateAndAssociateMTUCode extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
}

export const qGenerateAndAssociateMTUCode = new QGenerateAndAssociateMTUCode();

export class QUpdateStatusDefinitionResponse extends QCommandResponse {
}

export const qUpdateStatusDefinitionResponse = new QUpdateStatusDefinitionResponse();

export class QUpdateStatusDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
}

export const qUpdateStatusDefinition = new QUpdateStatusDefinition();

export class QGenerateWorkOrderNIdResponse extends QCommandResponse {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qGenerateWorkOrderNIdResponse = new QGenerateWorkOrderNIdResponse();

export class QGenerateWorkOrderNId extends QueryObject {
    public readonly MaterialId = new QStringPath(this.withPrefix("MaterialId"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qGenerateWorkOrderNId = new QGenerateWorkOrderNId();

export class QCreateAMPowderBatchGenealogyResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateAMPowderBatchGenealogyResponse = new QCreateAMPowderBatchGenealogyResponse();

export class QCreateAMPowderBatchGenealogy extends QueryObject {
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly MixedQuantity = new QStringPath(this.withPrefix("MixedQuantity"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QStringPath(this.withPrefix("RecycleCount"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly SourceDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("SourceDM_MaterialTrackingUnit"));
    public readonly TargetDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("TargetDM_MaterialTrackingUnit"));
    public readonly Action = new QGuidPath(this.withPrefix("Action"));
}

export const qCreateAMPowderBatchGenealogy = new QCreateAMPowderBatchGenealogy();

export class QUnlinkWIDefinitionsFromEGPhaseResponse extends QCommandResponse {
}

export const qUnlinkWIDefinitionsFromEGPhaseResponse = new QUnlinkWIDefinitionsFromEGPhaseResponse();

export class QUnlinkWIDefinitionsFromEGPhase extends QueryObject {
    public readonly WIDefinitionToEGPhaseAssociationIds = new QCollectionPath(this.withPrefix("WIDefinitionToEGPhaseAssociationIds"), () => QGuidCollection);
}

export const qUnlinkWIDefinitionsFromEGPhase = new QUnlinkWIDefinitionsFromEGPhase();

export class QUpdateFutureHoldResponse extends QCommandResponse {
}

export const qUpdateFutureHoldResponse = new QUpdateFutureHoldResponse();

export class QUpdateFutureHold extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CloseTime = new QDateTimeOffsetPath(this.withPrefix("CloseTime"));
    public readonly CloseUserId = new QStringPath(this.withPrefix("CloseUserId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly IsPresent = new QBooleanPath(this.withPrefix("IsPresent"));
    public readonly LifeCycle = new QStringPath(this.withPrefix("LifeCycle"));
    public readonly OpenTime = new QDateTimeOffsetPath(this.withPrefix("OpenTime"));
    public readonly OpenUserId = new QStringPath(this.withPrefix("OpenUserId"));
    public readonly PreviousStatus = new QStringPath(this.withPrefix("PreviousStatus"));
    public readonly ReasonId = new QStringPath(this.withPrefix("ReasonId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qUpdateFutureHold = new QUpdateFutureHold();

export class QEditPrintJobFileResponse extends QCommandResponse {
}

export const qEditPrintJobFileResponse = new QEditPrintJobFileResponse();

export class QEditPrintJobFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PrintJobFileDetails = new QEntityPath(this.withPrefix("PrintJobFileDetails"), () => QPJFParameterType);
    public readonly IsImport = new QBooleanPath(this.withPrefix("IsImport"));
}

export const qEditPrintJobFile = new QEditPrintJobFile();

export class QCheckInStartWOOperationTransferBatchResponse extends QCommandResponse {
}

export const qCheckInStartWOOperationTransferBatchResponse = new QCheckInStartWOOperationTransferBatchResponse();

export class QCheckInStartWOOperationTransferBatch extends QueryObject {
    public readonly StartWOOperationTransferBatchParameterType = new QEntityPath(this.withPrefix("StartWOOperationTransferBatchParameterType"), () => QStartWOOperationTransferBatchParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInStartWOOperationTransferBatch = new QCheckInStartWOOperationTransferBatch();

export class QDeleteBufferDefinitionResponse extends QCommandResponse {
}

export const qDeleteBufferDefinitionResponse = new QDeleteBufferDefinitionResponse();

export class QDeleteBufferDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteBufferDefinition = new QDeleteBufferDefinition();

export class QUnlinkItlkCheckToWorkOrderStepListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnlinkItlkCheckToWorkOrderStepListResponse = new QUnlinkItlkCheckToWorkOrderStepListResponse();

export class QUnlinkItlkCheckToWorkOrderStepList extends QueryObject {
    public readonly ItlkCheckWOStepAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckWOStepAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkItlkCheckToWorkOrderStepList = new QUnlinkItlkCheckToWorkOrderStepList();

export class QLinkDocumentListToDM_MaterialTrackingUnitResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitDocumentAssociationIds = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitDocumentAssociationIds"), () => QGuidCollection);
}

export const qLinkDocumentListToDM_MaterialTrackingUnitResponse = new QLinkDocumentListToDM_MaterialTrackingUnitResponse();

export class QLinkDocumentListToDM_MaterialTrackingUnit extends QueryObject {
    public readonly DocumentIdsList = new QCollectionPath(this.withPrefix("DocumentIdsList"), () => QGuidCollection);
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly WorkOderOperationId = new QGuidPath(this.withPrefix("WorkOderOperationId"));
    public readonly ExecutioGroupPhaseId = new QGuidPath(this.withPrefix("ExecutioGroupPhaseId"));
    public readonly ExecutioGroupPhaseNId = new QStringPath(this.withPrefix("ExecutioGroupPhaseNId"));
    public readonly WorkOderOperationNId = new QStringPath(this.withPrefix("WorkOderOperationNId"));
    public readonly AreCurrent = new QBooleanPath(this.withPrefix("AreCurrent"));
}

export const qLinkDocumentListToDM_MaterialTrackingUnit = new QLinkDocumentListToDM_MaterialTrackingUnit();

export class QCreateWorkOrderFromProcessResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderFromProcessResponse = new QCreateWorkOrderFromProcessResponse();

export class QCreateWorkOrderFromProcess extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly AsPlannedId = new QGuidPath(this.withPrefix("AsPlannedId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoMParameterType);
}

export const qCreateWorkOrderFromProcess = new QCreateWorkOrderFromProcess();

export class QCreateResultListResponse extends QCommandResponse {
    public readonly ResultIdList = new QCollectionPath(this.withPrefix("ResultIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly CreatedResultList = new QEntityCollectionPath(this.withPrefix("CreatedResultList"), () => QOnResultCreationParameterType);
}

export const qCreateResultListResponse = new QCreateResultListResponse();

export class QCreateResultList extends QueryObject {
    public readonly ResultList = new QEntityCollectionPath(this.withPrefix("ResultList"), () => QCreateResultListParameterType);
}

export const qCreateResultList = new QCreateResultList();

export class QCreateMaterialDefinitionDocumentResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateMaterialDefinitionDocumentResponse = new QCreateMaterialDefinitionDocumentResponse();

export class QCreateMaterialDefinitionDocument extends QueryObject {
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qCreateMaterialDefinitionDocument = new QCreateMaterialDefinitionDocument();

export class QCheckOutWorkOrderOperationListResponse extends QCommandResponse {
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
}

export const qCheckOutWorkOrderOperationListResponse = new QCheckOutWorkOrderOperationListResponse();

export class QCheckOutWorkOrderOperationList extends QueryObject {
    public readonly DeviceId = new QStringPath(this.withPrefix("DeviceId"));
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
}

export const qCheckOutWorkOrderOperationList = new QCheckOutWorkOrderOperationList();

export class QCreateExecutionGroupPhaseDependencyResponse extends QCommandResponse {
}

export const qCreateExecutionGroupPhaseDependencyResponse = new QCreateExecutionGroupPhaseDependencyResponse();

export class QCreateExecutionGroupPhaseDependency extends QueryObject {
    public readonly FromEGPhaseId = new QGuidPath(this.withPrefix("FromEGPhaseId"));
    public readonly ToEGPhaseId = new QGuidPath(this.withPrefix("ToEGPhaseId"));
}

export const qCreateExecutionGroupPhaseDependency = new QCreateExecutionGroupPhaseDependency();

export class QCreateWorkInstructionTemplateResponse extends QCommandResponse {
    public readonly WorkInstructionTemplateId = new QGuidPath(this.withPrefix("WorkInstructionTemplateId"));
    public readonly ParameterIds = new QCollectionPath(this.withPrefix("ParameterIds"), () => QGuidCollection);
}

export const qCreateWorkInstructionTemplateResponse = new QCreateWorkInstructionTemplateResponse();

export class QCreateWorkInstructionTemplate extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QWorkInstructionDefinitionParameterParameterType);
}

export const qCreateWorkInstructionTemplate = new QCreateWorkInstructionTemplate();

export class QCreateStatusDefinitionResponse extends QCommandResponse {
    public readonly StatusDefinitionId = new QGuidPath(this.withPrefix("StatusDefinitionId"));
}

export const qCreateStatusDefinitionResponse = new QCreateStatusDefinitionResponse();

export class QCreateStatusDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
}

export const qCreateStatusDefinition = new QCreateStatusDefinition();

export class QLinkMaterialToContainerTypeListResponse extends QCommandResponse {
}

export const qLinkMaterialToContainerTypeListResponse = new QLinkMaterialToContainerTypeListResponse();

export class QLinkMaterialToContainerTypeList extends QueryObject {
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly CompatibleMaterialList = new QEntityCollectionPath(this.withPrefix("CompatibleMaterialList"), () => QMaterialParameterType);
}

export const qLinkMaterialToContainerTypeList = new QLinkMaterialToContainerTypeList();

export class QCreateWorkOrderStepFromStepResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderStepFromStepResponse = new QCreateWorkOrderStepFromStepResponse();

export class QCreateWorkOrderStepFromStep extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
}

export const qCreateWorkOrderStepFromStep = new QCreateWorkOrderStepFromStep();

export class QSubstrateMaintenanceResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSubstrateMaintenanceResponse = new QSubstrateMaintenanceResponse();

export class QSubstrateMaintenance extends QueryObject {
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly SubstrateId = new QGuidPath(this.withPrefix("SubstrateId"));
    public readonly Thickness = new QNumberPath(this.withPrefix("Thickness"));
    public readonly TreatmentCount = new QNumberPath(this.withPrefix("TreatmentCount"));
}

export const qSubstrateMaintenance = new QSubstrateMaintenance();

export class QUseScrewingToolResponse extends QCommandResponse {
}

export const qUseScrewingToolResponse = new QUseScrewingToolResponse();

export class QUseScrewingTool extends QueryObject {
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly ActualAngle = new QNumberPath(this.withPrefix("ActualAngle"));
    public readonly ActualTorque = new QNumberPath(this.withPrefix("ActualTorque"));
    public readonly BoltItemNumber = new QNumberPath(this.withPrefix("BoltItemNumber"));
    public readonly WorkOrderOperationId = new QStringPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
}

export const qUseScrewingTool = new QUseScrewingTool();

export class QSetFutureHoldAfterNonConformanceCreationResponse extends QCommandResponse {
}

export const qSetFutureHoldAfterNonConformanceCreationResponse = new QSetFutureHoldAfterNonConformanceCreationResponse();

export class QSetFutureHoldAfterNonConformanceCreation extends QueryObject {
    public readonly FutureHoldDetails = new QEntityPath(this.withPrefix("FutureHoldDetails"), () => QHoldParamterType);
    public readonly ExtensionKey = new QGuidPath(this.withPrefix("ExtensionKey"));
}

export const qSetFutureHoldAfterNonConformanceCreation = new QSetFutureHoldAfterNonConformanceCreation();

export class QCreateNonConformanceAttachmentListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateNonConformanceAttachmentListResponse = new QCreateNonConformanceAttachmentListResponse();

export class QCreateNonConformanceAttachmentList extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly AttachmentList = new QCollectionPath(this.withPrefix("AttachmentList"), () => QGuidCollection);
}

export const qCreateNonConformanceAttachmentList = new QCreateNonConformanceAttachmentList();

export class QDeleteWorkOrderHistoryResponse extends QCommandResponse {
}

export const qDeleteWorkOrderHistoryResponse = new QDeleteWorkOrderHistoryResponse();

export class QDeleteWorkOrderHistory extends QueryObject {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qDeleteWorkOrderHistory = new QDeleteWorkOrderHistory();

export class QUnlinkDocumentToOperationResponse extends QCommandResponse {
}

export const qUnlinkDocumentToOperationResponse = new QUnlinkDocumentToOperationResponse();

export class QUnlinkDocumentToOperation extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qUnlinkDocumentToOperation = new QUnlinkDocumentToOperation();

export class QCheckCertificationMultiMachineResponse extends QCommandResponse {
    public readonly NIds = new QCollectionPath(this.withPrefix("NIds"), () => QStringCollection);
}

export const qCheckCertificationMultiMachineResponse = new QCheckCertificationMultiMachineResponse();

export class QCheckCertificationMultiMachine extends QueryObject {
    public readonly CheckCertificationMultiMachineParameter = new QEntityCollectionPath(this.withPrefix("CheckCertificationMultiMachineParameter"), () => QCheckCertificationMultiMachineParameterType);
}

export const qCheckCertificationMultiMachine = new QCheckCertificationMultiMachine();

export class QCreateLogisticRequestItemResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateLogisticRequestItemResponse = new QCreateLogisticRequestItemResponse();

export class QCreateLogisticRequestItem extends QueryObject {
    public readonly ToolDefinition = new QGuidPath(this.withPrefix("ToolDefinition"));
    public readonly MaterialDefinition = new QGuidPath(this.withPrefix("MaterialDefinition"));
    public readonly LogisticRequest = new QGuidPath(this.withPrefix("LogisticRequest"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly Source = new QGuidPath(this.withPrefix("Source"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qCreateLogisticRequestItem = new QCreateLogisticRequestItem();

export class QCreateOperationDependencyResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateOperationDependencyResponse = new QCreateOperationDependencyResponse();

export class QCreateOperationDependency extends QueryObject {
    public readonly OperationDependency = new QEntityPath(this.withPrefix("OperationDependency"), () => QOperationDependencyParameterType);
}

export const qCreateOperationDependency = new QCreateOperationDependency();

export class QDeleteWorkInstructionDefinitionResponse extends QCommandResponse {
}

export const qDeleteWorkInstructionDefinitionResponse = new QDeleteWorkInstructionDefinitionResponse();

export class QDeleteWorkInstructionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkInstructionDefinition = new QDeleteWorkInstructionDefinition();

export class QPunchInUsersResponse extends QCommandResponse {
}

export const qPunchInUsersResponse = new QPunchInUsersResponse();

export class QPunchInUsers extends QueryObject {
    public readonly Users = new QCollectionPath(this.withPrefix("Users"), () => QStringCollection);
    public readonly ActiveUserOnMachineParameters = new QEntityCollectionPath(this.withPrefix("ActiveUserOnMachineParameters"), () => QActiveUserOnMachineParameterType);
}

export const qPunchInUsers = new QPunchInUsers();

export class QCheckInCompleteWOStepFullQtyResponse extends QCommandResponse {
}

export const qCheckInCompleteWOStepFullQtyResponse = new QCheckInCompleteWOStepFullQtyResponse();

export class QCheckInCompleteWOStepFullQty extends QueryObject {
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
    public readonly CompleteWOStepFullQtyParameter = new QEntityPath(this.withPrefix("CompleteWOStepFullQtyParameter"), () => QCompleteWOStepFullQtyParameterType);
}

export const qCheckInCompleteWOStepFullQty = new QCheckInCompleteWOStepFullQty();

export class QTCM2CreateEquipmentSpecificationFullListResponse extends QCommandResponse {
}

export const qTCM2CreateEquipmentSpecificationFullListResponse = new QTCM2CreateEquipmentSpecificationFullListResponse();

export class QTCM2CreateEquipmentSpecificationFullList extends QueryObject {
    public readonly EquipmentSpecificationList = new QEntityCollectionPath(this.withPrefix("EquipmentSpecificationList"), () => QTCM2EquipmentSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateEquipmentSpecificationFullList = new QTCM2CreateEquipmentSpecificationFullList();

export class QCreateWorkOrderResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderResponse = new QCreateWorkOrderResponse();

export class QCreateWorkOrder extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly ParentOrderId = new QGuidPath(this.withPrefix("ParentOrderId"));
    public readonly ReworkOfOrderId = new QGuidPath(this.withPrefix("ReworkOfOrderId"));
    public readonly InitialQuantity = new QNumberPath(this.withPrefix("InitialQuantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly ParentBatch = new QStringPath(this.withPrefix("ParentBatch"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Enterprise = new QStringPath(this.withPrefix("Enterprise"));
    public readonly PlannedTargetQuantity = new QNumberPath(this.withPrefix("PlannedTargetQuantity"));
    public readonly ActualTargetQuantity = new QNumberPath(this.withPrefix("ActualTargetQuantity"));
    public readonly TargetQuantity = new QNumberPath(this.withPrefix("TargetQuantity"));
    public readonly ConfirmationType = new QStringPath(this.withPrefix("ConfirmationType"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoMParameterType);
}

export const qCreateWorkOrder = new QCreateWorkOrder();

export class QUseToolResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUseToolResponse = new QUseToolResponse();

export class QUseTool extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Comments = new QStringPath(this.withPrefix("Comments"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly UsageDuration = new QNumberPath(this.withPrefix("UsageDuration"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly ActiveNonConformanceNr = new QNumberPath(this.withPrefix("ActiveNonConformanceNr"));
}

export const qUseTool = new QUseTool();

export class QCreateToolSpecificationListResponse extends QCommandResponse {
}

export const qCreateToolSpecificationListResponse = new QCreateToolSpecificationListResponse();

export class QCreateToolSpecificationList extends QueryObject {
    public readonly ToolSpecificationList = new QEntityCollectionPath(this.withPrefix("ToolSpecificationList"), () => QToolSpecificationParameterType);
}

export const qCreateToolSpecificationList = new QCreateToolSpecificationList();

export class QLinkSkillsToProcessOperationResponse extends QCommandResponse {
}

export const qLinkSkillsToProcessOperationResponse = new QLinkSkillsToProcessOperationResponse();

export class QLinkSkillsToProcessOperation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qLinkSkillsToProcessOperation = new QLinkSkillsToProcessOperation();

export class QLink3DPrinterTypeToEquipmentTypeResponse extends QCommandResponse {
}

export const qLink3DPrinterTypeToEquipmentTypeResponse = new QLink3DPrinterTypeToEquipmentTypeResponse();

export class QLink3DPrinterTypeToEquipmentType extends QueryObject {
    public readonly Link3DPrinterTypeToEquipmentTypeList = new QEntityCollectionPath(this.withPrefix("Link3DPrinterTypeToEquipmentTypeList"), () => QLink3DPrinterparameterType);
}

export const qLink3DPrinterTypeToEquipmentType = new QLink3DPrinterTypeToEquipmentType();

export class QCreateOperationRevisionSubStructureResponse extends QCommandResponse {
}

export const qCreateOperationRevisionSubStructureResponse = new QCreateOperationRevisionSubStructureResponse();

export class QCreateOperationRevisionSubStructure extends QueryObject {
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly SourceOperationId = new QGuidPath(this.withPrefix("SourceOperationId"));
    public readonly TargetOperationId = new QGuidPath(this.withPrefix("TargetOperationId"));
}

export const qCreateOperationRevisionSubStructure = new QCreateOperationRevisionSubStructure();

export class QLinkProcessToAsPlannedBOPResponse extends QCommandResponse {
}

export const qLinkProcessToAsPlannedBOPResponse = new QLinkProcessToAsPlannedBOPResponse();

export class QLinkProcessToAsPlannedBOP extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qLinkProcessToAsPlannedBOP = new QLinkProcessToAsPlannedBOP();

export class QDeleteEquipmentGraphTypeResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphTypeResponse = new QDeleteEquipmentGraphTypeResponse();

export class QDeleteEquipmentGraphType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphType = new QDeleteEquipmentGraphType();

export class QRemoveNonConformanceTransitionMailAddressListResponse extends QCommandResponse {
}

export const qRemoveNonConformanceTransitionMailAddressListResponse = new QRemoveNonConformanceTransitionMailAddressListResponse();

export class QRemoveNonConformanceTransitionMailAddressList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly MailAddressList = new QCollectionPath(this.withPrefix("MailAddressList"), () => QStringCollection);
}

export const qRemoveNonConformanceTransitionMailAddressList = new QRemoveNonConformanceTransitionMailAddressList();

export class QLinkItlkCheckToWorkOrderOperationListResponse extends QCommandResponse {
    public readonly ItlkCheckWOOpAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qLinkItlkCheckToWorkOrderOperationListResponse = new QLinkItlkCheckToWorkOrderOperationListResponse();

export class QLinkItlkCheckToWorkOrderOperationList extends QueryObject {
    public readonly ItlkCheckWOOpAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationList"), () => QItlkCheckWOOpAssociationParameterType);
}

export const qLinkItlkCheckToWorkOrderOperationList = new QLinkItlkCheckToWorkOrderOperationList();

export class QUnloadContainerResponse extends QCommandResponse {
}

export const qUnloadContainerResponse = new QUnloadContainerResponse();

export class QUnloadContainer extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly UnloadContainerParameterTypeList = new QEntityCollectionPath(this.withPrefix("UnloadContainerParameterTypeList"), () => QUnloadContainerParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUnloadContainer = new QUnloadContainer();

export class QCreateChangeResponse extends QCommandResponse {
    public readonly NonConformanceId = new QStringPath(this.withPrefix("NonConformanceId"));
}

export const qCreateChangeResponse = new QCreateChangeResponse();

export class QCreateChange extends QueryObject {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ChangeTypeId = new QGuidPath(this.withPrefix("ChangeTypeId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qCreateChange = new QCreateChange();

export class QDisAssignProducedMaterialItemsResponse extends QCommandResponse {
}

export const qDisAssignProducedMaterialItemsResponse = new QDisAssignProducedMaterialItemsResponse();

export class QDisAssignProducedMaterialItems extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly MaterialItems = new QEntityCollectionPath(this.withPrefix("MaterialItems"), () => QMaterialItemIdentifiersParameterType);
}

export const qDisAssignProducedMaterialItems = new QDisAssignProducedMaterialItems();

export class QUnlinkAutomationNodeInstanceParameterFromMaterialParameterListResponse extends QCommandResponse {
}

export const qUnlinkAutomationNodeInstanceParameterFromMaterialParameterListResponse = new QUnlinkAutomationNodeInstanceParameterFromMaterialParameterListResponse();

export class QUnlinkAutomationNodeInstanceParameterFromMaterialParameterList extends QueryObject {
    public readonly MaterialAutomationNodeInstanceParameterAssociationList = new QCollectionPath(this.withPrefix("MaterialAutomationNodeInstanceParameterAssociationList"), () => QGuidCollection);
}

export const qUnlinkAutomationNodeInstanceParameterFromMaterialParameterList = new QUnlinkAutomationNodeInstanceParameterFromMaterialParameterList();

export class QTCM2CreateMaterialSpecificationFullListResponse extends QCommandResponse {
}

export const qTCM2CreateMaterialSpecificationFullListResponse = new QTCM2CreateMaterialSpecificationFullListResponse();

export class QTCM2CreateMaterialSpecificationFullList extends QueryObject {
    public readonly MaterialSpecificationList = new QEntityCollectionPath(this.withPrefix("MaterialSpecificationList"), () => QTCM2MaterialSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateMaterialSpecificationFullList = new QTCM2CreateMaterialSpecificationFullList();

export class QStartWOOperationFullQtyResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qStartWOOperationFullQtyResponse = new QStartWOOperationFullQtyResponse();

export class QStartWOOperationFullQty extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly StartWOOperationFullQtyParameterType = new QEntityPath(this.withPrefix("StartWOOperationFullQtyParameterType"), () => QStartWOOperationFullQtyParameterType);
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartWOOperationFullQty = new QStartWOOperationFullQty();

export class QTakeOwnershipTransportOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qTakeOwnershipTransportOperationResponse = new QTakeOwnershipTransportOperationResponse();

export class QTakeOwnershipTransportOperation extends QueryObject {
    public readonly TransportOperationId = new QGuidPath(this.withPrefix("TransportOperationId"));
}

export const qTakeOwnershipTransportOperation = new QTakeOwnershipTransportOperation();

export class QTraceCertificationHistoryResponse extends QCommandResponse {
}

export const qTraceCertificationHistoryResponse = new QTraceCertificationHistoryResponse();

export class QTraceCertificationHistory extends QueryObject {
    public readonly CertificationActions = new QEntityCollectionPath(this.withPrefix("CertificationActions"), () => QCertificationHistoryParameterType);
}

export const qTraceCertificationHistory = new QTraceCertificationHistory();

export class QCreateSupplierResponse extends QCommandResponse {
    public readonly SupplierId = new QGuidPath(this.withPrefix("SupplierId"));
}

export const qCreateSupplierResponse = new QCreateSupplierResponse();

export class QCreateSupplier extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateSupplier = new QCreateSupplier();

export class QAutoGenerateWorkOrderNIdResponse extends QCommandResponse {
    public readonly AutoGeneratedWorkOrderNId = new QStringPath(this.withPrefix("AutoGeneratedWorkOrderNId"));
}

export const qAutoGenerateWorkOrderNIdResponse = new QAutoGenerateWorkOrderNIdResponse();

export class QAutoGenerateWorkOrderNId extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly NumberingPatternNId = new QStringPath(this.withPrefix("NumberingPatternNId"));
}

export const qAutoGenerateWorkOrderNId = new QAutoGenerateWorkOrderNId();

export class QCreateWorkOrdersFromAsPlannedBOPResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateWorkOrdersFromAsPlannedBOPResponse = new QCreateWorkOrdersFromAsPlannedBOPResponse();

export class QCreateWorkOrdersFromAsPlannedBOP extends QueryObject {
    public readonly BaselineUId = new QStringPath(this.withPrefix("BaselineUId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly WorkOrdersData = new QEntityCollectionPath(this.withPrefix("WorkOrdersData"), () => QAsPlannedWorkOrder);
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoMParameterType);
}

export const qCreateWorkOrdersFromAsPlannedBOP = new QCreateWorkOrdersFromAsPlannedBOP();

export class QReserveMaterialItemsResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
}

export const qReserveMaterialItemsResponse = new QReserveMaterialItemsResponse();

export class QReserveMaterialItems extends QueryObject {
    public readonly MaterialItemsToReserveList = new QEntityCollectionPath(this.withPrefix("MaterialItemsToReserveList"), () => QMaterialItemToReserveParamerType);
}

export const qReserveMaterialItems = new QReserveMaterialItems();

export class QDeleteBufferListResponse extends QCommandResponse {
}

export const qDeleteBufferListResponse = new QDeleteBufferListResponse();

export class QDeleteBufferList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteBufferList = new QDeleteBufferList();

export class QCreateEquipmentLevelResponse extends QCommandResponse {
    public readonly EquipConfLevelId = new QGuidPath(this.withPrefix("EquipConfLevelId"));
}

export const qCreateEquipmentLevelResponse = new QCreateEquipmentLevelResponse();

export class QCreateEquipmentLevel extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qCreateEquipmentLevel = new QCreateEquipmentLevel();

export class QUnlinkWorkInstructionsFromWOStepResponse extends QCommandResponse {
}

export const qUnlinkWorkInstructionsFromWOStepResponse = new QUnlinkWorkInstructionsFromWOStepResponse();

export class QUnlinkWorkInstructionsFromWOStep extends QueryObject {
    public readonly WorkInstructionWOSteps = new QCollectionPath(this.withPrefix("WorkInstructionWOSteps"), () => QGuidCollection);
}

export const qUnlinkWorkInstructionsFromWOStep = new QUnlinkWorkInstructionsFromWOStep();

export class QAcceptChangeChangeDependencyResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeChangeDependencyResponse = new QAcceptChangeChangeDependencyResponse();

export class QAcceptChangeChangeDependency extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly OldWorkOOperationDependencyId = new QStringPath(this.withPrefix("OldWorkOOperationDependencyId"));
    public readonly NewWorkOOperationDependency = new QEntityPath(this.withPrefix("NewWorkOOperationDependency"), () => QWorkOOperationDependencyParameter);
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qAcceptChangeChangeDependency = new QAcceptChangeChangeDependency();

export class QDeleteFunctionalCodeListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteFunctionalCodeListResponse = new QDeleteFunctionalCodeListResponse();

export class QDeleteFunctionalCodeList extends QueryObject {
    public readonly MaterialGroupIds = new QCollectionPath(this.withPrefix("MaterialGroupIds"), () => QGuidCollection);
}

export const qDeleteFunctionalCodeList = new QDeleteFunctionalCodeList();

export class QStartExecutionGroupResponse extends QCommandResponse {
}

export const qStartExecutionGroupResponse = new QStartExecutionGroupResponse();

export class QStartExecutionGroup extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly StartExecutionGroupParameterType = new QEntityPath(this.withPrefix("StartExecutionGroupParameterType"), () => QStartExecutionGroupParameteType);
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartExecutionGroup = new QStartExecutionGroup();

export class QRemoveCertificationToRoleListResponse extends QCommandResponse {
}

export const qRemoveCertificationToRoleListResponse = new QRemoveCertificationToRoleListResponse();

export class QRemoveCertificationToRoleList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly Roles = new QCollectionPath(this.withPrefix("Roles"), () => QStringCollection);
}

export const qRemoveCertificationToRoleList = new QRemoveCertificationToRoleList();

export class QCreateAPSAlertResponse extends QCommandResponse {
}

export const qCreateAPSAlertResponse = new QCreateAPSAlertResponse();

export class QCreateAPSAlert extends QueryObject {
    public readonly ChangeInformation = new QStringPath(this.withPrefix("ChangeInformation"));
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly OrderNId = new QStringPath(this.withPrefix("OrderNId"));
    public readonly TraceDate = new QDateTimeOffsetPath(this.withPrefix("TraceDate"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qCreateAPSAlert = new QCreateAPSAlert();

export class QCreateBufferDefinitionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBufferDefinitionResponse = new QCreateBufferDefinitionResponse();

export class QCreateBufferDefinition extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly CapacityType = new QStringPath(this.withPrefix("CapacityType"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IsValid = new QBooleanPath(this.withPrefix("IsValid"));
}

export const qCreateBufferDefinition = new QCreateBufferDefinition();

export class QResendConfirmWorkOrderOperationResponse extends QCommandResponse {
}

export const qResendConfirmWorkOrderOperationResponse = new QResendConfirmWorkOrderOperationResponse();

export class QResendConfirmWorkOrderOperation extends QueryObject {
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly PlantID = new QStringPath(this.withPrefix("PlantID"));
}

export const qResendConfirmWorkOrderOperation = new QResendConfirmWorkOrderOperation();

export class QDNCTransferDNCItemsResponse extends QCommandResponse {
}

export const qDNCTransferDNCItemsResponse = new QDNCTransferDNCItemsResponse();

export class QDNCTransferDNCItems extends QueryObject {
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly DNCIds = new QEntityPath(this.withPrefix("DNCIds"), () => QIdsParameter);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MachineId = new QGuidPath(this.withPrefix("MachineId"));
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
}

export const qDNCTransferDNCItems = new QDNCTransferDNCItems();

export class QUpdateNonConformanceSupervisorResponse extends QCommandResponse {
}

export const qUpdateNonConformanceSupervisorResponse = new QUpdateNonConformanceSupervisorResponse();

export class QUpdateNonConformanceSupervisor extends QueryObject {
    public readonly Defect = new QStringPath(this.withPrefix("Defect"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateNonConformanceSupervisor = new QUpdateNonConformanceSupervisor();

export class QAcquireMTUFromAutomationNodeInstanceParameterResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qAcquireMTUFromAutomationNodeInstanceParameterResponse = new QAcquireMTUFromAutomationNodeInstanceParameterResponse();

export class QAcquireMTUFromAutomationNodeInstanceParameter extends QueryObject {
    public readonly MaterialTrackingUnitToAcquireList = new QEntityCollectionPath(this.withPrefix("MaterialTrackingUnitToAcquireList"), () => QMaterialTrackingUnitToAcquireParameterType);
    public readonly WorkOrderOperationIdentifiers = new QEntityPath(this.withPrefix("WorkOrderOperationIdentifiers"), () => QIdentifiersParameterType);
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly WorkOrderStepIdentifiers = new QEntityPath(this.withPrefix("WorkOrderStepIdentifiers"), () => QIdentifiersParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qAcquireMTUFromAutomationNodeInstanceParameter = new QAcquireMTUFromAutomationNodeInstanceParameter();

export class QCreateActualCollectedDocumentListOnContainerResponse extends QCommandResponse {
}

export const qCreateActualCollectedDocumentListOnContainerResponse = new QCreateActualCollectedDocumentListOnContainerResponse();

export class QCreateActualCollectedDocumentListOnContainer extends QueryObject {
    public readonly DocumentIdList = new QCollectionPath(this.withPrefix("DocumentIdList"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ContainerNIdList = new QCollectionPath(this.withPrefix("ContainerNIdList"), () => QStringCollection);
}

export const qCreateActualCollectedDocumentListOnContainer = new QCreateActualCollectedDocumentListOnContainer();

export class QCreateToolDefinitionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolDefinitionResponse = new QCreateToolDefinitionResponse();

export class QCreateToolDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SubstrateDefinitionProperties = new QEntityPath(this.withPrefix("SubstrateDefinitionProperties"), () => QSubstrateDefinitionPropertiesParameterType);
    public readonly ToolClassNId = new QStringPath(this.withPrefix("ToolClassNId"));
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly RevisionExpression = new QStringPath(this.withPrefix("RevisionExpression"));
    public readonly LogisticParameter = new QEntityPath(this.withPrefix("LogisticParameter"), () => QLogisticParameterType);
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
}

export const qCreateToolDefinition = new QCreateToolDefinition();

export class QDeleteEquipmentConfigurationPropertyResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationPropertyResponse = new QDeleteEquipmentConfigurationPropertyResponse();

export class QDeleteEquipmentConfigurationProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentConfigurationProperty = new QDeleteEquipmentConfigurationProperty();

export class QCreateAsPlannedBOPResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateAsPlannedBOPResponse = new QCreateAsPlannedBOPResponse();

export class QCreateAsPlannedBOP extends QueryObject {
    public readonly AsPlannedBOP = new QEntityPath(this.withPrefix("AsPlannedBOP"), () => QAsPlannedBOPParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
}

export const qCreateAsPlannedBOP = new QCreateAsPlannedBOP();

export class QDeleteTemplateToMaterialPlantResponse extends QCommandResponse {
}

export const qDeleteTemplateToMaterialPlantResponse = new QDeleteTemplateToMaterialPlantResponse();

export class QDeleteTemplateToMaterialPlant extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTemplateToMaterialPlant = new QDeleteTemplateToMaterialPlant();

export class QAcceptMaterialRequestResponse extends QCommandResponse {
}

export const qAcceptMaterialRequestResponse = new QAcceptMaterialRequestResponse();

export class QAcceptMaterialRequest extends QueryObject {
    public readonly TransportOperationNId = new QStringPath(this.withPrefix("TransportOperationNId"));
    public readonly LogisticRequestId = new QGuidPath(this.withPrefix("LogisticRequestId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly BufferSourceList = new QEntityCollectionPath(this.withPrefix("BufferSourceList"), () => QBufferWithPriority);
    public readonly BufferDestinationList = new QEntityCollectionPath(this.withPrefix("BufferDestinationList"), () => QBufferWithPriority);
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly RoleId = new QStringPath(this.withPrefix("RoleId"));
}

export const qAcceptMaterialRequest = new QAcceptMaterialRequest();

export class QUADMUpdateProcessResponse extends QCommandResponse {
}

export const qUADMUpdateProcessResponse = new QUADMUpdateProcessResponse();

export class QUADMUpdateProcess extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaxQuantity = new QEntityPath(this.withPrefix("MaxQuantity"), () => QQuantityParameterType);
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityParameterType);
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly RevisionEffectivityExpression = new QStringPath(this.withPrefix("RevisionEffectivityExpression"));
    public readonly ParentProcessId = new QGuidPath(this.withPrefix("ParentProcessId"));
}

export const qUADMUpdateProcess = new QUADMUpdateProcess();

export class QAmendResultListResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly ResultIdList = new QCollectionPath(this.withPrefix("ResultIdList"), () => QGuidCollection);
}

export const qAmendResultListResponse = new QAmendResultListResponse();

export class QAmendResultList extends QueryObject {
    public readonly ResultList = new QEntityCollectionPath(this.withPrefix("ResultList"), () => QAmendResultListParameterType);
}

export const qAmendResultList = new QAmendResultList();

export class QUpdateToBeUsedMachineResponse extends QCommandResponse {
}

export const qUpdateToBeUsedMachineResponse = new QUpdateToBeUsedMachineResponse();

export class QUpdateToBeUsedMachine extends QueryObject {
    public readonly ToBeUsedMachineNId = new QStringPath(this.withPrefix("ToBeUsedMachineNId"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
}

export const qUpdateToBeUsedMachine = new QUpdateToBeUsedMachine();

export class QAssociateDNCItemMachinesMaterialsAssociationResponse extends QCommandResponse {
    public readonly FailedMaterialId = new QGuidPath(this.withPrefix("FailedMaterialId"));
    public readonly FailedMachineToDNCId = new QGuidPath(this.withPrefix("FailedMachineToDNCId"));
}

export const qAssociateDNCItemMachinesMaterialsAssociationResponse = new QAssociateDNCItemMachinesMaterialsAssociationResponse();

export class QAssociateDNCItemMachinesMaterialsAssociation extends QueryObject {
    public readonly Ids = new QEntityPath(this.withPrefix("Ids"), () => QIdsParameterType);
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly MachineToDNCIds = new QEntityPath(this.withPrefix("MachineToDNCIds"), () => QIdsParameterType);
    public readonly ManageHierarchy = new QBooleanPath(this.withPrefix("ManageHierarchy"));
}

export const qAssociateDNCItemMachinesMaterialsAssociation = new QAssociateDNCItemMachinesMaterialsAssociation();

export class QCreateRuntimeCharacteristicRepresentationContainerResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateRuntimeCharacteristicRepresentationContainerResponse = new QCreateRuntimeCharacteristicRepresentationContainerResponse();

export class QCreateRuntimeCharacteristicRepresentationContainer extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly CharacteristicRepresentationInfo = new QEntityCollectionPath(this.withPrefix("CharacteristicRepresentationInfo"), () => QCharacteristicRepresentationType);
}

export const qCreateRuntimeCharacteristicRepresentationContainer = new QCreateRuntimeCharacteristicRepresentationContainer();

export class QDeleteWOOpDependencyNavigationListResponse extends QCommandResponse {
}

export const qDeleteWOOpDependencyNavigationListResponse = new QDeleteWOOpDependencyNavigationListResponse();

export class QDeleteWOOpDependencyNavigationList extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
}

export const qDeleteWOOpDependencyNavigationList = new QDeleteWOOpDependencyNavigationList();

export class QCompleteWorkInstructionResponse extends QCommandResponse {
}

export const qCompleteWorkInstructionResponse = new QCompleteWorkInstructionResponse();

export class QCompleteWorkInstruction extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCompleteWorkInstruction = new QCompleteWorkInstruction();

export class QUnlockWorkInstructionDefinitionResponse extends QCommandResponse {
}

export const qUnlockWorkInstructionDefinitionResponse = new QUnlockWorkInstructionDefinitionResponse();

export class QUnlockWorkInstructionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnlockWorkInstructionDefinition = new QUnlockWorkInstructionDefinition();

export class QAcceptChangeRemoveToBeConsumedMaterialResponse extends QCommandResponse {
    public readonly NonConformancNId = new QStringPath(this.withPrefix("NonConformancNId"));
}

export const qAcceptChangeRemoveToBeConsumedMaterialResponse = new QAcceptChangeRemoveToBeConsumedMaterialResponse();

export class QAcceptChangeRemoveToBeConsumedMaterial extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly IsMaterialBehaviourOutputTypeFlag0 = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputTypeFlag0"));
    public readonly IsMaterialBehaviourOutputType = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputType"));
}

export const qAcceptChangeRemoveToBeConsumedMaterial = new QAcceptChangeRemoveToBeConsumedMaterial();

export class QAPSSetInScheduledResponse extends QCommandResponse {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qAPSSetInScheduledResponse = new QAPSSetInScheduledResponse();

export class QAPSSetInScheduled extends QueryObject {
    public readonly APSOrderOperation = new QEntityPath(this.withPrefix("APSOrderOperation"), () => QAPSOrderOperationParameterType);
}

export const qAPSSetInScheduled = new QAPSSetInScheduled();

export class QCreateLogisticClassResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateLogisticClassResponse = new QCreateLogisticClassResponse();

export class QCreateLogisticClass extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
}

export const qCreateLogisticClass = new QCreateLogisticClass();

export class QLink3DPrinterTypeToMESResponse extends QCommandResponse {
}

export const qLink3DPrinterTypeToMESResponse = new QLink3DPrinterTypeToMESResponse();

export class QLink3DPrinterTypeToMES extends QueryObject {
    public readonly Link3DPrinterTypeToMESList = new QEntityCollectionPath(this.withPrefix("Link3DPrinterTypeToMESList"), () => QPrinterParameterType);
}

export const qLink3DPrinterTypeToMES = new QLink3DPrinterTypeToMES();

export class QAcceptChangeAddProcessOperationResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeAddProcessOperationResponse = new QAcceptChangeAddProcessOperationResponse();

export class QAcceptChangeAddProcessOperation extends QueryObject {
    public readonly ChangeProcessOperationId = new QGuidPath(this.withPrefix("ChangeProcessOperationId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly AfterSequence = new QNumberPath(this.withPrefix("AfterSequence"));
    public readonly ProcessOperationId = new QGuidPath(this.withPrefix("ProcessOperationId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderOperationSequence = new QNumberPath(this.withPrefix("WorkOrderOperationSequence"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBopId = new QGuidPath(this.withPrefix("AsPlannedBopId"));
}

export const qAcceptChangeAddProcessOperation = new QAcceptChangeAddProcessOperation();

export class QDeleteToolResponse extends QCommandResponse {
}

export const qDeleteToolResponse = new QDeleteToolResponse();

export class QDeleteTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTool = new QDeleteTool();

export class QLinkPJFToMaterialDefinitionResponse extends QCommandResponse {
}

export const qLinkPJFToMaterialDefinitionResponse = new QLinkPJFToMaterialDefinitionResponse();

export class QLinkPJFToMaterialDefinition extends QueryObject {
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly MaterialDefinition = new QGuidPath(this.withPrefix("MaterialDefinition"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qLinkPJFToMaterialDefinition = new QLinkPJFToMaterialDefinition();

export class QUpdateCharacteristicRepresentationResponse extends QCommandResponse {
}

export const qUpdateCharacteristicRepresentationResponse = new QUpdateCharacteristicRepresentationResponse();

export class QUpdateCharacteristicRepresentation extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly SampleSize = new QNumberPath(this.withPrefix("SampleSize"));
    public readonly CanBeSkipped = new QBooleanPath(this.withPrefix("CanBeSkipped"));
    public readonly CharacteristicSpecificationId = new QGuidPath(this.withPrefix("CharacteristicSpecificationId"));
    public readonly ScenarioNId = new QStringPath(this.withPrefix("ScenarioNId"));
    public readonly CharacteristicRepresentationFrequencyId = new QGuidPath(this.withPrefix("CharacteristicRepresentationFrequencyId"));
    public readonly CharacteristicRepresentationFrequencyValue = new QNumberPath(this.withPrefix("CharacteristicRepresentationFrequencyValue"));
    public readonly TimeBasedScheduleMode = new QStringPath(this.withPrefix("TimeBasedScheduleMode"));
    public readonly TimeBasedMandatoryInspectionWarningValue = new QNumberPath(this.withPrefix("TimeBasedMandatoryInspectionWarningValue"));
    public readonly TimeBasedMandatoryInspectionWarningUoMNId = new QEnumPath(this.withPrefix("TimeBasedMandatoryInspectionWarningUoMNId"), TimeBasedUoM);
}

export const qUpdateCharacteristicRepresentation = new QUpdateCharacteristicRepresentation();

export class QDeleteDNCItemResponse extends QCommandResponse {
}

export const qDeleteDNCItemResponse = new QDeleteDNCItemResponse();

export class QDeleteDNCItem extends QueryObject {
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
}

export const qDeleteDNCItem = new QDeleteDNCItem();

export class QDeleteAMPowderBatchGenealogyResponse extends QCommandResponse {
}

export const qDeleteAMPowderBatchGenealogyResponse = new QDeleteAMPowderBatchGenealogyResponse();

export class QDeleteAMPowderBatchGenealogy extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteAMPowderBatchGenealogy = new QDeleteAMPowderBatchGenealogy();

export class QCreateCustomItlkCheckParameterListResponse extends QCommandResponse {
    public readonly ListOfItlkCheckParameterId = new QCollectionPath(this.withPrefix("ListOfItlkCheckParameterId"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qCreateCustomItlkCheckParameterListResponse = new QCreateCustomItlkCheckParameterListResponse();

export class QCreateCustomItlkCheckParameterList extends QueryObject {
    public readonly ListOfItlkCheckParameter = new QEntityCollectionPath(this.withPrefix("ListOfItlkCheckParameter"), () => QCustomItlkCheckParamParameterType);
}

export const qCreateCustomItlkCheckParameterList = new QCreateCustomItlkCheckParameterList();

export class QSetConfigurationKeyResponse extends QCommandResponse {
}

export const qSetConfigurationKeyResponse = new QSetConfigurationKeyResponse();

export class QSetConfigurationKey extends QueryObject {
    public readonly KeyId = new QStringPath(this.withPrefix("KeyId"));
    public readonly Val = new QStringPath(this.withPrefix("Val"));
}

export const qSetConfigurationKey = new QSetConfigurationKey();

export class QCreateOperationStructureDependencyListResponse extends QCommandResponse {
}

export const qCreateOperationStructureDependencyListResponse = new QCreateOperationStructureDependencyListResponse();

export class QCreateOperationStructureDependencyList extends QueryObject {
    public readonly OperationStructureDependencies = new QEntityCollectionPath(this.withPrefix("OperationStructureDependencies"), () => QOperationStructureDependencyParameterType);
}

export const qCreateOperationStructureDependencyList = new QCreateOperationStructureDependencyList();

export class QCreateAndStartWorkProcessListFromProcessDefinitionResponse extends QCommandResponse {
    public readonly WorkProcessIdList = new QCollectionPath(this.withPrefix("WorkProcessIdList"), () => QGuidCollection);
}

export const qCreateAndStartWorkProcessListFromProcessDefinitionResponse = new QCreateAndStartWorkProcessListFromProcessDefinitionResponse();

export class QCreateAndStartWorkProcessListFromProcessDefinition extends QueryObject {
    public readonly CreateAndStartWorkProcessListFromProcessDefinitionParameter = new QEntityPath(this.withPrefix("CreateAndStartWorkProcessListFromProcessDefinitionParameter"), () => QCreateAndStartWorkProcessListFromProcessDefinitionParameterType);
}

export const qCreateAndStartWorkProcessListFromProcessDefinition = new QCreateAndStartWorkProcessListFromProcessDefinition();

export class QCreateDM_MaterialTrackingUnitHistoryActionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateDM_MaterialTrackingUnitHistoryActionResponse = new QCreateDM_MaterialTrackingUnitHistoryActionResponse();

export class QCreateDM_MaterialTrackingUnitHistoryAction extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateDM_MaterialTrackingUnitHistoryAction = new QCreateDM_MaterialTrackingUnitHistoryAction();

export class QTCM2CreateToolDefinitionListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qTCM2CreateToolDefinitionListResponse = new QTCM2CreateToolDefinitionListResponse();

export class QTCM2CreateToolDefinitionList extends QueryObject {
    public readonly ToolList = new QEntityCollectionPath(this.withPrefix("ToolList"), () => QTCM2ToolDefinitionParameterTypeCreate);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateToolDefinitionList = new QTCM2CreateToolDefinitionList();

export class QUnlinkStepToOperationResponse extends QCommandResponse {
}

export const qUnlinkStepToOperationResponse = new QUnlinkStepToOperationResponse();

export class QUnlinkStepToOperation extends QueryObject {
    public readonly OperationToStepLinkIds = new QCollectionPath(this.withPrefix("OperationToStepLinkIds"), () => QGuidCollection);
}

export const qUnlinkStepToOperation = new QUnlinkStepToOperation();

export class QCreateNonConformanceSupervisorResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNonConformanceSupervisorResponse = new QCreateNonConformanceSupervisorResponse();

export class QCreateNonConformanceSupervisor extends QueryObject {
    public readonly Defect = new QStringPath(this.withPrefix("Defect"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
}

export const qCreateNonConformanceSupervisor = new QCreateNonConformanceSupervisor();

export class QCoProduceMaterialTrackingUnitResponse extends QCommandResponse {
}

export const qCoProduceMaterialTrackingUnitResponse = new QCoProduceMaterialTrackingUnitResponse();

export class QCoProduceMaterialTrackingUnit extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ToBeCoProducedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeCoProducedMaterials"), () => QToBeCoProducedMaterialParameterType);
}

export const qCoProduceMaterialTrackingUnit = new QCoProduceMaterialTrackingUnit();

export class QGetInputResultTypeResponse extends QCommandResponse {
    public readonly ResultsWithType = new QEntityCollectionPath(this.withPrefix("ResultsWithType"), () => QResultWithTypeParameterType);
}

export const qGetInputResultTypeResponse = new QGetInputResultTypeResponse();

export class QGetInputResultType extends QueryObject {
    public readonly Results = new QEntityCollectionPath(this.withPrefix("Results"), () => QResultParameterType);
}

export const qGetInputResultType = new QGetInputResultType();

export class QLinkPrintJobFileToEquipmentTypeResponse extends QCommandResponse {
}

export const qLinkPrintJobFileToEquipmentTypeResponse = new QLinkPrintJobFileToEquipmentTypeResponse();

export class QLinkPrintJobFileToEquipmentType extends QueryObject {
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly EquipmentTypeNIdList = new QCollectionPath(this.withPrefix("EquipmentTypeNIdList"), () => QStringCollection);
}

export const qLinkPrintJobFileToEquipmentType = new QLinkPrintJobFileToEquipmentType();

export class QLinkTransferPluginTo3DPrinterResponse extends QCommandResponse {
}

export const qLinkTransferPluginTo3DPrinterResponse = new QLinkTransferPluginTo3DPrinterResponse();

export class QLinkTransferPluginTo3DPrinter extends QueryObject {
    public readonly TransferPlugin = new QStringPath(this.withPrefix("TransferPlugin"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
}

export const qLinkTransferPluginTo3DPrinter = new QLinkTransferPluginTo3DPrinter();

export class QCreateSnagAndNoteListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateSnagAndNoteListResponse = new QCreateSnagAndNoteListResponse();

export class QCreateSnagAndNoteList extends QueryObject {
    public readonly Messages = new QCollectionPath(this.withPrefix("Messages"), () => QStringCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly IsWorkOrderLevel = new QBooleanPath(this.withPrefix("IsWorkOrderLevel"));
    public readonly IsAutomatic = new QBooleanPath(this.withPrefix("IsAutomatic"));
    public readonly TimeStampAutomatic = new QDateTimeOffsetPath(this.withPrefix("TimeStampAutomatic"));
}

export const qCreateSnagAndNoteList = new QCreateSnagAndNoteList();

export class QLinkSuppliersToMaterialV4_0Response extends QCommandResponse {
}

export const qLinkSuppliersToMaterialV4_0Response = new QLinkSuppliersToMaterialV4_0Response();

export class QLinkSuppliersToMaterialV4_0 extends QueryObject {
    public readonly Material = new QEntityPath(this.withPrefix("Material"), () => QMaterialValueParameterType);
    public readonly SupplierNId = new QStringPath(this.withPrefix("SupplierNId"));
}

export const qLinkSuppliersToMaterialV4_0 = new QLinkSuppliersToMaterialV4_0();

export class QUpdateStateMachineResponse extends QCommandResponse {
    public readonly StatusIdList = new QCollectionPath(this.withPrefix("StatusIdList"), () => QGuidCollection);
}

export const qUpdateStateMachineResponse = new QUpdateStateMachineResponse();

export class QUpdateStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly StatusList = new QEntityCollectionPath(this.withPrefix("StatusList"), () => QStatusParameterType);
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateStateMachine = new QUpdateStateMachine();

export class QDeleteCertificationResponse extends QCommandResponse {
}

export const qDeleteCertificationResponse = new QDeleteCertificationResponse();

export class QDeleteCertification extends QueryObject {
    public readonly DeleteCertificationParameter = new QEntityPath(this.withPrefix("DeleteCertificationParameter"), () => QDeleteCertificationParameterType);
}

export const qDeleteCertification = new QDeleteCertification();

export class QEditWorkOrderOperationResponse extends QCommandResponse {
}

export const qEditWorkOrderOperationResponse = new QEditWorkOrderOperationResponse();

export class QEditWorkOrderOperation extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly WorkOperationTypeId = new QGuidPath(this.withPrefix("WorkOperationTypeId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly ActiveNonConformanceNr = new QNumberPath(this.withPrefix("ActiveNonConformanceNr"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
}

export const qEditWorkOrderOperation = new QEditWorkOrderOperation();

export class QLinkWorkInstructionsToEGPhaseResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWorkInstructionsToEGPhaseResponse = new QLinkWorkInstructionsToEGPhaseResponse();

export class QLinkWorkInstructionsToEGPhase extends QueryObject {
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly ExecutionPhaseId = new QGuidPath(this.withPrefix("ExecutionPhaseId"));
    public readonly SerialNumbers = new QCollectionPath(this.withPrefix("SerialNumbers"), () => QStringCollection);
    public readonly IsReEditEnabled = new QBooleanPath(this.withPrefix("IsReEditEnabled"));
}

export const qLinkWorkInstructionsToEGPhase = new QLinkWorkInstructionsToEGPhase();

export class QSkipWOOperationFullQtyResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qSkipWOOperationFullQtyResponse = new QSkipWOOperationFullQtyResponse();

export class QSkipWOOperationFullQty extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qSkipWOOperationFullQty = new QSkipWOOperationFullQty();

export class QAPSSetInSchedulingResponse extends QCommandResponse {
}

export const qAPSSetInSchedulingResponse = new QAPSSetInSchedulingResponse();

export class QAPSSetInScheduling extends QueryObject {
    public readonly NIds = new QEntityPath(this.withPrefix("NIds"), () => QNIdsParameterType);
}

export const qAPSSetInScheduling = new QAPSSetInScheduling();

export class QAssignCertificationToSkillListResponse extends QCommandResponse {
}

export const qAssignCertificationToSkillListResponse = new QAssignCertificationToSkillListResponse();

export class QAssignCertificationToSkillList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
}

export const qAssignCertificationToSkillList = new QAssignCertificationToSkillList();

export class QSetDueDateOnExecGroupResponse extends QCommandResponse {
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
}

export const qSetDueDateOnExecGroupResponse = new QSetDueDateOnExecGroupResponse();

export class QSetDueDateOnExecGroup extends QueryObject {
    public readonly ExecGroupNId = new QStringPath(this.withPrefix("ExecGroupNId"));
}

export const qSetDueDateOnExecGroup = new QSetDueDateOnExecGroup();

export class QDeleteOperationListFromCatalogueResponse extends QCommandResponse {
}

export const qDeleteOperationListFromCatalogueResponse = new QDeleteOperationListFromCatalogueResponse();

export class QDeleteOperationListFromCatalogue extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteOperationListFromCatalogue = new QDeleteOperationListFromCatalogue();

export class QTCM2DeleteLinkProcessToOperationListResponse extends QCommandResponse {
}

export const qTCM2DeleteLinkProcessToOperationListResponse = new QTCM2DeleteLinkProcessToOperationListResponse();

export class QTCM2DeleteLinkProcessToOperationList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qTCM2DeleteLinkProcessToOperationList = new QTCM2DeleteLinkProcessToOperationList();

export class QSentenceNonConformanceV3_1Response extends QCommandResponse {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
    public readonly CurrentStatus = new QStringPath(this.withPrefix("CurrentStatus"));
    public readonly NonConformanceHistoryIds = new QCollectionPath(this.withPrefix("NonConformanceHistoryIds"), () => QGuidCollection);
}

export const qSentenceNonConformanceV3_1Response = new QSentenceNonConformanceV3_1Response();

export class QSentenceNonConformanceV3_1 extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceStatusNId = new QStringPath(this.withPrefix("NonConformanceStatusNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly ReworkProcessId = new QGuidPath(this.withPrefix("ReworkProcessId"));
    public readonly NonConformancePartialWOOpQuantities = new QEntityPath(this.withPrefix("NonConformancePartialWOOpQuantities"), () => QNonConformanceQuantities4PartialSentenceParameterType);
    public readonly IsAutomaticallyInvoked = new QBooleanPath(this.withPrefix("IsAutomaticallyInvoked"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
}

export const qSentenceNonConformanceV3_1 = new QSentenceNonConformanceV3_1();

export class QDeleteStepDependencyListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteStepDependencyListResponse = new QDeleteStepDependencyListResponse();

export class QDeleteStepDependencyList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteStepDependencyList = new QDeleteStepDependencyList();

export class QGetOfflineWorkInstructionsResponse extends QCommandResponse {
    public readonly WorkInstructions = new QEntityCollectionPath(this.withPrefix("WorkInstructions"), () => QOfflineWorkInstruction);
}

export const qGetOfflineWorkInstructionsResponse = new QGetOfflineWorkInstructionsResponse();

export class QGetOfflineWorkInstructions extends QueryObject {
    public readonly WorkOrderOperationIds = new QCollectionPath(this.withPrefix("WorkOrderOperationIds"), () => QGuidCollection);
}

export const qGetOfflineWorkInstructions = new QGetOfflineWorkInstructions();

export class QUnlinkOperationListToProcessResponse extends QCommandResponse {
}

export const qUnlinkOperationListToProcessResponse = new QUnlinkOperationListToProcessResponse();

export class QUnlinkOperationListToProcess extends QueryObject {
    public readonly OprationIds = new QCollectionPath(this.withPrefix("OprationIds"), () => QGuidCollection);
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
}

export const qUnlinkOperationListToProcess = new QUnlinkOperationListToProcess();

export class QDeleteEquipmentGraphLinkConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphLinkConfigurationResponse = new QDeleteEquipmentGraphLinkConfigurationResponse();

export class QDeleteEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphLinkConfiguration = new QDeleteEquipmentGraphLinkConfiguration();

export class QCompleteScrewingWOOpOnToolDeactivationResponse extends QCommandResponse {
}

export const qCompleteScrewingWOOpOnToolDeactivationResponse = new QCompleteScrewingWOOpOnToolDeactivationResponse();

export class QCompleteScrewingWOOpOnToolDeactivation extends QueryObject {
    public readonly WorkOrderOperationId = new QStringPath(this.withPrefix("WorkOrderOperationId"));
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
}

export const qCompleteScrewingWOOpOnToolDeactivation = new QCompleteScrewingWOOpOnToolDeactivation();

export class QCheckInStartWOStepTransferBatchResponse extends QCommandResponse {
}

export const qCheckInStartWOStepTransferBatchResponse = new QCheckInStartWOStepTransferBatchResponse();

export class QCheckInStartWOStepTransferBatch extends QueryObject {
    public readonly StartWOStepTransferBatchParameter = new QEntityPath(this.withPrefix("StartWOStepTransferBatchParameter"), () => QStartWOStepTransferBatchParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInStartWOStepTransferBatch = new QCheckInStartWOStepTransferBatch();

export class QCreateNonConformanceNotificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNonConformanceNotificationResponse = new QCreateNonConformanceNotificationResponse();

export class QCreateNonConformanceNotification extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceType = new QStringPath(this.withPrefix("NonConformanceType"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly UserRole = new QStringPath(this.withPrefix("UserRole"));
}

export const qCreateNonConformanceNotification = new QCreateNonConformanceNotification();

export class QLinkDocumentListToOperationResponse extends QCommandResponse {
}

export const qLinkDocumentListToOperationResponse = new QLinkDocumentListToOperationResponse();

export class QLinkDocumentListToOperation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly ListOfDocumentId = new QCollectionPath(this.withPrefix("ListOfDocumentId"), () => QGuidCollection);
}

export const qLinkDocumentListToOperation = new QLinkDocumentListToOperation();

export class QLoadHandlingUnitResponse extends QCommandResponse {
}

export const qLoadHandlingUnitResponse = new QLoadHandlingUnitResponse();

export class QLoadHandlingUnit extends QueryObject {
    public readonly HandlingUnit = new QGuidPath(this.withPrefix("HandlingUnit"));
    public readonly MaterialItem = new QCollectionPath(this.withPrefix("MaterialItem"), () => QGuidCollection);
}

export const qLoadHandlingUnit = new QLoadHandlingUnit();

export class QConsumeMaterialItemOnContainerResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qConsumeMaterialItemOnContainerResponse = new QConsumeMaterialItemOnContainerResponse();

export class QConsumeMaterialItemOnContainer extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly MaterialItemToConsumeOnContainerList = new QEntityCollectionPath(this.withPrefix("MaterialItemToConsumeOnContainerList"), () => QMaterialItemToConsumeOnContainerParameterType);
}

export const qConsumeMaterialItemOnContainer = new QConsumeMaterialItemOnContainer();

export class QSetEquipmentPropertyValueResponse extends QCommandResponse {
}

export const qSetEquipmentPropertyValueResponse = new QSetEquipmentPropertyValueResponse();

export class QSetEquipmentPropertyValue extends QueryObject {
    public readonly EquipmentPropertyId = new QGuidPath(this.withPrefix("EquipmentPropertyId"));
    public readonly EquipmentPropertyValue = new QStringPath(this.withPrefix("EquipmentPropertyValue"));
}

export const qSetEquipmentPropertyValue = new QSetEquipmentPropertyValue();

export class QCheckInConsumeMaterialItemResponse extends QCommandResponse {
}

export const qCheckInConsumeMaterialItemResponse = new QCheckInConsumeMaterialItemResponse();

export class QCheckInConsumeMaterialItem extends QueryObject {
    public readonly MaterialItemToConsumeList = new QEntityCollectionPath(this.withPrefix("MaterialItemToConsumeList"), () => QMaterialItemToConsumeParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInConsumeMaterialItem = new QCheckInConsumeMaterialItem();

export class QUADMCreateNewToolDefinitionRevisionResponse extends QCommandResponse {
}

export const qUADMCreateNewToolDefinitionRevisionResponse = new QUADMCreateNewToolDefinitionRevisionResponse();

export class QUADMCreateNewToolDefinitionRevision extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateNewToolDefinitionRevision = new QUADMCreateNewToolDefinitionRevision();

export class QAcceptChangeChangeToBeConsumedMaterialQuantityResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeChangeToBeConsumedMaterialQuantityResponse = new QAcceptChangeChangeToBeConsumedMaterialQuantityResponse();

export class QAcceptChangeChangeToBeConsumedMaterialQuantity extends QueryObject {
    public readonly ChangePartId = new QGuidPath(this.withPrefix("ChangePartId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly NewQuantity = new QNumberPath(this.withPrefix("NewQuantity"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly IsMaterialBehaviourOutputTypeFlag0 = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputTypeFlag0"));
    public readonly IsMaterialBehaviourOutputType = new QBooleanPath(this.withPrefix("IsMaterialBehaviourOutputType"));
}

export const qAcceptChangeChangeToBeConsumedMaterialQuantity = new QAcceptChangeChangeToBeConsumedMaterialQuantity();

export class QDeletePauseReasonResponse extends QCommandResponse {
}

export const qDeletePauseReasonResponse = new QDeletePauseReasonResponse();

export class QDeletePauseReason extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeletePauseReason = new QDeletePauseReason();

export class QManageResultListResponse extends QCommandResponse {
    public readonly ResultIdList = new QCollectionPath(this.withPrefix("ResultIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly ManagedResultList = new QEntityCollectionPath(this.withPrefix("ManagedResultList"), () => QOnResultCreationParameterType);
}

export const qManageResultListResponse = new QManageResultListResponse();

export class QManageResultList extends QueryObject {
    public readonly ResultList = new QEntityCollectionPath(this.withPrefix("ResultList"), () => QManageResultListParameterType);
}

export const qManageResultList = new QManageResultList();

export class QAutomaticSentenceNonConformanceResponse extends QCommandResponse {
}

export const qAutomaticSentenceNonConformanceResponse = new QAutomaticSentenceNonConformanceResponse();

export class QAutomaticSentenceNonConformance extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly TargetStatus = new QStringPath(this.withPrefix("TargetStatus"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly SerialNumberCodeList = new QCollectionPath(this.withPrefix("SerialNumberCodeList"), () => QStringCollection);
}

export const qAutomaticSentenceNonConformance = new QAutomaticSentenceNonConformance();

export class QUnlinkUserToWorkOrderOperationListResponse extends QCommandResponse {
}

export const qUnlinkUserToWorkOrderOperationListResponse = new QUnlinkUserToWorkOrderOperationListResponse();

export class QUnlinkUserToWorkOrderOperationList extends QueryObject {
    public readonly UserToWorkOrderOperationList = new QCollectionPath(this.withPrefix("UserToWorkOrderOperationList"), () => QGuidCollection);
}

export const qUnlinkUserToWorkOrderOperationList = new QUnlinkUserToWorkOrderOperationList();

export class QCreateNonConformanceResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceGroupPathList = new QEntityCollectionPath(this.withPrefix("NonConformanceGroupPathList"), () => QNonConformanceGroupPathParameterType);
}

export const qCreateNonConformanceResponse = new QCreateNonConformanceResponse();

export class QCreateNonConformance extends QueryObject {
    public readonly NonConformanceDetail = new QEntityPath(this.withPrefix("NonConformanceDetail"), () => QNonConformanceParameterType);
    public readonly NonConformanceHistoryDetail = new QEntityPath(this.withPrefix("NonConformanceHistoryDetail"), () => QNonConformanceHistoryParameterType);
    public readonly DefectsDetails = new QEntityCollectionPath(this.withPrefix("DefectsDetails"), () => QDefectParameterType);
    public readonly ExtensionKey = new QStringPath(this.withPrefix("ExtensionKey"));
    public readonly Context = new QStringPath(this.withPrefix("Context"));
    public readonly ChangeOperationProperties = new QEntityPath(this.withPrefix("ChangeOperationProperties"), () => QChangeOperationParameterType);
    public readonly ChangePartProperties = new QEntityPath(this.withPrefix("ChangePartProperties"), () => QChangePartParameterType);
    public readonly ChangeDataCollectionProperties = new QEntityPath(this.withPrefix("ChangeDataCollectionProperties"), () => QChangeDataCollectionParameterType);
    public readonly ChangeToolProperties = new QEntityPath(this.withPrefix("ChangeToolProperties"), () => QChangeToolParameterType);
    public readonly ChangeRoutingProperties = new QEntityPath(this.withPrefix("ChangeRoutingProperties"), () => QChangeRoutingParameterType);
}

export const qCreateNonConformance = new QCreateNonConformance();

export class QTCM2CreateProcessListResponse extends QCommandResponse {
}

export const qTCM2CreateProcessListResponse = new QTCM2CreateProcessListResponse();

export class QTCM2CreateProcessList extends QueryObject {
    public readonly ProcessList = new QEntityCollectionPath(this.withPrefix("ProcessList"), () => QTCM2ProcessParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateProcessList = new QTCM2CreateProcessList();

export class QCreateEquipmentSpecificationWithPrintJobFileResponse extends QCommandResponse {
    public readonly EquipmentSpecificationId = new QGuidPath(this.withPrefix("EquipmentSpecificationId"));
}

export const qCreateEquipmentSpecificationWithPrintJobFileResponse = new QCreateEquipmentSpecificationWithPrintJobFileResponse();

export class QCreateEquipmentSpecificationWithPrintJobFile extends QueryObject {
    public readonly EquipmentSpecification = new QEntityPath(this.withPrefix("EquipmentSpecification"), () => QEquipmentSpecificationParameterType);
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly PrintJobFileExtId = new QStringPath(this.withPrefix("PrintJobFileExtId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
    public readonly Process = new QGuidPath(this.withPrefix("Process"));
}

export const qCreateEquipmentSpecificationWithPrintJobFile = new QCreateEquipmentSpecificationWithPrintJobFile();

export class QUpdateOperationDependencyResponse extends QCommandResponse {
}

export const qUpdateOperationDependencyResponse = new QUpdateOperationDependencyResponse();

export class QUpdateOperationDependency extends QueryObject {
    public readonly OperationDependency = new QEntityPath(this.withPrefix("OperationDependency"), () => QOperationDependencyParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateOperationDependency = new QUpdateOperationDependency();

export class QSkipWOOperationSerializedResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qSkipWOOperationSerializedResponse = new QSkipWOOperationSerializedResponse();

export class QSkipWOOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qSkipWOOperationSerialized = new QSkipWOOperationSerialized();

export class QDeleteSkipReasonResponse extends QCommandResponse {
}

export const qDeleteSkipReasonResponse = new QDeleteSkipReasonResponse();

export class QDeleteSkipReason extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteSkipReason = new QDeleteSkipReason();

export class QUpdateCertificationResponse extends QCommandResponse {
}

export const qUpdateCertificationResponse = new QUpdateCertificationResponse();

export class QUpdateCertification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateCertification = new QUpdateCertification();

export class QLinkWIDefinitionsToWOOperationResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWIDefinitionsToWOOperationResponse = new QLinkWIDefinitionsToWOOperationResponse();

export class QLinkWIDefinitionsToWOOperation extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly WorkInstructionAssociationType = new QStringPath(this.withPrefix("WorkInstructionAssociationType"));
    public readonly HideOnExecGroup = new QBooleanPath(this.withPrefix("HideOnExecGroup"));
}

export const qLinkWIDefinitionsToWOOperation = new QLinkWIDefinitionsToWOOperation();

export class QCreateSkill_BOPResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateSkill_BOPResponse = new QCreateSkill_BOPResponse();

export class QCreateSkill_BOP extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
}

export const qCreateSkill_BOP = new QCreateSkill_BOP();

export class QSetEquipmentPreferencesForUserResponse extends QCommandResponse {
}

export const qSetEquipmentPreferencesForUserResponse = new QSetEquipmentPreferencesForUserResponse();

export class QSetEquipmentPreferencesForUser extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qSetEquipmentPreferencesForUser = new QSetEquipmentPreferencesForUser();

export class QAcceptChangeRemoveDependencyResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeRemoveDependencyResponse = new QAcceptChangeRemoveDependencyResponse();

export class QAcceptChangeRemoveDependency extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly WorkOOperationDependencyId = new QGuidPath(this.withPrefix("WorkOOperationDependencyId"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qAcceptChangeRemoveDependency = new QAcceptChangeRemoveDependency();

export class QUnlinkPrintJobFileToMachineResponse extends QCommandResponse {
}

export const qUnlinkPrintJobFileToMachineResponse = new QUnlinkPrintJobFileToMachineResponse();

export class QUnlinkPrintJobFileToMachine extends QueryObject {
    public readonly PrintJobFileToMachine = new QGuidPath(this.withPrefix("PrintJobFileToMachine"));
}

export const qUnlinkPrintJobFileToMachine = new QUnlinkPrintJobFileToMachine();

export class QDeleteFutureHoldResponse extends QCommandResponse {
}

export const qDeleteFutureHoldResponse = new QDeleteFutureHoldResponse();

export class QDeleteFutureHold extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteFutureHold = new QDeleteFutureHold();

export class QDeleteEquipmentConfigurationPropertyAttributeResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationPropertyAttributeResponse = new QDeleteEquipmentConfigurationPropertyAttributeResponse();

export class QDeleteEquipmentConfigurationPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentConfigurationPropertyAttribute = new QDeleteEquipmentConfigurationPropertyAttribute();

export class QCreateMaterialSpecificationListResponse extends QCommandResponse {
}

export const qCreateMaterialSpecificationListResponse = new QCreateMaterialSpecificationListResponse();

export class QCreateMaterialSpecificationList extends QueryObject {
    public readonly MaterialSpecificationList = new QEntityCollectionPath(this.withPrefix("MaterialSpecificationList"), () => QMaterialSpecificationParameterType);
}

export const qCreateMaterialSpecificationList = new QCreateMaterialSpecificationList();

export class QValidateDataCollectionIsCompleteResponse extends QCommandResponse {
}

export const qValidateDataCollectionIsCompleteResponse = new QValidateDataCollectionIsCompleteResponse();

export class QValidateDataCollectionIsComplete extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qValidateDataCollectionIsComplete = new QValidateDataCollectionIsComplete();

export class QTCM2CreateToolSpecificationFullListResponse extends QCommandResponse {
}

export const qTCM2CreateToolSpecificationFullListResponse = new QTCM2CreateToolSpecificationFullListResponse();

export class QTCM2CreateToolSpecificationFullList extends QueryObject {
    public readonly ToolSpecificationList = new QEntityCollectionPath(this.withPrefix("ToolSpecificationList"), () => QTCM2ToolSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateToolSpecificationFullList = new QTCM2CreateToolSpecificationFullList();

export class QDeleteCharacteristicRepresentationResponse extends QCommandResponse {
    public readonly NotDeletedIds = new QCollectionPath(this.withPrefix("NotDeletedIds"), () => QGuidCollection);
}

export const qDeleteCharacteristicRepresentationResponse = new QDeleteCharacteristicRepresentationResponse();

export class QDeleteCharacteristicRepresentation extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteCharacteristicRepresentation = new QDeleteCharacteristicRepresentation();

export class QAutomaticUseToolListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
    public readonly UsedToolList = new QEntityCollectionPath(this.withPrefix("UsedToolList"), () => QUsedToolParameterType);
    public readonly TimesOfToolUsage = new QEntityCollectionPath(this.withPrefix("TimesOfToolUsage"), () => QTimesOfToolUsageParameterType);
}

export const qAutomaticUseToolListResponse = new QAutomaticUseToolListResponse();

export class QAutomaticUseToolList extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly ToolToBeUsedList = new QEntityCollectionPath(this.withPrefix("ToolToBeUsedList"), () => QToolToBeUsedOnSNParameterType);
}

export const qAutomaticUseToolList = new QAutomaticUseToolList();

export class QSetConfigurationKeyListResponse extends QCommandResponse {
}

export const qSetConfigurationKeyListResponse = new QSetConfigurationKeyListResponse();

export class QSetConfigurationKeyList extends QueryObject {
    public readonly KeyId = new QStringPath(this.withPrefix("KeyId"));
    public readonly ValueList = new QEntityCollectionPath(this.withPrefix("ValueList"), () => QKeyMultiValueParameterType);
}

export const qSetConfigurationKeyList = new QSetConfigurationKeyList();

export class QUpdateLinkStepToOperationResponse extends QCommandResponse {
}

export const qUpdateLinkStepToOperationResponse = new QUpdateLinkStepToOperationResponse();

export class QUpdateLinkStepToOperation extends QueryObject {
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly OldSequence = new QNumberPath(this.withPrefix("OldSequence"));
    public readonly NewSequence = new QNumberPath(this.withPrefix("NewSequence"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
}

export const qUpdateLinkStepToOperation = new QUpdateLinkStepToOperation();

export class QUpdateWorkOrderOperationActualExecutionTimesResponse extends QCommandResponse {
}

export const qUpdateWorkOrderOperationActualExecutionTimesResponse = new QUpdateWorkOrderOperationActualExecutionTimesResponse();

export class QUpdateWorkOrderOperationActualExecutionTimes extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly ExecutionDuration = new QStringPath(this.withPrefix("ExecutionDuration"));
}

export const qUpdateWorkOrderOperationActualExecutionTimes = new QUpdateWorkOrderOperationActualExecutionTimes();

export class QCreateSkillResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateSkillResponse = new QCreateSkillResponse();

export class QCreateSkill extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateSkill = new QCreateSkill();

export class QUADMUpdateMaterialSpecificationResponse extends QCommandResponse {
}

export const qUADMUpdateMaterialSpecificationResponse = new QUADMUpdateMaterialSpecificationResponse();

export class QUADMUpdateMaterialSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly GroupId = new QStringPath(this.withPrefix("GroupId"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
}

export const qUADMUpdateMaterialSpecification = new QUADMUpdateMaterialSpecification();

export class QDNCGetMachineDNCItemAssociationResponse extends QCommandResponse {
}

export const qDNCGetMachineDNCItemAssociationResponse = new QDNCGetMachineDNCItemAssociationResponse();

export class QDNCGetMachineDNCItemAssociation extends QueryObject {
    public readonly IsDeltaImport = new QBooleanPath(this.withPrefix("IsDeltaImport"));
}

export const qDNCGetMachineDNCItemAssociation = new QDNCGetMachineDNCItemAssociation();

export class QMaterialItemSplitBatchResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly SplitContextList = new QEntityCollectionPath(this.withPrefix("SplitContextList"), () => QSplitContext);
}

export const qMaterialItemSplitBatchResponse = new QMaterialItemSplitBatchResponse();

export class QMaterialItemSplitBatch extends QueryObject {
    public readonly SplitBatchList = new QEntityCollectionPath(this.withPrefix("SplitBatchList"), () => QMaterialItemForSplitType);
    public readonly MaterialItemId = new QGuidPath(this.withPrefix("MaterialItemId"));
    public readonly IsCalledFromConsumeOfMTU = new QBooleanPath(this.withPrefix("IsCalledFromConsumeOfMTU"));
}

export const qMaterialItemSplitBatch = new QMaterialItemSplitBatch();

export class QUnlinkSetPointItemToSetPointResponse extends QCommandResponse {
}

export const qUnlinkSetPointItemToSetPointResponse = new QUnlinkSetPointItemToSetPointResponse();

export class QUnlinkSetPointItemToSetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly SetPointItemList = new QCollectionPath(this.withPrefix("SetPointItemList"), () => QGuidCollection);
}

export const qUnlinkSetPointItemToSetPoint = new QUnlinkSetPointItemToSetPoint();

export class QConfirmSnagAndNoteListResponse extends QCommandResponse {
}

export const qConfirmSnagAndNoteListResponse = new QConfirmSnagAndNoteListResponse();

export class QConfirmSnagAndNoteList extends QueryObject {
    public readonly SnagAndNoteIds = new QCollectionPath(this.withPrefix("SnagAndNoteIds"), () => QGuidCollection);
}

export const qConfirmSnagAndNoteList = new QConfirmSnagAndNoteList();

export class QConfirmWorkOrderResponse extends QCommandResponse {
}

export const qConfirmWorkOrderResponse = new QConfirmWorkOrderResponse();

export class QConfirmWorkOrder extends QueryObject {
    public readonly OrderID = new QStringPath(this.withPrefix("OrderID"));
    public readonly PlantID = new QStringPath(this.withPrefix("PlantID"));
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly completion = new QBooleanPath(this.withPrefix("completion"));
}

export const qConfirmWorkOrder = new QConfirmWorkOrder();

export class QScheduleExecutionGroupResponse extends QCommandResponse {
}

export const qScheduleExecutionGroupResponse = new QScheduleExecutionGroupResponse();

export class QScheduleExecutionGroup extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
}

export const qScheduleExecutionGroup = new QScheduleExecutionGroup();

export class QAssociateContainerToWorkOrderResponse extends QCommandResponse {
}

export const qAssociateContainerToWorkOrderResponse = new QAssociateContainerToWorkOrderResponse();

export class QAssociateContainerToWorkOrder extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qAssociateContainerToWorkOrder = new QAssociateContainerToWorkOrder();

export class QCreateProcessListResponse extends QCommandResponse {
    public readonly CreatedProcesses = new QEntityCollectionPath(this.withPrefix("CreatedProcesses"), () => QOutputProcessParameterType);
}

export const qCreateProcessListResponse = new QCreateProcessListResponse();

export class QCreateProcessList extends QueryObject {
    public readonly Processes = new QEntityCollectionPath(this.withPrefix("Processes"), () => QProcessParameterType);
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
}

export const qCreateProcessList = new QCreateProcessList();

export class QTCM2DeleteLinkOperationToStepListResponse extends QCommandResponse {
}

export const qTCM2DeleteLinkOperationToStepListResponse = new QTCM2DeleteLinkOperationToStepListResponse();

export class QTCM2DeleteLinkOperationToStepList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qTCM2DeleteLinkOperationToStepList = new QTCM2DeleteLinkOperationToStepList();

export class QAcceptChangeAddToBeUsedToolResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeAddToBeUsedToolResponse = new QAcceptChangeAddToBeUsedToolResponse();

export class QAcceptChangeAddToBeUsedTool extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly ToolDefinitionNId = new QStringPath(this.withPrefix("ToolDefinitionNId"));
    public readonly ToolUsage = new QNumberPath(this.withPrefix("ToolUsage"));
    public readonly ChangeToolId = new QGuidPath(this.withPrefix("ChangeToolId"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
}

export const qAcceptChangeAddToBeUsedTool = new QAcceptChangeAddToBeUsedTool();

export class QDeassociateDNCItemMachineMaterialAssociationResponse extends QCommandResponse {
}

export const qDeassociateDNCItemMachineMaterialAssociationResponse = new QDeassociateDNCItemMachineMaterialAssociationResponse();

export class QDeassociateDNCItemMachineMaterialAssociation extends QueryObject {
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qDeassociateDNCItemMachineMaterialAssociation = new QDeassociateDNCItemMachineMaterialAssociation();

export class QDeleteUoMDimensionResponse extends QCommandResponse {
}

export const qDeleteUoMDimensionResponse = new QDeleteUoMDimensionResponse();

export class QDeleteUoMDimension extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteUoMDimension = new QDeleteUoMDimension();

export class QCompleteWOOperationTransferBatchResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QCollectionPath(this.withPrefix("WorkOrderHistoryId"), () => QGuidCollection);
}

export const qCompleteWOOperationTransferBatchResponse = new QCompleteWOOperationTransferBatchResponse();

export class QCompleteWOOperationTransferBatch extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly CompleteWOOperationTransferBatchParameterType = new QEntityPath(this.withPrefix("CompleteWOOperationTransferBatchParameterType"), () => QCompleteWOOperationTransferBatchParameterType);
}

export const qCompleteWOOperationTransferBatch = new QCompleteWOOperationTransferBatch();

export class QLinkSetPointItemToSetPointResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qLinkSetPointItemToSetPointResponse = new QLinkSetPointItemToSetPointResponse();

export class QLinkSetPointItemToSetPoint extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly DataType = new QStringPath(this.withPrefix("DataType"));
    public readonly Editable = new QBooleanPath(this.withPrefix("Editable"));
    public readonly DefaultValues = new QCollectionPath(this.withPrefix("DefaultValues"), () => QStringCollection);
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
}

export const qLinkSetPointItemToSetPoint = new QLinkSetPointItemToSetPoint();

export class QSaveResultQuantitiesOnWorkOrderOperationListResponse extends QCommandResponse {
}

export const qSaveResultQuantitiesOnWorkOrderOperationListResponse = new QSaveResultQuantitiesOnWorkOrderOperationListResponse();

export class QSaveResultQuantitiesOnWorkOrderOperationList extends QueryObject {
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
}

export const qSaveResultQuantitiesOnWorkOrderOperationList = new QSaveResultQuantitiesOnWorkOrderOperationList();

export class QCreateWIResultListResponse extends QCommandResponse {
}

export const qCreateWIResultListResponse = new QCreateWIResultListResponse();

export class QCreateWIResultList extends QueryObject {
    public readonly WIResultList = new QEntityCollectionPath(this.withPrefix("WIResultList"), () => QWIResult);
}

export const qCreateWIResultList = new QCreateWIResultList();

export class QUnLinkToolsFromNonConformanceResponse extends QCommandResponse {
}

export const qUnLinkToolsFromNonConformanceResponse = new QUnLinkToolsFromNonConformanceResponse();

export class QUnLinkToolsFromNonConformance extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly ToolIds = new QCollectionPath(this.withPrefix("ToolIds"), () => QGuidCollection);
}

export const qUnLinkToolsFromNonConformance = new QUnLinkToolsFromNonConformance();

export class QAssignCertificationToUserListResponse extends QCommandResponse {
}

export const qAssignCertificationToUserListResponse = new QAssignCertificationToUserListResponse();

export class QAssignCertificationToUserList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly Users = new QCollectionPath(this.withPrefix("Users"), () => QStringCollection);
    public readonly ExpiryDate = new QDateTimeOffsetPath(this.withPrefix("ExpiryDate"));
}

export const qAssignCertificationToUserList = new QAssignCertificationToUserList();

export class QEndIdTemplateEditingResponse extends QCommandResponse {
}

export const qEndIdTemplateEditingResponse = new QEndIdTemplateEditingResponse();

export class QEndIdTemplateEditing extends QueryObject {
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qEndIdTemplateEditing = new QEndIdTemplateEditing();

export class QLinkDocumentListToEGPhaseResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkDocumentListToEGPhaseResponse = new QLinkDocumentListToEGPhaseResponse();

export class QLinkDocumentListToEGPhase extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly DocumentIds = new QCollectionPath(this.withPrefix("DocumentIds"), () => QGuidCollection);
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
}

export const qLinkDocumentListToEGPhase = new QLinkDocumentListToEGPhase();

export class QManageRepeatResultForScrappedMTUResponse extends QCommandResponse {
}

export const qManageRepeatResultForScrappedMTUResponse = new QManageRepeatResultForScrappedMTUResponse();

export class QManageRepeatResultForScrappedMTU extends QueryObject {
    public readonly MTUNIdList = new QCollectionPath(this.withPrefix("MTUNIdList"), () => QStringCollection);
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qManageRepeatResultForScrappedMTU = new QManageRepeatResultForScrappedMTU();

export class QDeleteProducedMaterialUnderReworkResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteProducedMaterialUnderReworkResponse = new QDeleteProducedMaterialUnderReworkResponse();

export class QDeleteProducedMaterialUnderRework extends QueryObject {
    public readonly ProducedMaterialItemUnderReworkId = new QCollectionPath(this.withPrefix("ProducedMaterialItemUnderReworkId"), () => QGuidCollection);
}

export const qDeleteProducedMaterialUnderRework = new QDeleteProducedMaterialUnderRework();

export class QDeleteWorkOrderNotificationListResponse extends QCommandResponse {
}

export const qDeleteWorkOrderNotificationListResponse = new QDeleteWorkOrderNotificationListResponse();

export class QDeleteWorkOrderNotificationList extends QueryObject {
    public readonly WorkOrderNotificationIdList = new QCollectionPath(this.withPrefix("WorkOrderNotificationIdList"), () => QGuidCollection);
}

export const qDeleteWorkOrderNotificationList = new QDeleteWorkOrderNotificationList();

export class QDeleteWorkOStepDependencyResponse extends QCommandResponse {
}

export const qDeleteWorkOStepDependencyResponse = new QDeleteWorkOStepDependencyResponse();

export class QDeleteWorkOStepDependency extends QueryObject {
    public readonly Dependency = new QEntityPath(this.withPrefix("Dependency"), () => QWorkOStepDependencyParameter);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkOStepDependency = new QDeleteWorkOStepDependency();

export class QDeleteHoldReasonResponse extends QCommandResponse {
}

export const qDeleteHoldReasonResponse = new QDeleteHoldReasonResponse();

export class QDeleteHoldReason extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteHoldReason = new QDeleteHoldReason();

export class QLinkCharacteristicRepresentationToOperationResponse extends QCommandResponse {
}

export const qLinkCharacteristicRepresentationToOperationResponse = new QLinkCharacteristicRepresentationToOperationResponse();

export class QLinkCharacteristicRepresentationToOperation extends QueryObject {
    public readonly CharacteristicRepresentationNId = new QStringPath(this.withPrefix("CharacteristicRepresentationNId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly CharacteristicRepresentationRevision = new QStringPath(this.withPrefix("CharacteristicRepresentationRevision"));
    public readonly ReferencedOperation = new QStringPath(this.withPrefix("ReferencedOperation"));
    public readonly IsWOSpecific = new QBooleanPath(this.withPrefix("IsWOSpecific"));
}

export const qLinkCharacteristicRepresentationToOperation = new QLinkCharacteristicRepresentationToOperation();

export class QManageToBeConsumedMaterialDisassembleResponse extends QCommandResponse {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly OpenNonConformance = new QBooleanPath(this.withPrefix("OpenNonConformance"));
    public readonly IsStep = new QBooleanPath(this.withPrefix("IsStep"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qManageToBeConsumedMaterialDisassembleResponse = new QManageToBeConsumedMaterialDisassembleResponse();

export class QManageToBeConsumedMaterialDisassemble extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly MaterialItemIdentifiersList = new QEntityCollectionPath(this.withPrefix("MaterialItemIdentifiersList"), () => QMaterialItemIdentifiersParameterType);
}

export const qManageToBeConsumedMaterialDisassemble = new QManageToBeConsumedMaterialDisassemble();

export class QLinkMaterialTrackingUnitToContainerListResponse extends QCommandResponse {
}

export const qLinkMaterialTrackingUnitToContainerListResponse = new QLinkMaterialTrackingUnitToContainerListResponse();

export class QLinkMaterialTrackingUnitToContainerList extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly MaterialTrackingUnitNIdList = new QCollectionPath(this.withPrefix("MaterialTrackingUnitNIdList"), () => QStringCollection);
}

export const qLinkMaterialTrackingUnitToContainerList = new QLinkMaterialTrackingUnitToContainerList();

export class QAssignNonConformanceTransitionRoleListResponse extends QCommandResponse {
}

export const qAssignNonConformanceTransitionRoleListResponse = new QAssignNonConformanceTransitionRoleListResponse();

export class QAssignNonConformanceTransitionRoleList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly RoleList = new QCollectionPath(this.withPrefix("RoleList"), () => QStringCollection);
    public readonly LifeCycle = new QStringPath(this.withPrefix("LifeCycle"));
}

export const qAssignNonConformanceTransitionRoleList = new QAssignNonConformanceTransitionRoleList();

export class QCheckInPauseWOOperationResponse extends QCommandResponse {
}

export const qCheckInPauseWOOperationResponse = new QCheckInPauseWOOperationResponse();

export class QCheckInPauseWOOperation extends QueryObject {
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
    public readonly PauseWOOperationParameterType = new QEntityPath(this.withPrefix("PauseWOOperationParameterType"), () => QPauseWOOperationParameterType);
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qCheckInPauseWOOperation = new QCheckInPauseWOOperation();

export class QCreateOperationStructureDependencyResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateOperationStructureDependencyResponse = new QCreateOperationStructureDependencyResponse();

export class QCreateOperationStructureDependency extends QueryObject {
    public readonly OperationStructureDependency = new QEntityPath(this.withPrefix("OperationStructureDependency"), () => QOperationStructureDependencyParameterType);
}

export const qCreateOperationStructureDependency = new QCreateOperationStructureDependency();

export class QCreateStateMachineResponse extends QCommandResponse {
    public readonly StateMachineId = new QGuidPath(this.withPrefix("StateMachineId"));
}

export const qCreateStateMachineResponse = new QCreateStateMachineResponse();

export class QCreateStateMachine extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateStateMachine = new QCreateStateMachine();

export class QDeleteStatusTransitionResponse extends QCommandResponse {
}

export const qDeleteStatusTransitionResponse = new QDeleteStatusTransitionResponse();

export class QDeleteStatusTransition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteStatusTransition = new QDeleteStatusTransition();

export class QUnLinkWorkInstructionDefinitionListFromStepResponse extends QCommandResponse {
}

export const qUnLinkWorkInstructionDefinitionListFromStepResponse = new QUnLinkWorkInstructionDefinitionListFromStepResponse();

export class QUnLinkWorkInstructionDefinitionListFromStep extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly WorkInstructionDefinitionList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionList"), () => QGuidCollection);
}

export const qUnLinkWorkInstructionDefinitionListFromStep = new QUnLinkWorkInstructionDefinitionListFromStep();

export class QStartWOStepTransferBatchResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qStartWOStepTransferBatchResponse = new QStartWOStepTransferBatchResponse();

export class QStartWOStepTransferBatch extends QueryObject {
    public readonly StartWOStepTransferBatchParameter = new QEntityPath(this.withPrefix("StartWOStepTransferBatchParameter"), () => QStartWOStepTransferBatchParameterType);
}

export const qStartWOStepTransferBatch = new QStartWOStepTransferBatch();

export class QCreateWorkOrderNotificationResponse extends QCommandResponse {
    public readonly WorkOrderNotificationId = new QGuidPath(this.withPrefix("WorkOrderNotificationId"));
}

export const qCreateWorkOrderNotificationResponse = new QCreateWorkOrderNotificationResponse();

export class QCreateWorkOrderNotification extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderStatus = new QStringPath(this.withPrefix("WorkOrderStatus"));
    public readonly WorkOrderFinalMaterial = new QStringPath(this.withPrefix("WorkOrderFinalMaterial"));
    public readonly WorkOrderEstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("WorkOrderEstimatedStartTime"));
}

export const qCreateWorkOrderNotification = new QCreateWorkOrderNotification();

export class QUnlinkUserToPlantResponse extends QCommandResponse {
}

export const qUnlinkUserToPlantResponse = new QUnlinkUserToPlantResponse();

export class QUnlinkUserToPlant extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUnlinkUserToPlant = new QUnlinkUserToPlant();

export class QCreateDefectGroupResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateDefectGroupResponse = new QCreateDefectGroupResponse();

export class QCreateDefectGroup extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ChildrenIdentifiersList = new QEntityCollectionPath(this.withPrefix("ChildrenIdentifiersList"), () => QIdentifiersParameterType);
    public readonly ParentIdentifiersList = new QEntityCollectionPath(this.withPrefix("ParentIdentifiersList"), () => QIdentifiersParameterType);
}

export const qCreateDefectGroup = new QCreateDefectGroup();

export class QCheckMaterialConsumptionResponse extends QCommandResponse {
}

export const qCheckMaterialConsumptionResponse = new QCheckMaterialConsumptionResponse();

export class QCheckMaterialConsumption extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProducedMaterialItems = new QEntityCollectionPath(this.withPrefix("ProducedMaterialItems"), () => QProducedMaterialItemQuantity);
}

export const qCheckMaterialConsumption = new QCheckMaterialConsumption();

export class QGetResolvedToBeUsedMachinesOnWOOperationListResponse extends QCommandResponse {
    public readonly ResolvedToBeUsedMachinesOnWOOperationList = new QEntityCollectionPath(this.withPrefix("ResolvedToBeUsedMachinesOnWOOperationList"), () => QResolvedToBeUsedMachinesOnWOOpParameterType);
}

export const qGetResolvedToBeUsedMachinesOnWOOperationListResponse = new QGetResolvedToBeUsedMachinesOnWOOperationListResponse();

export class QGetResolvedToBeUsedMachinesOnWOOperationList extends QueryObject {
    public readonly WorkOrderOperationIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationIdList"), () => QGuidCollection);
}

export const qGetResolvedToBeUsedMachinesOnWOOperationList = new QGetResolvedToBeUsedMachinesOnWOOperationList();

export class QLinkAutomationNodeInstanceParameterToMaterialParameterListResponse extends QCommandResponse {
}

export const qLinkAutomationNodeInstanceParameterToMaterialParameterListResponse = new QLinkAutomationNodeInstanceParameterToMaterialParameterListResponse();

export class QLinkAutomationNodeInstanceParameterToMaterialParameterList extends QueryObject {
    public readonly ATNInstanceParameter = new QEntityPath(this.withPrefix("ATNInstanceParameter"), () => QATNInstanceParameterType);
    public readonly MaterialIdentifierList = new QCollectionPath(this.withPrefix("MaterialIdentifierList"), () => QGuidCollection);
    public readonly MaterialParameterNId = new QStringPath(this.withPrefix("MaterialParameterNId"));
}

export const qLinkAutomationNodeInstanceParameterToMaterialParameterList = new QLinkAutomationNodeInstanceParameterToMaterialParameterList();

export class QCreateUoMFactorResponse extends QCommandResponse {
    public readonly UoMFactorId = new QGuidPath(this.withPrefix("UoMFactorId"));
}

export const qCreateUoMFactorResponse = new QCreateUoMFactorResponse();

export class QCreateUoMFactor extends QueryObject {
    public readonly K0Multiplier = new QNumberPath(this.withPrefix("K0Multiplier"));
    public readonly Addend = new QNumberPath(this.withPrefix("Addend"));
    public readonly K1Multiplier = new QNumberPath(this.withPrefix("K1Multiplier"));
    public readonly Exponent = new QNumberPath(this.withPrefix("Exponent"));
    public readonly TargetUoMId = new QGuidPath(this.withPrefix("TargetUoMId"));
    public readonly SourceUoMId = new QGuidPath(this.withPrefix("SourceUoMId"));
}

export const qCreateUoMFactor = new QCreateUoMFactor();

export class QCreateWorkOrderHistoryActionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderHistoryActionResponse = new QCreateWorkOrderHistoryActionResponse();

export class QCreateWorkOrderHistoryAction extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateWorkOrderHistoryAction = new QCreateWorkOrderHistoryAction();

export class QCreateContainerTypeResponse extends QCommandResponse {
    public readonly ContainerTypeId = new QGuidPath(this.withPrefix("ContainerTypeId"));
}

export const qCreateContainerTypeResponse = new QCreateContainerTypeResponse();

export class QCreateContainerType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly CompatibleMaterialList = new QEntityCollectionPath(this.withPrefix("CompatibleMaterialList"), () => QMaterialParameterType);
}

export const qCreateContainerType = new QCreateContainerType();

export class QCreateHierarchyEquipmentNodeConfigurationsResponse extends QCommandResponse {
    public readonly EquipmentGraphNodeConfigurationIds = new QCollectionPath(this.withPrefix("EquipmentGraphNodeConfigurationIds"), () => QGuidCollection);
}

export const qCreateHierarchyEquipmentNodeConfigurationsResponse = new QCreateHierarchyEquipmentNodeConfigurationsResponse();

export class QCreateHierarchyEquipmentNodeConfigurations extends QueryObject {
    public readonly ParentEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("ParentEquipmentGraphNodeConfigurationId"));
    public readonly EquipmentConfigurations = new QCollectionPath(this.withPrefix("EquipmentConfigurations"), () => QStringCollection);
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
}

export const qCreateHierarchyEquipmentNodeConfigurations = new QCreateHierarchyEquipmentNodeConfigurations();

export class QUADMCreateNewProcessRevisionMasterPlanResponse extends QCommandResponse {
}

export const qUADMCreateNewProcessRevisionMasterPlanResponse = new QUADMCreateNewProcessRevisionMasterPlanResponse();

export class QUADMCreateNewProcessRevisionMasterPlan extends QueryObject {
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ParentProcessId = new QGuidPath(this.withPrefix("ParentProcessId"));
}

export const qUADMCreateNewProcessRevisionMasterPlan = new QUADMCreateNewProcessRevisionMasterPlan();

export class QAssignCertificationToLocationListResponse extends QCommandResponse {
}

export const qAssignCertificationToLocationListResponse = new QAssignCertificationToLocationListResponse();

export class QAssignCertificationToLocationList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly LocationNIds = new QCollectionPath(this.withPrefix("LocationNIds"), () => QStringCollection);
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
}

export const qAssignCertificationToLocationList = new QAssignCertificationToLocationList();

export class QCompleteWOStepTransferBatchResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qCompleteWOStepTransferBatchResponse = new QCompleteWOStepTransferBatchResponse();

export class QCompleteWOStepTransferBatch extends QueryObject {
    public readonly CompleteWOStepTransferBatchParameterType = new QEntityPath(this.withPrefix("CompleteWOStepTransferBatchParameterType"), () => QCompleteWOStepTransferBatchParameterType);
}

export const qCompleteWOStepTransferBatch = new QCompleteWOStepTransferBatch();

export class QDeleteMaterialListResponse extends QCommandResponse {
}

export const qDeleteMaterialListResponse = new QDeleteMaterialListResponse();

export class QDeleteMaterialList extends QueryObject {
    public readonly DM_MaterialIds = new QCollectionPath(this.withPrefix("DM_MaterialIds"), () => QGuidCollection);
}

export const qDeleteMaterialList = new QDeleteMaterialList();

export class QStartNonProductiveActivityListResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qStartNonProductiveActivityListResponse = new QStartNonProductiveActivityListResponse();

export class QStartNonProductiveActivityList extends QueryObject {
    public readonly NPAIds = new QCollectionPath(this.withPrefix("NPAIds"), () => QGuidCollection);
    public readonly NPAContextId = new QGuidPath(this.withPrefix("NPAContextId"));
    public readonly NPAContextValue = new QGuidPath(this.withPrefix("NPAContextValue"));
    public readonly NPAEquipmentNIdValue = new QStringPath(this.withPrefix("NPAEquipmentNIdValue"));
}

export const qStartNonProductiveActivityList = new QStartNonProductiveActivityList();

export class QDeleteToBeConsumedMaterialResponse extends QCommandResponse {
}

export const qDeleteToBeConsumedMaterialResponse = new QDeleteToBeConsumedMaterialResponse();

export class QDeleteToBeConsumedMaterial extends QueryObject {
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
}

export const qDeleteToBeConsumedMaterial = new QDeleteToBeConsumedMaterial();

export class QUpdateEquipmentLevelResponse extends QCommandResponse {
}

export const qUpdateEquipmentLevelResponse = new QUpdateEquipmentLevelResponse();

export class QUpdateEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qUpdateEquipmentLevel = new QUpdateEquipmentLevel();

export class QLinkItlkCheckToProcessToOpLinkListResponse extends QCommandResponse {
    public readonly ItlkCheckProcessToOpLinkAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qLinkItlkCheckToProcessToOpLinkListResponse = new QLinkItlkCheckToProcessToOpLinkListResponse();

export class QLinkItlkCheckToProcessToOpLinkList extends QueryObject {
    public readonly ItlkCheckProcessToOpLinkAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationList"), () => QItlkCheckProcessToOpLinkAssociationParameterType);
}

export const qLinkItlkCheckToProcessToOpLinkList = new QLinkItlkCheckToProcessToOpLinkList();

export class QCreateFailureResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
}

export const qCreateFailureResponse = new QCreateFailureResponse();

export class QCreateFailure extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ParentId = new QGuidPath(this.withPrefix("ParentId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qCreateFailure = new QCreateFailure();

export class QDeleteDNCItemMachineMaterialAssociationResponse extends QCommandResponse {
}

export const qDeleteDNCItemMachineMaterialAssociationResponse = new QDeleteDNCItemMachineMaterialAssociationResponse();

export class QDeleteDNCItemMachineMaterialAssociation extends QueryObject {
    public readonly DNCItemMachineMaterialAssociationId = new QGuidPath(this.withPrefix("DNCItemMachineMaterialAssociationId"));
}

export const qDeleteDNCItemMachineMaterialAssociation = new QDeleteDNCItemMachineMaterialAssociation();

export class QSentenceNonConformanceSetLocationHoldResponse extends QCommandResponse {
}

export const qSentenceNonConformanceSetLocationHoldResponse = new QSentenceNonConformanceSetLocationHoldResponse();

export class QSentenceNonConformanceSetLocationHold extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly HoldReasonNIdList = new QCollectionPath(this.withPrefix("HoldReasonNIdList"), () => QStringCollection);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
}

export const qSentenceNonConformanceSetLocationHold = new QSentenceNonConformanceSetLocationHold();

export class QRemoveWorkOrderScrapResponse extends QCommandResponse {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qRemoveWorkOrderScrapResponse = new QRemoveWorkOrderScrapResponse();

export class QRemoveWorkOrderScrap extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
}

export const qRemoveWorkOrderScrap = new QRemoveWorkOrderScrap();

export class QUpdateDM_MaterialTrackingUnitHistoryResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitHistoryId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitHistoryId"));
}

export const qUpdateDM_MaterialTrackingUnitHistoryResponse = new QUpdateDM_MaterialTrackingUnitHistoryResponse();

export class QUpdateDM_MaterialTrackingUnitHistory extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Action = new QGuidPath(this.withPrefix("Action"));
    public readonly MixedQuantity = new QNumberPath(this.withPrefix("MixedQuantity"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly RecycleCount = new QNumberPath(this.withPrefix("RecycleCount"));
    public readonly DM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit"));
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QGuidPath(this.withPrefix("WorkOrderOperation"));
    public readonly WorkOrderStep = new QGuidPath(this.withPrefix("WorkOrderStep"));
    public readonly SourceDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("SourceDM_MaterialTrackingUnit"));
    public readonly TargetDM_MaterialTrackingUnit = new QGuidPath(this.withPrefix("TargetDM_MaterialTrackingUnit"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly SourceCode = new QStringPath(this.withPrefix("SourceCode"));
    public readonly TargetCode = new QStringPath(this.withPrefix("TargetCode"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly DM_MaterialTrackingUnitHistoryId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitHistoryId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OldCode = new QStringPath(this.withPrefix("OldCode"));
    public readonly NewCode = new QStringPath(this.withPrefix("NewCode"));
}

export const qUpdateDM_MaterialTrackingUnitHistory = new QUpdateDM_MaterialTrackingUnitHistory();

export class QCreateStatusTransitionResponse extends QCommandResponse {
    public readonly StatusTransitionId = new QGuidPath(this.withPrefix("StatusTransitionId"));
}

export const qCreateStatusTransitionResponse = new QCreateStatusTransitionResponse();

export class QCreateStatusTransition extends QueryObject {
    public readonly SourceStatusId = new QGuidPath(this.withPrefix("SourceStatusId"));
    public readonly TargetStatusId = new QGuidPath(this.withPrefix("TargetStatusId"));
    public readonly DoRaiseEvent = new QBooleanPath(this.withPrefix("DoRaiseEvent"));
    public readonly StatusTransitionDefinitionVerb = new QStringPath(this.withPrefix("StatusTransitionDefinitionVerb"));
}

export const qCreateStatusTransition = new QCreateStatusTransition();

export class QSetEquipmentPropertyAttributeValueResponse extends QCommandResponse {
}

export const qSetEquipmentPropertyAttributeValueResponse = new QSetEquipmentPropertyAttributeValueResponse();

export class QSetEquipmentPropertyAttributeValue extends QueryObject {
    public readonly EquipmentPropertyAttributeId = new QGuidPath(this.withPrefix("EquipmentPropertyAttributeId"));
    public readonly EquipmentPropertyAttributeValue = new QStringPath(this.withPrefix("EquipmentPropertyAttributeValue"));
}

export const qSetEquipmentPropertyAttributeValue = new QSetEquipmentPropertyAttributeValue();

export class QReopenWorkOrderOperationTransferBatchResponse extends QCommandResponse {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QIdentifiersParameterType);
    public readonly WorkOrderOperationIdentifiers = new QEntityPath(this.withPrefix("WorkOrderOperationIdentifiers"), () => QIdentifiersParameterType);
}

export const qReopenWorkOrderOperationTransferBatchResponse = new QReopenWorkOrderOperationTransferBatchResponse();

export class QReopenWorkOrderOperationTransferBatch extends QueryObject {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QIdentifiersParameterType);
    public readonly WorkOrderOperationIdentifiers = new QEntityPath(this.withPrefix("WorkOrderOperationIdentifiers"), () => QIdentifiersParameterType);
    public readonly QuantityToReopen = new QNumberPath(this.withPrefix("QuantityToReopen"));
}

export const qReopenWorkOrderOperationTransferBatch = new QReopenWorkOrderOperationTransferBatch();

export class QManageToBeConsumedMaterialDisassembleOnContainerResponse extends QCommandResponse {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qManageToBeConsumedMaterialDisassembleOnContainerResponse = new QManageToBeConsumedMaterialDisassembleOnContainerResponse();

export class QManageToBeConsumedMaterialDisassembleOnContainer extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ToBeConsumedMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedMaterialId"));
    public readonly ContainerNIdList = new QCollectionPath(this.withPrefix("ContainerNIdList"), () => QStringCollection);
}

export const qManageToBeConsumedMaterialDisassembleOnContainer = new QManageToBeConsumedMaterialDisassembleOnContainer();

export class QUnlinkWorkInstructionsFromWOOperationResponse extends QCommandResponse {
}

export const qUnlinkWorkInstructionsFromWOOperationResponse = new QUnlinkWorkInstructionsFromWOOperationResponse();

export class QUnlinkWorkInstructionsFromWOOperation extends QueryObject {
    public readonly WorkInstructionIds = new QCollectionPath(this.withPrefix("WorkInstructionIds"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qUnlinkWorkInstructionsFromWOOperation = new QUnlinkWorkInstructionsFromWOOperation();

export class QSetLocationHoldResponse extends QCommandResponse {
}

export const qSetLocationHoldResponse = new QSetLocationHoldResponse();

export class QSetLocationHold extends QueryObject {
    public readonly EquipmentIdentifiers = new QStringPath(this.withPrefix("EquipmentIdentifiers"));
    public readonly HoldReasonNIdList = new QCollectionPath(this.withPrefix("HoldReasonNIdList"), () => QStringCollection);
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
}

export const qSetLocationHold = new QSetLocationHold();

export class QLinkToolSpecificationToOperationResponse extends QCommandResponse {
}

export const qLinkToolSpecificationToOperationResponse = new QLinkToolSpecificationToOperationResponse();

export class QLinkToolSpecificationToOperation extends QueryObject {
    public readonly ToolSpecificationId = new QGuidPath(this.withPrefix("ToolSpecificationId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qLinkToolSpecificationToOperation = new QLinkToolSpecificationToOperation();

export class QRemoveCertificationToSkillListResponse extends QCommandResponse {
}

export const qRemoveCertificationToSkillListResponse = new QRemoveCertificationToSkillListResponse();

export class QRemoveCertificationToSkillList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly SkillIds = new QEntityCollectionPath(this.withPrefix("SkillIds"), () => QCertificationAssociationParameterType);
}

export const qRemoveCertificationToSkillList = new QRemoveCertificationToSkillList();

export class QLinkMaterialItemToBufferResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qLinkMaterialItemToBufferResponse = new QLinkMaterialItemToBufferResponse();

export class QLinkMaterialItemToBuffer extends QueryObject {
    public readonly BufferId = new QGuidPath(this.withPrefix("BufferId"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
}

export const qLinkMaterialItemToBuffer = new QLinkMaterialItemToBuffer();

export class QGetOfflineWorkInstructionDefinitionsResponse extends QCommandResponse {
    public readonly OfflineWorkInstructionAssociations = new QEntityCollectionPath(this.withPrefix("OfflineWorkInstructionAssociations"), () => QOfflineWorkInstructionDefinitionAssociation);
}

export const qGetOfflineWorkInstructionDefinitionsResponse = new QGetOfflineWorkInstructionDefinitionsResponse();

export class QGetOfflineWorkInstructionDefinitions extends QueryObject {
    public readonly WorkOrderOperationIds = new QCollectionPath(this.withPrefix("WorkOrderOperationIds"), () => QGuidCollection);
}

export const qGetOfflineWorkInstructionDefinitions = new QGetOfflineWorkInstructionDefinitions();

export class QUADMCreateProcessResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateProcessResponse = new QUADMCreateProcessResponse();

export class QUADMCreateProcess extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaxQuantity = new QEntityPath(this.withPrefix("MaxQuantity"), () => QQuantityParameterType);
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityParameterType);
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ParentProcessId = new QGuidPath(this.withPrefix("ParentProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly RevisionEffectivityExpression = new QStringPath(this.withPrefix("RevisionEffectivityExpression"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qUADMCreateProcess = new QUADMCreateProcess();

export class QUpdateStatusResponse extends QCommandResponse {
}

export const qUpdateStatusResponse = new QUpdateStatusResponse();

export class QUpdateStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsInitial = new QBooleanPath(this.withPrefix("IsInitial"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
}

export const qUpdateStatus = new QUpdateStatus();

export class QManageNullResultOnKoWOOperationListResponse extends QCommandResponse {
}

export const qManageNullResultOnKoWOOperationListResponse = new QManageNullResultOnKoWOOperationListResponse();

export class QManageNullResultOnKoWOOperationList extends QueryObject {
    public readonly ManageNullResultParameterList = new QEntityCollectionPath(this.withPrefix("ManageNullResultParameterList"), () => QManageNullResultParameterType);
}

export const qManageNullResultOnKoWOOperationList = new QManageNullResultOnKoWOOperationList();

export class QCreateDNCItemMachineMaterialAssociationResponse extends QCommandResponse {
    public readonly DNCItemMachineMaterialAssociationId = new QGuidPath(this.withPrefix("DNCItemMachineMaterialAssociationId"));
}

export const qCreateDNCItemMachineMaterialAssociationResponse = new QCreateDNCItemMachineMaterialAssociationResponse();

export class QCreateDNCItemMachineMaterialAssociation extends QueryObject {
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qCreateDNCItemMachineMaterialAssociation = new QCreateDNCItemMachineMaterialAssociation();

export class QGenerateMaterialBatchIdResponse extends QCommandResponse {
    public readonly MaterialBatchId = new QStringPath(this.withPrefix("MaterialBatchId"));
}

export const qGenerateMaterialBatchIdResponse = new QGenerateMaterialBatchIdResponse();

export class QGenerateMaterialBatchId extends QueryObject {
    public readonly MaterialId = new QStringPath(this.withPrefix("MaterialId"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qGenerateMaterialBatchId = new QGenerateMaterialBatchId();

export class QDeleteHierarchyEquipmentNodeConfigurationResponse extends QCommandResponse {
}

export const qDeleteHierarchyEquipmentNodeConfigurationResponse = new QDeleteHierarchyEquipmentNodeConfigurationResponse();

export class QDeleteHierarchyEquipmentNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteHierarchyEquipmentNodeConfiguration = new QDeleteHierarchyEquipmentNodeConfiguration();

export class QLinkWorkInstructionDefinitionListToOperationResponse extends QCommandResponse {
}

export const qLinkWorkInstructionDefinitionListToOperationResponse = new QLinkWorkInstructionDefinitionListToOperationResponse();

export class QLinkWorkInstructionDefinitionListToOperation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly WorkInstructionDefinitionList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionList"), () => QGuidCollection);
    public readonly WorkInstructionAssociationType = new QStringPath(this.withPrefix("WorkInstructionAssociationType"));
    public readonly StopPropagationToProcessOp = new QBooleanPath(this.withPrefix("StopPropagationToProcessOp"));
    public readonly HideOnExecGroup = new QBooleanPath(this.withPrefix("HideOnExecGroup"));
}

export const qLinkWorkInstructionDefinitionListToOperation = new QLinkWorkInstructionDefinitionListToOperation();

export class QUpdateNonConformanceHistoryResponse extends QCommandResponse {
}

export const qUpdateNonConformanceHistoryResponse = new QUpdateNonConformanceHistoryResponse();

export class QUpdateNonConformanceHistory extends QueryObject {
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Transition = new QStringPath(this.withPrefix("Transition"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Action = new QStringPath(this.withPrefix("Action"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
}

export const qUpdateNonConformanceHistory = new QUpdateNonConformanceHistory();

export class QDeleteEquipmentConfigurationStateMachineResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationStateMachineResponse = new QDeleteEquipmentConfigurationStateMachineResponse();

export class QDeleteEquipmentConfigurationStateMachine extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationStateMachineId = new QGuidPath(this.withPrefix("EquipmentConfigurationStateMachineId"));
}

export const qDeleteEquipmentConfigurationStateMachine = new QDeleteEquipmentConfigurationStateMachine();

export class QTCM2CreateStepListResponse extends QCommandResponse {
}

export const qTCM2CreateStepListResponse = new QTCM2CreateStepListResponse();

export class QTCM2CreateStepList extends QueryObject {
    public readonly StepList = new QEntityCollectionPath(this.withPrefix("StepList"), () => QTCM2StepParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateStepList = new QTCM2CreateStepList();

export class QDeleteActualConsumedMaterialResponse extends QCommandResponse {
}

export const qDeleteActualConsumedMaterialResponse = new QDeleteActualConsumedMaterialResponse();

export class QDeleteActualConsumedMaterial extends QueryObject {
    public readonly ActualConsumedMaterialIds = new QCollectionPath(this.withPrefix("ActualConsumedMaterialIds"), () => QGuidCollection);
}

export const qDeleteActualConsumedMaterial = new QDeleteActualConsumedMaterial();

export class QDeleteNonConformanceResourceResponse extends QCommandResponse {
}

export const qDeleteNonConformanceResourceResponse = new QDeleteNonConformanceResourceResponse();

export class QDeleteNonConformanceResource extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteNonConformanceResource = new QDeleteNonConformanceResource();

export class QSentencingChangeNonConformanceResponse extends QCommandResponse {
}

export const qSentencingChangeNonConformanceResponse = new QSentencingChangeNonConformanceResponse();

export class QSentencingChangeNonConformance extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly NonConformanceUser = new QStringPath(this.withPrefix("NonConformanceUser"));
    public readonly CloseNotes = new QStringPath(this.withPrefix("CloseNotes"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qSentencingChangeNonConformance = new QSentencingChangeNonConformance();

export class QDeleteWorkOperationTypeListResponse extends QCommandResponse {
}

export const qDeleteWorkOperationTypeListResponse = new QDeleteWorkOperationTypeListResponse();

export class QDeleteWorkOperationTypeList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteWorkOperationTypeList = new QDeleteWorkOperationTypeList();

export class QCreateMaterialGroupResponse extends QCommandResponse {
    public readonly MaterialGroupId = new QGuidPath(this.withPrefix("MaterialGroupId"));
}

export const qCreateMaterialGroupResponse = new QCreateMaterialGroupResponse();

export class QCreateMaterialGroup extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateMaterialGroup = new QCreateMaterialGroup();

export class QCheckInDataCollectionResponse extends QCommandResponse {
    public readonly DataCollectionCheckedInList = new QEntityCollectionPath(this.withPrefix("DataCollectionCheckedInList"), () => QOfflineDataCollectionCheckedIn);
}

export const qCheckInDataCollectionResponse = new QCheckInDataCollectionResponse();

export class QCheckInDataCollection extends QueryObject {
    public readonly DataCollectionList = new QEntityCollectionPath(this.withPrefix("DataCollectionList"), () => QOfflineDataCollection);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInDataCollection = new QCheckInDataCollection();

export class QDeleteToBeUsedToolResponse extends QCommandResponse {
}

export const qDeleteToBeUsedToolResponse = new QDeleteToBeUsedToolResponse();

export class QDeleteToBeUsedTool extends QueryObject {
    public readonly ToBeUsedToolId = new QGuidPath(this.withPrefix("ToBeUsedToolId"));
}

export const qDeleteToBeUsedTool = new QDeleteToBeUsedTool();

export class QDeleteNonConformanceAttachmentListResponse extends QCommandResponse {
}

export const qDeleteNonConformanceAttachmentListResponse = new QDeleteNonConformanceAttachmentListResponse();

export class QDeleteNonConformanceAttachmentList extends QueryObject {
    public readonly NonConformanceAttachmentIdList = new QCollectionPath(this.withPrefix("NonConformanceAttachmentIdList"), () => QGuidCollection);
}

export const qDeleteNonConformanceAttachmentList = new QDeleteNonConformanceAttachmentList();

export class QUpdateSerialNumberListResponse extends QCommandResponse {
    public readonly FailedMaterialItemIdList = new QCollectionPath(this.withPrefix("FailedMaterialItemIdList"), () => QGuidCollection);
}

export const qUpdateSerialNumberListResponse = new QUpdateSerialNumberListResponse();

export class QUpdateSerialNumberList extends QueryObject {
    public readonly SerialNumbersToBeUpdatedList = new QEntityCollectionPath(this.withPrefix("SerialNumbersToBeUpdatedList"), () => QUpdateSerialNumberParameterType);
}

export const qUpdateSerialNumberList = new QUpdateSerialNumberList();

export class QUpdateDefectTypeResponse extends QCommandResponse {
}

export const qUpdateDefectTypeResponse = new QUpdateDefectTypeResponse();

export class QUpdateDefectType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly GroupIdentifiersList = new QEntityCollectionPath(this.withPrefix("GroupIdentifiersList"), () => QIdentifiersParameterType);
}

export const qUpdateDefectType = new QUpdateDefectType();

export class QGenerateSerialNumberCodeResponse extends QCommandResponse {
    public readonly SerialNumberCode = new QStringPath(this.withPrefix("SerialNumberCode"));
}

export const qGenerateSerialNumberCodeResponse = new QGenerateSerialNumberCodeResponse();

export class QGenerateSerialNumberCode extends QueryObject {
    public readonly MaterialId = new QStringPath(this.withPrefix("MaterialId"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qGenerateSerialNumberCode = new QGenerateSerialNumberCode();

export class QAssignCertificationToMaterialListResponse extends QCommandResponse {
}

export const qAssignCertificationToMaterialListResponse = new QAssignCertificationToMaterialListResponse();

export class QAssignCertificationToMaterialList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly MaterialIds = new QCollectionPath(this.withPrefix("MaterialIds"), () => QGuidCollection);
}

export const qAssignCertificationToMaterialList = new QAssignCertificationToMaterialList();

export class QCreateDM_MaterialResponse extends QCommandResponse {
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
}

export const qCreateDM_MaterialResponse = new QCreateDM_MaterialResponse();

export class QCreateDM_Material extends QueryObject {
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly MaterialClassId = new QGuidPath(this.withPrefix("MaterialClassId"));
    public readonly SupplierId = new QGuidPath(this.withPrefix("SupplierId"));
    public readonly FunctionalCodeId = new QGuidPath(this.withPrefix("FunctionalCodeId"));
    public readonly Lot = new QBooleanPath(this.withPrefix("Lot"));
    public readonly EnableAutomaticConsumptionQty = new QBooleanPath(this.withPrefix("EnableAutomaticConsumptionQty"));
    public readonly MaxQuantityConsumption = new QNumberPath(this.withPrefix("MaxQuantityConsumption"));
}

export const qCreateDM_Material = new QCreateDM_Material();

export class QUpdateDefectGroupResponse extends QCommandResponse {
}

export const qUpdateDefectGroupResponse = new QUpdateDefectGroupResponse();

export class QUpdateDefectGroup extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParentIdentifiersList = new QEntityCollectionPath(this.withPrefix("ParentIdentifiersList"), () => QIdentifiersParameterType);
    public readonly ChildrenIdentifiersList = new QEntityCollectionPath(this.withPrefix("ChildrenIdentifiersList"), () => QIdentifiersParameterType);
}

export const qUpdateDefectGroup = new QUpdateDefectGroup();

export class QUpdateHoldResponse extends QCommandResponse {
}

export const qUpdateHoldResponse = new QUpdateHoldResponse();

export class QUpdateHold extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CloseComment = new QStringPath(this.withPrefix("CloseComment"));
    public readonly CloseTime = new QDateTimeOffsetPath(this.withPrefix("CloseTime"));
    public readonly CloseUserId = new QStringPath(this.withPrefix("CloseUserId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly FutureHold = new QStringPath(this.withPrefix("FutureHold"));
    public readonly IsPresent = new QBooleanPath(this.withPrefix("IsPresent"));
    public readonly OpenTime = new QDateTimeOffsetPath(this.withPrefix("OpenTime"));
    public readonly OpenUserId = new QStringPath(this.withPrefix("OpenUserId"));
    public readonly PreviousState = new QStringPath(this.withPrefix("PreviousState"));
    public readonly ReasonId = new QGuidPath(this.withPrefix("ReasonId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly TypeNId = new QStringPath(this.withPrefix("TypeNId"));
}

export const qUpdateHold = new QUpdateHold();

export class QDeleteProcessNotificationListResponse extends QCommandResponse {
}

export const qDeleteProcessNotificationListResponse = new QDeleteProcessNotificationListResponse();

export class QDeleteProcessNotificationList extends QueryObject {
    public readonly ProcessNotificationIdList = new QCollectionPath(this.withPrefix("ProcessNotificationIdList"), () => QGuidCollection);
}

export const qDeleteProcessNotificationList = new QDeleteProcessNotificationList();

export class QTriggerPrintingOnWorkOrderStepResponse extends QCommandResponse {
}

export const qTriggerPrintingOnWorkOrderStepResponse = new QTriggerPrintingOnWorkOrderStepResponse();

export class QTriggerPrintingOnWorkOrderStep extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qTriggerPrintingOnWorkOrderStep = new QTriggerPrintingOnWorkOrderStep();

export class QUADMDeleteEquipmentSpecificationListResponse extends QCommandResponse {
}

export const qUADMDeleteEquipmentSpecificationListResponse = new QUADMDeleteEquipmentSpecificationListResponse();

export class QUADMDeleteEquipmentSpecificationList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qUADMDeleteEquipmentSpecificationList = new QUADMDeleteEquipmentSpecificationList();

export class QCreateProducedMaterialUnderReworkResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateProducedMaterialUnderReworkResponse = new QCreateProducedMaterialUnderReworkResponse();

export class QCreateProducedMaterialUnderRework extends QueryObject {
    public readonly ReworkOrderId = new QGuidPath(this.withPrefix("ReworkOrderId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MaterialItemUnderReworkParameterType = new QEntityCollectionPath(this.withPrefix("MaterialItemUnderReworkParameterType"), () => QMaterialItemUnderReworkParameterType);
}

export const qCreateProducedMaterialUnderRework = new QCreateProducedMaterialUnderRework();

export class QUpdateWorkInstructionDefinitionResponse extends QCommandResponse {
    public readonly ParameterIds = new QCollectionPath(this.withPrefix("ParameterIds"), () => QGuidCollection);
}

export const qUpdateWorkInstructionDefinitionResponse = new QUpdateWorkInstructionDefinitionResponse();

export class QUpdateWorkInstructionDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QWorkInstructionDefinitionParameterParameterType);
}

export const qUpdateWorkInstructionDefinition = new QUpdateWorkInstructionDefinition();

export class QLinkMaterialToContainerListResponse extends QCommandResponse {
}

export const qLinkMaterialToContainerListResponse = new QLinkMaterialToContainerListResponse();

export class QLinkMaterialToContainerList extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly CompatibleMaterialList = new QEntityCollectionPath(this.withPrefix("CompatibleMaterialList"), () => QMaterialParameterType);
}

export const qLinkMaterialToContainerList = new QLinkMaterialToContainerList();

export class QUpdateUoMFactorResponse extends QCommandResponse {
}

export const qUpdateUoMFactorResponse = new QUpdateUoMFactorResponse();

export class QUpdateUoMFactor extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly K0Multiplier = new QNumberPath(this.withPrefix("K0Multiplier"));
    public readonly Addend = new QNumberPath(this.withPrefix("Addend"));
    public readonly K1Multiplier = new QNumberPath(this.withPrefix("K1Multiplier"));
    public readonly Exponent = new QNumberPath(this.withPrefix("Exponent"));
}

export const qUpdateUoMFactor = new QUpdateUoMFactor();

export class QUnVerifyWorkOrderResponse extends QCommandResponse {
    public readonly MaterialItemIdentifiers = new QEntityPath(this.withPrefix("MaterialItemIdentifiers"), () => QMaterialItemIdentifiersParameterType);
}

export const qUnVerifyWorkOrderResponse = new QUnVerifyWorkOrderResponse();

export class QUnVerifyWorkOrder extends QueryObject {
    public readonly MaterialItemIdentifiers = new QEntityPath(this.withPrefix("MaterialItemIdentifiers"), () => QMaterialItemIdentifiersParameterType);
}

export const qUnVerifyWorkOrder = new QUnVerifyWorkOrder();

export class QStartWOOperationTransferBatchResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qStartWOOperationTransferBatchResponse = new QStartWOOperationTransferBatchResponse();

export class QStartWOOperationTransferBatch extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly StartWOOperationTransferBatchParameterType = new QEntityPath(this.withPrefix("StartWOOperationTransferBatchParameterType"), () => QStartWOOperationTransferBatchParameterType);
    public readonly SetPointItemParameterType = new QEntityCollectionPath(this.withPrefix("SetPointItemParameterType"), () => QSetPointParameterType);
}

export const qStartWOOperationTransferBatch = new QStartWOOperationTransferBatch();

export class QCreateEquipmentConfigurationByDefaultEquipmentTypeResponse extends QCommandResponse {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qCreateEquipmentConfigurationByDefaultEquipmentTypeResponse = new QCreateEquipmentConfigurationByDefaultEquipmentTypeResponse();

export class QCreateEquipmentConfigurationByDefaultEquipmentType extends QueryObject {
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyWithAttributesParameterType);
}

export const qCreateEquipmentConfigurationByDefaultEquipmentType = new QCreateEquipmentConfigurationByDefaultEquipmentType();

export class QLinkUsersToTeamResponse extends QCommandResponse {
}

export const qLinkUsersToTeamResponse = new QLinkUsersToTeamResponse();

export class QLinkUsersToTeam extends QueryObject {
    public readonly TeamId = new QGuidPath(this.withPrefix("TeamId"));
    public readonly Users = new QCollectionPath(this.withPrefix("Users"), () => QStringCollection);
}

export const qLinkUsersToTeam = new QLinkUsersToTeam();

export class QCreateBufferResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBufferResponse = new QCreateBufferResponse();

export class QCreateBuffer extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly BufferDefinition = new QGuidPath(this.withPrefix("BufferDefinition"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Status = new QGuidPath(this.withPrefix("Status"));
    public readonly ValidFrom = new QDateTimeOffsetPath(this.withPrefix("ValidFrom"));
    public readonly ValidTo = new QDateTimeOffsetPath(this.withPrefix("ValidTo"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
}

export const qCreateBuffer = new QCreateBuffer();

export class QUnlinkToolDefinitionToAutomationNodeTypeListResponse extends QCommandResponse {
}

export const qUnlinkToolDefinitionToAutomationNodeTypeListResponse = new QUnlinkToolDefinitionToAutomationNodeTypeListResponse();

export class QUnlinkToolDefinitionToAutomationNodeTypeList extends QueryObject {
    public readonly ToolDefinitionATNTypeAssociationIdList = new QCollectionPath(this.withPrefix("ToolDefinitionATNTypeAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkToolDefinitionToAutomationNodeTypeList = new QUnlinkToolDefinitionToAutomationNodeTypeList();

export class QCreateEquipmentGraphTypeResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphTypeResponse = new QCreateEquipmentGraphTypeResponse();

export class QCreateEquipmentGraphType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateEquipmentGraphType = new QCreateEquipmentGraphType();

export class QSaveDocumentForPreviewResponse extends QCommandResponse {
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
}

export const qSaveDocumentForPreviewResponse = new QSaveDocumentForPreviewResponse();

export class QSaveDocumentForPreview extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
}

export const qSaveDocumentForPreview = new QSaveDocumentForPreview();

export class QCreateVisualCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateVisualCharacteristicSpecificationResponse = new QCreateVisualCharacteristicSpecificationResponse();

export class QCreateVisualCharacteristicSpecification extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly Sketch = new QBinaryPath(this.withPrefix("Sketch"));
    public readonly SketchRows = new QNumberPath(this.withPrefix("SketchRows"));
    public readonly SketchColumns = new QNumberPath(this.withPrefix("SketchColumns"));
    public readonly SketchMimeType = new QStringPath(this.withPrefix("SketchMimeType"));
    public readonly SketchName = new QStringPath(this.withPrefix("SketchName"));
}

export const qCreateVisualCharacteristicSpecification = new QCreateVisualCharacteristicSpecification();

export class QSentenceBuyOffResponse extends QCommandResponse {
}

export const qSentenceBuyOffResponse = new QSentenceBuyOffResponse();

export class QSentenceBuyOff extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly ScenarioInstanceId = new QGuidPath(this.withPrefix("ScenarioInstanceId"));
    public readonly InspectionSampleId = new QGuidPath(this.withPrefix("InspectionSampleId"));
}

export const qSentenceBuyOff = new QSentenceBuyOff();

export class QCreateOfflineSessionResponse extends QCommandResponse {
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
}

export const qCreateOfflineSessionResponse = new QCreateOfflineSessionResponse();

export class QCreateOfflineSession extends QueryObject {
    public readonly DeviceId = new QStringPath(this.withPrefix("DeviceId"));
}

export const qCreateOfflineSession = new QCreateOfflineSession();

export class QCreateStepRevisionSubStructureResponse extends QCommandResponse {
}

export const qCreateStepRevisionSubStructureResponse = new QCreateStepRevisionSubStructureResponse();

export class QCreateStepRevisionSubStructure extends QueryObject {
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly SourceStepId = new QGuidPath(this.withPrefix("SourceStepId"));
    public readonly TargetStepId = new QGuidPath(this.withPrefix("TargetStepId"));
}

export const qCreateStepRevisionSubStructure = new QCreateStepRevisionSubStructure();

export class QSkipWOOperationTransferBatchResponse extends QCommandResponse {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qSkipWOOperationTransferBatchResponse = new QSkipWOOperationTransferBatchResponse();

export class QSkipWOOperationTransferBatch extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ReasonNId = new QStringPath(this.withPrefix("ReasonNId"));
}

export const qSkipWOOperationTransferBatch = new QSkipWOOperationTransferBatch();

export class QUpdateContainerTypeResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateContainerTypeResponse = new QUpdateContainerTypeResponse();

export class QUpdateContainerType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
}

export const qUpdateContainerType = new QUpdateContainerType();

export class QCreateAttributiveCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateAttributiveCharacteristicSpecificationResponse = new QCreateAttributiveCharacteristicSpecificationResponse();

export class QCreateAttributiveCharacteristicSpecification extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly NOKDescription = new QStringPath(this.withPrefix("NOKDescription"));
    public readonly OKDescription = new QStringPath(this.withPrefix("OKDescription"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qCreateAttributiveCharacteristicSpecification = new QCreateAttributiveCharacteristicSpecification();

export class QGetPJFsHookOnLinkActualUsedMachinePJFResponse extends QCommandResponse {
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
}

export const qGetPJFsHookOnLinkActualUsedMachinePJFResponse = new QGetPJFsHookOnLinkActualUsedMachinePJFResponse();

export class QGetPJFsHookOnLinkActualUsedMachinePJF extends QueryObject {
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
}

export const qGetPJFsHookOnLinkActualUsedMachinePJF = new QGetPJFsHookOnLinkActualUsedMachinePJF();

export class QDeleteEquipmentTypeResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypeResponse = new QDeleteEquipmentTypeResponse();

export class QDeleteEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentType = new QDeleteEquipmentType();

export class QUpdateMaterialAndDM_MaterialResponse extends QCommandResponse {
}

export const qUpdateMaterialAndDM_MaterialResponse = new QUpdateMaterialAndDM_MaterialResponse();

export class QUpdateMaterialAndDM_Material extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly FirstArticleInspection = new QBooleanPath(this.withPrefix("FirstArticleInspection"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly LogisticClassNId = new QStringPath(this.withPrefix("LogisticClassNId"));
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly MaterialClassNId = new QStringPath(this.withPrefix("MaterialClassNId"));
}

export const qUpdateMaterialAndDM_Material = new QUpdateMaterialAndDM_Material();

export class QLinkBufferDefinitionToMaterialDefListResponse extends QCommandResponse {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qLinkBufferDefinitionToMaterialDefListResponse = new QLinkBufferDefinitionToMaterialDefListResponse();

export class QLinkBufferDefinitionToMaterialDefList extends QueryObject {
    public readonly BufferDefinitionId = new QGuidPath(this.withPrefix("BufferDefinitionId"));
    public readonly MaterialDefList = new QCollectionPath(this.withPrefix("MaterialDefList"), () => QGuidCollection);
    public readonly Min = new QEntityPath(this.withPrefix("Min"), () => QQuantityParameterType);
    public readonly Threshold = new QEntityPath(this.withPrefix("Threshold"), () => QQuantityParameterType);
    public readonly Target = new QEntityPath(this.withPrefix("Target"), () => QQuantityParameterType);
    public readonly Max = new QEntityPath(this.withPrefix("Max"), () => QQuantityParameterType);
}

export const qLinkBufferDefinitionToMaterialDefList = new QLinkBufferDefinitionToMaterialDefList();

export class QLinkBufferDefinitionToToolDefListResponse extends QCommandResponse {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qLinkBufferDefinitionToToolDefListResponse = new QLinkBufferDefinitionToToolDefListResponse();

export class QLinkBufferDefinitionToToolDefList extends QueryObject {
    public readonly BufferDefinitionId = new QGuidPath(this.withPrefix("BufferDefinitionId"));
    public readonly ToolDefList = new QCollectionPath(this.withPrefix("ToolDefList"), () => QGuidCollection);
    public readonly Min = new QEntityPath(this.withPrefix("Min"), () => QQuantityParameterType);
    public readonly Max = new QEntityPath(this.withPrefix("Max"), () => QQuantityParameterType);
    public readonly Threshold = new QEntityPath(this.withPrefix("Threshold"), () => QQuantityParameterType);
    public readonly Target = new QEntityPath(this.withPrefix("Target"), () => QQuantityParameterType);
}

export const qLinkBufferDefinitionToToolDefList = new QLinkBufferDefinitionToToolDefList();

export class QTCM2LinkProcessToOperationFullListResponse extends QCommandResponse {
}

export const qTCM2LinkProcessToOperationFullListResponse = new QTCM2LinkProcessToOperationFullListResponse();

export class QTCM2LinkProcessToOperationFullList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QTCM2LinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2LinkProcessToOperationFullList = new QTCM2LinkProcessToOperationFullList();

export class QCreateHandlingUnitHistoryResponse extends QCommandResponse {
}

export const qCreateHandlingUnitHistoryResponse = new QCreateHandlingUnitHistoryResponse();

export class QCreateHandlingUnitHistory extends QueryObject {
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
    public readonly ActionId = new QGuidPath(this.withPrefix("ActionId"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly SourceBufferNId = new QStringPath(this.withPrefix("SourceBufferNId"));
    public readonly DestinationBufferNId = new QStringPath(this.withPrefix("DestinationBufferNId"));
    public readonly TransportOperationNId = new QStringPath(this.withPrefix("TransportOperationNId"));
    public readonly MaterialItemQuantity = new QEntityPath(this.withPrefix("MaterialItemQuantity"), () => QQuantityParameterType);
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
}

export const qCreateHandlingUnitHistory = new QCreateHandlingUnitHistory();

export class QUnlinkToBeUsedMachineToPJFResponse extends QCommandResponse {
}

export const qUnlinkToBeUsedMachineToPJFResponse = new QUnlinkToBeUsedMachineToPJFResponse();

export class QUnlinkToBeUsedMachineToPJF extends QueryObject {
    public readonly ToBeUsedEquipmentConfigurationPJFList = new QCollectionPath(this.withPrefix("ToBeUsedEquipmentConfigurationPJFList"), () => QGuidCollection);
}

export const qUnlinkToBeUsedMachineToPJF = new QUnlinkToBeUsedMachineToPJF();

export class QCreateNonProductiveActivityResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNonProductiveActivityResponse = new QCreateNonProductiveActivityResponse();

export class QCreateNonProductiveActivity extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateNonProductiveActivity = new QCreateNonProductiveActivity();

export class QCompleteCheckInResponse extends QCommandResponse {
}

export const qCompleteCheckInResponse = new QCompleteCheckInResponse();

export class QCompleteCheckIn extends QueryObject {
    public readonly OfflineSessionIdFlag0 = new QBooleanPath(this.withPrefix("OfflineSessionIdFlag0"));
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
}

export const qCompleteCheckIn = new QCompleteCheckIn();

export class QUpdateOperationStepCategoryResponse extends QCommandResponse {
}

export const qUpdateOperationStepCategoryResponse = new QUpdateOperationStepCategoryResponse();

export class QUpdateOperationStepCategory extends QueryObject {
    public readonly OperationStepCategory = new QEntityPath(this.withPrefix("OperationStepCategory"), () => QOperationStepCategoryType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateOperationStepCategory = new QUpdateOperationStepCategory();

export class QLinkWIDefinitionsToEGPhaseResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qLinkWIDefinitionsToEGPhaseResponse = new QLinkWIDefinitionsToEGPhaseResponse();

export class QLinkWIDefinitionsToEGPhase extends QueryObject {
    public readonly EGPhaseId = new QGuidPath(this.withPrefix("EGPhaseId"));
    public readonly WorkInstructionDefinitionIds = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionIds"), () => QGuidCollection);
    public readonly WorkInstructionAssociationType = new QStringPath(this.withPrefix("WorkInstructionAssociationType"));
}

export const qLinkWIDefinitionsToEGPhase = new QLinkWIDefinitionsToEGPhase();

export class QUpdateCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly FailureAssociationIds = new QCollectionPath(this.withPrefix("FailureAssociationIds"), () => QGuidCollection);
}

export const qUpdateCharacteristicSpecificationResponse = new QUpdateCharacteristicSpecificationResponse();

export class QUpdateCharacteristicSpecification extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly FailureAssociations = new QEntityCollectionPath(this.withPrefix("FailureAssociations"), () => QCharacteristicFailureAssociation);
}

export const qUpdateCharacteristicSpecification = new QUpdateCharacteristicSpecification();

export class QGetWIParameterValuesResponse extends QCommandResponse {
    public readonly ParameterValueList = new QEntityCollectionPath(this.withPrefix("ParameterValueList"), () => QParameterValueParameterType);
}

export const qGetWIParameterValuesResponse = new QGetWIParameterValuesResponse();

export class QGetWIParameterValues extends QueryObject {
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly ExecutionGroupPhase_Id = new QGuidPath(this.withPrefix("ExecutionGroupPhase_Id"));
    public readonly WorkInstructionDefinition_Id = new QGuidPath(this.withPrefix("WorkInstructionDefinition_Id"));
}

export const qGetWIParameterValues = new QGetWIParameterValues();

export class QSetOperationStepCategoryProcessDefinitionActiveStatusResponse extends QCommandResponse {
}

export const qSetOperationStepCategoryProcessDefinitionActiveStatusResponse = new QSetOperationStepCategoryProcessDefinitionActiveStatusResponse();

export class QSetOperationStepCategoryProcessDefinitionActiveStatus extends QueryObject {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
    public readonly Active = new QBooleanPath(this.withPrefix("Active"));
}

export const qSetOperationStepCategoryProcessDefinitionActiveStatus = new QSetOperationStepCategoryProcessDefinitionActiveStatus();

export class QCreateToBeConsumedMaterialsResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
    public readonly CreatedToBeConsumedMaterials = new QEntityCollectionPath(this.withPrefix("CreatedToBeConsumedMaterials"), () => QToBeConsumedMaterialInfo);
}

export const qCreateToBeConsumedMaterialsResponse = new QCreateToBeConsumedMaterialsResponse();

export class QCreateToBeConsumedMaterials extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ToBeConsumedMaterials = new QEntityCollectionPath(this.withPrefix("ToBeConsumedMaterials"), () => QToBeConsumedMaterialParameter);
}

export const qCreateToBeConsumedMaterials = new QCreateToBeConsumedMaterials();

export class QDeleteActualProducedMaterialResponse extends QCommandResponse {
}

export const qDeleteActualProducedMaterialResponse = new QDeleteActualProducedMaterialResponse();

export class QDeleteActualProducedMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteActualProducedMaterial = new QDeleteActualProducedMaterial();

export class QUnlinkProcessToAsPlannedBOPResponse extends QCommandResponse {
}

export const qUnlinkProcessToAsPlannedBOPResponse = new QUnlinkProcessToAsPlannedBOPResponse();

export class QUnlinkProcessToAsPlannedBOP extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUnlinkProcessToAsPlannedBOP = new QUnlinkProcessToAsPlannedBOP();

export class QUADMCreateOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateOperationResponse = new QUADMCreateOperationResponse();

export class QUADMCreateOperation extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly CreateDependency = new QBooleanPath(this.withPrefix("CreateDependency"));
    public readonly DependencyType = new QGuidPath(this.withPrefix("DependencyType"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly WorkOperationId = new QGuidPath(this.withPrefix("WorkOperationId"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly PredecessorId = new QGuidPath(this.withPrefix("PredecessorId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly RevisionEffectivityExpression = new QStringPath(this.withPrefix("RevisionEffectivityExpression"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qUADMCreateOperation = new QUADMCreateOperation();

export class QUnlinkSkillsFromWOOperationResponse extends QCommandResponse {
}

export const qUnlinkSkillsFromWOOperationResponse = new QUnlinkSkillsFromWOOperationResponse();

export class QUnlinkSkillsFromWOOperation extends QueryObject {
    public readonly WOOperationSkillIds = new QCollectionPath(this.withPrefix("WOOperationSkillIds"), () => QGuidCollection);
}

export const qUnlinkSkillsFromWOOperation = new QUnlinkSkillsFromWOOperation();

export class QDeleteMachineToDNCResponse extends QCommandResponse {
}

export const qDeleteMachineToDNCResponse = new QDeleteMachineToDNCResponse();

export class QDeleteMachineToDNC extends QueryObject {
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
}

export const qDeleteMachineToDNC = new QDeleteMachineToDNC();

export class QDeleteResultsFromWOOperationsResponse extends QCommandResponse {
}

export const qDeleteResultsFromWOOperationsResponse = new QDeleteResultsFromWOOperationsResponse();

export class QDeleteResultsFromWOOperations extends QueryObject {
    public readonly WorkOrderOperationNIdList = new QCollectionPath(this.withPrefix("WorkOrderOperationNIdList"), () => QStringCollection);
}

export const qDeleteResultsFromWOOperations = new QDeleteResultsFromWOOperations();

export class QCreateNewProcessRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewProcessRevisionResponse = new QCreateNewProcessRevisionResponse();

export class QCreateNewProcessRevision extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ParentProcessId = new QGuidPath(this.withPrefix("ParentProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly TargetProcessId = new QGuidPath(this.withPrefix("TargetProcessId"));
}

export const qCreateNewProcessRevision = new QCreateNewProcessRevision();

export class QCheckIdTemplateEditingResponse extends QCommandResponse {
    public readonly Editing = new QBooleanPath(this.withPrefix("Editing"));
}

export const qCheckIdTemplateEditingResponse = new QCheckIdTemplateEditingResponse();

export class QCheckIdTemplateEditing extends QueryObject {
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qCheckIdTemplateEditing = new QCheckIdTemplateEditing();

export class QTCM2CompleteAsPlannedBOPResponse extends QCommandResponse {
}

export const qTCM2CompleteAsPlannedBOPResponse = new QTCM2CompleteAsPlannedBOPResponse();

export class QTCM2CompleteAsPlannedBOP extends QueryObject {
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CompleteAsPlannedBOP = new QTCM2CompleteAsPlannedBOP();

export class QCreateCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateCharacteristicSpecificationResponse = new QCreateCharacteristicSpecificationResponse();

export class QCreateCharacteristicSpecification extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly Type = new QEnumPath(this.withPrefix("Type"), CharacteristicType);
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qCreateCharacteristicSpecification = new QCreateCharacteristicSpecification();

export class QConfirmWorkOrderOperationResponse extends QCommandResponse {
}

export const qConfirmWorkOrderOperationResponse = new QConfirmWorkOrderOperationResponse();

export class QConfirmWorkOrderOperation extends QueryObject {
    public readonly ERPOrderID = new QStringPath(this.withPrefix("ERPOrderID"));
    public readonly operationId = new QStringPath(this.withPrefix("operationId"));
    public readonly PlantID = new QStringPath(this.withPrefix("PlantID"));
    public readonly confirmationId = new QStringPath(this.withPrefix("confirmationId"));
    public readonly EventId = new QGuidPath(this.withPrefix("EventId"));
    public readonly completion = new QBooleanPath(this.withPrefix("completion"));
    public readonly FastOperationConfirmation = new QBooleanPath(this.withPrefix("FastOperationConfirmation"));
}

export const qConfirmWorkOrderOperation = new QConfirmWorkOrderOperation();

export class QDeleteEquipmentTypeStateMachineResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypeStateMachineResponse = new QDeleteEquipmentTypeStateMachineResponse();

export class QDeleteEquipmentTypeStateMachine extends QueryObject {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
    public readonly EquipmentTypeStateMachineId = new QGuidPath(this.withPrefix("EquipmentTypeStateMachineId"));
}

export const qDeleteEquipmentTypeStateMachine = new QDeleteEquipmentTypeStateMachine();

export class QCreateBufferDefinitionRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateBufferDefinitionRevisionResponse = new QCreateBufferDefinitionRevisionResponse();

export class QCreateBufferDefinitionRevision extends QueryObject {
    public readonly OriginalBufferId = new QGuidPath(this.withPrefix("OriginalBufferId"));
}

export const qCreateBufferDefinitionRevision = new QCreateBufferDefinitionRevision();

export class QDNCPreviewDNCItemResponse extends QCommandResponse {
    public readonly DNCPreview = new QBinaryPath(this.withPrefix("DNCPreview"));
}

export const qDNCPreviewDNCItemResponse = new QDNCPreviewDNCItemResponse();

export class QDNCPreviewDNCItem extends QueryObject {
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
}

export const qDNCPreviewDNCItem = new QDNCPreviewDNCItem();

export class QReopenWorkOrderOperationListResponse extends QCommandResponse {
    public readonly WorkOrderOperationIdentifiers = new QEntityPath(this.withPrefix("WorkOrderOperationIdentifiers"), () => QIdentifiersParameterType);
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QIdentifiersParameterType);
}

export const qReopenWorkOrderOperationListResponse = new QReopenWorkOrderOperationListResponse();

export class QReopenWorkOrderOperationList extends QueryObject {
    public readonly WorkOrderIdentifiers = new QEntityPath(this.withPrefix("WorkOrderIdentifiers"), () => QIdentifiersParameterType);
    public readonly WorkOrderOperationIdentifiersList = new QEntityCollectionPath(this.withPrefix("WorkOrderOperationIdentifiersList"), () => QIdentifiersParameterType);
}

export const qReopenWorkOrderOperationList = new QReopenWorkOrderOperationList();

export class QManageNullResultOnKoWorkOrderOperationResponse extends QCommandResponse {
}

export const qManageNullResultOnKoWorkOrderOperationResponse = new QManageNullResultOnKoWorkOrderOperationResponse();

export class QManageNullResultOnKoWorkOrderOperation extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MaterialTrackingUnitWithResultList = new QEntityCollectionPath(this.withPrefix("DM_MaterialTrackingUnitWithResultList"), () => QCompletedMTUParameterType);
    public readonly AutomaticEquipmentNId = new QStringPath(this.withPrefix("AutomaticEquipmentNId"));
}

export const qManageNullResultOnKoWorkOrderOperation = new QManageNullResultOnKoWorkOrderOperation();

export class QExecuteCustomItlkCheckInboundResponse extends QCommandResponse {
    public readonly CustomItlkCheckOutputList = new QEntityCollectionPath(this.withPrefix("CustomItlkCheckOutputList"), () => QItlkCheckOrchestratorOutputParameterType);
}

export const qExecuteCustomItlkCheckInboundResponse = new QExecuteCustomItlkCheckInboundResponse();

export class QExecuteCustomItlkCheckInbound extends QueryObject {
    public readonly CustomItlkCheckInputList = new QEntityCollectionPath(this.withPrefix("CustomItlkCheckInputList"), () => QItlkCheckOrchestratorInputParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly DM_MTUList = new QEntityCollectionPath(this.withPrefix("DM_MTUList"), () => QItlkCheckDM_MTUParameterType);
    public readonly IsAutomatic = new QBooleanPath(this.withPrefix("IsAutomatic"));
    public readonly ItlkCheckSessionId = new QGuidPath(this.withPrefix("ItlkCheckSessionId"));
}

export const qExecuteCustomItlkCheckInbound = new QExecuteCustomItlkCheckInbound();

export class QUnlinkProcessToProcessResponse extends QCommandResponse {
}

export const qUnlinkProcessToProcessResponse = new QUnlinkProcessToProcessResponse();

export class QUnlinkProcessToProcess extends QueryObject {
    public readonly FromProcessId = new QGuidPath(this.withPrefix("FromProcessId"));
    public readonly ToProcessId = new QGuidPath(this.withPrefix("ToProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
}

export const qUnlinkProcessToProcess = new QUnlinkProcessToProcess();

export class QUnLinkMaterialItemFromBufferResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnLinkMaterialItemFromBufferResponse = new QUnLinkMaterialItemFromBufferResponse();

export class QUnLinkMaterialItemFromBuffer extends QueryObject {
    public readonly BufferId = new QGuidPath(this.withPrefix("BufferId"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly FromPage = new QStringPath(this.withPrefix("FromPage"));
    public readonly MTUQtyToUnlink = new QEntityCollectionPath(this.withPrefix("MTUQtyToUnlink"), () => QToUnlinkQtyParameterType);
}

export const qUnLinkMaterialItemFromBuffer = new QUnLinkMaterialItemFromBuffer();

export class QLinkItlkCheckToWorkOrderStepListResponse extends QCommandResponse {
    public readonly ItlkCheckWOStepIdList = new QCollectionPath(this.withPrefix("ItlkCheckWOStepIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qLinkItlkCheckToWorkOrderStepListResponse = new QLinkItlkCheckToWorkOrderStepListResponse();

export class QLinkItlkCheckToWorkOrderStepList extends QueryObject {
    public readonly ItlkCheckWOStepList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepList"), () => QItlkCheckWOStepAssociationParameterType);
}

export const qLinkItlkCheckToWorkOrderStepList = new QLinkItlkCheckToWorkOrderStepList();

export class QLinkSkillsToStepResponse extends QCommandResponse {
}

export const qLinkSkillsToStepResponse = new QLinkSkillsToStepResponse();

export class QLinkSkillsToStep extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly SkillIds = new QCollectionPath(this.withPrefix("SkillIds"), () => QGuidCollection);
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qLinkSkillsToStep = new QLinkSkillsToStep();

export class QAmendOfflineActionResponse extends QCommandResponse {
}

export const qAmendOfflineActionResponse = new QAmendOfflineActionResponse();

export class QAmendOfflineAction extends QueryObject {
    public readonly CommandPayload = new QBinaryPath(this.withPrefix("CommandPayload"));
    public readonly ActionId = new QGuidPath(this.withPrefix("ActionId"));
}

export const qAmendOfflineAction = new QAmendOfflineAction();

export class QUpdateEquipmentTypeResponse extends QCommandResponse {
    public readonly PropertyIds = new QCollectionPath(this.withPrefix("PropertyIds"), () => QGuidCollection);
}

export const qUpdateEquipmentTypeResponse = new QUpdateEquipmentTypeResponse();

export class QUpdateEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyParameterType);
}

export const qUpdateEquipmentType = new QUpdateEquipmentType();

export class QTCM2LinkProcessToProcessFullListResponse extends QCommandResponse {
}

export const qTCM2LinkProcessToProcessFullListResponse = new QTCM2LinkProcessToProcessFullListResponse();

export class QTCM2LinkProcessToProcessFullList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QTCM2LinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2LinkProcessToProcessFullList = new QTCM2LinkProcessToProcessFullList();

export class QUpdateNonProductiveActivityResponse extends QCommandResponse {
}

export const qUpdateNonProductiveActivityResponse = new QUpdateNonProductiveActivityResponse();

export class QUpdateNonProductiveActivity extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateNonProductiveActivity = new QUpdateNonProductiveActivity();

export class QLinkAutomationNodeInstanceParameterToToolDefinitionParameterListResponse extends QCommandResponse {
}

export const qLinkAutomationNodeInstanceParameterToToolDefinitionParameterListResponse = new QLinkAutomationNodeInstanceParameterToToolDefinitionParameterListResponse();

export class QLinkAutomationNodeInstanceParameterToToolDefinitionParameterList extends QueryObject {
    public readonly ATNInstanceParameter = new QEntityPath(this.withPrefix("ATNInstanceParameter"), () => QATNInstanceParameterType);
    public readonly ToolDefinitionIdentifierList = new QCollectionPath(this.withPrefix("ToolDefinitionIdentifierList"), () => QGuidCollection);
    public readonly ToolDefinitionParameterNId = new QStringPath(this.withPrefix("ToolDefinitionParameterNId"));
}

export const qLinkAutomationNodeInstanceParameterToToolDefinitionParameterList = new QLinkAutomationNodeInstanceParameterToToolDefinitionParameterList();

export class QLinkToolDefinitionToAutomationNodeTypeListResponse extends QCommandResponse {
}

export const qLinkToolDefinitionToAutomationNodeTypeListResponse = new QLinkToolDefinitionToAutomationNodeTypeListResponse();

export class QLinkToolDefinitionToAutomationNodeTypeList extends QueryObject {
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly AutomationNodeTypeNIdList = new QCollectionPath(this.withPrefix("AutomationNodeTypeNIdList"), () => QStringCollection);
}

export const qLinkToolDefinitionToAutomationNodeTypeList = new QLinkToolDefinitionToAutomationNodeTypeList();

export class QCreateMaterialDefinitionDocumentListResponse extends QCommandResponse {
}

export const qCreateMaterialDefinitionDocumentListResponse = new QCreateMaterialDefinitionDocumentListResponse();

export class QCreateMaterialDefinitionDocumentList extends QueryObject {
    public readonly MaterialDefinitionDocumentList = new QEntityCollectionPath(this.withPrefix("MaterialDefinitionDocumentList"), () => QMaterialDefinitionDocumentParameterType);
}

export const qCreateMaterialDefinitionDocumentList = new QCreateMaterialDefinitionDocumentList();

export class QUnlinkItlkCheckToWorkOrderOperationListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnlinkItlkCheckToWorkOrderOperationListResponse = new QUnlinkItlkCheckToWorkOrderOperationListResponse();

export class QUnlinkItlkCheckToWorkOrderOperationList extends QueryObject {
    public readonly ItlkCheckWOOpAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkItlkCheckToWorkOrderOperationList = new QUnlinkItlkCheckToWorkOrderOperationList();

export class QSetWorkInstructionTemplateAsDefaultResponse extends QCommandResponse {
}

export const qSetWorkInstructionTemplateAsDefaultResponse = new QSetWorkInstructionTemplateAsDefaultResponse();

export class QSetWorkInstructionTemplateAsDefault extends QueryObject {
    public readonly IdFlag0 = new QBooleanPath(this.withPrefix("IdFlag0"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSetWorkInstructionTemplateAsDefault = new QSetWorkInstructionTemplateAsDefault();

export class QSetNonConformanceStatusIsClosedOkResponse extends QCommandResponse {
}

export const qSetNonConformanceStatusIsClosedOkResponse = new QSetNonConformanceStatusIsClosedOkResponse();

export class QSetNonConformanceStatusIsClosedOk extends QueryObject {
    public readonly NonConformanceLifecycleId = new QGuidPath(this.withPrefix("NonConformanceLifecycleId"));
    public readonly NonConformanceStatusId = new QGuidPath(this.withPrefix("NonConformanceStatusId"));
    public readonly IsClosedOk = new QBooleanPath(this.withPrefix("IsClosedOk"));
}

export const qSetNonConformanceStatusIsClosedOk = new QSetNonConformanceStatusIsClosedOk();

export class QUnlinkToolToSetPointResponse extends QCommandResponse {
}

export const qUnlinkToolToSetPointResponse = new QUnlinkToolToSetPointResponse();

export class QUnlinkToolToSetPoint extends QueryObject {
    public readonly SetPointToolAssociationList = new QCollectionPath(this.withPrefix("SetPointToolAssociationList"), () => QGuidCollection);
}

export const qUnlinkToolToSetPoint = new QUnlinkToolToSetPoint();

export class QRemoveDefectGroupContextualizationResponse extends QCommandResponse {
}

export const qRemoveDefectGroupContextualizationResponse = new QRemoveDefectGroupContextualizationResponse();

export class QRemoveDefectGroupContextualization extends QueryObject {
    public readonly DefectGroupId = new QGuidPath(this.withPrefix("DefectGroupId"));
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
    public readonly EquipmentConfigurationList = new QCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qRemoveDefectGroupContextualization = new QRemoveDefectGroupContextualization();

export class QManageResultsForSkippedOperationsResponse extends QCommandResponse {
}

export const qManageResultsForSkippedOperationsResponse = new QManageResultsForSkippedOperationsResponse();

export class QManageResultsForSkippedOperations extends QueryObject {
    public readonly WorkOrderOperationAndMTUsToSkip = new QEntityPath(this.withPrefix("WorkOrderOperationAndMTUsToSkip"), () => QWorkOrderOperationAndMTUsToSkipType);
    public readonly DM_MTUsWithKOList = new QCollectionPath(this.withPrefix("DM_MTUsWithKOList"), () => QGuidCollection);
    public readonly ProductionType = new QStringPath(this.withPrefix("ProductionType"));
}

export const qManageResultsForSkippedOperations = new QManageResultsForSkippedOperations();

export class QManageRepeatOfKoWorkOrderOperationResponse extends QCommandResponse {
}

export const qManageRepeatOfKoWorkOrderOperationResponse = new QManageRepeatOfKoWorkOrderOperationResponse();

export class QManageRepeatOfKoWorkOrderOperation extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUWithResultList = new QEntityCollectionPath(this.withPrefix("DM_MTUWithResultList"), () => QDMMTUWithResultParameterType);
    public readonly ProductionType = new QEnumPath(this.withPrefix("ProductionType"), ProductionTypeEnum);
}

export const qManageRepeatOfKoWorkOrderOperation = new QManageRepeatOfKoWorkOrderOperation();

export class QConsumeMaterialItemLiteResponse extends QCommandResponse {
    public readonly ActualConsumedMaterialId = new QGuidPath(this.withPrefix("ActualConsumedMaterialId"));
}

export const qConsumeMaterialItemLiteResponse = new QConsumeMaterialItemLiteResponse();

export class QConsumeMaterialItemLite extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly ProducedDMMaterialTrackingUnitId = new QGuidPath(this.withPrefix("ProducedDMMaterialTrackingUnitId"));
    public readonly ToBeConsumedDmMaterialId = new QGuidPath(this.withPrefix("ToBeConsumedDmMaterialId"));
    public readonly ToBeConsumedCode = new QStringPath(this.withPrefix("ToBeConsumedCode"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ToBeConsumedQuantity = new QNumberPath(this.withPrefix("ToBeConsumedQuantity"));
    public readonly ApplySNUniquenessCheckByMaterial = new QBooleanPath(this.withPrefix("ApplySNUniquenessCheckByMaterial"));
    public readonly SkipActivityValidation = new QBooleanPath(this.withPrefix("SkipActivityValidation"));
}

export const qConsumeMaterialItemLite = new QConsumeMaterialItemLite();

export class QCreateCertificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateCertificationResponse = new QCreateCertificationResponse();

export class QCreateCertification extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateCertification = new QCreateCertification();

export class QCheckCertificationResponse extends QCommandResponse {
    public readonly NIds = new QCollectionPath(this.withPrefix("NIds"), () => QStringCollection);
}

export const qCheckCertificationResponse = new QCheckCertificationResponse();

export class QCheckCertification extends QueryObject {
    public readonly CheckCertificationParameter = new QEntityCollectionPath(this.withPrefix("CheckCertificationParameter"), () => QCheckCertificationParameterType);
}

export const qCheckCertification = new QCheckCertification();

export class QCreateTransportOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateTransportOperationResponse = new QCreateTransportOperationResponse();

export class QCreateTransportOperation extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly LogisticRequestId = new QGuidPath(this.withPrefix("LogisticRequestId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly BufferSourceList = new QEntityCollectionPath(this.withPrefix("BufferSourceList"), () => QBufferWithPriority);
    public readonly BufferDestinationList = new QEntityCollectionPath(this.withPrefix("BufferDestinationList"), () => QBufferWithPriority);
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly RoleId = new QStringPath(this.withPrefix("RoleId"));
    public readonly LogisticRequestItemId = new QGuidPath(this.withPrefix("LogisticRequestItemId"));
}

export const qCreateTransportOperation = new QCreateTransportOperation();

export class QUpdateToolDefinitionResponse extends QCommandResponse {
}

export const qUpdateToolDefinitionResponse = new QUpdateToolDefinitionResponse();

export class QUpdateToolDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SubstrateDefinitionProperties = new QEntityPath(this.withPrefix("SubstrateDefinitionProperties"), () => QSubstrateDefinitionPropertiesParameterType);
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly LogisticParameter = new QEntityPath(this.withPrefix("LogisticParameter"), () => QLogisticParameterType);
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
}

export const qUpdateToolDefinition = new QUpdateToolDefinition();

export class QCreateWorkOrderStepFromMPProcessStepResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderStepFromMPProcessStepResponse = new QCreateWorkOrderStepFromMPProcessStepResponse();

export class QCreateWorkOrderStepFromMPProcessStep extends QueryObject {
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly SkipMaterialsCreation = new QBooleanPath(this.withPrefix("SkipMaterialsCreation"));
}

export const qCreateWorkOrderStepFromMPProcessStep = new QCreateWorkOrderStepFromMPProcessStep();

export class QManageResultWorkOrderOperationNIdForSplitWorkOrderResponse extends QCommandResponse {
}

export const qManageResultWorkOrderOperationNIdForSplitWorkOrderResponse = new QManageResultWorkOrderOperationNIdForSplitWorkOrderResponse();

export class QManageResultWorkOrderOperationNIdForSplitWorkOrder extends QueryObject {
    public readonly WorkOrderOperationPairIdList = new QEntityCollectionPath(this.withPrefix("WorkOrderOperationPairIdList"), () => QWorkOrderOperationPairParameterType);
    public readonly SplitType = new QStringPath(this.withPrefix("SplitType"));
    public readonly ParentWorkOrderId = new QGuidPath(this.withPrefix("ParentWorkOrderId"));
    public readonly NewWorkOrderList = new QEntityCollectionPath(this.withPrefix("NewWorkOrderList"), () => QWorkOrderIdentifiersParameterType);
}

export const qManageResultWorkOrderOperationNIdForSplitWorkOrder = new QManageResultWorkOrderOperationNIdForSplitWorkOrder();

export class QAmendOfResultToRepeatMaterialConsumptionResponse extends QCommandResponse {
}

export const qAmendOfResultToRepeatMaterialConsumptionResponse = new QAmendOfResultToRepeatMaterialConsumptionResponse();

export class QAmendOfResultToRepeatMaterialConsumption extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUWithResultList = new QEntityCollectionPath(this.withPrefix("DM_MTUWithResultList"), () => QDMMTUWithResultParameterType);
    public readonly ProductionType = new QEnumPath(this.withPrefix("ProductionType"), ProductionTypeEnum);
}

export const qAmendOfResultToRepeatMaterialConsumption = new QAmendOfResultToRepeatMaterialConsumption();

export class QUnlinkWorkInstructionDefinitionListFromOperationResponse extends QCommandResponse {
}

export const qUnlinkWorkInstructionDefinitionListFromOperationResponse = new QUnlinkWorkInstructionDefinitionListFromOperationResponse();

export class QUnlinkWorkInstructionDefinitionListFromOperation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly WorkInstructionDefinitionList = new QCollectionPath(this.withPrefix("WorkInstructionDefinitionList"), () => QGuidCollection);
    public readonly StopPropagationToProcessOp = new QBooleanPath(this.withPrefix("StopPropagationToProcessOp"));
}

export const qUnlinkWorkInstructionDefinitionListFromOperation = new QUnlinkWorkInstructionDefinitionListFromOperation();

export class QCreateToolSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateToolSpecificationResponse = new QCreateToolSpecificationResponse();

export class QCreateToolSpecification extends QueryObject {
    public readonly ToolSpecification = new QEntityPath(this.withPrefix("ToolSpecification"), () => QToolSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qCreateToolSpecification = new QCreateToolSpecification();

export class QDeleteToBeUsedDocumentResponse extends QCommandResponse {
}

export const qDeleteToBeUsedDocumentResponse = new QDeleteToBeUsedDocumentResponse();

export class QDeleteToBeUsedDocument extends QueryObject {
    public readonly ToBeUsedDocumentId = new QGuidPath(this.withPrefix("ToBeUsedDocumentId"));
}

export const qDeleteToBeUsedDocument = new QDeleteToBeUsedDocument();

export class QRemoveCertificationToLocationListResponse extends QCommandResponse {
}

export const qRemoveCertificationToLocationListResponse = new QRemoveCertificationToLocationListResponse();

export class QRemoveCertificationToLocationList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly LocationNIds = new QCollectionPath(this.withPrefix("LocationNIds"), () => QStringCollection);
    public readonly EquipmentType = new QStringPath(this.withPrefix("EquipmentType"));
}

export const qRemoveCertificationToLocationList = new QRemoveCertificationToLocationList();

export class QCreateExecutionGroupPhaseResponse extends QCommandResponse {
}

export const qCreateExecutionGroupPhaseResponse = new QCreateExecutionGroupPhaseResponse();

export class QCreateExecutionGroupPhase extends QueryObject {
    public readonly ExecutionGroupPhaseDetails = new QEntityCollectionPath(this.withPrefix("ExecutionGroupPhaseDetails"), () => QExecutionGroupPhaseParameterType);
}

export const qCreateExecutionGroupPhase = new QCreateExecutionGroupPhase();

export class QUnlinkATNTypeParameterFromToolDefinitionSetPointItemListResponse extends QCommandResponse {
}

export const qUnlinkATNTypeParameterFromToolDefinitionSetPointItemListResponse = new QUnlinkATNTypeParameterFromToolDefinitionSetPointItemListResponse();

export class QUnlinkATNTypeParameterFromToolDefinitionSetPointItemList extends QueryObject {
    public readonly SetPointItemToolDefinitionATNTypeParameterAssociationIds = new QCollectionPath(this.withPrefix("SetPointItemToolDefinitionATNTypeParameterAssociationIds"), () => QGuidCollection);
}

export const qUnlinkATNTypeParameterFromToolDefinitionSetPointItemList = new QUnlinkATNTypeParameterFromToolDefinitionSetPointItemList();

export class QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnitResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnitResponse = new QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnitResponse();

export class QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusTypeParameterType);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly ActiveNonConformanceNumber = new QNumberPath(this.withPrefix("ActiveNonConformanceNumber"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly HistoryAction = new QStringPath(this.withPrefix("HistoryAction"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly IsCalledFromSplitOfMTU = new QBooleanPath(this.withPrefix("IsCalledFromSplitOfMTU"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
}

export const qUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit = new QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit();

export class QUnlinkToolSpecificationToOperationResponse extends QCommandResponse {
}

export const qUnlinkToolSpecificationToOperationResponse = new QUnlinkToolSpecificationToOperationResponse();

export class QUnlinkToolSpecificationToOperation extends QueryObject {
    public readonly ToolSpecificationId = new QGuidPath(this.withPrefix("ToolSpecificationId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qUnlinkToolSpecificationToOperation = new QUnlinkToolSpecificationToOperation();

export class QUnlinkToBeUsedMachineToPJFFromLogicalKeyResponse extends QCommandResponse {
}

export const qUnlinkToBeUsedMachineToPJFFromLogicalKeyResponse = new QUnlinkToBeUsedMachineToPJFFromLogicalKeyResponse();

export class QUnlinkToBeUsedMachineToPJFFromLogicalKey extends QueryObject {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
    public readonly PrintJobFileId = new QGuidPath(this.withPrefix("PrintJobFileId"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
}

export const qUnlinkToBeUsedMachineToPJFFromLogicalKey = new QUnlinkToBeUsedMachineToPJFFromLogicalKey();

export class QPunchOutUsersResponse extends QCommandResponse {
}

export const qPunchOutUsersResponse = new QPunchOutUsersResponse();

export class QPunchOutUsers extends QueryObject {
    public readonly Users = new QCollectionPath(this.withPrefix("Users"), () => QStringCollection);
}

export const qPunchOutUsers = new QPunchOutUsers();

export class QSetWorkOrderOperationEstimatedTimesResponse extends QCommandResponse {
}

export const qSetWorkOrderOperationEstimatedTimesResponse = new QSetWorkOrderOperationEstimatedTimesResponse();

export class QSetWorkOrderOperationEstimatedTimes extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
}

export const qSetWorkOrderOperationEstimatedTimes = new QSetWorkOrderOperationEstimatedTimes();

export class QDeletePrintJobFileListResponse extends QCommandResponse {
}

export const qDeletePrintJobFileListResponse = new QDeletePrintJobFileListResponse();

export class QDeletePrintJobFileList extends QueryObject {
    public readonly PrintJobFileList = new QCollectionPath(this.withPrefix("PrintJobFileList"), () => QGuidCollection);
}

export const qDeletePrintJobFileList = new QDeletePrintJobFileList();

export class QDeleteContainerTypeListResponse extends QCommandResponse {
}

export const qDeleteContainerTypeListResponse = new QDeleteContainerTypeListResponse();

export class QDeleteContainerTypeList extends QueryObject {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qDeleteContainerTypeList = new QDeleteContainerTypeList();

export class QLinkActualUsedMachineToPJFResponse extends QCommandResponse {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qLinkActualUsedMachineToPJFResponse = new QLinkActualUsedMachineToPJFResponse();

export class QLinkActualUsedMachineToPJF extends QueryObject {
    public readonly ActualUsedMachineId = new QGuidPath(this.withPrefix("ActualUsedMachineId"));
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
    public readonly EG_PhaseId = new QGuidPath(this.withPrefix("EG_PhaseId"));
}

export const qLinkActualUsedMachineToPJF = new QLinkActualUsedMachineToPJF();

export class QGetValidMachinesWOOpIdsResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
    public readonly WOOpWithValidMachineIdList = new QCollectionPath(this.withPrefix("WOOpWithValidMachineIdList"), () => QGuidCollection);
}

export const qGetValidMachinesWOOpIdsResponse = new QGetValidMachinesWOOpIdsResponse();

export class QGetValidMachinesWOOpIds extends QueryObject {
    public readonly GetValidMachineInputParameter = new QEntityCollectionPath(this.withPrefix("GetValidMachineInputParameter"), () => QGetValidMachineWOOpIdsParameterType);
}

export const qGetValidMachinesWOOpIds = new QGetValidMachinesWOOpIds();

export class QSelectMTUForPartBasedInspectionResponse extends QCommandResponse {
    public readonly SelectedDM_MTUList = new QEntityCollectionPath(this.withPrefix("SelectedDM_MTUList"), () => QDM_MaterialTrackingUnitIdentifierParameterType);
}

export const qSelectMTUForPartBasedInspectionResponse = new QSelectMTUForPartBasedInspectionResponse();

export class QSelectMTUForPartBasedInspection extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUList = new QEntityCollectionPath(this.withPrefix("DM_MTUList"), () => QDM_MaterialTrackingUnitIdentifierParameterType);
    public readonly SelectionsRequired = new QNumberPath(this.withPrefix("SelectionsRequired"));
}

export const qSelectMTUForPartBasedInspection = new QSelectMTUForPartBasedInspection();

export class QCreateNonConformanceItemResponse extends QCommandResponse {
}

export const qCreateNonConformanceItemResponse = new QCreateNonConformanceItemResponse();

export class QCreateNonConformanceItem extends QueryObject {
    public readonly Equipment = new QCollectionPath(this.withPrefix("Equipment"), () => QStringCollection);
    public readonly MaterialItem = new QCollectionPath(this.withPrefix("MaterialItem"), () => QGuidCollection);
    public readonly Tool = new QCollectionPath(this.withPrefix("Tool"), () => QGuidCollection);
    public readonly NonConformance = new QGuidPath(this.withPrefix("NonConformance"));
    public readonly NonConformanceSupervisor = new QGuidPath(this.withPrefix("NonConformanceSupervisor"));
}

export const qCreateNonConformanceItem = new QCreateNonConformanceItem();

export class QCreateNonConformanceResourceResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNonConformanceResourceResponse = new QCreateNonConformanceResourceResponse();

export class QCreateNonConformanceResource extends QueryObject {
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Operation = new QStringPath(this.withPrefix("Operation"));
    public readonly ResourceId = new QStringPath(this.withPrefix("ResourceId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Resources = new QGuidPath(this.withPrefix("Resources"));
}

export const qCreateNonConformanceResource = new QCreateNonConformanceResource();

export class QEditMaterialItemsLinkedToHandlingUnitResponse extends QCommandResponse {
}

export const qEditMaterialItemsLinkedToHandlingUnitResponse = new QEditMaterialItemsLinkedToHandlingUnitResponse();

export class QEditMaterialItemsLinkedToHandlingUnit extends QueryObject {
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
    public readonly MaterialTrackingUnitIdQuantityList = new QEntityCollectionPath(this.withPrefix("MaterialTrackingUnitIdQuantityList"), () => QMaterialTrackingUnitIdQuantityParameterType);
}

export const qEditMaterialItemsLinkedToHandlingUnit = new QEditMaterialItemsLinkedToHandlingUnit();

export class QCreateDefectGroupContextualizationResponse extends QCommandResponse {
}

export const qCreateDefectGroupContextualizationResponse = new QCreateDefectGroupContextualizationResponse();

export class QCreateDefectGroupContextualization extends QueryObject {
    public readonly DefectGroup = new QGuidPath(this.withPrefix("DefectGroup"));
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
    public readonly EquipmentConfigurationList = new QCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QStringCollection);
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
}

export const qCreateDefectGroupContextualization = new QCreateDefectGroupContextualization();

export class QLinkATNTypeParameterToToolDefinitionSetPointItemListResponse extends QCommandResponse {
}

export const qLinkATNTypeParameterToToolDefinitionSetPointItemListResponse = new QLinkATNTypeParameterToToolDefinitionSetPointItemListResponse();

export class QLinkATNTypeParameterToToolDefinitionSetPointItemList extends QueryObject {
    public readonly ProcessOperationUId = new QStringPath(this.withPrefix("ProcessOperationUId"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly AutomationNodeTypeParameterNId = new QStringPath(this.withPrefix("AutomationNodeTypeParameterNId"));
    public readonly SetPointItemParameter = new QEntityCollectionPath(this.withPrefix("SetPointItemParameter"), () => QSetPointItemParameterType);
}

export const qLinkATNTypeParameterToToolDefinitionSetPointItemList = new QLinkATNTypeParameterToToolDefinitionSetPointItemList();

export class QUnlinkToolToAutomationNodeInstanceListResponse extends QCommandResponse {
}

export const qUnlinkToolToAutomationNodeInstanceListResponse = new QUnlinkToolToAutomationNodeInstanceListResponse();

export class QUnlinkToolToAutomationNodeInstanceList extends QueryObject {
    public readonly ToolATNInstanceAssociationIdList = new QCollectionPath(this.withPrefix("ToolATNInstanceAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkToolToAutomationNodeInstanceList = new QUnlinkToolToAutomationNodeInstanceList();

export class QCreateProcessRevisionSubStructureResponse extends QCommandResponse {
}

export const qCreateProcessRevisionSubStructureResponse = new QCreateProcessRevisionSubStructureResponse();

export class QCreateProcessRevisionSubStructure extends QueryObject {
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly SourceProcessId = new QGuidPath(this.withPrefix("SourceProcessId"));
    public readonly TargetProcessId = new QGuidPath(this.withPrefix("TargetProcessId"));
}

export const qCreateProcessRevisionSubStructure = new QCreateProcessRevisionSubStructure();

export class QCreateWorkOrderOperationsResponse extends QCommandResponse {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qCreateWorkOrderOperationsResponse = new QCreateWorkOrderOperationsResponse();

export class QCreateWorkOrderOperations extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperations = new QEntityCollectionPath(this.withPrefix("WorkOrderOperations"), () => QWorkOrderOperationParameter);
}

export const qCreateWorkOrderOperations = new QCreateWorkOrderOperations();

export class QCreateCustomItlkCheckListResponse extends QCommandResponse {
    public readonly ListOfItlkCheckId = new QCollectionPath(this.withPrefix("ListOfItlkCheckId"), () => QGuidCollection);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qCreateCustomItlkCheckListResponse = new QCreateCustomItlkCheckListResponse();

export class QCreateCustomItlkCheckList extends QueryObject {
    public readonly ListOfItlkCheck = new QEntityCollectionPath(this.withPrefix("ListOfItlkCheck"), () => QCustomItlkCheckParameterType);
}

export const qCreateCustomItlkCheckList = new QCreateCustomItlkCheckList();

export class QUnlinkPJFToMaterialDefinitionResponse extends QCommandResponse {
}

export const qUnlinkPJFToMaterialDefinitionResponse = new QUnlinkPJFToMaterialDefinitionResponse();

export class QUnlinkPJFToMaterialDefinition extends QueryObject {
    public readonly PrintJobFileToMaterialDefinition = new QGuidPath(this.withPrefix("PrintJobFileToMaterialDefinition"));
}

export const qUnlinkPJFToMaterialDefinition = new QUnlinkPJFToMaterialDefinition();

export class QUnlinkItlkCheckToOperationToStepLinkListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnlinkItlkCheckToOperationToStepLinkListResponse = new QUnlinkItlkCheckToOperationToStepLinkListResponse();

export class QUnlinkItlkCheckToOperationToStepLinkList extends QueryObject {
    public readonly ItlkCheckOperationToStepLinkAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkItlkCheckToOperationToStepLinkList = new QUnlinkItlkCheckToOperationToStepLinkList();

export class QUnlinkMaterialTrackingUnitFromContainerListResponse extends QCommandResponse {
}

export const qUnlinkMaterialTrackingUnitFromContainerListResponse = new QUnlinkMaterialTrackingUnitFromContainerListResponse();

export class QUnlinkMaterialTrackingUnitFromContainerList extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly MaterialTrackingUnitNIdList = new QCollectionPath(this.withPrefix("MaterialTrackingUnitNIdList"), () => QStringCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUnlinkMaterialTrackingUnitFromContainerList = new QUnlinkMaterialTrackingUnitFromContainerList();

export class QUpdateEquipmentTypePropertyAttributeResponse extends QCommandResponse {
}

export const qUpdateEquipmentTypePropertyAttributeResponse = new QUpdateEquipmentTypePropertyAttributeResponse();

export class QUpdateEquipmentTypePropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentTypePropertyAttribute = new QUpdateEquipmentTypePropertyAttribute();

export class QSetIsValidResponse extends QCommandResponse {
}

export const qSetIsValidResponse = new QSetIsValidResponse();

export class QSetIsValid extends QueryObject {
    public readonly IsValid = new QBooleanPath(this.withPrefix("IsValid"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSetIsValid = new QSetIsValid();

export class QTCM2DeleteLinkProcessToProcessListResponse extends QCommandResponse {
}

export const qTCM2DeleteLinkProcessToProcessListResponse = new QTCM2DeleteLinkProcessToProcessListResponse();

export class QTCM2DeleteLinkProcessToProcessList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qTCM2DeleteLinkProcessToProcessList = new QTCM2DeleteLinkProcessToProcessList();

export class QUnLinkMaterialItemsFromHandlingUnitResponse extends QCommandResponse {
}

export const qUnLinkMaterialItemsFromHandlingUnitResponse = new QUnLinkMaterialItemsFromHandlingUnitResponse();

export class QUnLinkMaterialItemsFromHandlingUnit extends QueryObject {
    public readonly HandlingUnitId = new QGuidPath(this.withPrefix("HandlingUnitId"));
    public readonly MaterialItemList = new QCollectionPath(this.withPrefix("MaterialItemList"), () => QGuidCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qUnLinkMaterialItemsFromHandlingUnit = new QUnLinkMaterialItemsFromHandlingUnit();

export class QCreateDM_MaterialTrackingUnitandMaterialTrackingUnitResponse extends QCommandResponse {
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly MaterialTrackingUnitId = new QGuidPath(this.withPrefix("MaterialTrackingUnitId"));
    public readonly DM_MaterialTrackingUnitHistoryIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitHistoryIdList"), () => QGuidCollection);
}

export const qCreateDM_MaterialTrackingUnitandMaterialTrackingUnitResponse = new QCreateDM_MaterialTrackingUnitandMaterialTrackingUnitResponse();

export class QCreateDM_MaterialTrackingUnitandMaterialTrackingUnit extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TemplateNId = new QStringPath(this.withPrefix("TemplateNId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly Weight = new QEntityPath(this.withPrefix("Weight"), () => QQuantityParameterType);
    public readonly Volume = new QEntityPath(this.withPrefix("Volume"), () => QQuantityParameterType);
    public readonly ActiveNonConformanceNumber = new QNumberPath(this.withPrefix("ActiveNonConformanceNumber"));
    public readonly BufferNId = new QStringPath(this.withPrefix("BufferNId"));
    public readonly AMPowderProperties = new QEntityPath(this.withPrefix("AMPowderProperties"), () => QAMPowderPropertiesParameterType);
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly ParentDM_MTUId = new QGuidPath(this.withPrefix("ParentDM_MTUId"));
    public readonly IsCalledFromSplitOfMTU = new QBooleanPath(this.withPrefix("IsCalledFromSplitOfMTU"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
}

export const qCreateDM_MaterialTrackingUnitandMaterialTrackingUnit = new QCreateDM_MaterialTrackingUnitandMaterialTrackingUnit();

export class QChangeSubstrateStatusByThresholdsResponse extends QCommandResponse {
    public readonly NewStatus = new QStringPath(this.withPrefix("NewStatus"));
}

export const qChangeSubstrateStatusByThresholdsResponse = new QChangeSubstrateStatusByThresholdsResponse();

export class QChangeSubstrateStatusByThresholds extends QueryObject {
    public readonly SubstrateNId = new QStringPath(this.withPrefix("SubstrateNId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly SubstrateDetails = new QEntityPath(this.withPrefix("SubstrateDetails"), () => QSubstratePropertiesParameterType);
}

export const qChangeSubstrateStatusByThresholds = new QChangeSubstrateStatusByThresholds();

export class QDeleteMaterialGroupResponse extends QCommandResponse {
}

export const qDeleteMaterialGroupResponse = new QDeleteMaterialGroupResponse();

export class QDeleteMaterialGroup extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteMaterialGroup = new QDeleteMaterialGroup();

export class QUseToolListOnContainerResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUseToolListOnContainerResponse = new QUseToolListOnContainerResponse();

export class QUseToolListOnContainer extends QueryObject {
    public readonly ToolToBeUsedList = new QEntityCollectionPath(this.withPrefix("ToolToBeUsedList"), () => QToolToBeUsedOnContainerParameterType);
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
}

export const qUseToolListOnContainer = new QUseToolListOnContainer();

export class QCreateProcessToOpLinkDependencyNavigationListResponse extends QCommandResponse {
}

export const qCreateProcessToOpLinkDependencyNavigationListResponse = new QCreateProcessToOpLinkDependencyNavigationListResponse();

export class QCreateProcessToOpLinkDependencyNavigationList extends QueryObject {
    public readonly ProcessToOpLinkDependecyNavigation = new QEntityCollectionPath(this.withPrefix("ProcessToOpLinkDependecyNavigation"), () => QDependencyNavigationParameterType);
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
}

export const qCreateProcessToOpLinkDependencyNavigationList = new QCreateProcessToOpLinkDependencyNavigationList();

export class QDeactivateMaterialTrackingUnitOnScrewingToolResponse extends QCommandResponse {
}

export const qDeactivateMaterialTrackingUnitOnScrewingToolResponse = new QDeactivateMaterialTrackingUnitOnScrewingToolResponse();

export class QDeactivateMaterialTrackingUnitOnScrewingTool extends QueryObject {
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly ToBeUsedToolId = new QGuidPath(this.withPrefix("ToBeUsedToolId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qDeactivateMaterialTrackingUnitOnScrewingTool = new QDeactivateMaterialTrackingUnitOnScrewingTool();

export class QCreateNewOperationRevisionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewOperationRevisionResponse = new QCreateNewOperationRevisionResponse();

export class QCreateNewOperationRevision extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly TargetOperationId = new QGuidPath(this.withPrefix("TargetOperationId"));
}

export const qCreateNewOperationRevision = new QCreateNewOperationRevision();

export class QDeleteWorkOrderStepResponse extends QCommandResponse {
}

export const qDeleteWorkOrderStepResponse = new QDeleteWorkOrderStepResponse();

export class QDeleteWorkOrderStep extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteWorkOrderStep = new QDeleteWorkOrderStep();

export class QDeleteExecutionGroupsResponse extends QCommandResponse {
}

export const qDeleteExecutionGroupsResponse = new QDeleteExecutionGroupsResponse();

export class QDeleteExecutionGroups extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteExecutionGroups = new QDeleteExecutionGroups();

export class QRemoveLocationHoldResponse extends QCommandResponse {
}

export const qRemoveLocationHoldResponse = new QRemoveLocationHoldResponse();

export class QRemoveLocationHold extends QueryObject {
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly HoldId = new QGuidPath(this.withPrefix("HoldId"));
}

export const qRemoveLocationHold = new QRemoveLocationHold();

export class QUnlinkProcessToProcessListResponse extends QCommandResponse {
}

export const qUnlinkProcessToProcessListResponse = new QUnlinkProcessToProcessListResponse();

export class QUnlinkProcessToProcessList extends QueryObject {
    public readonly Links = new QEntityCollectionPath(this.withPrefix("Links"), () => QLinkParameterType);
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
}

export const qUnlinkProcessToProcessList = new QUnlinkProcessToProcessList();

export class QUpdateEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qUpdateEquipmentGroupConfigurationResponse = new QUpdateEquipmentGroupConfigurationResponse();

export class QUpdateEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
}

export const qUpdateEquipmentGroupConfiguration = new QUpdateEquipmentGroupConfiguration();

export class QUpdateWorkInstructionTemplateResponse extends QCommandResponse {
    public readonly ParameterIds = new QCollectionPath(this.withPrefix("ParameterIds"), () => QGuidCollection);
}

export const qUpdateWorkInstructionTemplateResponse = new QUpdateWorkInstructionTemplateResponse();

export class QUpdateWorkInstructionTemplate extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Parameters = new QEntityCollectionPath(this.withPrefix("Parameters"), () => QWorkInstructionDefinitionParameterParameterType);
}

export const qUpdateWorkInstructionTemplate = new QUpdateWorkInstructionTemplate();

export class QUADMCreateOperationInCatalogueResponse extends QCommandResponse {
}

export const qUADMCreateOperationInCatalogueResponse = new QUADMCreateOperationInCatalogueResponse();

export class QUADMCreateOperationInCatalogue extends QueryObject {
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
    public readonly WorkOperationTypeNId = new QStringPath(this.withPrefix("WorkOperationTypeNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
}

export const qUADMCreateOperationInCatalogue = new QUADMCreateOperationInCatalogue();

export class QUnLinkEquipmentsToBuffersResponse extends QCommandResponse {
}

export const qUnLinkEquipmentsToBuffersResponse = new QUnLinkEquipmentsToBuffersResponse();

export class QUnLinkEquipmentsToBuffers extends QueryObject {
    public readonly BufferIds = new QCollectionPath(this.withPrefix("BufferIds"), () => QGuidCollection);
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
}

export const qUnLinkEquipmentsToBuffers = new QUnLinkEquipmentsToBuffers();

export class QUpdateSetPointResponse extends QCommandResponse {
}

export const qUpdateSetPointResponse = new QUpdateSetPointResponse();

export class QUpdateSetPoint extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateSetPoint = new QUpdateSetPoint();

export class QUpdateToolResponse extends QCommandResponse {
}

export const qUpdateToolResponse = new QUpdateToolResponse();

export class QUpdateTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly SubstrateProperties = new QEntityPath(this.withPrefix("SubstrateProperties"), () => QSubstratePropertiesParameterType);
    public readonly UsageCounterMax = new QNumberPath(this.withPrefix("UsageCounterMax"));
    public readonly UsageDurationMax = new QStringPath(this.withPrefix("UsageDurationMax"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly ActiveNonConformanceNr = new QNumberPath(this.withPrefix("ActiveNonConformanceNr"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly IsScrap = new QBooleanPath(this.withPrefix("IsScrap"));
    public readonly IsLock = new QBooleanPath(this.withPrefix("IsLock"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly IsRuntimeFrozen = new QBooleanPath(this.withPrefix("IsRuntimeFrozen"));
}

export const qUpdateTool = new QUpdateTool();

export class QCreateStepInOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateStepInOperationResponse = new QCreateStepInOperationResponse();

export class QCreateStepInOperation extends QueryObject {
    public readonly Step = new QEntityPath(this.withPrefix("Step"), () => QStepInOperationParameterType);
}

export const qCreateStepInOperation = new QCreateStepInOperation();

export class QSplitAndLinkMaterialItemsToHandlingUnitResponse extends QCommandResponse {
}

export const qSplitAndLinkMaterialItemsToHandlingUnitResponse = new QSplitAndLinkMaterialItemsToHandlingUnitResponse();

export class QSplitAndLinkMaterialItemsToHandlingUnit extends QueryObject {
    public readonly DM_MaterialTrackingUnitIdList = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnitIdList"), () => QGuidCollection);
    public readonly HandlingUnit_Id = new QGuidPath(this.withPrefix("HandlingUnit_Id"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qSplitAndLinkMaterialItemsToHandlingUnit = new QSplitAndLinkMaterialItemsToHandlingUnit();

export class QLinkToBeUsedMachineToPJFForEGPhaseResponse extends QCommandResponse {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qLinkToBeUsedMachineToPJFForEGPhaseResponse = new QLinkToBeUsedMachineToPJFForEGPhaseResponse();

export class QLinkToBeUsedMachineToPJFForEGPhase extends QueryObject {
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly PrintJobFileList = new QEntityCollectionPath(this.withPrefix("PrintJobFileList"), () => QPJFIsSourceParameterType);
    public readonly EG_PhaseId = new QGuidPath(this.withPrefix("EG_PhaseId"));
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qLinkToBeUsedMachineToPJFForEGPhase = new QLinkToBeUsedMachineToPJFForEGPhase();

export class QCreateLogisticRequestResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateLogisticRequestResponse = new QCreateLogisticRequestResponse();

export class QCreateLogisticRequest extends QueryObject {
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Destination = new QGuidPath(this.withPrefix("Destination"));
    public readonly Source = new QGuidPath(this.withPrefix("Source"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly Buffer = new QGuidPath(this.withPrefix("Buffer"));
    public readonly MaterialDefinition = new QGuidPath(this.withPrefix("MaterialDefinition"));
    public readonly ToolDefinition = new QGuidPath(this.withPrefix("ToolDefinition"));
    public readonly Uom = new QStringPath(this.withPrefix("Uom"));
    public readonly LogisticRequestType = new QStringPath(this.withPrefix("LogisticRequestType"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
}

export const qCreateLogisticRequest = new QCreateLogisticRequest();

export class QLinkMaterialItemsToNonConformanceResponse extends QCommandResponse {
}

export const qLinkMaterialItemsToNonConformanceResponse = new QLinkMaterialItemsToNonConformanceResponse();

export class QLinkMaterialItemsToNonConformance extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
}

export const qLinkMaterialItemsToNonConformance = new QLinkMaterialItemsToNonConformance();

export class QPauseExecutionGroupPhaseResponse extends QCommandResponse {
}

export const qPauseExecutionGroupPhaseResponse = new QPauseExecutionGroupPhaseResponse();

export class QPauseExecutionGroupPhase extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly ReasonId = new QGuidPath(this.withPrefix("ReasonId"));
}

export const qPauseExecutionGroupPhase = new QPauseExecutionGroupPhase();

export class QUpdateEquipmentTypePropertyResponse extends QCommandResponse {
    public readonly AttributeIds = new QCollectionPath(this.withPrefix("AttributeIds"), () => QGuidCollection);
}

export const qUpdateEquipmentTypePropertyResponse = new QUpdateEquipmentTypePropertyResponse();

export class QUpdateEquipmentTypeProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Attributes = new QEntityCollectionPath(this.withPrefix("Attributes"), () => QPropertyParameterType);
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentTypeProperty = new QUpdateEquipmentTypeProperty();

export class QCreateUoMDimensionResponse extends QCommandResponse {
    public readonly UoMDimensionId = new QGuidPath(this.withPrefix("UoMDimensionId"));
}

export const qCreateUoMDimensionResponse = new QCreateUoMDimensionResponse();

export class QCreateUoMDimension extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateUoMDimension = new QCreateUoMDimension();

export class QStartTransportOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qStartTransportOperationResponse = new QStartTransportOperationResponse();

export class QStartTransportOperation extends QueryObject {
    public readonly TransportOperationId = new QGuidPath(this.withPrefix("TransportOperationId"));
}

export const qStartTransportOperation = new QStartTransportOperation();

export class QUpdateWOOpQuantityAssociatedToEGResponse extends QCommandResponse {
}

export const qUpdateWOOpQuantityAssociatedToEGResponse = new QUpdateWOOpQuantityAssociatedToEGResponse();

export class QUpdateWOOpQuantityAssociatedToEG extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly ExecutionGroupOperations = new QEntityCollectionPath(this.withPrefix("ExecutionGroupOperations"), () => QExecutionGroupOperationParameterType);
}

export const qUpdateWOOpQuantityAssociatedToEG = new QUpdateWOOpQuantityAssociatedToEG();

export class QCompleteExecutionGroupPhaseResponse extends QCommandResponse {
}

export const qCompleteExecutionGroupPhaseResponse = new QCompleteExecutionGroupPhaseResponse();

export class QCompleteExecutionGroupPhase extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qCompleteExecutionGroupPhase = new QCompleteExecutionGroupPhase();

export class QUpdateBufferResponse extends QCommandResponse {
}

export const qUpdateBufferResponse = new QUpdateBufferResponse();

export class QUpdateBuffer extends QueryObject {
    public readonly BufferId = new QGuidPath(this.withPrefix("BufferId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ValidFrom = new QDateTimeOffsetPath(this.withPrefix("ValidFrom"));
    public readonly ValidTo = new QDateTimeOffsetPath(this.withPrefix("ValidTo"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
}

export const qUpdateBuffer = new QUpdateBuffer();

export class QUpdateStepDependencyResponse extends QCommandResponse {
}

export const qUpdateStepDependencyResponse = new QUpdateStepDependencyResponse();

export class QUpdateStepDependency extends QueryObject {
    public readonly StepDependency = new QEntityPath(this.withPrefix("StepDependency"), () => QStepDependencyParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUpdateStepDependency = new QUpdateStepDependency();

export class QAmendOfResultToRepeatResponse extends QCommandResponse {
}

export const qAmendOfResultToRepeatResponse = new QAmendOfResultToRepeatResponse();

export class QAmendOfResultToRepeat extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MTUWithResultList = new QEntityCollectionPath(this.withPrefix("DM_MTUWithResultList"), () => QDMMTUWithResultParameterType);
    public readonly ProductionType = new QEnumPath(this.withPrefix("ProductionType"), ProductionTypeEnum);
}

export const qAmendOfResultToRepeat = new QAmendOfResultToRepeat();

export class QCompleteAsPlannedBOPResponse extends QCommandResponse {
}

export const qCompleteAsPlannedBOPResponse = new QCompleteAsPlannedBOPResponse();

export class QCompleteAsPlannedBOP extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCompleteAsPlannedBOP = new QCompleteAsPlannedBOP();

export class QTransmitEquipmentSetPointToAutomationNodeParametersResponse extends QCommandResponse {
}

export const qTransmitEquipmentSetPointToAutomationNodeParametersResponse = new QTransmitEquipmentSetPointToAutomationNodeParametersResponse();

export class QTransmitEquipmentSetPointToAutomationNodeParameters extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly SetPointItemId = new QGuidPath(this.withPrefix("SetPointItemId"));
    public readonly SetPointValue = new QStringPath(this.withPrefix("SetPointValue"));
}

export const qTransmitEquipmentSetPointToAutomationNodeParameters = new QTransmitEquipmentSetPointToAutomationNodeParameters();

export class QAcquireDCItemValueFromAutomationNodeInstanceParameterResponse extends QCommandResponse {
}

export const qAcquireDCItemValueFromAutomationNodeInstanceParameterResponse = new QAcquireDCItemValueFromAutomationNodeInstanceParameterResponse();

export class QAcquireDCItemValueFromAutomationNodeInstanceParameter extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly WorkInstructionStepItemIds = new QCollectionPath(this.withPrefix("WorkInstructionStepItemIds"), () => QGuidCollection);
    public readonly IsConfirm = new QBooleanPath(this.withPrefix("IsConfirm"));
}

export const qAcquireDCItemValueFromAutomationNodeInstanceParameter = new QAcquireDCItemValueFromAutomationNodeInstanceParameter();

export class QUpdateUoMResponse extends QCommandResponse {
    public readonly MultipleOrSubmultipleUoMIdList = new QCollectionPath(this.withPrefix("MultipleOrSubmultipleUoMIdList"), () => QGuidCollection);
}

export const qUpdateUoMResponse = new QUpdateUoMResponse();

export class QUpdateUoM extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly MultipleOrSubmultipleUoMList = new QEntityCollectionPath(this.withPrefix("MultipleOrSubmultipleUoMList"), () => QMultipleOrSubmultipleUoMParameterType);
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateUoM = new QUpdateUoM();

export class QUnlinkItlkCheckToProcessToOpLinkListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUnlinkItlkCheckToProcessToOpLinkListResponse = new QUnlinkItlkCheckToProcessToOpLinkListResponse();

export class QUnlinkItlkCheckToProcessToOpLinkList extends QueryObject {
    public readonly ItlkCheckProcessToOpLinkAssociationIdList = new QCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationIdList"), () => QGuidCollection);
}

export const qUnlinkItlkCheckToProcessToOpLinkList = new QUnlinkItlkCheckToProcessToOpLinkList();

export class QUpdateAttributiveCharacteristicSpecificationResponse extends QCommandResponse {
    public readonly FailureAssociationIds = new QCollectionPath(this.withPrefix("FailureAssociationIds"), () => QGuidCollection);
}

export const qUpdateAttributiveCharacteristicSpecificationResponse = new QUpdateAttributiveCharacteristicSpecificationResponse();

export class QUpdateAttributiveCharacteristicSpecification extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly NOKDescription = new QStringPath(this.withPrefix("NOKDescription"));
    public readonly OKDescription = new QStringPath(this.withPrefix("OKDescription"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly FailureAssociations = new QEntityCollectionPath(this.withPrefix("FailureAssociations"), () => QCharacteristicFailureAssociation);
}

export const qUpdateAttributiveCharacteristicSpecification = new QUpdateAttributiveCharacteristicSpecification();

export class QUpdateVisualCharacteristicSpecificationResponse extends QCommandResponse {
}

export const qUpdateVisualCharacteristicSpecificationResponse = new QUpdateVisualCharacteristicSpecificationResponse();

export class QUpdateVisualCharacteristicSpecification extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Context = new QEnumPath(this.withPrefix("Context"), CharacteristicContext);
    public readonly Criticality = new QStringPath(this.withPrefix("Criticality"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly SketchRows = new QNumberPath(this.withPrefix("SketchRows"));
    public readonly SketchColumns = new QNumberPath(this.withPrefix("SketchColumns"));
    public readonly Sketch = new QBinaryPath(this.withPrefix("Sketch"));
    public readonly SketchMimeType = new QStringPath(this.withPrefix("SketchMimeType"));
    public readonly SketchName = new QStringPath(this.withPrefix("SketchName"));
    public readonly SketchId = new QGuidPath(this.withPrefix("SketchId"));
    public readonly MarkForDeletion = new QBooleanPath(this.withPrefix("MarkForDeletion"));
}

export const qUpdateVisualCharacteristicSpecification = new QUpdateVisualCharacteristicSpecification();

export class QUpdateMachineToDNCResponse extends QCommandResponse {
}

export const qUpdateMachineToDNCResponse = new QUpdateMachineToDNCResponse();

export class QUpdateMachineToDNC extends QueryObject {
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qUpdateMachineToDNC = new QUpdateMachineToDNC();

export class QGenerateSerialNumberCodesResponse extends QCommandResponse {
    public readonly SerialNumberCodes = new QEntityPath(this.withPrefix("SerialNumberCodes"), () => QSerialNumberCodesParameterType);
}

export const qGenerateSerialNumberCodesResponse = new QGenerateSerialNumberCodesResponse();

export class QGenerateSerialNumberCodes extends QueryObject {
    public readonly Count = new QNumberPath(this.withPrefix("Count"));
    public readonly MaterialId = new QStringPath(this.withPrefix("MaterialId"));
    public readonly OrderId = new QStringPath(this.withPrefix("OrderId"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
    public readonly TemplateId = new QGuidPath(this.withPrefix("TemplateId"));
}

export const qGenerateSerialNumberCodes = new QGenerateSerialNumberCodes();

export class QDeleteActualUsedMachinePJFResponse extends QCommandResponse {
}

export const qDeleteActualUsedMachinePJFResponse = new QDeleteActualUsedMachinePJFResponse();

export class QDeleteActualUsedMachinePJF extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteActualUsedMachinePJF = new QDeleteActualUsedMachinePJF();

export class QCheckInCompleteWOStepSerializedResponse extends QCommandResponse {
}

export const qCheckInCompleteWOStepSerializedResponse = new QCheckInCompleteWOStepSerializedResponse();

export class QCheckInCompleteWOStepSerialized extends QueryObject {
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
    public readonly CompleteWOStepSerializedParameter = new QEntityPath(this.withPrefix("CompleteWOStepSerializedParameter"), () => QCompleteWOStepSerializedParameterType);
}

export const qCheckInCompleteWOStepSerialized = new QCheckInCompleteWOStepSerialized();

export class QDeassociateDNCItemMachineMaterialsAssociationResponse extends QCommandResponse {
    public readonly FailedId = new QGuidPath(this.withPrefix("FailedId"));
}

export const qDeassociateDNCItemMachineMaterialsAssociationResponse = new QDeassociateDNCItemMachineMaterialsAssociationResponse();

export class QDeassociateDNCItemMachineMaterialsAssociation extends QueryObject {
    public readonly Ids = new QEntityPath(this.withPrefix("Ids"), () => QIdsParameterType);
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
}

export const qDeassociateDNCItemMachineMaterialsAssociation = new QDeassociateDNCItemMachineMaterialsAssociation();

export class QCreateWorkOrderHistoryMaterialItemResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderHistoryMaterialItemResponse = new QCreateWorkOrderHistoryMaterialItemResponse();

export class QCreateWorkOrderHistoryMaterialItem extends QueryObject {
    public readonly MaterialItem = new QGuidPath(this.withPrefix("MaterialItem"));
    public readonly WorkOrderHistory = new QGuidPath(this.withPrefix("WorkOrderHistory"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qCreateWorkOrderHistoryMaterialItem = new QCreateWorkOrderHistoryMaterialItem();

export class QUnlinkDocumentFromContainerTypeListResponse extends QCommandResponse {
}

export const qUnlinkDocumentFromContainerTypeListResponse = new QUnlinkDocumentFromContainerTypeListResponse();

export class QUnlinkDocumentFromContainerTypeList extends QueryObject {
    public readonly ContainerTypeNId = new QStringPath(this.withPrefix("ContainerTypeNId"));
    public readonly DocumentIdList = new QCollectionPath(this.withPrefix("DocumentIdList"), () => QGuidCollection);
}

export const qUnlinkDocumentFromContainerTypeList = new QUnlinkDocumentFromContainerTypeList();

export class QLinkDocumentToOperationResponse extends QCommandResponse {
}

export const qLinkDocumentToOperationResponse = new QLinkDocumentToOperationResponse();

export class QLinkDocumentToOperation extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qLinkDocumentToOperation = new QLinkDocumentToOperation();

export class QDeleteMaterialClassListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qDeleteMaterialClassListResponse = new QDeleteMaterialClassListResponse();

export class QDeleteMaterialClassList extends QueryObject {
    public readonly MaterialGroupIds = new QCollectionPath(this.withPrefix("MaterialGroupIds"), () => QGuidCollection);
}

export const qDeleteMaterialClassList = new QDeleteMaterialClassList();

export class QLinkSubstrateToMachineResponse extends QCommandResponse {
}

export const qLinkSubstrateToMachineResponse = new QLinkSubstrateToMachineResponse();

export class QLinkSubstrateToMachine extends QueryObject {
    public readonly SubstrateId = new QGuidPath(this.withPrefix("SubstrateId"));
    public readonly MachineList = new QCollectionPath(this.withPrefix("MachineList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qLinkSubstrateToMachine = new QLinkSubstrateToMachine();

export class QUnlinkSkillsToStepResponse extends QCommandResponse {
}

export const qUnlinkSkillsToStepResponse = new QUnlinkSkillsToStepResponse();

export class QUnlinkSkillsToStep extends QueryObject {
    public readonly StepSkillIds = new QCollectionPath(this.withPrefix("StepSkillIds"), () => QGuidCollection);
}

export const qUnlinkSkillsToStep = new QUnlinkSkillsToStep();

export class QUADMUpdateToolSpecificationResponse extends QCommandResponse {
}

export const qUADMUpdateToolSpecificationResponse = new QUADMUpdateToolSpecificationResponse();

export class QUADMUpdateToolSpecification extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly UsageNumber = new QNumberPath(this.withPrefix("UsageNumber"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly EffectivityExpression = new QStringPath(this.withPrefix("EffectivityExpression"));
}

export const qUADMUpdateToolSpecification = new QUADMUpdateToolSpecification();

export class QCreateWorkOrderHeaderResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderHeaderResponse = new QCreateWorkOrderHeaderResponse();

export class QCreateWorkOrderHeader extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly BatchId = new QStringPath(this.withPrefix("BatchId"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly ConfigurationParameter = new QStringPath(this.withPrefix("ConfigurationParameter"));
    public readonly RoutingID = new QStringPath(this.withPrefix("RoutingID"));
    public readonly TargetProductID = new QStringPath(this.withPrefix("TargetProductID"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly ProductionTypeNId = new QStringPath(this.withPrefix("ProductionTypeNId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly ConfirmationType = new QStringPath(this.withPrefix("ConfirmationType"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly BillOfFeatureNId = new QStringPath(this.withPrefix("BillOfFeatureNId"));
    public readonly BillOfFeatureRevision = new QStringPath(this.withPrefix("BillOfFeatureRevision"));
    public readonly BoM = new QEntityPath(this.withPrefix("BoM"), () => QBoMParameterType);
}

export const qCreateWorkOrderHeader = new QCreateWorkOrderHeader();

export class QDeleteEquipmentGraphNodeConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphNodeConfigurationResponse = new QDeleteEquipmentGraphNodeConfigurationResponse();

export class QDeleteEquipmentGraphNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphNodeConfiguration = new QDeleteEquipmentGraphNodeConfiguration();

export class QUADMAutomaticStartResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ExecutionContextData = new QEntityPath(this.withPrefix("ExecutionContextData"), () => QWOOpExecutionParameterType);
}

export const qUADMAutomaticStartResponse = new QUADMAutomaticStartResponse();

export class QUADMAutomaticStart extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly ProductMaterialItemList = new QEntityCollectionPath(this.withPrefix("ProductMaterialItemList"), () => QProducedMaterialItemParameterType);
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
}

export const qUADMAutomaticStart = new QUADMAutomaticStart();

export class QCreateNewStepRevisionInOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateNewStepRevisionInOperationResponse = new QCreateNewStepRevisionInOperationResponse();

export class QCreateNewStepRevisionInOperation extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qCreateNewStepRevisionInOperation = new QCreateNewStepRevisionInOperation();

export class QCreateNonConformanceTransitionResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCreateNonConformanceTransitionResponse = new QCreateNonConformanceTransitionResponse();

export class QCreateNonConformanceTransition extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Lifecycle = new QStringPath(this.withPrefix("Lifecycle"));
    public readonly FromStatus = new QStringPath(this.withPrefix("FromStatus"));
    public readonly ToStatus = new QStringPath(this.withPrefix("ToStatus"));
}

export const qCreateNonConformanceTransition = new QCreateNonConformanceTransition();

export class QUpdateWorkOOperationDependencyResponse extends QCommandResponse {
}

export const qUpdateWorkOOperationDependencyResponse = new QUpdateWorkOOperationDependencyResponse();

export class QUpdateWorkOOperationDependency extends QueryObject {
    public readonly Dependency = new QEntityPath(this.withPrefix("Dependency"), () => QWorkOOperationDependencyParameter);
}

export const qUpdateWorkOOperationDependency = new QUpdateWorkOOperationDependency();

export class QCompleteWOOperationFullQtyResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly CompletedMaterialTrackingUnitList = new QEntityCollectionPath(this.withPrefix("CompletedMaterialTrackingUnitList"), () => QCompletedMTUParameterType);
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qCompleteWOOperationFullQtyResponse = new QCompleteWOOperationFullQtyResponse();

export class QCompleteWOOperationFullQty extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly CompleteWOOperationFullQtyParameterType = new QEntityPath(this.withPrefix("CompleteWOOperationFullQtyParameterType"), () => QCompleteWOOperationFullQtyParameterType);
}

export const qCompleteWOOperationFullQty = new QCompleteWOOperationFullQty();

export class QCompleteWOStepSerializedResponse extends QCommandResponse {
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qCompleteWOStepSerializedResponse = new QCompleteWOStepSerializedResponse();

export class QCompleteWOStepSerialized extends QueryObject {
    public readonly CompleteWOStepSerializedParameterType = new QEntityPath(this.withPrefix("CompleteWOStepSerializedParameterType"), () => QCompleteWOStepSerializedParameterType);
}

export const qCompleteWOStepSerialized = new QCompleteWOStepSerialized();

export class QAcceptChangeRemoveOperationResponse extends QCommandResponse {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAcceptChangeRemoveOperationResponse = new QAcceptChangeRemoveOperationResponse();

export class QAcceptChangeRemoveOperation extends QueryObject {
    public readonly ChangeOperationId = new QGuidPath(this.withPrefix("ChangeOperationId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly RefNumber = new QStringPath(this.withPrefix("RefNumber"));
}

export const qAcceptChangeRemoveOperation = new QAcceptChangeRemoveOperation();

export class QCompleteWOOperationsSerializedLiteResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
    public readonly CompletedMaterialTrackingUnits = new QEntityCollectionPath(this.withPrefix("CompletedMaterialTrackingUnits"), () => QCompletedMTUParameterType);
}

export const qCompleteWOOperationsSerializedLiteResponse = new QCompleteWOOperationsSerializedLiteResponse();

export class QCompleteWOOperationsSerializedLite extends QueryObject {
    public readonly CompleteWOOpSerializedLiteParameters = new QEntityCollectionPath(this.withPrefix("CompleteWOOpSerializedLiteParameters"), () => QCompleteWOOpSerializedLiteParameterType);
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly PauseSerialNumbers = new QBooleanPath(this.withPrefix("PauseSerialNumbers"));
}

export const qCompleteWOOperationsSerializedLite = new QCompleteWOOperationsSerializedLite();

export class QLinkAMMachineToMESResponse extends QCommandResponse {
}

export const qLinkAMMachineToMESResponse = new QLinkAMMachineToMESResponse();

export class QLinkAMMachineToMES extends QueryObject {
    public readonly AMMachine = new QStringPath(this.withPrefix("AMMachine"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TransferPlugin = new QStringPath(this.withPrefix("TransferPlugin"));
}

export const qLinkAMMachineToMES = new QLinkAMMachineToMES();

export class QDNCTransferDNCItemResponse extends QCommandResponse {
}

export const qDNCTransferDNCItemResponse = new QDNCTransferDNCItemResponse();

export class QDNCTransferDNCItem extends QueryObject {
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly IsPickerTransfer = new QBooleanPath(this.withPrefix("IsPickerTransfer"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly MaterialItemIds = new QCollectionPath(this.withPrefix("MaterialItemIds"), () => QGuidCollection);
}

export const qDNCTransferDNCItem = new QDNCTransferDNCItem();

export class QTCM2CreateDocumentListResponse extends QCommandResponse {
}

export const qTCM2CreateDocumentListResponse = new QTCM2CreateDocumentListResponse();

export class QTCM2CreateDocumentList extends QueryObject {
    public readonly DocumentList = new QEntityCollectionPath(this.withPrefix("DocumentList"), () => QTCM2DocumentParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateDocumentList = new QTCM2CreateDocumentList();

export class QUpdateDefectResponse extends QCommandResponse {
}

export const qUpdateDefectResponse = new QUpdateDefectResponse();

export class QUpdateDefect extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DefectType = new QGuidPath(this.withPrefix("DefectType"));
    public readonly NonConformance = new QGuidPath(this.withPrefix("NonConformance"));
    public readonly GroupPath = new QStringPath(this.withPrefix("GroupPath"));
    public readonly FailureNId = new QStringPath(this.withPrefix("FailureNId"));
}

export const qUpdateDefect = new QUpdateDefect();

export class QRemoveNonConformanceTransitionRoleListResponse extends QCommandResponse {
}

export const qRemoveNonConformanceTransitionRoleListResponse = new QRemoveNonConformanceTransitionRoleListResponse();

export class QRemoveNonConformanceTransitionRoleList extends QueryObject {
    public readonly NonConformanceTransitionId = new QStringPath(this.withPrefix("NonConformanceTransitionId"));
    public readonly RoleList = new QCollectionPath(this.withPrefix("RoleList"), () => QStringCollection);
    public readonly LifeCycle = new QStringPath(this.withPrefix("LifeCycle"));
}

export const qRemoveNonConformanceTransitionRoleList = new QRemoveNonConformanceTransitionRoleList();

export class QDeleteStatusDefinitionResponse extends QCommandResponse {
}

export const qDeleteStatusDefinitionResponse = new QDeleteStatusDefinitionResponse();

export class QDeleteStatusDefinition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteStatusDefinition = new QDeleteStatusDefinition();

export class QUnlinkOperationStepCategoryFromProcessDefinitionListResponse extends QCommandResponse {
}

export const qUnlinkOperationStepCategoryFromProcessDefinitionListResponse = new QUnlinkOperationStepCategoryFromProcessDefinitionListResponse();

export class QUnlinkOperationStepCategoryFromProcessDefinitionList extends QueryObject {
    public readonly IdList = new QCollectionPath(this.withPrefix("IdList"), () => QGuidCollection);
}

export const qUnlinkOperationStepCategoryFromProcessDefinitionList = new QUnlinkOperationStepCategoryFromProcessDefinitionList();

export class QUpdateItlkCheckWOStepAssociationListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateItlkCheckWOStepAssociationListResponse = new QUpdateItlkCheckWOStepAssociationListResponse();

export class QUpdateItlkCheckWOStepAssociationList extends QueryObject {
    public readonly ItlkCheckWOStepAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociationList"), () => QItlkCheckWOStepAssociationUpdateParameterType);
}

export const qUpdateItlkCheckWOStepAssociationList = new QUpdateItlkCheckWOStepAssociationList();

export class QCreateProcessNotificationResponse extends QCommandResponse {
    public readonly ProcessNotificationId = new QGuidPath(this.withPrefix("ProcessNotificationId"));
}

export const qCreateProcessNotificationResponse = new QCreateProcessNotificationResponse();

export class QCreateProcessNotification extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly ProcessNId = new QStringPath(this.withPrefix("ProcessNId"));
    public readonly ProcessRevision = new QStringPath(this.withPrefix("ProcessRevision"));
    public readonly ProcessUId = new QStringPath(this.withPrefix("ProcessUId"));
    public readonly ProcessName = new QStringPath(this.withPrefix("ProcessName"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qCreateProcessNotification = new QCreateProcessNotification();

export class QCreateFutureHoldResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateFutureHoldResponse = new QCreateFutureHoldResponse();

export class QCreateFutureHold extends QueryObject {
    public readonly CloseTime = new QDateTimeOffsetPath(this.withPrefix("CloseTime"));
    public readonly CloseUserId = new QStringPath(this.withPrefix("CloseUserId"));
    public readonly Comment = new QStringPath(this.withPrefix("Comment"));
    public readonly IsPresent = new QBooleanPath(this.withPrefix("IsPresent"));
    public readonly LifeCycle = new QStringPath(this.withPrefix("LifeCycle"));
    public readonly OpenTime = new QDateTimeOffsetPath(this.withPrefix("OpenTime"));
    public readonly OpenUserId = new QStringPath(this.withPrefix("OpenUserId"));
    public readonly PreviousStatus = new QStringPath(this.withPrefix("PreviousStatus"));
    public readonly ReasonId = new QStringPath(this.withPrefix("ReasonId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qCreateFutureHold = new QCreateFutureHold();

export class QCreateEquipmentGraphLinkConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphLinkConfigurationResponse = new QCreateEquipmentGraphLinkConfigurationResponse();

export class QCreateEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly SourceEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("SourceEquipmentGraphNodeConfigurationId"));
    public readonly DestinationEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("DestinationEquipmentGraphNodeConfigurationId"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
}

export const qCreateEquipmentGraphLinkConfiguration = new QCreateEquipmentGraphLinkConfiguration();

export class QDeleteProcessListResponse extends QCommandResponse {
}

export const qDeleteProcessListResponse = new QDeleteProcessListResponse();

export class QDeleteProcessList extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteProcessList = new QDeleteProcessList();

export class QUpdateActualUsedToolResponse extends QCommandResponse {
}

export const qUpdateActualUsedToolResponse = new QUpdateActualUsedToolResponse();

export class QUpdateActualUsedTool extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly UsedTimes = new QNumberPath(this.withPrefix("UsedTimes"));
    public readonly ToBeUsedTool = new QGuidPath(this.withPrefix("ToBeUsedTool"));
    public readonly ActualUsageCounter = new QNumberPath(this.withPrefix("ActualUsageCounter"));
}

export const qUpdateActualUsedTool = new QUpdateActualUsedTool();

export class QDeleteOperationFromCatalogueResponse extends QCommandResponse {
}

export const qDeleteOperationFromCatalogueResponse = new QDeleteOperationFromCatalogueResponse();

export class QDeleteOperationFromCatalogue extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteOperationFromCatalogue = new QDeleteOperationFromCatalogue();

export class QCompleteWOOperationSerializedResponse extends QCommandResponse {
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
    public readonly CompletedMaterialTrackingUnits = new QEntityCollectionPath(this.withPrefix("CompletedMaterialTrackingUnits"), () => QCompletedMTUParameterType);
    public readonly WorkOrderHistoryId = new QGuidPath(this.withPrefix("WorkOrderHistoryId"));
}

export const qCompleteWOOperationSerializedResponse = new QCompleteWOOperationSerializedResponse();

export class QCompleteWOOperationSerialized extends QueryObject {
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly CompleteWOOperationSerializedParameterType = new QEntityPath(this.withPrefix("CompleteWOOperationSerializedParameterType"), () => QCompleteWOOperationSerializedParameterType);
}

export const qCompleteWOOperationSerialized = new QCompleteWOOperationSerialized();

export class QUpdateItlkCheckOperationStepCategoryAssociationListResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qUpdateItlkCheckOperationStepCategoryAssociationListResponse = new QUpdateItlkCheckOperationStepCategoryAssociationListResponse();

export class QUpdateItlkCheckOperationStepCategoryAssociationList extends QueryObject {
    public readonly ItlkCheckOperationStepCategoryAssociationList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationList"), () => QItlkCheckOperationStepCategoryAssociationUpdateParameterType);
}

export const qUpdateItlkCheckOperationStepCategoryAssociationList = new QUpdateItlkCheckOperationStepCategoryAssociationList();

export class QDeleteTemplateBlockResponse extends QCommandResponse {
}

export const qDeleteTemplateBlockResponse = new QDeleteTemplateBlockResponse();

export class QDeleteTemplateBlock extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteTemplateBlock = new QDeleteTemplateBlock();

export class QSetExecGroupListInEditStatusResponse extends QCommandResponse {
    public readonly WarningMessages = new QCollectionPath(this.withPrefix("WarningMessages"), () => QStringCollection);
}

export const qSetExecGroupListInEditStatusResponse = new QSetExecGroupListInEditStatusResponse();

export class QSetExecGroupListInEditStatus extends QueryObject {
    public readonly ExecutionGroupNIdList = new QCollectionPath(this.withPrefix("ExecutionGroupNIdList"), () => QStringCollection);
}

export const qSetExecGroupListInEditStatus = new QSetExecGroupListInEditStatus();

export class QDeleteMaterialDefinitionDocumentResponse extends QCommandResponse {
}

export const qDeleteMaterialDefinitionDocumentResponse = new QDeleteMaterialDefinitionDocumentResponse();

export class QDeleteMaterialDefinitionDocument extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteMaterialDefinitionDocument = new QDeleteMaterialDefinitionDocument();

export class QUnLinkToBeUsedMachineToPJFForEGPhaseResponse extends QCommandResponse {
}

export const qUnLinkToBeUsedMachineToPJFForEGPhaseResponse = new QUnLinkToBeUsedMachineToPJFForEGPhaseResponse();

export class QUnLinkToBeUsedMachineToPJFForEGPhase extends QueryObject {
    public readonly EGPhase_Id = new QGuidPath(this.withPrefix("EGPhase_Id"));
}

export const qUnLinkToBeUsedMachineToPJFForEGPhase = new QUnLinkToBeUsedMachineToPJFForEGPhase();

export class QUpdateWorkInstructionDefinitionParameterResponse extends QCommandResponse {
}

export const qUpdateWorkInstructionDefinitionParameterResponse = new QUpdateWorkInstructionDefinitionParameterResponse();

export class QUpdateWorkInstructionDefinitionParameter extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
}

export const qUpdateWorkInstructionDefinitionParameter = new QUpdateWorkInstructionDefinitionParameter();

export class QTCM2LinkOperationToStepFullListResponse extends QCommandResponse {
}

export const qTCM2LinkOperationToStepFullListResponse = new QTCM2LinkOperationToStepFullListResponse();

export class QTCM2LinkOperationToStepFullList extends QueryObject {
    public readonly LinkList = new QEntityCollectionPath(this.withPrefix("LinkList"), () => QTCM2LinkParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2LinkOperationToStepFullList = new QTCM2LinkOperationToStepFullList();

export class QTCM2CreateMasterPlanResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qTCM2CreateMasterPlanResponse = new QTCM2CreateMasterPlanResponse();

export class QTCM2CreateMasterPlan extends QueryObject {
    public readonly MasterPlan = new QEntityPath(this.withPrefix("MasterPlan"), () => QTCM2MasterPlanParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qTCM2CreateMasterPlan = new QTCM2CreateMasterPlan();

export class QCreateWorkOrderOperationFromMPProcessOperationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateWorkOrderOperationFromMPProcessOperationResponse = new QCreateWorkOrderOperationFromMPProcessOperationResponse();

export class QCreateWorkOrderOperationFromMPProcessOperation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly DependencyType = new QStringPath(this.withPrefix("DependencyType"));
    public readonly WorkOrderOperationData = new QEntityPath(this.withPrefix("WorkOrderOperationData"), () => QWorkOrderOperationParameter);
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly SkipStepsCreation = new QBooleanPath(this.withPrefix("SkipStepsCreation"));
    public readonly SkipMaterialsCreation = new QBooleanPath(this.withPrefix("SkipMaterialsCreation"));
}

export const qCreateWorkOrderOperationFromMPProcessOperation = new QCreateWorkOrderOperationFromMPProcessOperation();

export class QCheckInStartWOStepSerializedResponse extends QCommandResponse {
}

export const qCheckInStartWOStepSerializedResponse = new QCheckInStartWOStepSerializedResponse();

export class QCheckInStartWOStepSerialized extends QueryObject {
    public readonly StartWOStepSerializedParameter = new QEntityPath(this.withPrefix("StartWOStepSerializedParameter"), () => QStartWOStepSerializedParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInStartWOStepSerialized = new QCheckInStartWOStepSerialized();

export class QUADMCreateMaterialSpecificationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMCreateMaterialSpecificationResponse = new QUADMCreateMaterialSpecificationResponse();

export class QUADMCreateMaterialSpecification extends QueryObject {
    public readonly MaterialSpecification = new QEntityPath(this.withPrefix("MaterialSpecification"), () => QMaterialSpecificationParameterType);
    public readonly CorrelationId = new QGuidPath(this.withPrefix("CorrelationId"));
}

export const qUADMCreateMaterialSpecification = new QUADMCreateMaterialSpecification();

export class QCreateWOOpDependencyNavigationMTUAssociationResponse extends QCommandResponse {
}

export const qCreateWOOpDependencyNavigationMTUAssociationResponse = new QCreateWOOpDependencyNavigationMTUAssociationResponse();

export class QCreateWOOpDependencyNavigationMTUAssociation extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly MTUList = new QCollectionPath(this.withPrefix("MTUList"), () => QGuidCollection);
}

export const qCreateWOOpDependencyNavigationMTUAssociation = new QCreateWOOpDependencyNavigationMTUAssociation();

export class QCreateDefectTypeResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateDefectTypeResponse = new QCreateDefectTypeResponse();

export class QCreateDefectType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly GroupIdentifiersList = new QEntityCollectionPath(this.withPrefix("GroupIdentifiersList"), () => QIdentifiersParameterType);
}

export const qCreateDefectType = new QCreateDefectType();

export class QCreateToBeUsedMachineResponse extends QCommandResponse {
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
}

export const qCreateToBeUsedMachineResponse = new QCreateToBeUsedMachineResponse();

export class QCreateToBeUsedMachine extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly PrintJobFile = new QGuidPath(this.withPrefix("PrintJobFile"));
    public readonly IsForEgPhase = new QBooleanPath(this.withPrefix("IsForEgPhase"));
}

export const qCreateToBeUsedMachine = new QCreateToBeUsedMachine();

export class QUnlinkToolDefinitionToSetPointResponse extends QCommandResponse {
}

export const qUnlinkToolDefinitionToSetPointResponse = new QUnlinkToolDefinitionToSetPointResponse();

export class QUnlinkToolDefinitionToSetPoint extends QueryObject {
    public readonly SetPointToolDefinitionAssociationList = new QCollectionPath(this.withPrefix("SetPointToolDefinitionAssociationList"), () => QGuidCollection);
}

export const qUnlinkToolDefinitionToSetPoint = new QUnlinkToolDefinitionToSetPoint();

export class QToolMaintenanceResponse extends QCommandResponse {
}

export const qToolMaintenanceResponse = new QToolMaintenanceResponse();

export class QToolMaintenance extends QueryObject {
    public readonly Tool = new QGuidPath(this.withPrefix("Tool"));
    public readonly UsageCounter = new QNumberPath(this.withPrefix("UsageCounter"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly ExpirationDate = new QDateTimeOffsetPath(this.withPrefix("ExpirationDate"));
    public readonly Locked = new QBooleanPath(this.withPrefix("Locked"));
}

export const qToolMaintenance = new QToolMaintenance();

export class QLinkATNInstanceParameterToSetPointItemListResponse extends QCommandResponse {
}

export const qLinkATNInstanceParameterToSetPointItemListResponse = new QLinkATNInstanceParameterToSetPointItemListResponse();

export class QLinkATNInstanceParameterToSetPointItemList extends QueryObject {
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly AutomationNodeInstanceParameterNId = new QStringPath(this.withPrefix("AutomationNodeInstanceParameterNId"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly ProcessOperation = new QGuidPath(this.withPrefix("ProcessOperation"));
    public readonly SetPointItemList = new QCollectionPath(this.withPrefix("SetPointItemList"), () => QGuidCollection);
}

export const qLinkATNInstanceParameterToSetPointItemList = new QLinkATNInstanceParameterToSetPointItemList();

export class QAssignCertificationToRoleListResponse extends QCommandResponse {
}

export const qAssignCertificationToRoleListResponse = new QAssignCertificationToRoleListResponse();

export class QAssignCertificationToRoleList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly Roles = new QCollectionPath(this.withPrefix("Roles"), () => QStringCollection);
    public readonly ExpiryDate = new QDateTimeOffsetPath(this.withPrefix("ExpiryDate"));
}

export const qAssignCertificationToRoleList = new QAssignCertificationToRoleList();

export class QLinkOperationDependencyToProcessResponse extends QCommandResponse {
}

export const qLinkOperationDependencyToProcessResponse = new QLinkOperationDependencyToProcessResponse();

export class QLinkOperationDependencyToProcess extends QueryObject {
    public readonly OperationDependencyId = new QGuidPath(this.withPrefix("OperationDependencyId"));
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
}

export const qLinkOperationDependencyToProcess = new QLinkOperationDependencyToProcess();

export class QCheckInStartWOStepFullQtyResponse extends QCommandResponse {
}

export const qCheckInStartWOStepFullQtyResponse = new QCheckInStartWOStepFullQtyResponse();

export class QCheckInStartWOStepFullQty extends QueryObject {
    public readonly StartWOStepFullQtyParameter = new QEntityPath(this.withPrefix("StartWOStepFullQtyParameter"), () => QStartWOStepFullQtyParameterType);
    public readonly OfflineActionInternalId = new QGuidPath(this.withPrefix("OfflineActionInternalId"));
}

export const qCheckInStartWOStepFullQty = new QCheckInStartWOStepFullQty();

export class QDeleteNonConformanceItemResponse extends QCommandResponse {
}

export const qDeleteNonConformanceItemResponse = new QDeleteNonConformanceItemResponse();

export class QDeleteNonConformanceItem extends QueryObject {
    public readonly GenericItems = new QCollectionPath(this.withPrefix("GenericItems"), () => QGuidCollection);
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
}

export const qDeleteNonConformanceItem = new QDeleteNonConformanceItem();

export class QLinkDocumentListToStepResponse extends QCommandResponse {
}

export const qLinkDocumentListToStepResponse = new QLinkDocumentListToStepResponse();

export class QLinkDocumentListToStep extends QueryObject {
    public readonly ListOfDocumentId = new QCollectionPath(this.withPrefix("ListOfDocumentId"), () => QGuidCollection);
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
}

export const qLinkDocumentListToStep = new QLinkDocumentListToStep();

export class QRemoveDefectTypeContextualizationResponse extends QCommandResponse {
}

export const qRemoveDefectTypeContextualizationResponse = new QRemoveDefectTypeContextualizationResponse();

export class QRemoveDefectTypeContextualization extends QueryObject {
    public readonly DefectTypeId = new QGuidPath(this.withPrefix("DefectTypeId"));
    public readonly DM_MaterialList = new QCollectionPath(this.withPrefix("DM_MaterialList"), () => QGuidCollection);
    public readonly EquipmentConfigurationList = new QCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QStringCollection);
    public readonly EquipmentTypeList = new QCollectionPath(this.withPrefix("EquipmentTypeList"), () => QStringCollection);
}

export const qRemoveDefectTypeContextualization = new QRemoveDefectTypeContextualization();

export class QLoadContainerResponse extends QCommandResponse {
}

export const qLoadContainerResponse = new QLoadContainerResponse();

export class QLoadContainer extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly MTUNIdList = new QCollectionPath(this.withPrefix("MTUNIdList"), () => QStringCollection);
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qLoadContainer = new QLoadContainer();

export class QCreateMachineToDNCResponse extends QCommandResponse {
    public readonly MachineToDNCId = new QGuidPath(this.withPrefix("MachineToDNCId"));
}

export const qCreateMachineToDNCResponse = new QCreateMachineToDNCResponse();

export class QCreateMachineToDNC extends QueryObject {
    public readonly DNCMachine = new QStringPath(this.withPrefix("DNCMachine"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qCreateMachineToDNC = new QCreateMachineToDNC();

export class QRemoveCertificationToUserListResponse extends QCommandResponse {
}

export const qRemoveCertificationToUserListResponse = new QRemoveCertificationToUserListResponse();

export class QRemoveCertificationToUserList extends QueryObject {
    public readonly CertificationId = new QGuidPath(this.withPrefix("CertificationId"));
    public readonly Users = new QCollectionPath(this.withPrefix("Users"), () => QStringCollection);
}

export const qRemoveCertificationToUserList = new QRemoveCertificationToUserList();

export class QChangeOfflineSessionStatusResponse extends QCommandResponse {
}

export const qChangeOfflineSessionStatusResponse = new QChangeOfflineSessionStatusResponse();

export class QChangeOfflineSessionStatus extends QueryObject {
    public readonly OfflineSessionIdFlag0 = new QBooleanPath(this.withPrefix("OfflineSessionIdFlag0"));
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
    public readonly TransitionVerb = new QStringPath(this.withPrefix("TransitionVerb"));
}

export const qChangeOfflineSessionStatus = new QChangeOfflineSessionStatus();

export class QRepairWorkInstructionResponse extends QCommandResponse {
}

export const qRepairWorkInstructionResponse = new QRepairWorkInstructionResponse();

export class QRepairWorkInstruction extends QueryObject {
    public readonly RepairContext = new QEntityPath(this.withPrefix("RepairContext"), () => QRepairActivityParameterType);
    public readonly WorkInstructionRepair = new QEntityPath(this.withPrefix("WorkInstructionRepair"), () => QRepairWorkInstructionActivityParameterType);
}

export const qRepairWorkInstruction = new QRepairWorkInstruction();

export class QCreateActivityListResponse extends QCommandResponse {
    public readonly ActivityIdList = new QCollectionPath(this.withPrefix("ActivityIdList"), () => QGuidCollection);
    public readonly WarningMessage = new QCollectionPath(this.withPrefix("WarningMessage"), () => QStringCollection);
}

export const qCreateActivityListResponse = new QCreateActivityListResponse();

export class QCreateActivityList extends QueryObject {
    public readonly Activities = new QEntityCollectionPath(this.withPrefix("Activities"), () => QActivity);
}

export const qCreateActivityList = new QCreateActivityList();

export class QRepairMaterialConsumptionResponse extends QCommandResponse {
    public readonly RepairResult = new QEntityPath(this.withPrefix("RepairResult"), () => QRepairResultParameterType);
}

export const qRepairMaterialConsumptionResponse = new QRepairMaterialConsumptionResponse();

export class QRepairMaterialConsumption extends QueryObject {
    public readonly RepairContext = new QEntityPath(this.withPrefix("RepairContext"), () => QRepairActivityParameterType);
    public readonly MaterialConsumption = new QEntityPath(this.withPrefix("MaterialConsumption"), () => QRepairMaterialActivityParameterType);
}

export const qRepairMaterialConsumption = new QRepairMaterialConsumption();

export class QMarkForCleaningToolListResponse extends QCommandResponse {
}

export const qMarkForCleaningToolListResponse = new QMarkForCleaningToolListResponse();

export class QMarkForCleaningToolList extends QueryObject {
    public readonly ToolIdList = new QCollectionPath(this.withPrefix("ToolIdList"), () => QGuidCollection);
}

export const qMarkForCleaningToolList = new QMarkForCleaningToolList();

export class QCreateCustomActivityResponse extends QCommandResponse {
    public readonly ActivityIdList = new QCollectionPath(this.withPrefix("ActivityIdList"), () => QGuidCollection);
}

export const qCreateCustomActivityResponse = new QCreateCustomActivityResponse();

export class QCreateCustomActivity extends QueryObject {
    public readonly Activities = new QEntityCollectionPath(this.withPrefix("Activities"), () => QActivity);
}

export const qCreateCustomActivity = new QCreateCustomActivity();

export class QMarkForCleaningWorkOrderListResponse extends QCommandResponse {
}

export const qMarkForCleaningWorkOrderListResponse = new QMarkForCleaningWorkOrderListResponse();

export class QMarkForCleaningWorkOrderList extends QueryObject {
    public readonly WorkOrderIdList = new QCollectionPath(this.withPrefix("WorkOrderIdList"), () => QGuidCollection);
}

export const qMarkForCleaningWorkOrderList = new QMarkForCleaningWorkOrderList();

export class QRepairToolUsageResponse extends QCommandResponse {
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
    public readonly RepairResult = new QEntityPath(this.withPrefix("RepairResult"), () => QRepairResultParameterType);
}

export const qRepairToolUsageResponse = new QRepairToolUsageResponse();

export class QRepairToolUsage extends QueryObject {
    public readonly RepairContext = new QEntityPath(this.withPrefix("RepairContext"), () => QRepairActivityParameterType);
    public readonly ToolUsage = new QEntityPath(this.withPrefix("ToolUsage"), () => QRepairToolActivityParameterType);
}

export const qRepairToolUsage = new QRepairToolUsage();

export class QUpdateWorkOrderStatusAndPropertiesCommandResponse extends QCommandResponse {
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qUpdateWorkOrderStatusAndPropertiesCommandResponse = new QUpdateWorkOrderStatusAndPropertiesCommandResponse();

export class QUpdateWorkOrderStatusAndPropertiesCommand extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly ActualTime = new QDateTimeOffsetPath(this.withPrefix("ActualTime"));
    public readonly DM_MtuIdList = new QCollectionPath(this.withPrefix("DM_MtuIdList"), () => QGuidCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qUpdateWorkOrderStatusAndPropertiesCommand = new QUpdateWorkOrderStatusAndPropertiesCommand();

export class QMarkForCleaningMTUListResponse extends QCommandResponse {
}

export const qMarkForCleaningMTUListResponse = new QMarkForCleaningMTUListResponse();

export class QMarkForCleaningMTUList extends QueryObject {
    public readonly MTUIdList = new QCollectionPath(this.withPrefix("MTUIdList"), () => QGuidCollection);
}

export const qMarkForCleaningMTUList = new QMarkForCleaningMTUList();

export class QMarkForCleaningExecutionGroupListResponse extends QCommandResponse {
}

export const qMarkForCleaningExecutionGroupListResponse = new QMarkForCleaningExecutionGroupListResponse();

export class QMarkForCleaningExecutionGroupList extends QueryObject {
    public readonly ExecutionGroupIdList = new QCollectionPath(this.withPrefix("ExecutionGroupIdList"), () => QGuidCollection);
}

export const qMarkForCleaningExecutionGroupList = new QMarkForCleaningExecutionGroupList();

export class QRepairQualityInspectionResponse extends QCommandResponse {
    public readonly RepairResult = new QEntityPath(this.withPrefix("RepairResult"), () => QRepairResultParameterType);
}

export const qRepairQualityInspectionResponse = new QRepairQualityInspectionResponse();

export class QRepairQualityInspection extends QueryObject {
    public readonly RepairContext = new QEntityPath(this.withPrefix("RepairContext"), () => QRepairActivityParameterType);
    public readonly QualityInspection = new QEntityCollectionPath(this.withPrefix("QualityInspection"), () => QAutomaticAcquireQualityCharactersticsParameterType);
}

export const qRepairQualityInspection = new QRepairQualityInspection();

export class QRepairScrewingToolUsageResponse extends QCommandResponse {
    public readonly RepairResult = new QEntityPath(this.withPrefix("RepairResult"), () => QRepairResultParameterType);
    public readonly WarningMessage = new QStringPath(this.withPrefix("WarningMessage"));
}

export const qRepairScrewingToolUsageResponse = new QRepairScrewingToolUsageResponse();

export class QRepairScrewingToolUsage extends QueryObject {
    public readonly RepairContext = new QEntityPath(this.withPrefix("RepairContext"), () => QRepairActivityParameterType);
    public readonly ScrewingContext = new QEntityPath(this.withPrefix("ScrewingContext"), () => QRepairScrewingToolActivityParameterType);
}

export const qRepairScrewingToolUsage = new QRepairScrewingToolUsage();

export class QGroupWoOpsTotallyInExecGroupByTypeResponse extends QCommandResponse {
    public readonly ExecutionGroupNIds = new QCollectionPath(this.withPrefix("ExecutionGroupNIds"), () => QStringCollection);
}

export const qGroupWoOpsTotallyInExecGroupByTypeResponse = new QGroupWoOpsTotallyInExecGroupByTypeResponse();

export class QGroupWoOpsTotallyInExecGroupByType extends QueryObject {
    public readonly WorkOrders = new QEntityCollectionPath(this.withPrefix("WorkOrders"), () => QWorkOrderToBeGrouped);
    public readonly EgToBeCreated = new QEntityCollectionPath(this.withPrefix("EgToBeCreated"), () => QWoTypeAndEgNId);
    public readonly EGFinalStatus = new QStringPath(this.withPrefix("EGFinalStatus"));
}

export const qGroupWoOpsTotallyInExecGroupByType = new QGroupWoOpsTotallyInExecGroupByType();

export class QSetToBeCollectedDocumentOnStepResponse extends QCommandResponse {
}

export const qSetToBeCollectedDocumentOnStepResponse = new QSetToBeCollectedDocumentOnStepResponse();

export class QSetToBeCollectedDocumentOnStep extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
}

export const qSetToBeCollectedDocumentOnStep = new QSetToBeCollectedDocumentOnStep();

export class QItlkCheckStepAssociationParameterValueParameterType extends QueryObject {
    public readonly ItlkCheckParameterId = new QGuidPath(this.withPrefix("ItlkCheckParameterId"));
    public readonly ItlkCheckParameterNId = new QStringPath(this.withPrefix("ItlkCheckParameterNId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly DataType = new QEnumPath(this.withPrefix("DataType"), ItlkCheckParameterDataTypeEnum);
}

export const qItlkCheckStepAssociationParameterValueParameterType = new QItlkCheckStepAssociationParameterValueParameterType();

export class QItlkCheckOperationToStepLinkAssociationParameterType extends QueryObject {
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
    public readonly OperationToStepLinkId = new QGuidPath(this.withPrefix("OperationToStepLinkId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckOperationToStepLinkAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationParameterValueList"), () => QItlkCheckStepAssociationParameterValueParameterType);
}

export const qItlkCheckOperationToStepLinkAssociationParameterType = new QItlkCheckOperationToStepLinkAssociationParameterType();

export class QItlkCheckOpAssociationParameterValueParameterType extends QueryObject {
    public readonly ItlkCheckParameterId = new QGuidPath(this.withPrefix("ItlkCheckParameterId"));
    public readonly ItlkCheckParameterNId = new QStringPath(this.withPrefix("ItlkCheckParameterNId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly DataType = new QEnumPath(this.withPrefix("DataType"), ItlkCheckParameterDataTypeEnum);
}

export const qItlkCheckOpAssociationParameterValueParameterType = new QItlkCheckOpAssociationParameterValueParameterType();

export class QItlkCheckOperationStepCategoryAssociationParameterType extends QueryObject {
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly StepRelevant = new QBooleanPath(this.withPrefix("StepRelevant"));
    public readonly OperationRelevant = new QBooleanPath(this.withPrefix("OperationRelevant"));
    public readonly ItlkCheckOperationStepCategoryAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
}

export const qItlkCheckOperationStepCategoryAssociationParameterType = new QItlkCheckOperationStepCategoryAssociationParameterType();

export class QItlkCheckOperationToStepLinkAssociationUpdateParameterType extends QueryObject {
    public readonly ItlkCheckOperationToStepLinkAssociationId = new QGuidPath(this.withPrefix("ItlkCheckOperationToStepLinkAssociationId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckOperationToStepAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationToStepAssociationParameterValueList"), () => QItlkCheckStepAssociationParameterValueParameterType);
}

export const qItlkCheckOperationToStepLinkAssociationUpdateParameterType = new QItlkCheckOperationToStepLinkAssociationUpdateParameterType();

export class QItlkCheckProcessToOpAssociationUpdateParameterType extends QueryObject {
    public readonly ItlkCheckProcessToOpAssociationId = new QGuidPath(this.withPrefix("ItlkCheckProcessToOpAssociationId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckProcessToOpAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpAssociationParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
}

export const qItlkCheckProcessToOpAssociationUpdateParameterType = new QItlkCheckProcessToOpAssociationUpdateParameterType();

export class QCustomItlkCheckParamParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly DataType = new QEnumPath(this.withPrefix("DataType"), ItlkCheckParameterDataTypeEnum);
    public readonly IsMandatory = new QBooleanPath(this.withPrefix("IsMandatory"));
    public readonly IsList = new QBooleanPath(this.withPrefix("IsList"));
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
}

export const qCustomItlkCheckParamParameterType = new QCustomItlkCheckParamParameterType();

export class QCustomItlkCheckParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly StepRelevant = new QBooleanPath(this.withPrefix("StepRelevant"));
    public readonly OperationRelevant = new QBooleanPath(this.withPrefix("OperationRelevant"));
}

export const qCustomItlkCheckParameterType = new QCustomItlkCheckParameterType();

export class QItlkCheckProcessToOpLinkAssociationParameterType extends QueryObject {
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
    public readonly ProcessToOperationLinkId = new QGuidPath(this.withPrefix("ProcessToOperationLinkId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckProcessToOpLinkAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckProcessToOpLinkAssociationParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
}

export const qItlkCheckProcessToOpLinkAssociationParameterType = new QItlkCheckProcessToOpLinkAssociationParameterType();

export class QItlkCheckOperationStepCategoryAssociationUpdateParameterType extends QueryObject {
    public readonly ItlkCheckOperationStepCategoryAssociationId = new QGuidPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly StepRelevant = new QBooleanPath(this.withPrefix("StepRelevant"));
    public readonly OperationRelevant = new QBooleanPath(this.withPrefix("OperationRelevant"));
    public readonly ItlkCheckOperationStepCategoryAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckOperationStepCategoryAssociationParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
}

export const qItlkCheckOperationStepCategoryAssociationUpdateParameterType = new QItlkCheckOperationStepCategoryAssociationUpdateParameterType();

export class QInitializeCreatedTaskParameterType extends QueryObject {
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qInitializeCreatedTaskParameterType = new QInitializeCreatedTaskParameterType();

export class QDeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qDeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType = new QDeleteWorkProcessDMMaterialTrackingUnitAssociationListParameterType();

export class QCompleteTaskAndWorkProcessListParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
}

export const qCompleteTaskAndWorkProcessListParameterType = new QCompleteTaskAndWorkProcessListParameterType();

export class QCreateAndStartWorkProcessListFromProcessDefinitionParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MTUIdList = new QCollectionPath(this.withPrefix("DM_MTUIdList"), () => QGuidCollection);
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qCreateAndStartWorkProcessListFromProcessDefinitionParameterType = new QCreateAndStartWorkProcessListFromProcessDefinitionParameterType();

export class QOutputBufferActualQuantityType extends QueryObject {
    public readonly Ids = new QGuidPath(this.withPrefix("Ids"));
    public readonly ActualQuantity = new QEntityPath(this.withPrefix("ActualQuantity"), () => QQuantityParameterType);
}

export const qOutputBufferActualQuantityType = new QOutputBufferActualQuantityType();

export class QBufferWithPriority extends QueryObject {
    public readonly BufferId = new QGuidPath(this.withPrefix("BufferId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
}

export const qBufferWithPriority = new QBufferWithPriority();

export class QToUnlinkQtyParameterType extends QueryObject {
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
}

export const qToUnlinkQtyParameterType = new QToUnlinkQtyParameterType();

export class QMaterialTrackingUnitIdQuantityParameterType extends QueryObject {
    public readonly MaterialTrackingUnitId = new QGuidPath(this.withPrefix("MaterialTrackingUnitId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qMaterialTrackingUnitIdQuantityParameterType = new QMaterialTrackingUnitIdQuantityParameterType();

export class QWI_ESScenerioParameterType extends QueryObject {
    public readonly WIElement_NId = new QStringPath(this.withPrefix("WIElement_NId"));
    public readonly WIElement_Type = new QStringPath(this.withPrefix("WIElement_Type"));
    public readonly ScenarioNId = new QStringPath(this.withPrefix("ScenarioNId"));
}

export const qWI_ESScenerioParameterType = new QWI_ESScenerioParameterType();

export class QWorkInstructionDefinitionParameterParameterType extends QueryObject {
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
}

export const qWorkInstructionDefinitionParameterParameterType = new QWorkInstructionDefinitionParameterParameterType();

export class QDM_MaterialParameterType extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialUId = new QStringPath(this.withPrefix("MaterialUId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
}

export const qDM_MaterialParameterType = new QDM_MaterialParameterType();

export class QAMPowderPropertiesParameterType2 extends QueryObject {
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QQuantityParameterType);
    public readonly MaxRecycleCount = new QNumberPath(this.withPrefix("MaxRecycleCount"));
}

export const qAMPowderPropertiesParameterType2 = new QAMPowderPropertiesParameterType2();

export class QMaterialValueParameterType extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialUId = new QStringPath(this.withPrefix("MaterialUId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
}

export const qMaterialValueParameterType = new QMaterialValueParameterType();

export class QItlkCheckWOOpAssociationUpdateParameterType extends QueryObject {
    public readonly ItlkCheckWOOpAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociationId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckWOOpAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
}

export const qItlkCheckWOOpAssociationUpdateParameterType = new QItlkCheckWOOpAssociationUpdateParameterType();

export class QItlkCheckOrchestratorOutputParameterType extends QueryObject {
    public readonly ItlkCheckWOOpAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociationId"));
    public readonly ItlkCheckParameterList = new QEntityCollectionPath(this.withPrefix("ItlkCheckParameterList"), () => QItlkCheckOpAssociationParameterValueParameterType);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUCodeType = new QEnumPath(this.withPrefix("MTUCodeType"), MTUCodeType);
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ItlkCheckResult = new QBooleanPath(this.withPrefix("ItlkCheckResult"));
    public readonly ItlkCheckWOStepAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociationId"));
    public readonly ItlkCheckOpStepCategoryAssociationId = new QGuidPath(this.withPrefix("ItlkCheckOpStepCategoryAssociationId"));
}

export const qItlkCheckOrchestratorOutputParameterType = new QItlkCheckOrchestratorOutputParameterType();

export class QItlkCheckOrchestratorInputParameterType extends QueryObject {
    public readonly ItlkCheckWOOpAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociationId"));
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
    public readonly ItlkCheckNId = new QStringPath(this.withPrefix("ItlkCheckNId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckParameterList = new QEntityCollectionPath(this.withPrefix("ItlkCheckParameterList"), () => QItlkCheckOpAssociationParameterValueParameterType);
    public readonly ItlkCheckWOStepAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociationId"));
    public readonly ItlkCheckOpStepCategoryAssociationId = new QGuidPath(this.withPrefix("ItlkCheckOpStepCategoryAssociationId"));
}

export const qItlkCheckOrchestratorInputParameterType = new QItlkCheckOrchestratorInputParameterType();

export class QItlkCheckHistoryParameterType extends QueryObject {
    public readonly ItlkCheckWOOpAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOOpAssociationId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly ItlkCheckWOStepAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUCodeType = new QEnumPath(this.withPrefix("MTUCodeType"), MTUCodeType);
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ItlkCheckSessionId = new QGuidPath(this.withPrefix("ItlkCheckSessionId"));
    public readonly ItlkCheckResult = new QBooleanPath(this.withPrefix("ItlkCheckResult"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ItlkCheckHistoryParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckHistoryParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly OperationStepCategoryNId = new QStringPath(this.withPrefix("OperationStepCategoryNId"));
    public readonly ItlkCheckOpStepCategoryAssociationId = new QGuidPath(this.withPrefix("ItlkCheckOpStepCategoryAssociationId"));
}

export const qItlkCheckHistoryParameterType = new QItlkCheckHistoryParameterType();

export class QItlkCheckWOOpAssociationParameterType extends QueryObject {
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckWOOpAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOOpAssociationParameterValueList"), () => QItlkCheckOpAssociationParameterValueParameterType);
}

export const qItlkCheckWOOpAssociationParameterType = new QItlkCheckWOOpAssociationParameterType();

export class QItlkCheckWOStepAssociationParameterType extends QueryObject {
    public readonly ItlkCheckId = new QGuidPath(this.withPrefix("ItlkCheckId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckWOStepAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociationParameterValueList"), () => QItlkCheckStepAssociationParameterValueParameterType);
}

export const qItlkCheckWOStepAssociationParameterType = new QItlkCheckWOStepAssociationParameterType();

export class QItlkCheckWOStepAssociationUpdateParameterType extends QueryObject {
    public readonly ItlkCheckWOStepAssociationId = new QGuidPath(this.withPrefix("ItlkCheckWOStepAssociationId"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ItlkCheckWOStepAssociationParameterValueList = new QEntityCollectionPath(this.withPrefix("ItlkCheckWOStepAssociationParameterValueList"), () => QItlkCheckStepAssociationParameterValueParameterType);
}

export const qItlkCheckWOStepAssociationUpdateParameterType = new QItlkCheckWOStepAssociationUpdateParameterType();

export class QCreateResultTypeParameterType extends QueryObject {
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly IsKO = new QBooleanPath(this.withPrefix("IsKO"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
}

export const qCreateResultTypeParameterType = new QCreateResultTypeParameterType();

export class QOnResultCreationParameterType extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly ResultIsKo = new QBooleanPath(this.withPrefix("ResultIsKo"));
    public readonly ResultStrategyNId = new QStringPath(this.withPrefix("ResultStrategyNId"));
    public readonly ResultHistoryId = new QGuidPath(this.withPrefix("ResultHistoryId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ActivityType = new QStringPath(this.withPrefix("ActivityType"));
    public readonly IsPartial = new QBooleanPath(this.withPrefix("IsPartial"));
}

export const qOnResultCreationParameterType = new QOnResultCreationParameterType();

export class QUpdateResultListParameterType extends QueryObject {
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ResultStrategyNId = new QStringPath(this.withPrefix("ResultStrategyNId"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly IsPartial = new QBooleanPath(this.withPrefix("IsPartial"));
}

export const qUpdateResultListParameterType = new QUpdateResultListParameterType();

export class QUpdateResultTypeParameterType extends QueryObject {
    public readonly ResultTypeId = new QGuidPath(this.withPrefix("ResultTypeId"));
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
}

export const qUpdateResultTypeParameterType = new QUpdateResultTypeParameterType();

export class QRevertResultsStrategyParameterType extends QueryObject {
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly StrategyNId = new QStringPath(this.withPrefix("StrategyNId"));
}

export const qRevertResultsStrategyParameterType = new QRevertResultsStrategyParameterType();

export class QResultHistoryParamType extends QueryObject {
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly ResultHistoryId = new QGuidPath(this.withPrefix("ResultHistoryId"));
}

export const qResultHistoryParamType = new QResultHistoryParamType();

export class QCreateResultHistoryListParameterType extends QueryObject {
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
}

export const qCreateResultHistoryListParameterType = new QCreateResultHistoryListParameterType();

export class QCreateResultListParameterType extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ResultStrategyNId = new QStringPath(this.withPrefix("ResultStrategyNId"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly ActivityType = new QStringPath(this.withPrefix("ActivityType"));
    public readonly IsPartial = new QBooleanPath(this.withPrefix("IsPartial"));
}

export const qCreateResultListParameterType = new QCreateResultListParameterType();

export class QAmendResultListParameterType extends QueryObject {
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly ResultStrategyNId = new QStringPath(this.withPrefix("ResultStrategyNId"));
}

export const qAmendResultListParameterType = new QAmendResultListParameterType();

export class QManageResultListParameterType extends QueryObject {
    public readonly Result = new QEntityPath(this.withPrefix("Result"), () => QCreateResultListParameterType);
    public readonly WOHistoryMaterialItemId = new QGuidPath(this.withPrefix("WOHistoryMaterialItemId"));
    public readonly WOOperationId = new QGuidPath(this.withPrefix("WOOperationId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly ProductionType = new QEnumPath(this.withPrefix("ProductionType"), ProductionTypeEnum);
    public readonly WOOperationTargetQuantity = new QNumberPath(this.withPrefix("WOOperationTargetQuantity"));
}

export const qManageResultListParameterType = new QManageResultListParameterType();

export class QWIResult extends QueryObject {
    public readonly WorkInstructionId = new QGuidPath(this.withPrefix("WorkInstructionId"));
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
    public readonly IsRepeat = new QBooleanPath(this.withPrefix("IsRepeat"));
    public readonly CanBeRepeated = new QBooleanPath(this.withPrefix("CanBeRepeated"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qWIResult = new QWIResult();

export class QManageNullResultParameterType extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly DM_MaterialTrackingUnitWithResultList = new QEntityCollectionPath(this.withPrefix("DM_MaterialTrackingUnitWithResultList"), () => QCompletedMTUParameterType);
    public readonly AutomaticEquipmentNId = new QStringPath(this.withPrefix("AutomaticEquipmentNId"));
}

export const qManageNullResultParameterType = new QManageNullResultParameterType();

export class QDMMTUWithResultParameterType extends QueryObject {
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
    public readonly StrategyNId = new QStringPath(this.withPrefix("StrategyNId"));
    public readonly ResultId = new QGuidPath(this.withPrefix("ResultId"));
}

export const qDMMTUWithResultParameterType = new QDMMTUWithResultParameterType();

export class QActivity extends QueryObject {
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly SpecificationId = new QGuidPath(this.withPrefix("SpecificationId"));
    public readonly DefaultResultValue = new QStringPath(this.withPrefix("DefaultResultValue"));
    public readonly DefaultResultStrategy = new QStringPath(this.withPrefix("DefaultResultStrategy"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qActivity = new QActivity();

export class QOfflineActionType extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly CommandName = new QStringPath(this.withPrefix("CommandName"));
    public readonly CommandApp = new QStringPath(this.withPrefix("CommandApp"));
    public readonly CommandPayload = new QBinaryPath(this.withPrefix("CommandPayload"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly InternalId = new QGuidPath(this.withPrefix("InternalId"));
}

export const qOfflineActionType = new QOfflineActionType();

export class QOfflineWIStepItem extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SectionNId = new QStringPath(this.withPrefix("SectionNId"));
    public readonly StepNId = new QStringPath(this.withPrefix("StepNId"));
    public readonly CompletedBy = new QStringPath(this.withPrefix("CompletedBy"));
    public readonly ItemValue = new QStringPath(this.withPrefix("ItemValue"));
    public readonly IsCompleted = new QBooleanPath(this.withPrefix("IsCompleted"));
    public readonly LastValueUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastValueUpdatedOn"));
}

export const qOfflineWIStepItem = new QOfflineWIStepItem();

export class QOfflineWorkInstruction extends QueryObject {
    public readonly WorkInstructionDefinitionNId = new QStringPath(this.withPrefix("WorkInstructionDefinitionNId"));
    public readonly StepItems = new QEntityCollectionPath(this.withPrefix("StepItems"), () => QOfflineWIStepItem);
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly WorkInstructionDefinitionRevision = new QStringPath(this.withPrefix("WorkInstructionDefinitionRevision"));
}

export const qOfflineWorkInstruction = new QOfflineWorkInstruction();

export class QResolvedToBeUsedMachinesOnWOOpParameterType extends QueryObject {
    public readonly EquipmentNIdList = new QCollectionPath(this.withPrefix("EquipmentNIdList"), () => QStringCollection);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qResolvedToBeUsedMachinesOnWOOpParameterType = new QResolvedToBeUsedMachinesOnWOOpParameterType();

export class QOfflineStepItem extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SectionNId = new QStringPath(this.withPrefix("SectionNId"));
    public readonly StepNId = new QStringPath(this.withPrefix("StepNId"));
    public readonly StepSequence = new QNumberPath(this.withPrefix("StepSequence"));
    public readonly IsRequired = new QBooleanPath(this.withPrefix("IsRequired"));
    public readonly Caption = new QStringPath(this.withPrefix("Caption"));
    public readonly Title = new QStringPath(this.withPrefix("Title"));
    public readonly DataType = new QStringPath(this.withPrefix("DataType"));
    public readonly Instructions = new QStringPath(this.withPrefix("Instructions"));
    public readonly Format = new QStringPath(this.withPrefix("Format"));
    public readonly DefaultValue = new QStringPath(this.withPrefix("DefaultValue"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly StepType = new QStringPath(this.withPrefix("StepType"));
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly LowLimit = new QStringPath(this.withPrefix("LowLimit"));
    public readonly HighLimit = new QStringPath(this.withPrefix("HighLimit"));
    public readonly Target = new QStringPath(this.withPrefix("Target"));
    public readonly SectionSequence = new QNumberPath(this.withPrefix("SectionSequence"));
    public readonly Length = new QNumberPath(this.withPrefix("Length"));
}

export const qOfflineStepItem = new QOfflineStepItem();

export class QOfflineWorkInstructionDefinition extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly StepItems = new QEntityCollectionPath(this.withPrefix("StepItems"), () => QOfflineStepItem);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qOfflineWorkInstructionDefinition = new QOfflineWorkInstructionDefinition();

export class QOfflineWorkInstructionDefinitionAssociation extends QueryObject {
    public readonly AssociationType = new QStringPath(this.withPrefix("AssociationType"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WorkInstructionDefinition = new QEntityPath(this.withPrefix("WorkInstructionDefinition"), () => QOfflineWorkInstructionDefinition);
}

export const qOfflineWorkInstructionDefinitionAssociation = new QOfflineWorkInstructionDefinitionAssociation();

export class QWIStepItemValueOfflineHistory extends QueryObject {
    public readonly Value = new QStringPath(this.withPrefix("Value"));
    public readonly OfflineDate = new QDateTimeOffsetPath(this.withPrefix("OfflineDate"));
}

export const qWIStepItemValueOfflineHistory = new QWIStepItemValueOfflineHistory();

export class QOfflineDataCollection extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly WIDefinitionNId = new QStringPath(this.withPrefix("WIDefinitionNId"));
    public readonly WIDefinitionRevision = new QStringPath(this.withPrefix("WIDefinitionRevision"));
    public readonly WISectionNId = new QStringPath(this.withPrefix("WISectionNId"));
    public readonly WIStepNId = new QStringPath(this.withPrefix("WIStepNId"));
    public readonly WIStepItemNId = new QStringPath(this.withPrefix("WIStepItemNId"));
    public readonly IsWIStepConfirmed = new QBooleanPath(this.withPrefix("IsWIStepConfirmed"));
    public readonly WIStepItemValueList = new QEntityCollectionPath(this.withPrefix("WIStepItemValueList"), () => QWIStepItemValueOfflineHistory);
}

export const qOfflineDataCollection = new QOfflineDataCollection();

export class QOfflineDataCollectionOutput extends QueryObject {
    public readonly WorkInstructionStepId = new QGuidPath(this.withPrefix("WorkInstructionStepId"));
    public readonly WorkInstructionStepItemId = new QGuidPath(this.withPrefix("WorkInstructionStepItemId"));
    public readonly IsDataCollectionCheckedIn = new QBooleanPath(this.withPrefix("IsDataCollectionCheckedIn"));
    public readonly WorkInstructionId = new QGuidPath(this.withPrefix("WorkInstructionId"));
}

export const qOfflineDataCollectionOutput = new QOfflineDataCollectionOutput();

export class QOfflineDataCollectionCheckedIn extends QueryObject {
    public readonly OfflineDataCollection = new QEntityPath(this.withPrefix("OfflineDataCollection"), () => QOfflineDataCollection);
    public readonly OnlineDataCollection = new QEntityPath(this.withPrefix("OnlineDataCollection"), () => QOfflineDataCollectionOutput);
}

export const qOfflineDataCollectionCheckedIn = new QOfflineDataCollectionCheckedIn();

export class QMTuWithQty extends QueryObject {
    public readonly MTuNId = new QStringPath(this.withPrefix("MTuNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qMTuWithQty = new QMTuWithQty();

export class QIdTemplateBlockInfoParameterType extends QueryObject {
    public readonly ExtendedYear = new QBooleanPath(this.withPrefix("ExtendedYear"));
    public readonly NextValue = new QNumberPath(this.withPrefix("NextValue"));
    public readonly NumDigits = new QNumberPath(this.withPrefix("NumDigits"));
    public readonly Separator = new QStringPath(this.withPrefix("Separator"));
    public readonly ZeroPadding = new QBooleanPath(this.withPrefix("ZeroPadding"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
}

export const qIdTemplateBlockInfoParameterType = new QIdTemplateBlockInfoParameterType();

export class QSerialNumberCodesParameterType extends QueryObject {
    public readonly Values = new QCollectionPath(this.withPrefix("Values"), () => QStringCollection);
}

export const qSerialNumberCodesParameterType = new QSerialNumberCodesParameterType();

export class QQualificationCriteriaParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Rule = new QStringPath(this.withPrefix("Rule"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qQualificationCriteriaParameterType = new QQualificationCriteriaParameterType();

export class QPropertyParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qPropertyParameterType = new QPropertyParameterType();

export class QPropertyWithAttributesParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Attributes = new QEntityCollectionPath(this.withPrefix("Attributes"), () => QPropertyParameterType);
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qPropertyWithAttributesParameterType = new QPropertyWithAttributesParameterType();

export class QMaterialParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly MaxQuantity = new QNumberPath(this.withPrefix("MaxQuantity"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
}

export const qMaterialParameterType = new QMaterialParameterType();

export class QPJFIsSourceParameterType extends QueryObject {
    public readonly IsSource = new QBooleanPath(this.withPrefix("IsSource"));
    public readonly PrintJobFileId = new QGuidPath(this.withPrefix("PrintJobFileId"));
    public readonly PrintJobFileSource = new QStringPath(this.withPrefix("PrintJobFileSource"));
    public readonly PrintJobFileName = new QStringPath(this.withPrefix("PrintJobFileName"));
    public readonly PrintJobFileExternalId = new QStringPath(this.withPrefix("PrintJobFileExternalId"));
}

export const qPJFIsSourceParameterType = new QPJFIsSourceParameterType();

export class QEquipSpecWithPjf extends QueryObject {
    public readonly PjfExternalId = new QStringPath(this.withPrefix("PjfExternalId"));
    public readonly PjfFileName = new QStringPath(this.withPrefix("PjfFileName"));
    public readonly PjfSource = new QStringPath(this.withPrefix("PjfSource"));
    public readonly EqSpecParentOpId = new QGuidPath(this.withPrefix("EqSpecParentOpId"));
    public readonly EquipNId = new QStringPath(this.withPrefix("EquipNId"));
    public readonly EquipTypeNId = new QStringPath(this.withPrefix("EquipTypeNId"));
    public readonly PjfId = new QGuidPath(this.withPrefix("PjfId"));
}

export const qEquipSpecWithPjf = new QEquipSpecWithPjf();

export class QToolToBeAcquireParameterType extends QueryObject {
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
}

export const qToolToBeAcquireParameterType = new QToolToBeAcquireParameterType();

export class QMaterialTrackingUnitParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
}

export const qMaterialTrackingUnitParameterType = new QMaterialTrackingUnitParameterType();

export class QToBeAcquireMaterialTrackingUnitParameterType extends QueryObject {
    public readonly ActualQuantity = new QNumberPath(this.withPrefix("ActualQuantity"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly ToBeConsumedMaterialName = new QStringPath(this.withPrefix("ToBeConsumedMaterialName"));
    public readonly ToBeConsumedMaterialSequence = new QNumberPath(this.withPrefix("ToBeConsumedMaterialSequence"));
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
}

export const qToBeAcquireMaterialTrackingUnitParameterType = new QToBeAcquireMaterialTrackingUnitParameterType();

export class QMaterialTrackingUnitToAcquireParameterType extends QueryObject {
    public readonly TargetMaterialTrackingUnit = new QEntityPath(this.withPrefix("TargetMaterialTrackingUnit"), () => QMaterialTrackingUnitParameterType);
    public readonly ToBeAcquireMaterialTrackingUnitList = new QEntityCollectionPath(this.withPrefix("ToBeAcquireMaterialTrackingUnitList"), () => QToBeAcquireMaterialTrackingUnitParameterType);
}

export const qMaterialTrackingUnitToAcquireParameterType = new QMaterialTrackingUnitToAcquireParameterType();

export class QCharacteristicFailureAssociation extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCharacteristicFailureAssociation = new QCharacteristicFailureAssociation();

export class QATNInstanceParameterType extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ATNInstanceParameterNId = new QStringPath(this.withPrefix("ATNInstanceParameterNId"));
    public readonly ATNInstanceNId = new QStringPath(this.withPrefix("ATNInstanceNId"));
}

export const qATNInstanceParameterType = new QATNInstanceParameterType();

export class QSetPointItemParameterType extends QueryObject {
    public readonly SetPointItemNId = new QStringPath(this.withPrefix("SetPointItemNId"));
    public readonly Editable = new QBooleanPath(this.withPrefix("Editable"));
}

export const qSetPointItemParameterType = new QSetPointItemParameterType();

export class QDeleteCertificationParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qDeleteCertificationParameterType = new QDeleteCertificationParameterType();

export class QCertificationAssociationParameterType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qCertificationAssociationParameterType = new QCertificationAssociationParameterType();

export class QCertificationHistoryParameterType extends QueryObject {
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ReferenceRoleId = new QStringPath(this.withPrefix("ReferenceRoleId"));
    public readonly ReferenceUserId = new QStringPath(this.withPrefix("ReferenceUserId"));
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly SkillId = new QGuidPath(this.withPrefix("SkillId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly SkillNId = new QStringPath(this.withPrefix("SkillNId"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
}

export const qCertificationHistoryParameterType = new QCertificationHistoryParameterType();

export class QWorkInstructionParameters extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IsReadOnly = new QBooleanPath(this.withPrefix("IsReadOnly"));
    public readonly Direction = new QEnumPath(this.withPrefix("Direction"), WorkInstructionDefinitionParameterDirection);
    public readonly ParameterType = new QEnumPath(this.withPrefix("ParameterType"), SupportedTypes);
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
    public readonly ParameterUoMNId = new QStringPath(this.withPrefix("ParameterUoMNId"));
}

export const qWorkInstructionParameters = new QWorkInstructionParameters();

export class QStepItemValueType extends QueryObject {
    public readonly ItemId = new QGuidPath(this.withPrefix("ItemId"));
    public readonly ItemValue = new QStringPath(this.withPrefix("ItemValue"));
}

export const qStepItemValueType = new QStepItemValueType();

export class QIdsParameterType extends QueryObject {
    public readonly Values = new QCollectionPath(this.withPrefix("Values"), () => QGuidCollection);
}

export const qIdsParameterType = new QIdsParameterType();

export class QIdsParameter extends QueryObject {
    public readonly Values = new QCollectionPath(this.withPrefix("Values"), () => QStringCollection);
}

export const qIdsParameter = new QIdsParameter();

export class QKeyMultiValueParameterType extends QueryObject {
    public readonly Key = new QStringPath(this.withPrefix("Key"));
    public readonly Val = new QStringPath(this.withPrefix("Val"));
}

export const qKeyMultiValueParameterType = new QKeyMultiValueParameterType();

export class QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse extends QCommandResponse {
}

export const qToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse = new QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse();

export class QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly AutomationNodeInstanceNIds = new QCollectionPath(this.withPrefix("AutomationNodeInstanceNIds"), () => QStringCollection);
}

export const qToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration = new QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration();

export class QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse extends QCommandResponse {
}

export const qToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse = new QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse();

export class QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly AutomationNodeInstanceNIds = new QCollectionPath(this.withPrefix("AutomationNodeInstanceNIds"), () => QStringCollection);
}

export const qToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration = new QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration();

export class QAPPMain_GF_ImportLOIPROResponse extends QCommandResponse {
}

export const qAPPMain_GF_ImportLOIPROResponse = new QAPPMain_GF_ImportLOIPROResponse();

export class QAPPMain_GF_ImportLOIPRO extends QueryObject {
    public readonly RawIdocXml = new QStringPath(this.withPrefix("RawIdocXml"));
    public readonly CNMOMMessageId = new QNumberPath(this.withPrefix("CNMOMMessageId"));
}

export const qAPPMain_GF_ImportLOIPRO = new QAPPMain_GF_ImportLOIPRO();

export class QAPPMain_GF_ImportMATMASResponse extends QCommandResponse {
}

export const qAPPMain_GF_ImportMATMASResponse = new QAPPMain_GF_ImportMATMASResponse();

export class QAPPMain_GF_ImportMATMAS extends QueryObject {
    public readonly RawIdocXml = new QStringPath(this.withPrefix("RawIdocXml"));
    public readonly CNMOMMessageId = new QNumberPath(this.withPrefix("CNMOMMessageId"));
}

export const qAPPMain_GF_ImportMATMAS = new QAPPMain_GF_ImportMATMAS();

export class QAPPMain_GF_KeepWorkerAlive_1Response extends QCommandResponse {
}

export const qAPPMain_GF_KeepWorkerAlive_1Response = new QAPPMain_GF_KeepWorkerAlive_1Response();

export class QAPPMain_GF_KeepWorkerAlive_1 extends QueryObject {
}

export const qAPPMain_GF_KeepWorkerAlive_1 = new QAPPMain_GF_KeepWorkerAlive_1();

export class QAPPMain_GF_KeepWorkerAlive_2Response extends QCommandResponse {
}

export const qAPPMain_GF_KeepWorkerAlive_2Response = new QAPPMain_GF_KeepWorkerAlive_2Response();

export class QAPPMain_GF_KeepWorkerAlive_2 extends QueryObject {
}

export const qAPPMain_GF_KeepWorkerAlive_2 = new QAPPMain_GF_KeepWorkerAlive_2();

export class QAPPMain_GF_KeepWorkerAlive_3Response extends QCommandResponse {
}

export const qAPPMain_GF_KeepWorkerAlive_3Response = new QAPPMain_GF_KeepWorkerAlive_3Response();

export class QAPPMain_GF_KeepWorkerAlive_3 extends QueryObject {
}

export const qAPPMain_GF_KeepWorkerAlive_3 = new QAPPMain_GF_KeepWorkerAlive_3();

export class QAPPMain_GF_KeepWorkerAlive_4Response extends QCommandResponse {
}

export const qAPPMain_GF_KeepWorkerAlive_4Response = new QAPPMain_GF_KeepWorkerAlive_4Response();

export class QAPPMain_GF_KeepWorkerAlive_4 extends QueryObject {
}

export const qAPPMain_GF_KeepWorkerAlive_4 = new QAPPMain_GF_KeepWorkerAlive_4();

export class QAPPMain_GF_KeepWorkerAlive_5Response extends QCommandResponse {
}

export const qAPPMain_GF_KeepWorkerAlive_5Response = new QAPPMain_GF_KeepWorkerAlive_5Response();

export class QAPPMain_GF_KeepWorkerAlive_5 extends QueryObject {
}

export const qAPPMain_GF_KeepWorkerAlive_5 = new QAPPMain_GF_KeepWorkerAlive_5();

export class QAPPMain_GF_CreateKeepAliveWorkerTimerResponse extends QCommandResponse {
}

export const qAPPMain_GF_CreateKeepAliveWorkerTimerResponse = new QAPPMain_GF_CreateKeepAliveWorkerTimerResponse();

export class QAPPMain_GF_CreateKeepAliveWorkerTimer extends QueryObject {
    public readonly EndTime = new QDateTimeOffsetPath(this.withPrefix("EndTime"));
    public readonly CheckTimeMinutes = new QNumberPath(this.withPrefix("CheckTimeMinutes"));
}

export const qAPPMain_GF_CreateKeepAliveWorkerTimer = new QAPPMain_GF_CreateKeepAliveWorkerTimer();

export class QAPPMain_GF_HandleScanFromShopfloorResponse extends QCommandResponse {
}

export const qAPPMain_GF_HandleScanFromShopfloorResponse = new QAPPMain_GF_HandleScanFromShopfloorResponse();

export class QAPPMain_GF_HandleScanFromShopfloor extends QueryObject {
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
}

export const qAPPMain_GF_HandleScanFromShopfloor = new QAPPMain_GF_HandleScanFromShopfloor();

export class QAPPMain_GF_ImportMATMAS_CNMOMResponse extends QCommandResponse {
}

export const qAPPMain_GF_ImportMATMAS_CNMOMResponse = new QAPPMain_GF_ImportMATMAS_CNMOMResponse();

export class QAPPMain_GF_ImportMATMAS_CNMOM extends QueryObject {
    public readonly RawIdocXml = new QStringPath(this.withPrefix("RawIdocXml"));
    public readonly CNMOMMessageIdFlag0 = new QBooleanPath(this.withPrefix("CNMOMMessageIdFlag0"));
    public readonly CNMOMMessageId = new QNumberPath(this.withPrefix("CNMOMMessageId"));
}

export const qAPPMain_GF_ImportMATMAS_CNMOM = new QAPPMain_GF_ImportMATMAS_CNMOM();

export class QAPPMain_GF_ImportLOIPRO_CNMOMResponse extends QCommandResponse {
}

export const qAPPMain_GF_ImportLOIPRO_CNMOMResponse = new QAPPMain_GF_ImportLOIPRO_CNMOMResponse();

export class QAPPMain_GF_ImportLOIPRO_CNMOM extends QueryObject {
    public readonly RawIdocXml = new QStringPath(this.withPrefix("RawIdocXml"));
    public readonly CNMOMMessageIdFlag0 = new QBooleanPath(this.withPrefix("CNMOMMessageIdFlag0"));
    public readonly CNMOMMessageId = new QNumberPath(this.withPrefix("CNMOMMessageId"));
}

export const qAPPMain_GF_ImportLOIPRO_CNMOM = new QAPPMain_GF_ImportLOIPRO_CNMOM();

export class QAPPMain_GF_ClassificationDataImportResponse extends QCommandResponse {
}

export const qAPPMain_GF_ClassificationDataImportResponse = new QAPPMain_GF_ClassificationDataImportResponse();

export class QAPPMain_GF_ClassificationDataImport extends QueryObject {
    public readonly RawCharacteristicsJSON = new QStringPath(this.withPrefix("RawCharacteristicsJSON"));
    public readonly WorkOrderIdFlag0 = new QBooleanPath(this.withPrefix("WorkOrderIdFlag0"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qAPPMain_GF_ClassificationDataImport = new QAPPMain_GF_ClassificationDataImport();

export class QAPPMain_GF_ClassificationDataRequestResponse extends QCommandResponse {
}

export const qAPPMain_GF_ClassificationDataRequestResponse = new QAPPMain_GF_ClassificationDataRequestResponse();

export class QAPPMain_GF_ClassificationDataRequest extends QueryObject {
    public readonly WorkOrderIds = new QCollectionPath(this.withPrefix("WorkOrderIds"), () => QGuidCollection);
}

export const qAPPMain_GF_ClassificationDataRequest = new QAPPMain_GF_ClassificationDataRequest();

export class QAPPMain_GF_DownloadAndAddDocumentsResponse extends QCommandResponse {
}

export const qAPPMain_GF_DownloadAndAddDocumentsResponse = new QAPPMain_GF_DownloadAndAddDocumentsResponse();

export class QAPPMain_GF_DownloadAndAddDocuments extends QueryObject {
    public readonly SAPDocumentJSON = new QStringPath(this.withPrefix("SAPDocumentJSON"));
}

export const qAPPMain_GF_DownloadAndAddDocuments = new QAPPMain_GF_DownloadAndAddDocuments();

export class QAPPMain_GF_HandleWorkOrderIdScanFromShopfloorResponse extends QCommandResponse {
}

export const qAPPMain_GF_HandleWorkOrderIdScanFromShopfloorResponse = new QAPPMain_GF_HandleWorkOrderIdScanFromShopfloorResponse();

export class QAPPMain_GF_HandleWorkOrderIdScanFromShopfloor extends QueryObject {
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
}

export const qAPPMain_GF_HandleWorkOrderIdScanFromShopfloor = new QAPPMain_GF_HandleWorkOrderIdScanFromShopfloor();

export class QAPPMain_GF_ActivateAndStartTaskResponse extends QCommandResponse {
}

export const qAPPMain_GF_ActivateAndStartTaskResponse = new QAPPMain_GF_ActivateAndStartTaskResponse();

export class QAPPMain_GF_ActivateAndStartTask extends QueryObject {
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
    public readonly UserName = new QStringPath(this.withPrefix("UserName"));
    public readonly ChainId = new QGuidPath(this.withPrefix("ChainId"));
}

export const qAPPMain_GF_ActivateAndStartTask = new QAPPMain_GF_ActivateAndStartTask();

export class QAPPMain_GF_InsertLineRoutingEntryResponse extends QCommandResponse {
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
}

export const qAPPMain_GF_InsertLineRoutingEntryResponse = new QAPPMain_GF_InsertLineRoutingEntryResponse();

export class QAPPMain_GF_InsertLineRoutingEntry extends QueryObject {
    public readonly EquipmentNIdFlag0 = new QBooleanPath(this.withPrefix("EquipmentNIdFlag0"));
    public readonly EquipmentNId = new QGuidPath(this.withPrefix("EquipmentNId"));
    public readonly FEVOR = new QStringPath(this.withPrefix("FEVOR"));
    public readonly DISPO = new QStringPath(this.withPrefix("DISPO"));
    public readonly WERKS = new QStringPath(this.withPrefix("WERKS"));
}

export const qAPPMain_GF_InsertLineRoutingEntry = new QAPPMain_GF_InsertLineRoutingEntry();

export class QAPPMain_GF_InsertScanDiagnosticResponse extends QCommandResponse {
}

export const qAPPMain_GF_InsertScanDiagnosticResponse = new QAPPMain_GF_InsertScanDiagnosticResponse();

export class QAPPMain_GF_InsertScanDiagnostic extends QueryObject {
    public readonly WorkCenter = new QStringPath(this.withPrefix("WorkCenter"));
    public readonly SerialNumber = new QStringPath(this.withPrefix("SerialNumber"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Timestamp = new QDateTimeOffsetPath(this.withPrefix("Timestamp"));
}

export const qAPPMain_GF_InsertScanDiagnostic = new QAPPMain_GF_InsertScanDiagnostic();

export class QAPPMain_GF_CreateMaterialResponse extends QCommandResponse {
    public readonly NewGUID = new QGuidPath(this.withPrefix("NewGUID"));
}

export const qAPPMain_GF_CreateMaterialResponse = new QAPPMain_GF_CreateMaterialResponse();

export class QAPPMain_GF_CreateMaterial extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly IsSerializedFlag0 = new QBooleanPath(this.withPrefix("IsSerializedFlag0"));
    public readonly IsSerialized = new QBooleanPath(this.withPrefix("IsSerialized"));
    public readonly IsPhantomFlag0 = new QBooleanPath(this.withPrefix("IsPhantomFlag0"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly BasicDataText = new QStringPath(this.withPrefix("BasicDataText"));
    public readonly MaterialMemo = new QStringPath(this.withPrefix("MaterialMemo"));
}

export const qAPPMain_GF_CreateMaterial = new QAPPMain_GF_CreateMaterial();

export class QAPPMain_GF_OnEngraverHandshakeSentResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnEngraverHandshakeSentResponse = new QAPPMain_GF_OnEngraverHandshakeSentResponse();

export class QAPPMain_GF_OnEngraverHandshakeSent extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
}

export const qAPPMain_GF_OnEngraverHandshakeSent = new QAPPMain_GF_OnEngraverHandshakeSent();

export class QAPPMain_GF_DeleteProductWaitingForValidationResponse extends QCommandResponse {
}

export const qAPPMain_GF_DeleteProductWaitingForValidationResponse = new QAPPMain_GF_DeleteProductWaitingForValidationResponse();

export class QAPPMain_GF_DeleteProductWaitingForValidation extends QueryObject {
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly WorkcenterNId = new QStringPath(this.withPrefix("WorkcenterNId"));
}

export const qAPPMain_GF_DeleteProductWaitingForValidation = new QAPPMain_GF_DeleteProductWaitingForValidation();

export class QAPPMain_GF_ManageWetTestResultResponse extends QCommandResponse {
}

export const qAPPMain_GF_ManageWetTestResultResponse = new QAPPMain_GF_ManageWetTestResultResponse();

export class QAPPMain_GF_ManageWetTestResult extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly Result = new QNumberPath(this.withPrefix("Result"));
    public readonly CommandFlag = new QNumberPath(this.withPrefix("CommandFlag"));
}

export const qAPPMain_GF_ManageWetTestResult = new QAPPMain_GF_ManageWetTestResult();

export class QAPPMain_GF_CreateWorkOrderFromLOIPROResponse extends QCommandResponse {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qAPPMain_GF_CreateWorkOrderFromLOIPROResponse = new QAPPMain_GF_CreateWorkOrderFromLOIPROResponse();

export class QAPPMain_GF_CreateWorkOrderFromLOIPRO extends QueryObject {
    public readonly RawIdocXml = new QStringPath(this.withPrefix("RawIdocXml"));
    public readonly OperationBoMItems = new QEntityCollectionPath(this.withPrefix("OperationBoMItems"), () => QGF_OperationBoMItemParameterType);
}

export const qAPPMain_GF_CreateWorkOrderFromLOIPRO = new QAPPMain_GF_CreateWorkOrderFromLOIPRO();

export class QAPPMain_GF_UpdateLineRoutingEntryResponse extends QCommandResponse {
}

export const qAPPMain_GF_UpdateLineRoutingEntryResponse = new QAPPMain_GF_UpdateLineRoutingEntryResponse();

export class QAPPMain_GF_UpdateLineRoutingEntry extends QueryObject {
    public readonly EquipmentNIdFlag0 = new QBooleanPath(this.withPrefix("EquipmentNIdFlag0"));
    public readonly EquipmentNId = new QGuidPath(this.withPrefix("EquipmentNId"));
    public readonly FEVOR = new QStringPath(this.withPrefix("FEVOR"));
    public readonly DISPO = new QStringPath(this.withPrefix("DISPO"));
    public readonly WERKS = new QStringPath(this.withPrefix("WERKS"));
    public readonly UIdFlag0 = new QBooleanPath(this.withPrefix("UIdFlag0"));
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
}

export const qAPPMain_GF_UpdateLineRoutingEntry = new QAPPMain_GF_UpdateLineRoutingEntry();

export class QAPPMain_GF_DeleteRunningScanResponse extends QCommandResponse {
}

export const qAPPMain_GF_DeleteRunningScanResponse = new QAPPMain_GF_DeleteRunningScanResponse();

export class QAPPMain_GF_DeleteRunningScan extends QueryObject {
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
}

export const qAPPMain_GF_DeleteRunningScan = new QAPPMain_GF_DeleteRunningScan();

export class QAPPMain_GF_ManageScanFromShopfloorResponse extends QCommandResponse {
}

export const qAPPMain_GF_ManageScanFromShopfloorResponse = new QAPPMain_GF_ManageScanFromShopfloorResponse();

export class QAPPMain_GF_ManageScanFromShopfloor extends QueryObject {
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
}

export const qAPPMain_GF_ManageScanFromShopfloor = new QAPPMain_GF_ManageScanFromShopfloor();

export class QAPPMain_GF_UpsertOperationExtensionsResponse extends QCommandResponse {
}

export const qAPPMain_GF_UpsertOperationExtensionsResponse = new QAPPMain_GF_UpsertOperationExtensionsResponse();

export class QAPPMain_GF_UpsertOperationExtensions extends QueryObject {
    public readonly Mandatory = new QBooleanPath(this.withPrefix("Mandatory"));
    public readonly InclusionRule = new QStringPath(this.withPrefix("InclusionRule"));
    public readonly OperationGuidFlag0 = new QBooleanPath(this.withPrefix("OperationGuidFlag0"));
    public readonly OperationGuid = new QGuidPath(this.withPrefix("OperationGuid"));
}

export const qAPPMain_GF_UpsertOperationExtensions = new QAPPMain_GF_UpsertOperationExtensions();

export class QAPPMain_GF_SendMessageToHALPResponse extends QCommandResponse {
}

export const qAPPMain_GF_SendMessageToHALPResponse = new QAPPMain_GF_SendMessageToHALPResponse();

export class QAPPMain_GF_SendMessageToHALP extends QueryObject {
    public readonly WorkcenterNId = new QStringPath(this.withPrefix("WorkcenterNId"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly Message = new QStringPath(this.withPrefix("Message"));
    public readonly Level = new QEnumPath(this.withPrefix("Level"), GF_MessageToHALPLevels);
    public readonly Param1 = new QStringPath(this.withPrefix("Param1"));
    public readonly Param2 = new QStringPath(this.withPrefix("Param2"));
    public readonly Param3 = new QStringPath(this.withPrefix("Param3"));
    public readonly Param4 = new QStringPath(this.withPrefix("Param4"));
    public readonly Param5 = new QStringPath(this.withPrefix("Param5"));
}

export const qAPPMain_GF_SendMessageToHALP = new QAPPMain_GF_SendMessageToHALP();

export class QAPPMain_GF_DeleteLineRoutingEntryResponse extends QCommandResponse {
}

export const qAPPMain_GF_DeleteLineRoutingEntryResponse = new QAPPMain_GF_DeleteLineRoutingEntryResponse();

export class QAPPMain_GF_DeleteLineRoutingEntry extends QueryObject {
    public readonly UIdFlag0 = new QBooleanPath(this.withPrefix("UIdFlag0"));
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
}

export const qAPPMain_GF_DeleteLineRoutingEntry = new QAPPMain_GF_DeleteLineRoutingEntry();

export class QAPPMain_GF_CreateUoMResponse extends QCommandResponse {
}

export const qAPPMain_GF_CreateUoMResponse = new QAPPMain_GF_CreateUoMResponse();

export class QAPPMain_GF_CreateUoM extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
}

export const qAPPMain_GF_CreateUoM = new QAPPMain_GF_CreateUoM();

export class QAPPMain_GF_OnPackagingHandshakeSentResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnPackagingHandshakeSentResponse = new QAPPMain_GF_OnPackagingHandshakeSentResponse();

export class QAPPMain_GF_OnPackagingHandshakeSent extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
}

export const qAPPMain_GF_OnPackagingHandshakeSent = new QAPPMain_GF_OnPackagingHandshakeSent();

export class QAPPMain_GF_UpdateProductWaitingForValidationResponse extends QCommandResponse {
}

export const qAPPMain_GF_UpdateProductWaitingForValidationResponse = new QAPPMain_GF_UpdateProductWaitingForValidationResponse();

export class QAPPMain_GF_UpdateProductWaitingForValidation extends QueryObject {
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly WorkcenterNId = new QStringPath(this.withPrefix("WorkcenterNId"));
    public readonly ValidatedProductId = new QStringPath(this.withPrefix("ValidatedProductId"));
    public readonly ValidationOK = new QBooleanPath(this.withPrefix("ValidationOK"));
    public readonly Handshaken = new QBooleanPath(this.withPrefix("Handshaken"));
}

export const qAPPMain_GF_UpdateProductWaitingForValidation = new QAPPMain_GF_UpdateProductWaitingForValidation();

export class QAPPMain_GF_StartRequestDocumentsResponse extends QCommandResponse {
}

export const qAPPMain_GF_StartRequestDocumentsResponse = new QAPPMain_GF_StartRequestDocumentsResponse();

export class QAPPMain_GF_StartRequestDocuments extends QueryObject {
    public readonly RawIdocXml = new QStringPath(this.withPrefix("RawIdocXml"));
}

export const qAPPMain_GF_StartRequestDocuments = new QAPPMain_GF_StartRequestDocuments();

export class QAPPMain_GF_InsertProductWaitingForValidationResponse extends QCommandResponse {
}

export const qAPPMain_GF_InsertProductWaitingForValidationResponse = new QAPPMain_GF_InsertProductWaitingForValidationResponse();

export class QAPPMain_GF_InsertProductWaitingForValidation extends QueryObject {
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly WorkcenterNId = new QStringPath(this.withPrefix("WorkcenterNId"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
    public readonly ValidationOK = new QBooleanPath(this.withPrefix("ValidationOK"));
}

export const qAPPMain_GF_InsertProductWaitingForValidation = new QAPPMain_GF_InsertProductWaitingForValidation();

export class QAPPMain_GF_SendEngraverPrinterDataResponse extends QCommandResponse {
}

export const qAPPMain_GF_SendEngraverPrinterDataResponse = new QAPPMain_GF_SendEngraverPrinterDataResponse();

export class QAPPMain_GF_SendEngraverPrinterData extends QueryObject {
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly WorkCenter = new QStringPath(this.withPrefix("WorkCenter"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
}

export const qAPPMain_GF_SendEngraverPrinterData = new QAPPMain_GF_SendEngraverPrinterData();

export class QAPPMain_GF_CloseOperationSignalHandlerResponse extends QCommandResponse {
}

export const qAPPMain_GF_CloseOperationSignalHandlerResponse = new QAPPMain_GF_CloseOperationSignalHandlerResponse();

export class QAPPMain_GF_CloseOperationSignalHandler extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
}

export const qAPPMain_GF_CloseOperationSignalHandler = new QAPPMain_GF_CloseOperationSignalHandler();

export class QAPPMain_GF_UpdateMaterialResponse extends QCommandResponse {
}

export const qAPPMain_GF_UpdateMaterialResponse = new QAPPMain_GF_UpdateMaterialResponse();

export class QAPPMain_GF_UpdateMaterial extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly BasicDataText = new QStringPath(this.withPrefix("BasicDataText"));
    public readonly IsSerialized = new QBooleanPath(this.withPrefix("IsSerialized"));
    public readonly MaterialMemo = new QStringPath(this.withPrefix("MaterialMemo"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly IsPhantomFlag0 = new QBooleanPath(this.withPrefix("IsPhantomFlag0"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
}

export const qAPPMain_GF_UpdateMaterial = new QAPPMain_GF_UpdateMaterial();

export class QAPPMain_GF_GetUoMResponse extends QCommandResponse {
    public readonly UoMValue = new QStringPath(this.withPrefix("UoMValue"));
}

export const qAPPMain_GF_GetUoMResponse = new QAPPMain_GF_GetUoMResponse();

export class QAPPMain_GF_GetUoM extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly CreateIfNotExisting = new QBooleanPath(this.withPrefix("CreateIfNotExisting"));
}

export const qAPPMain_GF_GetUoM = new QAPPMain_GF_GetUoM();

export class QAPPMain_GF_CreateBoMResponse extends QCommandResponse {
    public readonly BoMId = new QGuidPath(this.withPrefix("BoMId"));
}

export const qAPPMain_GF_CreateBoMResponse = new QAPPMain_GF_CreateBoMResponse();

export class QAPPMain_GF_CreateBoM extends QueryObject {
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly BoMItems = new QEntityCollectionPath(this.withPrefix("BoMItems"), () => QGF_BoMItemParameterType);
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qAPPMain_GF_CreateBoM = new QAPPMain_GF_CreateBoM();

export class QAPPMain_GF_InsertRunningScanResponse extends QCommandResponse {
}

export const qAPPMain_GF_InsertRunningScanResponse = new QAPPMain_GF_InsertRunningScanResponse();

export class QAPPMain_GF_InsertRunningScan extends QueryObject {
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
}

export const qAPPMain_GF_InsertRunningScan = new QAPPMain_GF_InsertRunningScan();

export class QAPPMain_GF_AllowKWAChecksExecutionResponse extends QCommandResponse {
    public readonly ExecutionAllowed = new QBooleanPath(this.withPrefix("ExecutionAllowed"));
}

export const qAPPMain_GF_AllowKWAChecksExecutionResponse = new QAPPMain_GF_AllowKWAChecksExecutionResponse();

export class QAPPMain_GF_AllowKWAChecksExecution extends QueryObject {
    public readonly CommandName = new QStringPath(this.withPrefix("CommandName"));
}

export const qAPPMain_GF_AllowKWAChecksExecution = new QAPPMain_GF_AllowKWAChecksExecution();

export class QAPPMain_GF_SendPackagingPrinterDataResponse extends QCommandResponse {
}

export const qAPPMain_GF_SendPackagingPrinterDataResponse = new QAPPMain_GF_SendPackagingPrinterDataResponse();

export class QAPPMain_GF_SendPackagingPrinterData extends QueryObject {
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
    public readonly WorkCenter = new QStringPath(this.withPrefix("WorkCenter"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
}

export const qAPPMain_GF_SendPackagingPrinterData = new QAPPMain_GF_SendPackagingPrinterData();

export class QAPPMain_DeleteMaterialResponse extends QCommandResponse {
}

export const qAPPMain_DeleteMaterialResponse = new QAPPMain_DeleteMaterialResponse();

export class QAPPMain_DeleteMaterial extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qAPPMain_DeleteMaterial = new QAPPMain_DeleteMaterial();

export class QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerializedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerializedResponse = new QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerializedResponse();

export class QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized = new QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized();

export class QAPPMain_GF_CompleteEquipmentPLCTaskResponse extends QCommandResponse {
}

export const qAPPMain_GF_CompleteEquipmentPLCTaskResponse = new QAPPMain_GF_CompleteEquipmentPLCTaskResponse();

export class QAPPMain_GF_CompleteEquipmentPLCTask extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
}

export const qAPPMain_GF_CompleteEquipmentPLCTask = new QAPPMain_GF_CompleteEquipmentPLCTask();

export class QAPPMain_GF_OnAssistedPickingStoppedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnAssistedPickingStoppedResponse = new QAPPMain_GF_OnAssistedPickingStoppedResponse();

export class QAPPMain_GF_OnAssistedPickingStopped extends QueryObject {
    public readonly EquipmentName = new QStringPath(this.withPrefix("EquipmentName"));
}

export const qAPPMain_GF_OnAssistedPickingStopped = new QAPPMain_GF_OnAssistedPickingStopped();

export class QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerializedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerializedResponse = new QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerializedResponse();

export class QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized = new QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized();

export class QAPPMain_GF_DeleteReworkProcessAssignmentEntryResponse extends QCommandResponse {
}

export const qAPPMain_GF_DeleteReworkProcessAssignmentEntryResponse = new QAPPMain_GF_DeleteReworkProcessAssignmentEntryResponse();

export class QAPPMain_GF_DeleteReworkProcessAssignmentEntry extends QueryObject {
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
}

export const qAPPMain_GF_DeleteReworkProcessAssignmentEntry = new QAPPMain_GF_DeleteReworkProcessAssignmentEntry();

export class QAPPMain_GF_OnEPLCStartWorkOrderOperationSerializedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnEPLCStartWorkOrderOperationSerializedResponse = new QAPPMain_GF_OnEPLCStartWorkOrderOperationSerializedResponse();

export class QAPPMain_GF_OnEPLCStartWorkOrderOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qAPPMain_GF_OnEPLCStartWorkOrderOperationSerialized = new QAPPMain_GF_OnEPLCStartWorkOrderOperationSerialized();

export class QAPPMain_GF_InsertReworkProcessAssignmentEntryResponse extends QCommandResponse {
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
}

export const qAPPMain_GF_InsertReworkProcessAssignmentEntryResponse = new QAPPMain_GF_InsertReworkProcessAssignmentEntryResponse();

export class QAPPMain_GF_InsertReworkProcessAssignmentEntry extends QueryObject {
    public readonly FailureId = new QEntityPath(this.withPrefix("FailureId"), () => QGF_FailureIdType);
    public readonly EquipmentConfigId = new QEntityPath(this.withPrefix("EquipmentConfigId"), () => QGF_EquipmentConfigIdType);
    public readonly ProcessId = new QEntityPath(this.withPrefix("ProcessId"), () => QGF_ProcessIdType);
}

export const qAPPMain_GF_InsertReworkProcessAssignmentEntry = new QAPPMain_GF_InsertReworkProcessAssignmentEntry();

export class QAPPMain_GF_SendMESDataToEquipmentPLCResponse extends QCommandResponse {
}

export const qAPPMain_GF_SendMESDataToEquipmentPLCResponse = new QAPPMain_GF_SendMESDataToEquipmentPLCResponse();

export class QAPPMain_GF_SendMESDataToEquipmentPLC extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
}

export const qAPPMain_GF_SendMESDataToEquipmentPLC = new QAPPMain_GF_SendMESDataToEquipmentPLC();

export class QAPPMain_GF_UpdateReworkProcessAssignmentEntryResponse extends QCommandResponse {
}

export const qAPPMain_GF_UpdateReworkProcessAssignmentEntryResponse = new QAPPMain_GF_UpdateReworkProcessAssignmentEntryResponse();

export class QAPPMain_GF_UpdateReworkProcessAssignmentEntry extends QueryObject {
    public readonly FailureId = new QEntityPath(this.withPrefix("FailureId"), () => QGF_FailureIdType);
    public readonly EquipmentConfigId = new QEntityPath(this.withPrefix("EquipmentConfigId"), () => QGF_EquipmentConfigIdType);
    public readonly UId = new QGuidPath(this.withPrefix("UId"));
    public readonly ProcessId = new QEntityPath(this.withPrefix("ProcessId"), () => QGF_ProcessIdType);
}

export const qAPPMain_GF_UpdateReworkProcessAssignmentEntry = new QAPPMain_GF_UpdateReworkProcessAssignmentEntry();

export class QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerializedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerializedResponse = new QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerializedResponse();

export class QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized = new QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized();

export class QAPPMain_GF_ResetTagResponse extends QCommandResponse {
}

export const qAPPMain_GF_ResetTagResponse = new QAPPMain_GF_ResetTagResponse();

export class QAPPMain_GF_ResetTag extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly TagName = new QStringPath(this.withPrefix("TagName"));
}

export const qAPPMain_GF_ResetTag = new QAPPMain_GF_ResetTag();

export class QAPPMain_GF_StartEquipmentPLCOperationResponse extends QCommandResponse {
}

export const qAPPMain_GF_StartEquipmentPLCOperationResponse = new QAPPMain_GF_StartEquipmentPLCOperationResponse();

export class QAPPMain_GF_StartEquipmentPLCOperation extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
}

export const qAPPMain_GF_StartEquipmentPLCOperation = new QAPPMain_GF_StartEquipmentPLCOperation();

export class QAPPMain_GF_CompleteEquipmentPLCOperationResponse extends QCommandResponse {
}

export const qAPPMain_GF_CompleteEquipmentPLCOperationResponse = new QAPPMain_GF_CompleteEquipmentPLCOperationResponse();

export class QAPPMain_GF_CompleteEquipmentPLCOperation extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly ProductId = new QStringPath(this.withPrefix("ProductId"));
}

export const qAPPMain_GF_CompleteEquipmentPLCOperation = new QAPPMain_GF_CompleteEquipmentPLCOperation();

export class QAPPMain_GF_OnCarrierArrivedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnCarrierArrivedResponse = new QAPPMain_GF_OnCarrierArrivedResponse();

export class QAPPMain_GF_OnCarrierArrived extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly SourceCarrierId = new QNumberPath(this.withPrefix("SourceCarrierId"));
    public readonly DestinationCarrierId = new QNumberPath(this.withPrefix("DestinationCarrierId"));
}

export const qAPPMain_GF_OnCarrierArrived = new QAPPMain_GF_OnCarrierArrived();

export class QAPPMain_GF_StartLineControllerOperationResponse extends QCommandResponse {
}

export const qAPPMain_GF_StartLineControllerOperationResponse = new QAPPMain_GF_StartLineControllerOperationResponse();

export class QAPPMain_GF_StartLineControllerOperation extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly SourceCarrierId = new QNumberPath(this.withPrefix("SourceCarrierId"));
}

export const qAPPMain_GF_StartLineControllerOperation = new QAPPMain_GF_StartLineControllerOperation();

export class QAPPMain_GF_OnChangeNonConformanceEntityResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnChangeNonConformanceEntityResponse = new QAPPMain_GF_OnChangeNonConformanceEntityResponse();

export class QAPPMain_GF_OnChangeNonConformanceEntity extends QueryObject {
    public readonly NonConformanceNId = new QStringPath(this.withPrefix("NonConformanceNId"));
}

export const qAPPMain_GF_OnChangeNonConformanceEntity = new QAPPMain_GF_OnChangeNonConformanceEntity();

export class QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerializedResponse extends QCommandResponse {
}

export const qAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerializedResponse = new QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerializedResponse();

export class QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly SerialNumberCodeList = new QCollectionPath(this.withPrefix("SerialNumberCodeList"), () => QStringCollection);
}

export const qAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized = new QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized();

export class QAPPMain_GF_CompleteLineControllerOperationResponse extends QCommandResponse {
}

export const qAPPMain_GF_CompleteLineControllerOperationResponse = new QAPPMain_GF_CompleteLineControllerOperationResponse();

export class QAPPMain_GF_CompleteLineControllerOperation extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly CompleteStrategy = new QNumberPath(this.withPrefix("CompleteStrategy"));
    public readonly IsParking = new QNumberPath(this.withPrefix("IsParking"));
}

export const qAPPMain_GF_CompleteLineControllerOperation = new QAPPMain_GF_CompleteLineControllerOperation();

export class QAPPMain_GF_ResetAutomationNodeTagsResponse extends QCommandResponse {
}

export const qAPPMain_GF_ResetAutomationNodeTagsResponse = new QAPPMain_GF_ResetAutomationNodeTagsResponse();

export class QAPPMain_GF_ResetAutomationNodeTags extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly TagNames = new QStringPath(this.withPrefix("TagNames"));
}

export const qAPPMain_GF_ResetAutomationNodeTags = new QAPPMain_GF_ResetAutomationNodeTags();

export class QAPPMain_GF_SendCarrierToStationResponse extends QCommandResponse {
}

export const qAPPMain_GF_SendCarrierToStationResponse = new QAPPMain_GF_SendCarrierToStationResponse();

export class QAPPMain_GF_SendCarrierToStation extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly LogicalAction = new QNumberPath(this.withPrefix("LogicalAction"));
}

export const qAPPMain_GF_SendCarrierToStation = new QAPPMain_GF_SendCarrierToStation();

export class QAPPMain_GF_CreateGFFileResponse extends QCommandResponse {
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
}

export const qAPPMain_GF_CreateGFFileResponse = new QAPPMain_GF_CreateGFFileResponse();

export class QAPPMain_GF_CreateGFFile extends QueryObject {
    public readonly FileType = new QStringPath(this.withPrefix("FileType"));
    public readonly FileContent = new QBinaryPath(this.withPrefix("FileContent"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
}

export const qAPPMain_GF_CreateGFFile = new QAPPMain_GF_CreateGFFile();

export class QAPPMain_GF_ManageMarkingResponse extends QCommandResponse {
}

export const qAPPMain_GF_ManageMarkingResponse = new QAPPMain_GF_ManageMarkingResponse();

export class QAPPMain_GF_ManageMarking extends QueryObject {
    public readonly NodeInstance = new QStringPath(this.withPrefix("NodeInstance"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
    public readonly PLCHandshake = new QNumberPath(this.withPrefix("PLCHandshake"));
    public readonly PCHandshake = new QNumberPath(this.withPrefix("PCHandshake"));
}

export const qAPPMain_GF_ManageMarking = new QAPPMain_GF_ManageMarking();

export class QAPPMain_GF_ManageWorkOrderIdScanFromShopfloorResponse extends QCommandResponse {
}

export const qAPPMain_GF_ManageWorkOrderIdScanFromShopfloorResponse = new QAPPMain_GF_ManageWorkOrderIdScanFromShopfloorResponse();

export class QAPPMain_GF_ManageWorkOrderIdScanFromShopfloor extends QueryObject {
    public readonly RawXml = new QStringPath(this.withPrefix("RawXml"));
}

export const qAPPMain_GF_ManageWorkOrderIdScanFromShopfloor = new QAPPMain_GF_ManageWorkOrderIdScanFromShopfloor();

export class QGF_OperationBoMItemParameterType extends QueryObject {
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly PositionNumber = new QStringPath(this.withPrefix("PositionNumber"));
    public readonly IsPhantom = new QBooleanPath(this.withPrefix("IsPhantom"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly OrderLevel = new QStringPath(this.withPrefix("OrderLevel"));
    public readonly OrderPath = new QStringPath(this.withPrefix("OrderPath"));
    public readonly AssemblyOrderLevel = new QStringPath(this.withPrefix("AssemblyOrderLevel"));
    public readonly AssemblyOrderPath = new QStringPath(this.withPrefix("AssemblyOrderPath"));
}

export const qGF_OperationBoMItemParameterType = new QGF_OperationBoMItemParameterType();

export class QGF_BoMItemParameterType extends QueryObject {
    public readonly BoMItemNid = new QStringPath(this.withPrefix("BoMItemNid"));
    public readonly QuantityAndUoM = new QEntityPath(this.withPrefix("QuantityAndUoM"), () => QQuantityParameterType);
}

export const qGF_BoMItemParameterType = new QGF_BoMItemParameterType();

export class QGF_FailureIdType extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qGF_FailureIdType = new QGF_FailureIdType();

export class QGF_EquipmentConfigIdType extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
}

export const qGF_EquipmentConfigIdType = new QGF_EquipmentConfigIdType();

export class QGF_ProcessIdType_Quantity extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly QuantityValue = new QNumberPath(this.withPrefix("QuantityValue"));
}

export const qGF_ProcessIdType_Quantity = new QGF_ProcessIdType_Quantity();

export class QGF_ProcessIdType_DiscreteStatus extends QueryObject {
    public readonly StatusMachineNId = new QStringPath(this.withPrefix("StatusMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qGF_ProcessIdType_DiscreteStatus = new QGF_ProcessIdType_DiscreteStatus();

export class QGF_ProcessIdType extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly MaxQuantity = new QEntityPath(this.withPrefix("MaxQuantity"), () => QGF_ProcessIdType_Quantity);
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QGF_ProcessIdType_Quantity);
    public readonly MinQuantity = new QEntityPath(this.withPrefix("MinQuantity"), () => QGF_ProcessIdType_Quantity);
    public readonly DiscreteStatus = new QEntityPath(this.withPrefix("DiscreteStatus"), () => QGF_ProcessIdType_DiscreteStatus);
}

export const qGF_ProcessIdType = new QGF_ProcessIdType();

export class QRepairActivityParameterType extends QueryObject {
    public readonly QGWorkOrderOperationNId = new QStringPath(this.withPrefix("QGWorkOrderOperationNId"));
    public readonly ActivityNId = new QStringPath(this.withPrefix("ActivityNId"));
    public readonly QGEquipmentNId = new QStringPath(this.withPrefix("QGEquipmentNId"));
    public readonly QualityGateNId = new QStringPath(this.withPrefix("QualityGateNId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
}

export const qRepairActivityParameterType = new QRepairActivityParameterType();

export class QWorkInstructionStepParameterType extends QueryObject {
    public readonly WorkInstructionStepId = new QGuidPath(this.withPrefix("WorkInstructionStepId"));
    public readonly WorkInstructionStepType = new QStringPath(this.withPrefix("WorkInstructionStepType"));
    public readonly WorkInstructionStepItems = new QEntityCollectionPath(this.withPrefix("WorkInstructionStepItems"), () => QStepItemValueType);
}

export const qWorkInstructionStepParameterType = new QWorkInstructionStepParameterType();

export class QRepairWorkInstructionActivityParameterType extends QueryObject {
    public readonly WorkInstructionId = new QGuidPath(this.withPrefix("WorkInstructionId"));
    public readonly WorkInstructionSteps = new QEntityCollectionPath(this.withPrefix("WorkInstructionSteps"), () => QWorkInstructionStepParameterType);
}

export const qRepairWorkInstructionActivityParameterType = new QRepairWorkInstructionActivityParameterType();

export class QRepairResultParameterType extends QueryObject {
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly IsKo = new QBooleanPath(this.withPrefix("IsKo"));
}

export const qRepairResultParameterType = new QRepairResultParameterType();

export class QRepairMaterialActivityParameterType extends QueryObject {
    public readonly MaterialItemToConsume = new QEntityPath(this.withPrefix("MaterialItemToConsume"), () => QMaterialItemToConsumeParameterType);
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Notes = new QStringPath(this.withPrefix("Notes"));
    public readonly FailAtFirstError = new QBooleanPath(this.withPrefix("FailAtFirstError"));
}

export const qRepairMaterialActivityParameterType = new QRepairMaterialActivityParameterType();

export class QRepairToolActivityParameterType extends QueryObject {
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
    public readonly TimesToBeUsed = new QNumberPath(this.withPrefix("TimesToBeUsed"));
    public readonly UsageDuration = new QStringPath(this.withPrefix("UsageDuration"));
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
}

export const qRepairToolActivityParameterType = new QRepairToolActivityParameterType();

export class QRepairScrewingToolActivityParameterType extends QueryObject {
    public readonly IsRepaired = new QBooleanPath(this.withPrefix("IsRepaired"));
    public readonly ToolUsage = new QEntityPath(this.withPrefix("ToolUsage"), () => QRepairToolActivityParameterType);
    public readonly ResultValue = new QStringPath(this.withPrefix("ResultValue"));
    public readonly StrategyNId = new QStringPath(this.withPrefix("StrategyNId"));
}

export const qRepairScrewingToolActivityParameterType = new QRepairScrewingToolActivityParameterType();

export class QUADMGetAllReasonsResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Location = new QStringPath(this.withPrefix("Location"));
}

export const qUADMGetAllReasonsResponse = new QUADMGetAllReasonsResponse();

export class QUADMGetAllReasons extends QueryObject {
    public readonly ReasonId = new QGuidPath(this.withPrefix("ReasonId"));
}

export const qUADMGetAllReasons = new QUADMGetAllReasons();

export class QUADMGetExecutionGroupListResponse extends QueryObject {
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
}

export const qUADMGetExecutionGroupListResponse = new QUADMGetExecutionGroupListResponse();

export class QUADMGetExecutionGroupList extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
}

export const qUADMGetExecutionGroupList = new QUADMGetExecutionGroupList();

export class QUADMGetExecutionGroupHistoryResponse extends QueryObject {
    public readonly ExecutionGroupNId = new QStringPath(this.withPrefix("ExecutionGroupNId"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderOperationSeqence = new QNumberPath(this.withPrefix("WorkOrderOperationSeqence"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly OldQuantity = new QNumberPath(this.withPrefix("OldQuantity"));
    public readonly NewQuantity = new QNumberPath(this.withPrefix("NewQuantity"));
    public readonly MachineNId = new QStringPath(this.withPrefix("MachineNId"));
    public readonly WorkInstructionNId = new QStringPath(this.withPrefix("WorkInstructionNId"));
    public readonly ExecutionGroupPhaseNId = new QStringPath(this.withPrefix("ExecutionGroupPhaseNId"));
}

export const qUADMGetExecutionGroupHistoryResponse = new QUADMGetExecutionGroupHistoryResponse();

export class QUADMGetExecutionGroupHistory extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
}

export const qUADMGetExecutionGroupHistory = new QUADMGetExecutionGroupHistory();

export class QUADMGetAllExecutionGroupPhasesWithLinkedPJFResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly LinkedMachine = new QStringPath(this.withPrefix("LinkedMachine"));
    public readonly LinkedPJF = new QStringPath(this.withPrefix("LinkedPJF"));
    public readonly PreferredMachineNId = new QStringPath(this.withPrefix("PreferredMachineNId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
}

export const qUADMGetAllExecutionGroupPhasesWithLinkedPJFResponse = new QUADMGetAllExecutionGroupPhasesWithLinkedPJFResponse();

export class QUADMGetAllExecutionGroupPhasesWithLinkedPJF extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
}

export const qUADMGetAllExecutionGroupPhasesWithLinkedPJF = new QUADMGetAllExecutionGroupPhasesWithLinkedPJF();

export class QUADMGetAllToBeUsedMachineForSetWKCHoldResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly Sorting = new QNumberPath(this.withPrefix("Sorting"));
}

export const qUADMGetAllToBeUsedMachineForSetWKCHoldResponse = new QUADMGetAllToBeUsedMachineForSetWKCHoldResponse();

export class QUADMGetAllToBeUsedMachineForSetWKCHold extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
}

export const qUADMGetAllToBeUsedMachineForSetWKCHold = new QUADMGetAllToBeUsedMachineForSetWKCHold();

export class QUADMGetDefectOrFailureResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly GroupPath = new QStringPath(this.withPrefix("GroupPath"));
    public readonly IsDefect = new QBooleanPath(this.withPrefix("IsDefect"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetDefectOrFailureResponse = new QUADMGetDefectOrFailureResponse();

export class QUADMGetDefectOrFailure extends QueryObject {
    public readonly NonConformanceId = new QGuidPath(this.withPrefix("NonConformanceId"));
}

export const qUADMGetDefectOrFailure = new QUADMGetDefectOrFailure();

export class QUADMGetNonConformanceContainerMTUResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DM_MaterialTrackingUnit_Ids = new QCollectionPath(this.withPrefix("DM_MaterialTrackingUnit_Ids"), () => QGuidCollection);
    public readonly IsContainer = new QBooleanPath(this.withPrefix("IsContainer"));
    public readonly svgIcon = new QEntityPath(this.withPrefix("svgIcon"), () => QSvgIcon);
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly IsReusable = new QBooleanPath(this.withPrefix("IsReusable"));
    public readonly CodeType = new QStringPath(this.withPrefix("CodeType"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qUADMGetNonConformanceContainerMTUResponse = new QUADMGetNonConformanceContainerMTUResponse();

export class QUADMGetNonConformanceContainerMTU extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetNonConformanceContainerMTU = new QUADMGetNonConformanceContainerMTU();

export class QUADMGetContainerToWorkOrderLinkResponse extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly ContainerName = new QStringPath(this.withPrefix("ContainerName"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Equipment = new QStringPath(this.withPrefix("Equipment"));
    public readonly ContainerType = new QStringPath(this.withPrefix("ContainerType"));
    public readonly IsContainerReusable = new QBooleanPath(this.withPrefix("IsContainerReusable"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
}

export const qUADMGetContainerToWorkOrderLinkResponse = new QUADMGetContainerToWorkOrderLinkResponse();

export class QUADMGetContainerToWorkOrderLink extends QueryObject {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qUADMGetContainerToWorkOrderLink = new QUADMGetContainerToWorkOrderLink();

export class QUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrderResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly IsReserved = new QBooleanPath(this.withPrefix("IsReserved"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrderResponse = new QUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrderResponse();

export class QUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder = new QUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder();

export class QUADMGetExecutionGroupsForWorkOrderResponse extends QueryObject {
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetExecutionGroupsForWorkOrderResponse = new QUADMGetExecutionGroupsForWorkOrderResponse();

export class QUADMGetExecutionGroupsForWorkOrder extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qUADMGetExecutionGroupsForWorkOrder = new QUADMGetExecutionGroupsForWorkOrder();

export class QUADMGetEquipmentAndRelatedOperationsResponse extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly OperationName = new QStringPath(this.withPrefix("OperationName"));
    public readonly OperationStatus = new QStringPath(this.withPrefix("OperationStatus"));
    public readonly EstimatedStart = new QDateTimeOffsetPath(this.withPrefix("EstimatedStart"));
    public readonly EstimatedEnd = new QDateTimeOffsetPath(this.withPrefix("EstimatedEnd"));
    public readonly ActualStart = new QDateTimeOffsetPath(this.withPrefix("ActualStart"));
    public readonly ActualEnd = new QDateTimeOffsetPath(this.withPrefix("ActualEnd"));
    public readonly EstimatedDuration = new QNumberPath(this.withPrefix("EstimatedDuration"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderStatus = new QStringPath(this.withPrefix("WorkOrderStatus"));
    public readonly Skills = new QEntityCollectionPath(this.withPrefix("Skills"), () => QSkillParameterType);
    public readonly Users = new QEntityCollectionPath(this.withPrefix("Users"), () => QIdentifiersParameterType);
    public readonly FinalMaterialNId = new QStringPath(this.withPrefix("FinalMaterialNId"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
}

export const qUADMGetEquipmentAndRelatedOperationsResponse = new QUADMGetEquipmentAndRelatedOperationsResponse();

export class QUADMGetEquipmentAndRelatedOperations extends QueryObject {
    public readonly GetReadyOps = new QBooleanPath(this.withPrefix("GetReadyOps"));
    public readonly GetOpenOps = new QBooleanPath(this.withPrefix("GetOpenOps"));
    public readonly GetCompleteOps = new QBooleanPath(this.withPrefix("GetCompleteOps"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly GetActiveOps = new QBooleanPath(this.withPrefix("GetActiveOps"));
    public readonly GetPartialOps = new QBooleanPath(this.withPrefix("GetPartialOps"));
}

export const qUADMGetEquipmentAndRelatedOperations = new QUADMGetEquipmentAndRelatedOperations();

export class QUADMGetAllEquipmentsAndRelatedOperationsResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Level = new QStringPath(this.withPrefix("Level"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly CompleteByDifferentUser = new QStringPath(this.withPrefix("CompleteByDifferentUser"));
    public readonly QueueOperations = new QNumberPath(this.withPrefix("QueueOperations"));
    public readonly ActiveOperations = new QNumberPath(this.withPrefix("ActiveOperations"));
    public readonly OpenOperations = new QNumberPath(this.withPrefix("OpenOperations"));
    public readonly ActiveOpenQueue = new QStringPath(this.withPrefix("ActiveOpenQueue"));
}

export const qUADMGetAllEquipmentsAndRelatedOperationsResponse = new QUADMGetAllEquipmentsAndRelatedOperationsResponse();

export class QUADMGetAllEquipmentsAndRelatedOperations extends QueryObject {
}

export const qUADMGetAllEquipmentsAndRelatedOperations = new QUADMGetAllEquipmentsAndRelatedOperations();

export class QUADMGetWorkOrderOutMsgFileResponse extends QueryObject {
    public readonly File = new QEntityPath(this.withPrefix("File"), () => QFileType);
}

export const qUADMGetWorkOrderOutMsgFileResponse = new QUADMGetWorkOrderOutMsgFileResponse();

export class QUADMGetWorkOrderOutMsgFile extends QueryObject {
    public readonly FileId = new QGuidPath(this.withPrefix("FileId"));
}

export const qUADMGetWorkOrderOutMsgFile = new QUADMGetWorkOrderOutMsgFile();

export class QUADMGetBuyoffNonConformancesResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Severity = new QStringPath(this.withPrefix("Severity"));
    public readonly StartDate = new QDateTimeOffsetPath(this.withPrefix("StartDate"));
    public readonly EndDate = new QDateTimeOffsetPath(this.withPrefix("EndDate"));
    public readonly User = new QStringPath(this.withPrefix("User"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly FinalMaterial = new QStringPath(this.withPrefix("FinalMaterial"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderStepName = new QStringPath(this.withPrefix("WorkOrderStepName"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly Signers = new QStringPath(this.withPrefix("Signers"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly FinalMaterialUId = new QStringPath(this.withPrefix("FinalMaterialUId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetBuyoffNonConformancesResponse = new QUADMGetBuyoffNonConformancesResponse();

export class QUADMGetBuyoffNonConformances extends QueryObject {
    public readonly FilterByUserAndRole = new QBooleanPath(this.withPrefix("FilterByUserAndRole"));
}

export const qUADMGetBuyoffNonConformances = new QUADMGetBuyoffNonConformances();

export class QUADMGetSignersFromBuyOffHistoryResponse extends QueryObject {
    public readonly StatusTransitionId = new QGuidPath(this.withPrefix("StatusTransitionId"));
    public readonly StatusTransitionNId = new QStringPath(this.withPrefix("StatusTransitionNId"));
    public readonly Signers = new QEntityCollectionPath(this.withPrefix("Signers"), () => QSignerParameterType);
    public readonly TimeStamp = new QDateTimeOffsetPath(this.withPrefix("TimeStamp"));
    public readonly CharacteristicRepresentationNId = new QStringPath(this.withPrefix("CharacteristicRepresentationNId"));
    public readonly BuyOffId = new QGuidPath(this.withPrefix("BuyOffId"));
}

export const qUADMGetSignersFromBuyOffHistoryResponse = new QUADMGetSignersFromBuyOffHistoryResponse();

export class QUADMGetSignersFromBuyOffHistory extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
}

export const qUADMGetSignersFromBuyOffHistory = new QUADMGetSignersFromBuyOffHistory();

export class QUADMGetWIDetailsForWorkOrderOperationAndStepResponse extends QueryObject {
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
    public readonly WorkInstructionDefinitionNId = new QStringPath(this.withPrefix("WorkInstructionDefinitionNId"));
    public readonly WorkInstructionDefinitionName = new QStringPath(this.withPrefix("WorkInstructionDefinitionName"));
    public readonly WorkInstructionDefinitionRevision = new QStringPath(this.withPrefix("WorkInstructionDefinitionRevision"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly SectionName = new QStringPath(this.withPrefix("SectionName"));
    public readonly StepName = new QStringPath(this.withPrefix("StepName"));
    public readonly StepType = new QStringPath(this.withPrefix("StepType"));
    public readonly DCName = new QStringPath(this.withPrefix("DCName"));
    public readonly DCValue = new QStringPath(this.withPrefix("DCValue"));
    public readonly DCDefaultValue = new QStringPath(this.withPrefix("DCDefaultValue"));
    public readonly DCLowerLimit = new QStringPath(this.withPrefix("DCLowerLimit"));
    public readonly DCUpperLimit = new QStringPath(this.withPrefix("DCUpperLimit"));
    public readonly DCUOM = new QStringPath(this.withPrefix("DCUOM"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AssociationType = new QStringPath(this.withPrefix("AssociationType"));
    public readonly HideOnExecGroup = new QBooleanPath(this.withPrefix("HideOnExecGroup"));
}

export const qUADMGetWIDetailsForWorkOrderOperationAndStepResponse = new QUADMGetWIDetailsForWorkOrderOperationAndStepResponse();

export class QUADMGetWIDetailsForWorkOrderOperationAndStep extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qUADMGetWIDetailsForWorkOrderOperationAndStep = new QUADMGetWIDetailsForWorkOrderOperationAndStep();

export class QUADMGetContainerTobeConsumedMTUsResponse extends QueryObject {
    public readonly Quantity = new QEntityPath(this.withPrefix("Quantity"), () => QQuantityParameterType);
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly CodeType = new QEnumPath(this.withPrefix("CodeType"), MTUCodeType);
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly InternalWarningMessages = new QCollectionPath(this.withPrefix("InternalWarningMessages"), () => QStringCollection);
}

export const qUADMGetContainerTobeConsumedMTUsResponse = new QUADMGetContainerTobeConsumedMTUsResponse();

export class QUADMGetContainerTobeConsumedMTUs extends QueryObject {
    public readonly ContainerNId = new QStringPath(this.withPrefix("ContainerNId"));
    public readonly MaterialNIds = new QCollectionPath(this.withPrefix("MaterialNIds"), () => QStringCollection);
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qUADMGetContainerTobeConsumedMTUs = new QUADMGetContainerTobeConsumedMTUs();

export class QUADMGetMTUFromBufferForToBeConsumedBatchMaterialsResponse extends QueryObject {
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
}

export const qUADMGetMTUFromBufferForToBeConsumedBatchMaterialsResponse = new QUADMGetMTUFromBufferForToBeConsumedBatchMaterialsResponse();

export class QUADMGetMTUFromBufferForToBeConsumedBatchMaterials extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialQuantityList = new QEntityCollectionPath(this.withPrefix("MaterialQuantityList"), () => QMaterialQuantityList);
}

export const qUADMGetMTUFromBufferForToBeConsumedBatchMaterials = new QUADMGetMTUFromBufferForToBeConsumedBatchMaterials();

export class QUADMGetActualConsumedMaterialForGenealogyResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ProducedMaterialItem_Id = new QGuidPath(this.withPrefix("ProducedMaterialItem_Id"));
    public readonly DM_MaterialTrackingUnit_Id = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnit_Id"));
    public readonly ProducedMaterialItemActualQty = new QNumberPath(this.withPrefix("ProducedMaterialItemActualQty"));
    public readonly MaterialItemAssembledQty = new QNumberPath(this.withPrefix("MaterialItemAssembledQty"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ConsumptionDateTime = new QDateTimeOffsetPath(this.withPrefix("ConsumptionDateTime"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly DM_MaterialTrackingUnit = new QEntityPath(this.withPrefix("DM_MaterialTrackingUnit"), () => QDM_MTUGenealogyType);
    public readonly ProducedMaterialItem = new QEntityPath(this.withPrefix("ProducedMaterialItem"), () => QProducedMTUGenealogyType);
    public readonly ToBeConsumedMaterial = new QEntityPath(this.withPrefix("ToBeConsumedMaterial"), () => QToBeConsumedMaterialGenealogyType);
}

export const qUADMGetActualConsumedMaterialForGenealogyResponse = new QUADMGetActualConsumedMaterialForGenealogyResponse();

export class QUADMGetActualConsumedMaterialForGenealogy extends QueryObject {
    public readonly DM_MTU_Id = new QGuidPath(this.withPrefix("DM_MTU_Id"));
}

export const qUADMGetActualConsumedMaterialForGenealogy = new QUADMGetActualConsumedMaterialForGenealogy();

export class QUADMGetEventLogsResponse extends QueryObject {
    public readonly WorkOrder = new QStringPath(this.withPrefix("WorkOrder"));
    public readonly WorkOrderOperation = new QStringPath(this.withPrefix("WorkOrderOperation"));
    public readonly CompletedQuantity = new QNumberPath(this.withPrefix("CompletedQuantity"));
    public readonly ERPOrder = new QStringPath(this.withPrefix("ERPOrder"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
    public readonly LastUpdate = new QDateTimeOffsetPath(this.withPrefix("LastUpdate"));
    public readonly EventEntityType = new QStringPath(this.withPrefix("EventEntityType"));
    public readonly EventID = new QGuidPath(this.withPrefix("EventID"));
    public readonly PlantID = new QStringPath(this.withPrefix("PlantID"));
}

export const qUADMGetEventLogsResponse = new QUADMGetEventLogsResponse();

export class QUADMGetEventLogs extends QueryObject {
    public readonly Source = new QStringPath(this.withPrefix("Source"));
}

export const qUADMGetEventLogs = new QUADMGetEventLogs();

export class QUADMGetAllMaterialDefinitionDocumentsResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly File_Id_Id = new QGuidPath(this.withPrefix("File_Id_Id"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qUADMGetAllMaterialDefinitionDocumentsResponse = new QUADMGetAllMaterialDefinitionDocumentsResponse();

export class QUADMGetAllMaterialDefinitionDocuments extends QueryObject {
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
}

export const qUADMGetAllMaterialDefinitionDocuments = new QUADMGetAllMaterialDefinitionDocuments();

export class QUADMGetDataFromFeaturesResponse extends QueryObject {
    public readonly FeatureNId = new QStringPath(this.withPrefix("FeatureNId"));
    public readonly FeatureValueNId = new QStringPath(this.withPrefix("FeatureValueNId"));
    public readonly IsOption = new QBooleanPath(this.withPrefix("IsOption"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly FeatureName = new QStringPath(this.withPrefix("FeatureName"));
    public readonly FeatureDescription = new QStringPath(this.withPrefix("FeatureDescription"));
    public readonly FeatureValueName = new QStringPath(this.withPrefix("FeatureValueName"));
    public readonly FeatureValueDescription = new QStringPath(this.withPrefix("FeatureValueDescription"));
}

export const qUADMGetDataFromFeaturesResponse = new QUADMGetDataFromFeaturesResponse();

export class QUADMGetDataFromFeatures extends QueryObject {
    public readonly BillOfFeaturesNId = new QStringPath(this.withPrefix("BillOfFeaturesNId"));
    public readonly BillOfFeaturesRevision = new QStringPath(this.withPrefix("BillOfFeaturesRevision"));
}

export const qUADMGetDataFromFeatures = new QUADMGetDataFromFeatures();

export class QUADMGetAllTasksResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly TaskTypeNId = new QStringPath(this.withPrefix("TaskTypeNId"));
    public readonly TaskUI = new QStringPath(this.withPrefix("TaskUI"));
    public readonly TaskDefinitionNId = new QStringPath(this.withPrefix("TaskDefinitionNId"));
    public readonly TaskTypeIcon = new QStringPath(this.withPrefix("TaskTypeIcon"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStateMachineStatusNIdParameterType);
    public readonly Contexts = new QEntityCollectionPath(this.withPrefix("Contexts"), () => QTaskContextParameterType);
}

export const qUADMGetAllTasksResponse = new QUADMGetAllTasksResponse();

export class QUADMGetAllTasks extends QueryObject {
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly DM_MaterialUId = new QStringPath(this.withPrefix("DM_MaterialUId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly TaskId = new QGuidPath(this.withPrefix("TaskId"));
}

export const qUADMGetAllTasks = new QUADMGetAllTasks();

export class QUADMGetWIDetailsForEgPhaseResponse extends QueryObject {
    public readonly WorkInstructionDefinitionId = new QGuidPath(this.withPrefix("WorkInstructionDefinitionId"));
    public readonly WorkInstructionDefinitionNId = new QStringPath(this.withPrefix("WorkInstructionDefinitionNId"));
    public readonly WorkInstructionDefinitionName = new QStringPath(this.withPrefix("WorkInstructionDefinitionName"));
    public readonly WorkInstructionDefinitionRevision = new QStringPath(this.withPrefix("WorkInstructionDefinitionRevision"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly SectionName = new QStringPath(this.withPrefix("SectionName"));
    public readonly StepName = new QStringPath(this.withPrefix("StepName"));
    public readonly StepType = new QStringPath(this.withPrefix("StepType"));
    public readonly DCName = new QStringPath(this.withPrefix("DCName"));
    public readonly DCValue = new QStringPath(this.withPrefix("DCValue"));
    public readonly DCDefaultValue = new QStringPath(this.withPrefix("DCDefaultValue"));
    public readonly DCLowerLimit = new QStringPath(this.withPrefix("DCLowerLimit"));
    public readonly DCUpperLimit = new QStringPath(this.withPrefix("DCUpperLimit"));
    public readonly DCUOM = new QStringPath(this.withPrefix("DCUOM"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AssociationType = new QStringPath(this.withPrefix("AssociationType"));
}

export const qUADMGetWIDetailsForEgPhaseResponse = new QUADMGetWIDetailsForEgPhaseResponse();

export class QUADMGetWIDetailsForEgPhase extends QueryObject {
    public readonly EgPhaseId = new QGuidPath(this.withPrefix("EgPhaseId"));
}

export const qUADMGetWIDetailsForEgPhase = new QUADMGetWIDetailsForEgPhase();

export class QUADMGetScrewingDetailsResponse extends QueryObject {
    public readonly ScrewingDetails = new QEntityPath(this.withPrefix("ScrewingDetails"), () => QScrewingDetailsParameterType);
}

export const qUADMGetScrewingDetailsResponse = new QUADMGetScrewingDetailsResponse();

export class QUADMGetScrewingDetails extends QueryObject {
    public readonly ToBeUsedToolIdList = new QCollectionPath(this.withPrefix("ToBeUsedToolIdList"), () => QGuidCollection);
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
}

export const qUADMGetScrewingDetails = new QUADMGetScrewingDetails();

export class QUADMGetScrewingHistoryFromMaterialTrackingUnitResponse extends QueryObject {
    public readonly ScrewingData = new QEntityPath(this.withPrefix("ScrewingData"), () => QScrewingDataParameterType);
}

export const qUADMGetScrewingHistoryFromMaterialTrackingUnitResponse = new QUADMGetScrewingHistoryFromMaterialTrackingUnitResponse();

export class QUADMGetScrewingHistoryFromMaterialTrackingUnit extends QueryObject {
    public readonly MaterialTrackingUnitNId = new QStringPath(this.withPrefix("MaterialTrackingUnitNId"));
    public readonly ToolNId = new QStringPath(this.withPrefix("ToolNId"));
}

export const qUADMGetScrewingHistoryFromMaterialTrackingUnit = new QUADMGetScrewingHistoryFromMaterialTrackingUnit();

export class QUADMGetAllDocumentsFromNonConformanceIdResponse extends QueryObject {
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly LocalFileId = new QGuidPath(this.withPrefix("LocalFileId"));
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly IconId = new QGuidPath(this.withPrefix("IconId"));
    public readonly DocumentName = new QStringPath(this.withPrefix("DocumentName"));
    public readonly DocumentNId = new QStringPath(this.withPrefix("DocumentNId"));
    public readonly DocumentCategory = new QStringPath(this.withPrefix("DocumentCategory"));
    public readonly DocumentDescription = new QStringPath(this.withPrefix("DocumentDescription"));
    public readonly RepositoryType = new QEnumPath(this.withPrefix("RepositoryType"), DocumentRepositoryType);
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly IconName = new QStringPath(this.withPrefix("IconName"));
    public readonly EntityLinkId = new QGuidPath(this.withPrefix("EntityLinkId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DocumentRevision = new QStringPath(this.withPrefix("DocumentRevision"));
    public readonly NonConformanceHistory = new QGuidPath(this.withPrefix("NonConformanceHistory"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
}

export const qUADMGetAllDocumentsFromNonConformanceIdResponse = new QUADMGetAllDocumentsFromNonConformanceIdResponse();

export class QUADMGetAllDocumentsFromNonConformanceId extends QueryObject {
    public readonly NCId = new QGuidPath(this.withPrefix("NCId"));
}

export const qUADMGetAllDocumentsFromNonConformanceId = new QUADMGetAllDocumentsFromNonConformanceId();

export class QUADMGetExecutionGroupListWithEstimatedDurationResponse extends QueryObject {
    public readonly TotalQuantity = new QNumberPath(this.withPrefix("TotalQuantity"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly DueDate = new QDateTimeOffsetPath(this.withPrefix("DueDate"));
}

export const qUADMGetExecutionGroupListWithEstimatedDurationResponse = new QUADMGetExecutionGroupListWithEstimatedDurationResponse();

export class QUADMGetExecutionGroupListWithEstimatedDuration extends QueryObject {
    public readonly ExecutionGroupId = new QGuidPath(this.withPrefix("ExecutionGroupId"));
}

export const qUADMGetExecutionGroupListWithEstimatedDuration = new QUADMGetExecutionGroupListWithEstimatedDuration();

export class QUADMGetAllMaterialForPrekitResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly PrekitSerialNumber = new QStringPath(this.withPrefix("PrekitSerialNumber"));
    public readonly WorkOrderOperationNId = new QStringPath(this.withPrefix("WorkOrderOperationNId"));
    public readonly WorkOrderOperationName = new QStringPath(this.withPrefix("WorkOrderOperationName"));
    public readonly WorkOrderOperationSequence = new QNumberPath(this.withPrefix("WorkOrderOperationSequence"));
    public readonly WorkOrderStepNId = new QStringPath(this.withPrefix("WorkOrderStepNId"));
    public readonly WorkOrderStepName = new QStringPath(this.withPrefix("WorkOrderStepName"));
    public readonly WorkOrderStepSequence = new QNumberPath(this.withPrefix("WorkOrderStepSequence"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qUADMGetAllMaterialForPrekitResponse = new QUADMGetAllMaterialForPrekitResponse();

export class QUADMGetAllMaterialForPrekit extends QueryObject {
    public readonly woId = new QGuidPath(this.withPrefix("woId"));
}

export const qUADMGetAllMaterialForPrekit = new QUADMGetAllMaterialForPrekit();

export class QUADMGetItlkParametersDetailsResponse extends QueryObject {
    public readonly ParameterName = new QStringPath(this.withPrefix("ParameterName"));
    public readonly ParameterDataType = new QStringPath(this.withPrefix("ParameterDataType"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
}

export const qUADMGetItlkParametersDetailsResponse = new QUADMGetItlkParametersDetailsResponse();

export class QUADMGetItlkParametersDetails extends QueryObject {
    public readonly AssociationId = new QGuidPath(this.withPrefix("AssociationId"));
    public readonly IsWoOp = new QBooleanPath(this.withPrefix("IsWoOp"));
    public readonly IsProcOp = new QBooleanPath(this.withPrefix("IsProcOp"));
    public readonly IsOpStepCategory = new QBooleanPath(this.withPrefix("IsOpStepCategory"));
    public readonly IsWoStep = new QBooleanPath(this.withPrefix("IsWoStep"));
    public readonly IsProcStep = new QBooleanPath(this.withPrefix("IsProcStep"));
}

export const qUADMGetItlkParametersDetails = new QUADMGetItlkParametersDetails();

export class QDM_MaterialAndMaterialResponse extends QueryObject {
    public readonly MaterialClass = new QStringPath(this.withPrefix("MaterialClass"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
}

export const qDM_MaterialAndMaterialResponse = new QDM_MaterialAndMaterialResponse();

export class QDM_MaterialAndMaterial extends QueryObject {
}

export const qDM_MaterialAndMaterial = new QDM_MaterialAndMaterial();

export class QUADMGetItlkCheckHistoryParamValuesResponse extends QueryObject {
    public readonly ParameterName = new QStringPath(this.withPrefix("ParameterName"));
    public readonly ParameterDataType = new QStringPath(this.withPrefix("ParameterDataType"));
    public readonly ParameterValue = new QStringPath(this.withPrefix("ParameterValue"));
}

export const qUADMGetItlkCheckHistoryParamValuesResponse = new QUADMGetItlkCheckHistoryParamValuesResponse();

export class QUADMGetItlkCheckHistoryParamValues extends QueryObject {
    public readonly ItlkCheckHistoryId = new QGuidPath(this.withPrefix("ItlkCheckHistoryId"));
}

export const qUADMGetItlkCheckHistoryParamValues = new QUADMGetItlkCheckHistoryParamValues();

export class QUADMGetFullEquipmentResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AssociatedPrintJobFileId = new QGuidPath(this.withPrefix("AssociatedPrintJobFileId"));
    public readonly AssociatedPrintJobFileNId = new QStringPath(this.withPrefix("AssociatedPrintJobFileNId"));
    public readonly IsWorkOperationAM = new QBooleanPath(this.withPrefix("IsWorkOperationAM"));
    public readonly IsWorkOperationCNC = new QBooleanPath(this.withPrefix("IsWorkOperationCNC"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Locked = new QBooleanPath(this.withPrefix("Locked"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PartProgram = new QStringPath(this.withPrefix("PartProgram"));
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
    public readonly Preferred = new QBooleanPath(this.withPrefix("Preferred"));
    public readonly ToBeUsedMachineId = new QGuidPath(this.withPrefix("ToBeUsedMachineId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly AssociatedPrintJobFileNIdRuntimeOnly = new QBooleanPath(this.withPrefix("AssociatedPrintJobFileNIdRuntimeOnly"));
    public readonly AssociatedPrintJobFileProductSerializable = new QBooleanPath(this.withPrefix("AssociatedPrintJobFileProductSerializable"));
    public readonly AssociatedPrintJobFileProductSerialManagement = new QStringPath(this.withPrefix("AssociatedPrintJobFileProductSerialManagement"));
}

export const qUADMGetFullEquipmentResponse = new QUADMGetFullEquipmentResponse();

export class QUADMGetFullEquipment extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qUADMGetFullEquipment = new QUADMGetFullEquipment();

export class QUADMGetAllProcessMachinesResponse extends QueryObject {
    public readonly result = new QEntityPath(this.withPrefix("result"), () => QProcessMachinesParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAllProcessMachinesResponse = new QUADMGetAllProcessMachinesResponse();

export class QUADMGetAllProcessMachines extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
    public readonly MasterPlan_Id = new QGuidPath(this.withPrefix("MasterPlan_Id"));
}

export const qUADMGetAllProcessMachines = new QUADMGetAllProcessMachines();

export class QUADMGetAllItlkCheckWOOpAssociationResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsStandard = new QBooleanPath(this.withPrefix("IsStandard"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly AssociationId = new QGuidPath(this.withPrefix("AssociationId"));
}

export const qUADMGetAllItlkCheckWOOpAssociationResponse = new QUADMGetAllItlkCheckWOOpAssociationResponse();

export class QUADMGetAllItlkCheckWOOpAssociation extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
}

export const qUADMGetAllItlkCheckWOOpAssociation = new QUADMGetAllItlkCheckWOOpAssociation();

export class QUADMGetAllItlkCheckProcessToOpLinkAssociationResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsStandard = new QBooleanPath(this.withPrefix("IsStandard"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly ProcessToOperationLinkId = new QGuidPath(this.withPrefix("ProcessToOperationLinkId"));
    public readonly AssociationId = new QGuidPath(this.withPrefix("AssociationId"));
}

export const qUADMGetAllItlkCheckProcessToOpLinkAssociationResponse = new QUADMGetAllItlkCheckProcessToOpLinkAssociationResponse();

export class QUADMGetAllItlkCheckProcessToOpLinkAssociation extends QueryObject {
    public readonly linkId = new QGuidPath(this.withPrefix("linkId"));
}

export const qUADMGetAllItlkCheckProcessToOpLinkAssociation = new QUADMGetAllItlkCheckProcessToOpLinkAssociation();

export class QUADMGetEquipmentForToBeUsedMachineResponse extends QueryObject {
    public readonly EquipmentToBeLinked = new QStringPath(this.withPrefix("EquipmentToBeLinked"));
    public readonly EquipmentToBeLinkedId = new QGuidPath(this.withPrefix("EquipmentToBeLinkedId"));
    public readonly EquipmentToBeLinkedName = new QStringPath(this.withPrefix("EquipmentToBeLinkedName"));
    public readonly EquipmentToBeLinkedLevel = new QStringPath(this.withPrefix("EquipmentToBeLinkedLevel"));
}

export const qUADMGetEquipmentForToBeUsedMachineResponse = new QUADMGetEquipmentForToBeUsedMachineResponse();

export class QUADMGetEquipmentForToBeUsedMachine extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
}

export const qUADMGetEquipmentForToBeUsedMachine = new QUADMGetEquipmentForToBeUsedMachine();

export class QUADMGetEquipmentForEqSpecificationResponse extends QueryObject {
    public readonly EquipmentToBeLinked = new QStringPath(this.withPrefix("EquipmentToBeLinked"));
    public readonly EquipmentToBeLinkedId = new QGuidPath(this.withPrefix("EquipmentToBeLinkedId"));
    public readonly EquipmentToBeLinkedName = new QStringPath(this.withPrefix("EquipmentToBeLinkedName"));
    public readonly EquipmentToBeLinkedLevel = new QStringPath(this.withPrefix("EquipmentToBeLinkedLevel"));
}

export const qUADMGetEquipmentForEqSpecificationResponse = new QUADMGetEquipmentForEqSpecificationResponse();

export class QUADMGetEquipmentForEqSpecification extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
}

export const qUADMGetEquipmentForEqSpecification = new QUADMGetEquipmentForEqSpecification();

export class QUADM_DMMaterialTrackingUnitAndMTUResponse extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CodeType = new QStringPath(this.withPrefix("CodeType"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Code = new QStringPath(this.withPrefix("Code"));
    public readonly MaterialDefinition = new QStringPath(this.withPrefix("MaterialDefinition"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly IsResultKo = new QBooleanPath(this.withPrefix("IsResultKo"));
}

export const qUADM_DMMaterialTrackingUnitAndMTUResponse = new QUADM_DMMaterialTrackingUnitAndMTUResponse();

export class QUADM_DMMaterialTrackingUnitAndMTU extends QueryObject {
    public readonly WorkOrder = new QGuidPath(this.withPrefix("WorkOrder"));
}

export const qUADM_DMMaterialTrackingUnitAndMTU = new QUADM_DMMaterialTrackingUnitAndMTU();

export class QUADMGetAllToolCompatibleMachinesResponse extends QueryObject {
    public readonly ToolCompatibleMachineParameter = new QEntityPath(this.withPrefix("ToolCompatibleMachineParameter"), () => QToolCompatibleMachineParameterType);
}

export const qUADMGetAllToolCompatibleMachinesResponse = new QUADMGetAllToolCompatibleMachinesResponse();

export class QUADMGetAllToolCompatibleMachines extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
}

export const qUADMGetAllToolCompatibleMachines = new QUADMGetAllToolCompatibleMachines();

export class QUADMGetLinkableEquipmentResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
}

export const qUADMGetLinkableEquipmentResponse = new QUADMGetLinkableEquipmentResponse();

export class QUADMGetLinkableEquipment extends QueryObject {
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
}

export const qUADMGetLinkableEquipment = new QUADMGetLinkableEquipment();

export class QUADMGetAllToolDefinitionCompatibleMachineResponse extends QueryObject {
    public readonly ToolDefinitionCompatibleMachineParameterType = new QEntityPath(this.withPrefix("ToolDefinitionCompatibleMachineParameterType"), () => QRF_ToolDefinitionCompatibleMachineParameterType);
}

export const qUADMGetAllToolDefinitionCompatibleMachineResponse = new QUADMGetAllToolDefinitionCompatibleMachineResponse();

export class QUADMGetAllToolDefinitionCompatibleMachine extends QueryObject {
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
}

export const qUADMGetAllToolDefinitionCompatibleMachine = new QUADMGetAllToolDefinitionCompatibleMachine();

export class QUADMGetAllItlkCheckWOStepAssociationResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsStandard = new QBooleanPath(this.withPrefix("IsStandard"));
    public readonly IsInbound = new QBooleanPath(this.withPrefix("IsInbound"));
    public readonly IsOutbound = new QBooleanPath(this.withPrefix("IsOutbound"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly AssociationId = new QGuidPath(this.withPrefix("AssociationId"));
}

export const qUADMGetAllItlkCheckWOStepAssociationResponse = new QUADMGetAllItlkCheckWOStepAssociationResponse();

export class QUADMGetAllItlkCheckWOStepAssociation extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
}

export const qUADMGetAllItlkCheckWOStepAssociation = new QUADMGetAllItlkCheckWOStepAssociation();

export class QUADMGetDefectGroupSpecificationsResponse extends QueryObject {
    public readonly ContextNId = new QStringPath(this.withPrefix("ContextNId"));
    public readonly SpecificationType = new QStringPath(this.withPrefix("SpecificationType"));
    public readonly SpecificationTypeCode = new QNumberPath(this.withPrefix("SpecificationTypeCode"));
    public readonly SpecificationNId = new QStringPath(this.withPrefix("SpecificationNId"));
    public readonly DM_Material = new QEntityPath(this.withPrefix("DM_Material"), () => QUADMMaterialParameterType);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QUADMEquipmentSpecificationParameterType);
}

export const qUADMGetDefectGroupSpecificationsResponse = new QUADMGetDefectGroupSpecificationsResponse();

export class QUADMGetDefectGroupSpecifications extends QueryObject {
    public readonly DefectGroupId = new QGuidPath(this.withPrefix("DefectGroupId"));
    public readonly IncludeEquipmentConfigurations = new QBooleanPath(this.withPrefix("IncludeEquipmentConfigurations"));
    public readonly IncludeEquipmentTypes = new QBooleanPath(this.withPrefix("IncludeEquipmentTypes"));
    public readonly IncludeMaterials = new QBooleanPath(this.withPrefix("IncludeMaterials"));
}

export const qUADMGetDefectGroupSpecifications = new QUADMGetDefectGroupSpecifications();

export class QUADMGetUnitsFromWorkCenterResponse extends QueryObject {
    public readonly Units = new QEntityPath(this.withPrefix("Units"), () => QProcessMachinesParameterType);
}

export const qUADMGetUnitsFromWorkCenterResponse = new QUADMGetUnitsFromWorkCenterResponse();

export class QUADMGetUnitsFromWorkCenter extends QueryObject {
    public readonly CellNId = new QStringPath(this.withPrefix("CellNId"));
}

export const qUADMGetUnitsFromWorkCenter = new QUADMGetUnitsFromWorkCenter();

export class QUADMGetUnitsFromBufferLocationResponse extends QueryObject {
    public readonly UnitNId = new QStringPath(this.withPrefix("UnitNId"));
}

export const qUADMGetUnitsFromBufferLocationResponse = new QUADMGetUnitsFromBufferLocationResponse();

export class QUADMGetUnitsFromBufferLocation extends QueryObject {
    public readonly BufferId = new QGuidPath(this.withPrefix("BufferId"));
    public readonly LocationNId = new QStringPath(this.withPrefix("LocationNId"));
}

export const qUADMGetUnitsFromBufferLocation = new QUADMGetUnitsFromBufferLocation();

export class QUADMGetCharacteristicRepresentationResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly SampleSize = new QNumberPath(this.withPrefix("SampleSize"));
    public readonly CanBeSkipped = new QBooleanPath(this.withPrefix("CanBeSkipped"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ToBeUsedInspectionId = new QGuidPath(this.withPrefix("ToBeUsedInspectionId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly ReferencedOperationNId = new QStringPath(this.withPrefix("ReferencedOperationNId"));
    public readonly ReferencedOperationName = new QStringPath(this.withPrefix("ReferencedOperationName"));
    public readonly ReferencedOperationSequence = new QNumberPath(this.withPrefix("ReferencedOperationSequence"));
    public readonly Frequency = new QStringPath(this.withPrefix("Frequency"));
    public readonly FrequencyValue = new QNumberPath(this.withPrefix("FrequencyValue"));
    public readonly IsWOSpecific = new QBooleanPath(this.withPrefix("IsWOSpecific"));
    public readonly TimeBasedScheduleMode = new QStringPath(this.withPrefix("TimeBasedScheduleMode"));
    public readonly TimeBasedMandatoryInspectionWarningValue = new QNumberPath(this.withPrefix("TimeBasedMandatoryInspectionWarningValue"));
    public readonly TimeBasedMandatoryInspectionWarningUoM = new QStringPath(this.withPrefix("TimeBasedMandatoryInspectionWarningUoM"));
    public readonly TimeBasedMandatoryInspectionWarningUoMValue = new QNumberPath(this.withPrefix("TimeBasedMandatoryInspectionWarningUoMValue"));
}

export const qUADMGetCharacteristicRepresentationResponse = new QUADMGetCharacteristicRepresentationResponse();

export class QUADMGetCharacteristicRepresentation extends QueryObject {
    public readonly OperationID = new QGuidPath(this.withPrefix("OperationID"));
    public readonly GetFromContainer = new QBooleanPath(this.withPrefix("GetFromContainer"));
    public readonly StepID = new QGuidPath(this.withPrefix("StepID"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUADMGetCharacteristicRepresentation = new QUADMGetCharacteristicRepresentation();

export class QUADMGetAlternativeGroupsFromWorkOrderIdResponse extends QueryObject {
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
    public readonly ParentWOOpId = new QGuidPath(this.withPrefix("ParentWOOpId"));
    public readonly ParentWOOpNId = new QStringPath(this.withPrefix("ParentWOOpNId"));
    public readonly PreferredWOOpId = new QGuidPath(this.withPrefix("PreferredWOOpId"));
    public readonly PreferredWOOpNId = new QStringPath(this.withPrefix("PreferredWOOpNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAlternativeGroupsFromWorkOrderIdResponse = new QUADMGetAlternativeGroupsFromWorkOrderIdResponse();

export class QUADMGetAlternativeGroupsFromWorkOrderId extends QueryObject {
    public readonly WorkOrderId = new QGuidPath(this.withPrefix("WorkOrderId"));
}

export const qUADMGetAlternativeGroupsFromWorkOrderId = new QUADMGetAlternativeGroupsFromWorkOrderId();

export class QUADMGetQualityInspectionSamplesResponse extends QueryObject {
    public readonly QualityInspectionData = new QEntityPath(this.withPrefix("QualityInspectionData"), () => QQualityInspectionDataType);
}

export const qUADMGetQualityInspectionSamplesResponse = new QUADMGetQualityInspectionSamplesResponse();

export class QUADMGetQualityInspectionSamples extends QueryObject {
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly WorkOrder_Id = new QGuidPath(this.withPrefix("WorkOrder_Id"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
}

export const qUADMGetQualityInspectionSamples = new QUADMGetQualityInspectionSamples();

export class QUADMGetUnitsFromPlantResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUADMGetUnitsFromPlantResponse = new QUADMGetUnitsFromPlantResponse();

export class QUADMGetUnitsFromPlant extends QueryObject {
    public readonly Plant = new QStringPath(this.withPrefix("Plant"));
}

export const qUADMGetUnitsFromPlant = new QUADMGetUnitsFromPlant();

export class QUADMGetQualityForGenealogyResponse extends QueryObject {
    public readonly QualityInspectionData = new QEntityPath(this.withPrefix("QualityInspectionData"), () => QQualityInspectionDataType);
}

export const qUADMGetQualityForGenealogyResponse = new QUADMGetQualityForGenealogyResponse();

export class QUADMGetQualityForGenealogy extends QueryObject {
    public readonly WorkOrderOperation_Id = new QGuidPath(this.withPrefix("WorkOrderOperation_Id"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly WorkOrderStep_Id = new QGuidPath(this.withPrefix("WorkOrderStep_Id"));
}

export const qUADMGetQualityForGenealogy = new QUADMGetQualityForGenealogy();

export class QUADMGetStartableItemsOnWOStepResponse extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ProductionType = new QStringPath(this.withPrefix("ProductionType"));
    public readonly MaterialTrackingUnit_MaterialNId = new QStringPath(this.withPrefix("MaterialTrackingUnit_MaterialNId"));
    public readonly MaterialTrackingUnit_Quantity_UoM = new QStringPath(this.withPrefix("MaterialTrackingUnit_Quantity_UoM"));
    public readonly MaterialTrackingUnit_Quantity_Quantity = new QNumberPath(this.withPrefix("MaterialTrackingUnit_Quantity_Quantity"));
    public readonly MaterialTrackingUnit_Status_StateMachine = new QStringPath(this.withPrefix("MaterialTrackingUnit_Status_StateMachine"));
    public readonly MaterialTrackingUnit_Status_Status = new QStringPath(this.withPrefix("MaterialTrackingUnit_Status_Status"));
    public readonly MaterialTrackingUnit_Code = new QStringPath(this.withPrefix("MaterialTrackingUnit_Code"));
    public readonly MaterialTrackingUnit_Name = new QStringPath(this.withPrefix("MaterialTrackingUnit_Name"));
    public readonly MaterialTrackingUnit_NId = new QStringPath(this.withPrefix("MaterialTrackingUnit_NId"));
    public readonly Equipment_Name = new QStringPath(this.withPrefix("Equipment_Name"));
    public readonly Equipment_Type = new QStringPath(this.withPrefix("Equipment_Type"));
    public readonly Equipment_IsCbduEnabled = new QBooleanPath(this.withPrefix("Equipment_IsCbduEnabled"));
    public readonly Equipment_Level = new QStringPath(this.withPrefix("Equipment_Level"));
}

export const qUADMGetStartableItemsOnWOStepResponse = new QUADMGetStartableItemsOnWOStepResponse();

export class QUADMGetStartableItemsOnWOStep extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qUADMGetStartableItemsOnWOStep = new QUADMGetStartableItemsOnWOStep();

export class QUADMGetCompletableItemsOnWOStepResponse extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MaterialTrackingUnitId = new QGuidPath(this.withPrefix("DM_MaterialTrackingUnitId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ProductionType = new QStringPath(this.withPrefix("ProductionType"));
    public readonly MaterialTrackingUnit_MaterialNId = new QStringPath(this.withPrefix("MaterialTrackingUnit_MaterialNId"));
    public readonly MaterialTrackingUnit_Quantity_UoM = new QStringPath(this.withPrefix("MaterialTrackingUnit_Quantity_UoM"));
    public readonly MaterialTrackingUnit_Quantity_Quantity = new QNumberPath(this.withPrefix("MaterialTrackingUnit_Quantity_Quantity"));
    public readonly MaterialTrackingUnit_Status_StateMachine = new QStringPath(this.withPrefix("MaterialTrackingUnit_Status_StateMachine"));
    public readonly MaterialTrackingUnit_Status_Status = new QStringPath(this.withPrefix("MaterialTrackingUnit_Status_Status"));
    public readonly MaterialTrackingUnit_Code = new QStringPath(this.withPrefix("MaterialTrackingUnit_Code"));
    public readonly MaterialTrackingUnit_Name = new QStringPath(this.withPrefix("MaterialTrackingUnit_Name"));
    public readonly MaterialTrackingUnit_NId = new QStringPath(this.withPrefix("MaterialTrackingUnit_NId"));
    public readonly Equipment_Name = new QStringPath(this.withPrefix("Equipment_Name"));
    public readonly Equipment_Type = new QStringPath(this.withPrefix("Equipment_Type"));
    public readonly Equipment_IsCbduEnabled = new QBooleanPath(this.withPrefix("Equipment_IsCbduEnabled"));
    public readonly Equipment_Level = new QStringPath(this.withPrefix("Equipment_Level"));
}

export const qUADMGetCompletableItemsOnWOStepResponse = new QUADMGetCompletableItemsOnWOStepResponse();

export class QUADMGetCompletableItemsOnWOStep extends QueryObject {
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
}

export const qUADMGetCompletableItemsOnWOStep = new QUADMGetCompletableItemsOnWOStep();

export class QUADMGetAllPrintJobFilesResponse extends QueryObject {
    public readonly IsEditable = new QBooleanPath(this.withPrefix("IsEditable"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly BuildtrayLayout = new QStringPath(this.withPrefix("BuildtrayLayout"));
    public readonly ExternalId = new QStringPath(this.withPrefix("ExternalId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly ProductSerializable = new QBooleanPath(this.withPrefix("ProductSerializable"));
    public readonly ProductSerialNumberManagement = new QStringPath(this.withPrefix("ProductSerialNumberManagement"));
    public readonly RunTimeOnly = new QBooleanPath(this.withPrefix("RunTimeOnly"));
    public readonly Source = new QStringPath(this.withPrefix("Source"));
    public readonly TestBars = new QBooleanPath(this.withPrefix("TestBars"));
    public readonly TestBarsNumber = new QNumberPath(this.withPrefix("TestBarsNumber"));
    public readonly TestBarsSerializable = new QBooleanPath(this.withPrefix("TestBarsSerializable"));
    public readonly TestBarsSerialNumberManagement = new QStringPath(this.withPrefix("TestBarsSerialNumberManagement"));
    public readonly ProductionPrinter = new QStringPath(this.withPrefix("ProductionPrinter"));
    public readonly EstimatedMaterialConsumption = new QEntityPath(this.withPrefix("EstimatedMaterialConsumption"), () => QQuantityParameterType);
    public readonly MaxProducedHeight = new QEntityPath(this.withPrefix("MaxProducedHeight"), () => QQuantityParameterType);
    public readonly EstimatedPrintDurationHours = new QNumberPath(this.withPrefix("EstimatedPrintDurationHours"));
    public readonly EstimatedPrintDurationMinutes = new QNumberPath(this.withPrefix("EstimatedPrintDurationMinutes"));
    public readonly EstimatedPrintDurationSeconds = new QNumberPath(this.withPrefix("EstimatedPrintDurationSeconds"));
    public readonly EstimatedBuildProcessDurationHours = new QNumberPath(this.withPrefix("EstimatedBuildProcessDurationHours"));
    public readonly EstimatedBuildProcessDurationMinutes = new QNumberPath(this.withPrefix("EstimatedBuildProcessDurationMinutes"));
    public readonly EstimatedBuildProcessDurationSeconds = new QNumberPath(this.withPrefix("EstimatedBuildProcessDurationSeconds"));
}

export const qUADMGetAllPrintJobFilesResponse = new QUADMGetAllPrintJobFilesResponse();

export class QUADMGetAllPrintJobFiles extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAllPrintJobFiles = new QUADMGetAllPrintJobFiles();

export class QUADMGetAlternativeGroupsFromProcessIdResponse extends QueryObject {
    public readonly AlternativeGroup = new QStringPath(this.withPrefix("AlternativeGroup"));
    public readonly ParentProcessToOpLinkId = new QGuidPath(this.withPrefix("ParentProcessToOpLinkId"));
    public readonly ParentProcessToOpLinkNId = new QStringPath(this.withPrefix("ParentProcessToOpLinkNId"));
    public readonly PreferredProcessToOpLinkId = new QGuidPath(this.withPrefix("PreferredProcessToOpLinkId"));
    public readonly PreferredProcessToOpLinkNId = new QStringPath(this.withPrefix("PreferredProcessToOpLinkNId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAlternativeGroupsFromProcessIdResponse = new QUADMGetAlternativeGroupsFromProcessIdResponse();

export class QUADMGetAlternativeGroupsFromProcessId extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
}

export const qUADMGetAlternativeGroupsFromProcessId = new QUADMGetAlternativeGroupsFromProcessId();

export class QUADMGetPrintJobFilesFromAssociationsResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ExternalId = new QStringPath(this.withPrefix("ExternalId"));
    public readonly IsSourcePJF = new QBooleanPath(this.withPrefix("IsSourcePJF"));
}

export const qUADMGetPrintJobFilesFromAssociationsResponse = new QUADMGetPrintJobFilesFromAssociationsResponse();

export class QUADMGetPrintJobFilesFromAssociations extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly DM_MaterialNId = new QStringPath(this.withPrefix("DM_MaterialNId"));
}

export const qUADMGetPrintJobFilesFromAssociations = new QUADMGetPrintJobFilesFromAssociations();

export class QUADMGetWOByProcessRevisionResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly CreationDate = new QDateTimeOffsetPath(this.withPrefix("CreationDate"));
    public readonly Process = new QStringPath(this.withPrefix("Process"));
    public readonly ProcessName = new QStringPath(this.withPrefix("ProcessName"));
    public readonly ProcessRevision = new QStringPath(this.withPrefix("ProcessRevision"));
    public readonly PBOPIdentID = new QStringPath(this.withPrefix("PBOPIdentID"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qUADMGetWOByProcessRevisionResponse = new QUADMGetWOByProcessRevisionResponse();

export class QUADMGetWOByProcessRevision extends QueryObject {
}

export const qUADMGetWOByProcessRevision = new QUADMGetWOByProcessRevision();

export class QUADMGetStepForCatalogResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDurationHours = new QNumberPath(this.withPrefix("EstimatedDurationHours"));
    public readonly EstimatedDurationMinutes = new QNumberPath(this.withPrefix("EstimatedDurationMinutes"));
    public readonly EstimatedDurationSeconds = new QNumberPath(this.withPrefix("EstimatedDurationSeconds"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly OperationStepCategoryNId = new QStringPath(this.withPrefix("OperationStepCategoryNId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly Optional = new QBooleanPath(this.withPrefix("Optional"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
}

export const qUADMGetStepForCatalogResponse = new QUADMGetStepForCatalogResponse();

export class QUADMGetStepForCatalog extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetStepForCatalog = new QUADMGetStepForCatalog();

export class QUADMGetAllEquipmentFor3DPrinterResponse extends QueryObject {
    public readonly Equipment3DPrinter = new QEntityPath(this.withPrefix("Equipment3DPrinter"), () => QEquipment3DPrinterParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAllEquipmentFor3DPrinterResponse = new QUADMGetAllEquipmentFor3DPrinterResponse();

export class QUADMGetAllEquipmentFor3DPrinter extends QueryObject {
}

export const qUADMGetAllEquipmentFor3DPrinter = new QUADMGetAllEquipmentFor3DPrinter();

export class QUADMGetAllToolDefinitionAutomationNodeTypeResponse extends QueryObject {
    public readonly AutomationNodeTypeParameterType = new QEntityPath(this.withPrefix("AutomationNodeTypeParameterType"), () => QAutomationNodeTypeParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAllToolDefinitionAutomationNodeTypeResponse = new QUADMGetAllToolDefinitionAutomationNodeTypeResponse();

export class QUADMGetAllToolDefinitionAutomationNodeType extends QueryObject {
    public readonly ToolDefinitionId = new QGuidPath(this.withPrefix("ToolDefinitionId"));
}

export const qUADMGetAllToolDefinitionAutomationNodeType = new QUADMGetAllToolDefinitionAutomationNodeType();

export class QUADMGetAllToolAutomationNodeInstanceResponse extends QueryObject {
    public readonly AutomationNodeInstanceParameterType = new QEntityPath(this.withPrefix("AutomationNodeInstanceParameterType"), () => QAutomationNodeInstanceParameterType);
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetAllToolAutomationNodeInstanceResponse = new QUADMGetAllToolAutomationNodeInstanceResponse();

export class QUADMGetAllToolAutomationNodeInstance extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
}

export const qUADMGetAllToolAutomationNodeInstance = new QUADMGetAllToolAutomationNodeInstance();

export class QUADMGetToolDefinationsBySetPointResponse extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Consumable = new QBooleanPath(this.withPrefix("Consumable"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly RevisionExpression = new QStringPath(this.withPrefix("RevisionExpression"));
    public readonly Volume = new QNumberPath(this.withPrefix("Volume"));
    public readonly VolumeUoM = new QStringPath(this.withPrefix("VolumeUoM"));
    public readonly Weight = new QNumberPath(this.withPrefix("Weight"));
    public readonly WeightUoM = new QStringPath(this.withPrefix("WeightUoM"));
    public readonly LogisticClass = new QStringPath(this.withPrefix("LogisticClass"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetToolDefinationsBySetPointResponse = new QUADMGetToolDefinationsBySetPointResponse();

export class QUADMGetToolDefinationsBySetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
}

export const qUADMGetToolDefinationsBySetPoint = new QUADMGetToolDefinationsBySetPoint();

export class QUADMGetToolBySetPointResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UsageCounter = new QNumberPath(this.withPrefix("UsageCounter"));
    public readonly Lockable = new QBooleanPath(this.withPrefix("Lockable"));
    public readonly Locked = new QBooleanPath(this.withPrefix("Locked"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly IsScrapped = new QBooleanPath(this.withPrefix("IsScrapped"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly Volume = new QNumberPath(this.withPrefix("Volume"));
    public readonly VolumeUoM = new QStringPath(this.withPrefix("VolumeUoM"));
    public readonly Weight = new QNumberPath(this.withPrefix("Weight"));
    public readonly WeightUoM = new QStringPath(this.withPrefix("WeightUoM"));
    public readonly LogisticClass = new QStringPath(this.withPrefix("LogisticClass"));
    public readonly Definition = new QStringPath(this.withPrefix("Definition"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetToolBySetPointResponse = new QUADMGetToolBySetPointResponse();

export class QUADMGetToolBySetPoint extends QueryObject {
    public readonly SetPointId = new QGuidPath(this.withPrefix("SetPointId"));
}

export const qUADMGetToolBySetPoint = new QUADMGetToolBySetPoint();

export class QUADMGetDNCItemsFromAssociationsResponse extends QueryObject {
    public readonly DNCItemId = new QGuidPath(this.withPrefix("DNCItemId"));
    public readonly DNCId = new QStringPath(this.withPrefix("DNCId"));
    public readonly DNCExternalId = new QStringPath(this.withPrefix("DNCExternalId"));
}

export const qUADMGetDNCItemsFromAssociationsResponse = new QUADMGetDNCItemsFromAssociationsResponse();

export class QUADMGetDNCItemsFromAssociations extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly DM_MaterialNId = new QStringPath(this.withPrefix("DM_MaterialNId"));
}

export const qUADMGetDNCItemsFromAssociations = new QUADMGetDNCItemsFromAssociations();

export class QUADMGetOperationToStepLinkResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDurationHours = new QNumberPath(this.withPrefix("EstimatedDurationHours"));
    public readonly EstimatedDurationMinutes = new QNumberPath(this.withPrefix("EstimatedDurationMinutes"));
    public readonly EstimatedDurationSeconds = new QNumberPath(this.withPrefix("EstimatedDurationSeconds"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly OperationStepCategoryNId = new QStringPath(this.withPrefix("OperationStepCategoryNId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly ChildStepId = new QGuidPath(this.withPrefix("ChildStepId"));
}

export const qUADMGetOperationToStepLinkResponse = new QUADMGetOperationToStepLinkResponse();

export class QUADMGetOperationToStepLink extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUADMGetOperationToStepLink = new QUADMGetOperationToStepLink();

export class QUADMGetWOStepsResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly UID = new QStringPath(this.withPrefix("UID"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly EstimatedDurationHours = new QNumberPath(this.withPrefix("EstimatedDurationHours"));
    public readonly EstimatedDurationMinutes = new QNumberPath(this.withPrefix("EstimatedDurationMinutes"));
    public readonly EstimatedDurationSeconds = new QNumberPath(this.withPrefix("EstimatedDurationSeconds"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly OperationStepCategoryNId = new QStringPath(this.withPrefix("OperationStepCategoryNId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly NextSequence = new QNumberPath(this.withPrefix("NextSequence"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
    public readonly EstimatedDuration = new QStringPath(this.withPrefix("EstimatedDuration"));
}

export const qUADMGetWOStepsResponse = new QUADMGetWOStepsResponse();

export class QUADMGetWOSteps extends QueryObject {
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly WOId = new QGuidPath(this.withPrefix("WOId"));
    public readonly GetNextSequence = new QBooleanPath(this.withPrefix("GetNextSequence"));
}

export const qUADMGetWOSteps = new QUADMGetWOSteps();

export class QUADMGetAllWorkOrderPrintJobFileAssociationResponse extends QueryObject {
    public readonly WorkOrderPrintJobFileParameter = new QEntityPath(this.withPrefix("WorkOrderPrintJobFileParameter"), () => QPrintJobFileWorkOrderParameterType);
}

export const qUADMGetAllWorkOrderPrintJobFileAssociationResponse = new QUADMGetAllWorkOrderPrintJobFileAssociationResponse();

export class QUADMGetAllWorkOrderPrintJobFileAssociation extends QueryObject {
    public readonly PrintJobFileId = new QGuidPath(this.withPrefix("PrintJobFileId"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
}

export const qUADMGetAllWorkOrderPrintJobFileAssociation = new QUADMGetAllWorkOrderPrintJobFileAssociation();

export class QUADMGetBufferHistoryResponse extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly Date = new QDateTimeOffsetPath(this.withPrefix("Date"));
    public readonly ActionNId = new QStringPath(this.withPrefix("ActionNId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
}

export const qUADMGetBufferHistoryResponse = new QUADMGetBufferHistoryResponse();

export class QUADMGetBufferHistory extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUADMGetBufferHistory = new QUADMGetBufferHistory();

export class QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypesResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly Behaviour = new QStringPath(this.withPrefix("Behaviour"));
    public readonly MaterialDefinitionId = new QGuidPath(this.withPrefix("MaterialDefinitionId"));
    public readonly WorkOperationId = new QGuidPath(this.withPrefix("WorkOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly PrekitSerialNumber = new QStringPath(this.withPrefix("PrekitSerialNumber"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly GroupName = new QStringPath(this.withPrefix("GroupName"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly SerialNumberProfile = new QBooleanPath(this.withPrefix("SerialNumberProfile"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly HasPrekit = new QBooleanPath(this.withPrefix("HasPrekit"));
    public readonly OccurrenceId = new QStringPath(this.withPrefix("OccurrenceId"));
}

export const qUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypesResponse = new QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypesResponse();

export class QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes = new QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes();

export class QUADMGetCertificationDetailsResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NumberOfUsers = new QNumberPath(this.withPrefix("NumberOfUsers"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly CertificationName = new QStringPath(this.withPrefix("CertificationName"));
    public readonly CertificationDesc = new QStringPath(this.withPrefix("CertificationDesc"));
    public readonly AsPlannedBoPId = new QGuidPath(this.withPrefix("AsPlannedBoPId"));
    public readonly MasterPlanId = new QGuidPath(this.withPrefix("MasterPlanId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
}

export const qUADMGetCertificationDetailsResponse = new QUADMGetCertificationDetailsResponse();

export class QUADMGetCertificationDetails extends QueryObject {
    public readonly ParentID = new QStringPath(this.withPrefix("ParentID"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUADMGetCertificationDetails = new QUADMGetCertificationDetails();

export class QUADMGetWorkOrderHumanResourceDetailsResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NumberOfUsers = new QNumberPath(this.withPrefix("NumberOfUsers"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly CertificationNId = new QStringPath(this.withPrefix("CertificationNId"));
    public readonly CertificationName = new QStringPath(this.withPrefix("CertificationName"));
    public readonly CertificationDesc = new QStringPath(this.withPrefix("CertificationDesc"));
}

export const qUADMGetWorkOrderHumanResourceDetailsResponse = new QUADMGetWorkOrderHumanResourceDetailsResponse();

export class QUADMGetWorkOrderHumanResourceDetails extends QueryObject {
    public readonly WorkOrderOperationID = new QGuidPath(this.withPrefix("WorkOrderOperationID"));
    public readonly WorkOrderStepID = new QGuidPath(this.withPrefix("WorkOrderStepID"));
}

export const qUADMGetWorkOrderHumanResourceDetails = new QUADMGetWorkOrderHumanResourceDetails();

export class QUADMGetOfflineSessionWOOperationAssociationsResponse extends QueryObject {
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ElectronicSignatureComplete = new QBooleanPath(this.withPrefix("ElectronicSignatureComplete"));
    public readonly ElectronicSignaturePause = new QBooleanPath(this.withPrefix("ElectronicSignaturePause"));
    public readonly ElectronicSignatureStart = new QBooleanPath(this.withPrefix("ElectronicSignatureStart"));
    public readonly EstimatedEndTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedEndTime"));
    public readonly EstimatedStartTime = new QDateTimeOffsetPath(this.withPrefix("EstimatedStartTime"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly Priority = new QNumberPath(this.withPrefix("Priority"));
    public readonly RequiredCertificateNId = new QStringPath(this.withPrefix("RequiredCertificateNId"));
    public readonly RequiredInspectionRole = new QStringPath(this.withPrefix("RequiredInspectionRole"));
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly ToBeCollectedDocument = new QBooleanPath(this.withPrefix("ToBeCollectedDocument"));
    public readonly WorkOperationTypeId = new QGuidPath(this.withPrefix("WorkOperationTypeId"));
    public readonly OperationStepCategoryId = new QGuidPath(this.withPrefix("OperationStepCategoryId"));
    public readonly ERPConfirmationId = new QStringPath(this.withPrefix("ERPConfirmationId"));
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
    public readonly WorkOrderName = new QStringPath(this.withPrefix("WorkOrderName"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly WorkOrderProductionTypeNId = new QStringPath(this.withPrefix("WorkOrderProductionTypeNId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
    public readonly PreviousStatus = new QStringPath(this.withPrefix("PreviousStatus"));
    public readonly TargetQuantity = new QNumberPath(this.withPrefix("TargetQuantity"));
    public readonly AvailableQuantity = new QNumberPath(this.withPrefix("AvailableQuantity"));
    public readonly ReworkedQuantity = new QNumberPath(this.withPrefix("ReworkedQuantity"));
    public readonly IsReady = new QBooleanPath(this.withPrefix("IsReady"));
    public readonly OperationNId = new QStringPath(this.withPrefix("OperationNId"));
    public readonly WorkOperationTypeNId = new QStringPath(this.withPrefix("WorkOperationTypeNId"));
    public readonly PartialWorkedQuantity = new QNumberPath(this.withPrefix("PartialWorkedQuantity"));
    public readonly EstimatedDurationHours = new QNumberPath(this.withPrefix("EstimatedDurationHours"));
    public readonly EstimatedDurationMinutes = new QNumberPath(this.withPrefix("EstimatedDurationMinutes"));
    public readonly EstimatedDurationSeconds = new QNumberPath(this.withPrefix("EstimatedDurationSeconds"));
    public readonly OperationStepCategoryNId = new QStringPath(this.withPrefix("OperationStepCategoryNId"));
    public readonly ActiveNonConformanceNr = new QNumberPath(this.withPrefix("ActiveNonConformanceNr"));
    public readonly ActualStartTime = new QDateTimeOffsetPath(this.withPrefix("ActualStartTime"));
    public readonly ActualEndTime = new QDateTimeOffsetPath(this.withPrefix("ActualEndTime"));
}

export const qUADMGetOfflineSessionWOOperationAssociationsResponse = new QUADMGetOfflineSessionWOOperationAssociationsResponse();

export class QUADMGetOfflineSessionWOOperationAssociations extends QueryObject {
    public readonly OfflineSessionId = new QGuidPath(this.withPrefix("OfflineSessionId"));
}

export const qUADMGetOfflineSessionWOOperationAssociations = new QUADMGetOfflineSessionWOOperationAssociations();

export class QUADMGetMaterialSpecificationTypeIndicatorResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly StepId = new QGuidPath(this.withPrefix("StepId"));
    public readonly AlternativeSelected = new QBooleanPath(this.withPrefix("AlternativeSelected"));
    public readonly MaterialDefinitionNId = new QStringPath(this.withPrefix("MaterialDefinitionNId"));
    public readonly LogicalPosition = new QStringPath(this.withPrefix("LogicalPosition"));
    public readonly Behaviour = new QStringPath(this.withPrefix("Behaviour"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly SerialNumberprofile = new QBooleanPath(this.withPrefix("SerialNumberprofile"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly GroupName = new QStringPath(this.withPrefix("GroupName"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qUADMGetMaterialSpecificationTypeIndicatorResponse = new QUADMGetMaterialSpecificationTypeIndicatorResponse();

export class QUADMGetMaterialSpecificationTypeIndicator extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly AsPlannedBOP_Id = new QGuidPath(this.withPrefix("AsPlannedBOP_Id"));
}

export const qUADMGetMaterialSpecificationTypeIndicator = new QUADMGetMaterialSpecificationTypeIndicator();

export class QUADMGetAllOfflineSessionsResponse extends QueryObject {
    public readonly UserId = new QStringPath(this.withPrefix("UserId"));
    public readonly DownloadDate = new QDateTimeOffsetPath(this.withPrefix("DownloadDate"));
    public readonly UploadDate = new QDateTimeOffsetPath(this.withPrefix("UploadDate"));
    public readonly CheckInDate = new QDateTimeOffsetPath(this.withPrefix("CheckInDate"));
    public readonly DeviceId = new QStringPath(this.withPrefix("DeviceId"));
    public readonly Status_StateMachineNId = new QStringPath(this.withPrefix("Status_StateMachineNId"));
    public readonly Status_StatusNId = new QStringPath(this.withPrefix("Status_StatusNId"));
    public readonly ActionCheckedIn = new QStringPath(this.withPrefix("ActionCheckedIn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
}

export const qUADMGetAllOfflineSessionsResponse = new QUADMGetAllOfflineSessionsResponse();

export class QUADMGetAllOfflineSessions extends QueryObject {
}

export const qUADMGetAllOfflineSessions = new QUADMGetAllOfflineSessions();

export class QUADMGetProcessOperationDetailsResponse extends QueryObject {
    public readonly ProcessOperationNId = new QStringPath(this.withPrefix("ProcessOperationNId"));
    public readonly ProcessOperationName = new QStringPath(this.withPrefix("ProcessOperationName"));
    public readonly ProcessToOperationLinkId = new QGuidPath(this.withPrefix("ProcessToOperationLinkId"));
    public readonly ProcessOperationSequence = new QNumberPath(this.withPrefix("ProcessOperationSequence"));
}

export const qUADMGetProcessOperationDetailsResponse = new QUADMGetProcessOperationDetailsResponse();

export class QUADMGetProcessOperationDetails extends QueryObject {
    public readonly ProcessId = new QGuidPath(this.withPrefix("ProcessId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUADMGetProcessOperationDetails = new QUADMGetProcessOperationDetails();

export class QUADMGetProcessStepDetailsResponse extends QueryObject {
    public readonly ProcessStepNId = new QStringPath(this.withPrefix("ProcessStepNId"));
    public readonly ProcessStepName = new QStringPath(this.withPrefix("ProcessStepName"));
    public readonly ProcessStepId = new QGuidPath(this.withPrefix("ProcessStepId"));
}

export const qUADMGetProcessStepDetailsResponse = new QUADMGetProcessStepDetailsResponse();

export class QUADMGetProcessStepDetails extends QueryObject {
    public readonly OperationId = new QGuidPath(this.withPrefix("OperationId"));
    public readonly AsPlannedBOPId = new QGuidPath(this.withPrefix("AsPlannedBOPId"));
}

export const qUADMGetProcessStepDetails = new QUADMGetProcessStepDetails();

export class QUADMGetAllDocumentsFromDM_MaterialTrackingUnitIdsResponse extends QueryObject {
    public readonly MIMEType = new QStringPath(this.withPrefix("MIMEType"));
    public readonly File_Id_Id = new QGuidPath(this.withPrefix("File_Id_Id"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AId = new QGuidPath(this.withPrefix("AId"));
    public readonly CreatedOn = new QStringPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QStringPath(this.withPrefix("LastUpdatedOn"));
    public readonly FileName = new QStringPath(this.withPrefix("FileName"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly CorrelationId = new QStringPath(this.withPrefix("CorrelationId"));
    public readonly DatasetNId = new QStringPath(this.withPrefix("DatasetNId"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUADMGetAllDocumentsFromDM_MaterialTrackingUnitIdsResponse = new QUADMGetAllDocumentsFromDM_MaterialTrackingUnitIdsResponse();

export class QUADMGetAllDocumentsFromDM_MaterialTrackingUnitIds extends QueryObject {
    public readonly DM_MTUIds = new QCollectionPath(this.withPrefix("DM_MTUIds"), () => QGuidCollection);
}

export const qUADMGetAllDocumentsFromDM_MaterialTrackingUnitIds = new QUADMGetAllDocumentsFromDM_MaterialTrackingUnitIds();

export class QUADMGetSerialNumberStatusForGenealogyResponse extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Status = new QStringPath(this.withPrefix("Status"));
}

export const qUADMGetSerialNumberStatusForGenealogyResponse = new QUADMGetSerialNumberStatusForGenealogyResponse();

export class QUADMGetSerialNumberStatusForGenealogy extends QueryObject {
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
}

export const qUADMGetSerialNumberStatusForGenealogy = new QUADMGetSerialNumberStatusForGenealogy();

export class QUADMGetAllConsumedDM_MTUForProducedDM_MTUResponse extends QueryObject {
    public readonly ProducedDM_MTUId = new QGuidPath(this.withPrefix("ProducedDM_MTUId"));
    public readonly ProducedMTUId = new QGuidPath(this.withPrefix("ProducedMTUId"));
    public readonly ProducedMTUCode = new QStringPath(this.withPrefix("ProducedMTUCode"));
    public readonly ProducedMTUNId = new QStringPath(this.withPrefix("ProducedMTUNId"));
    public readonly ProducedMTUCodeType = new QStringPath(this.withPrefix("ProducedMTUCodeType"));
    public readonly ProducedDM_MTUQuantity = new QNumberPath(this.withPrefix("ProducedDM_MTUQuantity"));
    public readonly DM_MTUId = new QGuidPath(this.withPrefix("DM_MTUId"));
    public readonly MTUId = new QGuidPath(this.withPrefix("MTUId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly MTUCodeType = new QStringPath(this.withPrefix("MTUCodeType"));
    public readonly ProducedMaterialNId = new QStringPath(this.withPrefix("ProducedMaterialNId"));
    public readonly ProducedMaterialRevision = new QStringPath(this.withPrefix("ProducedMaterialRevision"));
    public readonly ConsumedQuantity = new QNumberPath(this.withPrefix("ConsumedQuantity"));
    public readonly ActualQuantity = new QNumberPath(this.withPrefix("ActualQuantity"));
    public readonly ConsumptionDateTime = new QDateTimeOffsetPath(this.withPrefix("ConsumptionDateTime"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ExecutionGroupPhaseId = new QGuidPath(this.withPrefix("ExecutionGroupPhaseId"));
    public readonly WorkOrderOperationId = new QGuidPath(this.withPrefix("WorkOrderOperationId"));
    public readonly WorkOrderStepId = new QGuidPath(this.withPrefix("WorkOrderStepId"));
    public readonly MTUStateMachine = new QStringPath(this.withPrefix("MTUStateMachine"));
    public readonly MTUStatus = new QStringPath(this.withPrefix("MTUStatus"));
    public readonly ParentDM_MTUId = new QGuidPath(this.withPrefix("ParentDM_MTUId"));
    public readonly CurrentLocation = new QStringPath(this.withPrefix("CurrentLocation"));
    public readonly MaterialSpecificationType = new QStringPath(this.withPrefix("MaterialSpecificationType"));
    public readonly DM_MaterialId = new QGuidPath(this.withPrefix("DM_MaterialId"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly MaterialNId = new QStringPath(this.withPrefix("MaterialNId"));
    public readonly MaterialRevision = new QStringPath(this.withPrefix("MaterialRevision"));
    public readonly ProducedMaterialItemId = new QGuidPath(this.withPrefix("ProducedMaterialItemId"));
}

export const qUADMGetAllConsumedDM_MTUForProducedDM_MTUResponse = new QUADMGetAllConsumedDM_MTUForProducedDM_MTUResponse();

export class QUADMGetAllConsumedDM_MTUForProducedDM_MTU extends QueryObject {
    public readonly ProducedDM_MTUId = new QGuidPath(this.withPrefix("ProducedDM_MTUId"));
    public readonly ProducedMTUCode = new QStringPath(this.withPrefix("ProducedMTUCode"));
    public readonly ProducedMaterialNId = new QStringPath(this.withPrefix("ProducedMaterialNId"));
    public readonly ProducedMaterialRevision = new QStringPath(this.withPrefix("ProducedMaterialRevision"));
}

export const qUADMGetAllConsumedDM_MTUForProducedDM_MTU = new QUADMGetAllConsumedDM_MTUForProducedDM_MTU();

export class QIQueryable extends QueryObject {
}

export const qIQueryable = new QIQueryable();

export class QAPPMain_GF_GetBomItemsResponse extends QueryObject {
    public readonly DocumentId = new QGuidPath(this.withPrefix("DocumentId"));
    public readonly Material = new QStringPath(this.withPrefix("Material"));
    public readonly BOMItem = new QStringPath(this.withPrefix("BOMItem"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly UoM = new QStringPath(this.withPrefix("UoM"));
    public readonly Traceable = new QBooleanPath(this.withPrefix("Traceable"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ParentBOM = new QGuidPath(this.withPrefix("ParentBOM"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly MaterialId = new QGuidPath(this.withPrefix("MaterialId"));
    public readonly BOM = new QStringPath(this.withPrefix("BOM"));
    public readonly FinalMaterial = new QStringPath(this.withPrefix("FinalMaterial"));
    public readonly FinalMaterialId = new QGuidPath(this.withPrefix("FinalMaterialId"));
    public readonly IsRoot = new QBooleanPath(this.withPrefix("IsRoot"));
    public readonly BomId = new QGuidPath(this.withPrefix("BomId"));
    public readonly SubBomId = new QGuidPath(this.withPrefix("SubBomId"));
    public readonly PositionNumber = new QStringPath(this.withPrefix("PositionNumber"));
}

export const qAPPMain_GF_GetBomItemsResponse = new QAPPMain_GF_GetBomItemsResponse();

export class QAPPMain_GF_GetBomItems extends QueryObject {
    public readonly WorkOrderNId = new QStringPath(this.withPrefix("WorkOrderNId"));
}

export const qAPPMain_GF_GetBomItems = new QAPPMain_GF_GetBomItems();

export class QFileType extends QueryObject {
    public readonly contents = new QStringPath(this.withPrefix("contents"));
    public readonly type = new QStringPath(this.withPrefix("type"));
    public readonly name = new QStringPath(this.withPrefix("name"));
    public readonly data = new QStringPath(this.withPrefix("data"));
}

export const qFileType = new QFileType();

export class QToolAGW_ToolOnWorkplaceResponse extends QueryObject {
    public readonly WorkplaceNId = new QStringPath(this.withPrefix("WorkplaceNId"));
    public readonly WorkplaceName = new QStringPath(this.withPrefix("WorkplaceName"));
    public readonly WorkplaceDescription = new QStringPath(this.withPrefix("WorkplaceDescription"));
    public readonly ToolDefinitionNId = new QStringPath(this.withPrefix("ToolDefinitionNId"));
    public readonly ToolDefinitionLogisticClass = new QStringPath(this.withPrefix("ToolDefinitionLogisticClass"));
    public readonly AutomationNodeInstanceNIds = new QCollectionPath(this.withPrefix("AutomationNodeInstanceNIds"), () => QStringCollection);
    public readonly WorkplaceId = new QGuidPath(this.withPrefix("WorkplaceId"));
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
}

export const qToolAGW_ToolOnWorkplaceResponse = new QToolAGW_ToolOnWorkplaceResponse();

export class QToolAGW_ToolOnWorkplace extends QueryObject {
    public readonly ToolId = new QGuidPath(this.withPrefix("ToolId"));
}

export const qToolAGW_ToolOnWorkplace = new QToolAGW_ToolOnWorkplace();

export class QBaseResponse extends QCommandResponse {
}

export const qBaseResponse = new QBaseResponse();

export class QSignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types extends QueryObject {
    public readonly Type = new QEnumPath(this.withPrefix("Type"), SignatureTypeEnum);
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FullName = new QStringPath(this.withPrefix("FullName"));
}

export const qSignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types = new QSignerValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types();

export class QScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly ActionLabel = new QStringPath(this.withPrefix("ActionLabel"));
}

export const qScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types = new QScenarioConfigurationValueType_Siemens_SimaticIT_MasterData_ES_MS_MSModel_Types();

export class QMaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qMaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types = new QMaterialValueType_Siemens_SimaticIT_UADM_MasterData_FB_MS_MAT_MSModel_Types();

export class QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types extends QueryObject {
    public readonly Dirty = new QBooleanPath(this.withPrefix("Dirty"));
    public readonly Activated = new QBooleanPath(this.withPrefix("Activated"));
    public readonly Ready = new QBooleanPath(this.withPrefix("Ready"));
    public readonly Dismissed = new QBooleanPath(this.withPrefix("Dismissed"));
    public readonly ConfirmedOn = new QDateTimeOffsetPath(this.withPrefix("ConfirmedOn"));
}

export const qActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types = new QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types();

export class QTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types extends QueryObject {
    public readonly ChannelNId = new QStringPath(this.withPrefix("ChannelNId"));
    public readonly Address = new QStringPath(this.withPrefix("Address"));
    public readonly AcquisitionCycleNId = new QStringPath(this.withPrefix("AcquisitionCycleNId"));
    public readonly DeltaValue = new QNumberPath(this.withPrefix("DeltaValue"));
    public readonly SmoothingMode = new QEnumPath(this.withPrefix("SmoothingMode"), TagSmoothingMode);
    public readonly AcquisitionMode = new QEnumPath(this.withPrefix("AcquisitionMode"), TagAcquisitionMode);
    public readonly AddressType = new QEnumPath(this.withPrefix("AddressType"), TagAddressType);
    public readonly Delta = new QNumberPath(this.withPrefix("Delta"));
}

export const qTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types = new QTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types();

export class QWorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types extends QueryObject {
    public readonly Model = new QStringPath(this.withPrefix("Model"));
}

export const qWorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types = new QWorkInstructionDesignValueType_Siemens_SimaticIT_MasterData_WI_MS_MSModel_Types();

export class QDesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types extends QueryObject {
    public readonly Model = new QStringPath(this.withPrefix("Model"));
}

export const qDesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types = new QDesignValueType_Siemens_SimaticIT_MasterData_BPF_MS_MSModel_Types();

export class QATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly ATNInstanceNId = new QStringPath(this.withPrefix("ATNInstanceNId"));
    public readonly ATNInstanceParameterNId = new QStringPath(this.withPrefix("ATNInstanceParameterNId"));
}

export const qATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types = new QATNInstanceValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types();

export class QToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
}

export const qToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types = new QToolDefinitionValueType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_AGWInt_MSModel_Types();

export class QMaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly UId = new QStringPath(this.withPrefix("UId"));
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
}

export const qMaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types = new QMaterialType_Siemens_SimaticIT_U4DM_MasterData_FB_MS_Container_MSModel_Types();

export class QBoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Version = new QStringPath(this.withPrefix("Version"));
}

export const qBoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types = new QBoMType_Siemens_SimaticIT_U4DM_OperationalData_Runtime_OPModel_Types();

export class QTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types extends QueryObject {
    public readonly Sequence = new QNumberPath(this.withPrefix("Sequence"));
    public readonly MaxIterations = new QNumberPath(this.withPrefix("MaxIterations"));
    public readonly IterationGroupId = new QGuidPath(this.withPrefix("IterationGroupId"));
    public readonly ContinueOnSuccess = new QBooleanPath(this.withPrefix("ContinueOnSuccess"));
    public readonly ContinueOnFailure = new QBooleanPath(this.withPrefix("ContinueOnFailure"));
    public readonly TaskFlow = new QStringPath(this.withPrefix("TaskFlow"));
}

export const qTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types = new QTaskFlowType_Siemens_SimaticIT_OperationalData_TSK_OP_OPModel_Types();

export class QATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types extends QueryObject {
    public readonly ATNNodeId = new QStringPath(this.withPrefix("ATNNodeId"));
    public readonly ATNParameterName = new QStringPath(this.withPrefix("ATNParameterName"));
    public readonly ATNParameterQualityStatus = new QStringPath(this.withPrefix("ATNParameterQualityStatus"));
    public readonly ATNParameterTimestamp = new QDateTimeOffsetPath(this.withPrefix("ATNParameterTimestamp"));
    public readonly ATNParameterValue = new QStringPath(this.withPrefix("ATNParameterValue"));
    public readonly DSParameterNId = new QStringPath(this.withPrefix("DSParameterNId"));
    public readonly AcquiredFromShopfloorDate = new QDateTimeOffsetPath(this.withPrefix("AcquiredFromShopfloorDate"));
}

export const qATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types = new QATNAcquisitionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types();

export class QATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types extends QueryObject {
    public readonly ATNNodeId = new QStringPath(this.withPrefix("ATNNodeId"));
    public readonly ATNParameterName = new QStringPath(this.withPrefix("ATNParameterName"));
    public readonly SetPointItemNId = new QStringPath(this.withPrefix("SetPointItemNId"));
    public readonly SetPointItemValue = new QStringPath(this.withPrefix("SetPointItemValue"));
    public readonly TransmissionSucceeded = new QBooleanPath(this.withPrefix("TransmissionSucceeded"));
    public readonly ATNParameterTimestamp = new QDateTimeOffsetPath(this.withPrefix("ATNParameterTimestamp"));
    public readonly ATNParameterQualityStatus = new QStringPath(this.withPrefix("ATNParameterQualityStatus"));
    public readonly SetPointNId = new QStringPath(this.withPrefix("SetPointNId"));
}

export const qATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types = new QATNTransmissionHistoryAssociationValueType_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_AGWInt_OPModel_Types();

export class QMTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types extends QueryObject {
    public readonly MTUNId = new QStringPath(this.withPrefix("MTUNId"));
    public readonly Quantity = new QNumberPath(this.withPrefix("Quantity"));
    public readonly ParentMTUNId = new QStringPath(this.withPrefix("ParentMTUNId"));
    public readonly MTUCode = new QStringPath(this.withPrefix("MTUCode"));
    public readonly MTUName = new QStringPath(this.withPrefix("MTUName"));
}

export const qMTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types = new QMTUAggregateContent_Siemens_SimaticIT_U4DM_OperationalData_FB_OP_Container_OPModel_Types();

export class QQuantityType extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly QuantityValue = new QNumberPath(this.withPrefix("QuantityValue"));
}

export const qQuantityType = new QQuantityType();

export class QStatusType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qStatusType = new QStatusType();

export class QSignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FullName = new QStringPath(this.withPrefix("FullName"));
}

export const qSignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types = new QSignerIdentityType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types();

export class QScenarioInstanceValueType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
}

export const qScenarioInstanceValueType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types = new QScenarioInstanceValueType_Siemens_SimaticIT_SystemData_ES_SD_SDModel_Types();

export class QUADMGetAllReasons2 extends QFunction<UADMGetAllReasons2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllReasons())];

    constructor() {
        super("UADMGetAllReasons", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetExecutionGroupList2 extends QFunction<UADMGetExecutionGroupList2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetExecutionGroupList())];

    constructor() {
        super("UADMGetExecutionGroupList", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetExecutionGroupHistory2 extends QFunction<UADMGetExecutionGroupHistory2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetExecutionGroupHistory())];

    constructor() {
        super("UADMGetExecutionGroupHistory", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllExecutionGroupPhasesWithLinkedPJF2 extends QFunction<UADMGetAllExecutionGroupPhasesWithLinkedPJF2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllExecutionGroupPhasesWithLinkedPJF())];

    constructor() {
        super("UADMGetAllExecutionGroupPhasesWithLinkedPJF", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllToBeUsedMachineForSetWKCHold2 extends QFunction<UADMGetAllToBeUsedMachineForSetWKCHold2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllToBeUsedMachineForSetWKCHold())];

    constructor() {
        super("UADMGetAllToBeUsedMachineForSetWKCHold", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_GetBomItems2 extends QFunction<APPMain_GF_GetBomItems2Params> {
    private readonly params = [new QComplexParam("function", new QAPPMain_GF_GetBomItems())];

    constructor() {
        super("APPMain_GF_GetBomItems", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetDefectOrFailure2 extends QFunction<UADMGetDefectOrFailure2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetDefectOrFailure())];

    constructor() {
        super("UADMGetDefectOrFailure", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetNonConformanceContainerMTU2 extends QFunction<UADMGetNonConformanceContainerMTU2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetNonConformanceContainerMTU())];

    constructor() {
        super("UADMGetNonConformanceContainerMTU", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetContainerToWorkOrderLink2 extends QFunction<UADMGetContainerToWorkOrderLink2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetContainerToWorkOrderLink())];

    constructor() {
        super("UADMGetContainerToWorkOrderLink", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder2 extends QFunction<UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder())];

    constructor() {
        super("UADMGetAllDM_MaterialTrackingUnitToAssignWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetExecutionGroupsForWorkOrder2 extends QFunction<UADMGetExecutionGroupsForWorkOrder2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetExecutionGroupsForWorkOrder())];

    constructor() {
        super("UADMGetExecutionGroupsForWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetEquipmentAndRelatedOperations2 extends QFunction<UADMGetEquipmentAndRelatedOperations2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetEquipmentAndRelatedOperations())];

    constructor() {
        super("UADMGetEquipmentAndRelatedOperations", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllEquipmentsAndRelatedOperations2 extends QFunction<UADMGetAllEquipmentsAndRelatedOperations2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllEquipmentsAndRelatedOperations())];

    constructor() {
        super("UADMGetAllEquipmentsAndRelatedOperations", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetWorkOrderOutMsgFile2 extends QFunction<UADMGetWorkOrderOutMsgFile2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetWorkOrderOutMsgFile())];

    constructor() {
        super("UADMGetWorkOrderOutMsgFile", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetBuyoffNonConformances2 extends QFunction<UADMGetBuyoffNonConformances2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetBuyoffNonConformances())];

    constructor() {
        super("UADMGetBuyoffNonConformances", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetSignersFromBuyOffHistory2 extends QFunction<UADMGetSignersFromBuyOffHistory2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetSignersFromBuyOffHistory())];

    constructor() {
        super("UADMGetSignersFromBuyOffHistory", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetWIDetailsForWorkOrderOperationAndStep2 extends QFunction<UADMGetWIDetailsForWorkOrderOperationAndStep2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetWIDetailsForWorkOrderOperationAndStep())];

    constructor() {
        super("UADMGetWIDetailsForWorkOrderOperationAndStep", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetContainerTobeConsumedMTUs2 extends QFunction<UADMGetContainerTobeConsumedMTUs2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetContainerTobeConsumedMTUs())];

    constructor() {
        super("UADMGetContainerTobeConsumedMTUs", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetMTUFromBufferForToBeConsumedBatchMaterials2 extends QFunction<UADMGetMTUFromBufferForToBeConsumedBatchMaterials2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetMTUFromBufferForToBeConsumedBatchMaterials())];

    constructor() {
        super("UADMGetMTUFromBufferForToBeConsumedBatchMaterials", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetActualConsumedMaterialForGenealogy2 extends QFunction<UADMGetActualConsumedMaterialForGenealogy2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetActualConsumedMaterialForGenealogy())];

    constructor() {
        super("UADMGetActualConsumedMaterialForGenealogy", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetEventLogs2 extends QFunction<UADMGetEventLogs2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetEventLogs())];

    constructor() {
        super("UADMGetEventLogs", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllMaterialDefinitionDocuments2 extends QFunction<UADMGetAllMaterialDefinitionDocuments2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllMaterialDefinitionDocuments())];

    constructor() {
        super("UADMGetAllMaterialDefinitionDocuments", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetDataFromFeatures2 extends QFunction<UADMGetDataFromFeatures2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetDataFromFeatures())];

    constructor() {
        super("UADMGetDataFromFeatures", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllTasks2 extends QFunction<UADMGetAllTasks2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllTasks())];

    constructor() {
        super("UADMGetAllTasks", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetWIDetailsForEgPhase2 extends QFunction<UADMGetWIDetailsForEgPhase2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetWIDetailsForEgPhase())];

    constructor() {
        super("UADMGetWIDetailsForEgPhase", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetScrewingDetails2 extends QFunction<UADMGetScrewingDetails2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetScrewingDetails())];

    constructor() {
        super("UADMGetScrewingDetails", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetScrewingHistoryFromMaterialTrackingUnit2 extends QFunction<UADMGetScrewingHistoryFromMaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetScrewingHistoryFromMaterialTrackingUnit())];

    constructor() {
        super("UADMGetScrewingHistoryFromMaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllDocumentsFromNonConformanceId2 extends QFunction<UADMGetAllDocumentsFromNonConformanceId2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllDocumentsFromNonConformanceId())];

    constructor() {
        super("UADMGetAllDocumentsFromNonConformanceId", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetExecutionGroupListWithEstimatedDuration2 extends QFunction<UADMGetExecutionGroupListWithEstimatedDuration2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetExecutionGroupListWithEstimatedDuration())];

    constructor() {
        super("UADMGetExecutionGroupListWithEstimatedDuration", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllMaterialForPrekit2 extends QFunction<UADMGetAllMaterialForPrekit2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllMaterialForPrekit())];

    constructor() {
        super("UADMGetAllMaterialForPrekit", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetItlkParametersDetails2 extends QFunction<UADMGetItlkParametersDetails2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetItlkParametersDetails())];

    constructor() {
        super("UADMGetItlkParametersDetails", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QDM_MaterialAndMaterial2 extends QFunction<DM_MaterialAndMaterial2Params> {
    private readonly params = [new QComplexParam("function", new QDM_MaterialAndMaterial())];

    constructor() {
        super("DM_MaterialAndMaterial", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetItlkCheckHistoryParamValues2 extends QFunction<UADMGetItlkCheckHistoryParamValues2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetItlkCheckHistoryParamValues())];

    constructor() {
        super("UADMGetItlkCheckHistoryParamValues", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetFullEquipment2 extends QFunction<UADMGetFullEquipment2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetFullEquipment())];

    constructor() {
        super("UADMGetFullEquipment", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllProcessMachines2 extends QFunction<UADMGetAllProcessMachines2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllProcessMachines())];

    constructor() {
        super("UADMGetAllProcessMachines", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllItlkCheckWOOpAssociation2 extends QFunction<UADMGetAllItlkCheckWOOpAssociation2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllItlkCheckWOOpAssociation())];

    constructor() {
        super("UADMGetAllItlkCheckWOOpAssociation", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllItlkCheckProcessToOpLinkAssociation2 extends QFunction<UADMGetAllItlkCheckProcessToOpLinkAssociation2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllItlkCheckProcessToOpLinkAssociation())];

    constructor() {
        super("UADMGetAllItlkCheckProcessToOpLinkAssociation", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetEquipmentForToBeUsedMachine2 extends QFunction<UADMGetEquipmentForToBeUsedMachine2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetEquipmentForToBeUsedMachine())];

    constructor() {
        super("UADMGetEquipmentForToBeUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetEquipmentForEqSpecification2 extends QFunction<UADMGetEquipmentForEqSpecification2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetEquipmentForEqSpecification())];

    constructor() {
        super("UADMGetEquipmentForEqSpecification", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADM_DMMaterialTrackingUnitAndMTU2 extends QFunction<UADM_DMMaterialTrackingUnitAndMTU2Params> {
    private readonly params = [new QComplexParam("function", new QUADM_DMMaterialTrackingUnitAndMTU())];

    constructor() {
        super("UADM_DMMaterialTrackingUnitAndMTU", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllToolCompatibleMachines2 extends QFunction<UADMGetAllToolCompatibleMachines2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllToolCompatibleMachines())];

    constructor() {
        super("UADMGetAllToolCompatibleMachines", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetLinkableEquipment2 extends QFunction<UADMGetLinkableEquipment2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetLinkableEquipment())];

    constructor() {
        super("UADMGetLinkableEquipment", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllToolDefinitionCompatibleMachine2 extends QFunction<UADMGetAllToolDefinitionCompatibleMachine2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllToolDefinitionCompatibleMachine())];

    constructor() {
        super("UADMGetAllToolDefinitionCompatibleMachine", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllItlkCheckWOStepAssociation2 extends QFunction<UADMGetAllItlkCheckWOStepAssociation2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllItlkCheckWOStepAssociation())];

    constructor() {
        super("UADMGetAllItlkCheckWOStepAssociation", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetDefectGroupSpecifications2 extends QFunction<UADMGetDefectGroupSpecifications2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetDefectGroupSpecifications())];

    constructor() {
        super("UADMGetDefectGroupSpecifications", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetUnitsFromWorkCenter2 extends QFunction<UADMGetUnitsFromWorkCenter2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetUnitsFromWorkCenter())];

    constructor() {
        super("UADMGetUnitsFromWorkCenter", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetUnitsFromBufferLocation2 extends QFunction<UADMGetUnitsFromBufferLocation2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetUnitsFromBufferLocation())];

    constructor() {
        super("UADMGetUnitsFromBufferLocation", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetCharacteristicRepresentation2 extends QFunction<UADMGetCharacteristicRepresentation2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetCharacteristicRepresentation())];

    constructor() {
        super("UADMGetCharacteristicRepresentation", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAlternativeGroupsFromWorkOrderId2 extends QFunction<UADMGetAlternativeGroupsFromWorkOrderId2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAlternativeGroupsFromWorkOrderId())];

    constructor() {
        super("UADMGetAlternativeGroupsFromWorkOrderId", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetQualityInspectionSamples2 extends QFunction<UADMGetQualityInspectionSamples2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetQualityInspectionSamples())];

    constructor() {
        super("UADMGetQualityInspectionSamples", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetUnitsFromPlant2 extends QFunction<UADMGetUnitsFromPlant2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetUnitsFromPlant())];

    constructor() {
        super("UADMGetUnitsFromPlant", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetQualityForGenealogy2 extends QFunction<UADMGetQualityForGenealogy2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetQualityForGenealogy())];

    constructor() {
        super("UADMGetQualityForGenealogy", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetStartableItemsOnWOStep2 extends QFunction<UADMGetStartableItemsOnWOStep2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetStartableItemsOnWOStep())];

    constructor() {
        super("UADMGetStartableItemsOnWOStep", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetCompletableItemsOnWOStep2 extends QFunction<UADMGetCompletableItemsOnWOStep2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetCompletableItemsOnWOStep())];

    constructor() {
        super("UADMGetCompletableItemsOnWOStep", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllPrintJobFiles2 extends QFunction<UADMGetAllPrintJobFiles2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllPrintJobFiles())];

    constructor() {
        super("UADMGetAllPrintJobFiles", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAlternativeGroupsFromProcessId2 extends QFunction<UADMGetAlternativeGroupsFromProcessId2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAlternativeGroupsFromProcessId())];

    constructor() {
        super("UADMGetAlternativeGroupsFromProcessId", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetPrintJobFilesFromAssociations2 extends QFunction<UADMGetPrintJobFilesFromAssociations2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetPrintJobFilesFromAssociations())];

    constructor() {
        super("UADMGetPrintJobFilesFromAssociations", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetWOByProcessRevision2 extends QFunction<UADMGetWOByProcessRevision2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetWOByProcessRevision())];

    constructor() {
        super("UADMGetWOByProcessRevision", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetStepForCatalog2 extends QFunction<UADMGetStepForCatalog2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetStepForCatalog())];

    constructor() {
        super("UADMGetStepForCatalog", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllEquipmentFor3DPrinter2 extends QFunction<UADMGetAllEquipmentFor3DPrinter2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllEquipmentFor3DPrinter())];

    constructor() {
        super("UADMGetAllEquipmentFor3DPrinter", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllToolDefinitionAutomationNodeType2 extends QFunction<UADMGetAllToolDefinitionAutomationNodeType2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllToolDefinitionAutomationNodeType())];

    constructor() {
        super("UADMGetAllToolDefinitionAutomationNodeType", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllToolAutomationNodeInstance2 extends QFunction<UADMGetAllToolAutomationNodeInstance2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllToolAutomationNodeInstance())];

    constructor() {
        super("UADMGetAllToolAutomationNodeInstance", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetToolDefinationsBySetPoint2 extends QFunction<UADMGetToolDefinationsBySetPoint2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetToolDefinationsBySetPoint())];

    constructor() {
        super("UADMGetToolDefinationsBySetPoint", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetToolBySetPoint2 extends QFunction<UADMGetToolBySetPoint2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetToolBySetPoint())];

    constructor() {
        super("UADMGetToolBySetPoint", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetDNCItemsFromAssociations2 extends QFunction<UADMGetDNCItemsFromAssociations2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetDNCItemsFromAssociations())];

    constructor() {
        super("UADMGetDNCItemsFromAssociations", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetOperationToStepLink2 extends QFunction<UADMGetOperationToStepLink2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetOperationToStepLink())];

    constructor() {
        super("UADMGetOperationToStepLink", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetWOSteps2 extends QFunction<UADMGetWOSteps2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetWOSteps())];

    constructor() {
        super("UADMGetWOSteps", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllWorkOrderPrintJobFileAssociation2 extends QFunction<UADMGetAllWorkOrderPrintJobFileAssociation2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllWorkOrderPrintJobFileAssociation())];

    constructor() {
        super("UADMGetAllWorkOrderPrintJobFileAssociation", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetBufferHistory2 extends QFunction<UADMGetBufferHistory2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetBufferHistory())];

    constructor() {
        super("UADMGetBufferHistory", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes2 extends QFunction<UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes())];

    constructor() {
        super("UADMGetAllMaterialDefinitionsForAllMaterialSpecificationTypes", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetCertificationDetails2 extends QFunction<UADMGetCertificationDetails2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetCertificationDetails())];

    constructor() {
        super("UADMGetCertificationDetails", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetWorkOrderHumanResourceDetails2 extends QFunction<UADMGetWorkOrderHumanResourceDetails2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetWorkOrderHumanResourceDetails())];

    constructor() {
        super("UADMGetWorkOrderHumanResourceDetails", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetOfflineSessionWOOperationAssociations2 extends QFunction<UADMGetOfflineSessionWOOperationAssociations2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetOfflineSessionWOOperationAssociations())];

    constructor() {
        super("UADMGetOfflineSessionWOOperationAssociations", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetMaterialSpecificationTypeIndicator2 extends QFunction<UADMGetMaterialSpecificationTypeIndicator2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetMaterialSpecificationTypeIndicator())];

    constructor() {
        super("UADMGetMaterialSpecificationTypeIndicator", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllOfflineSessions2 extends QFunction<UADMGetAllOfflineSessions2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllOfflineSessions())];

    constructor() {
        super("UADMGetAllOfflineSessions", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetProcessOperationDetails2 extends QFunction<UADMGetProcessOperationDetails2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetProcessOperationDetails())];

    constructor() {
        super("UADMGetProcessOperationDetails", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetProcessStepDetails2 extends QFunction<UADMGetProcessStepDetails2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetProcessStepDetails())];

    constructor() {
        super("UADMGetProcessStepDetails", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllDocumentsFromDM_MaterialTrackingUnitIds2 extends QFunction<UADMGetAllDocumentsFromDM_MaterialTrackingUnitIds2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllDocumentsFromDM_MaterialTrackingUnitIds())];

    constructor() {
        super("UADMGetAllDocumentsFromDM_MaterialTrackingUnitIds", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetSerialNumberStatusForGenealogy2 extends QFunction<UADMGetSerialNumberStatusForGenealogy2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetSerialNumberStatusForGenealogy())];

    constructor() {
        super("UADMGetSerialNumberStatusForGenealogy", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetAllConsumedDM_MTUForProducedDM_MTU2 extends QFunction<UADMGetAllConsumedDM_MTUForProducedDM_MTU2Params> {
    private readonly params = [new QComplexParam("function", new QUADMGetAllConsumedDM_MTUForProducedDM_MTU())];

    constructor() {
        super("UADMGetAllConsumedDM_MTUForProducedDM_MTU", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QToolAGW_ToolOnWorkplace2 extends QFunction<ToolAGW_ToolOnWorkplace2Params> {
    private readonly params = [new QComplexParam("function", new QToolAGW_ToolOnWorkplace())];

    constructor() {
        super("ToolAGW_ToolOnWorkplace", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteWorkOperationTypeList2 extends QAction<UADMDeleteWorkOperationTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteWorkOperationTypeList())];

    constructor() {
        super("UADMDeleteWorkOperationTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteWorkOperationTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMStartOperation2 extends QAction<UADMStartOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMStartOperation())];

    constructor() {
        super("UADMStartOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMStartOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateWOByBoPList2 extends QAction<UADMUpdateWOByBoPList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateWOByBoPList())];

    constructor() {
        super("UADMUpdateWOByBoPList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateWOByBoPListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMStartWOOperationTransferBatchList2 extends QAction<UADMStartWOOperationTransferBatchList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMStartWOOperationTransferBatchList())];

    constructor() {
        super("UADMStartWOOperationTransferBatchList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMStartWOOperationTransferBatchListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMConsumeMaterialItemList2 extends QAction<UADMConsumeMaterialItemList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMConsumeMaterialItemList())];

    constructor() {
        super("UADMConsumeMaterialItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMConsumeMaterialItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSentenceNonConformance2 extends QAction<UADMSentenceNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSentenceNonConformance())];

    constructor() {
        super("UADMSentenceNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSentenceNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNonConformance2 extends QAction<UADMCreateNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNonConformance())];

    constructor() {
        super("UADMCreateNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptBuyOff2 extends QAction<AcceptBuyOff2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptBuyOff())];

    constructor() {
        super("AcceptBuyOff", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptBuyOffResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRejectBuyOff2 extends QAction<RejectBuyOff2Params> {
    private readonly params = [new QComplexParam("command", new QRejectBuyOff())];

    constructor() {
        super("RejectBuyOff", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRejectBuyOffResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateWorkOrdersFromAsPlannedBOP2 extends QAction<UADMCreateWorkOrdersFromAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateWorkOrdersFromAsPlannedBOP())];

    constructor() {
        super("UADMCreateWorkOrdersFromAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateWorkOrdersFromAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateTravellingWork2 extends QAction<UADMCreateTravellingWork2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateTravellingWork())];

    constructor() {
        super("UADMCreateTravellingWork", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateTravellingWorkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMTakeOwnershipTravellingWork2 extends QAction<UADMTakeOwnershipTravellingWork2Params> {
    private readonly params = [new QComplexParam("command", new QUADMTakeOwnershipTravellingWork())];

    constructor() {
        super("UADMTakeOwnershipTravellingWork", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMTakeOwnershipTravellingWorkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptTravellingWork2 extends QAction<UADMAcceptTravellingWork2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptTravellingWork())];

    constructor() {
        super("UADMAcceptTravellingWork", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptTravellingWorkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMStartWOOperationSerializedList2 extends QAction<UADMStartWOOperationSerializedList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMStartWOOperationSerializedList())];

    constructor() {
        super("UADMStartWOOperationSerializedList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMStartWOOperationSerializedListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSetWorkOrderOperationFutureHoldList2 extends QAction<UADMSetWorkOrderOperationFutureHoldList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSetWorkOrderOperationFutureHoldList())];

    constructor() {
        super("UADMSetWorkOrderOperationFutureHoldList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSetWorkOrderOperationFutureHoldListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateChangeNonConformance2 extends QAction<UADMCreateChangeNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateChangeNonConformance())];

    constructor() {
        super("UADMCreateChangeNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateChangeNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAbortWorkOrder2 extends QAction<UADMAbortWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAbortWorkOrder())];

    constructor() {
        super("UADMAbortWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAbortWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMVerifyWorkOrder2 extends QAction<UADMVerifyWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUADMVerifyWorkOrder())];

    constructor() {
        super("UADMVerifyWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMVerifyWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSetWorkOrderHoldList2 extends QAction<UADMSetWorkOrderHoldList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSetWorkOrderHoldList())];

    constructor() {
        super("UADMSetWorkOrderHoldList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSetWorkOrderHoldListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveWorkOrderOperationFutureHoldList2 extends QAction<UADMRemoveWorkOrderOperationFutureHoldList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveWorkOrderOperationFutureHoldList())];

    constructor() {
        super("UADMRemoveWorkOrderOperationFutureHoldList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveWorkOrderOperationFutureHoldListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCompleteWOOperationSerializedList2 extends QAction<UADMCompleteWOOperationSerializedList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCompleteWOOperationSerializedList())];

    constructor() {
        super("UADMCompleteWOOperationSerializedList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCompleteWOOperationSerializedListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUnVerifyWorkOrder2 extends QAction<UADMUnVerifyWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUnVerifyWorkOrder())];

    constructor() {
        super("UADMUnVerifyWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUnVerifyWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateAndAssignProducedMaterialItems2 extends QAction<UADMCreateAndAssignProducedMaterialItems2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateAndAssignProducedMaterialItems())];

    constructor() {
        super("UADMCreateAndAssignProducedMaterialItems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateAndAssignProducedMaterialItemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCompleteWOStepList2 extends QAction<UADMCompleteWOStepList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCompleteWOStepList())];

    constructor() {
        super("UADMCompleteWOStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCompleteWOStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMStartWOStep2 extends QAction<UADMStartWOStep2Params> {
    private readonly params = [new QComplexParam("command", new QUADMStartWOStep())];

    constructor() {
        super("UADMStartWOStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMStartWOStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeRepeatOperation2 extends QAction<UADMAcceptChangeRepeatOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeRepeatOperation())];

    constructor() {
        super("UADMAcceptChangeRepeatOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeRepeatOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeAddToBeConsumedMaterial2 extends QAction<UADMAcceptChangeAddToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeAddToBeConsumedMaterial())];

    constructor() {
        super("UADMAcceptChangeAddToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeAddToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeAddDCDRuntimeTask2 extends QAction<UADMAcceptChangeAddDCDRuntimeTask2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeAddDCDRuntimeTask())];

    constructor() {
        super("UADMAcceptChangeAddDCDRuntimeTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeAddDCDRuntimeTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeAddOperation2 extends QAction<UADMAcceptChangeAddOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeAddOperation())];

    constructor() {
        super("UADMAcceptChangeAddOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeAddOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeChangeDependency2 extends QAction<UADMAcceptChangeChangeDependency2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeChangeDependency())];

    constructor() {
        super("UADMAcceptChangeChangeDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeChangeDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeChangeToBeConsumedMaterialQuantity2 extends QAction<UADMAcceptChangeChangeToBeConsumedMaterialQuantity2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeChangeToBeConsumedMaterialQuantity())];

    constructor() {
        super("UADMAcceptChangeChangeToBeConsumedMaterialQuantity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeChangeToBeConsumedMaterialQuantityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeChangeToBeUsedMachine2 extends QAction<UADMAcceptChangeChangeToBeUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeChangeToBeUsedMachine())];

    constructor() {
        super("UADMAcceptChangeChangeToBeUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeChangeToBeUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeRemoveDependency2 extends QAction<UADMAcceptChangeRemoveDependency2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeRemoveDependency())];

    constructor() {
        super("UADMAcceptChangeRemoveDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeRemoveDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeRemoveOperation2 extends QAction<UADMAcceptChangeRemoveOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeRemoveOperation())];

    constructor() {
        super("UADMAcceptChangeRemoveOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeRemoveOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeRemoveToBeConsumedMaterial2 extends QAction<UADMAcceptChangeRemoveToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeRemoveToBeConsumedMaterial())];

    constructor() {
        super("UADMAcceptChangeRemoveToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeRemoveToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeReplaceToBeConsumedMaterial2 extends QAction<UADMAcceptChangeReplaceToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeReplaceToBeConsumedMaterial())];

    constructor() {
        super("UADMAcceptChangeReplaceToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeReplaceToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRejectChangeNonConformance2 extends QAction<UADMRejectChangeNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRejectChangeNonConformance())];

    constructor() {
        super("UADMRejectChangeNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRejectChangeNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateReworkCodeList2 extends QAction<UADMCreateReworkCodeList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateReworkCodeList())];

    constructor() {
        super("UADMCreateReworkCodeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateReworkCodeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSentenceNonConformanceSetLocationHold2 extends QAction<UADMSentenceNonConformanceSetLocationHold2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSentenceNonConformanceSetLocationHold())];

    constructor() {
        super("UADMSentenceNonConformanceSetLocationHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSentenceNonConformanceSetLocationHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMManageToBeConsumedMaterialDisassemble2 extends QAction<UADMManageToBeConsumedMaterialDisassemble2Params> {
    private readonly params = [new QComplexParam("command", new QUADMManageToBeConsumedMaterialDisassemble())];

    constructor() {
        super("UADMManageToBeConsumedMaterialDisassemble", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMManageToBeConsumedMaterialDisassembleResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSplitWorkOrder2 extends QAction<UADMSplitWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSplitWorkOrder())];

    constructor() {
        super("UADMSplitWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSplitWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSkipWOOperationFullQty2 extends QAction<UADMSkipWOOperationFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSkipWOOperationFullQty())];

    constructor() {
        super("UADMSkipWOOperationFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSkipWOOperationFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSkipWOOperationTransferBatch2 extends QAction<UADMSkipWOOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSkipWOOperationTransferBatch())];

    constructor() {
        super("UADMSkipWOOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSkipWOOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSkipWOOperationSerialized2 extends QAction<UADMSkipWOOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSkipWOOperationSerialized())];

    constructor() {
        super("UADMSkipWOOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSkipWOOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSentenceNonConformancePartially2 extends QAction<UADMSentenceNonConformancePartially2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSentenceNonConformancePartially())];

    constructor() {
        super("UADMSentenceNonConformancePartially", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSentenceNonConformancePartiallyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetActiveUserListOnWorkOrderOperation2 extends QAction<UADMGetActiveUserListOnWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMGetActiveUserListOnWorkOrderOperation())];

    constructor() {
        super("UADMGetActiveUserListOnWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMGetActiveUserListOnWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateSnagAndNoteList2 extends QAction<UADMCreateSnagAndNoteList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateSnagAndNoteList())];

    constructor() {
        super("UADMCreateSnagAndNoteList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateSnagAndNoteListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMConfirmSnagAndNoteList2 extends QAction<UADMConfirmSnagAndNoteList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMConfirmSnagAndNoteList())];

    constructor() {
        super("UADMConfirmSnagAndNoteList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMConfirmSnagAndNoteListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUseTool2 extends QAction<UADMUseTool2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUseTool())];

    constructor() {
        super("UADMUseTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUseToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSaveDCDRuntimeTaskValues2 extends QAction<UADMSaveDCDRuntimeTaskValues2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSaveDCDRuntimeTaskValues())];

    constructor() {
        super("UADMSaveDCDRuntimeTaskValues", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSaveDCDRuntimeTaskValuesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCheckDCDRuntimeValues2 extends QAction<UADMCheckDCDRuntimeValues2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCheckDCDRuntimeValues())];

    constructor() {
        super("UADMCheckDCDRuntimeValues", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCheckDCDRuntimeValuesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSetLocationHold2 extends QAction<UADMSetLocationHold2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSetLocationHold())];

    constructor() {
        super("UADMSetLocationHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSetLocationHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDisassembleMaterialItem2 extends QAction<UADMDisassembleMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDisassembleMaterialItem())];

    constructor() {
        super("UADMDisassembleMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDisassembleMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMExportGenealogy2 extends QAction<UADMExportGenealogy2Params> {
    private readonly params = [new QComplexParam("command", new QUADMExportGenealogy())];

    constructor() {
        super("UADMExportGenealogy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMExportGenealogyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNewMaterialDefinitionRevision2 extends QAction<UADMCreateNewMaterialDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNewMaterialDefinitionRevision())];

    constructor() {
        super("UADMCreateNewMaterialDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNewMaterialDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDisAssignProducedMaterialitems2 extends QAction<UADMDisAssignProducedMaterialitems2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDisAssignProducedMaterialitems())];

    constructor() {
        super("UADMDisAssignProducedMaterialitems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDisAssignProducedMaterialitemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMImportLifecycle2 extends QAction<UADMImportLifecycle2Params> {
    private readonly params = [new QComplexParam("command", new QUADMImportLifecycle())];

    constructor() {
        super("UADMImportLifecycle", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMImportLifecycleResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSaveDocumentForPreview2 extends QAction<UADMSaveDocumentForPreview2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSaveDocumentForPreview())];

    constructor() {
        super("UADMSaveDocumentForPreview", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSaveDocumentForPreviewResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeAddProcessOperation2 extends QAction<UADMAcceptChangeAddProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeAddProcessOperation())];

    constructor() {
        super("UADMAcceptChangeAddProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeAddProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteEquipment2 extends QAction<UADMDeleteEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteEquipment())];

    constructor() {
        super("UADMDeleteEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveWorkOrderScrap2 extends QAction<UADMRemoveWorkOrderScrap2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveWorkOrderScrap())];

    constructor() {
        super("UADMRemoveWorkOrderScrap", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveWorkOrderScrapResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMEnableLocationMachineForCompleteByDifferentUser2 extends QAction<UADMEnableLocationMachineForCompleteByDifferentUser2Params> {
    private readonly params = [new QComplexParam("command", new QUADMEnableLocationMachineForCompleteByDifferentUser())];

    constructor() {
        super("UADMEnableLocationMachineForCompleteByDifferentUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMEnableLocationMachineForCompleteByDifferentUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateWorkOrderOperationFromProcessOperation2 extends QAction<UADMCreateWorkOrderOperationFromProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateWorkOrderOperationFromProcessOperation())];

    constructor() {
        super("UADMCreateWorkOrderOperationFromProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateWorkOrderOperationFromProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNonConformanceDefectList2 extends QAction<UADMCreateNonConformanceDefectList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNonConformanceDefectList())];

    constructor() {
        super("UADMCreateNonConformanceDefectList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNonConformanceDefectListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateDefectTypeContextualization2 extends QAction<UADMCreateDefectTypeContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateDefectTypeContextualization())];

    constructor() {
        super("UADMCreateDefectTypeContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateDefectTypeContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateDefectGroupContextualization2 extends QAction<UADMCreateDefectGroupContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateDefectGroupContextualization())];

    constructor() {
        super("UADMCreateDefectGroupContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateDefectGroupContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAssignNonConformanceTransitionRoleList2 extends QAction<UADMAssignNonConformanceTransitionRoleList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAssignNonConformanceTransitionRoleList())];

    constructor() {
        super("UADMAssignNonConformanceTransitionRoleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAssignNonConformanceTransitionRoleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveNonConformanceTransitionRoleList2 extends QAction<UADMRemoveNonConformanceTransitionRoleList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveNonConformanceTransitionRoleList())];

    constructor() {
        super("UADMRemoveNonConformanceTransitionRoleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveNonConformanceTransitionRoleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveDefectGroupContextualization2 extends QAction<UADMRemoveDefectGroupContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveDefectGroupContextualization())];

    constructor() {
        super("UADMRemoveDefectGroupContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveDefectGroupContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveDefectTypeContextualization2 extends QAction<UADMRemoveDefectTypeContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveDefectTypeContextualization())];

    constructor() {
        super("UADMRemoveDefectTypeContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveDefectTypeContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAssignNonConformanceTransitionMailAddressList2 extends QAction<UADMAssignNonConformanceTransitionMailAddressList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAssignNonConformanceTransitionMailAddressList())];

    constructor() {
        super("UADMAssignNonConformanceTransitionMailAddressList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAssignNonConformanceTransitionMailAddressListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveNonConformanceTransitionMailAddressList2 extends QAction<UADMRemoveNonConformanceTransitionMailAddressList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveNonConformanceTransitionMailAddressList())];

    constructor() {
        super("UADMRemoveNonConformanceTransitionMailAddressList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveNonConformanceTransitionMailAddressListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreatePrintJobFile2 extends QAction<UADMCreatePrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreatePrintJobFile())];

    constructor() {
        super("UADMCreatePrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreatePrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMImportAMPrintJobFile2 extends QAction<UADMImportAMPrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QUADMImportAMPrintJobFile())];

    constructor() {
        super("UADMImportAMPrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMImportAMPrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateEquipmentSpecificationWithPrintJobFile2 extends QAction<UADMCreateEquipmentSpecificationWithPrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateEquipmentSpecificationWithPrintJobFile())];

    constructor() {
        super("UADMCreateEquipmentSpecificationWithPrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateEquipmentSpecificationWithPrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMEditPrintJobFile2 extends QAction<UADMEditPrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QUADMEditPrintJobFile())];

    constructor() {
        super("UADMEditPrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMEditPrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMTransferAMData2 extends QAction<UADMTransferAMData2Params> {
    private readonly params = [new QComplexParam("command", new QUADMTransferAMData())];

    constructor() {
        super("UADMTransferAMData", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMTransferAMDataResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutoTransferAMData2 extends QAction<UADMAutoTransferAMData2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutoTransferAMData())];

    constructor() {
        super("UADMAutoTransferAMData", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutoTransferAMDataResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCompleteWOOperationTransferBatchMultiMachineList2 extends QAction<UADMCompleteWOOperationTransferBatchMultiMachineList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCompleteWOOperationTransferBatchMultiMachineList())];

    constructor() {
        super("UADMCompleteWOOperationTransferBatchMultiMachineList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCompleteWOOperationTransferBatchMultiMachineListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeletePrintJobFileList2 extends QAction<UADMDeletePrintJobFileList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeletePrintJobFileList())];

    constructor() {
        super("UADMDeletePrintJobFileList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeletePrintJobFileListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreatePrintJobFileList2 extends QAction<UADMCreatePrintJobFileList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreatePrintJobFileList())];

    constructor() {
        super("UADMCreatePrintJobFileList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreatePrintJobFileListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QImportAMPrintJobFile2 extends QAction<ImportAMPrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QImportAMPrintJobFile())];

    constructor() {
        super("ImportAMPrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QImportAMPrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMPauseWorkOrderOperationMultiMachineList2 extends QAction<UADMPauseWorkOrderOperationMultiMachineList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMPauseWorkOrderOperationMultiMachineList())];

    constructor() {
        super("UADMPauseWorkOrderOperationMultiMachineList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMPauseWorkOrderOperationMultiMachineListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCompleteWOOperationFullQtyMultiMachineList2 extends QAction<UADMCompleteWOOperationFullQtyMultiMachineList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCompleteWOOperationFullQtyMultiMachineList())];

    constructor() {
        super("UADMCompleteWOOperationFullQtyMultiMachineList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCompleteWOOperationFullQtyMultiMachineListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteToolDefinitionList2 extends QAction<UADMDeleteToolDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteToolDefinitionList())];

    constructor() {
        super("UADMDeleteToolDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteToolDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateForm2 extends QAction<UADMCreateForm2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateForm())];

    constructor() {
        super("UADMCreateForm", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateFormResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMGetPMI2 extends QAction<UADMGetPMI2Params> {
    private readonly params = [new QComplexParam("command", new QUADMGetPMI())];

    constructor() {
        super("UADMGetPMI", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMGetPMIResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSaveAsWorkInstruction2 extends QAction<UADMSaveAsWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSaveAsWorkInstruction())];

    constructor() {
        super("UADMSaveAsWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSaveAsWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAssociateFormsToTcM2 extends QAction<UADMAssociateFormsToTcM2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAssociateFormsToTcM())];

    constructor() {
        super("UADMAssociateFormsToTcM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAssociateFormsToTcMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMChangeWorkInstructionStatus2 extends QAction<UADMChangeWorkInstructionStatus2Params> {
    private readonly params = [new QComplexParam("command", new QUADMChangeWorkInstructionStatus())];

    constructor() {
        super("UADMChangeWorkInstructionStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMChangeWorkInstructionStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNewProcessRevision2 extends QAction<UADMCreateNewProcessRevision2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNewProcessRevision())];

    constructor() {
        super("UADMCreateNewProcessRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNewProcessRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateNonConformance2 extends QAction<UADMUpdateNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateNonConformance())];

    constructor() {
        super("UADMUpdateNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSetWorkOrderForScheduling2 extends QAction<UADMSetWorkOrderForScheduling2Params> {
    private readonly params = [new QComplexParam("command", new QUADMSetWorkOrderForScheduling())];

    constructor() {
        super("UADMSetWorkOrderForScheduling", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSetWorkOrderForSchedulingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMReleaseWorkOrder2 extends QAction<UADMReleaseWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUADMReleaseWorkOrder())];

    constructor() {
        super("UADMReleaseWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMReleaseWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeAddToBeUsedTool2 extends QAction<UADMAcceptChangeAddToBeUsedTool2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeAddToBeUsedTool())];

    constructor() {
        super("UADMAcceptChangeAddToBeUsedTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeAddToBeUsedToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateIssueReport2 extends QAction<PLMCreateIssueReport2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateIssueReport())];

    constructor() {
        super("PLMCreateIssueReport", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateIssueReportResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateMasterPlan2 extends QAction<PLMCreateMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateMasterPlan())];

    constructor() {
        super("PLMCreateMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationList2 extends QAction<PLMCreateOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationList())];

    constructor() {
        super("PLMCreateOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateProcessList2 extends QAction<PLMCreateProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateProcessList())];

    constructor() {
        super("PLMCreateProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateDocumentList2 extends QAction<PLMCreateDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateDocumentList())];

    constructor() {
        super("PLMCreateDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateMaterialDefinitionList2 extends QAction<PLMCreateMaterialDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateMaterialDefinitionList())];

    constructor() {
        super("PLMCreateMaterialDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateMaterialDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateToolDefinitionList2 extends QAction<PLMCreateToolDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateToolDefinitionList())];

    constructor() {
        super("PLMCreateToolDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateToolDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepList2 extends QAction<PLMCreateStepList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepList())];

    constructor() {
        super("PLMCreateStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMAssociateDocumentToMaterialDefinitionList2 extends QAction<PLMAssociateDocumentToMaterialDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMAssociateDocumentToMaterialDefinitionList())];

    constructor() {
        super("PLMAssociateDocumentToMaterialDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMAssociateDocumentToMaterialDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMAssociateDocumentToToolDefinitionList2 extends QAction<PLMAssociateDocumentToToolDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMAssociateDocumentToToolDefinitionList())];

    constructor() {
        super("PLMAssociateDocumentToToolDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMAssociateDocumentToToolDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMAssociateDocumentToOperationList2 extends QAction<PLMAssociateDocumentToOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMAssociateDocumentToOperationList())];

    constructor() {
        super("PLMAssociateDocumentToOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMAssociateDocumentToOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMAssociateDocumentToStepList2 extends QAction<PLMAssociateDocumentToStepList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMAssociateDocumentToStepList())];

    constructor() {
        super("PLMAssociateDocumentToStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMAssociateDocumentToStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateAsPlannedBoP2 extends QAction<PLMCreateAsPlannedBoP2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateAsPlannedBoP())];

    constructor() {
        super("PLMCreateAsPlannedBoP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateAsPlannedBoPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMLinkProcessToProcessFullList2 extends QAction<PLMLinkProcessToProcessFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMLinkProcessToProcessFullList())];

    constructor() {
        super("PLMLinkProcessToProcessFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMLinkProcessToProcessFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMLinkProcessToOperationFullList2 extends QAction<PLMLinkProcessToOperationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMLinkProcessToOperationFullList())];

    constructor() {
        super("PLMLinkProcessToOperationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMLinkProcessToOperationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMLinkOperationToStepFullList2 extends QAction<PLMLinkOperationToStepFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMLinkOperationToStepFullList())];

    constructor() {
        super("PLMLinkOperationToStepFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMLinkOperationToStepFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepMaterialSpecificationFullList2 extends QAction<PLMCreateStepMaterialSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepMaterialSpecificationFullList())];

    constructor() {
        super("PLMCreateStepMaterialSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepMaterialSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepToolSpecificationFullList2 extends QAction<PLMCreateStepToolSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepToolSpecificationFullList())];

    constructor() {
        super("PLMCreateStepToolSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepToolSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepDependencyList2 extends QAction<PLMCreateStepDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepDependencyList())];

    constructor() {
        super("PLMCreateStepDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationEquipmentSpecLocationFullList2 extends QAction<PLMCreateOperationEquipmentSpecLocationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationEquipmentSpecLocationFullList())];

    constructor() {
        super("PLMCreateOperationEquipmentSpecLocationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationEquipmentSpecLocationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationMaterialSpecificationFullList2 extends QAction<PLMCreateOperationMaterialSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationMaterialSpecificationFullList())];

    constructor() {
        super("PLMCreateOperationMaterialSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationMaterialSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationToolSpecificationFullList2 extends QAction<PLMCreateOperationToolSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationToolSpecificationFullList())];

    constructor() {
        super("PLMCreateOperationToolSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationToolSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOpDependencyList2 extends QAction<PLMCreateOpDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOpDependencyList())];

    constructor() {
        super("PLMCreateOpDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOpDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMSubmit2 extends QAction<PLMSubmit2Params> {
    private readonly params = [new QComplexParam("command", new QPLMSubmit())];

    constructor() {
        super("PLMSubmit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMSubmitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMSubmitMasterPlan2 extends QAction<PLMSubmitMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QPLMSubmitMasterPlan())];

    constructor() {
        super("PLMSubmitMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMSubmitMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMRollback2 extends QAction<PLMRollback2Params> {
    private readonly params = [new QComplexParam("command", new QPLMRollback())];

    constructor() {
        super("PLMRollback", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMRollbackResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMRollbackMasterPlan2 extends QAction<PLMRollbackMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QPLMRollbackMasterPlan())];

    constructor() {
        super("PLMRollbackMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMRollbackMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateIssueReportResult2 extends QAction<PLMCreateIssueReportResult2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateIssueReportResult())];

    constructor() {
        super("PLMCreateIssueReportResult", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateIssueReportResultResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateWorkOrderHeader2 extends QAction<PLMCreateWorkOrderHeader2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateWorkOrderHeader())];

    constructor() {
        super("PLMCreateWorkOrderHeader", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateWorkOrderHeaderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateWorkOrderFromMasterPlanBOMResolution2 extends QAction<PLMCreateWorkOrderFromMasterPlanBOMResolution2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateWorkOrderFromMasterPlanBOMResolution())];

    constructor() {
        super("PLMCreateWorkOrderFromMasterPlanBOMResolution", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateWorkOrderFromMasterPlanBOMResolutionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCompleteAsPlannedBOP2 extends QAction<UADMCompleteAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCompleteAsPlannedBOP())];

    constructor() {
        super("UADMCompleteAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCompleteAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateMaterialDefinition2 extends QAction<UpdateMaterialDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateMaterialDefinition())];

    constructor() {
        super("UpdateMaterialDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateMaterialDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteBufferDefinitionList2 extends QAction<UADMDeleteBufferDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteBufferDefinitionList())];

    constructor() {
        super("UADMDeleteBufferDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteBufferDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyToolDefinition2 extends QAction<CopyToolDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCopyToolDefinition())];

    constructor() {
        super("CopyToolDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyToolDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateToolDefinition2 extends QAction<UADMUpdateToolDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateToolDefinition())];

    constructor() {
        super("UADMUpdateToolDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateToolDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteMaterialDefinitions2 extends QAction<UADMDeleteMaterialDefinitions2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteMaterialDefinitions())];

    constructor() {
        super("UADMDeleteMaterialDefinitions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteMaterialDefinitionsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteAsPlannedBOPList2 extends QAction<UADMDeleteAsPlannedBOPList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteAsPlannedBOPList())];

    constructor() {
        super("UADMDeleteAsPlannedBOPList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteAsPlannedBOPListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMLinkMaterialItemsToHandlingUnit2 extends QAction<UADMLinkMaterialItemsToHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUADMLinkMaterialItemsToHandlingUnit())];

    constructor() {
        super("UADMLinkMaterialItemsToHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMLinkMaterialItemsToHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMLinkGenericItemsToNonConformance2 extends QAction<UADMLinkGenericItemsToNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMLinkGenericItemsToNonConformance())];

    constructor() {
        super("UADMLinkGenericItemsToNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMLinkGenericItemsToNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUnLinkGenericItemsFromNonConformance2 extends QAction<UADMUnLinkGenericItemsFromNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUnLinkGenericItemsFromNonConformance())];

    constructor() {
        super("UADMUnLinkGenericItemsFromNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUnLinkGenericItemsFromNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateExecutionGroup2 extends QAction<UADMCreateExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateExecutionGroup())];

    constructor() {
        super("UADMCreateExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateWorkOrderFromProcess2 extends QAction<UADMCreateWorkOrderFromProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateWorkOrderFromProcess())];

    constructor() {
        super("UADMCreateWorkOrderFromProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateWorkOrderFromProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMLinkMaterialItemsToBuffer2 extends QAction<UADMLinkMaterialItemsToBuffer2Params> {
    private readonly params = [new QComplexParam("command", new QUADMLinkMaterialItemsToBuffer())];

    constructor() {
        super("UADMLinkMaterialItemsToBuffer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMLinkMaterialItemsToBufferResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAcceptChangeAddWorkInstruction2 extends QAction<UADMAcceptChangeAddWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAcceptChangeAddWorkInstruction())];

    constructor() {
        super("UADMAcceptChangeAddWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAcceptChangeAddWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteSkillList2 extends QAction<UADMDeleteSkillList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteSkillList())];

    constructor() {
        super("UADMDeleteSkillList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteSkillListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMStartNonProductiveActivityList2 extends QAction<UADMStartNonProductiveActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMStartNonProductiveActivityList())];

    constructor() {
        super("UADMStartNonProductiveActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMStartNonProductiveActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCompleteNonProductiveActivityList2 extends QAction<UADMCompleteNonProductiveActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCompleteNonProductiveActivityList())];

    constructor() {
        super("UADMCompleteNonProductiveActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCompleteNonProductiveActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteNonProductiveActivityList2 extends QAction<UADMDeleteNonProductiveActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteNonProductiveActivityList())];

    constructor() {
        super("UADMDeleteNonProductiveActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteNonProductiveActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteOperationStepCategoryList2 extends QAction<UADMDeleteOperationStepCategoryList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteOperationStepCategoryList())];

    constructor() {
        super("UADMDeleteOperationStepCategoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteOperationStepCategoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMLinkSkillsToTeam2 extends QAction<UADMLinkSkillsToTeam2Params> {
    private readonly params = [new QComplexParam("command", new QUADMLinkSkillsToTeam())];

    constructor() {
        super("UADMLinkSkillsToTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMLinkSkillsToTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCopyDM_Material2 extends QAction<UADMCopyDM_Material2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCopyDM_Material())];

    constructor() {
        super("UADMCopyDM_Material", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCopyDM_MaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUnLinkUsersFromTeam2 extends QAction<UADMUnLinkUsersFromTeam2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUnLinkUsersFromTeam())];

    constructor() {
        super("UADMUnLinkUsersFromTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUnLinkUsersFromTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMLinkUsersToTeam2 extends QAction<UADMLinkUsersToTeam2Params> {
    private readonly params = [new QComplexParam("command", new QUADMLinkUsersToTeam())];

    constructor() {
        super("UADMLinkUsersToTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMLinkUsersToTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteDM_MaterialList2 extends QAction<UADMDeleteDM_MaterialList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteDM_MaterialList())];

    constructor() {
        super("UADMDeleteDM_MaterialList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteDM_MaterialListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteCustomItlkCheckList2 extends QAction<UADMDeleteCustomItlkCheckList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteCustomItlkCheckList())];

    constructor() {
        super("UADMDeleteCustomItlkCheckList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteCustomItlkCheckListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteCustomItlkCheckParameterList2 extends QAction<UADMDeleteCustomItlkCheckParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteCustomItlkCheckParameterList())];

    constructor() {
        super("UADMDeleteCustomItlkCheckParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteCustomItlkCheckParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRemoveHoldList2 extends QAction<UADMRemoveHoldList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRemoveHoldList())];

    constructor() {
        super("UADMRemoveHoldList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRemoveHoldListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationDCDList2 extends QAction<PLMCreateOperationDCDList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationDCDList())];

    constructor() {
        super("PLMCreateOperationDCDList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationDCDListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepDCDList2 extends QAction<PLMCreateStepDCDList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepDCDList())];

    constructor() {
        super("PLMCreateStepDCDList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepDCDListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMRegisterNonProductiveActivityForUser2 extends QAction<UADMRegisterNonProductiveActivityForUser2Params> {
    private readonly params = [new QComplexParam("command", new QUADMRegisterNonProductiveActivityForUser())];

    constructor() {
        super("UADMRegisterNonProductiveActivityForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMRegisterNonProductiveActivityForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteNonProductiveActivityListForUser2 extends QAction<UADMDeleteNonProductiveActivityListForUser2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteNonProductiveActivityListForUser())];

    constructor() {
        super("UADMDeleteNonProductiveActivityListForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteNonProductiveActivityListForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateNonProductiveActivityForUser2 extends QAction<UADMUpdateNonProductiveActivityForUser2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateNonProductiveActivityForUser())];

    constructor() {
        super("UADMUpdateNonProductiveActivityForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateNonProductiveActivityForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCancelScheduling2 extends QAction<CancelScheduling2Params> {
    private readonly params = [new QComplexParam("command", new QCancelScheduling())];

    constructor() {
        super("CancelScheduling", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCancelSchedulingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetInScheduling2 extends QAction<SetInScheduling2Params> {
    private readonly params = [new QComplexParam("command", new QSetInScheduling())];

    constructor() {
        super("SetInScheduling", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetInSchedulingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetInScheduled2 extends QAction<SetInScheduled2Params> {
    private readonly params = [new QComplexParam("command", new QSetInScheduled())];

    constructor() {
        super("SetInScheduled", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetInScheduledResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetAlternativeSelected2 extends QAction<SetAlternativeSelected2Params> {
    private readonly params = [new QComplexParam("command", new QSetAlternativeSelected())];

    constructor() {
        super("SetAlternativeSelected", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetAlternativeSelectedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticCreateNonConformanceOnMTUList2 extends QAction<UADMAutomaticCreateNonConformanceOnMTUList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticCreateNonConformanceOnMTUList())];

    constructor() {
        super("UADMAutomaticCreateNonConformanceOnMTUList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticCreateNonConformanceOnMTUListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticCreateNonConformanceOnWOOperation2 extends QAction<UADMAutomaticCreateNonConformanceOnWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticCreateNonConformanceOnWOOperation())];

    constructor() {
        super("UADMAutomaticCreateNonConformanceOnWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticCreateNonConformanceOnWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticCreateNonConformanceOnEquipment2 extends QAction<UADMAutomaticCreateNonConformanceOnEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticCreateNonConformanceOnEquipment())];

    constructor() {
        super("UADMAutomaticCreateNonConformanceOnEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticCreateNonConformanceOnEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticUseToolList2 extends QAction<UADMAutomaticUseToolList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticUseToolList())];

    constructor() {
        super("UADMAutomaticUseToolList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticUseToolListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticConsumeMaterialTrackingUnit2 extends QAction<UADMAutomaticConsumeMaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticConsumeMaterialTrackingUnit())];

    constructor() {
        super("UADMAutomaticConsumeMaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticConsumeMaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNonConformanceV3_12 extends QAction<UADMCreateNonConformanceV3_12Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNonConformanceV3_1())];

    constructor() {
        super("UADMCreateNonConformanceV3_1", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNonConformanceV3_1Response)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMSentenceNonConformanceV3_12 extends QAction<UADMSentenceNonConformanceV3_12Params> {
    private readonly params = [new QComplexParam("command", new QUADMSentenceNonConformanceV3_1())];

    constructor() {
        super("UADMSentenceNonConformanceV3_1", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMSentenceNonConformanceV3_1Response)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticSentenceNonConformance2 extends QAction<UADMAutomaticSentenceNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticSentenceNonConformance())];

    constructor() {
        super("UADMAutomaticSentenceNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticSentenceNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateToBeUsedMachinePJF2 extends QAction<UADMCreateToBeUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateToBeUsedMachinePJF())];

    constructor() {
        super("UADMCreateToBeUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateToBeUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteStepList2 extends QAction<UADMDeleteStepList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteStepList())];

    constructor() {
        super("UADMDeleteStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAbruptlyCloseFlexibleWorkOrder2 extends QAction<UADMAbruptlyCloseFlexibleWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAbruptlyCloseFlexibleWorkOrder())];

    constructor() {
        super("UADMAbruptlyCloseFlexibleWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAbruptlyCloseFlexibleWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMLinkHumanResourceToProcess2 extends QAction<UADMLinkHumanResourceToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUADMLinkHumanResourceToProcess())];

    constructor() {
        super("UADMLinkHumanResourceToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMLinkHumanResourceToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUnlinkHumanResourceFromProcess2 extends QAction<UADMUnlinkHumanResourceFromProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUnlinkHumanResourceFromProcess())];

    constructor() {
        super("UADMUnlinkHumanResourceFromProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUnlinkHumanResourceFromProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateCertificationWithSkillList2 extends QAction<PLMCreateCertificationWithSkillList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateCertificationWithSkillList())];

    constructor() {
        super("PLMCreateCertificationWithSkillList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateCertificationWithSkillListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationHRSpecificationFullList2 extends QAction<PLMCreateOperationHRSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationHRSpecificationFullList())];

    constructor() {
        super("PLMCreateOperationHRSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationHRSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepHRSpecificationFullList2 extends QAction<PLMCreateStepHRSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepHRSpecificationFullList())];

    constructor() {
        super("PLMCreateStepHRSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepHRSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteDefectGroupList2 extends QAction<UADMDeleteDefectGroupList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteDefectGroupList())];

    constructor() {
        super("UADMDeleteDefectGroupList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteDefectGroupListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteDefectTypeList2 extends QAction<UADMDeleteDefectTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteDefectTypeList())];

    constructor() {
        super("UADMDeleteDefectTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteDefectTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList2 extends QAction<PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList())];

    constructor() {
        super("PLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateDM_MaterialTrackingUnitandMaterialTrackingUnitListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMChangeStatusEventLog2 extends QAction<PLMChangeStatusEventLog2Params> {
    private readonly params = [new QComplexParam("command", new QPLMChangeStatusEventLog())];

    constructor() {
        super("PLMChangeStatusEventLog", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMChangeStatusEventLogResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMDeleteEventLogList2 extends QAction<PLMDeleteEventLogList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMDeleteEventLogList())];

    constructor() {
        super("PLMDeleteEventLogList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMDeleteEventLogListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMChangeStatusEventLogList2 extends QAction<PLMChangeStatusEventLogList2Params> {
    private readonly params = [new QComplexParam("command", new QPLMChangeStatusEventLogList())];

    constructor() {
        super("PLMChangeStatusEventLogList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMChangeStatusEventLogListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetInScheduledNoBulk2 extends QAction<SetInScheduledNoBulk2Params> {
    private readonly params = [new QComplexParam("command", new QSetInScheduledNoBulk())];

    constructor() {
        super("SetInScheduledNoBulk", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetInScheduledNoBulkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateOperationDCDWI2 extends QAction<PLMCreateOperationDCDWI2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateOperationDCDWI())];

    constructor() {
        super("PLMCreateOperationDCDWI", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateOperationDCDWIResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPLMCreateStepDCDWI2 extends QAction<PLMCreateStepDCDWI2Params> {
    private readonly params = [new QComplexParam("command", new QPLMCreateStepDCDWI())];

    constructor() {
        super("PLMCreateStepDCDWI", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPLMCreateStepDCDWIResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticAcquireQualityInspectionData2 extends QAction<UADMAutomaticAcquireQualityInspectionData2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticAcquireQualityInspectionData())];

    constructor() {
        super("UADMAutomaticAcquireQualityInspectionData", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticAcquireQualityInspectionDataResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticCreateSnagAndNote2 extends QAction<UADMAutomaticCreateSnagAndNote2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticCreateSnagAndNote())];

    constructor() {
        super("UADMAutomaticCreateSnagAndNote", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticCreateSnagAndNoteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMConsumeMaterialItemOnContainer2 extends QAction<UADMConsumeMaterialItemOnContainer2Params> {
    private readonly params = [new QComplexParam("command", new QUADMConsumeMaterialItemOnContainer())];

    constructor() {
        super("UADMConsumeMaterialItemOnContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMConsumeMaterialItemOnContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMReleaseWorkOrderList2 extends QAction<UADMReleaseWorkOrderList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMReleaseWorkOrderList())];

    constructor() {
        super("UADMReleaseWorkOrderList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMReleaseWorkOrderListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBoMItem2 extends QAction<CreateBoMItem2Params> {
    private readonly params = [new QComplexParam("command", new QCreateBoMItem())];

    constructor() {
        super("CreateBoMItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBoMItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSentenceNonConformance2 extends QAction<SentenceNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QSentenceNonConformance())];

    constructor() {
        super("SentenceNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSentenceNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateSkill2 extends QAction<UpdateSkill2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateSkill())];

    constructor() {
        super("UpdateSkill", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateSkillResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkOrderHold2 extends QAction<SetWorkOrderHold2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkOrderHold())];

    constructor() {
        super("SetWorkOrderHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkOrderHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTriggerPrintingOnWorkOrderOperation2 extends QAction<TriggerPrintingOnWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QTriggerPrintingOnWorkOrderOperation())];

    constructor() {
        super("TriggerPrintingOnWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTriggerPrintingOnWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetNonConformanceStatusIsFrozen2 extends QAction<SetNonConformanceStatusIsFrozen2Params> {
    private readonly params = [new QComplexParam("command", new QSetNonConformanceStatusIsFrozen())];

    constructor() {
        super("SetNonConformanceStatusIsFrozen", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetNonConformanceStatusIsFrozenResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialsTrackingUnit2 extends QAction<DeleteMaterialsTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialsTrackingUnit())];

    constructor() {
        super("DeleteMaterialsTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialsTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolSpecificationList2 extends QAction<DeleteToolSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolSpecificationList())];

    constructor() {
        super("DeleteToolSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkAMMachineToMES2 extends QAction<UnlinkAMMachineToMES2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkAMMachineToMES())];

    constructor() {
        super("UnlinkAMMachineToMES", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkAMMachineToMESResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeUsedMachinePJF2 extends QAction<CreateToBeUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeUsedMachinePJF())];

    constructor() {
        super("CreateToBeUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkItlkCheckToOperationToStepLinkList2 extends QAction<LinkItlkCheckToOperationToStepLinkList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkItlkCheckToOperationToStepLinkList())];

    constructor() {
        super("LinkItlkCheckToOperationToStepLinkList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkItlkCheckToOperationToStepLinkListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteUoM2 extends QAction<DeleteUoM2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteUoM())];

    constructor() {
        super("DeleteUoM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteUoMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetToBeCollectedDocument2 extends QAction<SetToBeCollectedDocument2Params> {
    private readonly params = [new QComplexParam("command", new QSetToBeCollectedDocument())];

    constructor() {
        super("SetToBeCollectedDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetToBeCollectedDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QInitializeCreatedTask2 extends QAction<InitializeCreatedTask2Params> {
    private readonly params = [new QComplexParam("command", new QInitializeCreatedTask())];

    constructor() {
        super("InitializeCreatedTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QInitializeCreatedTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOOperationSerialized2 extends QAction<StartWOOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOOperationSerialized())];

    constructor() {
        super("StartWOOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocumentListToDM_MaterialTrackingUnit2 extends QAction<UnlinkDocumentListToDM_MaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocumentListToDM_MaterialTrackingUnit())];

    constructor() {
        super("UnlinkDocumentListToDM_MaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentListToDM_MaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateResourceDefinitionList2 extends QAction<TCM2CreateResourceDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateResourceDefinitionList())];

    constructor() {
        super("TCM2CreateResourceDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateResourceDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetBufferWithActualQuantity2 extends QAction<GetBufferWithActualQuantity2Params> {
    private readonly params = [new QComplexParam("command", new QGetBufferWithActualQuantity())];

    constructor() {
        super("GetBufferWithActualQuantity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetBufferWithActualQuantityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolDefinitionDocumentList2 extends QAction<DeleteToolDefinitionDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolDefinitionDocumentList())];

    constructor() {
        super("DeleteToolDefinitionDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolDefinitionDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSaveWorkInstructionDesign2 extends QAction<SaveWorkInstructionDesign2Params> {
    private readonly params = [new QComplexParam("command", new QSaveWorkInstructionDesign())];

    constructor() {
        super("SaveWorkInstructionDesign", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSaveWorkInstructionDesignResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSubstrateDefinitionToMachine2 extends QAction<UnlinkSubstrateDefinitionToMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSubstrateDefinitionToMachine())];

    constructor() {
        super("UnlinkSubstrateDefinitionToMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSubstrateDefinitionToMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWIDefinitionsToWOStep2 extends QAction<LinkWIDefinitionsToWOStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWIDefinitionsToWOStep())];

    constructor() {
        super("LinkWIDefinitionsToWOStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWIDefinitionsToWOStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLockWorkInstructionDefinition2 extends QAction<LockWorkInstructionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QLockWorkInstructionDefinition())];

    constructor() {
        super("LockWorkInstructionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLockWorkInstructionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphConfiguration2 extends QAction<CreateEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphConfiguration())];

    constructor() {
        super("CreateEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateDNCItemMachineMaterialAssociation2 extends QAction<AssociateDNCItemMachineMaterialAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateDNCItemMachineMaterialAssociation())];

    constructor() {
        super("AssociateDNCItemMachineMaterialAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateDNCItemMachineMaterialAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2LinkOperationToStepList2 extends QAction<TCM2LinkOperationToStepList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2LinkOperationToStepList())];

    constructor() {
        super("TCM2LinkOperationToStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2LinkOperationToStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCustomItlkCheckParameterList2 extends QAction<DeleteCustomItlkCheckParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCustomItlkCheckParameterList())];

    constructor() {
        super("DeleteCustomItlkCheckParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCustomItlkCheckParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTeam2 extends QAction<CreateTeam2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTeam())];

    constructor() {
        super("CreateTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteProcessToOpLinkDependencyNavigationList2 extends QAction<DeleteProcessToOpLinkDependencyNavigationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteProcessToOpLinkDependencyNavigationList())];

    constructor() {
        super("DeleteProcessToOpLinkDependencyNavigationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteProcessToOpLinkDependencyNavigationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateOperation2 extends QAction<UpdateOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateOperation())];

    constructor() {
        super("UpdateOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentType2 extends QAction<CreateEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentType())];

    constructor() {
        super("CreateEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditWorkOrderHumanResource2 extends QAction<EditWorkOrderHumanResource2Params> {
    private readonly params = [new QComplexParam("command", new QEditWorkOrderHumanResource())];

    constructor() {
        super("EditWorkOrderHumanResource", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditWorkOrderHumanResourceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignNonConformanceTransitionMailAddressList2 extends QAction<AssignNonConformanceTransitionMailAddressList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignNonConformanceTransitionMailAddressList())];

    constructor() {
        super("AssignNonConformanceTransitionMailAddressList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignNonConformanceTransitionMailAddressListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSplitWorkOrder2 extends QAction<SplitWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QSplitWorkOrder())];

    constructor() {
        super("SplitWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSplitWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateVariableCharacteristicSpecification2 extends QAction<CreateVariableCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateVariableCharacteristicSpecification())];

    constructor() {
        super("CreateVariableCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateVariableCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteHold2 extends QAction<DeleteHold2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteHold())];

    constructor() {
        super("DeleteHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDM_MaterialTrackingUnitHistoryList2 extends QAction<CreateDM_MaterialTrackingUnitHistoryList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDM_MaterialTrackingUnitHistoryList())];

    constructor() {
        super("CreateDM_MaterialTrackingUnitHistoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDM_MaterialTrackingUnitHistoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteSkillList2 extends QAction<DeleteSkillList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteSkillList())];

    constructor() {
        super("DeleteSkillList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteSkillListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStatusTransitionDefinition2 extends QAction<CreateStatusTransitionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStatusTransitionDefinition())];

    constructor() {
        super("CreateStatusTransitionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStatusTransitionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkCharacteristicRepresentationToStep2 extends QAction<UnlinkCharacteristicRepresentationToStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkCharacteristicRepresentationToStep())];

    constructor() {
        super("UnlinkCharacteristicRepresentationToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkCharacteristicRepresentationToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteActualUsedMachine2 extends QAction<DeleteActualUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteActualUsedMachine())];

    constructor() {
        super("DeleteActualUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteActualUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateDocument2 extends QAction<UADMCreateDocument2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateDocument())];

    constructor() {
        super("UADMCreateDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBoMItemV4_02 extends QAction<CreateBoMItemV4_02Params> {
    private readonly params = [new QComplexParam("command", new QCreateBoMItemV4_0())];

    constructor() {
        super("CreateBoMItemV4_0", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBoMItemV4_0Response)))
    }

    getParams() {
        return this.params
    }
}

export class QRejectMaterialRequest2 extends QAction<RejectMaterialRequest2Params> {
    private readonly params = [new QComplexParam("command", new QRejectMaterialRequest())];

    constructor() {
        super("RejectMaterialRequest", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRejectMaterialRequestResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMaterialItemSplitBatchByPartialPreview2 extends QAction<MaterialItemSplitBatchByPartialPreview2Params> {
    private readonly params = [new QComplexParam("command", new QMaterialItemSplitBatchByPartialPreview())];

    constructor() {
        super("MaterialItemSplitBatchByPartialPreview", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMaterialItemSplitBatchByPartialPreviewResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDM_Material2 extends QAction<UpdateDM_Material2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDM_Material())];

    constructor() {
        super("UpdateDM_Material", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDM_MaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateToolDefinition2 extends QAction<UADMCreateToolDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateToolDefinition())];

    constructor() {
        super("UADMCreateToolDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateToolDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTeam2 extends QAction<DeleteTeam2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTeam())];

    constructor() {
        super("DeleteTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateItlkCheckWOOpAssociationList2 extends QAction<UpdateItlkCheckWOOpAssociationList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateItlkCheckWOOpAssociationList())];

    constructor() {
        super("UpdateItlkCheckWOOpAssociationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateItlkCheckWOOpAssociationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QExecuteCustomItlkCheckOutbound2 extends QAction<ExecuteCustomItlkCheckOutbound2Params> {
    private readonly params = [new QComplexParam("command", new QExecuteCustomItlkCheckOutbound())];

    constructor() {
        super("ExecuteCustomItlkCheckOutbound", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QExecuteCustomItlkCheckOutboundResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentSpecification2 extends QAction<CreateEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentSpecification())];

    constructor() {
        super("CreateEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkProcessToBeCleaned2 extends QAction<SetWorkProcessToBeCleaned2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkProcessToBeCleaned())];

    constructor() {
        super("SetWorkProcessToBeCleaned", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkProcessToBeCleanedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutoGenerateSerialNumberCodes2 extends QAction<AutoGenerateSerialNumberCodes2Params> {
    private readonly params = [new QComplexParam("command", new QAutoGenerateSerialNumberCodes())];

    constructor() {
        super("AutoGenerateSerialNumberCodes", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutoGenerateSerialNumberCodesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkUserToWorkOrderOperationList2 extends QAction<LinkUserToWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkUserToWorkOrderOperationList())];

    constructor() {
        super("LinkUserToWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkUserToWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateResultTypeList2 extends QAction<CreateResultTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateResultTypeList())];

    constructor() {
        super("CreateResultTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateResultTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignProducedMaterialItems2 extends QAction<AssignProducedMaterialItems2Params> {
    private readonly params = [new QComplexParam("command", new QAssignProducedMaterialItems())];

    constructor() {
        super("AssignProducedMaterialItems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignProducedMaterialItemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteFutureHoldAfterNonConformanceSentencing2 extends QAction<DeleteFutureHoldAfterNonConformanceSentencing2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteFutureHoldAfterNonConformanceSentencing())];

    constructor() {
        super("DeleteFutureHoldAfterNonConformanceSentencing", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteFutureHoldAfterNonConformanceSentencingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteActiveUserOnMachine2 extends QAction<DeleteActiveUserOnMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteActiveUserOnMachine())];

    constructor() {
        super("DeleteActiveUserOnMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteActiveUserOnMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkInstructionDefinition2 extends QAction<CreateWorkInstructionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkInstructionDefinition())];

    constructor() {
        super("CreateWorkInstructionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkInstructionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUploadOfflineActionList2 extends QAction<UploadOfflineActionList2Params> {
    private readonly params = [new QComplexParam("command", new QUploadOfflineActionList())];

    constructor() {
        super("UploadOfflineActionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUploadOfflineActionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPSSetAlternativeSelected2 extends QAction<APSSetAlternativeSelected2Params> {
    private readonly params = [new QComplexParam("command", new QAPSSetAlternativeSelected())];

    constructor() {
        super("APSSetAlternativeSelected", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPSSetAlternativeSelectedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDNCItemMachineMaterialAssociation2 extends QAction<UpdateDNCItemMachineMaterialAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDNCItemMachineMaterialAssociation())];

    constructor() {
        super("UpdateDNCItemMachineMaterialAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDNCItemMachineMaterialAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateOperation2 extends QAction<UADMUpdateOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateOperation())];

    constructor() {
        super("UADMUpdateOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTriggerPrintingOnWorkOrder2 extends QAction<TriggerPrintingOnWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QTriggerPrintingOnWorkOrder())];

    constructor() {
        super("TriggerPrintingOnWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTriggerPrintingOnWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2LinkProcessToProcessList2 extends QAction<TCM2LinkProcessToProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2LinkProcessToProcessList())];

    constructor() {
        super("TCM2LinkProcessToProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2LinkProcessToProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAdministrativePause2 extends QAction<AdministrativePause2Params> {
    private readonly params = [new QComplexParam("command", new QAdministrativePause())];

    constructor() {
        super("AdministrativePause", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAdministrativePauseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInUploadDocuments2 extends QAction<CheckInUploadDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInUploadDocuments())];

    constructor() {
        super("CheckInUploadDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInUploadDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStatusBehaviorDefinition2 extends QAction<DeleteStatusBehaviorDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStatusBehaviorDefinition())];

    constructor() {
        super("DeleteStatusBehaviorDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStatusBehaviorDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialSpecification2 extends QAction<CreateMaterialSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialSpecification())];

    constructor() {
        super("CreateMaterialSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocumentListToStep2 extends QAction<UnlinkDocumentListToStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocumentListToStep())];

    constructor() {
        super("UnlinkDocumentListToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentListToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderOutMsg2 extends QAction<CreateWorkOrderOutMsg2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderOutMsg())];

    constructor() {
        super("CreateWorkOrderOutMsg", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderOutMsgResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSkillsToCertificate2 extends QAction<LinkSkillsToCertificate2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSkillsToCertificate())];

    constructor() {
        super("LinkSkillsToCertificate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSkillsToCertificateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewOperationRevisionInCatalogue2 extends QAction<CreateNewOperationRevisionInCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewOperationRevisionInCatalogue())];

    constructor() {
        super("CreateNewOperationRevisionInCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewOperationRevisionInCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonProductiveActivityListForUser2 extends QAction<DeleteNonProductiveActivityListForUser2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonProductiveActivityListForUser())];

    constructor() {
        super("DeleteNonProductiveActivityListForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonProductiveActivityListForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateMaterialSpecificationList2 extends QAction<TCM2CreateMaterialSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateMaterialSpecificationList())];

    constructor() {
        super("TCM2CreateMaterialSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateMaterialSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTraceNonConformanceOnContainer2 extends QAction<TraceNonConformanceOnContainer2Params> {
    private readonly params = [new QComplexParam("command", new QTraceNonConformanceOnContainer())];

    constructor() {
        super("TraceNonConformanceOnContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTraceNonConformanceOnContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDocumentListFormFileIds2 extends QAction<CreateDocumentListFormFileIds2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDocumentListFormFileIds())];

    constructor() {
        super("CreateDocumentListFormFileIds", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDocumentListFormFileIdsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateToolSpecificationList2 extends QAction<TCM2CreateToolSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateToolSpecificationList())];

    constructor() {
        super("TCM2CreateToolSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateToolSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateStepDependencyList2 extends QAction<TCM2CreateStepDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateStepDependencyList())];

    constructor() {
        super("TCM2CreateStepDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateStepDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSkillsToWorkOrderStep2 extends QAction<LinkSkillsToWorkOrderStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSkillsToWorkOrderStep())];

    constructor() {
        super("LinkSkillsToWorkOrderStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSkillsToWorkOrderStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkItlkCheckToOperationStepCategoryList2 extends QAction<LinkItlkCheckToOperationStepCategoryList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkItlkCheckToOperationStepCategoryList())];

    constructor() {
        super("LinkItlkCheckToOperationStepCategoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkItlkCheckToOperationStepCategoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2AssociateDocumentToOperationList2 extends QAction<TCM2AssociateDocumentToOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2AssociateDocumentToOperationList())];

    constructor() {
        super("TCM2AssociateDocumentToOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2AssociateDocumentToOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOStep2 extends QAction<StartWOStep2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOStep())];

    constructor() {
        super("StartWOStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateMaterialSpecification2 extends QAction<UpdateMaterialSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateMaterialSpecification())];

    constructor() {
        super("UpdateMaterialSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateMaterialSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolCompatibleMachine2 extends QAction<DeleteToolCompatibleMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolCompatibleMachine())];

    constructor() {
        super("DeleteToolCompatibleMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolCompatibleMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDM_MaterialTrackingUnitHistory2 extends QAction<CreateDM_MaterialTrackingUnitHistory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDM_MaterialTrackingUnitHistory())];

    constructor() {
        super("CreateDM_MaterialTrackingUnitHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDM_MaterialTrackingUnitHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteAsPlannedBoP2 extends QAction<DeleteAsPlannedBoP2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteAsPlannedBoP())];

    constructor() {
        super("DeleteAsPlannedBoP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteAsPlannedBoPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeWorkOrderStatusToEdit2 extends QAction<ChangeWorkOrderStatusToEdit2Params> {
    private readonly params = [new QComplexParam("command", new QChangeWorkOrderStatusToEdit())];

    constructor() {
        super("ChangeWorkOrderStatusToEdit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeWorkOrderStatusToEditResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateBufferDefinition2 extends QAction<UpdateBufferDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateBufferDefinition())];

    constructor() {
        super("UpdateBufferDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateBufferDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateUoMDimension2 extends QAction<UpdateUoMDimension2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateUoMDimension())];

    constructor() {
        super("UpdateUoMDimension", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateUoMDimensionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkProcessDMMaterialTrackingUnitAssociationList2 extends QAction<DeleteWorkProcessDMMaterialTrackingUnitAssociationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkProcessDMMaterialTrackingUnitAssociationList())];

    constructor() {
        super("DeleteWorkProcessDMMaterialTrackingUnitAssociationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkProcessDMMaterialTrackingUnitAssociationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteFailure2 extends QAction<DeleteFailure2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteFailure())];

    constructor() {
        super("DeleteFailure", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteFailureResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToolsToNonConformance2 extends QAction<LinkToolsToNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToolsToNonConformance())];

    constructor() {
        super("LinkToolsToNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToolsToNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdatePreferredProcessToOpLinkDependencyNavigation2 extends QAction<UpdatePreferredProcessToOpLinkDependencyNavigation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdatePreferredProcessToOpLinkDependencyNavigation())];

    constructor() {
        super("UpdatePreferredProcessToOpLinkDependencyNavigation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdatePreferredProcessToOpLinkDependencyNavigationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeUsedInspection2 extends QAction<DeleteToBeUsedInspection2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeUsedInspection())];

    constructor() {
        super("DeleteToBeUsedInspection", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeUsedInspectionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDocument2 extends QAction<CreateDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDocument())];

    constructor() {
        super("CreateDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateMaterialDefinition2 extends QAction<UADMUpdateMaterialDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateMaterialDefinition())];

    constructor() {
        super("UADMUpdateMaterialDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateMaterialDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkPJFToEquipmentSpecification2 extends QAction<UnLinkPJFToEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkPJFToEquipmentSpecification())];

    constructor() {
        super("UnLinkPJFToEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkPJFToEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStatus2 extends QAction<DeleteStatus2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStatus())];

    constructor() {
        super("DeleteStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkItlkCheckToOperationStepCategoryList2 extends QAction<UnlinkItlkCheckToOperationStepCategoryList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkItlkCheckToOperationStepCategoryList())];

    constructor() {
        super("UnlinkItlkCheckToOperationStepCategoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkItlkCheckToOperationStepCategoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStatusBehaviorDefinition2 extends QAction<UpdateStatusBehaviorDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStatusBehaviorDefinition())];

    constructor() {
        super("UpdateStatusBehaviorDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStatusBehaviorDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateItlkCheckToOperationToStepLinkList2 extends QAction<UpdateItlkCheckToOperationToStepLinkList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateItlkCheckToOperationToStepLinkList())];

    constructor() {
        super("UpdateItlkCheckToOperationToStepLinkList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateItlkCheckToOperationToStepLinkListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteBufferDefinitionList2 extends QAction<DeleteBufferDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteBufferDefinitionList())];

    constructor() {
        super("DeleteBufferDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteBufferDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkATNInstanceParameterToSetPointItemList2 extends QAction<UnlinkATNInstanceParameterToSetPointItemList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkATNInstanceParameterToSetPointItemList())];

    constructor() {
        super("UnlinkATNInstanceParameterToSetPointItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkATNInstanceParameterToSetPointItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartUsingScrewingTool2 extends QAction<StartUsingScrewingTool2Params> {
    private readonly params = [new QComplexParam("command", new QStartUsingScrewingTool())];

    constructor() {
        super("StartUsingScrewingTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartUsingScrewingToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolList2 extends QAction<DeleteToolList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolList())];

    constructor() {
        super("DeleteToolList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkOperationStepCategoryToProcessDefinitionList2 extends QAction<LinkOperationStepCategoryToProcessDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkOperationStepCategoryToProcessDefinitionList())];

    constructor() {
        super("LinkOperationStepCategoryToProcessDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkOperationStepCategoryToProcessDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceNotification2 extends QAction<DeleteNonConformanceNotification2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceNotification())];

    constructor() {
        super("DeleteNonConformanceNotification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceNotificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWOByBop2 extends QAction<UpdateWOByBop2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWOByBop())];

    constructor() {
        super("UpdateWOByBop", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWOByBopResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTemplateToMaterialPlantList2 extends QAction<DeleteTemplateToMaterialPlantList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTemplateToMaterialPlantList())];

    constructor() {
        super("DeleteTemplateToMaterialPlantList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTemplateToMaterialPlantListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdatePreferredWOOpDependencyNavigation2 extends QAction<UpdatePreferredWOOpDependencyNavigation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdatePreferredWOOpDependencyNavigation())];

    constructor() {
        super("UpdatePreferredWOOpDependencyNavigation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdatePreferredWOOpDependencyNavigationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentLevel2 extends QAction<DeleteEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentLevel())];

    constructor() {
        super("DeleteEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRecycleAMPowderBatch2 extends QAction<RecycleAMPowderBatch2Params> {
    private readonly params = [new QComplexParam("command", new QRecycleAMPowderBatch())];

    constructor() {
        super("RecycleAMPowderBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRecycleAMPowderBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetDCDRuntimeWIToSaveByMachine2 extends QAction<GetDCDRuntimeWIToSaveByMachine2Params> {
    private readonly params = [new QComplexParam("command", new QGetDCDRuntimeWIToSaveByMachine())];

    constructor() {
        super("GetDCDRuntimeWIToSaveByMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetDCDRuntimeWIToSaveByMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialItemsToHandlingUnit2 extends QAction<LinkMaterialItemsToHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialItemsToHandlingUnit())];

    constructor() {
        super("LinkMaterialItemsToHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialItemsToHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetOperationStepCategoryProcessDefinitionByMTU2 extends QAction<SetOperationStepCategoryProcessDefinitionByMTU2Params> {
    private readonly params = [new QComplexParam("command", new QSetOperationStepCategoryProcessDefinitionByMTU())];

    constructor() {
        super("SetOperationStepCategoryProcessDefinitionByMTU", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetOperationStepCategoryProcessDefinitionByMTUResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkCharacteristicRepresentationToOperation2 extends QAction<UnlinkCharacteristicRepresentationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkCharacteristicRepresentationToOperation())];

    constructor() {
        super("UnlinkCharacteristicRepresentationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkCharacteristicRepresentationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkOperationToProcess2 extends QAction<LinkOperationToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QLinkOperationToProcess())];

    constructor() {
        super("LinkOperationToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkOperationToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2LinkProcessToOperationList2 extends QAction<TCM2LinkProcessToOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2LinkProcessToOperationList())];

    constructor() {
        super("TCM2LinkProcessToOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2LinkProcessToOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderAndMaterialItemHistory2 extends QAction<CreateWorkOrderAndMaterialItemHistory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderAndMaterialItemHistory())];

    constructor() {
        super("CreateWorkOrderAndMaterialItemHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderAndMaterialItemHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConsumeMaterialItem2 extends QAction<ConsumeMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QConsumeMaterialItem())];

    constructor() {
        super("ConsumeMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConsumeMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOOperationsSerializedLiteSingleWO2 extends QAction<CompleteWOOperationsSerializedLiteSingleWO2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOOperationsSerializedLiteSingleWO())];

    constructor() {
        super("CompleteWOOperationsSerializedLiteSingleWO", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOOperationsSerializedLiteSingleWOResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphConfiguration2 extends QAction<DeleteEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphConfiguration())];

    constructor() {
        super("DeleteEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeUsedMachine2 extends QAction<DeleteToBeUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeUsedMachine())];

    constructor() {
        super("DeleteToBeUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateResultList2 extends QAction<UpdateResultList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateResultList())];

    constructor() {
        super("UpdateResultList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateResultListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkInstructionsToWOOperation2 extends QAction<LinkWorkInstructionsToWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkInstructionsToWOOperation())];

    constructor() {
        super("LinkWorkInstructionsToWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkInstructionsToWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWOOperationListToExecutionGroup2 extends QAction<LinkWOOperationListToExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWOOperationListToExecutionGroup())];

    constructor() {
        super("LinkWOOperationListToExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWOOperationListToExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkOrderForScheduling2 extends QAction<SetWorkOrderForScheduling2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkOrderForScheduling())];

    constructor() {
        super("SetWorkOrderForScheduling", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkOrderForSchedulingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkToBeUsedMachineToPartProgram2 extends QAction<UnLinkToBeUsedMachineToPartProgram2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkToBeUsedMachineToPartProgram())];

    constructor() {
        super("UnLinkToBeUsedMachineToPartProgram", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkToBeUsedMachineToPartProgramResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMasterPlanList2 extends QAction<DeleteMasterPlanList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMasterPlanList())];

    constructor() {
        super("DeleteMasterPlanList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMasterPlanListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateOpDependencyList2 extends QAction<TCM2CreateOpDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateOpDependencyList())];

    constructor() {
        super("TCM2CreateOpDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateOpDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceStatusList2 extends QAction<DeleteNonConformanceStatusList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceStatusList())];

    constructor() {
        super("DeleteNonConformanceStatusList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceStatusListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2AssociateDocumentToToolDefinitionList2 extends QAction<TCM2AssociateDocumentToToolDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2AssociateDocumentToToolDefinitionList())];

    constructor() {
        super("TCM2AssociateDocumentToToolDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2AssociateDocumentToToolDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkCharacteristicRepresentationToStep2 extends QAction<LinkCharacteristicRepresentationToStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkCharacteristicRepresentationToStep())];

    constructor() {
        super("LinkCharacteristicRepresentationToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkCharacteristicRepresentationToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentStatus2 extends QAction<SetEquipmentStatus2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentStatus())];

    constructor() {
        super("SetEquipmentStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateEquipmentSpecification2 extends QAction<UADMUpdateEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateEquipmentSpecification())];

    constructor() {
        super("UADMUpdateEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentSpecificationList2 extends QAction<CreateEquipmentSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentSpecificationList())];

    constructor() {
        super("CreateEquipmentSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialDefinitionDocumentList2 extends QAction<DeleteMaterialDefinitionDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialDefinitionDocumentList())];

    constructor() {
        super("DeleteMaterialDefinitionDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialDefinitionDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDefectTypeList2 extends QAction<DeleteDefectTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDefectTypeList())];

    constructor() {
        super("DeleteDefectTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDefectTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateSubstrateTreatmentAndThickness2 extends QAction<UpdateSubstrateTreatmentAndThickness2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateSubstrateTreatmentAndThickness())];

    constructor() {
        super("UpdateSubstrateTreatmentAndThickness", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateSubstrateTreatmentAndThicknessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialAndDM_Material2 extends QAction<CreateMaterialAndDM_Material2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialAndDM_Material())];

    constructor() {
        super("CreateMaterialAndDM_Material", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialAndDM_MaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkOrderOperationFutureHold2 extends QAction<SetWorkOrderOperationFutureHold2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkOrderOperationFutureHold())];

    constructor() {
        super("SetWorkOrderOperationFutureHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkOrderOperationFutureHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderFromMasterPlanWithQC2 extends QAction<CreateWorkOrderFromMasterPlanWithQC2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderFromMasterPlanWithQC())];

    constructor() {
        super("CreateWorkOrderFromMasterPlanWithQC", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderFromMasterPlanWithQCResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStepDependencyList2 extends QAction<CreateStepDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStepDependencyList())];

    constructor() {
        super("CreateStepDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStepDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkOrderHistory2 extends QAction<UpdateWorkOrderHistory2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkOrderHistory())];

    constructor() {
        super("UpdateWorkOrderHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkOrderHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialClass2 extends QAction<CreateMaterialClass2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialClass())];

    constructor() {
        super("CreateMaterialClass", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialClassResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkUserToPlant2 extends QAction<LinkUserToPlant2Params> {
    private readonly params = [new QComplexParam("command", new QLinkUserToPlant())];

    constructor() {
        super("LinkUserToPlant", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkUserToPlantResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetToBeProducedMaterialsResult2 extends QAction<GetToBeProducedMaterialsResult2Params> {
    private readonly params = [new QComplexParam("command", new QGetToBeProducedMaterialsResult())];

    constructor() {
        super("GetToBeProducedMaterialsResult", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetToBeProducedMaterialsResultResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInCompleteWOOperationTransferBatch2 extends QAction<CheckInCompleteWOOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInCompleteWOOperationTransferBatch())];

    constructor() {
        super("CheckInCompleteWOOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInCompleteWOOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateResultTypeList2 extends QAction<UpdateResultTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateResultTypeList())];

    constructor() {
        super("UpdateResultTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateResultTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOStepList2 extends QAction<CompleteWOStepList2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOStepList())];

    constructor() {
        super("CompleteWOStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocument2 extends QAction<DeleteDocument2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocument())];

    constructor() {
        super("DeleteDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteUoMFactor2 extends QAction<DeleteUoMFactor2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteUoMFactor())];

    constructor() {
        super("DeleteUoMFactor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteUoMFactorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceSupervisor2 extends QAction<DeleteNonConformanceSupervisor2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceSupervisor())];

    constructor() {
        super("DeleteNonConformanceSupervisor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceSupervisorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateToBeUsedMachinePJF2 extends QAction<UpdateToBeUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateToBeUsedMachinePJF())];

    constructor() {
        super("UpdateToBeUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateToBeUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrderHistoryMaterialItem2 extends QAction<DeleteWorkOrderHistoryMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrderHistoryMaterialItem())];

    constructor() {
        super("DeleteWorkOrderHistoryMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderHistoryMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateMaterialDefinition2 extends QAction<UADMCreateMaterialDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateMaterialDefinition())];

    constructor() {
        super("UADMCreateMaterialDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateMaterialDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteTaskAndWorkProcessList2 extends QAction<CompleteTaskAndWorkProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteTaskAndWorkProcessList())];

    constructor() {
        super("CompleteTaskAndWorkProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteTaskAndWorkProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkOfflineSessionToWorkOrderOperationList2 extends QAction<LinkOfflineSessionToWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkOfflineSessionToWorkOrderOperationList())];

    constructor() {
        super("LinkOfflineSessionToWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkOfflineSessionToWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperationDependencyList2 extends QAction<DeleteOperationDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperationDependencyList())];

    constructor() {
        super("DeleteOperationDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSubstrateToMachine2 extends QAction<UnlinkSubstrateToMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSubstrateToMachine())];

    constructor() {
        super("UnlinkSubstrateToMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSubstrateToMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutomaticConsumeMaterialItem2 extends QAction<AutomaticConsumeMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QAutomaticConsumeMaterialItem())];

    constructor() {
        super("AutomaticConsumeMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutomaticConsumeMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOperationType2 extends QAction<CreateWorkOperationType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOperationType())];

    constructor() {
        super("CreateWorkOperationType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOperationTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateEquipmentSpecification2 extends QAction<UADMCreateEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateEquipmentSpecification())];

    constructor() {
        super("UADMCreateEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRevertResultsStrategy2 extends QAction<RevertResultsStrategy2Params> {
    private readonly params = [new QComplexParam("command", new QRevertResultsStrategy())];

    constructor() {
        super("RevertResultsStrategy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRevertResultsStrategyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateCharacteristicFailureAssociation2 extends QAction<UpdateCharacteristicFailureAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateCharacteristicFailureAssociation())];

    constructor() {
        super("UpdateCharacteristicFailureAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateCharacteristicFailureAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutoGenerateMTUCode2 extends QAction<AutoGenerateMTUCode2Params> {
    private readonly params = [new QComplexParam("command", new QAutoGenerateMTUCode())];

    constructor() {
        super("AutoGenerateMTUCode", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutoGenerateMTUCodeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QExecuteItlkCheckOutbound2 extends QAction<ExecuteItlkCheckOutbound2Params> {
    private readonly params = [new QComplexParam("command", new QExecuteItlkCheckOutbound())];

    constructor() {
        super("ExecuteItlkCheckOutbound", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QExecuteItlkCheckOutboundResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateItlkCheckProcessToOpLinkAssociationList2 extends QAction<UpdateItlkCheckProcessToOpLinkAssociationList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateItlkCheckProcessToOpLinkAssociationList())];

    constructor() {
        super("UpdateItlkCheckProcessToOpLinkAssociationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateItlkCheckProcessToOpLinkAssociationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateSetPointItem2 extends QAction<UpdateSetPointItem2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateSetPointItem())];

    constructor() {
        super("UpdateSetPointItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateSetPointItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QValidateMaterialCoProductionIsComplete2 extends QAction<ValidateMaterialCoProductionIsComplete2Params> {
    private readonly params = [new QComplexParam("command", new QValidateMaterialCoProductionIsComplete())];

    constructor() {
        super("ValidateMaterialCoProductionIsComplete", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QValidateMaterialCoProductionIsCompleteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkMaterialItemsFromNonConformance2 extends QAction<UnLinkMaterialItemsFromNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkMaterialItemsFromNonConformance())];

    constructor() {
        super("UnLinkMaterialItemsFromNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkMaterialItemsFromNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkAutomationNodeInstanceParameterFromDCItemList2 extends QAction<UnlinkAutomationNodeInstanceParameterFromDCItemList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkAutomationNodeInstanceParameterFromDCItemList())];

    constructor() {
        super("UnlinkAutomationNodeInstanceParameterFromDCItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkAutomationNodeInstanceParameterFromDCItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkWorkOrderHumanResource2 extends QAction<UnlinkWorkOrderHumanResource2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkWorkOrderHumanResource())];

    constructor() {
        super("UnlinkWorkOrderHumanResource", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkWorkOrderHumanResourceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStatusTransitionDefinition2 extends QAction<DeleteStatusTransitionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStatusTransitionDefinition())];

    constructor() {
        super("DeleteStatusTransitionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStatusTransitionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateSetPoint2 extends QAction<CreateSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QCreateSetPoint())];

    constructor() {
        super("CreateSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteBuffer2 extends QAction<DeleteBuffer2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteBuffer())];

    constructor() {
        super("DeleteBuffer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteBufferResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeAddToBeConsumedMaterial2 extends QAction<AcceptChangeAddToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeAddToBeConsumedMaterial())];

    constructor() {
        super("AcceptChangeAddToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeAddToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateProcessInCatalogue2 extends QAction<UADMCreateProcessInCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateProcessInCatalogue())];

    constructor() {
        super("UADMCreateProcessInCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateProcessInCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrder2 extends QAction<DeleteWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrder())];

    constructor() {
        super("DeleteWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationList2 extends QAction<CreateOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationList())];

    constructor() {
        super("CreateOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkLogisticWhitelist2 extends QAction<UnLinkLogisticWhitelist2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkLogisticWhitelist())];

    constructor() {
        super("UnLinkLogisticWhitelist", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkLogisticWhitelistResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeUsedMachinePJFFromProcess2 extends QAction<CreateToBeUsedMachinePJFFromProcess2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeUsedMachinePJFFromProcess())];

    constructor() {
        super("CreateToBeUsedMachinePJFFromProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeUsedMachinePJFFromProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteActualUsedTool2 extends QAction<DeleteActualUsedTool2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteActualUsedTool())];

    constructor() {
        super("DeleteActualUsedTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteActualUsedToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSkillsFromProcessOperation2 extends QAction<UnlinkSkillsFromProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSkillsFromProcessOperation())];

    constructor() {
        super("UnlinkSkillsFromProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSkillsFromProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTemplateBlock2 extends QAction<CreateTemplateBlock2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTemplateBlock())];

    constructor() {
        super("CreateTemplateBlock", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTemplateBlockResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActualUsedMachinePJF2 extends QAction<CreateActualUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActualUsedMachinePJF())];

    constructor() {
        super("CreateActualUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActualUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTemplateBlock2 extends QAction<UpdateTemplateBlock2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTemplateBlock())];

    constructor() {
        super("UpdateTemplateBlock", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTemplateBlockResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreatePauseReason2 extends QAction<CreatePauseReason2Params> {
    private readonly params = [new QComplexParam("command", new QCreatePauseReason())];

    constructor() {
        super("CreatePauseReason", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreatePauseReasonResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperation2 extends QAction<DeleteOperation2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperation())];

    constructor() {
        super("DeleteOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetMaterialItemListForVerifyWorkOrderOperation2 extends QAction<GetMaterialItemListForVerifyWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QGetMaterialItemListForVerifyWorkOrderOperation())];

    constructor() {
        super("GetMaterialItemListForVerifyWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetMaterialItemListForVerifyWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfiguration2 extends QAction<DeleteEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfiguration())];

    constructor() {
        super("DeleteEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonProductiveActivityForUser2 extends QAction<UpdateNonProductiveActivityForUser2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonProductiveActivityForUser())];

    constructor() {
        super("UpdateNonProductiveActivityForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonProductiveActivityForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceStatus2 extends QAction<CreateNonConformanceStatus2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceStatus())];

    constructor() {
        super("CreateNonConformanceStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonConformanceLifecycle2 extends QAction<UpdateNonConformanceLifecycle2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonConformanceLifecycle())];

    constructor() {
        super("UpdateNonConformanceLifecycle", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonConformanceLifecycleResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInCreateNonConformance2 extends QAction<CheckInCreateNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInCreateNonConformance())];

    constructor() {
        super("CheckInCreateNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInCreateNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGroupConfiguration2 extends QAction<DeleteEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGroupConfiguration())];

    constructor() {
        super("DeleteEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRetrieveAllFilterQCData2 extends QAction<RetrieveAllFilterQCData2Params> {
    private readonly params = [new QComplexParam("command", new QRetrieveAllFilterQCData())];

    constructor() {
        super("RetrieveAllFilterQCData", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRetrieveAllFilterQCDataResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteSnagAndNoteNotificationList2 extends QAction<DeleteSnagAndNoteNotificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteSnagAndNoteNotificationList())];

    constructor() {
        super("DeleteSnagAndNoteNotificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteSnagAndNoteNotificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStateMachine2 extends QAction<DeleteStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStateMachine())];

    constructor() {
        super("DeleteStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyToBeProducedFacets2 extends QAction<CopyToBeProducedFacets2Params> {
    private readonly params = [new QComplexParam("command", new QCopyToBeProducedFacets())];

    constructor() {
        super("CopyToBeProducedFacets", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyToBeProducedFacetsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeSetPointStatus2 extends QAction<ChangeSetPointStatus2Params> {
    private readonly params = [new QComplexParam("command", new QChangeSetPointStatus())];

    constructor() {
        super("ChangeSetPointStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeSetPointStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReleaseTransportOperation2 extends QAction<ReleaseTransportOperation2Params> {
    private readonly params = [new QComplexParam("command", new QReleaseTransportOperation())];

    constructor() {
        super("ReleaseTransportOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReleaseTransportOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSkillsFromCertificate2 extends QAction<UnlinkSkillsFromCertificate2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSkillsFromCertificate())];

    constructor() {
        super("UnlinkSkillsFromCertificate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSkillsFromCertificateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDefectTypeContextualization2 extends QAction<CreateDefectTypeContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDefectTypeContextualization())];

    constructor() {
        super("CreateDefectTypeContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDefectTypeContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkMachineDefinitionToSetPoint2 extends QAction<UnlinkMachineDefinitionToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkMachineDefinitionToSetPoint())];

    constructor() {
        super("UnlinkMachineDefinitionToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkMachineDefinitionToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCharacteristicSpecification2 extends QAction<DeleteCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCharacteristicSpecification())];

    constructor() {
        super("DeleteCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSkillsToWorkOrderOperation2 extends QAction<LinkSkillsToWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSkillsToWorkOrderOperation())];

    constructor() {
        super("LinkSkillsToWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSkillsToWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateOperationList2 extends QAction<TCM2CreateOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateOperationList())];

    constructor() {
        super("TCM2CreateOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolHistoryAction2 extends QAction<DeleteToolHistoryAction2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolHistoryAction())];

    constructor() {
        super("DeleteToolHistoryAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolHistoryActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLink3DPrinterToEquipment2 extends QAction<Link3DPrinterToEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QLink3DPrinterToEquipment())];

    constructor() {
        super("Link3DPrinterToEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLink3DPrinterToEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentConfiguration2 extends QAction<UpdateEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentConfiguration())];

    constructor() {
        super("UpdateEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteSnagAndNote2 extends QAction<DeleteSnagAndNote2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteSnagAndNote())];

    constructor() {
        super("DeleteSnagAndNote", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteSnagAndNoteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteResultTypeList2 extends QAction<DeleteResultTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteResultTypeList())];

    constructor() {
        super("DeleteResultTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteResultTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGenerateRuntimePrintJobFile2 extends QAction<GenerateRuntimePrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QGenerateRuntimePrintJobFile())];

    constructor() {
        super("GenerateRuntimePrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGenerateRuntimePrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonConformance2 extends QAction<UpdateNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonConformance())];

    constructor() {
        super("UpdateNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderOperation2 extends QAction<CreateWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderOperation())];

    constructor() {
        super("CreateWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOOperationDependencies2 extends QAction<CreateWorkOOperationDependencies2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOOperationDependencies())];

    constructor() {
        super("CreateWorkOOperationDependencies", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOOperationDependenciesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformance2 extends QAction<DeleteNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformance())];

    constructor() {
        super("DeleteNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeRepeatOperation2 extends QAction<AcceptChangeRepeatOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeRepeatOperation())];

    constructor() {
        super("AcceptChangeRepeatOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeRepeatOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkPrintJobFileToMachine2 extends QAction<LinkPrintJobFileToMachine2Params> {
    private readonly params = [new QComplexParam("command", new QLinkPrintJobFileToMachine())];

    constructor() {
        super("LinkPrintJobFileToMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkPrintJobFileToMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSkillsToTeam2 extends QAction<LinkSkillsToTeam2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSkillsToTeam())];

    constructor() {
        super("LinkSkillsToTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSkillsToTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkInstructionsToContainer2 extends QAction<LinkWorkInstructionsToContainer2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkInstructionsToContainer())];

    constructor() {
        super("LinkWorkInstructionsToContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkInstructionsToContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkPartProgramFromEquipmentSpecification2 extends QAction<UnlinkPartProgramFromEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkPartProgramFromEquipmentSpecification())];

    constructor() {
        super("UnlinkPartProgramFromEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkPartProgramFromEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateHoldReason2 extends QAction<CreateHoldReason2Params> {
    private readonly params = [new QComplexParam("command", new QCreateHoldReason())];

    constructor() {
        super("CreateHoldReason", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateHoldReasonResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassembleMaterialItemLite2 extends QAction<DisassembleMaterialItemLite2Params> {
    private readonly params = [new QComplexParam("command", new QDisassembleMaterialItemLite())];

    constructor() {
        super("DisassembleMaterialItemLite", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassembleMaterialItemLiteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOStepFullQty2 extends QAction<StartWOStepFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOStepFullQty())];

    constructor() {
        super("StartWOStepFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOStepFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkOperationDependencyToProcess2 extends QAction<UnlinkOperationDependencyToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkOperationDependencyToProcess())];

    constructor() {
        super("UnlinkOperationDependencyToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkOperationDependencyToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkOStepDependency2 extends QAction<UpdateWorkOStepDependency2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkOStepDependency())];

    constructor() {
        super("UpdateWorkOStepDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkOStepDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceOnContainerContent2 extends QAction<CreateNonConformanceOnContainerContent2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceOnContainerContent())];

    constructor() {
        super("CreateNonConformanceOnContainerContent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceOnContainerContentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteReworkCodeList2 extends QAction<DeleteReworkCodeList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteReworkCodeList())];

    constructor() {
        super("DeleteReworkCodeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteReworkCodeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkMaterialFromContainerTypeList2 extends QAction<UnlinkMaterialFromContainerTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkMaterialFromContainerTypeList())];

    constructor() {
        super("UnlinkMaterialFromContainerTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkMaterialFromContainerTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeUsedTools2 extends QAction<CreateToBeUsedTools2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeUsedTools())];

    constructor() {
        super("CreateToBeUsedTools", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeUsedToolsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDiscardOfflineSessionList2 extends QAction<DiscardOfflineSessionList2Params> {
    private readonly params = [new QComplexParam("command", new QDiscardOfflineSessionList())];

    constructor() {
        super("DiscardOfflineSessionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDiscardOfflineSessionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkStepToOperation2 extends QAction<LinkStepToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkStepToOperation())];

    constructor() {
        super("LinkStepToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkStepToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetPJFsHookOnLinkToBeUsedMachineToPJF2 extends QAction<GetPJFsHookOnLinkToBeUsedMachineToPJF2Params> {
    private readonly params = [new QComplexParam("command", new QGetPJFsHookOnLinkToBeUsedMachineToPJF())];

    constructor() {
        super("GetPJFsHookOnLinkToBeUsedMachineToPJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetPJFsHookOnLinkToBeUsedMachineToPJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperationStepCategoryList2 extends QAction<DeleteOperationStepCategoryList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperationStepCategoryList())];

    constructor() {
        super("DeleteOperationStepCategoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationStepCategoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUseToolList2 extends QAction<UseToolList2Params> {
    private readonly params = [new QComplexParam("command", new QUseToolList())];

    constructor() {
        super("UseToolList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUseToolListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMixAMPowderBatchList2 extends QAction<MixAMPowderBatchList2Params> {
    private readonly params = [new QComplexParam("command", new QMixAMPowderBatchList())];

    constructor() {
        super("MixAMPowderBatchList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMixAMPowderBatchListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBuyOffForActiveMTUs2 extends QAction<CreateBuyOffForActiveMTUs2Params> {
    private readonly params = [new QComplexParam("command", new QCreateBuyOffForActiveMTUs())];

    constructor() {
        super("CreateBuyOffForActiveMTUs", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBuyOffForActiveMTUsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFilterInputResultsOnUndoRepeatWOOpStrategy2 extends QAction<FilterInputResultsOnUndoRepeatWOOpStrategy2Params> {
    private readonly params = [new QComplexParam("command", new QFilterInputResultsOnUndoRepeatWOOpStrategy())];

    constructor() {
        super("FilterInputResultsOnUndoRepeatWOOpStrategy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFilterInputResultsOnUndoRepeatWOOpStrategyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteNonProductiveActivityList2 extends QAction<CompleteNonProductiveActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteNonProductiveActivityList())];

    constructor() {
        super("CompleteNonProductiveActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteNonProductiveActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceV3_12 extends QAction<CreateNonConformanceV3_12Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceV3_1())];

    constructor() {
        super("CreateNonConformanceV3_1", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceV3_1Response)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationStepCategory2 extends QAction<CreateOperationStepCategory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationStepCategory())];

    constructor() {
        super("CreateOperationStepCategory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationStepCategoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CompleteMasterPlan2 extends QAction<TCM2CompleteMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CompleteMasterPlan())];

    constructor() {
        super("TCM2CompleteMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CompleteMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStepList2 extends QAction<CreateStepList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStepList())];

    constructor() {
        super("CreateStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetToBeProducedMaterialsResultOpList2 extends QAction<GetToBeProducedMaterialsResultOpList2Params> {
    private readonly params = [new QComplexParam("command", new QGetToBeProducedMaterialsResultOpList())];

    constructor() {
        super("GetToBeProducedMaterialsResultOpList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetToBeProducedMaterialsResultOpListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkOrderHumanResource2 extends QAction<LinkWorkOrderHumanResource2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkOrderHumanResource())];

    constructor() {
        super("LinkWorkOrderHumanResource", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkOrderHumanResourceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStatusBehaviorDefinition2 extends QAction<CreateStatusBehaviorDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStatusBehaviorDefinition())];

    constructor() {
        super("CreateStatusBehaviorDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStatusBehaviorDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateAMPowderBatch2 extends QAction<UpdateAMPowderBatch2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateAMPowderBatch())];

    constructor() {
        super("UpdateAMPowderBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateAMPowderBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetNonConformanceStatusIsScrapped2 extends QAction<SetNonConformanceStatusIsScrapped2Params> {
    private readonly params = [new QComplexParam("command", new QSetNonConformanceStatusIsScrapped())];

    constructor() {
        super("SetNonConformanceStatusIsScrapped", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetNonConformanceStatusIsScrappedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentConfigurationProperty2 extends QAction<UpdateEquipmentConfigurationProperty2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentConfigurationProperty())];

    constructor() {
        super("UpdateEquipmentConfigurationProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentConfigurationPropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCharacteristicFailureAssociation2 extends QAction<DeleteCharacteristicFailureAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCharacteristicFailureAssociation())];

    constructor() {
        super("DeleteCharacteristicFailureAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCharacteristicFailureAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocumentToStep2 extends QAction<UnlinkDocumentToStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocumentToStep())];

    constructor() {
        super("UnlinkDocumentToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActualUsedMachine2 extends QAction<CreateActualUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActualUsedMachine())];

    constructor() {
        super("CreateActualUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActualUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateCustomItlkCheckParameterList2 extends QAction<UpdateCustomItlkCheckParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateCustomItlkCheckParameterList())];

    constructor() {
        super("UpdateCustomItlkCheckParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateCustomItlkCheckParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceDefectList2 extends QAction<CreateNonConformanceDefectList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceDefectList())];

    constructor() {
        super("CreateNonConformanceDefectList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceDefectListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderSteps2 extends QAction<CreateWorkOrderSteps2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderSteps())];

    constructor() {
        super("CreateWorkOrderSteps", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderStepsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterial2 extends QAction<CreateMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterial())];

    constructor() {
        super("CreateMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateProcess2 extends QAction<CreateProcess2Params> {
    private readonly params = [new QComplexParam("command", new QCreateProcess())];

    constructor() {
        super("CreateProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialSpecificationToOperation2 extends QAction<LinkMaterialSpecificationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialSpecificationToOperation())];

    constructor() {
        super("LinkMaterialSpecificationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialSpecificationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveWorkOrderHold2 extends QAction<RemoveWorkOrderHold2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveWorkOrderHold())];

    constructor() {
        super("RemoveWorkOrderHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveWorkOrderHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcquireToolFromAutomationNodeInstanceParameter2 extends QAction<AcquireToolFromAutomationNodeInstanceParameter2Params> {
    private readonly params = [new QComplexParam("command", new QAcquireToolFromAutomationNodeInstanceParameter())];

    constructor() {
        super("AcquireToolFromAutomationNodeInstanceParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcquireToolFromAutomationNodeInstanceParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonConformanceStatus2 extends QAction<UpdateNonConformanceStatus2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonConformanceStatus())];

    constructor() {
        super("UpdateNonConformanceStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonConformanceStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetWorkOrderOperationIdToStartByMachine2 extends QAction<GetWorkOrderOperationIdToStartByMachine2Params> {
    private readonly params = [new QComplexParam("command", new QGetWorkOrderOperationIdToStartByMachine())];

    constructor() {
        super("GetWorkOrderOperationIdToStartByMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetWorkOrderOperationIdToStartByMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkHumanResourceToProcess2 extends QAction<LinkHumanResourceToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QLinkHumanResourceToProcess())];

    constructor() {
        super("LinkHumanResourceToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkHumanResourceToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOStepSerialized2 extends QAction<StartWOStepSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOStepSerialized())];

    constructor() {
        super("StartWOStepSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOStepSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateResultHistoryList2 extends QAction<CreateResultHistoryList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateResultHistoryList())];

    constructor() {
        super("CreateResultHistoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateResultHistoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateExecutionGroupPhase2 extends QAction<UpdateExecutionGroupPhase2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateExecutionGroupPhase())];

    constructor() {
        super("UpdateExecutionGroupPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateExecutionGroupPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeProducedMaterial2 extends QAction<CreateToBeProducedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeProducedMaterial())];

    constructor() {
        super("CreateToBeProducedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeProducedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolHistory2 extends QAction<CreateToolHistory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolHistory())];

    constructor() {
        super("CreateToolHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTransmitToolSetPointItemToAutomationNodeParameterList2 extends QAction<TransmitToolSetPointItemToAutomationNodeParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QTransmitToolSetPointItemToAutomationNodeParameterList())];

    constructor() {
        super("TransmitToolSetPointItemToAutomationNodeParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTransmitToolSetPointItemToAutomationNodeParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCharacteristicRepresentation2 extends QAction<CreateCharacteristicRepresentation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCharacteristicRepresentation())];

    constructor() {
        super("CreateCharacteristicRepresentation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCharacteristicRepresentationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBoMV4_02 extends QAction<CreateBoMV4_02Params> {
    private readonly params = [new QComplexParam("command", new QCreateBoMV4_0())];

    constructor() {
        super("CreateBoMV4_0", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBoMV4_0Response)))
    }

    getParams() {
        return this.params
    }
}

export class QGetCurrentUserRoles2 extends QAction<GetCurrentUserRoles2Params> {
    private readonly params = [new QComplexParam("command", new QGetCurrentUserRoles())];

    constructor() {
        super("GetCurrentUserRoles", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetCurrentUserRolesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWOOpDependencyNavigationList2 extends QAction<CreateWOOpDependencyNavigationList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWOOpDependencyNavigationList())];

    constructor() {
        super("CreateWOOpDependencyNavigationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWOOpDependencyNavigationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActualProducedMaterial2 extends QAction<CreateActualProducedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActualProducedMaterial())];

    constructor() {
        super("CreateActualProducedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActualProducedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCloseWorkProcess2 extends QAction<CloseWorkProcess2Params> {
    private readonly params = [new QComplexParam("command", new QCloseWorkProcess())];

    constructor() {
        super("CloseWorkProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCloseWorkProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetEquipSpecWithPJFHook2 extends QAction<GetEquipSpecWithPJFHook2Params> {
    private readonly params = [new QComplexParam("command", new QGetEquipSpecWithPJFHook())];

    constructor() {
        super("GetEquipSpecWithPJFHook", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetEquipSpecWithPJFHookResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2AssociateDocumentToMaterialDefinitionList2 extends QAction<TCM2AssociateDocumentToMaterialDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2AssociateDocumentToMaterialDefinitionList())];

    constructor() {
        super("TCM2AssociateDocumentToMaterialDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2AssociateDocumentToMaterialDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperationDependency2 extends QAction<DeleteOperationDependency2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperationDependency())];

    constructor() {
        super("DeleteOperationDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrderOperation2 extends QAction<DeleteWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrderOperation())];

    constructor() {
        super("DeleteWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditSkillToOperationList2 extends QAction<EditSkillToOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QEditSkillToOperationList())];

    constructor() {
        super("EditSkillToOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditSkillToOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkEquipmentsToBuffers2 extends QAction<LinkEquipmentsToBuffers2Params> {
    private readonly params = [new QComplexParam("command", new QLinkEquipmentsToBuffers())];

    constructor() {
        super("LinkEquipmentsToBuffers", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkEquipmentsToBuffersResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTemplate2 extends QAction<CreateTemplate2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTemplate())];

    constructor() {
        super("CreateTemplate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTemplateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolDefinitionDocumentList2 extends QAction<CreateToolDefinitionDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolDefinitionDocumentList())];

    constructor() {
        super("CreateToolDefinitionDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolDefinitionDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocumentToContainerTypeList2 extends QAction<LinkDocumentToContainerTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocumentToContainerTypeList())];

    constructor() {
        super("LinkDocumentToContainerTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentToContainerTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDM_MaterialTrackingUnitHistoryAction2 extends QAction<DeleteDM_MaterialTrackingUnitHistoryAction2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDM_MaterialTrackingUnitHistoryAction())];

    constructor() {
        super("DeleteDM_MaterialTrackingUnitHistoryAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDM_MaterialTrackingUnitHistoryActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSentenceNonConformancePartially2 extends QAction<SentenceNonConformancePartially2Params> {
    private readonly params = [new QComplexParam("command", new QSentenceNonConformancePartially())];

    constructor() {
        super("SentenceNonConformancePartially", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSentenceNonConformancePartiallyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteFunctionalCodeListV4_02 extends QAction<DeleteFunctionalCodeListV4_02Params> {
    private readonly params = [new QComplexParam("command", new QDeleteFunctionalCodeListV4_0())];

    constructor() {
        super("DeleteFunctionalCodeListV4_0", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteFunctionalCodeListV4_0Response)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInCompleteWOStepTransferBatch2 extends QAction<CheckInCompleteWOStepTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInCompleteWOStepTransferBatch())];

    constructor() {
        super("CheckInCompleteWOStepTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInCompleteWOStepTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewMaterialDefinitionRevision2 extends QAction<CreateNewMaterialDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewMaterialDefinitionRevision())];

    constructor() {
        super("CreateNewMaterialDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewMaterialDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonConformanceStatusBehavior2 extends QAction<UpdateNonConformanceStatusBehavior2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonConformanceStatusBehavior())];

    constructor() {
        super("UpdateNonConformanceStatusBehavior", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonConformanceStatusBehaviorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSkillsToWorkOrderStep2 extends QAction<UnlinkSkillsToWorkOrderStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSkillsToWorkOrderStep())];

    constructor() {
        super("UnlinkSkillsToWorkOrderStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSkillsToWorkOrderStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkBufferDefinitionToLogisticClassList2 extends QAction<LinkBufferDefinitionToLogisticClassList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkBufferDefinitionToLogisticClassList())];

    constructor() {
        super("LinkBufferDefinitionToLogisticClassList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkBufferDefinitionToLogisticClassListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAbortWorkOrder2 extends QAction<AbortWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QAbortWorkOrder())];

    constructor() {
        super("AbortWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAbortWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceLifecycleList2 extends QAction<DeleteNonConformanceLifecycleList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceLifecycleList())];

    constructor() {
        super("DeleteNonConformanceLifecycleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceLifecycleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTemplateBlocks2 extends QAction<DeleteTemplateBlocks2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTemplateBlocks())];

    constructor() {
        super("DeleteTemplateBlocks", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTemplateBlocksResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetProcessWithoutOperationsList2 extends QAction<GetProcessWithoutOperationsList2Params> {
    private readonly params = [new QComplexParam("command", new QGetProcessWithoutOperationsList())];

    constructor() {
        super("GetProcessWithoutOperationsList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetProcessWithoutOperationsListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolHistory2 extends QAction<DeleteToolHistory2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolHistory())];

    constructor() {
        super("DeleteToolHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateHandlingUnit2 extends QAction<CreateHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QCreateHandlingUnit())];

    constructor() {
        super("CreateHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActualConsumedMaterial2 extends QAction<CreateActualConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActualConsumedMaterial())];

    constructor() {
        super("CreateActualConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActualConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateEquipmentSpecificationList2 extends QAction<TCM2CreateEquipmentSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateEquipmentSpecificationList())];

    constructor() {
        super("TCM2CreateEquipmentSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateEquipmentSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewProcessRevisionInCatalogue2 extends QAction<CreateNewProcessRevisionInCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewProcessRevisionInCatalogue())];

    constructor() {
        super("CreateNewProcessRevisionInCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewProcessRevisionInCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList2 extends QAction<UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList())];

    constructor() {
        super("UnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkAutomationNodeInstanceParameterFromToolDefinitionParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveEquipmentPreferencesForUser2 extends QAction<RemoveEquipmentPreferencesForUser2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveEquipmentPreferencesForUser())];

    constructor() {
        super("RemoveEquipmentPreferencesForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveEquipmentPreferencesForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentSpecificationList2 extends QAction<DeleteEquipmentSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentSpecificationList())];

    constructor() {
        super("DeleteEquipmentSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartContainer2 extends QAction<StartContainer2Params> {
    private readonly params = [new QComplexParam("command", new QStartContainer())];

    constructor() {
        super("StartContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationDependencyList2 extends QAction<CreateOperationDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationDependencyList())];

    constructor() {
        super("CreateOperationDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkEquipmentSpecificationToOperation2 extends QAction<LinkEquipmentSpecificationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkEquipmentSpecificationToOperation())];

    constructor() {
        super("LinkEquipmentSpecificationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkEquipmentSpecificationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUploadDocuments2 extends QAction<UploadDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QUploadDocuments())];

    constructor() {
        super("UploadDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUploadDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditWorkOrder2 extends QAction<EditWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QEditWorkOrder())];

    constructor() {
        super("EditWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteTransportOperation2 extends QAction<CompleteTransportOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteTransportOperation())];

    constructor() {
        super("CompleteTransportOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteTransportOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRegisterNonProductiveActivityForUser2 extends QAction<RegisterNonProductiveActivityForUser2Params> {
    private readonly params = [new QComplexParam("command", new QRegisterNonProductiveActivityForUser())];

    constructor() {
        super("RegisterNonProductiveActivityForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRegisterNonProductiveActivityForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetUserDetailsList2 extends QAction<GetUserDetailsList2Params> {
    private readonly params = [new QComplexParam("command", new QGetUserDetailsList())];

    constructor() {
        super("GetUserDetailsList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetUserDetailsListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateActualProducedMaterial2 extends QAction<UpdateActualProducedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateActualProducedMaterial())];

    constructor() {
        super("UpdateActualProducedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateActualProducedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceTransitionList2 extends QAction<DeleteNonConformanceTransitionList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceTransitionList())];

    constructor() {
        super("DeleteNonConformanceTransitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceTransitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypePropertyAttribute2 extends QAction<DeleteEquipmentTypePropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypePropertyAttribute())];

    constructor() {
        super("DeleteEquipmentTypePropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypePropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStatusTransition2 extends QAction<UpdateStatusTransition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStatusTransition())];

    constructor() {
        super("UpdateStatusTransition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStatusTransitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateReworkOrder2 extends QAction<CreateReworkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QCreateReworkOrder())];

    constructor() {
        super("CreateReworkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateReworkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEvolveAsPlannedBOP2 extends QAction<EvolveAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QEvolveAsPlannedBOP())];

    constructor() {
        super("EvolveAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEvolveAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetActiveUserListOnWorkOrderOperation2 extends QAction<GetActiveUserListOnWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QGetActiveUserListOnWorkOrderOperation())];

    constructor() {
        super("GetActiveUserListOnWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetActiveUserListOnWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceHistory2 extends QAction<CreateNonConformanceHistory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceHistory())];

    constructor() {
        super("CreateNonConformanceHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticComplete2 extends QAction<UADMAutomaticComplete2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticComplete())];

    constructor() {
        super("UADMAutomaticComplete", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticCompleteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStepList2 extends QAction<DeleteStepList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStepList())];

    constructor() {
        super("DeleteStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateFunctionalCode2 extends QAction<CreateFunctionalCode2Params> {
    private readonly params = [new QComplexParam("command", new QCreateFunctionalCode())];

    constructor() {
        super("CreateFunctionalCode", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateFunctionalCodeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateAMPowderBatchGenealogy2 extends QAction<UpdateAMPowderBatchGenealogy2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateAMPowderBatchGenealogy())];

    constructor() {
        super("UpdateAMPowderBatchGenealogy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateAMPowderBatchGenealogyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDefect2 extends QAction<DeleteDefect2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDefect())];

    constructor() {
        super("DeleteDefect", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDefectResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QInEditingWorkInstruction2 extends QAction<InEditingWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QInEditingWorkInstruction())];

    constructor() {
        super("InEditingWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QInEditingWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToBeUsedMachineToPartProgram2 extends QAction<LinkToBeUsedMachineToPartProgram2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToBeUsedMachineToPartProgram())];

    constructor() {
        super("LinkToBeUsedMachineToPartProgram", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToBeUsedMachineToPartProgramResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActiveUserOnMachine2 extends QAction<CreateActiveUserOnMachine2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActiveUserOnMachine())];

    constructor() {
        super("CreateActiveUserOnMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActiveUserOnMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentSpecification2 extends QAction<UpdateEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentSpecification())];

    constructor() {
        super("UpdateEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkHumanResourceFromProcess2 extends QAction<UnlinkHumanResourceFromProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkHumanResourceFromProcess())];

    constructor() {
        super("UnlinkHumanResourceFromProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkHumanResourceFromProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPauseContainer2 extends QAction<PauseContainer2Params> {
    private readonly params = [new QComplexParam("command", new QPauseContainer())];

    constructor() {
        super("PauseContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPauseContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkOperationToProcess2 extends QAction<UnlinkOperationToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkOperationToProcess())];

    constructor() {
        super("UnlinkOperationToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkOperationToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolDefinitionDocument2 extends QAction<CreateToolDefinitionDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolDefinitionDocument())];

    constructor() {
        super("CreateToolDefinitionDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolDefinitionDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteSupplierList2 extends QAction<DeleteSupplierList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteSupplierList())];

    constructor() {
        super("DeleteSupplierList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteSupplierListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDefect2 extends QAction<CreateDefect2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDefect())];

    constructor() {
        super("CreateDefect", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDefectResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphNodeConfiguration2 extends QAction<CreateEquipmentGraphNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphNodeConfiguration())];

    constructor() {
        super("CreateEquipmentGraphNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetDefectGroupPath2 extends QAction<SetDefectGroupPath2Params> {
    private readonly params = [new QComplexParam("command", new QSetDefectGroupPath())];

    constructor() {
        super("SetDefectGroupPath", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetDefectGroupPathResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToolToAutomationNodeInstanceList2 extends QAction<LinkToolToAutomationNodeInstanceList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToolToAutomationNodeInstanceList())];

    constructor() {
        super("LinkToolToAutomationNodeInstanceList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToolToAutomationNodeInstanceListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetNonConformanceTransitionRoleMailList2 extends QAction<GetNonConformanceTransitionRoleMailList2Params> {
    private readonly params = [new QComplexParam("command", new QGetNonConformanceTransitionRoleMailList())];

    constructor() {
        super("GetNonConformanceTransitionRoleMailList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetNonConformanceTransitionRoleMailListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QValidateMaterialConsumptionIsComplete2 extends QAction<ValidateMaterialConsumptionIsComplete2Params> {
    private readonly params = [new QComplexParam("command", new QValidateMaterialConsumptionIsComplete())];

    constructor() {
        super("ValidateMaterialConsumptionIsComplete", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QValidateMaterialConsumptionIsCompleteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDNCItem2 extends QAction<UpdateDNCItem2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDNCItem())];

    constructor() {
        super("UpdateDNCItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDNCItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTool2 extends QAction<CreateTool2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTool())];

    constructor() {
        super("CreateTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkEquipmentToSetPoint2 extends QAction<UnlinkEquipmentToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkEquipmentToSetPoint())];

    constructor() {
        super("UnlinkEquipmentToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkEquipmentToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBoM2 extends QAction<CreateBoM2Params> {
    private readonly params = [new QComplexParam("command", new QCreateBoM())];

    constructor() {
        super("CreateBoM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBoMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphLinkConfiguration2 extends QAction<UpdateEquipmentGraphLinkConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphLinkConfiguration())];

    constructor() {
        super("UpdateEquipmentGraphLinkConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphLinkConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderHistory2 extends QAction<CreateWorkOrderHistory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderHistory())];

    constructor() {
        super("CreateWorkOrderHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphType2 extends QAction<UpdateEquipmentGraphType2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphType())];

    constructor() {
        super("UpdateEquipmentGraphType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeBoMStatus2 extends QAction<ChangeBoMStatus2Params> {
    private readonly params = [new QComplexParam("command", new QChangeBoMStatus())];

    constructor() {
        super("ChangeBoMStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeBoMStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QExecuteItlkCheckInbound2 extends QAction<ExecuteItlkCheckInbound2Params> {
    private readonly params = [new QComplexParam("command", new QExecuteItlkCheckInbound())];

    constructor() {
        super("ExecuteItlkCheckInbound", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QExecuteItlkCheckInboundResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConsumeMaterialItemOnExecutionGroup2 extends QAction<ConsumeMaterialItemOnExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QConsumeMaterialItemOnExecutionGroup())];

    constructor() {
        super("ConsumeMaterialItemOnExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConsumeMaterialItemOnExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperationList2 extends QAction<DeleteOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperationList())];

    constructor() {
        super("DeleteOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyWorkInstructionDefinitionRevision2 extends QAction<CopyWorkInstructionDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCopyWorkInstructionDefinitionRevision())];

    constructor() {
        super("CopyWorkInstructionDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyWorkInstructionDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveWorkOrderOperationFutureHold2 extends QAction<RemoveWorkOrderOperationFutureHold2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveWorkOrderOperationFutureHold())];

    constructor() {
        super("RemoveWorkOrderOperationFutureHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveWorkOrderOperationFutureHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkEquipmentToSetPoint2 extends QAction<LinkEquipmentToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QLinkEquipmentToSetPoint())];

    constructor() {
        super("LinkEquipmentToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkEquipmentToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateHierarchyEquipmentNodeConfiguration2 extends QAction<UpdateHierarchyEquipmentNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateHierarchyEquipmentNodeConfiguration())];

    constructor() {
        super("UpdateHierarchyEquipmentNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateHierarchyEquipmentNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStatus2 extends QAction<CreateStatus2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStatus())];

    constructor() {
        super("CreateStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSubstrateDefinitionToMachine2 extends QAction<LinkSubstrateDefinitionToMachine2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSubstrateDefinitionToMachine())];

    constructor() {
        super("LinkSubstrateDefinitionToMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSubstrateDefinitionToMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCustomItlkCheckList2 extends QAction<DeleteCustomItlkCheckList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCustomItlkCheckList())];

    constructor() {
        super("DeleteCustomItlkCheckList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCustomItlkCheckListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditHumanResourceToProcess2 extends QAction<EditHumanResourceToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QEditHumanResourceToProcess())];

    constructor() {
        super("EditHumanResourceToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditHumanResourceToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFilterWorkOrderOperationListByCheckCertification2 extends QAction<FilterWorkOrderOperationListByCheckCertification2Params> {
    private readonly params = [new QComplexParam("command", new QFilterWorkOrderOperationListByCheckCertification())];

    constructor() {
        super("FilterWorkOrderOperationListByCheckCertification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFilterWorkOrderOperationListByCheckCertificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewStepRevision2 extends QAction<CreateNewStepRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewStepRevision())];

    constructor() {
        super("CreateNewStepRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewStepRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypeProperty2 extends QAction<DeleteEquipmentTypeProperty2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypeProperty())];

    constructor() {
        super("DeleteEquipmentTypeProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypePropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkMaterialSpecificationToOperation2 extends QAction<UnlinkMaterialSpecificationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkMaterialSpecificationToOperation())];

    constructor() {
        super("UnlinkMaterialSpecificationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkMaterialSpecificationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderOperationFromProcessOperation2 extends QAction<CreateWorkOrderOperationFromProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderOperationFromProcessOperation())];

    constructor() {
        super("CreateWorkOrderOperationFromProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderOperationFromProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateCustomItlkCheckList2 extends QAction<UpdateCustomItlkCheckList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateCustomItlkCheckList())];

    constructor() {
        super("UpdateCustomItlkCheckList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateCustomItlkCheckListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolHistoryAction2 extends QAction<CreateToolHistoryAction2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolHistoryAction())];

    constructor() {
        super("CreateToolHistoryAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolHistoryActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateVariableCharacteristicSpecification2 extends QAction<UpdateVariableCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateVariableCharacteristicSpecification())];

    constructor() {
        super("UpdateVariableCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateVariableCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkOrderStep2 extends QAction<UpdateWorkOrderStep2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkOrderStep())];

    constructor() {
        super("UpdateWorkOrderStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkOrderStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGroupConfiguration2 extends QAction<CreateEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGroupConfiguration())];

    constructor() {
        super("CreateEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocumentListToOperation2 extends QAction<UnlinkDocumentListToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocumentListToOperation())];

    constructor() {
        super("UnlinkDocumentListToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentListToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkEquipmentSpecificationToOperation2 extends QAction<UnlinkEquipmentSpecificationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkEquipmentSpecificationToOperation())];

    constructor() {
        super("UnlinkEquipmentSpecificationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkEquipmentSpecificationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolDefinitions2 extends QAction<DeleteToolDefinitions2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolDefinitions())];

    constructor() {
        super("DeleteToolDefinitions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolDefinitionsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDM_MaterialTrackingUnit2 extends QAction<CreateDM_MaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDM_MaterialTrackingUnit())];

    constructor() {
        super("CreateDM_MaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDM_MaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkInstructionDefinitionRevisionCurrent2 extends QAction<SetWorkInstructionDefinitionRevisionCurrent2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkInstructionDefinitionRevisionCurrent())];

    constructor() {
        super("SetWorkInstructionDefinitionRevisionCurrent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkInstructionDefinitionRevisionCurrentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateExecutionGroup2 extends QAction<CreateExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QCreateExecutionGroup())];

    constructor() {
        super("CreateExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMergeWOHeaderWithProcess2 extends QAction<MergeWOHeaderWithProcess2Params> {
    private readonly params = [new QComplexParam("command", new QMergeWOHeaderWithProcess())];

    constructor() {
        super("MergeWOHeaderWithProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMergeWOHeaderWithProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInStartWOOperationSerialized2 extends QAction<CheckInStartWOOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInStartWOOperationSerialized())];

    constructor() {
        super("CheckInStartWOOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInStartWOOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteProcessFromCatalogue2 extends QAction<DeleteProcessFromCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteProcessFromCatalogue())];

    constructor() {
        super("DeleteProcessFromCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteProcessFromCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QBeginIdTemplateEditing2 extends QAction<BeginIdTemplateEditing2Params> {
    private readonly params = [new QComplexParam("command", new QBeginIdTemplateEditing())];

    constructor() {
        super("BeginIdTemplateEditing", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QBeginIdTemplateEditingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphConfiguration2 extends QAction<UpdateEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphConfiguration())];

    constructor() {
        super("UpdateEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDNCItem2 extends QAction<CreateDNCItem2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDNCItem())];

    constructor() {
        super("CreateDNCItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDNCItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInUseToolList2 extends QAction<CheckInUseToolList2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInUseToolList())];

    constructor() {
        super("CheckInUseToolList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInUseToolListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkInstructionTemplateParameter2 extends QAction<DeleteWorkInstructionTemplateParameter2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkInstructionTemplateParameter())];

    constructor() {
        super("DeleteWorkInstructionTemplateParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkInstructionTemplateParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetWorkOrderOperationNIdToCompleteByMachine2 extends QAction<GetWorkOrderOperationNIdToCompleteByMachine2Params> {
    private readonly params = [new QComplexParam("command", new QGetWorkOrderOperationNIdToCompleteByMachine())];

    constructor() {
        super("GetWorkOrderOperationNIdToCompleteByMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetWorkOrderOperationNIdToCompleteByMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateAsPlannedBOP2 extends QAction<TCM2CreateAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateAsPlannedBOP())];

    constructor() {
        super("TCM2CreateAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QVerifyWorkOrder2 extends QAction<VerifyWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QVerifyWorkOrder())];

    constructor() {
        super("VerifyWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QVerifyWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReopenWorkOrderOperationSerialized2 extends QAction<ReopenWorkOrderOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QReopenWorkOrderOperationSerialized())];

    constructor() {
        super("ReopenWorkOrderOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReopenWorkOrderOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetProductionProcessFromAsPlanned2 extends QAction<GetProductionProcessFromAsPlanned2Params> {
    private readonly params = [new QComplexParam("command", new QGetProductionProcessFromAsPlanned())];

    constructor() {
        super("GetProductionProcessFromAsPlanned", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetProductionProcessFromAsPlannedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceHistory2 extends QAction<DeleteNonConformanceHistory2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceHistory())];

    constructor() {
        super("DeleteNonConformanceHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeAddOperation2 extends QAction<AcceptChangeAddOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeAddOperation())];

    constructor() {
        super("AcceptChangeAddOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeAddOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDocumentList2 extends QAction<DeleteDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDocumentList())];

    constructor() {
        super("DeleteDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteContainer2 extends QAction<CompleteContainer2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteContainer())];

    constructor() {
        super("CompleteContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPauseWOOperation2 extends QAction<PauseWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QPauseWOOperation())];

    constructor() {
        super("PauseWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPauseWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteAsPlannedBOPList2 extends QAction<DeleteAsPlannedBOPList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteAsPlannedBOPList())];

    constructor() {
        super("DeleteAsPlannedBOPList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteAsPlannedBOPListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateHold2 extends QAction<CreateHold2Params> {
    private readonly params = [new QComplexParam("command", new QCreateHold())];

    constructor() {
        super("CreateHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToBeUsedMachineToPJF2 extends QAction<LinkToBeUsedMachineToPJF2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToBeUsedMachineToPJF())];

    constructor() {
        super("LinkToBeUsedMachineToPJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToBeUsedMachineToPJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetResultStrategy2 extends QAction<GetResultStrategy2Params> {
    private readonly params = [new QComplexParam("command", new QGetResultStrategy())];

    constructor() {
        super("GetResultStrategy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetResultStrategyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMachineDefinitionToSetPoint2 extends QAction<LinkMachineDefinitionToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMachineDefinitionToSetPoint())];

    constructor() {
        super("LinkMachineDefinitionToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMachineDefinitionToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTeam2 extends QAction<UpdateTeam2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTeam())];

    constructor() {
        super("UpdateTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewWorkInstructionDefinitionRevision2 extends QAction<CreateNewWorkInstructionDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewWorkInstructionDefinitionRevision())];

    constructor() {
        super("CreateNewWorkInstructionDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewWorkInstructionDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTemplate2 extends QAction<DeleteTemplate2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTemplate())];

    constructor() {
        super("DeleteTemplate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTemplateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetResultValueOnEmpty2 extends QAction<GetResultValueOnEmpty2Params> {
    private readonly params = [new QComplexParam("command", new QGetResultValueOnEmpty())];

    constructor() {
        super("GetResultValueOnEmpty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetResultValueOnEmptyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCMCreateUoMList2 extends QAction<TCMCreateUoMList2Params> {
    private readonly params = [new QComplexParam("command", new QTCMCreateUoMList())];

    constructor() {
        super("TCMCreateUoMList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCMCreateUoMListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceLifecycle2 extends QAction<CreateNonConformanceLifecycle2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceLifecycle())];

    constructor() {
        super("CreateNonConformanceLifecycle", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceLifecycleResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetIsOutOfDateAsPlannedBOP2 extends QAction<SetIsOutOfDateAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QSetIsOutOfDateAsPlannedBOP())];

    constructor() {
        super("SetIsOutOfDateAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetIsOutOfDateAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActualUsedTool2 extends QAction<CreateActualUsedTool2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActualUsedTool())];

    constructor() {
        super("CreateActualUsedTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActualUsedToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckWorkOrderStatusIsInEditing2 extends QAction<CheckWorkOrderStatusIsInEditing2Params> {
    private readonly params = [new QComplexParam("command", new QCheckWorkOrderStatusIsInEditing())];

    constructor() {
        super("CheckWorkOrderStatusIsInEditing", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckWorkOrderStatusIsInEditingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateItlkCheckHistoryList2 extends QAction<CreateItlkCheckHistoryList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateItlkCheckHistoryList())];

    constructor() {
        super("CreateItlkCheckHistoryList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateItlkCheckHistoryListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDM_MaterialTrackingUnit2 extends QAction<UpdateDM_MaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDM_MaterialTrackingUnit())];

    constructor() {
        super("UpdateDM_MaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDM_MaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWaitingForInspection2 extends QAction<SetWaitingForInspection2Params> {
    private readonly params = [new QComplexParam("command", new QSetWaitingForInspection())];

    constructor() {
        super("SetWaitingForInspection", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWaitingForInspectionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonProductiveActivityList2 extends QAction<DeleteNonProductiveActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonProductiveActivityList())];

    constructor() {
        super("DeleteNonProductiveActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonProductiveActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkAutomationNodeInstanceParameterToDCItemList2 extends QAction<LinkAutomationNodeInstanceParameterToDCItemList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkAutomationNodeInstanceParameterToDCItemList())];

    constructor() {
        super("LinkAutomationNodeInstanceParameterToDCItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkAutomationNodeInstanceParameterToDCItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkPartProgramToEquipmentSpecification2 extends QAction<LinkPartProgramToEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QLinkPartProgramToEquipmentSpecification())];

    constructor() {
        super("LinkPartProgramToEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkPartProgramToEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateActualUsedMachinePJF2 extends QAction<UpdateActualUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateActualUsedMachinePJF())];

    constructor() {
        super("UpdateActualUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateActualUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCopyNonConformanceFromParentWorkOrder2 extends QAction<CopyNonConformanceFromParentWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QCopyNonConformanceFromParentWorkOrder())];

    constructor() {
        super("CopyNonConformanceFromParentWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCopyNonConformanceFromParentWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeUsedInspection2 extends QAction<CreateToBeUsedInspection2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeUsedInspection())];

    constructor() {
        super("CreateToBeUsedInspection", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeUsedInspectionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrderHistoryAction2 extends QAction<DeleteWorkOrderHistoryAction2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrderHistoryAction())];

    constructor() {
        super("DeleteWorkOrderHistoryAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderHistoryActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkWOOperationsFromExecutionGroup2 extends QAction<UnlinkWOOperationsFromExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkWOOperationsFromExecutionGroup())];

    constructor() {
        super("UnlinkWOOperationsFromExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkWOOperationsFromExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeBufferStatus2 extends QAction<ChangeBufferStatus2Params> {
    private readonly params = [new QComplexParam("command", new QChangeBufferStatus())];

    constructor() {
        super("ChangeBufferStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeBufferStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReleaseExecutionGroup2 extends QAction<ReleaseExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QReleaseExecutionGroup())];

    constructor() {
        super("ReleaseExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReleaseExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkInstructionDefinitionParameter2 extends QAction<DeleteWorkInstructionDefinitionParameter2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkInstructionDefinitionParameter())];

    constructor() {
        super("DeleteWorkInstructionDefinitionParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkInstructionDefinitionParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeChangeToBeUsedMachine2 extends QAction<AcceptChangeChangeToBeUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeChangeToBeUsedMachine())];

    constructor() {
        super("AcceptChangeChangeToBeUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeChangeToBeUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeHandlingUnitStatus2 extends QAction<ChangeHandlingUnitStatus2Params> {
    private readonly params = [new QComplexParam("command", new QChangeHandlingUnitStatus())];

    constructor() {
        super("ChangeHandlingUnitStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeHandlingUnitStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToolToSetPoint2 extends QAction<LinkToolToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToolToSetPoint())];

    constructor() {
        super("LinkToolToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToolToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCertificationList2 extends QAction<DeleteCertificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCertificationList())];

    constructor() {
        super("DeleteCertificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCertificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetPreferredMachine2 extends QAction<SetPreferredMachine2Params> {
    private readonly params = [new QComplexParam("command", new QSetPreferredMachine())];

    constructor() {
        super("SetPreferredMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetPreferredMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToolDefinitionToSetPoint2 extends QAction<LinkToolDefinitionToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToolDefinitionToSetPoint())];

    constructor() {
        super("LinkToolDefinitionToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToolDefinitionToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeUsedMachinePJF2 extends QAction<DeleteToBeUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeUsedMachinePJF())];

    constructor() {
        super("DeleteToBeUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToolDefinitionDocument2 extends QAction<DeleteToolDefinitionDocument2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToolDefinitionDocument())];

    constructor() {
        super("DeleteToolDefinitionDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolDefinitionDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutomaticCollectWorkInstruction2 extends QAction<AutomaticCollectWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QAutomaticCollectWorkInstruction())];

    constructor() {
        super("AutomaticCollectWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutomaticCollectWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreatePrintJobFile2 extends QAction<CreatePrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QCreatePrintJobFile())];

    constructor() {
        super("CreatePrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreatePrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeReplaceToBeConsumedMaterial2 extends QAction<AcceptChangeReplaceToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeReplaceToBeConsumedMaterial())];

    constructor() {
        super("AcceptChangeReplaceToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeReplaceToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUploadPLMX2 extends QAction<UploadPLMX2Params> {
    private readonly params = [new QComplexParam("command", new QUploadPLMX())];

    constructor() {
        super("UploadPLMX", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUploadPLMXResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkSkillsFromTeam2 extends QAction<UnLinkSkillsFromTeam2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkSkillsFromTeam())];

    constructor() {
        super("UnLinkSkillsFromTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkSkillsFromTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOStepFullQty2 extends QAction<CompleteWOStepFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOStepFullQty())];

    constructor() {
        super("CompleteWOStepFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOStepFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStep2 extends QAction<UpdateStep2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStep())];

    constructor() {
        super("UpdateStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkPrintJobFileFromEquipmentType2 extends QAction<UnlinkPrintJobFileFromEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkPrintJobFileFromEquipmentType())];

    constructor() {
        super("UnlinkPrintJobFileFromEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkPrintJobFileFromEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetTargetQuantityOnFlexibleWorkOrder2 extends QAction<SetTargetQuantityOnFlexibleWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QSetTargetQuantityOnFlexibleWorkOrder())];

    constructor() {
        super("SetTargetQuantityOnFlexibleWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetTargetQuantityOnFlexibleWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperation2 extends QAction<CreateOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperation())];

    constructor() {
        super("CreateOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkPJFToEquipmentSpecification2 extends QAction<LinkPJFToEquipmentSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QLinkPJFToEquipmentSpecification())];

    constructor() {
        super("LinkPJFToEquipmentSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkPJFToEquipmentSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateAndAssignProducedMaterialItems2 extends QAction<CreateAndAssignProducedMaterialItems2Params> {
    private readonly params = [new QComplexParam("command", new QCreateAndAssignProducedMaterialItems())];

    constructor() {
        super("CreateAndAssignProducedMaterialItems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateAndAssignProducedMaterialItemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolCompatibleMachine2 extends QAction<CreateToolCompatibleMachine2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolCompatibleMachine())];

    constructor() {
        super("CreateToolCompatibleMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolCompatibleMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList2 extends QAction<LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList())];

    constructor() {
        super("LinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToBeUsedInspectionToRuntimeCharReprRefOperationAssociationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateDNCItemMachineMaterialsAssociation2 extends QAction<AssociateDNCItemMachineMaterialsAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateDNCItemMachineMaterialsAssociation())];

    constructor() {
        super("AssociateDNCItemMachineMaterialsAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateDNCItemMachineMaterialsAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkInstructionTemplate2 extends QAction<DeleteWorkInstructionTemplate2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkInstructionTemplate())];

    constructor() {
        super("DeleteWorkInstructionTemplate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkInstructionTemplateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QActivateMaterialTrackingUnitOnScrewingTool2 extends QAction<ActivateMaterialTrackingUnitOnScrewingTool2Params> {
    private readonly params = [new QComplexParam("command", new QActivateMaterialTrackingUnitOnScrewingTool())];

    constructor() {
        super("ActivateMaterialTrackingUnitOnScrewingTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QActivateMaterialTrackingUnitOnScrewingToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkInstructionDefinitionListToStep2 extends QAction<LinkWorkInstructionDefinitionListToStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkInstructionDefinitionListToStep())];

    constructor() {
        super("LinkWorkInstructionDefinitionListToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkInstructionDefinitionListToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTransportOperation2 extends QAction<UpdateTransportOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTransportOperation())];

    constructor() {
        super("UpdateTransportOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateTransportOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWOOperationDependency2 extends QAction<DeleteWOOperationDependency2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWOOperationDependency())];

    constructor() {
        super("DeleteWOOperationDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWOOperationDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLoadHandlingUnit2 extends QAction<UnLoadHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUnLoadHandlingUnit())];

    constructor() {
        super("UnLoadHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLoadHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2AssociateDocumentToStepList2 extends QAction<TCM2AssociateDocumentToStepList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2AssociateDocumentToStepList())];

    constructor() {
        super("TCM2AssociateDocumentToStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2AssociateDocumentToStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassembleMaterialItem2 extends QAction<DisassembleMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QDisassembleMaterialItem())];

    constructor() {
        super("DisassembleMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassembleMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEnableLocationMachineForCompleteByDifferentUser2 extends QAction<EnableLocationMachineForCompleteByDifferentUser2Params> {
    private readonly params = [new QComplexParam("command", new QEnableLocationMachineForCompleteByDifferentUser())];

    constructor() {
        super("EnableLocationMachineForCompleteByDifferentUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEnableLocationMachineForCompleteByDifferentUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnsetWorkInstructionDefinitionRevisionCurrent2 extends QAction<UnsetWorkInstructionDefinitionRevisionCurrent2Params> {
    private readonly params = [new QComplexParam("command", new QUnsetWorkInstructionDefinitionRevisionCurrent())];

    constructor() {
        super("UnsetWorkInstructionDefinitionRevisionCurrent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnsetWorkInstructionDefinitionRevisionCurrentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateActualUsedMachine2 extends QAction<UpdateActualUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateActualUsedMachine())];

    constructor() {
        super("UpdateActualUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateActualUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentConfigurationPropertyAttribute2 extends QAction<UpdateEquipmentConfigurationPropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentConfigurationPropertyAttribute())];

    constructor() {
        super("UpdateEquipmentConfigurationPropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentConfigurationPropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDefectGroupList2 extends QAction<DeleteDefectGroupList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDefectGroupList())];

    constructor() {
        super("DeleteDefectGroupList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDefectGroupListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAbortExecutionGroupList2 extends QAction<AbortExecutionGroupList2Params> {
    private readonly params = [new QComplexParam("command", new QAbortExecutionGroupList())];

    constructor() {
        super("AbortExecutionGroupList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAbortExecutionGroupListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTemplateToMaterialPlant2 extends QAction<CreateTemplateToMaterialPlant2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTemplateToMaterialPlant())];

    constructor() {
        super("CreateTemplateToMaterialPlant", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTemplateToMaterialPlantResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteSetPointList2 extends QAction<DeleteSetPointList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteSetPointList())];

    constructor() {
        super("DeleteSetPointList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteSetPointListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateSkipReason2 extends QAction<CreateSkipReason2Params> {
    private readonly params = [new QComplexParam("command", new QCreateSkipReason())];

    constructor() {
        super("CreateSkipReason", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateSkipReasonResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkInstruction2 extends QAction<CreateWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkInstruction())];

    constructor() {
        super("CreateWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkInstructionsToWOStep2 extends QAction<LinkWorkInstructionsToWOStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkInstructionsToWOStep())];

    constructor() {
        super("LinkWorkInstructionsToWOStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkInstructionsToWOStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialSpecificationList2 extends QAction<DeleteMaterialSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialSpecificationList())];

    constructor() {
        super("DeleteMaterialSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeProducedMaterial2 extends QAction<DeleteToBeProducedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeProducedMaterial())];

    constructor() {
        super("DeleteToBeProducedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeProducedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateReworkCodeList2 extends QAction<CreateReworkCodeList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateReworkCodeList())];

    constructor() {
        super("CreateReworkCodeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateReworkCodeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkProcessToProcess2 extends QAction<LinkProcessToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QLinkProcessToProcess())];

    constructor() {
        super("LinkProcessToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkProcessToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentConfiguration2 extends QAction<CreateEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentConfiguration())];

    constructor() {
        super("CreateEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetCheckedOutOnWorkOrderOperationList2 extends QAction<SetCheckedOutOnWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QSetCheckedOutOnWorkOrderOperationList())];

    constructor() {
        super("SetCheckedOutOnWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetCheckedOutOnWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateExecutionGroup2 extends QAction<UpdateExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateExecutionGroup())];

    constructor() {
        super("UpdateExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkInstructionTemplateParameter2 extends QAction<UpdateWorkInstructionTemplateParameter2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkInstructionTemplateParameter())];

    constructor() {
        super("UpdateWorkInstructionTemplateParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkInstructionTemplateParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveCertificationToMaterialList2 extends QAction<RemoveCertificationToMaterialList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveCertificationToMaterialList())];

    constructor() {
        super("RemoveCertificationToMaterialList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveCertificationToMaterialListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMasterPlan2 extends QAction<DeleteMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMasterPlan())];

    constructor() {
        super("DeleteMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCriticality2 extends QAction<CreateCriticality2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCriticality())];

    constructor() {
        super("CreateCriticality", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCriticalityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialTrackingUnit2 extends QAction<DeleteMaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialTrackingUnit())];

    constructor() {
        super("DeleteMaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkUsersFromTeam2 extends QAction<UnLinkUsersFromTeam2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkUsersFromTeam())];

    constructor() {
        super("UnLinkUsersFromTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkUsersFromTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateOfflineAction2 extends QAction<UpdateOfflineAction2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateOfflineAction())];

    constructor() {
        super("UpdateOfflineAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateOfflineActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeAddWorkInstruction2 extends QAction<AcceptChangeAddWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeAddWorkInstruction())];

    constructor() {
        super("AcceptChangeAddWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeAddWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeUsedDocuments2 extends QAction<CreateToBeUsedDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeUsedDocuments())];

    constructor() {
        super("CreateToBeUsedDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeUsedDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInCompleteWOOperationSerialized2 extends QAction<CheckInCompleteWOOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInCompleteWOOperationSerialized())];

    constructor() {
        super("CheckInCompleteWOOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInCompleteWOOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWOStepDependency2 extends QAction<CreateWOStepDependency2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWOStepDependency())];

    constructor() {
        super("CreateWOStepDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWOStepDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReleaseWorkOrder2 extends QAction<ReleaseWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QReleaseWorkOrder())];

    constructor() {
        super("ReleaseWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReleaseWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteBoMItemList2 extends QAction<DeleteBoMItemList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteBoMItemList())];

    constructor() {
        super("DeleteBoMItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteBoMItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOOperationsSerializedLiteSingleWO2 extends QAction<StartWOOperationsSerializedLiteSingleWO2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOOperationsSerializedLiteSingleWO())];

    constructor() {
        super("StartWOOperationsSerializedLiteSingleWO", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOOperationsSerializedLiteSingleWOResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSendMail2 extends QAction<SendMail2Params> {
    private readonly params = [new QComplexParam("command", new QSendMail())];

    constructor() {
        super("SendMail", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSendMailResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOOperationsSerializedLite2 extends QAction<StartWOOperationsSerializedLite2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOOperationsSerializedLite())];

    constructor() {
        super("StartWOOperationsSerializedLite", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOOperationsSerializedLiteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCloneAsPlannedBOP2 extends QAction<CloneAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QCloneAsPlannedBOP())];

    constructor() {
        super("CloneAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCloneAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGenerateAndAssociateMTUCode2 extends QAction<GenerateAndAssociateMTUCode2Params> {
    private readonly params = [new QComplexParam("command", new QGenerateAndAssociateMTUCode())];

    constructor() {
        super("GenerateAndAssociateMTUCode", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGenerateAndAssociateMTUCodeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStatusDefinition2 extends QAction<UpdateStatusDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStatusDefinition())];

    constructor() {
        super("UpdateStatusDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStatusDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGenerateWorkOrderNId2 extends QAction<GenerateWorkOrderNId2Params> {
    private readonly params = [new QComplexParam("command", new QGenerateWorkOrderNId())];

    constructor() {
        super("GenerateWorkOrderNId", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGenerateWorkOrderNIdResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateAMPowderBatchGenealogy2 extends QAction<CreateAMPowderBatchGenealogy2Params> {
    private readonly params = [new QComplexParam("command", new QCreateAMPowderBatchGenealogy())];

    constructor() {
        super("CreateAMPowderBatchGenealogy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateAMPowderBatchGenealogyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkWIDefinitionsFromEGPhase2 extends QAction<UnlinkWIDefinitionsFromEGPhase2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkWIDefinitionsFromEGPhase())];

    constructor() {
        super("UnlinkWIDefinitionsFromEGPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkWIDefinitionsFromEGPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateFutureHold2 extends QAction<UpdateFutureHold2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateFutureHold())];

    constructor() {
        super("UpdateFutureHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateFutureHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditPrintJobFile2 extends QAction<EditPrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QEditPrintJobFile())];

    constructor() {
        super("EditPrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditPrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInStartWOOperationTransferBatch2 extends QAction<CheckInStartWOOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInStartWOOperationTransferBatch())];

    constructor() {
        super("CheckInStartWOOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInStartWOOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteBufferDefinition2 extends QAction<DeleteBufferDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteBufferDefinition())];

    constructor() {
        super("DeleteBufferDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteBufferDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkItlkCheckToWorkOrderStepList2 extends QAction<UnlinkItlkCheckToWorkOrderStepList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkItlkCheckToWorkOrderStepList())];

    constructor() {
        super("UnlinkItlkCheckToWorkOrderStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkItlkCheckToWorkOrderStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocumentListToDM_MaterialTrackingUnit2 extends QAction<LinkDocumentListToDM_MaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocumentListToDM_MaterialTrackingUnit())];

    constructor() {
        super("LinkDocumentListToDM_MaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentListToDM_MaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderFromProcess2 extends QAction<CreateWorkOrderFromProcess2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderFromProcess())];

    constructor() {
        super("CreateWorkOrderFromProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderFromProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateResultList2 extends QAction<CreateResultList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateResultList())];

    constructor() {
        super("CreateResultList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateResultListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialDefinitionDocument2 extends QAction<CreateMaterialDefinitionDocument2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialDefinitionDocument())];

    constructor() {
        super("CreateMaterialDefinitionDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialDefinitionDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckOutWorkOrderOperationList2 extends QAction<CheckOutWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QCheckOutWorkOrderOperationList())];

    constructor() {
        super("CheckOutWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckOutWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateExecutionGroupPhaseDependency2 extends QAction<CreateExecutionGroupPhaseDependency2Params> {
    private readonly params = [new QComplexParam("command", new QCreateExecutionGroupPhaseDependency())];

    constructor() {
        super("CreateExecutionGroupPhaseDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateExecutionGroupPhaseDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkInstructionTemplate2 extends QAction<CreateWorkInstructionTemplate2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkInstructionTemplate())];

    constructor() {
        super("CreateWorkInstructionTemplate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkInstructionTemplateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStatusDefinition2 extends QAction<CreateStatusDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStatusDefinition())];

    constructor() {
        super("CreateStatusDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStatusDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialToContainerTypeList2 extends QAction<LinkMaterialToContainerTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialToContainerTypeList())];

    constructor() {
        super("LinkMaterialToContainerTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialToContainerTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderStepFromStep2 extends QAction<CreateWorkOrderStepFromStep2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderStepFromStep())];

    constructor() {
        super("CreateWorkOrderStepFromStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderStepFromStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSubstrateMaintenance2 extends QAction<SubstrateMaintenance2Params> {
    private readonly params = [new QComplexParam("command", new QSubstrateMaintenance())];

    constructor() {
        super("SubstrateMaintenance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSubstrateMaintenanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUseScrewingTool2 extends QAction<UseScrewingTool2Params> {
    private readonly params = [new QComplexParam("command", new QUseScrewingTool())];

    constructor() {
        super("UseScrewingTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUseScrewingToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetFutureHoldAfterNonConformanceCreation2 extends QAction<SetFutureHoldAfterNonConformanceCreation2Params> {
    private readonly params = [new QComplexParam("command", new QSetFutureHoldAfterNonConformanceCreation())];

    constructor() {
        super("SetFutureHoldAfterNonConformanceCreation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetFutureHoldAfterNonConformanceCreationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceAttachmentList2 extends QAction<CreateNonConformanceAttachmentList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceAttachmentList())];

    constructor() {
        super("CreateNonConformanceAttachmentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceAttachmentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrderHistory2 extends QAction<DeleteWorkOrderHistory2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrderHistory())];

    constructor() {
        super("DeleteWorkOrderHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocumentToOperation2 extends QAction<UnlinkDocumentToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocumentToOperation())];

    constructor() {
        super("UnlinkDocumentToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckCertificationMultiMachine2 extends QAction<CheckCertificationMultiMachine2Params> {
    private readonly params = [new QComplexParam("command", new QCheckCertificationMultiMachine())];

    constructor() {
        super("CheckCertificationMultiMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckCertificationMultiMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateLogisticRequestItem2 extends QAction<CreateLogisticRequestItem2Params> {
    private readonly params = [new QComplexParam("command", new QCreateLogisticRequestItem())];

    constructor() {
        super("CreateLogisticRequestItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateLogisticRequestItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationDependency2 extends QAction<CreateOperationDependency2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationDependency())];

    constructor() {
        super("CreateOperationDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkInstructionDefinition2 extends QAction<DeleteWorkInstructionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkInstructionDefinition())];

    constructor() {
        super("DeleteWorkInstructionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkInstructionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPunchInUsers2 extends QAction<PunchInUsers2Params> {
    private readonly params = [new QComplexParam("command", new QPunchInUsers())];

    constructor() {
        super("PunchInUsers", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPunchInUsersResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInCompleteWOStepFullQty2 extends QAction<CheckInCompleteWOStepFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInCompleteWOStepFullQty())];

    constructor() {
        super("CheckInCompleteWOStepFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInCompleteWOStepFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateEquipmentSpecificationFullList2 extends QAction<TCM2CreateEquipmentSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateEquipmentSpecificationFullList())];

    constructor() {
        super("TCM2CreateEquipmentSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateEquipmentSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrder2 extends QAction<CreateWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrder())];

    constructor() {
        super("CreateWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUseTool2 extends QAction<UseTool2Params> {
    private readonly params = [new QComplexParam("command", new QUseTool())];

    constructor() {
        super("UseTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUseToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolSpecificationList2 extends QAction<CreateToolSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolSpecificationList())];

    constructor() {
        super("CreateToolSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSkillsToProcessOperation2 extends QAction<LinkSkillsToProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSkillsToProcessOperation())];

    constructor() {
        super("LinkSkillsToProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSkillsToProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLink3DPrinterTypeToEquipmentType2 extends QAction<Link3DPrinterTypeToEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QLink3DPrinterTypeToEquipmentType())];

    constructor() {
        super("Link3DPrinterTypeToEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLink3DPrinterTypeToEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationRevisionSubStructure2 extends QAction<CreateOperationRevisionSubStructure2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationRevisionSubStructure())];

    constructor() {
        super("CreateOperationRevisionSubStructure", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationRevisionSubStructureResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkProcessToAsPlannedBOP2 extends QAction<LinkProcessToAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QLinkProcessToAsPlannedBOP())];

    constructor() {
        super("LinkProcessToAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkProcessToAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphType2 extends QAction<DeleteEquipmentGraphType2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphType())];

    constructor() {
        super("DeleteEquipmentGraphType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveNonConformanceTransitionMailAddressList2 extends QAction<RemoveNonConformanceTransitionMailAddressList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveNonConformanceTransitionMailAddressList())];

    constructor() {
        super("RemoveNonConformanceTransitionMailAddressList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveNonConformanceTransitionMailAddressListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkItlkCheckToWorkOrderOperationList2 extends QAction<LinkItlkCheckToWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkItlkCheckToWorkOrderOperationList())];

    constructor() {
        super("LinkItlkCheckToWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkItlkCheckToWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnloadContainer2 extends QAction<UnloadContainer2Params> {
    private readonly params = [new QComplexParam("command", new QUnloadContainer())];

    constructor() {
        super("UnloadContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnloadContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateChange2 extends QAction<CreateChange2Params> {
    private readonly params = [new QComplexParam("command", new QCreateChange())];

    constructor() {
        super("CreateChange", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateChangeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisAssignProducedMaterialItems2 extends QAction<DisAssignProducedMaterialItems2Params> {
    private readonly params = [new QComplexParam("command", new QDisAssignProducedMaterialItems())];

    constructor() {
        super("DisAssignProducedMaterialItems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisAssignProducedMaterialItemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkAutomationNodeInstanceParameterFromMaterialParameterList2 extends QAction<UnlinkAutomationNodeInstanceParameterFromMaterialParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkAutomationNodeInstanceParameterFromMaterialParameterList())];

    constructor() {
        super("UnlinkAutomationNodeInstanceParameterFromMaterialParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkAutomationNodeInstanceParameterFromMaterialParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateMaterialSpecificationFullList2 extends QAction<TCM2CreateMaterialSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateMaterialSpecificationFullList())];

    constructor() {
        super("TCM2CreateMaterialSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateMaterialSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOOperationFullQty2 extends QAction<StartWOOperationFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOOperationFullQty())];

    constructor() {
        super("StartWOOperationFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOOperationFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTakeOwnershipTransportOperation2 extends QAction<TakeOwnershipTransportOperation2Params> {
    private readonly params = [new QComplexParam("command", new QTakeOwnershipTransportOperation())];

    constructor() {
        super("TakeOwnershipTransportOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTakeOwnershipTransportOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTraceCertificationHistory2 extends QAction<TraceCertificationHistory2Params> {
    private readonly params = [new QComplexParam("command", new QTraceCertificationHistory())];

    constructor() {
        super("TraceCertificationHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTraceCertificationHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateSupplier2 extends QAction<CreateSupplier2Params> {
    private readonly params = [new QComplexParam("command", new QCreateSupplier())];

    constructor() {
        super("CreateSupplier", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateSupplierResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutoGenerateWorkOrderNId2 extends QAction<AutoGenerateWorkOrderNId2Params> {
    private readonly params = [new QComplexParam("command", new QAutoGenerateWorkOrderNId())];

    constructor() {
        super("AutoGenerateWorkOrderNId", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutoGenerateWorkOrderNIdResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrdersFromAsPlannedBOP2 extends QAction<CreateWorkOrdersFromAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrdersFromAsPlannedBOP())];

    constructor() {
        super("CreateWorkOrdersFromAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrdersFromAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReserveMaterialItems2 extends QAction<ReserveMaterialItems2Params> {
    private readonly params = [new QComplexParam("command", new QReserveMaterialItems())];

    constructor() {
        super("ReserveMaterialItems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReserveMaterialItemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteBufferList2 extends QAction<DeleteBufferList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteBufferList())];

    constructor() {
        super("DeleteBufferList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteBufferListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentLevel2 extends QAction<CreateEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentLevel())];

    constructor() {
        super("CreateEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkWorkInstructionsFromWOStep2 extends QAction<UnlinkWorkInstructionsFromWOStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkWorkInstructionsFromWOStep())];

    constructor() {
        super("UnlinkWorkInstructionsFromWOStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkWorkInstructionsFromWOStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeChangeDependency2 extends QAction<AcceptChangeChangeDependency2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeChangeDependency())];

    constructor() {
        super("AcceptChangeChangeDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeChangeDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteFunctionalCodeList2 extends QAction<DeleteFunctionalCodeList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteFunctionalCodeList())];

    constructor() {
        super("DeleteFunctionalCodeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteFunctionalCodeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartExecutionGroup2 extends QAction<StartExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QStartExecutionGroup())];

    constructor() {
        super("StartExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveCertificationToRoleList2 extends QAction<RemoveCertificationToRoleList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveCertificationToRoleList())];

    constructor() {
        super("RemoveCertificationToRoleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveCertificationToRoleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateAPSAlert2 extends QAction<CreateAPSAlert2Params> {
    private readonly params = [new QComplexParam("command", new QCreateAPSAlert())];

    constructor() {
        super("CreateAPSAlert", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateAPSAlertResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBufferDefinition2 extends QAction<CreateBufferDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateBufferDefinition())];

    constructor() {
        super("CreateBufferDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBufferDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QResendConfirmWorkOrderOperation2 extends QAction<ResendConfirmWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QResendConfirmWorkOrderOperation())];

    constructor() {
        super("ResendConfirmWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QResendConfirmWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDNCTransferDNCItems2 extends QAction<DNCTransferDNCItems2Params> {
    private readonly params = [new QComplexParam("command", new QDNCTransferDNCItems())];

    constructor() {
        super("DNCTransferDNCItems", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDNCTransferDNCItemsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonConformanceSupervisor2 extends QAction<UpdateNonConformanceSupervisor2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonConformanceSupervisor())];

    constructor() {
        super("UpdateNonConformanceSupervisor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonConformanceSupervisorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcquireMTUFromAutomationNodeInstanceParameter2 extends QAction<AcquireMTUFromAutomationNodeInstanceParameter2Params> {
    private readonly params = [new QComplexParam("command", new QAcquireMTUFromAutomationNodeInstanceParameter())];

    constructor() {
        super("AcquireMTUFromAutomationNodeInstanceParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcquireMTUFromAutomationNodeInstanceParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActualCollectedDocumentListOnContainer2 extends QAction<CreateActualCollectedDocumentListOnContainer2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActualCollectedDocumentListOnContainer())];

    constructor() {
        super("CreateActualCollectedDocumentListOnContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActualCollectedDocumentListOnContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolDefinition2 extends QAction<CreateToolDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolDefinition())];

    constructor() {
        super("CreateToolDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurationProperty2 extends QAction<DeleteEquipmentConfigurationProperty2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurationProperty())];

    constructor() {
        super("DeleteEquipmentConfigurationProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationPropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateAsPlannedBOP2 extends QAction<CreateAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QCreateAsPlannedBOP())];

    constructor() {
        super("CreateAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTemplateToMaterialPlant2 extends QAction<DeleteTemplateToMaterialPlant2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTemplateToMaterialPlant())];

    constructor() {
        super("DeleteTemplateToMaterialPlant", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTemplateToMaterialPlantResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptMaterialRequest2 extends QAction<AcceptMaterialRequest2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptMaterialRequest())];

    constructor() {
        super("AcceptMaterialRequest", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptMaterialRequestResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateProcess2 extends QAction<UADMUpdateProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateProcess())];

    constructor() {
        super("UADMUpdateProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAmendResultList2 extends QAction<AmendResultList2Params> {
    private readonly params = [new QComplexParam("command", new QAmendResultList())];

    constructor() {
        super("AmendResultList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAmendResultListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateToBeUsedMachine2 extends QAction<UpdateToBeUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateToBeUsedMachine())];

    constructor() {
        super("UpdateToBeUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateToBeUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateDNCItemMachinesMaterialsAssociation2 extends QAction<AssociateDNCItemMachinesMaterialsAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateDNCItemMachinesMaterialsAssociation())];

    constructor() {
        super("AssociateDNCItemMachinesMaterialsAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateDNCItemMachinesMaterialsAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateRuntimeCharacteristicRepresentationContainer2 extends QAction<CreateRuntimeCharacteristicRepresentationContainer2Params> {
    private readonly params = [new QComplexParam("command", new QCreateRuntimeCharacteristicRepresentationContainer())];

    constructor() {
        super("CreateRuntimeCharacteristicRepresentationContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateRuntimeCharacteristicRepresentationContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWOOpDependencyNavigationList2 extends QAction<DeleteWOOpDependencyNavigationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWOOpDependencyNavigationList())];

    constructor() {
        super("DeleteWOOpDependencyNavigationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWOOpDependencyNavigationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWorkInstruction2 extends QAction<CompleteWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWorkInstruction())];

    constructor() {
        super("CompleteWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlockWorkInstructionDefinition2 extends QAction<UnlockWorkInstructionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUnlockWorkInstructionDefinition())];

    constructor() {
        super("UnlockWorkInstructionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlockWorkInstructionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeRemoveToBeConsumedMaterial2 extends QAction<AcceptChangeRemoveToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeRemoveToBeConsumedMaterial())];

    constructor() {
        super("AcceptChangeRemoveToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeRemoveToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPSSetInScheduled2 extends QAction<APSSetInScheduled2Params> {
    private readonly params = [new QComplexParam("command", new QAPSSetInScheduled())];

    constructor() {
        super("APSSetInScheduled", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPSSetInScheduledResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateLogisticClass2 extends QAction<CreateLogisticClass2Params> {
    private readonly params = [new QComplexParam("command", new QCreateLogisticClass())];

    constructor() {
        super("CreateLogisticClass", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateLogisticClassResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLink3DPrinterTypeToMES2 extends QAction<Link3DPrinterTypeToMES2Params> {
    private readonly params = [new QComplexParam("command", new QLink3DPrinterTypeToMES())];

    constructor() {
        super("Link3DPrinterTypeToMES", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLink3DPrinterTypeToMESResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeAddProcessOperation2 extends QAction<AcceptChangeAddProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeAddProcessOperation())];

    constructor() {
        super("AcceptChangeAddProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeAddProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTool2 extends QAction<DeleteTool2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTool())];

    constructor() {
        super("DeleteTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkPJFToMaterialDefinition2 extends QAction<LinkPJFToMaterialDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QLinkPJFToMaterialDefinition())];

    constructor() {
        super("LinkPJFToMaterialDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkPJFToMaterialDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateCharacteristicRepresentation2 extends QAction<UpdateCharacteristicRepresentation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateCharacteristicRepresentation())];

    constructor() {
        super("UpdateCharacteristicRepresentation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateCharacteristicRepresentationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDNCItem2 extends QAction<DeleteDNCItem2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDNCItem())];

    constructor() {
        super("DeleteDNCItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDNCItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteAMPowderBatchGenealogy2 extends QAction<DeleteAMPowderBatchGenealogy2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteAMPowderBatchGenealogy())];

    constructor() {
        super("DeleteAMPowderBatchGenealogy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteAMPowderBatchGenealogyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCustomItlkCheckParameterList2 extends QAction<CreateCustomItlkCheckParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCustomItlkCheckParameterList())];

    constructor() {
        super("CreateCustomItlkCheckParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCustomItlkCheckParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetConfigurationKey2 extends QAction<SetConfigurationKey2Params> {
    private readonly params = [new QComplexParam("command", new QSetConfigurationKey())];

    constructor() {
        super("SetConfigurationKey", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetConfigurationKeyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationStructureDependencyList2 extends QAction<CreateOperationStructureDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationStructureDependencyList())];

    constructor() {
        super("CreateOperationStructureDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationStructureDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateAndStartWorkProcessListFromProcessDefinition2 extends QAction<CreateAndStartWorkProcessListFromProcessDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateAndStartWorkProcessListFromProcessDefinition())];

    constructor() {
        super("CreateAndStartWorkProcessListFromProcessDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateAndStartWorkProcessListFromProcessDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDM_MaterialTrackingUnitHistoryAction2 extends QAction<CreateDM_MaterialTrackingUnitHistoryAction2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDM_MaterialTrackingUnitHistoryAction())];

    constructor() {
        super("CreateDM_MaterialTrackingUnitHistoryAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDM_MaterialTrackingUnitHistoryActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateToolDefinitionList2 extends QAction<TCM2CreateToolDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateToolDefinitionList())];

    constructor() {
        super("TCM2CreateToolDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateToolDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkStepToOperation2 extends QAction<UnlinkStepToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkStepToOperation())];

    constructor() {
        super("UnlinkStepToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkStepToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceSupervisor2 extends QAction<CreateNonConformanceSupervisor2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceSupervisor())];

    constructor() {
        super("CreateNonConformanceSupervisor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceSupervisorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCoProduceMaterialTrackingUnit2 extends QAction<CoProduceMaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QCoProduceMaterialTrackingUnit())];

    constructor() {
        super("CoProduceMaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCoProduceMaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetInputResultType2 extends QAction<GetInputResultType2Params> {
    private readonly params = [new QComplexParam("command", new QGetInputResultType())];

    constructor() {
        super("GetInputResultType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetInputResultTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkPrintJobFileToEquipmentType2 extends QAction<LinkPrintJobFileToEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QLinkPrintJobFileToEquipmentType())];

    constructor() {
        super("LinkPrintJobFileToEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkPrintJobFileToEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkTransferPluginTo3DPrinter2 extends QAction<LinkTransferPluginTo3DPrinter2Params> {
    private readonly params = [new QComplexParam("command", new QLinkTransferPluginTo3DPrinter())];

    constructor() {
        super("LinkTransferPluginTo3DPrinter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkTransferPluginTo3DPrinterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateSnagAndNoteList2 extends QAction<CreateSnagAndNoteList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateSnagAndNoteList())];

    constructor() {
        super("CreateSnagAndNoteList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateSnagAndNoteListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSuppliersToMaterialV4_02 extends QAction<LinkSuppliersToMaterialV4_02Params> {
    private readonly params = [new QComplexParam("command", new QLinkSuppliersToMaterialV4_0())];

    constructor() {
        super("LinkSuppliersToMaterialV4_0", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSuppliersToMaterialV4_0Response)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStateMachine2 extends QAction<UpdateStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStateMachine())];

    constructor() {
        super("UpdateStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCertification2 extends QAction<DeleteCertification2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCertification())];

    constructor() {
        super("DeleteCertification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCertificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditWorkOrderOperation2 extends QAction<EditWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QEditWorkOrderOperation())];

    constructor() {
        super("EditWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkInstructionsToEGPhase2 extends QAction<LinkWorkInstructionsToEGPhase2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkInstructionsToEGPhase())];

    constructor() {
        super("LinkWorkInstructionsToEGPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkInstructionsToEGPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSkipWOOperationFullQty2 extends QAction<SkipWOOperationFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QSkipWOOperationFullQty())];

    constructor() {
        super("SkipWOOperationFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSkipWOOperationFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPSSetInScheduling2 extends QAction<APSSetInScheduling2Params> {
    private readonly params = [new QComplexParam("command", new QAPSSetInScheduling())];

    constructor() {
        super("APSSetInScheduling", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPSSetInSchedulingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignCertificationToSkillList2 extends QAction<AssignCertificationToSkillList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignCertificationToSkillList())];

    constructor() {
        super("AssignCertificationToSkillList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignCertificationToSkillListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetDueDateOnExecGroup2 extends QAction<SetDueDateOnExecGroup2Params> {
    private readonly params = [new QComplexParam("command", new QSetDueDateOnExecGroup())];

    constructor() {
        super("SetDueDateOnExecGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetDueDateOnExecGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperationListFromCatalogue2 extends QAction<DeleteOperationListFromCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperationListFromCatalogue())];

    constructor() {
        super("DeleteOperationListFromCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationListFromCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2DeleteLinkProcessToOperationList2 extends QAction<TCM2DeleteLinkProcessToOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2DeleteLinkProcessToOperationList())];

    constructor() {
        super("TCM2DeleteLinkProcessToOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2DeleteLinkProcessToOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSentenceNonConformanceV3_12 extends QAction<SentenceNonConformanceV3_12Params> {
    private readonly params = [new QComplexParam("command", new QSentenceNonConformanceV3_1())];

    constructor() {
        super("SentenceNonConformanceV3_1", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSentenceNonConformanceV3_1Response)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStepDependencyList2 extends QAction<DeleteStepDependencyList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStepDependencyList())];

    constructor() {
        super("DeleteStepDependencyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStepDependencyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetOfflineWorkInstructions2 extends QAction<GetOfflineWorkInstructions2Params> {
    private readonly params = [new QComplexParam("command", new QGetOfflineWorkInstructions())];

    constructor() {
        super("GetOfflineWorkInstructions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetOfflineWorkInstructionsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkOperationListToProcess2 extends QAction<UnlinkOperationListToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkOperationListToProcess())];

    constructor() {
        super("UnlinkOperationListToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkOperationListToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphLinkConfiguration2 extends QAction<DeleteEquipmentGraphLinkConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphLinkConfiguration())];

    constructor() {
        super("DeleteEquipmentGraphLinkConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphLinkConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteScrewingWOOpOnToolDeactivation2 extends QAction<CompleteScrewingWOOpOnToolDeactivation2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteScrewingWOOpOnToolDeactivation())];

    constructor() {
        super("CompleteScrewingWOOpOnToolDeactivation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteScrewingWOOpOnToolDeactivationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInStartWOStepTransferBatch2 extends QAction<CheckInStartWOStepTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInStartWOStepTransferBatch())];

    constructor() {
        super("CheckInStartWOStepTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInStartWOStepTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceNotification2 extends QAction<CreateNonConformanceNotification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceNotification())];

    constructor() {
        super("CreateNonConformanceNotification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceNotificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocumentListToOperation2 extends QAction<LinkDocumentListToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocumentListToOperation())];

    constructor() {
        super("LinkDocumentListToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentListToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLoadHandlingUnit2 extends QAction<LoadHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QLoadHandlingUnit())];

    constructor() {
        super("LoadHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLoadHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConsumeMaterialItemOnContainer2 extends QAction<ConsumeMaterialItemOnContainer2Params> {
    private readonly params = [new QComplexParam("command", new QConsumeMaterialItemOnContainer())];

    constructor() {
        super("ConsumeMaterialItemOnContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConsumeMaterialItemOnContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentPropertyValue2 extends QAction<SetEquipmentPropertyValue2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentPropertyValue())];

    constructor() {
        super("SetEquipmentPropertyValue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentPropertyValueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInConsumeMaterialItem2 extends QAction<CheckInConsumeMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInConsumeMaterialItem())];

    constructor() {
        super("CheckInConsumeMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInConsumeMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNewToolDefinitionRevision2 extends QAction<UADMCreateNewToolDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNewToolDefinitionRevision())];

    constructor() {
        super("UADMCreateNewToolDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNewToolDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeChangeToBeConsumedMaterialQuantity2 extends QAction<AcceptChangeChangeToBeConsumedMaterialQuantity2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeChangeToBeConsumedMaterialQuantity())];

    constructor() {
        super("AcceptChangeChangeToBeConsumedMaterialQuantity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeChangeToBeConsumedMaterialQuantityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeletePauseReason2 extends QAction<DeletePauseReason2Params> {
    private readonly params = [new QComplexParam("command", new QDeletePauseReason())];

    constructor() {
        super("DeletePauseReason", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeletePauseReasonResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageResultList2 extends QAction<ManageResultList2Params> {
    private readonly params = [new QComplexParam("command", new QManageResultList())];

    constructor() {
        super("ManageResultList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageResultListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutomaticSentenceNonConformance2 extends QAction<AutomaticSentenceNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QAutomaticSentenceNonConformance())];

    constructor() {
        super("AutomaticSentenceNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutomaticSentenceNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkUserToWorkOrderOperationList2 extends QAction<UnlinkUserToWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkUserToWorkOrderOperationList())];

    constructor() {
        super("UnlinkUserToWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkUserToWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformance2 extends QAction<CreateNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformance())];

    constructor() {
        super("CreateNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateProcessList2 extends QAction<TCM2CreateProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateProcessList())];

    constructor() {
        super("TCM2CreateProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentSpecificationWithPrintJobFile2 extends QAction<CreateEquipmentSpecificationWithPrintJobFile2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentSpecificationWithPrintJobFile())];

    constructor() {
        super("CreateEquipmentSpecificationWithPrintJobFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentSpecificationWithPrintJobFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateOperationDependency2 extends QAction<UpdateOperationDependency2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateOperationDependency())];

    constructor() {
        super("UpdateOperationDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateOperationDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSkipWOOperationSerialized2 extends QAction<SkipWOOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QSkipWOOperationSerialized())];

    constructor() {
        super("SkipWOOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSkipWOOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteSkipReason2 extends QAction<DeleteSkipReason2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteSkipReason())];

    constructor() {
        super("DeleteSkipReason", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteSkipReasonResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateCertification2 extends QAction<UpdateCertification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateCertification())];

    constructor() {
        super("UpdateCertification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateCertificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWIDefinitionsToWOOperation2 extends QAction<LinkWIDefinitionsToWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWIDefinitionsToWOOperation())];

    constructor() {
        super("LinkWIDefinitionsToWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWIDefinitionsToWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateSkill_BOP2 extends QAction<CreateSkill_BOP2Params> {
    private readonly params = [new QComplexParam("command", new QCreateSkill_BOP())];

    constructor() {
        super("CreateSkill_BOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateSkill_BOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentPreferencesForUser2 extends QAction<SetEquipmentPreferencesForUser2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentPreferencesForUser())];

    constructor() {
        super("SetEquipmentPreferencesForUser", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentPreferencesForUserResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeRemoveDependency2 extends QAction<AcceptChangeRemoveDependency2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeRemoveDependency())];

    constructor() {
        super("AcceptChangeRemoveDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeRemoveDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkPrintJobFileToMachine2 extends QAction<UnlinkPrintJobFileToMachine2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkPrintJobFileToMachine())];

    constructor() {
        super("UnlinkPrintJobFileToMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkPrintJobFileToMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteFutureHold2 extends QAction<DeleteFutureHold2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteFutureHold())];

    constructor() {
        super("DeleteFutureHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteFutureHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurationPropertyAttribute2 extends QAction<DeleteEquipmentConfigurationPropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurationPropertyAttribute())];

    constructor() {
        super("DeleteEquipmentConfigurationPropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationPropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialSpecificationList2 extends QAction<CreateMaterialSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialSpecificationList())];

    constructor() {
        super("CreateMaterialSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QValidateDataCollectionIsComplete2 extends QAction<ValidateDataCollectionIsComplete2Params> {
    private readonly params = [new QComplexParam("command", new QValidateDataCollectionIsComplete())];

    constructor() {
        super("ValidateDataCollectionIsComplete", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QValidateDataCollectionIsCompleteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateToolSpecificationFullList2 extends QAction<TCM2CreateToolSpecificationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateToolSpecificationFullList())];

    constructor() {
        super("TCM2CreateToolSpecificationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateToolSpecificationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteCharacteristicRepresentation2 extends QAction<DeleteCharacteristicRepresentation2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteCharacteristicRepresentation())];

    constructor() {
        super("DeleteCharacteristicRepresentation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteCharacteristicRepresentationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAutomaticUseToolList2 extends QAction<AutomaticUseToolList2Params> {
    private readonly params = [new QComplexParam("command", new QAutomaticUseToolList())];

    constructor() {
        super("AutomaticUseToolList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAutomaticUseToolListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetConfigurationKeyList2 extends QAction<SetConfigurationKeyList2Params> {
    private readonly params = [new QComplexParam("command", new QSetConfigurationKeyList())];

    constructor() {
        super("SetConfigurationKeyList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetConfigurationKeyListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateLinkStepToOperation2 extends QAction<UpdateLinkStepToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateLinkStepToOperation())];

    constructor() {
        super("UpdateLinkStepToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateLinkStepToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkOrderOperationActualExecutionTimes2 extends QAction<UpdateWorkOrderOperationActualExecutionTimes2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkOrderOperationActualExecutionTimes())];

    constructor() {
        super("UpdateWorkOrderOperationActualExecutionTimes", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkOrderOperationActualExecutionTimesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateSkill2 extends QAction<CreateSkill2Params> {
    private readonly params = [new QComplexParam("command", new QCreateSkill())];

    constructor() {
        super("CreateSkill", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateSkillResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateMaterialSpecification2 extends QAction<UADMUpdateMaterialSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateMaterialSpecification())];

    constructor() {
        super("UADMUpdateMaterialSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateMaterialSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDNCGetMachineDNCItemAssociation2 extends QAction<DNCGetMachineDNCItemAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QDNCGetMachineDNCItemAssociation())];

    constructor() {
        super("DNCGetMachineDNCItemAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDNCGetMachineDNCItemAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMaterialItemSplitBatch2 extends QAction<MaterialItemSplitBatch2Params> {
    private readonly params = [new QComplexParam("command", new QMaterialItemSplitBatch())];

    constructor() {
        super("MaterialItemSplitBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMaterialItemSplitBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSetPointItemToSetPoint2 extends QAction<UnlinkSetPointItemToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSetPointItemToSetPoint())];

    constructor() {
        super("UnlinkSetPointItemToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSetPointItemToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConfirmSnagAndNoteList2 extends QAction<ConfirmSnagAndNoteList2Params> {
    private readonly params = [new QComplexParam("command", new QConfirmSnagAndNoteList())];

    constructor() {
        super("ConfirmSnagAndNoteList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConfirmSnagAndNoteListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConfirmWorkOrder2 extends QAction<ConfirmWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QConfirmWorkOrder())];

    constructor() {
        super("ConfirmWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConfirmWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QScheduleExecutionGroup2 extends QAction<ScheduleExecutionGroup2Params> {
    private readonly params = [new QComplexParam("command", new QScheduleExecutionGroup())];

    constructor() {
        super("ScheduleExecutionGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QScheduleExecutionGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateContainerToWorkOrder2 extends QAction<AssociateContainerToWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateContainerToWorkOrder())];

    constructor() {
        super("AssociateContainerToWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateContainerToWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateProcessList2 extends QAction<CreateProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateProcessList())];

    constructor() {
        super("CreateProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2DeleteLinkOperationToStepList2 extends QAction<TCM2DeleteLinkOperationToStepList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2DeleteLinkOperationToStepList())];

    constructor() {
        super("TCM2DeleteLinkOperationToStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2DeleteLinkOperationToStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeAddToBeUsedTool2 extends QAction<AcceptChangeAddToBeUsedTool2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeAddToBeUsedTool())];

    constructor() {
        super("AcceptChangeAddToBeUsedTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeAddToBeUsedToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeassociateDNCItemMachineMaterialAssociation2 extends QAction<DeassociateDNCItemMachineMaterialAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QDeassociateDNCItemMachineMaterialAssociation())];

    constructor() {
        super("DeassociateDNCItemMachineMaterialAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeassociateDNCItemMachineMaterialAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteUoMDimension2 extends QAction<DeleteUoMDimension2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteUoMDimension())];

    constructor() {
        super("DeleteUoMDimension", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteUoMDimensionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOOperationTransferBatch2 extends QAction<CompleteWOOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOOperationTransferBatch())];

    constructor() {
        super("CompleteWOOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSetPointItemToSetPoint2 extends QAction<LinkSetPointItemToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSetPointItemToSetPoint())];

    constructor() {
        super("LinkSetPointItemToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSetPointItemToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSaveResultQuantitiesOnWorkOrderOperationList2 extends QAction<SaveResultQuantitiesOnWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QSaveResultQuantitiesOnWorkOrderOperationList())];

    constructor() {
        super("SaveResultQuantitiesOnWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSaveResultQuantitiesOnWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWIResultList2 extends QAction<CreateWIResultList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWIResultList())];

    constructor() {
        super("CreateWIResultList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWIResultListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkToolsFromNonConformance2 extends QAction<UnLinkToolsFromNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkToolsFromNonConformance())];

    constructor() {
        super("UnLinkToolsFromNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkToolsFromNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignCertificationToUserList2 extends QAction<AssignCertificationToUserList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignCertificationToUserList())];

    constructor() {
        super("AssignCertificationToUserList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignCertificationToUserListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEndIdTemplateEditing2 extends QAction<EndIdTemplateEditing2Params> {
    private readonly params = [new QComplexParam("command", new QEndIdTemplateEditing())];

    constructor() {
        super("EndIdTemplateEditing", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEndIdTemplateEditingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocumentListToEGPhase2 extends QAction<LinkDocumentListToEGPhase2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocumentListToEGPhase())];

    constructor() {
        super("LinkDocumentListToEGPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentListToEGPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageRepeatResultForScrappedMTU2 extends QAction<ManageRepeatResultForScrappedMTU2Params> {
    private readonly params = [new QComplexParam("command", new QManageRepeatResultForScrappedMTU())];

    constructor() {
        super("ManageRepeatResultForScrappedMTU", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageRepeatResultForScrappedMTUResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteProducedMaterialUnderRework2 extends QAction<DeleteProducedMaterialUnderRework2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteProducedMaterialUnderRework())];

    constructor() {
        super("DeleteProducedMaterialUnderRework", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteProducedMaterialUnderReworkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrderNotificationList2 extends QAction<DeleteWorkOrderNotificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrderNotificationList())];

    constructor() {
        super("DeleteWorkOrderNotificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderNotificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOStepDependency2 extends QAction<DeleteWorkOStepDependency2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOStepDependency())];

    constructor() {
        super("DeleteWorkOStepDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOStepDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteHoldReason2 extends QAction<DeleteHoldReason2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteHoldReason())];

    constructor() {
        super("DeleteHoldReason", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteHoldReasonResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkCharacteristicRepresentationToOperation2 extends QAction<LinkCharacteristicRepresentationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkCharacteristicRepresentationToOperation())];

    constructor() {
        super("LinkCharacteristicRepresentationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkCharacteristicRepresentationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageToBeConsumedMaterialDisassemble2 extends QAction<ManageToBeConsumedMaterialDisassemble2Params> {
    private readonly params = [new QComplexParam("command", new QManageToBeConsumedMaterialDisassemble())];

    constructor() {
        super("ManageToBeConsumedMaterialDisassemble", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageToBeConsumedMaterialDisassembleResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialTrackingUnitToContainerList2 extends QAction<LinkMaterialTrackingUnitToContainerList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialTrackingUnitToContainerList())];

    constructor() {
        super("LinkMaterialTrackingUnitToContainerList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialTrackingUnitToContainerListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignNonConformanceTransitionRoleList2 extends QAction<AssignNonConformanceTransitionRoleList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignNonConformanceTransitionRoleList())];

    constructor() {
        super("AssignNonConformanceTransitionRoleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignNonConformanceTransitionRoleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInPauseWOOperation2 extends QAction<CheckInPauseWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInPauseWOOperation())];

    constructor() {
        super("CheckInPauseWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInPauseWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOperationStructureDependency2 extends QAction<CreateOperationStructureDependency2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOperationStructureDependency())];

    constructor() {
        super("CreateOperationStructureDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOperationStructureDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStateMachine2 extends QAction<CreateStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStateMachine())];

    constructor() {
        super("CreateStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStatusTransition2 extends QAction<DeleteStatusTransition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStatusTransition())];

    constructor() {
        super("DeleteStatusTransition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStatusTransitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkWorkInstructionDefinitionListFromStep2 extends QAction<UnLinkWorkInstructionDefinitionListFromStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkWorkInstructionDefinitionListFromStep())];

    constructor() {
        super("UnLinkWorkInstructionDefinitionListFromStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkWorkInstructionDefinitionListFromStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOStepTransferBatch2 extends QAction<StartWOStepTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOStepTransferBatch())];

    constructor() {
        super("StartWOStepTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOStepTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderNotification2 extends QAction<CreateWorkOrderNotification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderNotification())];

    constructor() {
        super("CreateWorkOrderNotification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderNotificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkUserToPlant2 extends QAction<UnlinkUserToPlant2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkUserToPlant())];

    constructor() {
        super("UnlinkUserToPlant", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkUserToPlantResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDefectGroup2 extends QAction<CreateDefectGroup2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDefectGroup())];

    constructor() {
        super("CreateDefectGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDefectGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckMaterialConsumption2 extends QAction<CheckMaterialConsumption2Params> {
    private readonly params = [new QComplexParam("command", new QCheckMaterialConsumption())];

    constructor() {
        super("CheckMaterialConsumption", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckMaterialConsumptionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetResolvedToBeUsedMachinesOnWOOperationList2 extends QAction<GetResolvedToBeUsedMachinesOnWOOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QGetResolvedToBeUsedMachinesOnWOOperationList())];

    constructor() {
        super("GetResolvedToBeUsedMachinesOnWOOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetResolvedToBeUsedMachinesOnWOOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkAutomationNodeInstanceParameterToMaterialParameterList2 extends QAction<LinkAutomationNodeInstanceParameterToMaterialParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkAutomationNodeInstanceParameterToMaterialParameterList())];

    constructor() {
        super("LinkAutomationNodeInstanceParameterToMaterialParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkAutomationNodeInstanceParameterToMaterialParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateUoMFactor2 extends QAction<CreateUoMFactor2Params> {
    private readonly params = [new QComplexParam("command", new QCreateUoMFactor())];

    constructor() {
        super("CreateUoMFactor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateUoMFactorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderHistoryAction2 extends QAction<CreateWorkOrderHistoryAction2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderHistoryAction())];

    constructor() {
        super("CreateWorkOrderHistoryAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderHistoryActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateContainerType2 extends QAction<CreateContainerType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateContainerType())];

    constructor() {
        super("CreateContainerType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateContainerTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateHierarchyEquipmentNodeConfigurations2 extends QAction<CreateHierarchyEquipmentNodeConfigurations2Params> {
    private readonly params = [new QComplexParam("command", new QCreateHierarchyEquipmentNodeConfigurations())];

    constructor() {
        super("CreateHierarchyEquipmentNodeConfigurations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateHierarchyEquipmentNodeConfigurationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateNewProcessRevisionMasterPlan2 extends QAction<UADMCreateNewProcessRevisionMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateNewProcessRevisionMasterPlan())];

    constructor() {
        super("UADMCreateNewProcessRevisionMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateNewProcessRevisionMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignCertificationToLocationList2 extends QAction<AssignCertificationToLocationList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignCertificationToLocationList())];

    constructor() {
        super("AssignCertificationToLocationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignCertificationToLocationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOStepTransferBatch2 extends QAction<CompleteWOStepTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOStepTransferBatch())];

    constructor() {
        super("CompleteWOStepTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOStepTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialList2 extends QAction<DeleteMaterialList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialList())];

    constructor() {
        super("DeleteMaterialList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartNonProductiveActivityList2 extends QAction<StartNonProductiveActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QStartNonProductiveActivityList())];

    constructor() {
        super("StartNonProductiveActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartNonProductiveActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeConsumedMaterial2 extends QAction<DeleteToBeConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeConsumedMaterial())];

    constructor() {
        super("DeleteToBeConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentLevel2 extends QAction<UpdateEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentLevel())];

    constructor() {
        super("UpdateEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkItlkCheckToProcessToOpLinkList2 extends QAction<LinkItlkCheckToProcessToOpLinkList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkItlkCheckToProcessToOpLinkList())];

    constructor() {
        super("LinkItlkCheckToProcessToOpLinkList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkItlkCheckToProcessToOpLinkListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateFailure2 extends QAction<CreateFailure2Params> {
    private readonly params = [new QComplexParam("command", new QCreateFailure())];

    constructor() {
        super("CreateFailure", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateFailureResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteDNCItemMachineMaterialAssociation2 extends QAction<DeleteDNCItemMachineMaterialAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteDNCItemMachineMaterialAssociation())];

    constructor() {
        super("DeleteDNCItemMachineMaterialAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteDNCItemMachineMaterialAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSentenceNonConformanceSetLocationHold2 extends QAction<SentenceNonConformanceSetLocationHold2Params> {
    private readonly params = [new QComplexParam("command", new QSentenceNonConformanceSetLocationHold())];

    constructor() {
        super("SentenceNonConformanceSetLocationHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSentenceNonConformanceSetLocationHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveWorkOrderScrap2 extends QAction<RemoveWorkOrderScrap2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveWorkOrderScrap())];

    constructor() {
        super("RemoveWorkOrderScrap", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveWorkOrderScrapResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDM_MaterialTrackingUnitHistory2 extends QAction<UpdateDM_MaterialTrackingUnitHistory2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDM_MaterialTrackingUnitHistory())];

    constructor() {
        super("UpdateDM_MaterialTrackingUnitHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDM_MaterialTrackingUnitHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStatusTransition2 extends QAction<CreateStatusTransition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStatusTransition())];

    constructor() {
        super("CreateStatusTransition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStatusTransitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentPropertyAttributeValue2 extends QAction<SetEquipmentPropertyAttributeValue2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentPropertyAttributeValue())];

    constructor() {
        super("SetEquipmentPropertyAttributeValue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentPropertyAttributeValueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReopenWorkOrderOperationTransferBatch2 extends QAction<ReopenWorkOrderOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QReopenWorkOrderOperationTransferBatch())];

    constructor() {
        super("ReopenWorkOrderOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReopenWorkOrderOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageToBeConsumedMaterialDisassembleOnContainer2 extends QAction<ManageToBeConsumedMaterialDisassembleOnContainer2Params> {
    private readonly params = [new QComplexParam("command", new QManageToBeConsumedMaterialDisassembleOnContainer())];

    constructor() {
        super("ManageToBeConsumedMaterialDisassembleOnContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageToBeConsumedMaterialDisassembleOnContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkWorkInstructionsFromWOOperation2 extends QAction<UnlinkWorkInstructionsFromWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkWorkInstructionsFromWOOperation())];

    constructor() {
        super("UnlinkWorkInstructionsFromWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkWorkInstructionsFromWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetLocationHold2 extends QAction<SetLocationHold2Params> {
    private readonly params = [new QComplexParam("command", new QSetLocationHold())];

    constructor() {
        super("SetLocationHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetLocationHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToolSpecificationToOperation2 extends QAction<LinkToolSpecificationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToolSpecificationToOperation())];

    constructor() {
        super("LinkToolSpecificationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToolSpecificationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveCertificationToSkillList2 extends QAction<RemoveCertificationToSkillList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveCertificationToSkillList())];

    constructor() {
        super("RemoveCertificationToSkillList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveCertificationToSkillListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialItemToBuffer2 extends QAction<LinkMaterialItemToBuffer2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialItemToBuffer())];

    constructor() {
        super("LinkMaterialItemToBuffer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialItemToBufferResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetOfflineWorkInstructionDefinitions2 extends QAction<GetOfflineWorkInstructionDefinitions2Params> {
    private readonly params = [new QComplexParam("command", new QGetOfflineWorkInstructionDefinitions())];

    constructor() {
        super("GetOfflineWorkInstructionDefinitions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetOfflineWorkInstructionDefinitionsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateProcess2 extends QAction<UADMCreateProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateProcess())];

    constructor() {
        super("UADMCreateProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStatus2 extends QAction<UpdateStatus2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStatus())];

    constructor() {
        super("UpdateStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageNullResultOnKoWOOperationList2 extends QAction<ManageNullResultOnKoWOOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QManageNullResultOnKoWOOperationList())];

    constructor() {
        super("ManageNullResultOnKoWOOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageNullResultOnKoWOOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDNCItemMachineMaterialAssociation2 extends QAction<CreateDNCItemMachineMaterialAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDNCItemMachineMaterialAssociation())];

    constructor() {
        super("CreateDNCItemMachineMaterialAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDNCItemMachineMaterialAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGenerateMaterialBatchId2 extends QAction<GenerateMaterialBatchId2Params> {
    private readonly params = [new QComplexParam("command", new QGenerateMaterialBatchId())];

    constructor() {
        super("GenerateMaterialBatchId", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGenerateMaterialBatchIdResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteHierarchyEquipmentNodeConfiguration2 extends QAction<DeleteHierarchyEquipmentNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteHierarchyEquipmentNodeConfiguration())];

    constructor() {
        super("DeleteHierarchyEquipmentNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteHierarchyEquipmentNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWorkInstructionDefinitionListToOperation2 extends QAction<LinkWorkInstructionDefinitionListToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWorkInstructionDefinitionListToOperation())];

    constructor() {
        super("LinkWorkInstructionDefinitionListToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWorkInstructionDefinitionListToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonConformanceHistory2 extends QAction<UpdateNonConformanceHistory2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonConformanceHistory())];

    constructor() {
        super("UpdateNonConformanceHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonConformanceHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurationStateMachine2 extends QAction<DeleteEquipmentConfigurationStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurationStateMachine())];

    constructor() {
        super("DeleteEquipmentConfigurationStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateStepList2 extends QAction<TCM2CreateStepList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateStepList())];

    constructor() {
        super("TCM2CreateStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteActualConsumedMaterial2 extends QAction<DeleteActualConsumedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteActualConsumedMaterial())];

    constructor() {
        super("DeleteActualConsumedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteActualConsumedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceResource2 extends QAction<DeleteNonConformanceResource2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceResource())];

    constructor() {
        super("DeleteNonConformanceResource", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceResourceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSentencingChangeNonConformance2 extends QAction<SentencingChangeNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QSentencingChangeNonConformance())];

    constructor() {
        super("SentencingChangeNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSentencingChangeNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOperationTypeList2 extends QAction<DeleteWorkOperationTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOperationTypeList())];

    constructor() {
        super("DeleteWorkOperationTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOperationTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialGroup2 extends QAction<CreateMaterialGroup2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialGroup())];

    constructor() {
        super("CreateMaterialGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInDataCollection2 extends QAction<CheckInDataCollection2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInDataCollection())];

    constructor() {
        super("CheckInDataCollection", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInDataCollectionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeUsedTool2 extends QAction<DeleteToBeUsedTool2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeUsedTool())];

    constructor() {
        super("DeleteToBeUsedTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeUsedToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceAttachmentList2 extends QAction<DeleteNonConformanceAttachmentList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceAttachmentList())];

    constructor() {
        super("DeleteNonConformanceAttachmentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceAttachmentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateSerialNumberList2 extends QAction<UpdateSerialNumberList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateSerialNumberList())];

    constructor() {
        super("UpdateSerialNumberList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateSerialNumberListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDefectType2 extends QAction<UpdateDefectType2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDefectType())];

    constructor() {
        super("UpdateDefectType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDefectTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGenerateSerialNumberCode2 extends QAction<GenerateSerialNumberCode2Params> {
    private readonly params = [new QComplexParam("command", new QGenerateSerialNumberCode())];

    constructor() {
        super("GenerateSerialNumberCode", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGenerateSerialNumberCodeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignCertificationToMaterialList2 extends QAction<AssignCertificationToMaterialList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignCertificationToMaterialList())];

    constructor() {
        super("AssignCertificationToMaterialList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignCertificationToMaterialListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDM_Material2 extends QAction<CreateDM_Material2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDM_Material())];

    constructor() {
        super("CreateDM_Material", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDM_MaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDefectGroup2 extends QAction<UpdateDefectGroup2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDefectGroup())];

    constructor() {
        super("UpdateDefectGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDefectGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateHold2 extends QAction<UpdateHold2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateHold())];

    constructor() {
        super("UpdateHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteProcessNotificationList2 extends QAction<DeleteProcessNotificationList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteProcessNotificationList())];

    constructor() {
        super("DeleteProcessNotificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteProcessNotificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTriggerPrintingOnWorkOrderStep2 extends QAction<TriggerPrintingOnWorkOrderStep2Params> {
    private readonly params = [new QComplexParam("command", new QTriggerPrintingOnWorkOrderStep())];

    constructor() {
        super("TriggerPrintingOnWorkOrderStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTriggerPrintingOnWorkOrderStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMDeleteEquipmentSpecificationList2 extends QAction<UADMDeleteEquipmentSpecificationList2Params> {
    private readonly params = [new QComplexParam("command", new QUADMDeleteEquipmentSpecificationList())];

    constructor() {
        super("UADMDeleteEquipmentSpecificationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMDeleteEquipmentSpecificationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateProducedMaterialUnderRework2 extends QAction<CreateProducedMaterialUnderRework2Params> {
    private readonly params = [new QComplexParam("command", new QCreateProducedMaterialUnderRework())];

    constructor() {
        super("CreateProducedMaterialUnderRework", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateProducedMaterialUnderReworkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkInstructionDefinition2 extends QAction<UpdateWorkInstructionDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkInstructionDefinition())];

    constructor() {
        super("UpdateWorkInstructionDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkInstructionDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialToContainerList2 extends QAction<LinkMaterialToContainerList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialToContainerList())];

    constructor() {
        super("LinkMaterialToContainerList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialToContainerListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateUoMFactor2 extends QAction<UpdateUoMFactor2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateUoMFactor())];

    constructor() {
        super("UpdateUoMFactor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateUoMFactorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnVerifyWorkOrder2 extends QAction<UnVerifyWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QUnVerifyWorkOrder())];

    constructor() {
        super("UnVerifyWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnVerifyWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartWOOperationTransferBatch2 extends QAction<StartWOOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QStartWOOperationTransferBatch())];

    constructor() {
        super("StartWOOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartWOOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentConfigurationByDefaultEquipmentType2 extends QAction<CreateEquipmentConfigurationByDefaultEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentConfigurationByDefaultEquipmentType())];

    constructor() {
        super("CreateEquipmentConfigurationByDefaultEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentConfigurationByDefaultEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkUsersToTeam2 extends QAction<LinkUsersToTeam2Params> {
    private readonly params = [new QComplexParam("command", new QLinkUsersToTeam())];

    constructor() {
        super("LinkUsersToTeam", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkUsersToTeamResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBuffer2 extends QAction<CreateBuffer2Params> {
    private readonly params = [new QComplexParam("command", new QCreateBuffer())];

    constructor() {
        super("CreateBuffer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBufferResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToolDefinitionToAutomationNodeTypeList2 extends QAction<UnlinkToolDefinitionToAutomationNodeTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToolDefinitionToAutomationNodeTypeList())];

    constructor() {
        super("UnlinkToolDefinitionToAutomationNodeTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToolDefinitionToAutomationNodeTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphType2 extends QAction<CreateEquipmentGraphType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphType())];

    constructor() {
        super("CreateEquipmentGraphType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSaveDocumentForPreview2 extends QAction<SaveDocumentForPreview2Params> {
    private readonly params = [new QComplexParam("command", new QSaveDocumentForPreview())];

    constructor() {
        super("SaveDocumentForPreview", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSaveDocumentForPreviewResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateVisualCharacteristicSpecification2 extends QAction<CreateVisualCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateVisualCharacteristicSpecification())];

    constructor() {
        super("CreateVisualCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateVisualCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSentenceBuyOff2 extends QAction<SentenceBuyOff2Params> {
    private readonly params = [new QComplexParam("command", new QSentenceBuyOff())];

    constructor() {
        super("SentenceBuyOff", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSentenceBuyOffResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateOfflineSession2 extends QAction<CreateOfflineSession2Params> {
    private readonly params = [new QComplexParam("command", new QCreateOfflineSession())];

    constructor() {
        super("CreateOfflineSession", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateOfflineSessionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStepRevisionSubStructure2 extends QAction<CreateStepRevisionSubStructure2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStepRevisionSubStructure())];

    constructor() {
        super("CreateStepRevisionSubStructure", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStepRevisionSubStructureResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSkipWOOperationTransferBatch2 extends QAction<SkipWOOperationTransferBatch2Params> {
    private readonly params = [new QComplexParam("command", new QSkipWOOperationTransferBatch())];

    constructor() {
        super("SkipWOOperationTransferBatch", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSkipWOOperationTransferBatchResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateContainerType2 extends QAction<UpdateContainerType2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateContainerType())];

    constructor() {
        super("UpdateContainerType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateContainerTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateAttributiveCharacteristicSpecification2 extends QAction<CreateAttributiveCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateAttributiveCharacteristicSpecification())];

    constructor() {
        super("CreateAttributiveCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateAttributiveCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetPJFsHookOnLinkActualUsedMachinePJF2 extends QAction<GetPJFsHookOnLinkActualUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QGetPJFsHookOnLinkActualUsedMachinePJF())];

    constructor() {
        super("GetPJFsHookOnLinkActualUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetPJFsHookOnLinkActualUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentType2 extends QAction<DeleteEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentType())];

    constructor() {
        super("DeleteEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateMaterialAndDM_Material2 extends QAction<UpdateMaterialAndDM_Material2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateMaterialAndDM_Material())];

    constructor() {
        super("UpdateMaterialAndDM_Material", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateMaterialAndDM_MaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkBufferDefinitionToMaterialDefList2 extends QAction<LinkBufferDefinitionToMaterialDefList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkBufferDefinitionToMaterialDefList())];

    constructor() {
        super("LinkBufferDefinitionToMaterialDefList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkBufferDefinitionToMaterialDefListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkBufferDefinitionToToolDefList2 extends QAction<LinkBufferDefinitionToToolDefList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkBufferDefinitionToToolDefList())];

    constructor() {
        super("LinkBufferDefinitionToToolDefList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkBufferDefinitionToToolDefListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2LinkProcessToOperationFullList2 extends QAction<TCM2LinkProcessToOperationFullList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2LinkProcessToOperationFullList())];

    constructor() {
        super("TCM2LinkProcessToOperationFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2LinkProcessToOperationFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateHandlingUnitHistory2 extends QAction<CreateHandlingUnitHistory2Params> {
    private readonly params = [new QComplexParam("command", new QCreateHandlingUnitHistory())];

    constructor() {
        super("CreateHandlingUnitHistory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateHandlingUnitHistoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToBeUsedMachineToPJF2 extends QAction<UnlinkToBeUsedMachineToPJF2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToBeUsedMachineToPJF())];

    constructor() {
        super("UnlinkToBeUsedMachineToPJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToBeUsedMachineToPJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonProductiveActivity2 extends QAction<CreateNonProductiveActivity2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonProductiveActivity())];

    constructor() {
        super("CreateNonProductiveActivity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonProductiveActivityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteCheckIn2 extends QAction<CompleteCheckIn2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteCheckIn())];

    constructor() {
        super("CompleteCheckIn", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteCheckInResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateOperationStepCategory2 extends QAction<UpdateOperationStepCategory2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateOperationStepCategory())];

    constructor() {
        super("UpdateOperationStepCategory", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateOperationStepCategoryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkWIDefinitionsToEGPhase2 extends QAction<LinkWIDefinitionsToEGPhase2Params> {
    private readonly params = [new QComplexParam("command", new QLinkWIDefinitionsToEGPhase())];

    constructor() {
        super("LinkWIDefinitionsToEGPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkWIDefinitionsToEGPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateCharacteristicSpecification2 extends QAction<UpdateCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateCharacteristicSpecification())];

    constructor() {
        super("UpdateCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetWIParameterValues2 extends QAction<GetWIParameterValues2Params> {
    private readonly params = [new QComplexParam("command", new QGetWIParameterValues())];

    constructor() {
        super("GetWIParameterValues", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetWIParameterValuesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetOperationStepCategoryProcessDefinitionActiveStatus2 extends QAction<SetOperationStepCategoryProcessDefinitionActiveStatus2Params> {
    private readonly params = [new QComplexParam("command", new QSetOperationStepCategoryProcessDefinitionActiveStatus())];

    constructor() {
        super("SetOperationStepCategoryProcessDefinitionActiveStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetOperationStepCategoryProcessDefinitionActiveStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeConsumedMaterials2 extends QAction<CreateToBeConsumedMaterials2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeConsumedMaterials())];

    constructor() {
        super("CreateToBeConsumedMaterials", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeConsumedMaterialsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteActualProducedMaterial2 extends QAction<DeleteActualProducedMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteActualProducedMaterial())];

    constructor() {
        super("DeleteActualProducedMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteActualProducedMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkProcessToAsPlannedBOP2 extends QAction<UnlinkProcessToAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkProcessToAsPlannedBOP())];

    constructor() {
        super("UnlinkProcessToAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkProcessToAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateOperation2 extends QAction<UADMCreateOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateOperation())];

    constructor() {
        super("UADMCreateOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSkillsFromWOOperation2 extends QAction<UnlinkSkillsFromWOOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSkillsFromWOOperation())];

    constructor() {
        super("UnlinkSkillsFromWOOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSkillsFromWOOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMachineToDNC2 extends QAction<DeleteMachineToDNC2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMachineToDNC())];

    constructor() {
        super("DeleteMachineToDNC", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMachineToDNCResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteResultsFromWOOperations2 extends QAction<DeleteResultsFromWOOperations2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteResultsFromWOOperations())];

    constructor() {
        super("DeleteResultsFromWOOperations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteResultsFromWOOperationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewProcessRevision2 extends QAction<CreateNewProcessRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewProcessRevision())];

    constructor() {
        super("CreateNewProcessRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewProcessRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckIdTemplateEditing2 extends QAction<CheckIdTemplateEditing2Params> {
    private readonly params = [new QComplexParam("command", new QCheckIdTemplateEditing())];

    constructor() {
        super("CheckIdTemplateEditing", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckIdTemplateEditingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CompleteAsPlannedBOP2 extends QAction<TCM2CompleteAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CompleteAsPlannedBOP())];

    constructor() {
        super("TCM2CompleteAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CompleteAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCharacteristicSpecification2 extends QAction<CreateCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCharacteristicSpecification())];

    constructor() {
        super("CreateCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConfirmWorkOrderOperation2 extends QAction<ConfirmWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QConfirmWorkOrderOperation())];

    constructor() {
        super("ConfirmWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConfirmWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypeStateMachine2 extends QAction<DeleteEquipmentTypeStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypeStateMachine())];

    constructor() {
        super("DeleteEquipmentTypeStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypeStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateBufferDefinitionRevision2 extends QAction<CreateBufferDefinitionRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateBufferDefinitionRevision())];

    constructor() {
        super("CreateBufferDefinitionRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateBufferDefinitionRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDNCPreviewDNCItem2 extends QAction<DNCPreviewDNCItem2Params> {
    private readonly params = [new QComplexParam("command", new QDNCPreviewDNCItem())];

    constructor() {
        super("DNCPreviewDNCItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDNCPreviewDNCItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QReopenWorkOrderOperationList2 extends QAction<ReopenWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QReopenWorkOrderOperationList())];

    constructor() {
        super("ReopenWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QReopenWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageNullResultOnKoWorkOrderOperation2 extends QAction<ManageNullResultOnKoWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QManageNullResultOnKoWorkOrderOperation())];

    constructor() {
        super("ManageNullResultOnKoWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageNullResultOnKoWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QExecuteCustomItlkCheckInbound2 extends QAction<ExecuteCustomItlkCheckInbound2Params> {
    private readonly params = [new QComplexParam("command", new QExecuteCustomItlkCheckInbound())];

    constructor() {
        super("ExecuteCustomItlkCheckInbound", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QExecuteCustomItlkCheckInboundResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkProcessToProcess2 extends QAction<UnlinkProcessToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkProcessToProcess())];

    constructor() {
        super("UnlinkProcessToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkProcessToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkMaterialItemFromBuffer2 extends QAction<UnLinkMaterialItemFromBuffer2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkMaterialItemFromBuffer())];

    constructor() {
        super("UnLinkMaterialItemFromBuffer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkMaterialItemFromBufferResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkItlkCheckToWorkOrderStepList2 extends QAction<LinkItlkCheckToWorkOrderStepList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkItlkCheckToWorkOrderStepList())];

    constructor() {
        super("LinkItlkCheckToWorkOrderStepList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkItlkCheckToWorkOrderStepListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSkillsToStep2 extends QAction<LinkSkillsToStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSkillsToStep())];

    constructor() {
        super("LinkSkillsToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSkillsToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAmendOfflineAction2 extends QAction<AmendOfflineAction2Params> {
    private readonly params = [new QComplexParam("command", new QAmendOfflineAction())];

    constructor() {
        super("AmendOfflineAction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAmendOfflineActionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentType2 extends QAction<UpdateEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentType())];

    constructor() {
        super("UpdateEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2LinkProcessToProcessFullList2 extends QAction<TCM2LinkProcessToProcessFullList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2LinkProcessToProcessFullList())];

    constructor() {
        super("TCM2LinkProcessToProcessFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2LinkProcessToProcessFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateNonProductiveActivity2 extends QAction<UpdateNonProductiveActivity2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateNonProductiveActivity())];

    constructor() {
        super("UpdateNonProductiveActivity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateNonProductiveActivityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkAutomationNodeInstanceParameterToToolDefinitionParameterList2 extends QAction<LinkAutomationNodeInstanceParameterToToolDefinitionParameterList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkAutomationNodeInstanceParameterToToolDefinitionParameterList())];

    constructor() {
        super("LinkAutomationNodeInstanceParameterToToolDefinitionParameterList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkAutomationNodeInstanceParameterToToolDefinitionParameterListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToolDefinitionToAutomationNodeTypeList2 extends QAction<LinkToolDefinitionToAutomationNodeTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToolDefinitionToAutomationNodeTypeList())];

    constructor() {
        super("LinkToolDefinitionToAutomationNodeTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToolDefinitionToAutomationNodeTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMaterialDefinitionDocumentList2 extends QAction<CreateMaterialDefinitionDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMaterialDefinitionDocumentList())];

    constructor() {
        super("CreateMaterialDefinitionDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMaterialDefinitionDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkItlkCheckToWorkOrderOperationList2 extends QAction<UnlinkItlkCheckToWorkOrderOperationList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkItlkCheckToWorkOrderOperationList())];

    constructor() {
        super("UnlinkItlkCheckToWorkOrderOperationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkItlkCheckToWorkOrderOperationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkInstructionTemplateAsDefault2 extends QAction<SetWorkInstructionTemplateAsDefault2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkInstructionTemplateAsDefault())];

    constructor() {
        super("SetWorkInstructionTemplateAsDefault", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkInstructionTemplateAsDefaultResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetNonConformanceStatusIsClosedOk2 extends QAction<SetNonConformanceStatusIsClosedOk2Params> {
    private readonly params = [new QComplexParam("command", new QSetNonConformanceStatusIsClosedOk())];

    constructor() {
        super("SetNonConformanceStatusIsClosedOk", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetNonConformanceStatusIsClosedOkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToolToSetPoint2 extends QAction<UnlinkToolToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToolToSetPoint())];

    constructor() {
        super("UnlinkToolToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToolToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveDefectGroupContextualization2 extends QAction<RemoveDefectGroupContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveDefectGroupContextualization())];

    constructor() {
        super("RemoveDefectGroupContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveDefectGroupContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageResultsForSkippedOperations2 extends QAction<ManageResultsForSkippedOperations2Params> {
    private readonly params = [new QComplexParam("command", new QManageResultsForSkippedOperations())];

    constructor() {
        super("ManageResultsForSkippedOperations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageResultsForSkippedOperationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageRepeatOfKoWorkOrderOperation2 extends QAction<ManageRepeatOfKoWorkOrderOperation2Params> {
    private readonly params = [new QComplexParam("command", new QManageRepeatOfKoWorkOrderOperation())];

    constructor() {
        super("ManageRepeatOfKoWorkOrderOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageRepeatOfKoWorkOrderOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QConsumeMaterialItemLite2 extends QAction<ConsumeMaterialItemLite2Params> {
    private readonly params = [new QComplexParam("command", new QConsumeMaterialItemLite())];

    constructor() {
        super("ConsumeMaterialItemLite", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QConsumeMaterialItemLiteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCertification2 extends QAction<CreateCertification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCertification())];

    constructor() {
        super("CreateCertification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCertificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckCertification2 extends QAction<CheckCertification2Params> {
    private readonly params = [new QComplexParam("command", new QCheckCertification())];

    constructor() {
        super("CheckCertification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckCertificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateTransportOperation2 extends QAction<CreateTransportOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateTransportOperation())];

    constructor() {
        super("CreateTransportOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateTransportOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateToolDefinition2 extends QAction<UpdateToolDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateToolDefinition())];

    constructor() {
        super("UpdateToolDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateToolDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderStepFromMPProcessStep2 extends QAction<CreateWorkOrderStepFromMPProcessStep2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderStepFromMPProcessStep())];

    constructor() {
        super("CreateWorkOrderStepFromMPProcessStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderStepFromMPProcessStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QManageResultWorkOrderOperationNIdForSplitWorkOrder2 extends QAction<ManageResultWorkOrderOperationNIdForSplitWorkOrder2Params> {
    private readonly params = [new QComplexParam("command", new QManageResultWorkOrderOperationNIdForSplitWorkOrder())];

    constructor() {
        super("ManageResultWorkOrderOperationNIdForSplitWorkOrder", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QManageResultWorkOrderOperationNIdForSplitWorkOrderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAmendOfResultToRepeatMaterialConsumption2 extends QAction<AmendOfResultToRepeatMaterialConsumption2Params> {
    private readonly params = [new QComplexParam("command", new QAmendOfResultToRepeatMaterialConsumption())];

    constructor() {
        super("AmendOfResultToRepeatMaterialConsumption", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAmendOfResultToRepeatMaterialConsumptionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkWorkInstructionDefinitionListFromOperation2 extends QAction<UnlinkWorkInstructionDefinitionListFromOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkWorkInstructionDefinitionListFromOperation())];

    constructor() {
        super("UnlinkWorkInstructionDefinitionListFromOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkWorkInstructionDefinitionListFromOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToolSpecification2 extends QAction<CreateToolSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToolSpecification())];

    constructor() {
        super("CreateToolSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToolSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteToBeUsedDocument2 extends QAction<DeleteToBeUsedDocument2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteToBeUsedDocument())];

    constructor() {
        super("DeleteToBeUsedDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteToBeUsedDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveCertificationToLocationList2 extends QAction<RemoveCertificationToLocationList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveCertificationToLocationList())];

    constructor() {
        super("RemoveCertificationToLocationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveCertificationToLocationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateExecutionGroupPhase2 extends QAction<CreateExecutionGroupPhase2Params> {
    private readonly params = [new QComplexParam("command", new QCreateExecutionGroupPhase())];

    constructor() {
        super("CreateExecutionGroupPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateExecutionGroupPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkATNTypeParameterFromToolDefinitionSetPointItemList2 extends QAction<UnlinkATNTypeParameterFromToolDefinitionSetPointItemList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkATNTypeParameterFromToolDefinitionSetPointItemList())];

    constructor() {
        super("UnlinkATNTypeParameterFromToolDefinitionSetPointItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkATNTypeParameterFromToolDefinitionSetPointItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit2 extends QAction<UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit())];

    constructor() {
        super("UpdateMaterialTrackingUnitAndDM_MaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateMaterialTrackingUnitAndDM_MaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToolSpecificationToOperation2 extends QAction<UnlinkToolSpecificationToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToolSpecificationToOperation())];

    constructor() {
        super("UnlinkToolSpecificationToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToolSpecificationToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToBeUsedMachineToPJFFromLogicalKey2 extends QAction<UnlinkToBeUsedMachineToPJFFromLogicalKey2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToBeUsedMachineToPJFFromLogicalKey())];

    constructor() {
        super("UnlinkToBeUsedMachineToPJFFromLogicalKey", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToBeUsedMachineToPJFFromLogicalKeyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPunchOutUsers2 extends QAction<PunchOutUsers2Params> {
    private readonly params = [new QComplexParam("command", new QPunchOutUsers())];

    constructor() {
        super("PunchOutUsers", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPunchOutUsersResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetWorkOrderOperationEstimatedTimes2 extends QAction<SetWorkOrderOperationEstimatedTimes2Params> {
    private readonly params = [new QComplexParam("command", new QSetWorkOrderOperationEstimatedTimes())];

    constructor() {
        super("SetWorkOrderOperationEstimatedTimes", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetWorkOrderOperationEstimatedTimesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeletePrintJobFileList2 extends QAction<DeletePrintJobFileList2Params> {
    private readonly params = [new QComplexParam("command", new QDeletePrintJobFileList())];

    constructor() {
        super("DeletePrintJobFileList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeletePrintJobFileListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteContainerTypeList2 extends QAction<DeleteContainerTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteContainerTypeList())];

    constructor() {
        super("DeleteContainerTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteContainerTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkActualUsedMachineToPJF2 extends QAction<LinkActualUsedMachineToPJF2Params> {
    private readonly params = [new QComplexParam("command", new QLinkActualUsedMachineToPJF())];

    constructor() {
        super("LinkActualUsedMachineToPJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkActualUsedMachineToPJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGetValidMachinesWOOpIds2 extends QAction<GetValidMachinesWOOpIds2Params> {
    private readonly params = [new QComplexParam("command", new QGetValidMachinesWOOpIds())];

    constructor() {
        super("GetValidMachinesWOOpIds", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGetValidMachinesWOOpIdsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSelectMTUForPartBasedInspection2 extends QAction<SelectMTUForPartBasedInspection2Params> {
    private readonly params = [new QComplexParam("command", new QSelectMTUForPartBasedInspection())];

    constructor() {
        super("SelectMTUForPartBasedInspection", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSelectMTUForPartBasedInspectionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceItem2 extends QAction<CreateNonConformanceItem2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceItem())];

    constructor() {
        super("CreateNonConformanceItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceResource2 extends QAction<CreateNonConformanceResource2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceResource())];

    constructor() {
        super("CreateNonConformanceResource", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceResourceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QEditMaterialItemsLinkedToHandlingUnit2 extends QAction<EditMaterialItemsLinkedToHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QEditMaterialItemsLinkedToHandlingUnit())];

    constructor() {
        super("EditMaterialItemsLinkedToHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QEditMaterialItemsLinkedToHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDefectGroupContextualization2 extends QAction<CreateDefectGroupContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDefectGroupContextualization())];

    constructor() {
        super("CreateDefectGroupContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDefectGroupContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkATNTypeParameterToToolDefinitionSetPointItemList2 extends QAction<LinkATNTypeParameterToToolDefinitionSetPointItemList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkATNTypeParameterToToolDefinitionSetPointItemList())];

    constructor() {
        super("LinkATNTypeParameterToToolDefinitionSetPointItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkATNTypeParameterToToolDefinitionSetPointItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToolToAutomationNodeInstanceList2 extends QAction<UnlinkToolToAutomationNodeInstanceList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToolToAutomationNodeInstanceList())];

    constructor() {
        super("UnlinkToolToAutomationNodeInstanceList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToolToAutomationNodeInstanceListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateProcessRevisionSubStructure2 extends QAction<CreateProcessRevisionSubStructure2Params> {
    private readonly params = [new QComplexParam("command", new QCreateProcessRevisionSubStructure())];

    constructor() {
        super("CreateProcessRevisionSubStructure", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateProcessRevisionSubStructureResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderOperations2 extends QAction<CreateWorkOrderOperations2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderOperations())];

    constructor() {
        super("CreateWorkOrderOperations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderOperationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCustomItlkCheckList2 extends QAction<CreateCustomItlkCheckList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCustomItlkCheckList())];

    constructor() {
        super("CreateCustomItlkCheckList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCustomItlkCheckListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkPJFToMaterialDefinition2 extends QAction<UnlinkPJFToMaterialDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkPJFToMaterialDefinition())];

    constructor() {
        super("UnlinkPJFToMaterialDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkPJFToMaterialDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkItlkCheckToOperationToStepLinkList2 extends QAction<UnlinkItlkCheckToOperationToStepLinkList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkItlkCheckToOperationToStepLinkList())];

    constructor() {
        super("UnlinkItlkCheckToOperationToStepLinkList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkItlkCheckToOperationToStepLinkListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkMaterialTrackingUnitFromContainerList2 extends QAction<UnlinkMaterialTrackingUnitFromContainerList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkMaterialTrackingUnitFromContainerList())];

    constructor() {
        super("UnlinkMaterialTrackingUnitFromContainerList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkMaterialTrackingUnitFromContainerListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentTypePropertyAttribute2 extends QAction<UpdateEquipmentTypePropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentTypePropertyAttribute())];

    constructor() {
        super("UpdateEquipmentTypePropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentTypePropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetIsValid2 extends QAction<SetIsValid2Params> {
    private readonly params = [new QComplexParam("command", new QSetIsValid())];

    constructor() {
        super("SetIsValid", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetIsValidResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2DeleteLinkProcessToProcessList2 extends QAction<TCM2DeleteLinkProcessToProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2DeleteLinkProcessToProcessList())];

    constructor() {
        super("TCM2DeleteLinkProcessToProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2DeleteLinkProcessToProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkMaterialItemsFromHandlingUnit2 extends QAction<UnLinkMaterialItemsFromHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkMaterialItemsFromHandlingUnit())];

    constructor() {
        super("UnLinkMaterialItemsFromHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkMaterialItemsFromHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDM_MaterialTrackingUnitandMaterialTrackingUnit2 extends QAction<CreateDM_MaterialTrackingUnitandMaterialTrackingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDM_MaterialTrackingUnitandMaterialTrackingUnit())];

    constructor() {
        super("CreateDM_MaterialTrackingUnitandMaterialTrackingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDM_MaterialTrackingUnitandMaterialTrackingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeSubstrateStatusByThresholds2 extends QAction<ChangeSubstrateStatusByThresholds2Params> {
    private readonly params = [new QComplexParam("command", new QChangeSubstrateStatusByThresholds())];

    constructor() {
        super("ChangeSubstrateStatusByThresholds", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeSubstrateStatusByThresholdsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialGroup2 extends QAction<DeleteMaterialGroup2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialGroup())];

    constructor() {
        super("DeleteMaterialGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUseToolListOnContainer2 extends QAction<UseToolListOnContainer2Params> {
    private readonly params = [new QComplexParam("command", new QUseToolListOnContainer())];

    constructor() {
        super("UseToolListOnContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUseToolListOnContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateProcessToOpLinkDependencyNavigationList2 extends QAction<CreateProcessToOpLinkDependencyNavigationList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateProcessToOpLinkDependencyNavigationList())];

    constructor() {
        super("CreateProcessToOpLinkDependencyNavigationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateProcessToOpLinkDependencyNavigationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeactivateMaterialTrackingUnitOnScrewingTool2 extends QAction<DeactivateMaterialTrackingUnitOnScrewingTool2Params> {
    private readonly params = [new QComplexParam("command", new QDeactivateMaterialTrackingUnitOnScrewingTool())];

    constructor() {
        super("DeactivateMaterialTrackingUnitOnScrewingTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeactivateMaterialTrackingUnitOnScrewingToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewOperationRevision2 extends QAction<CreateNewOperationRevision2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewOperationRevision())];

    constructor() {
        super("CreateNewOperationRevision", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewOperationRevisionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteWorkOrderStep2 extends QAction<DeleteWorkOrderStep2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteWorkOrderStep())];

    constructor() {
        super("DeleteWorkOrderStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteWorkOrderStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteExecutionGroups2 extends QAction<DeleteExecutionGroups2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteExecutionGroups())];

    constructor() {
        super("DeleteExecutionGroups", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteExecutionGroupsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveLocationHold2 extends QAction<RemoveLocationHold2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveLocationHold())];

    constructor() {
        super("RemoveLocationHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveLocationHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkProcessToProcessList2 extends QAction<UnlinkProcessToProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkProcessToProcessList())];

    constructor() {
        super("UnlinkProcessToProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkProcessToProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGroupConfiguration2 extends QAction<UpdateEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGroupConfiguration())];

    constructor() {
        super("UpdateEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkInstructionTemplate2 extends QAction<UpdateWorkInstructionTemplate2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkInstructionTemplate())];

    constructor() {
        super("UpdateWorkInstructionTemplate", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkInstructionTemplateResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateOperationInCatalogue2 extends QAction<UADMCreateOperationInCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateOperationInCatalogue())];

    constructor() {
        super("UADMCreateOperationInCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateOperationInCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkEquipmentsToBuffers2 extends QAction<UnLinkEquipmentsToBuffers2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkEquipmentsToBuffers())];

    constructor() {
        super("UnLinkEquipmentsToBuffers", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkEquipmentsToBuffersResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateSetPoint2 extends QAction<UpdateSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateSetPoint())];

    constructor() {
        super("UpdateSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateTool2 extends QAction<UpdateTool2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateTool())];

    constructor() {
        super("UpdateTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateStepInOperation2 extends QAction<CreateStepInOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateStepInOperation())];

    constructor() {
        super("CreateStepInOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateStepInOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSplitAndLinkMaterialItemsToHandlingUnit2 extends QAction<SplitAndLinkMaterialItemsToHandlingUnit2Params> {
    private readonly params = [new QComplexParam("command", new QSplitAndLinkMaterialItemsToHandlingUnit())];

    constructor() {
        super("SplitAndLinkMaterialItemsToHandlingUnit", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSplitAndLinkMaterialItemsToHandlingUnitResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkToBeUsedMachineToPJFForEGPhase2 extends QAction<LinkToBeUsedMachineToPJFForEGPhase2Params> {
    private readonly params = [new QComplexParam("command", new QLinkToBeUsedMachineToPJFForEGPhase())];

    constructor() {
        super("LinkToBeUsedMachineToPJFForEGPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkToBeUsedMachineToPJFForEGPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateLogisticRequest2 extends QAction<CreateLogisticRequest2Params> {
    private readonly params = [new QComplexParam("command", new QCreateLogisticRequest())];

    constructor() {
        super("CreateLogisticRequest", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateLogisticRequestResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkMaterialItemsToNonConformance2 extends QAction<LinkMaterialItemsToNonConformance2Params> {
    private readonly params = [new QComplexParam("command", new QLinkMaterialItemsToNonConformance())];

    constructor() {
        super("LinkMaterialItemsToNonConformance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkMaterialItemsToNonConformanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QPauseExecutionGroupPhase2 extends QAction<PauseExecutionGroupPhase2Params> {
    private readonly params = [new QComplexParam("command", new QPauseExecutionGroupPhase())];

    constructor() {
        super("PauseExecutionGroupPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QPauseExecutionGroupPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentTypeProperty2 extends QAction<UpdateEquipmentTypeProperty2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentTypeProperty())];

    constructor() {
        super("UpdateEquipmentTypeProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentTypePropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateUoMDimension2 extends QAction<CreateUoMDimension2Params> {
    private readonly params = [new QComplexParam("command", new QCreateUoMDimension())];

    constructor() {
        super("CreateUoMDimension", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateUoMDimensionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QStartTransportOperation2 extends QAction<StartTransportOperation2Params> {
    private readonly params = [new QComplexParam("command", new QStartTransportOperation())];

    constructor() {
        super("StartTransportOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QStartTransportOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWOOpQuantityAssociatedToEG2 extends QAction<UpdateWOOpQuantityAssociatedToEG2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWOOpQuantityAssociatedToEG())];

    constructor() {
        super("UpdateWOOpQuantityAssociatedToEG", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWOOpQuantityAssociatedToEGResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteExecutionGroupPhase2 extends QAction<CompleteExecutionGroupPhase2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteExecutionGroupPhase())];

    constructor() {
        super("CompleteExecutionGroupPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteExecutionGroupPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateBuffer2 extends QAction<UpdateBuffer2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateBuffer())];

    constructor() {
        super("UpdateBuffer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateBufferResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateStepDependency2 extends QAction<UpdateStepDependency2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateStepDependency())];

    constructor() {
        super("UpdateStepDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateStepDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAmendOfResultToRepeat2 extends QAction<AmendOfResultToRepeat2Params> {
    private readonly params = [new QComplexParam("command", new QAmendOfResultToRepeat())];

    constructor() {
        super("AmendOfResultToRepeat", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAmendOfResultToRepeatResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteAsPlannedBOP2 extends QAction<CompleteAsPlannedBOP2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteAsPlannedBOP())];

    constructor() {
        super("CompleteAsPlannedBOP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteAsPlannedBOPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTransmitEquipmentSetPointToAutomationNodeParameters2 extends QAction<TransmitEquipmentSetPointToAutomationNodeParameters2Params> {
    private readonly params = [new QComplexParam("command", new QTransmitEquipmentSetPointToAutomationNodeParameters())];

    constructor() {
        super("TransmitEquipmentSetPointToAutomationNodeParameters", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTransmitEquipmentSetPointToAutomationNodeParametersResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcquireDCItemValueFromAutomationNodeInstanceParameter2 extends QAction<AcquireDCItemValueFromAutomationNodeInstanceParameter2Params> {
    private readonly params = [new QComplexParam("command", new QAcquireDCItemValueFromAutomationNodeInstanceParameter())];

    constructor() {
        super("AcquireDCItemValueFromAutomationNodeInstanceParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcquireDCItemValueFromAutomationNodeInstanceParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateUoM2 extends QAction<UpdateUoM2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateUoM())];

    constructor() {
        super("UpdateUoM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateUoMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkItlkCheckToProcessToOpLinkList2 extends QAction<UnlinkItlkCheckToProcessToOpLinkList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkItlkCheckToProcessToOpLinkList())];

    constructor() {
        super("UnlinkItlkCheckToProcessToOpLinkList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkItlkCheckToProcessToOpLinkListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateAttributiveCharacteristicSpecification2 extends QAction<UpdateAttributiveCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateAttributiveCharacteristicSpecification())];

    constructor() {
        super("UpdateAttributiveCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateAttributiveCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateVisualCharacteristicSpecification2 extends QAction<UpdateVisualCharacteristicSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateVisualCharacteristicSpecification())];

    constructor() {
        super("UpdateVisualCharacteristicSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateVisualCharacteristicSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateMachineToDNC2 extends QAction<UpdateMachineToDNC2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateMachineToDNC())];

    constructor() {
        super("UpdateMachineToDNC", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateMachineToDNCResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGenerateSerialNumberCodes2 extends QAction<GenerateSerialNumberCodes2Params> {
    private readonly params = [new QComplexParam("command", new QGenerateSerialNumberCodes())];

    constructor() {
        super("GenerateSerialNumberCodes", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGenerateSerialNumberCodesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteActualUsedMachinePJF2 extends QAction<DeleteActualUsedMachinePJF2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteActualUsedMachinePJF())];

    constructor() {
        super("DeleteActualUsedMachinePJF", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteActualUsedMachinePJFResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInCompleteWOStepSerialized2 extends QAction<CheckInCompleteWOStepSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInCompleteWOStepSerialized())];

    constructor() {
        super("CheckInCompleteWOStepSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInCompleteWOStepSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeassociateDNCItemMachineMaterialsAssociation2 extends QAction<DeassociateDNCItemMachineMaterialsAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QDeassociateDNCItemMachineMaterialsAssociation())];

    constructor() {
        super("DeassociateDNCItemMachineMaterialsAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeassociateDNCItemMachineMaterialsAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderHistoryMaterialItem2 extends QAction<CreateWorkOrderHistoryMaterialItem2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderHistoryMaterialItem())];

    constructor() {
        super("CreateWorkOrderHistoryMaterialItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderHistoryMaterialItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkDocumentFromContainerTypeList2 extends QAction<UnlinkDocumentFromContainerTypeList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkDocumentFromContainerTypeList())];

    constructor() {
        super("UnlinkDocumentFromContainerTypeList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkDocumentFromContainerTypeListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocumentToOperation2 extends QAction<LinkDocumentToOperation2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocumentToOperation())];

    constructor() {
        super("LinkDocumentToOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentToOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialClassList2 extends QAction<DeleteMaterialClassList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialClassList())];

    constructor() {
        super("DeleteMaterialClassList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialClassListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkSubstrateToMachine2 extends QAction<LinkSubstrateToMachine2Params> {
    private readonly params = [new QComplexParam("command", new QLinkSubstrateToMachine())];

    constructor() {
        super("LinkSubstrateToMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkSubstrateToMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkSkillsToStep2 extends QAction<UnlinkSkillsToStep2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkSkillsToStep())];

    constructor() {
        super("UnlinkSkillsToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkSkillsToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMUpdateToolSpecification2 extends QAction<UADMUpdateToolSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUADMUpdateToolSpecification())];

    constructor() {
        super("UADMUpdateToolSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMUpdateToolSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderHeader2 extends QAction<CreateWorkOrderHeader2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderHeader())];

    constructor() {
        super("CreateWorkOrderHeader", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderHeaderResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphNodeConfiguration2 extends QAction<DeleteEquipmentGraphNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphNodeConfiguration())];

    constructor() {
        super("DeleteEquipmentGraphNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMAutomaticStart2 extends QAction<UADMAutomaticStart2Params> {
    private readonly params = [new QComplexParam("command", new QUADMAutomaticStart())];

    constructor() {
        super("UADMAutomaticStart", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMAutomaticStartResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNewStepRevisionInOperation2 extends QAction<CreateNewStepRevisionInOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNewStepRevisionInOperation())];

    constructor() {
        super("CreateNewStepRevisionInOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNewStepRevisionInOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateNonConformanceTransition2 extends QAction<CreateNonConformanceTransition2Params> {
    private readonly params = [new QComplexParam("command", new QCreateNonConformanceTransition())];

    constructor() {
        super("CreateNonConformanceTransition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateNonConformanceTransitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkOOperationDependency2 extends QAction<UpdateWorkOOperationDependency2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkOOperationDependency())];

    constructor() {
        super("UpdateWorkOOperationDependency", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkOOperationDependencyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOOperationFullQty2 extends QAction<CompleteWOOperationFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOOperationFullQty())];

    constructor() {
        super("CompleteWOOperationFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOOperationFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOStepSerialized2 extends QAction<CompleteWOStepSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOStepSerialized())];

    constructor() {
        super("CompleteWOStepSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOStepSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAcceptChangeRemoveOperation2 extends QAction<AcceptChangeRemoveOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAcceptChangeRemoveOperation())];

    constructor() {
        super("AcceptChangeRemoveOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAcceptChangeRemoveOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOOperationsSerializedLite2 extends QAction<CompleteWOOperationsSerializedLite2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOOperationsSerializedLite())];

    constructor() {
        super("CompleteWOOperationsSerializedLite", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOOperationsSerializedLiteResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkAMMachineToMES2 extends QAction<LinkAMMachineToMES2Params> {
    private readonly params = [new QComplexParam("command", new QLinkAMMachineToMES())];

    constructor() {
        super("LinkAMMachineToMES", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkAMMachineToMESResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDNCTransferDNCItem2 extends QAction<DNCTransferDNCItem2Params> {
    private readonly params = [new QComplexParam("command", new QDNCTransferDNCItem())];

    constructor() {
        super("DNCTransferDNCItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDNCTransferDNCItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateDocumentList2 extends QAction<TCM2CreateDocumentList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateDocumentList())];

    constructor() {
        super("TCM2CreateDocumentList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateDocumentListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateDefect2 extends QAction<UpdateDefect2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateDefect())];

    constructor() {
        super("UpdateDefect", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateDefectResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveNonConformanceTransitionRoleList2 extends QAction<RemoveNonConformanceTransitionRoleList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveNonConformanceTransitionRoleList())];

    constructor() {
        super("RemoveNonConformanceTransitionRoleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveNonConformanceTransitionRoleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteStatusDefinition2 extends QAction<DeleteStatusDefinition2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteStatusDefinition())];

    constructor() {
        super("DeleteStatusDefinition", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteStatusDefinitionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkOperationStepCategoryFromProcessDefinitionList2 extends QAction<UnlinkOperationStepCategoryFromProcessDefinitionList2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkOperationStepCategoryFromProcessDefinitionList())];

    constructor() {
        super("UnlinkOperationStepCategoryFromProcessDefinitionList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkOperationStepCategoryFromProcessDefinitionListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateItlkCheckWOStepAssociationList2 extends QAction<UpdateItlkCheckWOStepAssociationList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateItlkCheckWOStepAssociationList())];

    constructor() {
        super("UpdateItlkCheckWOStepAssociationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateItlkCheckWOStepAssociationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateProcessNotification2 extends QAction<CreateProcessNotification2Params> {
    private readonly params = [new QComplexParam("command", new QCreateProcessNotification())];

    constructor() {
        super("CreateProcessNotification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateProcessNotificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateFutureHold2 extends QAction<CreateFutureHold2Params> {
    private readonly params = [new QComplexParam("command", new QCreateFutureHold())];

    constructor() {
        super("CreateFutureHold", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateFutureHoldResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphLinkConfiguration2 extends QAction<CreateEquipmentGraphLinkConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphLinkConfiguration())];

    constructor() {
        super("CreateEquipmentGraphLinkConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphLinkConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteProcessList2 extends QAction<DeleteProcessList2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteProcessList())];

    constructor() {
        super("DeleteProcessList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteProcessListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateActualUsedTool2 extends QAction<UpdateActualUsedTool2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateActualUsedTool())];

    constructor() {
        super("UpdateActualUsedTool", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateActualUsedToolResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteOperationFromCatalogue2 extends QAction<DeleteOperationFromCatalogue2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteOperationFromCatalogue())];

    constructor() {
        super("DeleteOperationFromCatalogue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteOperationFromCatalogueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCompleteWOOperationSerialized2 extends QAction<CompleteWOOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QCompleteWOOperationSerialized())];

    constructor() {
        super("CompleteWOOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCompleteWOOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateItlkCheckOperationStepCategoryAssociationList2 extends QAction<UpdateItlkCheckOperationStepCategoryAssociationList2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateItlkCheckOperationStepCategoryAssociationList())];

    constructor() {
        super("UpdateItlkCheckOperationStepCategoryAssociationList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateItlkCheckOperationStepCategoryAssociationListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteTemplateBlock2 extends QAction<DeleteTemplateBlock2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteTemplateBlock())];

    constructor() {
        super("DeleteTemplateBlock", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteTemplateBlockResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetExecGroupListInEditStatus2 extends QAction<SetExecGroupListInEditStatus2Params> {
    private readonly params = [new QComplexParam("command", new QSetExecGroupListInEditStatus())];

    constructor() {
        super("SetExecGroupListInEditStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetExecGroupListInEditStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteMaterialDefinitionDocument2 extends QAction<DeleteMaterialDefinitionDocument2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteMaterialDefinitionDocument())];

    constructor() {
        super("DeleteMaterialDefinitionDocument", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteMaterialDefinitionDocumentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnLinkToBeUsedMachineToPJFForEGPhase2 extends QAction<UnLinkToBeUsedMachineToPJFForEGPhase2Params> {
    private readonly params = [new QComplexParam("command", new QUnLinkToBeUsedMachineToPJFForEGPhase())];

    constructor() {
        super("UnLinkToBeUsedMachineToPJFForEGPhase", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnLinkToBeUsedMachineToPJFForEGPhaseResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkInstructionDefinitionParameter2 extends QAction<UpdateWorkInstructionDefinitionParameter2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkInstructionDefinitionParameter())];

    constructor() {
        super("UpdateWorkInstructionDefinitionParameter", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkInstructionDefinitionParameterResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2LinkOperationToStepFullList2 extends QAction<TCM2LinkOperationToStepFullList2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2LinkOperationToStepFullList())];

    constructor() {
        super("TCM2LinkOperationToStepFullList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2LinkOperationToStepFullListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QTCM2CreateMasterPlan2 extends QAction<TCM2CreateMasterPlan2Params> {
    private readonly params = [new QComplexParam("command", new QTCM2CreateMasterPlan())];

    constructor() {
        super("TCM2CreateMasterPlan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QTCM2CreateMasterPlanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWorkOrderOperationFromMPProcessOperation2 extends QAction<CreateWorkOrderOperationFromMPProcessOperation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWorkOrderOperationFromMPProcessOperation())];

    constructor() {
        super("CreateWorkOrderOperationFromMPProcessOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWorkOrderOperationFromMPProcessOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInStartWOStepSerialized2 extends QAction<CheckInStartWOStepSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInStartWOStepSerialized())];

    constructor() {
        super("CheckInStartWOStepSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInStartWOStepSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUADMCreateMaterialSpecification2 extends QAction<UADMCreateMaterialSpecification2Params> {
    private readonly params = [new QComplexParam("command", new QUADMCreateMaterialSpecification())];

    constructor() {
        super("UADMCreateMaterialSpecification", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUADMCreateMaterialSpecificationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateWOOpDependencyNavigationMTUAssociation2 extends QAction<CreateWOOpDependencyNavigationMTUAssociation2Params> {
    private readonly params = [new QComplexParam("command", new QCreateWOOpDependencyNavigationMTUAssociation())];

    constructor() {
        super("CreateWOOpDependencyNavigationMTUAssociation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateWOOpDependencyNavigationMTUAssociationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateDefectType2 extends QAction<CreateDefectType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateDefectType())];

    constructor() {
        super("CreateDefectType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateDefectTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateToBeUsedMachine2 extends QAction<CreateToBeUsedMachine2Params> {
    private readonly params = [new QComplexParam("command", new QCreateToBeUsedMachine())];

    constructor() {
        super("CreateToBeUsedMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateToBeUsedMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnlinkToolDefinitionToSetPoint2 extends QAction<UnlinkToolDefinitionToSetPoint2Params> {
    private readonly params = [new QComplexParam("command", new QUnlinkToolDefinitionToSetPoint())];

    constructor() {
        super("UnlinkToolDefinitionToSetPoint", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnlinkToolDefinitionToSetPointResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QToolMaintenance2 extends QAction<ToolMaintenance2Params> {
    private readonly params = [new QComplexParam("command", new QToolMaintenance())];

    constructor() {
        super("ToolMaintenance", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QToolMaintenanceResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkATNInstanceParameterToSetPointItemList2 extends QAction<LinkATNInstanceParameterToSetPointItemList2Params> {
    private readonly params = [new QComplexParam("command", new QLinkATNInstanceParameterToSetPointItemList())];

    constructor() {
        super("LinkATNInstanceParameterToSetPointItemList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkATNInstanceParameterToSetPointItemListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssignCertificationToRoleList2 extends QAction<AssignCertificationToRoleList2Params> {
    private readonly params = [new QComplexParam("command", new QAssignCertificationToRoleList())];

    constructor() {
        super("AssignCertificationToRoleList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssignCertificationToRoleListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkOperationDependencyToProcess2 extends QAction<LinkOperationDependencyToProcess2Params> {
    private readonly params = [new QComplexParam("command", new QLinkOperationDependencyToProcess())];

    constructor() {
        super("LinkOperationDependencyToProcess", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkOperationDependencyToProcessResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCheckInStartWOStepFullQty2 extends QAction<CheckInStartWOStepFullQty2Params> {
    private readonly params = [new QComplexParam("command", new QCheckInStartWOStepFullQty())];

    constructor() {
        super("CheckInStartWOStepFullQty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCheckInStartWOStepFullQtyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteNonConformanceItem2 extends QAction<DeleteNonConformanceItem2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteNonConformanceItem())];

    constructor() {
        super("DeleteNonConformanceItem", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteNonConformanceItemResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLinkDocumentListToStep2 extends QAction<LinkDocumentListToStep2Params> {
    private readonly params = [new QComplexParam("command", new QLinkDocumentListToStep())];

    constructor() {
        super("LinkDocumentListToStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLinkDocumentListToStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveDefectTypeContextualization2 extends QAction<RemoveDefectTypeContextualization2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveDefectTypeContextualization())];

    constructor() {
        super("RemoveDefectTypeContextualization", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveDefectTypeContextualizationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QLoadContainer2 extends QAction<LoadContainer2Params> {
    private readonly params = [new QComplexParam("command", new QLoadContainer())];

    constructor() {
        super("LoadContainer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QLoadContainerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateMachineToDNC2 extends QAction<CreateMachineToDNC2Params> {
    private readonly params = [new QComplexParam("command", new QCreateMachineToDNC())];

    constructor() {
        super("CreateMachineToDNC", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateMachineToDNCResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRemoveCertificationToUserList2 extends QAction<RemoveCertificationToUserList2Params> {
    private readonly params = [new QComplexParam("command", new QRemoveCertificationToUserList())];

    constructor() {
        super("RemoveCertificationToUserList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRemoveCertificationToUserListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QChangeOfflineSessionStatus2 extends QAction<ChangeOfflineSessionStatus2Params> {
    private readonly params = [new QComplexParam("command", new QChangeOfflineSessionStatus())];

    constructor() {
        super("ChangeOfflineSessionStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QChangeOfflineSessionStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2 extends QAction<ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration())];

    constructor() {
        super("ToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QToolAGW_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration2 extends QAction<ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration())];

    constructor() {
        super("ToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QToolAGW_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ImportLOIPRO2 extends QAction<APPMain_GF_ImportLOIPRO2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ImportLOIPRO())];

    constructor() {
        super("APPMain_GF_ImportLOIPRO", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ImportLOIPROResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ImportMATMAS2 extends QAction<APPMain_GF_ImportMATMAS2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ImportMATMAS())];

    constructor() {
        super("APPMain_GF_ImportMATMAS", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ImportMATMASResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_KeepWorkerAlive_12 extends QAction<APPMain_GF_KeepWorkerAlive_12Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_KeepWorkerAlive_1())];

    constructor() {
        super("APPMain_GF_KeepWorkerAlive_1", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_KeepWorkerAlive_1Response)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_KeepWorkerAlive_22 extends QAction<APPMain_GF_KeepWorkerAlive_22Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_KeepWorkerAlive_2())];

    constructor() {
        super("APPMain_GF_KeepWorkerAlive_2", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_KeepWorkerAlive_2Response)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_KeepWorkerAlive_32 extends QAction<APPMain_GF_KeepWorkerAlive_32Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_KeepWorkerAlive_3())];

    constructor() {
        super("APPMain_GF_KeepWorkerAlive_3", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_KeepWorkerAlive_3Response)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_KeepWorkerAlive_42 extends QAction<APPMain_GF_KeepWorkerAlive_42Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_KeepWorkerAlive_4())];

    constructor() {
        super("APPMain_GF_KeepWorkerAlive_4", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_KeepWorkerAlive_4Response)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_KeepWorkerAlive_52 extends QAction<APPMain_GF_KeepWorkerAlive_52Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_KeepWorkerAlive_5())];

    constructor() {
        super("APPMain_GF_KeepWorkerAlive_5", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_KeepWorkerAlive_5Response)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CreateKeepAliveWorkerTimer2 extends QAction<APPMain_GF_CreateKeepAliveWorkerTimer2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CreateKeepAliveWorkerTimer())];

    constructor() {
        super("APPMain_GF_CreateKeepAliveWorkerTimer", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CreateKeepAliveWorkerTimerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_HandleScanFromShopfloor2 extends QAction<APPMain_GF_HandleScanFromShopfloor2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_HandleScanFromShopfloor())];

    constructor() {
        super("APPMain_GF_HandleScanFromShopfloor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_HandleScanFromShopfloorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ImportMATMAS_CNMOM2 extends QAction<APPMain_GF_ImportMATMAS_CNMOM2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ImportMATMAS_CNMOM())];

    constructor() {
        super("APPMain_GF_ImportMATMAS_CNMOM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ImportMATMAS_CNMOMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ImportLOIPRO_CNMOM2 extends QAction<APPMain_GF_ImportLOIPRO_CNMOM2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ImportLOIPRO_CNMOM())];

    constructor() {
        super("APPMain_GF_ImportLOIPRO_CNMOM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ImportLOIPRO_CNMOMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ActivateAndStartTask2 extends QAction<APPMain_GF_ActivateAndStartTask2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ActivateAndStartTask())];

    constructor() {
        super("APPMain_GF_ActivateAndStartTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ActivateAndStartTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_InsertLineRoutingEntry2 extends QAction<APPMain_GF_InsertLineRoutingEntry2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_InsertLineRoutingEntry())];

    constructor() {
        super("APPMain_GF_InsertLineRoutingEntry", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_InsertLineRoutingEntryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_InsertScanDiagnostic2 extends QAction<APPMain_GF_InsertScanDiagnostic2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_InsertScanDiagnostic())];

    constructor() {
        super("APPMain_GF_InsertScanDiagnostic", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_InsertScanDiagnosticResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CreateMaterial2 extends QAction<APPMain_GF_CreateMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CreateMaterial())];

    constructor() {
        super("APPMain_GF_CreateMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CreateMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnEngraverHandshakeSent2 extends QAction<APPMain_GF_OnEngraverHandshakeSent2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnEngraverHandshakeSent())];

    constructor() {
        super("APPMain_GF_OnEngraverHandshakeSent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnEngraverHandshakeSentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_DeleteProductWaitingForValidation2 extends QAction<APPMain_GF_DeleteProductWaitingForValidation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_DeleteProductWaitingForValidation())];

    constructor() {
        super("APPMain_GF_DeleteProductWaitingForValidation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_DeleteProductWaitingForValidationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ManageWetTestResult2 extends QAction<APPMain_GF_ManageWetTestResult2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ManageWetTestResult())];

    constructor() {
        super("APPMain_GF_ManageWetTestResult", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ManageWetTestResultResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CreateWorkOrderFromLOIPRO2 extends QAction<APPMain_GF_CreateWorkOrderFromLOIPRO2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CreateWorkOrderFromLOIPRO())];

    constructor() {
        super("APPMain_GF_CreateWorkOrderFromLOIPRO", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CreateWorkOrderFromLOIPROResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UpdateLineRoutingEntry2 extends QAction<APPMain_GF_UpdateLineRoutingEntry2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_UpdateLineRoutingEntry())];

    constructor() {
        super("APPMain_GF_UpdateLineRoutingEntry", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_UpdateLineRoutingEntryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_DeleteRunningScan2 extends QAction<APPMain_GF_DeleteRunningScan2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_DeleteRunningScan())];

    constructor() {
        super("APPMain_GF_DeleteRunningScan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_DeleteRunningScanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ManageScanFromShopfloor2 extends QAction<APPMain_GF_ManageScanFromShopfloor2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ManageScanFromShopfloor())];

    constructor() {
        super("APPMain_GF_ManageScanFromShopfloor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ManageScanFromShopfloorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UpsertOperationExtensions2 extends QAction<APPMain_GF_UpsertOperationExtensions2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_UpsertOperationExtensions())];

    constructor() {
        super("APPMain_GF_UpsertOperationExtensions", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_UpsertOperationExtensionsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_SendMessageToHALP2 extends QAction<APPMain_GF_SendMessageToHALP2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_SendMessageToHALP())];

    constructor() {
        super("APPMain_GF_SendMessageToHALP", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_SendMessageToHALPResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_DeleteLineRoutingEntry2 extends QAction<APPMain_GF_DeleteLineRoutingEntry2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_DeleteLineRoutingEntry())];

    constructor() {
        super("APPMain_GF_DeleteLineRoutingEntry", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_DeleteLineRoutingEntryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CreateUoM2 extends QAction<APPMain_GF_CreateUoM2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CreateUoM())];

    constructor() {
        super("APPMain_GF_CreateUoM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CreateUoMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnPackagingHandshakeSent2 extends QAction<APPMain_GF_OnPackagingHandshakeSent2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnPackagingHandshakeSent())];

    constructor() {
        super("APPMain_GF_OnPackagingHandshakeSent", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnPackagingHandshakeSentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UpdateProductWaitingForValidation2 extends QAction<APPMain_GF_UpdateProductWaitingForValidation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_UpdateProductWaitingForValidation())];

    constructor() {
        super("APPMain_GF_UpdateProductWaitingForValidation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_UpdateProductWaitingForValidationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_StartRequestDocuments2 extends QAction<APPMain_GF_StartRequestDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_StartRequestDocuments())];

    constructor() {
        super("APPMain_GF_StartRequestDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_StartRequestDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_InsertProductWaitingForValidation2 extends QAction<APPMain_GF_InsertProductWaitingForValidation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_InsertProductWaitingForValidation())];

    constructor() {
        super("APPMain_GF_InsertProductWaitingForValidation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_InsertProductWaitingForValidationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_SendEngraverPrinterData2 extends QAction<APPMain_GF_SendEngraverPrinterData2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_SendEngraverPrinterData())];

    constructor() {
        super("APPMain_GF_SendEngraverPrinterData", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_SendEngraverPrinterDataResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CloseOperationSignalHandler2 extends QAction<APPMain_GF_CloseOperationSignalHandler2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CloseOperationSignalHandler())];

    constructor() {
        super("APPMain_GF_CloseOperationSignalHandler", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CloseOperationSignalHandlerResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UpdateMaterial2 extends QAction<APPMain_GF_UpdateMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_UpdateMaterial())];

    constructor() {
        super("APPMain_GF_UpdateMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_UpdateMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_GetUoM2 extends QAction<APPMain_GF_GetUoM2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_GetUoM())];

    constructor() {
        super("APPMain_GF_GetUoM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_GetUoMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CreateBoM2 extends QAction<APPMain_GF_CreateBoM2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CreateBoM())];

    constructor() {
        super("APPMain_GF_CreateBoM", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CreateBoMResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_InsertRunningScan2 extends QAction<APPMain_GF_InsertRunningScan2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_InsertRunningScan())];

    constructor() {
        super("APPMain_GF_InsertRunningScan", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_InsertRunningScanResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_AllowKWAChecksExecution2 extends QAction<APPMain_GF_AllowKWAChecksExecution2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_AllowKWAChecksExecution())];

    constructor() {
        super("APPMain_GF_AllowKWAChecksExecution", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_AllowKWAChecksExecutionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_SendPackagingPrinterData2 extends QAction<APPMain_GF_SendPackagingPrinterData2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_SendPackagingPrinterData())];

    constructor() {
        super("APPMain_GF_SendPackagingPrinterData", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_SendPackagingPrinterDataResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_DeleteMaterial2 extends QAction<APPMain_DeleteMaterial2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_DeleteMaterial())];

    constructor() {
        super("APPMain_DeleteMaterial", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_DeleteMaterialResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ClassificationDataImport2 extends QAction<APPMain_GF_ClassificationDataImport2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ClassificationDataImport())];

    constructor() {
        super("APPMain_GF_ClassificationDataImport", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ClassificationDataImportResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ClassificationDataRequest2 extends QAction<APPMain_GF_ClassificationDataRequest2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ClassificationDataRequest())];

    constructor() {
        super("APPMain_GF_ClassificationDataRequest", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ClassificationDataRequestResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized2 extends QAction<APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized())];

    constructor() {
        super("APPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnAssistedPickingCompleteWorkOrderOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CompleteEquipmentPLCTask2 extends QAction<APPMain_GF_CompleteEquipmentPLCTask2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CompleteEquipmentPLCTask())];

    constructor() {
        super("APPMain_GF_CompleteEquipmentPLCTask", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CompleteEquipmentPLCTaskResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnAssistedPickingStopped2 extends QAction<APPMain_GF_OnAssistedPickingStopped2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnAssistedPickingStopped())];

    constructor() {
        super("APPMain_GF_OnAssistedPickingStopped", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnAssistedPickingStoppedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized2 extends QAction<APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized())];

    constructor() {
        super("APPMain_GF_OnAssistedPickingStartWorkOrderOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnAssistedPickingStartWorkOrderOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_DeleteReworkProcessAssignmentEntry2 extends QAction<APPMain_GF_DeleteReworkProcessAssignmentEntry2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_DeleteReworkProcessAssignmentEntry())];

    constructor() {
        super("APPMain_GF_DeleteReworkProcessAssignmentEntry", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_DeleteReworkProcessAssignmentEntryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnEPLCStartWorkOrderOperationSerialized2 extends QAction<APPMain_GF_OnEPLCStartWorkOrderOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnEPLCStartWorkOrderOperationSerialized())];

    constructor() {
        super("APPMain_GF_OnEPLCStartWorkOrderOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnEPLCStartWorkOrderOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_InsertReworkProcessAssignmentEntry2 extends QAction<APPMain_GF_InsertReworkProcessAssignmentEntry2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_InsertReworkProcessAssignmentEntry())];

    constructor() {
        super("APPMain_GF_InsertReworkProcessAssignmentEntry", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_InsertReworkProcessAssignmentEntryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_SendMESDataToEquipmentPLC2 extends QAction<APPMain_GF_SendMESDataToEquipmentPLC2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_SendMESDataToEquipmentPLC())];

    constructor() {
        super("APPMain_GF_SendMESDataToEquipmentPLC", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_SendMESDataToEquipmentPLCResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_UpdateReworkProcessAssignmentEntry2 extends QAction<APPMain_GF_UpdateReworkProcessAssignmentEntry2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_UpdateReworkProcessAssignmentEntry())];

    constructor() {
        super("APPMain_GF_UpdateReworkProcessAssignmentEntry", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_UpdateReworkProcessAssignmentEntryResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized2 extends QAction<APPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized())];

    constructor() {
        super("APPMain_GF_OnEPLCCompleteWorkOrderOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnEPLCCompleteWorkOrderOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ResetTag2 extends QAction<APPMain_GF_ResetTag2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ResetTag())];

    constructor() {
        super("APPMain_GF_ResetTag", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ResetTagResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_StartEquipmentPLCOperation2 extends QAction<APPMain_GF_StartEquipmentPLCOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_StartEquipmentPLCOperation())];

    constructor() {
        super("APPMain_GF_StartEquipmentPLCOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_StartEquipmentPLCOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CompleteEquipmentPLCOperation2 extends QAction<APPMain_GF_CompleteEquipmentPLCOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CompleteEquipmentPLCOperation())];

    constructor() {
        super("APPMain_GF_CompleteEquipmentPLCOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CompleteEquipmentPLCOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnCarrierArrived2 extends QAction<APPMain_GF_OnCarrierArrived2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnCarrierArrived())];

    constructor() {
        super("APPMain_GF_OnCarrierArrived", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnCarrierArrivedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_StartLineControllerOperation2 extends QAction<APPMain_GF_StartLineControllerOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_StartLineControllerOperation())];

    constructor() {
        super("APPMain_GF_StartLineControllerOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_StartLineControllerOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnChangeNonConformanceEntity2 extends QAction<APPMain_GF_OnChangeNonConformanceEntity2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnChangeNonConformanceEntity())];

    constructor() {
        super("APPMain_GF_OnChangeNonConformanceEntity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnChangeNonConformanceEntityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized2 extends QAction<APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized())];

    constructor() {
        super("APPMain_GF_OnLineControllerCompleteWorkOrderOperationSerialized", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_OnLineControllerCompleteWorkOrderOperationSerializedResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CompleteLineControllerOperation2 extends QAction<APPMain_GF_CompleteLineControllerOperation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CompleteLineControllerOperation())];

    constructor() {
        super("APPMain_GF_CompleteLineControllerOperation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CompleteLineControllerOperationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ResetAutomationNodeTags2 extends QAction<APPMain_GF_ResetAutomationNodeTags2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ResetAutomationNodeTags())];

    constructor() {
        super("APPMain_GF_ResetAutomationNodeTags", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ResetAutomationNodeTagsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_SendCarrierToStation2 extends QAction<APPMain_GF_SendCarrierToStation2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_SendCarrierToStation())];

    constructor() {
        super("APPMain_GF_SendCarrierToStation", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_SendCarrierToStationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_CreateGFFile2 extends QAction<APPMain_GF_CreateGFFile2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_CreateGFFile())];

    constructor() {
        super("APPMain_GF_CreateGFFile", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_CreateGFFileResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ManageMarking2 extends QAction<APPMain_GF_ManageMarking2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ManageMarking())];

    constructor() {
        super("APPMain_GF_ManageMarking", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ManageMarkingResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRepairWorkInstruction2 extends QAction<RepairWorkInstruction2Params> {
    private readonly params = [new QComplexParam("command", new QRepairWorkInstruction())];

    constructor() {
        super("RepairWorkInstruction", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRepairWorkInstructionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateActivityList2 extends QAction<CreateActivityList2Params> {
    private readonly params = [new QComplexParam("command", new QCreateActivityList())];

    constructor() {
        super("CreateActivityList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateActivityListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRepairMaterialConsumption2 extends QAction<RepairMaterialConsumption2Params> {
    private readonly params = [new QComplexParam("command", new QRepairMaterialConsumption())];

    constructor() {
        super("RepairMaterialConsumption", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRepairMaterialConsumptionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMarkForCleaningToolList2 extends QAction<MarkForCleaningToolList2Params> {
    private readonly params = [new QComplexParam("command", new QMarkForCleaningToolList())];

    constructor() {
        super("MarkForCleaningToolList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMarkForCleaningToolListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateCustomActivity2 extends QAction<CreateCustomActivity2Params> {
    private readonly params = [new QComplexParam("command", new QCreateCustomActivity())];

    constructor() {
        super("CreateCustomActivity", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateCustomActivityResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMarkForCleaningWorkOrderList2 extends QAction<MarkForCleaningWorkOrderList2Params> {
    private readonly params = [new QComplexParam("command", new QMarkForCleaningWorkOrderList())];

    constructor() {
        super("MarkForCleaningWorkOrderList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMarkForCleaningWorkOrderListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRepairToolUsage2 extends QAction<RepairToolUsage2Params> {
    private readonly params = [new QComplexParam("command", new QRepairToolUsage())];

    constructor() {
        super("RepairToolUsage", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRepairToolUsageResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateWorkOrderStatusAndPropertiesCommand2 extends QAction<UpdateWorkOrderStatusAndPropertiesCommand2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateWorkOrderStatusAndPropertiesCommand())];

    constructor() {
        super("UpdateWorkOrderStatusAndPropertiesCommand", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateWorkOrderStatusAndPropertiesCommandResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMarkForCleaningMTUList2 extends QAction<MarkForCleaningMTUList2Params> {
    private readonly params = [new QComplexParam("command", new QMarkForCleaningMTUList())];

    constructor() {
        super("MarkForCleaningMTUList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMarkForCleaningMTUListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QMarkForCleaningExecutionGroupList2 extends QAction<MarkForCleaningExecutionGroupList2Params> {
    private readonly params = [new QComplexParam("command", new QMarkForCleaningExecutionGroupList())];

    constructor() {
        super("MarkForCleaningExecutionGroupList", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QMarkForCleaningExecutionGroupListResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRepairQualityInspection2 extends QAction<RepairQualityInspection2Params> {
    private readonly params = [new QComplexParam("command", new QRepairQualityInspection())];

    constructor() {
        super("RepairQualityInspection", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRepairQualityInspectionResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QRepairScrewingToolUsage2 extends QAction<RepairScrewingToolUsage2Params> {
    private readonly params = [new QComplexParam("command", new QRepairScrewingToolUsage())];

    constructor() {
        super("RepairScrewingToolUsage", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QRepairScrewingToolUsageResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QGroupWoOpsTotallyInExecGroupByType2 extends QAction<GroupWoOpsTotallyInExecGroupByType2Params> {
    private readonly params = [new QComplexParam("command", new QGroupWoOpsTotallyInExecGroupByType())];

    constructor() {
        super("GroupWoOpsTotallyInExecGroupByType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QGroupWoOpsTotallyInExecGroupByTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetToBeCollectedDocumentOnStep2 extends QAction<SetToBeCollectedDocumentOnStep2Params> {
    private readonly params = [new QComplexParam("command", new QSetToBeCollectedDocumentOnStep())];

    constructor() {
        super("SetToBeCollectedDocumentOnStep", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetToBeCollectedDocumentOnStepResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_DownloadAndAddDocuments2 extends QAction<APPMain_GF_DownloadAndAddDocuments2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_DownloadAndAddDocuments())];

    constructor() {
        super("APPMain_GF_DownloadAndAddDocuments", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_DownloadAndAddDocumentsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_HandleWorkOrderIdScanFromShopfloor2 extends QAction<APPMain_GF_HandleWorkOrderIdScanFromShopfloor2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_HandleWorkOrderIdScanFromShopfloor())];

    constructor() {
        super("APPMain_GF_HandleWorkOrderIdScanFromShopfloor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_HandleWorkOrderIdScanFromShopfloorResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAPPMain_GF_ManageWorkOrderIdScanFromShopfloor2 extends QAction<APPMain_GF_ManageWorkOrderIdScanFromShopfloor2Params> {
    private readonly params = [new QComplexParam("command", new QAPPMain_GF_ManageWorkOrderIdScanFromShopfloor())];

    constructor() {
        super("APPMain_GF_ManageWorkOrderIdScanFromShopfloor", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAPPMain_GF_ManageWorkOrderIdScanFromShopfloorResponse)))
    }

    getParams() {
        return this.params
    }
}
